webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__storage_grapes_init__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reveal_js_js_reveal__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reveal_js_js_reveal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_reveal_js_js_reveal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_index_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_en_US__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18n_fr_FR__ = __webpack_require__(12);








var juice = __webpack_require__(344);



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    deviceSize: 'common/getDeviceSize',
    selectedSlides: 'slides/getSelected',
    selectedSegments: 'segments/getSelectedSegments',
    paramsClient: 'getParamsClients',
    currentSegment: 'segments/getCurrent',
    currentSlide: 'slides/getCurrent',
    permission: 'getPermissions'
  })),
  i18n: {
    messages: {
      en: __WEBPACK_IMPORTED_MODULE_9__i18n_en_US__["a" /* default */],
      fr: __WEBPACK_IMPORTED_MODULE_10__i18n_fr_FR__["a" /* default */]
    }
  },
  data: function data() {},

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('common', ['setCanvasSize', 'duplicateSvgObject']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])({
    setUrlMedia: 'setUrlMedia'
  }), {
    getLangCode: function getLangCode(plugin) {
      var plugins = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_6__storage_grapes_init__["a" /* default */].pluginsOpts);
      var p = plugins.filter(function (p, index) {
        return p === plugin ? plugin : 'display-tides-plugin';
      });

      return { translate: __WEBPACK_IMPORTED_MODULE_8__i18n_index_js__["a" /* default */].t(plugin) };
    },
    makeId: function makeId() {
      var text = 'i';
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      for (var i = 0; i < 5; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }return text;
    },
    removeToolbarCkeditor: function removeToolbarCkeditor() {
      if (document.querySelectorAll('.cke_reset_all')) {
        document.querySelectorAll('.cke_reset_all').forEach(function (element) {
          try {
            document.querySelector('.gjs-rte-toolbar').removeChild(element);
          } catch (e) {}
        });
      }
    },
    cmdInlineHtml: function cmdInlineHtml(html, css) {
      css = css.split('body').join('.body');
      html = html.replace(/contenteditable/g, '');
      var tmpl = '<div class=\'body\'>' + html + '</div>' + ('<style>' + css + ' .body{position: absolute;width: 100%;height: 100%;}</style>');
      return juice(tmpl, {});
    },
    updateCanvasDimensions: function updateCanvasDimensions() {
      var _this = this;

      var x = this.deviceSize.x;
      var y = this.deviceSize.y;

      var canvasEl = document.querySelector('.gjs-cv-canvas');
      var iframeEl = document.querySelector('.gjs-cv-canvas .gjs-frame');
      // Screens without a mounted GrapesJS editor (the segment list and the
      // segment metadata form) have no canvas, and the window resize handler
      // can also fire after the editor unmounts. Everything below - including
      // the deferred grapesjsEMP.editors[0] work - needs one, so bail out.
      if (!canvasEl || !iframeEl) return;
      var offsetWidth = canvasEl.offsetWidth,
          offsetHeight = canvasEl.offsetHeight;

      if (this.paramsClient.display_devices !== null && this.paramsClient.display_devices[0] && !!!this.paramsClient.display_devices[0].fixedSize) {
        if (offsetWidth / offsetHeight < x / y) {
          iframeEl.style.width = 'calc(100% - 55px)';
          iframeEl.style.height = (offsetWidth - 55) * (y / x) + 'px';
        } else {
          iframeEl.style.height = offsetHeight - 30 + 'px';
          iframeEl.style.width = (offsetHeight - 30) * (x / y) + 'px';
        }
      } else {
        setTimeout(function () {
          iframeEl.style.width = _this.paramsClient.display_devices[0].fixedSize.width + 'px';
          iframeEl.style.height = _this.paramsClient.display_devices[0].fixedSize.height + 'px';
        }, 200);
      }

      setTimeout(function () {
        var canvasDimension = {
          width: parseFloat(window.getComputedStyle(iframeEl).width),
          height: parseFloat(window.getComputedStyle(iframeEl).height)
        };
        if (_this.paramsClient.display_devices !== null && _this.paramsClient.display_devices[0] && !!!_this.paramsClient.display_devices[0].fixedSize) {
          _this.setCanvasSize(canvasDimension);
        } else {
          _this.setCanvasSize(_this.paramsClient.display_devices[0].fixedSize);
        }

        var editor = grapesjsEMP.editors[0];
        editor.getComponents().models.forEach(function (model) {
          if (model.attributes.type === 'facebook_widget') {
            model.view.updateScript();
            localStorage.setItem('gjs-js', editor.getJs());
          }
        });

        setTimeout(function () {
          grapesjsEMP.editors[0].trigger('change:canvasOffset');
          var height = document.querySelector('.canvas-div').offsetHeight / (document.querySelector('.canvas-div .gjs-frame').offsetHeight + 60) * 100;
          var width = document.querySelector('.canvas-div').offsetWidth / (document.querySelector('.canvas-div .gjs-frame').offsetWidth + 60) * 100;
          eventHub.$emit('updateDefaultValue', {
            percent: Math.min(height, width).toFixed(1) > 99 ? 100 : Math.min(height, width).toFixed(1),
            ty: Math.min(height, width).toFixed(1) > 99 ? 0 : document.querySelector('.canvas-div').offsetHeight - document.querySelector('.canvas-div .gjs-frame').offsetHeight + 50
          });
        }, 1000);
      }, 1000);
    },
    getScalingZoom: function getScalingZoom() {
      var height = document.querySelector('.canvas-div').offsetHeight / (document.querySelector('.canvas-div .gjs-frame').offsetHeight + 60) * 100;
      var width = document.querySelector('.canvas-div').offsetWidth / (document.querySelector('.canvas-div .gjs-frame').offsetWidth + 60) * 100;
      return {
        percent: Math.min(height, width).toFixed(1) > 99 ? 100 : Math.min(height, width).toFixed(1),
        ty: Math.min(height, width).toFixed(1) > 99 ? 0 : document.querySelector('.canvas-div').offsetHeight - document.querySelector('.canvas-div .gjs-frame').offsetHeight + 50
      };
    },
    getScalingZoomAll: function getScalingZoomAll() {
      var width16 = document.querySelector('#editor').offsetHeight * 1280 / 720;
      var height = document.querySelector('#editor').offsetHeight / (720 + 60) * 100;
      var width = width16 / (1280 + 60) * 100;
      var min = Math.min(height, width) / 1.1;
      var tx = (document.querySelector('#editor').offsetWidth - 1280 * min / 100) / 2;
      var ty = (document.querySelector('#editor').offsetHeight - 720 * min / 100) / 2;
      return { percent: min.toFixed(1) > 99 ? 80 : min.toFixed(1), ty: ty, tx: tx };
    },
    scaleValue: function scaleValue(customScale, size) {
      /* const sheetCanvas = new CSSStyleSheet();
      let self = this;
      /!*  ty = ty-self.ty(size);
      tx = tx-self.tx(size);*!/
       if(size*1 < 1 ){
         document.querySelector('.gjs-cv-canvas.customScale').classList.add('customScaleTransitionNotResize');
       }
      if(size*1 < 1 && size*1 >=0.8 ){
        document.querySelector('.gjs-cv-canvas.customScale').classList.add('customScaleTransition-8');
        document.querySelector('.gjs-cv-canvas.customScale').classList.remove('customScaleTransition-7');
      }
      if(size*1 < 0.8 ){
        document.querySelector('.gjs-cv-canvas.customScale').classList.remove('customScaleTransition-8');
        document.querySelector('.gjs-cv-canvas.customScale').classList.add('customScaleTransition-7');
      }
      if(customScale == ".customScale"){
        const sheetCanvas2 = new CSSStyleSheet();
        let sizeToolbar = 1 + size > 1.5 ? 1.5 :1 + size;
        document.querySelector('.gjs-cv-canvas.customScale').classList.remove('customScaleTransition');
        sheetCanvas2.replaceSync(
          `.gjs-rte-toolbar  {
             transform: matrix(` +
          sizeToolbar +`, 0, 0,`+ sizeToolbar+`, ` +0+`, `+0+`
        )!important; } ` + customScale+`  { opacity:0.8;
             transform: matrix(` +
          size +`, 0, 0,`+ size+`, ` +0+`, `+0+`
        )!important; } `);
        document.adoptedStyleSheets = [sheetCanvas2];
        setTimeout(function(){
          document.querySelector('.gjs-cv-canvas.customScale').classList.add('customScaleTransition');
          ty = -self.ty(size) + 40;
        tx = -self.tx(size);
         sheetCanvas2.replaceSync(
          `.gjs-rte-toolbar  {
             transform: matrix(` +
          sizeToolbar +`, 0, 0,`+ sizeToolbar+`, ` +0+`, `+0+`
        )!important; } ` + customScale+`  {
             transform: matrix(` +
          size +`, 0, 0,`+ size+`, ` +tx+`, `+ty+`
        )!important; } `);
        document.adoptedStyleSheets = [sheetCanvas2];
        },100)
       }else {
         sheetCanvas.replaceSync(
          customScale+`  {
             transform: matrix(` +
          size +`, 0, 0,`+ size+`, ` +0+`, `+0+`
        )!important; } `);
         document.adoptedStyleSheets = [sheetCanvas];
         setTimeout(function(){
          document.querySelector('.gjs-cv-canvas.customScale').classList.add('customScaleTransition');
          ty = (ty-document.querySelector('.slidesParent').getBoundingClientRect().top);
          tx = (tx-document.querySelector('.slidesParent').getBoundingClientRect().left);
           sheetCanvas.replaceSync(
            customScale+`  {
             transform: matrix(` +
            size +`, 0, 0,`+ size+`, ` +tx+`, `+ty+`
        )!important; } `);
           document.adoptedStyleSheets = [sheetCanvas];
        },100)
      }*/

      var ty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var tx = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    },
    sanitizeCSS: function sanitizeCSS(css) {
      if (!css) {
        return '';
      }
      var styles = css.split('body').slice(1);
      if (styles.length <= 1) {
        return css;
      }
      var body = 'body' + styles[0];
      var other = styles[styles.length - 1];
      var rest = other.replace(other.substring(0, other.indexOf('}') + 1), '');
      return body + rest;
    },
    tx: function tx(parsent) {
      var transition_x = 0;
      if (document.querySelector('.gjs-cv-canvas.customScale') && document.querySelector('.canvas-div .gjs-cv-canvas .gjs-frame')) {
        var leftValue = (document.querySelector('.gjs-cv-canvas.customScale').offsetWidth - document.querySelector('.canvas-div .gjs-cv-canvas .gjs-frame').offsetWidth * parsent) / 2;
        if (leftValue < 0) leftValue = 0;
        transition_x = document.querySelector('.canvas-div .gjs-cv-canvas .gjs-frame').getBoundingClientRect().left - leftValue;
      }
      return transition_x;
    },
    ty: function ty(parsent) {
      var transition_y = 0;
      if (document.querySelector('.gjs-cv-canvas.customScale') && document.querySelector('.canvas-div .gjs-cv-canvas .gjs-frame')) {
        var topValue = (document.querySelector('.gjs-cv-canvas.customScale').offsetHeight - document.querySelector('.canvas-div .gjs-cv-canvas .gjs-frame').offsetHeight * parsent) / 2;
        if (topValue < 0) topValue = 0;
        transition_y = document.querySelector('.canvas-div .gjs-cv-canvas .gjs-frame').getBoundingClientRect().top - topValue;
      }
      return transition_y;
    },
    getClone: function getClone(slide) {
      var _this2 = this;

      var exceptions = ['newsTicker', 'weather-grapes', 'position', 'hour', 'min', 'sec', 'clock-grapes', 'digital-clock'];
      var ids = [];
      var parseObject = function parseObject(m) {
        var id = m.attributes.id;
        if (id && ids.indexOf(id) + exceptions.indexOf(id) < -1) {
          ids.push(id);
        }
        m.components.forEach(function (m) {
          return parseObject(m);
        });
      };

      var components = void 0,
          js = void 0,
          html = void 0,
          css = void 0,
          styles = void 0;
      if (slide && slide.components) {
        var localStorageComponents = JSON.parse(slide.components);
        localStorageComponents.forEach(function (m) {
          return parseObject(m);
        });
        components = slide.components;
        js = slide.js;
        html = slide.html;
        css = slide.css;
        styles = slide.styles;
      } else {
        var _localStorageComponents = JSON.parse(localStorage.getItem('gjs-components'));
        _localStorageComponents.forEach(function (m) {
          return parseObject(m);
        });
        components = localStorage.getItem('gjs-components');
        js = localStorage.getItem('gjs-js');
        html = localStorage.getItem('gjs-html');
        css = this.sanitizeCSS(localStorage.getItem('gjs-css'));
        styles = localStorage.getItem('gjs-styles');
      }
      ids.forEach(function (id) {
        var newId = _this2.makeId();
        var re = new RegExp(id, 'g');

        /* duplicateSvgObject in store
           For Animation
         */
        var dataId = { oldid: id, newid: newId };
        _this2.duplicateSvgObject(dataId);
        //---------------------
        components = components.replace(re, newId);
        //js = js.replace(re, newId);
        html = html.replace(re, newId);
        css = css.replace(re, newId);
        styles = styles.replace(re, newId);
      });

      return {
        components: components,
        js: js,
        html: html,
        css: css,
        styles: styles
      };
    },
    getSegmentCloneThis: function getSegmentCloneThis(cloneThis) {
      var _this3 = this;

      var segment = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, cloneThis);
      segment.screens = segment.screens.map(function (screen) {
        if (screen.uid === _this3.currentSlide.uid) {
          screen = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, screen, _this3.getClone());
        } else {
          screen = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, screen, _this3.getClone(screen));
        }
        return screen;
      });
      return segment;
    },
    getSegmentClone: function getSegmentClone() {
      var _this4 = this;

      var segment = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.currentSegment);
      segment.screens = segment.screens.map(function (screen) {
        if (screen.uid === _this4.currentSlide.uid) {
          screen = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, screen, _this4.getClone());
        } else {
          screen = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, screen, _this4.getClone(screen));
        }
        return screen;
      });
      return segment;
    },
    showViewContainer: function showViewContainer() {
      var _this5 = this;

      var self = this;
      this.$nextTick(function () {
        var index = 0;
        var interval = setInterval(function () {
          var blocks = document.querySelector('.gjs-pn-panels .gjs-pn-panel.gjs-pn-views-container');
          index++;
          if (blocks) {
            clearInterval(interval);

            var slideEl = document.querySelector('div#panel__left.show_panel');
            var canvasEl = document.querySelector('.canvas-div');
            var toggleButton = document.querySelector('.gjs-pn-panels #btn-toggle');
            var panelButtons = document.querySelector('.gjs-pn-panels .panel-buttons');
            var infos_new = document.getElementById('list-informations-new');

            var panelParams = [{
              icon: 'fa-bars',
              type: 'bars'
            }, {
              icon: 'fa-th-large',
              type: 'large'
            }, {
              icon: 'fa-paint-brush',
              type: 'brush'
            }];
            var icons = panelParams.map(function (el) {
              return el.icon;
            });
            var types = panelParams.map(function (el) {
              return el.type;
            });

            types.forEach(function (type, index) {
              var el = document.querySelector('#gjs > div.gjs-editor.gjs-one-bg.gjs-two-color > div.gjs-pn-panels > div.gjs-pn-buttons.panel-buttons > span.gjs-pn-btn.fa.' + icons[index]);

              if (el.classList.contains('gjs-pn-active')) {
                el.classList.add('isActiveBlocks');
              } else {
                el.classList.remove('isActiveBlocks');
              }
              el.addEventListener('click', function () {
                if (el.classList.contains('gjs-pn-active')) {
                  el.classList.add('isActiveBlocks');
                } else {
                  el.classList.remove('isActiveBlocks');
                }
                self.$root.$emit('show-panels-container');
              });
            });

            if (toggleButton) {
              toggleButton.addEventListener('click', function () {
                self.displayToggleButton(blocks, canvasEl, slideEl, panelButtons, toggleButton, infos_new);
                setTimeout(function () {
                  _this5.updateCanvasDimensions();
                }, 150);
              });
              blocks.classList.remove('hide-blocks-panels');
              canvasEl.classList.remove('hide-canvas');
              panelButtons.classList.remove('hide-panel-buttons');
            }
          }
          if (index === 20) {
            clearInterval(interval);
          }
        }, 1000);
      });
    },
    displayToggleButton: function displayToggleButton(blocks, canvasEl, slideEl, panelButtons, toggleButton, infos_new) {
      if (toggleButton.classList.contains('rotate-buttons')) {
        blocks.classList.remove('show-blocks-panels');
        canvasEl.classList.remove('show-canvas');
        panelButtons.classList.remove('show-panel-buttons');
        toggleButton.classList.remove('resize-panel-buttons');
        toggleButton.classList.remove('rotate-buttons');
        blocks.classList.remove('hide-blocks-panels');
        panelButtons.classList.remove('hide-panel-buttons');
        slideEl.classList.remove('hide_panel');
        if (!this.paramsClient.display_default_blocks) {
          if (!this.paramsClient.modules.show_list_block_action) {
            this.removeBlockPanelClasses(blocks, panelButtons, toggleButton);
          }
        } else if (this.paramsClient.display_default_blocks && (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.paramsClient.display_default_blocks).length === 0 || !this.paramsClient.modules.show_list_block_action)) {
          this.removeBlockPanelClasses(blocks, panelButtons, toggleButton);
        }

        canvasEl.classList.remove('hide-canvas');

        infos_new.classList.remove('size-infos-new');
      } else {
        blocks.classList.remove('show-blocks-panels');
        canvasEl.classList.remove('show-canvas');
        panelButtons.classList.remove('show-panel-buttons');
        toggleButton.classList.remove('resize-panel-buttons');
        toggleButton.classList.add('rotate-buttons');
        blocks.classList.add('hide-blocks-panels');
        panelButtons.classList.add('hide-panel-buttons');
        slideEl.classList.add('hide_panel');
        if (!this.paramsClient.display_default_blocks) {
          if (!this.paramsClient.modules.show_list_block_action) {
            this.addBlockPanelClasses(blocks, panelButtons, toggleButton);
          }
        } else if (this.paramsClient.display_default_blocks && (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.paramsClient.display_default_blocks).length === 0 || !this.paramsClient.modules.show_list_block_action)) {
          this.addBlockPanelClasses(blocks, panelButtons, toggleButton);
        }
        canvasEl.classList.add('hide-canvas');

        infos_new.classList.add('size-infos-new');
      }
    },
    removeBlockPanelClasses: function removeBlockPanelClasses(blocks, panelButtons, toggleButton) {
      blocks.classList.remove('hide-block-panels');
      panelButtons.classList.remove('hide-panel-button');
      toggleButton.classList.remove('rotate-button');
    },
    addBlockPanelClasses: function addBlockPanelClasses(blocks, panelButtons, toggleButton) {
      blocks.classList.add('hide-block-panels');
      panelButtons.classList.add('hide-panel-button');
      toggleButton.classList.add('rotate-button');
    },
    setNoAutoplayVideo: function setNoAutoplayVideo(editor) {
      var iframe = document.querySelector('.gjs-frame').contentWindow;
      var videoId = void 0;
      var autoplay = void 0;
      editor.getComponents().models.forEach(function (model) {
        var videoArray = ['video']; //, 'player', 'playlist'
        if (videoArray.indexOf(model.attributes.type) > -1) {
          videoId = model.attributes.attributes.id;
          autoplay = model.attributes.autoplay || model.attributes.attributes.autoplay;
          var videoSrc = model.attributes.attributes.src || model.attributes.src;
          var videoMuted = model.attributes.attributes.muted || model.attributes.muted;
          if (videoId) {
            var videoElIframe = iframe.document.querySelector('#' + videoId + ' > iframe');
            var videoEl = iframe.document.querySelector('#' + videoId + ' > video');
            if (videoElIframe) {
              videoElIframe.setAttribute('src', videoSrc);
            }
            if (videoEl) {
              if (autoplay === 1) {
                model.attributes.autoplay = autoplay;
                model.attributes.muted = videoMuted;
                videoEl.setAttribute('muted', videoMuted);
                videoEl.setAttribute('autoplay', '');
                videoEl.muted = true;
              }
            }
          }
        }
      });
    },
    setNoAutoplayDuplicateVideo: function setNoAutoplayDuplicateVideo(editor, videoId) {
      var iframe = document.querySelector('.gjs-frame').contentWindow;
      editor.getComponents().models.forEach(function (model) {
        var videoArray = ['video']; //, 'player', 'playlist'
        if (videoArray.indexOf(model.attributes.type) > -1) {
          var videoSrc = model.attributes.attributes.src || model.attributes.src;
          if (videoId) {
            setTimeout(function () {
              var videoEl = iframe.document.querySelector('#' + videoId + ' > iframe');
              if (videoEl) {
                videoEl.setAttribute('src', videoSrc);
              }
            }, 100);
          }
        }
      });
    },
    getSelectedSlides: function getSelectedSlides(type) {
      var listVideosObjects = [];
      var components = void 0;
      if (this.$route.name === 'segment' || this.$route.name === 'edit') {
        components = this.selectedSegments;
      } else {
        components = this.selectedSlides;
      }
      components.forEach(function (component, index) {
        var comps = void 0;
        if (type === 'preview') {
          comps = JSON.parse(component.components);
        } else {
          comps = JSON.parse(localStorage.getItem('gjs-components'));
        }
        if (comps && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(comps).length > 0) {
          comps.forEach(function (comp) {
            comp.slide = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(index));
            listVideosObjects.push(comp);
          });
        }
      });
      this.$root.$emit('AutoPlayVideoPreview', {
        video: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(listVideosObjects)),
        type: type
      });
    },
    setPausedVideo: function setPausedVideo(type) {
      var _this6 = this;

      var timeout = 500;
      var iframe = document.querySelector('.gjs-frame').contentWindow;
      var items = iframe.document.querySelectorAll("div[data-gjs-type='" + type + "'] > iframe, iframe[src*='autoplay=']" //, iframe[src*='autoplay=']
      );
      if (items.length > 0) {
        items.forEach(function (item) {
          _this6.setPausedPlayers(item, type, timeout);
        });
      }
    },
    setAutoplayPlayer: function setAutoplayPlayer(editor) {
      var _this7 = this;

      var i = 0;
      var videosArray = ['video', 'player', 'playlist'];
      var attrAutoplay = void 0;
      var interval = setInterval(function () {
        var iframe = document.querySelector('.gjs-frame').contentWindow;
        videosArray.forEach(function (video) {
          var playerItems = iframe.document.querySelectorAll("div[data-gjs-type='" + video + "'] > iframe, iframe[src*='autoplay=']");
          if (video === 'video') {
            attrAutoplay = 'autoplay';
          } else {
            attrAutoplay = 'a';
          }
          if (playerItems.length > 0) {
            playerItems.forEach(function (item) {
              if (item.getAttribute('src').indexOf(attrAutoplay + '=1') > -1) {
                _this7.setPlayedPlayers(item);
              } else {
                _this7.setPausedPlayers(item);
              }
            });
          }
        });
        i++;
        if (i === 5) {
          clearInterval(interval);
        }
      }, 1000);
    },
    setPausedVimeoVideo: function setPausedVimeoVideo(p, video, timeout) {
      var i = 0;
      var nbr = 5;
      var interval = setInterval(function () {
        i++;
        if (i === nbr) {
          clearInterval(interval);
        }
        try {
          p.api('pause');
        } catch (e) {
          console.error(e);
        }
      }, timeout);
    },
    setPlayedVimeoVideo: function setPlayedVimeoVideo(p, video, timeout) {
      var i = 0;
      var nbr = 5;
      var interval = setInterval(function () {
        i++;
        if (i === nbr) {
          clearInterval(interval);
        }
        try {
          p.api('play');
        } catch (e) {
          console.error(e);
        }
      }, timeout);
    },
    setPausedPlayers: function setPausedPlayers(p, video, timeout) {
      var i = 0;
      var nbr = 1;
      if (video !== 'video') {
        nbr = 10;
      }
      var interval = setInterval(function () {
        i++;
        if (i === nbr) {
          clearInterval(interval);
        }
        try {
          p.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');

          p.contentWindow.postMessage({
            fn: 'launch_only_pause',
            params: []
          }, '*');
        } catch (e) {
          console.error(e);
        }
      }, timeout);
    },
    setPlayedPlayers: function setPlayedPlayers(p, video, timeout) {
      var i = 0;
      var nbr = 1;
      if (video !== 'video') {
        nbr = 10;
      }

      var interval = setInterval(function () {
        i++;
        if (i === nbr) {
          clearInterval(interval);
        }
        try {
          p.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');

          p.contentWindow.postMessage({
            fn: 'launch_only_play',
            params: []
          }, '*');
        } catch (e) {
          console.error(e);
        }
      }, timeout);
    },
    getSanitizedHtml: function getSanitizedHtml(html) {
      return html;
    },
    addModalUploadIframePlugin: function addModalUploadIframePlugin(id) {
      var self = this;
      var defaultUrls = void 0;
      var display = void 0;
      var div = document.createElement('div');
      div.id = id + '-iframe';
      div.style.display = 'none';
      defaultUrls = self.paramsClient.display_default_urls;
      if (defaultUrls) {
        var imageUrl = void 0;
        var urlMedia = void 0;
        var postInfos = void 0;
        var iframeHeight = void 0;
        if (id === 'image-media') {
          postInfos = 'showImage';
          iframeHeight = '500';
          imageUrl = defaultUrls.image_url;
          urlMedia = defaultUrls.url_media;
          self.setUrlMedia(urlMedia);
        }
        if (id === 'pattern') {
          postInfos = 'showImage';
          iframeHeight = '500';
          imageUrl = defaultUrls.pattern_url;
        }
        if (id === 'social-media') {
          imageUrl = self.paramsClient.display_default_urls.social_media_url;
          urlMedia = defaultUrls.url_social_media;
          postInfos = 'showSocialMedia';
          iframeHeight = '800';
        }
        var iframe = '<iframe width="100%" height="' + iframeHeight + '" frameborder="0" id="iframe-' + id + '" allow="autoplay;" allowfullscreen></iframe>';
        if (imageUrl) {
          iframe = self.setIframePlugin(id, imageUrl, iframeHeight);
        }
        div.innerHTML = '<div class="gjs-mdl-container">\n            <div id="gjs-mdl-dialog-' + id + '" class="gjs-mdl-dialog gjs-one-bg gjs-two-color" style="display: block;">\n                  <div class="gjs-mdl-header modal-' + id + '">\n                    <div class="gjs-mdl-title">' + __WEBPACK_IMPORTED_MODULE_8__i18n_index_js__["a" /* default */].t('blocks.select_' + id) + '</div>\n                  <div id="close-modal-' + id + '" class="gjs-mdl-btn-close" data-close-modal="">\u2A2F</div>\n                  </div>\n                  <div class="gjs-mdl-content modal-' + id + '"><div id="gjs-mdl-c-' + id + '">' + iframe + '</div>\n                  <div style="clear:both"></div>\n                    </div>\n                    </div>\n                    </div>';
        document.body.appendChild(div);
      }
    },
    setIframePlugin: function setIframePlugin(id, imageUrl, iframeHeight) {
      var iframe = '<iframe width="100%" height="' + iframeHeight + '" id="iframe-' + id + '"  src="' + imageUrl + '" frameborder="0" allow="autoplay;" allowfullscreen></iframe>';
      return iframe;
    },
    setCloseImageModal: function setCloseImageModal(comp, id) {
      var self = this;
      if (document.getElementById('close-modal-' + id)) {
        document.getElementById('close-modal-' + id).addEventListener('click', function (e) {
          self.closeModal(comp, id);
        });
      }
    },
    closeModal: function closeModal(comp, id) {
      if (document.getElementById(id + '-iframe')) {
        document.getElementById(id + '-iframe').style.display = 'none';
      }
      if (document.getElementById('CanvOverlay')) {
        document.getElementById('CanvOverlay').style.display = 'none';
      }
      var obj = { info: 'closeModal' };
      if (document.getElementById('iframe-' + id)) {
        document.getElementById('iframe-' + id).contentWindow.postMessage(obj, '*');
      }
      this.handleEmptyPluginMedia(comp);
    },
    handleEmptyPluginMedia: function handleEmptyPluginMedia(comp) {
      var found = this.isCompFound(comp);
      while (found) {
        grapesjsEMP.editors[0].UndoManager.undo();
        found = this.isCompFound(comp);
      }
    },
    isCompFound: function isCompFound(comp) {
      var getAllComponents = function getAllComponents(model) {
        var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        result.push(model);
        model.components().each(function (mod) {
          return getAllComponents(mod, result);
        });
        return result;
      };
      var all = getAllComponents(grapesjsEMP.editors[0].DomComponents.getWrapper());
      var found = void 0;
      if (comp === 'image_media' || comp === 'pattern') {
        found = all.some(function (c) {
          return c.attributes.type === comp && !c.attributes.src;
        });
      }
      if (comp === 'social_media') {
        found = all.some(function (c) {
          return c.attributes.type === comp && !c.attributes.objectMedia.data;
        });
      }
      return found;
    },
    convertHHMMSS: function convertHHMMSS(hms) {
      var a = hms.split(':'); // split it at the colons

      // minutes are worth 60 seconds. Hours are worth 60 minutes.
      var seconds = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
      return seconds;
    },
    triangleStyle: function triangleStyle(id, StyleDiv, px) {
      // Create our stylesheet:
      var sheet = new CSSStyleSheet();
      sheet.replaceSync(id + ':before {\n        content: \'\';\n        position: absolute;\n        width: 0;\n        height: 0;\n        left: ' + px + 'px;\n        box-sizing: border-box;\n        border-left: 20px solid transparent;\n        border-right: 20px solid transparent;\n        border-top: 15px solid #f8f9fa;\n        margin-left: -25px;\n        transform:' + StyleDiv + ';\n      }\n       ');
      // Apply the stylesheet
      document.adoptedStyleSheets = [sheet];
    },
    getNbSreenSegment: function getNbSreenSegment() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(parseInt(this.permission.nb_screen_segment));
    },
    ShowToolBar: function ShowToolBar(icon) {
      var style = document.createElement('style');
      document.head.appendChild(style);
      style.sheet.insertRule('div.fa.fa-' + icon + '.gjs-toolbar-item{ display:Block; } ');
    },
    displayToolBar: function displayToolBar(icon) {
      var style = document.createElement('style');
      document.head.appendChild(style);
      style.sheet.insertRule('div.fa.fa-' + icon + '.gjs-toolbar-item{ display:none; } ');
    },
    showHideToolBars: function showHideToolBars(icon) {
      document.querySelector('div.fa.fa-' + icon + '.gjs-toolbar-item ').setAttribute('style', 'display:none');
      this.eventComponentUpdate(this.editor);
    },
    displayImgBGToolBar: function displayImgBGToolBar() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      style.sheet.insertRule('.reset-full-BG{ display:none; } ');
    },
    showImgBGToolBars: function showImgBGToolBars() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      style.sheet.insertRule('.reset-full-BG{ display:Block; } ');
    },
    animationAttributesToClass: function animationAttributesToClass(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var elements = doc.querySelectorAll('div');

      elements.forEach(function (el) {
        var animation = el.getAttribute('data-animation');
        if (animation) {
          animation.split(' ').forEach(function (a) {
            el.classList.add(a);
          });
        }
      });

      return doc.documentElement.innerHTML;
    },
    updateAlignement: function updateAlignement() {
      setTimeout(function () {
        var model = grapesjsEMP.editors[0].getSelected();
        if (model) {
          var iframeEl = document.querySelector('.gjs-frame');
          var iframeWidth = iframeEl.getBoundingClientRect().width;
          if (model.view) {
            var modelWidth = model.view.el.getBoundingClientRect().width;
            var modelLeft = model.view.el.getBoundingClientRect().left;

            var leftEl = modelLeft / iframeWidth * 100;
            var rightEl = (1 - (modelLeft + modelWidth) / iframeWidth) * 100;

            var alignment = leftEl < rightEl ? 'left' : 'right';
            document.getElementById('float-' + alignment) ? document.getElementById('float-' + alignment).checked = true : null;
          }
        }
      }, 100);
    },
    getDuration: function getDuration(duration) {
      var fact1 = '';
      var fact2 = '';
      if (Math.floor(duration / 60) < 10) {
        fact1 = '0' + Math.floor(duration / 60);
      } else {
        fact1 = Math.floor(duration / 60);
      }
      if (duration % 60 < 10) {
        fact2 = '0' + duration % 60;
      } else {
        fact2 = duration % 60;
      }
      if (duration < 60) {
        return '00:' + fact2;
      } else {
        return fact1 + ':' + fact2;
      }
    }
  })
});

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  button: {
    cancel: 'cancel',
    confirm: 'Confirm',
    add: 'Add',
    settings: 'Settings',
    back: 'Back',
    next: 'Next',
    edit: 'Edit',
    finish: 'Finish',
    preview: 'Preview',
    deselect: 'Deselect',
    select: 'Select',
    validate: 'Validate',
    ecran: '+ Screen',
    search: 'Search',
    exit: 'Exit'
  },
  tabs: {
    screens: 'Screens list',
    dispositions: 'Dispositions list',
    models: 'Models',
    recents: 'Recent',
    images: 'Images',
    videos: 'Videos',
    empty: 'Empty slide'
  },
  panels: {
    selectedScreen: ' Selected screen',
    addNewScreen: 'Add new screen',
    addNewSegment: 'Add new segment',
    newSegment: 'New segment',
    deleteScreen: 'Delete screen',
    duplicateScreen: 'Duplicate screen',
    duplicateSegment: 'Duplicate segment',
    screenSettings: 'Screen settings',
    editScreen: 'Edit screen',
    edit_title: 'Edit title',
    title: 'Title',
    duration: 'Duration',
    infos: {
      title: 'Informations',
      name_segment: ' Name of segment:',
      duration_segment: 'Duration of segment:',
      duration_total: 'Total duration:',
      name_template: 'Name of template:',
      duration_template: 'Duration of template:',
      size_template: 'Size of template:',
      name_screen: 'Name of screen:',
      duration_screen: 'Duration of screen:'
    }
  },
  modal: {
    reclamation_placeholder: 'Describe the problem.',
    reclamation_title: 'Send feedback',
    about: 'About',
    error: 'Message Erorr',
    okText: 'Continue',
    cancelText: 'Cancel',
    verifDuration: 'The duration of the screens is greater than the duration of the template',

    delete: {
      title: 'Are you sure to delete it?',
      confirm_title: 'Deleted',
      confirm_msg: 'Deleted successfully .',
      cancel_title: 'Cancel',
      cancel_msg: 'Delete canceled',
      btn_confirm: 'Delete!',
      btn_cancel: 'Cancel'
    },
    edit: {
      title: 'Edit the title of this screen',
      error_msg: 'Enter a name',
      btn_confirm: 'Edit',
      btn_cancel: 'Cancel'
    },
    setting: {
      title: 'Setting',
      layers: 'Layers',
      effects: 'Effects',
      opacity: 'Opacity',
      delay: 'Delay(ms)',
      animation: {
        title: 'Animation',
        grow: 'Grow',
        shrink: 'Shrink',
        'fade-in': 'Fade in',
        'fade-out': 'Fade in',
        'fade-up': 'Fade up',
        'fade-down': 'Fade down',
        'fade-left': 'Fade left',
        'fade-right': 'Fade right',
        'zoom-in': 'Zoom in',
        'zoom-out': 'Zoom out',
        without_animation: 'Without animation',
        without_transition: 'none',
        convex: 'convex',
        strike: 'Strike',
        'reveal-text': 'Reveal text'
      }
    },
    add_generic: {
      title: 'Select a generic video ',
      subtitle: 'You should add a generic video to save the project',
      btn_add: 'Add',
      start: 'start',
      end: 'finish'
    }
  },
  disposition: {
    segment: 'Segment',
    disposition: 'Disposition',
    add: 'Add current disposition',
    name: 'Disposition name',
    empty: 'Empty slide'
  },
  screens: {
    select: 'Select screen',
    empty: 'Empty screen',
    screen: 'Screen'
  },
  template: {
    add_name: 'Add an name to your template:',
    name: 'Template name',
    save_template: 'save Template',
    save_as_template: 'Save as a copie of Template',
    save_as_copie: 'Save as a copie',
    save_as_video: 'Publish ',
    save_and_exit: '  Save and exit',
    new_template: 'New program',
    new_ligne: 'New line',
    reclamation: 'Reclamation'
  },
  labels: {
    duration: 'Duration',
    direction: 'Transition direction',
    transition: 'Transition type',
    add_model: 'add a new model',
    add_models: 'add model',
    models: 'Models',
    images: 'Images',
    videos: 'Videos',
    recent: 'Recents',
    title: 'Title',
    ligne: 'Line',
    edit_template_name: 'Please change the name of your template:',
    add_template_name: 'Give a name to your Template:',
    Foreground: 'Foreground',
    advance_more: 'Advance more',
    background: 'Background',
    Recede_less: 'Recede less',
    press: 'Press ',
    exit_fullScreen: 'to exit full screen',
    no_models: 'No models',
    no_images: 'No Images',
    no_videos: 'No Videos',
    'text-add': 'Add'
  },
  placeholder: {
    search: 'Search..',
    title: 'Title...',
    describe_problem: 'Describe the problem',
    template_title: 'Template title'
  },
  titles: {
    send_comment: 'Send comments',
    title_transition: 'List of transitions between slides'
  },
  tooltips: {
    'sw-visibility': 'Show Borders',
    preview: 'Preview',
    fullscreen: 'Fullscreen',
    'preview-screens': 'Preview screens',
    'export-template': 'Export',
    undo: 'Undo',
    redo: 'Redo',
    'gjs-open-import-webpage': 'Import',
    'canvas-clear': 'Clear canvas',
    'open-sm': 'Style Manager',
    'open-layers': 'Layers',
    'open-blocks': 'Blocks',
    save: 'Save',
    'save-template': 'Save',
    move: 'Move',
    duplicate: 'Duplicate',
    delete: 'Delete',
    setting: 'Setting',
    edit: 'Edit'
  },
  blocks: {
    column1: 'One column',
    column2: 'Two columns',
    column3: 'Three columns',
    'column3-7': 'Two columns 3/7',
    custom_column2: 'two columns',
    filet: 'Separator',
    text: 'Text',
    link: 'Link',
    image: 'Image',
    image_media: 'Image',
    video: 'Video',
    map: 'Map',
    'h-navbar': 'Navbar',
    countdown: 'Countdown',
    form: 'Form',
    input: 'Input',
    textarea: 'Textarea',
    select: 'Select',
    button: 'Button',
    label: 'Label',
    checkbox: 'Checkbox',
    radio: 'Radiobox',
    'link-block': 'Link block',
    quote: 'Quote',
    select_video: 'Select Video',
    select_image: 'Select image',
    drop_files: 'Drop files here or click to upload',
    select_screen: 'selected one or more screens',
    select_new: 'selected a media',
    add_generic_debut: 'Generic Video Start ',
    add_generic_fin: 'Generic Video End ',
    add_generic_intro: 'Introduction Video ',
    preview_screens: 'Preview screens',
    'text-basic': 'Text Basic',
    'lory-slider': 'Lory Slider',
    playlist: 'Playlist',
    Weather: 'Weather',
    Clock: 'Clock',
    facebook_widget: 'Facebook',
    linkedin_widget: 'LinkedIn',
    rss_widget: 'RSS',
    ticker: 'Ticker',
    web_widget: 'Web',
    webrtc_widget: 'WebRtc',
    player: 'Player',
    video_mp4: 'Player mp4',
    live: 'Live',
    generic_begin: 'Generic Begin',
    generic_end: 'Generic End',
    'social-icons-twitter': 'Twitter',
    Basic: 'Basic',
    Extra: 'Extra',
    Forms: 'Forms',
    Widget: 'Widget',
    Pattern: 'Motifs',
    Media: 'Media',
    column: 'Column',
    Tides: 'Tides',
    endText: 'Expired',
    labelDays: 'Days',
    labelHours: 'Hours',
    labelMinutes: 'Minutes',
    labelSeconds: 'Seconds',
    dateHeure: 'Date and Time',
    Text: 'Text',
    Areas: 'Areas',
    Medias: 'Medias',
    Social: 'Social networks',
    Disposition: 'Disposition',
    Dimension: 'Dimension',
    Spacing: 'Spacing',
    Decoration: 'Decoration',
    Background: 'Background',
    Border: 'Border',
    Responsive: 'Responsive',
    params: 'Advanced settings',
    social_media: 'Medias',
    'social-media': 'Select medias',
    'image-media': 'Select image',
    'select_image-media': 'Select image',
    select_pattern: 'Select pattern',
    'custom-title': 'Title block ',
    'custom-sharing': 'Sharing block ',
    'custom-credit': 'Credit block',
    pattern: 'Pattern',
    'custom-countdown': 'countdown'
  },
  'display-tides-plugin': {
    tides: 'Tides',
    title: 'Title',
    lat: 'Latitude',
    lng: 'Longitude',
    start: 'Start',
    end: 'End',
    airTemperature: 'Air temperature',
    humidity: 'Humidity',
    cloudCover: 'Cloud cover',
    currentDirection: 'Current Direction',
    currentSpeed: 'Current speed',
    precipitation: 'Precipitation',
    swellDirection: 'Swell direction',
    swellHeight: 'Swell height',
    swellPeriod: 'Swell period',
    waterTemperature: 'Water temperature',
    waveDirection: 'Wave Direction',
    waveHeight: 'Wave height',
    wavePeriod: 'Wave period',
    windWaveDirection: 'Direction of wind waves',
    windWaveHeight: 'Height of wind waves',
    windWavePeriod: 'Period of wind waves',
    seaLevel: 'Sea level',
    windDirection: 'Wind direction',
    windSpeed: 'Wind speed',
    gust: 'Gust'
  },
  'display-weather-plugin': {
    city: 'City',
    title: 'Temperature on',
    current: 'Current'
  },
  'display-clock-plugin': {
    title_clock: 'Date and hour',
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December'
  },
  'display-dateHeure-plugin': {
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December'
  },
  'display-player-plugin': {
    select_new: 'select a media',
    placeholder: 'Search video..'
  },
  message: {
    pageNotFound: 'Nothing Found',
    copy: 'copy'
  },
  'display-ticker-plugin': {
    loading: 'Loading...',
    save: 'Save',
    modalTitle: 'Enter your text line by line'
  },
  'display-countdown-plugin': {
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    model: 'Model',
    startfrom: 'Target date',
    hourfrom: 'Target time (HH:MM)',
    showStartDate: 'Show start date',
    source: 'choose format',
    startText: 'Start text',
    endText: 'Expired',
    endPosition: 'After',
    startPosition: 'Before',
    countdown1: 'CountDown 1',
    countdown2: 'CountDown 2',
    countdown3: 'CountDown 3',
    labelDays: 'Days',
    labelHours: 'Hours',
    labelMinutes: 'Minutes',
    labelSeconds: 'Seconds',
    formJours: 'Days',
    formHeures: 'Hours',
    formMinutes: 'Minutes',
    formSecondes: 'Seconds',
    textBefore: 'Before',
    textAfter: 'After'
  },
  empreinte: ' Aujourd’hui, empreinte.com est le leader français indépendant. Sa clientèle, composée de grands\n' + 'comptes est pérenne (100% de réabonnement). Depuis 2015 empreinte a connu une croissance de\n' + '+60%. En 2017, la société reçoit une aide BPI innovation de 100 K€ et réalise 1 M€ CA avec 575 K€\n' + 'de fonds propres. En 2018 elle obtient la note H3 de la Banque de France.\n',
  past_css: 'Paste here your HTML/CSS and click Import',
  biblioSegment: {
    allSegments: 'All segments',
    'placeholder-title': 'New segment',
    noSearch: 'No segment corresponds to your search',
    trySearch: 'Try using other search terms and options',
    editSegment: 'Editing a segment',
    textEdit: 'Modify the parameters of your chosen segment according to the criteria presented below',
    addSegment: 'Adding a segment',
    textAdd: 'Add the parameters of your chosen segment according to the criteria presented below',
    textDelete: 'The selected segment is deleted',
    title: 'Title:',
    theme: 'Theme:',
    selectTheme: 'Select one or more themes.',
    selectOneTheme: 'Select one theme.',
    description: 'Description:',
    addDescription: 'Adding a description ...',
    author: 'Author :',
    selectAuthor: 'Select an author.',
    Keyword: 'Keyword:',
    addkeyword: 'Adding a keyword',
    addTitle: 'Adding a Title',
    noResult: 'The list is empty ..',
    noOption: 'No items found.'
  },
  addProgram: {
    textAddLine: 'Add a title and line number',
    textAdd: 'Add a title',
    add: 'Create a new program'
  },
  sizeCanvas: 'Suitable for the screen',
  module: {
    timeline: {
      title: 'Selected'
    },
    segment: {
      title: 'Add segment'
    },
    slide: {
      title: 'Add slide'
    },
    generic: {
      title: 'Generic add',
      textAdd: 'Select a ',
      success_add: 'Generic added'
    }
  },
  exitSave: {
    exitEditor: 'Exit the editor',
    exitPage: 'Are you sure you want to leave the page?'
  },
  styleManager: {
    color: 'Color',
    background: 'Background'
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  button: {
    cancel: 'Annuler',
    confirm: 'Confirmer',
    add: 'Ajouter',
    settings: 'Propriétés',
    back: 'Retour',
    next: 'Suivant',
    edit: 'Modifier',
    finish: 'Terminer',
    preview: 'Aperçu',
    deselect: 'Désélectionner',
    select: 'Sélectionner',
    validate: 'Valider',
    ecran: '+ Écran',
    search: 'Rechercher',
    exit: 'Quitter'
  },
  tabs: {
    screens: 'Liste des écrans',
    dispositions: 'Liste des dispositions',
    models: 'Modèles',
    recents: 'Récent',
    images: 'Images',
    videos: 'Vidéos',
    empty: 'Disposition vierge'
  },
  panels: {
    selectedScreen: ' écran(s) séléctionné(s)',
    addNewScreen: 'Ajouter un écran',
    addNewSegment: 'Ajouter un segment',
    newSegment: 'Nouveau segment',
    deleteScreen: 'Supprimer',
    duplicateScreen: 'Dupliquer un écran',
    duplicateSegment: 'Dupliquer un segment',
    screenSettings: "Paramètres de l'écran",
    editScreen: 'Modifier un écran',
    edit_title: 'Modifier le titre',
    title: 'Titre',
    duration: 'Durée',
    infos: {
      title: 'Informations',
      name_segment: ' Nom de segment:',
      duration_segment: ' Durée de segment:',
      duration_total: ' Durée totale des écrans:',
      name_template: 'Nom de template:',
      duration_template: 'Durée de template:',
      size_template: 'Taille de template:',
      name_screen: "Nom de l'écran:",
      duration_screen: "Durée de l'écran:"
    }
  },
  modal: {
    reclamation_title: 'Envoyer des commentaires',
    reclamation_placeholder: 'Décrivez le problème.',
    about: 'A propos',
    error: 'Message Erorr',
    okText: 'Continuer',
    cancelText: 'Annuler',
    verifDuration: 'La durée des écrans est supérieure à celle de la template',

    delete: {
      title: 'Voulez vous vraiment supprimer?',
      confirm_title: 'Supprimé',
      confirm_msg: 'La suppression est effectuée avec succès.',
      cancel_title: 'Annuler',
      cancel_msg: 'Vous avez annulé la suppression',
      btn_confirm: 'Oui',
      btn_cancel: 'Non'
    },
    edit: {
      title: 'Modifier le titre de cet écran',
      error_msg: 'Entrer un nom',
      btn_confirm: 'Modifier',
      btn_cancel: 'Annuler'
    },
    setting: {
      title: 'Paramètres',
      layers: 'Couches',
      effects: ' Effets',
      opacity: 'Opacité',
      delay: 'Retard(ms)',
      animation: {
        title: 'Animation',
        grow: 'Grandir',
        shrink: 'Reduire',
        'fade-in': 'Fondu',
        'fade-out': 'Eteindre',
        'fade-up': 'Vers le haut',
        'fade-down': 'Vers le bas',
        'fade-left': 'Vers la gauche',
        'fade-right': 'Vers la droite',
        'zoom-in': 'Zoom avant',
        'zoom-out': 'Zoom arriere',
        without_animation: 'sans animation',
        without_transition: 'sans transition',
        convex: 'convexe',
        strike: 'Barré',
        'reveal-text': 'Révélation'
      }
    },
    add_generic: {
      title: 'Sélectionner une vidéo de générique de',
      subtitle: "Veuillez ajouter une vidéo de générique pour terminer l'enregistrement du projet",
      btn_add: 'Ajouter',
      start: 'début',
      end: 'fin'
    }
  },
  disposition: {
    segment: 'Segment',
    disposition: 'Disposition',
    add: 'Ajouter la disposition courante',
    name: 'Nom de la disposition',
    empty: 'Disposition vierge'
  },
  screens: {
    select: 'Séléctionner un écran',
    empty: 'Ecran vierge',
    screen: 'Écran'
  },
  labels: {
    duration: 'Durée',
    direction: 'Direction de la transition',
    transition: 'Type de transition',
    add_model: 'Ajouter un nouveau modèle',
    add_models: 'Ajouter modèle',
    models: 'Modèles',
    images: 'Images',
    videos: 'Vidéos',
    recent: 'Récents',
    title: 'Titre',
    ligne: 'Ligne',
    edit_template_name: 'Veuillez modifier le nom de votre Template:',
    add_template_name: 'Donner un nom à votre Template:',
    Foreground: 'Premier plan',
    advance_more: 'Avancer plus',
    background: 'Arrière plan',
    Recede_less: 'Réculer moins',
    press: 'Appuyez sur ',
    exit_fullScreen: 'pour quitter le plein écran',
    no_models: 'Pas Modèles',
    no_images: 'Pas Images',
    no_videos: 'Pas Vidéos',
    'text-add': 'Ajouter'
  },
  placeholder: {
    search: 'Rechercher..',
    title: 'Titre...',
    describe_problem: 'Décrivez le problème',
    template_title: 'Titre de template',
    ligne: 'Nouvelle ligne'
  },
  titles: {
    send_comment: 'Envoyer des commentaires',
    title_transition: 'Liste des transitions entre les diapositives'
  },
  texts: {},
  template: {
    add_name: 'Donner un nom à votre template:',
    name: 'Nom de la template',
    save_template: 'Enregistrer la template',
    save_as_template: 'Enregistrer une copie de template',
    save_as_copie: 'Enregistrer une copie',
    save_as_video: 'Publier',
    save_and_exit: '  Enregistrer et quitter',
    new_template: 'Nouveau programme',
    new_ligne: 'Nouvelle ligne',
    reclamation: 'Réclamation'
  },
  tooltips: {
    'sw-visibility': 'Affiche les bordures',
    preview: 'Aperçu',
    fullscreen: 'Plein écran',
    'preview-screens': 'Visualisation des écrans',
    'export-template': 'Exporter',
    undo: 'Annuler',
    redo: 'Refaire',
    'gjs-open-import-webpage': 'Importer',
    'canvas-clear': 'Nettoyer canvas',
    'open-sm': 'Gestionnaire de style',
    'open-layers': 'Layers',
    'open-blocks': 'Blocs',
    save: 'Enregistrer',
    'save-template': 'Enregistrer',
    move: 'Déplacement',
    duplicate: 'Dupliquer',
    delete: 'Supprimer',
    setting: 'Paramètres',
    edit: 'Modifier'
  },
  blocks: {
    column1: 'Une colonne',
    column2: 'Deux colonnes',
    column3: 'Trois colonnes',
    'column3-7': 'Deux colonnes 3/7',
    custom_column2: 'Deux colonnes',
    filet: 'Séparateur',
    text: 'Texte',
    link: 'Lien',
    image: 'Image',
    image_media: 'Image',
    video: 'Video',
    map: 'Carte',
    'h-navbar': 'Navbar',
    countdown: 'Compte à rebours',
    form: 'Formulaire',
    input: 'Input',
    textarea: 'Textarea',
    select: 'Selection',
    button: 'Bouton',
    label: 'Label',
    checkbox: 'Checkbox',
    radio: 'Radiobox',
    select_video: 'Sélectionner une vidéo',
    select_image: 'Sélectionner une image',
    drop_files: 'Déposer les fichiers ici ou cliquer pour télécharger',
    select_screen: 'Sélectionner un ou plusieurs écrans',
    select_new: 'Sélectionner un média',
    add_generic_debut: 'générique début ',
    add_generic_fin: 'générique fin ',
    add_generic_intro: "Vidéo d'introduction ",
    preview_screens: 'Visualisation des écrans',
    'link-block': 'Bloc des liens',
    quote: 'Citation',
    'text-basic': 'Texte Basique',
    'lory-slider': 'Lory Slider',
    playlist: 'Playlist',
    Weather: 'Météo',
    Clock: 'Horloge',
    facebook_widget: 'Facebook',
    linkedin_widget: 'LinkedIn',
    rss_widget: 'RSS',
    ticker: 'Téléscripteur',
    web_widget: 'Web',
    webrtc_widget: 'WebRtc',
    player: 'Player',
    video_mp4: 'Player mp4',
    live: 'Direct',
    generic_begin: 'Générique Debut',
    generic_end: 'Générique Fin',
    'social-icons-twitter': 'Twitter',
    Basic: 'Basique',
    Extra: 'Extra',
    Forms: 'Formlaires',
    Widget: 'Widgets',
    Pattern: 'Pattern',
    Media: 'Média',
    column: 'Colonne',
    Tides: 'Marées',
    endText: 'Expiré',
    labelDays: 'Jours',
    labelHours: 'Heures',
    labelMinutes: 'Minutes',
    labelSeconds: 'Secondes',
    dateHeure: 'Date et Heure',
    Text: 'Texte',
    Areas: 'Zones',
    Medias: 'Médias',
    Social: 'Réseaux sociaux',
    Disposition: 'Disposition',
    Dimension: 'Dimension',
    Spacing: 'Espacement',
    Decoration: 'Décoration',
    Background: 'Arrière-plan',
    Border: 'Bordure',
    Responsive: 'Responsive',
    params: 'Paramètres avancés',
    social_media: 'Médias',
    'social-media': 'Sélectionner un média',
    'image-media': 'Sélectionner une image',
    'select_image-media': 'Sélectionner une image',
    select_pattern: 'Sélectionner un motif',
    'custom-title': 'Bloc titre',
    'custom-sharing': 'Bloc partage',
    'custom-credit': 'Bloc crédit',
    pattern: 'Pattern',
    'custom-countdown': 'compte à rebours'
  },
  'display-tides-plugin': {
    tides: 'Marées',
    title: 'Titre',
    lat: 'Latitude',
    lng: 'Longitude',
    start: 'Debut',
    end: 'Fin',
    airTemperature: 'Température de lair',
    humidity: 'Humidité',
    cloudCover: 'Couverture nuageuse',
    currentDirection: 'Direction actuelle',
    currentSpeed: 'Vitesse actuelle',
    precipitation: 'Précipitation',
    swellDirection: 'Direction de houle',
    swellHeight: 'Hauteur de houle',
    swellPeriod: 'Période de houle',
    waterTemperature: 'Température de leau',
    waveDirection: 'Direction des vagues',
    waveHeight: 'Hauteur des vagues',
    wavePeriod: 'Période de vague',
    windWaveDirection: 'Direction des vagues de vent',
    windWaveHeight: 'Hauteur des vagues de vent',
    windWavePeriod: 'Période des vagues de vent',
    seaLevel: 'Niveau de la mer',
    windDirection: 'Direction du vent',
    windSpeed: 'Vitesse du vent',
    gust: 'Rafale'
  },
  'display-weather-plugin': {
    city: 'Ville',
    title: 'Température sur',
    current: 'Courant'
  },
  clock_plugin: {
    title_clock: 'Date et heure',
    sunday: 'Dimanche',
    monday: 'Lundi',
    tuesday: 'Mardi',
    wednesday: 'Mercredi',
    thursday: 'Jeudi',
    friday: 'Vendredi',
    saturday: 'Samedi',
    january: 'Janvier',
    february: 'Février',
    march: 'Mars',
    april: 'Avril',
    may: 'Mai',
    june: 'Juin',
    july: 'Juillet',
    august: 'Aout',
    september: 'Septembre',
    october: 'Octobre',
    november: 'Novembre',
    december: 'Decembre'
  },
  'display-clock-plugin': {
    title_clock: 'Date et heure',
    sunday: 'Dimanche',
    monday: 'Lundi',
    tuesday: 'Mardi',
    wednesday: 'Mercredi',
    thursday: 'Jeudi',
    friday: 'Vendredi',
    saturday: 'Samedi',
    january: 'Janvier',
    february: 'Février',
    march: 'Mars',
    april: 'Avril',
    may: 'Mai',
    june: 'Juin',
    july: 'Juillet',
    august: 'Aout',
    september: 'Septembre',
    october: 'Octobre',
    november: 'Novembre',
    december: 'Decembre'
  },
  'display-dateHeure-plugin': {
    january: 'Janvier',
    february: 'Février',
    march: 'Mars',
    april: 'Avril',
    may: 'Mai',
    june: 'Juin',
    july: 'Juillet',
    august: 'Aout',
    september: 'Septembre',
    october: 'Octobre',
    november: 'Novembre',
    december: 'Decembre'
  },
  'display-player-plugin': {
    select_new: 'Sélectionner un média',
    placeholder: 'Chercher une video..'
  },
  'display-ticker-plugin': {
    loading: 'Chargement...',
    save: 'Enregistrer',
    modalTitle: 'Entrer votre texte ligne par ligne'
  },
  'display-image-plugin': {
    'select_image-media': 'Sélectionner une image'
    // placeholder: 'Chercher une video..',
  },
  'display-pattern-plugin': {
    select_pattern: 'Sélectionner un motif'
    // placeholder: 'Chercher une video..',
  },
  'display-countdown-plugin': {
    sunday: 'Dimanche',
    monday: 'Lundi',
    tuesday: 'Mardi',
    wednesday: 'Mercredi',
    thursday: 'Jeudi',
    friday: 'Vendredi',
    saturday: 'Samedi',
    january: 'Janvier',
    february: 'Février',
    march: 'Mars',
    april: 'Avril',
    may: 'Mai',
    june: 'Juin',
    july: 'Juillet',
    august: 'Aout',
    september: 'Septembre',
    october: 'Octobre',
    november: 'Novembre',
    december: 'Decembre',
    model: 'Modéle',
    startfrom: 'Date cible',
    hourfrom: 'Temps cible (HH:MM)',
    showStartDate: 'Afficher la date de début',
    source: 'Choisir le format',
    startText: 'Texte de début',
    endText: 'Expiré',
    endPosition: 'Après',
    startPosition: 'Avant',
    countdown1: 'Compte à rebours 1',
    countdown2: 'Compte à rebours 2',
    countdown3: 'Compte à rebours 3',
    labelDays: 'Jours',
    labelHours: 'Heures',
    labelMinutes: 'Minutes',
    labelSeconds: 'Secondes',
    formJours: 'Jours',
    formHeures: 'Heures',
    formMinutes: 'Minutes',
    formSecondes: 'Secondes',
    textBefore: 'Avant',
    textAfter: 'Après'
  },
  message: {
    pageNotFound: "Rien n'a été trouvé",
    copy: 'copie'
  },
  empreinte: " distribue une ligne complète de solution vidéo: LIVE RICHMEDIA, WEBTV, L'AFFICHAGE Intranet",
  past_css: 'Coller votre code HTML/CSS et cliquer sur Importer',
  biblioSegment: {
    title: 'Titre',
    theme: 'Thèmes',
    'placeholder-title': 'Nouveau segment',
    selectTheme: 'Selectionner un ou plusieurs thèmes..',
    selectOneTheme: 'Selectionner un thème..',
    description: 'Description',
    addDescription: "Ajout d'une description...",
    author: 'Auteur',
    selectAuthor: 'Selectionner un auteur..',
    Keyword: 'Mots clés',
    addkeyword: 'Ajouter un tag',
    trySearch: "Essayez d'utiliser d'autres termes et options de recherche",
    textDelete: 'Le segment sélectionné est supprimé',
    textAdd: 'Remplir les informations du segment selon les critères mentionnés ci-dessous',
    addSegment: "Ajout d'un segment",
    textEdit: 'Modifier les informations du segment selon les critères mentionnés ci-dessous',
    editSegment: "Modification d'un segment",
    noSearch: 'Aucun segment ne correspond à votre recherche',
    allSegments: 'Tous les segments',
    addTitle: "Ajout d'un Titre",
    noResult: 'La liste est vide..',
    noOption: 'Aucun élément trouvé.'
  },

  addProgram: {
    textAddLine: 'Ajouter un titre et le numéro de la ligne',
    textAdd: 'Ajouter un titre',
    add: 'Créer un nouveau programme'
  },
  sizeCanvas: "Adapté à l'écran",
  module: {
    timeline: {
      title: 'Sélectionné'
    },
    segment: {
      title: 'Ajouter un segment'
    },
    slide: {
      title: 'Ajouter un écran'
    },
    generic: {
      title: 'Ajouter générique',
      textAdd: 'Sélectionner le ',
      success_add: 'Générique ajouté'
    }
  },
  exitSave: {
    exitEditor: "Quitter l'éditeur",
    exitPage: ' Êtes-vous sûr de vouloir quitter la page?'
  },
  styleManager: {
    color: 'Couleur',
    background: 'Arrière plan'
  }
});

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fos_routing__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fos_routing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fos_routing__);

// import file with routes data
var RoutingData = __webpack_require__.i({"NODE_ENV":"production","API_HOST":"undefined","API_HOST_GLOBAL":"undefined","API_TOCKEN":"eyJhbGciOiJSUzI1NiJ9.eyJyb2xlcyI6WyJST0xFX0ZPIiwiUk9MRV9VU0VSIl0sInVzZXJuYW1lIjoiX19mbyIsImlhdCI6MTUyOTQxNzcxNiwiZXhwIjo3ODM2NjE3NzE2fQ.ax85TH2CiufYRwQJ8xnh_ENrpzc8InJmMxHJIuvqjaPZJe8YQW4vjxTGigrYQXt8JJUu4WWery9XlnfIAitfIxw5El8IJqEZeXw-I5M0tDJM60FoMsQ5cQxVjTa43WmLWAF_2N8J6JXw9_xb0nAkeH14qKiSmCB7U0Ma2OVOTOOeJ-p4TArqScgmKSCRMsHM9BxX4UEwfM0-uUlQE4P_Hr_Je7ucGs0PA13ZjcL7Soq7W7-OUCwDi7EMRdKotMGTmTgYZUgl-v007AVd8jyPMyfFbuPcrrENRmcFXQe2s58WNakH3w83NgscoTatHlOl2kWQ5BRxUOzFL2JXFphH1_34571T-snGaxfafymsLHrXd1XDwVOl1kbrMyjv6v-LHdeyztmetlcPbXiUaaFmMdsaHMIUc2QXFjTvxsVIVep5-hafdss5zxLPhV6WgUKcRdYA1anG2LDIWnb593h72LWM3FipkZzDTdb9hKPTAphsXyFxld_rS6AUxAe0N_6qeHmGXLLt-jWqnlH-OIYTFXWJIZSZk00T62nueGqrC59Mkh81wwGP7g7fB91RjuTUP6FNGkWYRTkG3RFtdaohaRVwDQmeDVnkSp2Jl5upJRZKmcMUJ1eM20hvSX0wtX3PpxxXjups01FWq8704CrVJSP8bdrw4uj-9V62ZUDhlNM","BASE_HREF":"undefined","API_GO_HOST":"undefined","API_GO_TOKEN":"eyJhbGciOiJSUzI1NiJ9.eyJ1c2VybmFtZSI6InVzZXJfcGhvdG9wcmlzbSIsImlkIjoxMCwicm9sZXMiOlsiUk9MRV9VU0VSIl0sImlhdCI6MTU3NDY5Nzc4MywiZXhwIjo3ODgxODk3NzgzfQ.FwBMnJND_bYSRTxKPBeZk7hipgHx9wBcuSnE0ZQqPE2H5p89awb4Skrg6_jzLkUuPORehVu12Z4qZMkOw-HUpAqB8eNSC3lxGA_QKbmEU5P44hl6wncZywRcyCZEMUz-fYWU0DUfGZyyUnKdf0pEat-uhs3AcS2bdVY2J2cZE53C8B-ohyHAnpKySbD-WWVnhy5REusC_CZGJfatjqAbDyOvRpr8Ff1IvgwJrgKTfCb9gNjE-NoPgzSzfqvfSPilbMKPv2nxj6CyrPEKmFqRUEb6KOXNNSoyOFDYadsC0Y2Xw1Yd0U09wz5RlyIrjp1RwUDjvDyvdZm97aa103dx3ZRVuYAYhge3Mo_WkGJw_5hOzwAbGzPbYhM6H6OSp0FOpk6ltFuu7K7--Q3RFq98o4RkgxKWbQoKDQdpkfIrnzzKDUvo9ZIFbXueGEfgSdB8HRU5A4dkPDuy5aBNPqnDTKASgpXBPvlk0buStM-lVPP42bspZl7NqVMzYeUQCWjzVTfbuUw4nu8OVa-C0PeB0U5bevAq0Lp-RhdcPN76kpA4mYaCSNdnIVyKbYKpNK2IKE1k99gq1fgF0QOGSDKjHynVTrSWdD2i3otp1mSeOJgYtLmTK6bb9HxQVnfs91p20QEN5Jdfm8txoHav6aUlgEwA10tUrq3JLa_lUqb0HWg"}).MODE && __webpack_require__.i({"NODE_ENV":"production","API_HOST":"undefined","API_HOST_GLOBAL":"undefined","API_TOCKEN":"eyJhbGciOiJSUzI1NiJ9.eyJyb2xlcyI6WyJST0xFX0ZPIiwiUk9MRV9VU0VSIl0sInVzZXJuYW1lIjoiX19mbyIsImlhdCI6MTUyOTQxNzcxNiwiZXhwIjo3ODM2NjE3NzE2fQ.ax85TH2CiufYRwQJ8xnh_ENrpzc8InJmMxHJIuvqjaPZJe8YQW4vjxTGigrYQXt8JJUu4WWery9XlnfIAitfIxw5El8IJqEZeXw-I5M0tDJM60FoMsQ5cQxVjTa43WmLWAF_2N8J6JXw9_xb0nAkeH14qKiSmCB7U0Ma2OVOTOOeJ-p4TArqScgmKSCRMsHM9BxX4UEwfM0-uUlQE4P_Hr_Je7ucGs0PA13ZjcL7Soq7W7-OUCwDi7EMRdKotMGTmTgYZUgl-v007AVd8jyPMyfFbuPcrrENRmcFXQe2s58WNakH3w83NgscoTatHlOl2kWQ5BRxUOzFL2JXFphH1_34571T-snGaxfafymsLHrXd1XDwVOl1kbrMyjv6v-LHdeyztmetlcPbXiUaaFmMdsaHMIUc2QXFjTvxsVIVep5-hafdss5zxLPhV6WgUKcRdYA1anG2LDIWnb593h72LWM3FipkZzDTdb9hKPTAphsXyFxld_rS6AUxAe0N_6qeHmGXLLt-jWqnlH-OIYTFXWJIZSZk00T62nueGqrC59Mkh81wwGP7g7fB91RjuTUP6FNGkWYRTkG3RFtdaohaRVwDQmeDVnkSp2Jl5upJRZKmcMUJ1eM20hvSX0wtX3PpxxXjups01FWq8704CrVJSP8bdrw4uj-9V62ZUDhlNM","BASE_HREF":"undefined","API_GO_HOST":"undefined","API_GO_TOKEN":"eyJhbGciOiJSUzI1NiJ9.eyJ1c2VybmFtZSI6InVzZXJfcGhvdG9wcmlzbSIsImlkIjoxMCwicm9sZXMiOlsiUk9MRV9VU0VSIl0sImlhdCI6MTU3NDY5Nzc4MywiZXhwIjo3ODgxODk3NzgzfQ.FwBMnJND_bYSRTxKPBeZk7hipgHx9wBcuSnE0ZQqPE2H5p89awb4Skrg6_jzLkUuPORehVu12Z4qZMkOw-HUpAqB8eNSC3lxGA_QKbmEU5P44hl6wncZywRcyCZEMUz-fYWU0DUfGZyyUnKdf0pEat-uhs3AcS2bdVY2J2cZE53C8B-ohyHAnpKySbD-WWVnhy5REusC_CZGJfatjqAbDyOvRpr8Ff1IvgwJrgKTfCb9gNjE-NoPgzSzfqvfSPilbMKPv2nxj6CyrPEKmFqRUEb6KOXNNSoyOFDYadsC0Y2Xw1Yd0U09wz5RlyIrjp1RwUDjvDyvdZm97aa103dx3ZRVuYAYhge3Mo_WkGJw_5hOzwAbGzPbYhM6H6OSp0FOpk6ltFuu7K7--Q3RFq98o4RkgxKWbQoKDQdpkfIrnzzKDUvo9ZIFbXueGEfgSdB8HRU5A4dkPDuy5aBNPqnDTKASgpXBPvlk0buStM-lVPP42bspZl7NqVMzYeUQCWjzVTfbuUw4nu8OVa-C0PeB0U5bevAq0Lp-RhdcPN76kpA4mYaCSNdnIVyKbYKpNK2IKE1k99gq1fgF0QOGSDKjHynVTrSWdD2i3otp1mSeOJgYtLmTK6bb9HxQVnfs91p20QEN5Jdfm8txoHav6aUlgEwA10tUrq3JLa_lUqb0HWg"}).MODE == 'local' ? __webpack_require__(162) : __webpack_require__(161);
var routerDefault = RoutingData['default'];
// set data
__WEBPACK_IMPORTED_MODULE_0_fos_routing___default.a.setData(routerDefault);

// export library
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_fos_routing___default.a);

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = HTTP;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


// Force the API host to https so CORS preflight requests are not redirected
// (http://  or protocol-relative //  -> https://). A redirect on a preflight
// request is rejected by the browser.
function toHttps(host) {
  if (!host) return host;
  return host.trim().replace(/^http:\/\//i, 'https://').replace(/^\/\//, 'https://');
}

function HTTP(token) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    baseURL: toHttps(window.process && window.process.env && window.process.env.API_HOST_GLOBAL),
    headers: {
      Authorization: token
    }
  });
}

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_modules_paramsClient_data__ = __webpack_require__(119);


/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: function inserted(el, binding, vnode) {
    // To be sure that the state is Ready
    setTimeout(function () {
      var permissions = __WEBPACK_IMPORTED_MODULE_0__store_modules_paramsClient_data__["a" /* default */].state.permissions;
      var values = binding.value.split(',');
      var hasPermission = values.some(function (v) {
        return permissions[v];
      });

      if (!hasPermission) {
        vnode.elm.parentElement.removeChild(vnode.elm);
        // OR
        // el.parentNode.removeChild(el);
      }
    }, 100);
  }
});

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__en_US__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fr_FR__ = __webpack_require__(12);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'fr',
  messages: {
    en: __WEBPACK_IMPORTED_MODULE_2__en_US__["a" /* default */],
    fr: __WEBPACK_IMPORTED_MODULE_3__fr_FR__["a" /* default */]
  }
}));

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateSlidesDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return totalSegmentDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateSegmentDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isMultipleBy30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateSegmentOriginalDuration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_modules_paramsClient_data_js__ = __webpack_require__(119);



var totalSegmentDuration = function totalSegmentDuration() {
  return +__WEBPACK_IMPORTED_MODULE_1__store_modules_paramsClient_data_js__["a" /* default */].state.paramsClient.default_segment_duration || 20;
};

var isMultipleBy30 = function isMultipleBy30() {
  return +__WEBPACK_IMPORTED_MODULE_1__store_modules_paramsClient_data_js__["a" /* default */].state.paramsClient.default_segment_duration === 30 && +__WEBPACK_IMPORTED_MODULE_1__store_modules_paramsClient_data_js__["a" /* default */].state.paramsClient.nb_screen_segment !== 1;
};

var canEditDuration = function canEditDuration() {
  return __WEBPACK_IMPORTED_MODULE_1__store_modules_paramsClient_data_js__["a" /* default */].state.permissions.edit_duration_segment_action;
};

var updateSlidesDuration = function updateSlidesDuration(segment) {
  var segmentDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : totalSegmentDuration();

  if (canEditDuration()) {
    return segment;
  }
  var segmentShadow = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(segment));
  var startGeneric = segmentShadow.find(function (s) {
    return s.type === 'startGeneric';
  });

  var length = segmentShadow.length - (startGeneric ? 1 : 0);
  var duration = segmentDuration;

  if (startGeneric) {
    duration = Math.max(duration - startGeneric.options.duration, 0);
  }
  segmentShadow = segmentShadow.map(function (slide, index) {
    if (typeof slide.options === "string") {
      slide.options = JSON.parse(slide.options);
    }
    if (slide.type === 'startGeneric') {
      slide.options.duration = Math.min(slide.options.duration, segmentDuration);
    } else {
      slide.options.duration = Math.floor(+duration / length);

      if (index === segmentShadow.length - 1) {
        slide.options.duration += +duration % length;
      }
    }
    return slide;
  });
  return segmentShadow;
};

var updateSegmentDuration = function updateSegmentDuration(segments) {
  if (canEditDuration()) {
    return segments;
  }
  var startGeneric = segments.find(function (s) {
    return s.type === 'startGeneric';
  });
  var finishGeneric = segments.find(function (s) {
    return s.type === 'finishGeneric';
  });

  var segmentWithFullScreen = segments.filter(function (segmentf) {

    return segmentf.screens.find(function (s) {
      return s.options.fullscreenVideo === true;
    });
  }).map(function (segment, index) {
    return segment;
  });
  var AllDuration = segmentWithFullScreen.reduce(function (sum, e) {
    return sum + +(e.duration || 0);
  }, 0);
  var segmentWithoutFullScreen = segments.filter(function (segmentf) {
    return segmentf.screens.every(function (s) {
      return s.options.fullscreenVideo !== true;
    });
  });
  /*todo mode 30 */
  var durationMod30 = AllDuration && AllDuration > 0 ? AllDuration % 30 : 0;
  var lengthStartGeneric = startGeneric ? 1 : 0;
  var lengthFinishGeneric = finishGeneric ? 1 : 0;
  var lengthSegments = segmentWithoutFullScreen.length - lengthStartGeneric - lengthFinishGeneric;
  durationMod30 = durationMod30 > 0 ? durationMod30 > 15 ? 30 - durationMod30 : durationMod30 : 0;
  var newDuration = durationMod30 > 0 ? Math.floor(durationMod30 / lengthSegments) : 0;
  newDuration = newDuration > 0 ? newDuration : 0;
  var hasModDuration = durationMod30 ? durationMod30 % lengthSegments : 0;
  var durationNew = 0;
  var durationNewLast = 0;

  segments.map(function (segment, index) {
    if (segment.screens.find(function (s) {
      return s.options.fullscreenVideo === true;
    })) {
      durationNewLast = segment.duration;
      durationNewLast = durationNewLast && durationNewLast > 0 ? (durationNew + durationNewLast) % 30 : durationNew;
      durationNew = durationNewLast > 15 ? durationNewLast - 30 : durationNewLast;

      return segment;
    }

    var duration = segment.originalDuration || totalSegmentDuration();

    if (!segment.type.toLowerCase().includes('generic')) {
      var durationS = duration - durationNew < 0 ? duration - durationNew + 30 : duration - durationNew;
      segment.duration = duration - durationNew < 0 ? duration - durationNew + 30 : duration - durationNew;
      segment.screens = updateSlidesDuration(segment.screens, durationS);
      durationNew = 0;
    }

    return segment;
  });
  var seg = segments.filter(function (segmentf) {
    return segmentf.screens.every(function (s) {
      return s.options.fullscreenVideo !== true;
    });
  }).filter(function (s) {
    return s.type !== 'startGeneric';
  }).filter(function (s) {
    return s.type !== 'finishGeneric';
  });
  if (durationNew !== 0) {
    if (seg[seg.length - 1]) seg[seg.length - 1].duration = seg[seg.length - 1].duration - durationNew < 0 ? seg[seg.length - 1].duration - durationNew + 30 : seg[seg.length - 1].duration - durationNew;
  }

  if (!!startGeneric) {
    if (seg[0]) seg[0].duration = seg[0].duration - startGeneric.duration < 0 ? seg[0].duration - startGeneric.duration + 30 : seg[0].duration - startGeneric.duration;
  }
  if (!!finishGeneric) {
    if (seg[seg.length - 1]) seg[seg.length - 1].duration = seg[seg.length - 1].duration - finishGeneric.duration < 0 ? seg[seg.length - 1].duration - finishGeneric.duration + 30 : seg[seg.length - 1].duration - finishGeneric.duration;
  }

  segments.map(function (segment, index) {
    if (segment.screens.find(function (s) {
      return s.options.fullscreenVideo === true;
    })) {
      return segment;
    }
    if (!segment.type.toLowerCase().includes('generic')) {
      segment.screens = updateSlidesDuration(segment.screens, segment.duration);
    }
    return segment;
  });
  return segments;
};

var updateSegmentOriginalDuration = function updateSegmentOriginalDuration(segments) {
  if (canEditDuration()) {
    return segments;
  }
  var startGeneric = segments.find(function (s) {
    return s.type === 'startGeneric';
  });
  var finishGeneric = segments.find(function (s) {
    return s.type === 'finishGeneric';
  });
  var durationNewLast = 0;
  var durationNew = 0;
  segments.map(function (segment, index) {
    if (segment.screens.find(function (s) {
      return s.options.fullscreenVideo === true;
    })) {
      durationNewLast = segment.duration;
      durationNewLast = durationNewLast && durationNewLast > 0 ? (durationNew + durationNewLast) % 30 : durationNew;
      durationNew = durationNewLast > 15 ? durationNewLast - 30 : durationNewLast;
      return segment;
    }
    var duration = 0;

    if (!segment.type.toLowerCase().includes('generic')) {
      duration = segment.duration;
      var durationS = duration + durationNew;
      segment.originalDuration = durationS;
      durationNew = 0;
    }

    return segment;
  });

  var seg = segments.filter(function (segmentf) {
    return segmentf.screens.every(function (s) {
      return s.options.fullscreenVideo !== true;
    });
  }).filter(function (s) {
    return s.type !== 'startGeneric';
  }).filter(function (s) {
    return s.type !== 'finishGeneric';
  });
  if (durationNew !== 0) {
    if (seg[seg.length - 1]) {
      var duration1 = seg[seg.length - 1].originalDuration || seg[seg.length - 1].duration || totalSegmentDuration();

      seg[seg.length - 1].originalDuration = duration1 + durationNew;
    }
  }
  if (!!startGeneric) {
    if (seg[0]) {
      var duration2 = seg[0].originalDuration || totalSegmentDuration();
      seg[0].originalDuration = duration2 + startGeneric.duration;
    }
  }
  if (!!finishGeneric) {
    if (seg[seg.length - 1]) {
      var duration3 = seg[seg.length - 1].originalDuration || totalSegmentDuration();
      seg[seg.length - 1].originalDuration = duration3 + finishGeneric.duration;
    }
  }
  return segments;
};



/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_to_image__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_to_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_to_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_base64_img__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_base64_img___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_base64_img__);








// Force image URLs to https before fetching them for base64 inlining.
// An http:// (or protocol-relative) CDN URL gets redirected to https, and a
// redirect on the (CORS-preflighted) request is rejected by the browser
// ("Failed to fetch"), which would otherwise leave the thumbnail without its
// background. https:// avoids the redirect entirely.
function toHttps(url) {
  if (!url || typeof url !== 'string') return url;
  return url.trim().replace(/^http:\/\//i, 'https://').replace(/^\/\//, 'https://');
}

var styles = ['display/plugins/ticker/ticker.css', 'display/plugins/clock/clock.css', 'display/static/css/fonts.css', 'display/static/css/countdown.css', 'display/plugins/dateHeure/dateHeure.css', 'display/plugins/weather/weather.css', 'display/static/css/pays-icon.css'];

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({})),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('slides', ['updateSlideThumbnail']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('segments', ['updateSegmentThumbnail', 'updateSegmentListThumbnail']), {
    initClone: function initClone() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var iframe, _iframe$getBoundingCl, width, height, cloneWrapper;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                iframe = document.querySelector('.gjs-frame');
                _iframe$getBoundingCl = iframe.getBoundingClientRect(), width = _iframe$getBoundingCl.width, height = _iframe$getBoundingCl.height;
                cloneWrapper = document.createElement('iframe');

                cloneWrapper.style.position = 'absolute';
                cloneWrapper.style['z-index'] = '-9999';
                cloneWrapper.style.top = '-9999px';
                cloneWrapper.style.left = '-9999px';
                cloneWrapper.style.width = (width > 0 ? width : 1280) + 'px';
                cloneWrapper.style.height = (height > 0 ? height : 720) + 'px';
                cloneWrapper.id = 'clone';

                document.body.appendChild(cloneWrapper);
                setTimeout(function () {
                  var body = $('#clone').contents().find('body');

                  setTimeout(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                    var contentWrapper, xhr, i;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            contentWrapper = document.createElement('div');

                            contentWrapper.className = 'wrapper';
                            contentWrapper.style["background-color"] = '#fff';

                            body.append(contentWrapper);

                            xhr = [];
                            i = 0;

                          case 6:
                            if (!(i < styles.length)) {
                              _context.next = 12;
                              break;
                            }

                            _context.next = 9;
                            return function (i) {
                              xhr[i] = new XMLHttpRequest();
                              var url = styles[i];
                              xhr[i].open('GET', url, true);
                              xhr[i].onreadystatechange = function () {
                                if (xhr[i].readyState === 4 && xhr[i].status === 200) {
                                  var style = document.createElement('style');
                                  style.type = 'text/css';
                                  style.innerHTML = xhr[i].responseText;
                                  body.append(style);
                                }
                              };
                              xhr[i].send();
                            }(i);

                          case 9:
                            i++;
                            _context.next = 6;
                            break;

                          case 12:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  })), 500);
                }, 500);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    generateSlideThmbnail: function generateSlideThmbnail(uid) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.cloneNode();
                _context3.next = 3;
                return _this2.handleStyle();

              case 3:
                _context3.next = 5;
                return _this2.handleInlineStyle();

              case 5:
                _context3.next = 7;
                return _this2.handleImgTags();

              case 7:
                _context3.next = 9;
                return _this2.handlePlayers();

              case 9:
                _context3.next = 11;
                return _this2.handleVideos();

              case 11:
                _context3.next = 13;
                return _this2.renderSlide(uid);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    cloneNode: function cloneNode() {
      var previewFrame = $('#gjs iframe').contents();
      var domforImage = previewFrame.find('body')[0].innerHTML.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/g, '');

      var cloneBody = $('#clone').contents().find('.wrapper');

      cloneBody.html(domforImage);

      this.domforImage = cloneBody[0];
      var back = getComputedStyle(document.querySelector('#gjs iframe').contentWindow.document.querySelector("body"))["background-color"];
      if (back) this.domforImage.style["background-color"] = back;
    },
    handleStyle: function handleStyle() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var styles, _loop, i;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                styles = _this3.domforImage.getElementsByTagName('style');
                _loop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _loop(i) {
                  var style;
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _loop$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          style = styles[i];
                          _context5.next = 3;
                          return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (mainResolve) {
                            _this3.replaceAsync(style.innerHTML, /\bhttps?:[^)''"]+\.(?:jpe?g|png|gif|svg)(?![a-z/])/g, function () {
                              var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(img) {
                                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                                  while (1) {
                                    switch (_context4.prev = _context4.next) {
                                      case 0:
                                        _context4.next = 2;
                                        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                                          __WEBPACK_IMPORTED_MODULE_6_base64_img___default.a.requestBase64(toHttps(img), function (err, res, body) {
                                            if (err) {
                                              console.error('ERRRR', err);
                                            }
                                            // Fall back to the original URL when inlining fails so the
                                            // background is never replaced with `undefined` (and stripped).
                                            resolve(body || img);
                                          });
                                        });

                                      case 2:
                                        return _context4.abrupt('return', _context4.sent);

                                      case 3:
                                      case 'end':
                                        return _context4.stop();
                                    }
                                  }
                                }, _callee4, _this3);
                              }));

                              return function (_x) {
                                return _ref2.apply(this, arguments);
                              };
                            }()).then(function (replacedString) {
                              style.innerHTML = replacedString;
                              mainResolve();
                            });
                          });

                        case 3:
                        case 'end':
                          return _context5.stop();
                      }
                    }
                  }, _loop, _this3);
                });
                i = 0;

              case 3:
                if (!(i < styles.length)) {
                  _context6.next = 8;
                  break;
                }

                return _context6.delegateYield(_loop(i), 't0', 5);

              case 5:
                i++;
                _context6.next = 3;
                break;

              case 8:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee5, _this3);
      }))();
    },
    handleInlineStyle: function handleInlineStyle() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var divs, _loop2, i;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                divs = _this4.domforImage.getElementsByTagName('*');
                _loop2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _loop2(i) {
                  var div, img;
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _loop2$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          div = divs[i];
                          img = div.style.backgroundImage.split('"')[1];

                          if (!/\.(?:jpe?g|png|gif|svg)/g.test(img)) {
                            _context7.next = 5;
                            break;
                          }

                          _context7.next = 5;
                          return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                            __WEBPACK_IMPORTED_MODULE_6_base64_img___default.a.requestBase64(toHttps(img), function (err, res, body) {
                              if (err) {
                                console.error('ERRRR', err);
                              }
                              // Keep the original URL when inlining fails instead of "undefined".
                              div.style.backgroundImage = 'url("' + (body || img) + '")';
                              resolve();
                            });
                          });

                        case 5:
                        case 'end':
                          return _context7.stop();
                      }
                    }
                  }, _loop2, _this4);
                });
                i = 0;

              case 3:
                if (!(i < divs.length)) {
                  _context8.next = 8;
                  break;
                }

                return _context8.delegateYield(_loop2(i), 't0', 5);

              case 5:
                i++;
                _context8.next = 3;
                break;

              case 8:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee6, _this4);
      }))();
    },
    handleImgTags: function handleImgTags() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var images, _loop3, i;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                images = _this5.domforImage.getElementsByTagName('img');
                _loop3 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _loop3(i) {
                  var img, originalSrc;
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _loop3$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          img = images[i];

                          if (!/\.(?:jpe?g|png|gif|svg)/g.test(img.src)) {
                            _context9.next = 5;
                            break;
                          }

                          originalSrc = img.src;
                          _context9.next = 5;
                          return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                            __WEBPACK_IMPORTED_MODULE_6_base64_img___default.a.requestBase64(toHttps(originalSrc), function (err, res, body) {
                              if (err) {
                                console.error('ERRRR', err);
                              }
                              // Keep the original src when inlining fails instead of "undefined".
                              img.src = body || originalSrc;
                              resolve();
                            });
                          });

                        case 5:
                        case 'end':
                          return _context9.stop();
                      }
                    }
                  }, _loop3, _this5);
                });
                i = 0;

              case 3:
                if (!(i < images.length)) {
                  _context10.next = 8;
                  break;
                }

                return _context10.delegateYield(_loop3(i), 't0', 5);

              case 5:
                i++;
                _context10.next = 3;
                break;

              case 8:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee7, _this5);
      }))();
    },

    // Problème 12 : dom-to-image sérialise le DOM dans un <foreignObject> SVG, où
    // un élément <video> n'est jamais rasterisé — la vignette d'un écran vidéo
    // ressortait donc entièrement blanche. On remplace la balise par une image
    // fixe (le `poster` de la vidéo, à défaut un fond noir) surmontée de l'icône
    // « play », ce que dom-to-image sait rendre.
    replaceVideoTag: function replaceVideoTag(video) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var _video$getBoundingCli, width, height, placeholder, poster, inlined;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _video$getBoundingCli = video.getBoundingClientRect(), width = _video$getBoundingCli.width, height = _video$getBoundingCli.height;
                placeholder = document.createElement('div');

                placeholder.setAttribute('style', video.getAttribute('style') || '');
                placeholder.style.position = video.style.position || 'relative';
                placeholder.style.width = width ? width + 'px' : '100%';
                placeholder.style.height = height ? height + 'px' : '100%';
                placeholder.style.backgroundColor = '#000';
                placeholder.style.backgroundSize = 'contain';
                placeholder.style.backgroundPosition = 'center';
                placeholder.style.backgroundRepeat = 'no-repeat';
                placeholder.style.display = 'flex';
                placeholder.style.alignItems = 'center';
                placeholder.style.justifyContent = 'center';

                poster = video.getAttribute('poster');

                if (!poster) {
                  _context11.next = 19;
                  break;
                }

                _context11.next = 17;
                return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                  __WEBPACK_IMPORTED_MODULE_6_base64_img___default.a.requestBase64(toHttps(poster), function (err, res, body) {
                    resolve(body || poster);
                  });
                });

              case 17:
                inlined = _context11.sent;

                placeholder.style.backgroundImage = 'url("' + inlined + '")';

              case 19:

                placeholder.appendChild(_this6.buildPlayIcon());
                video.parentNode.replaceChild(placeholder, video);

              case 21:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee8, _this6);
      }))();
    },
    buildPlayIcon: function buildPlayIcon() {
      var playBtn = document.createElement('img');
      playBtn.src = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiBjbGFzcz0iIj48Zz48cGF0aCBkPSJNMjU2LDBDMTE0LjYxNywwLDAsMTE0LjYxNSwwLDI1NnMxMTQuNjE3LDI1NiwyNTYsMjU2czI1Ni0xMTQuNjE1LDI1Ni0yNTZTMzk3LjM4MywwLDI1NiwweiBNMzQ0LjQ4LDI2OS41N2wtMTI4LDgwICBjLTIuNTksMS42MTctNS41MzUsMi40My04LjQ4LDIuNDNjLTIuNjY4LDAtNS4zNC0wLjY2NC03Ljc1OC0yLjAwOEMxOTUuMTU2LDM0Ny4xNzIsMTkyLDM0MS44MiwxOTIsMzM2VjE3NiAgYzAtNS44MiwzLjE1Ni0xMS4xNzIsOC4yNDItMTMuOTkyYzUuMDg2LTIuODM2LDExLjMwNS0yLjY2NCwxNi4yMzgsMC40MjJsMTI4LDgwYzQuNjc2LDIuOTMsNy41Miw4LjA1NSw3LjUyLDEzLjU3ICBTMzQ5LjE1NiwyNjYuNjQxLDM0NC40OCwyNjkuNTd6IiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBjbGFzcz0iYWN0aXZlLXBhdGgiIHN0eWxlPSJmaWxsOiNGRkZGRkYiIGRhdGEtb2xkX2NvbG9yPSIjMDAwMDAwIj48L3BhdGg+PC9nPiA8L3N2Zz4=';
      playBtn.style.width = '200px';
      playBtn.style.maxWidth = '40%';
      playBtn.style.opacity = '0.85';
      return playBtn;
    },
    handlePlayers: function handlePlayers() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var videos, i, players, _i, player, _player$getBoundingCl, width, height, top, left, playBtn, overlay;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                // Les <video> sont traités à part : l'overlay ci-dessous était ajouté à
                // l'intérieur de la balise, où le navigateur ne rend jamais rien.
                videos = _this7.domforImage.querySelectorAll('video');
                i = videos.length - 1;

              case 2:
                if (!(i >= 0)) {
                  _context12.next = 8;
                  break;
                }

                _context12.next = 5;
                return _this7.replaceVideoTag(videos[i]);

              case 5:
                i--;
                _context12.next = 2;
                break;

              case 8:
                players = _this7.domforImage.querySelectorAll('[data-gjs-type="player"],[data-gjs-type="video_mp4"]');

                for (_i = 0; _i < players.length; _i++) {
                  player = players[_i];
                  _player$getBoundingCl = player.getBoundingClientRect(), width = _player$getBoundingCl.width, height = _player$getBoundingCl.height, top = _player$getBoundingCl.top, left = _player$getBoundingCl.left;
                  playBtn = _this7.buildPlayIcon();
                  overlay = document.createElement('div');

                  overlay.style.position = 'fixed';
                  overlay.style.backgroundColor = 'transparent';
                  overlay.style.width = width + 'px';
                  overlay.style.height = height + 'px';
                  overlay.style.top = top + 'px';
                  overlay.style.left = left + 'px';
                  overlay.style.display = 'flex';
                  overlay.style.alignItems = 'center';
                  overlay.style.justifyContent = 'center';
                  overlay.style.zIndex = '99';

                  if (player.childNodes.length > 0) {
                    player.removeChild(player.childNodes[0]);
                    player.appendChild(overlay);
                  } else {
                    player.parentNode.appendChild(overlay);
                  }
                  overlay.appendChild(playBtn);
                  // player.appendChild(overlay);
                }

              case 10:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee9, _this7);
      }))();
    },
    handleVideos: function handleVideos() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var videos, i, video;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                videos = _this8.domforImage.querySelectorAll('video');

                for (i = 0; i < videos.length; i++) {
                  video = videos[i];

                  video.mute = true;
                }

              case 2:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee10, _this8);
      }))();
    },
    replaceAsync: function replaceAsync(str, regex, asyncFn) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var promises, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                promises = [];

                str.replace(regex, function (match) {
                  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    args[_key - 1] = arguments[_key];
                  }

                  var promise = asyncFn.apply(undefined, [match].concat(args));
                  promises.push(promise);
                });
                _context14.next = 4;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises);

              case 4:
                data = _context14.sent;
                return _context14.abrupt('return', str.replace(regex, function () {
                  return data.shift();
                }));

              case 6:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee11, _this9);
      }))();
    },


    // dom-to-image walks document.styleSheets to inline web fonts, and reading
    // cssRules throws a SecurityError on any sheet the browser considers
    // unreadable: cross-origin ones (the animate.css that v-animate-css pulls
    // from cdnjs) and ones rejected by strict MIME checking. It swallows the
    // error but logs it on every capture. Their rules can't be inlined anyway,
    // so hide them behind a filtered styleSheets getter for the duration of the
    // capture. Shadowing the getter rather than detaching the <link> nodes
    // avoids re-fetching the sheets and restyling the live page.
    hideUnreadableStyleSheets: function hideUnreadableStyleSheets() {
      var readable = Array.prototype.filter.call(document.styleSheets, function (sheet) {
        try {
          // Throws for sheets we're not allowed to read.
          // eslint-disable-next-line no-unused-expressions
          sheet.cssRules;
          return true;
        } catch (e) {
          return false;
        }
      });

      Object.defineProperty(document, 'styleSheets', {
        configurable: true,
        get: function get() {
          return readable;
        }
      });

      return function () {
        delete document.styleSheets;
      };
    },
    renderSlide: function renderSlide(uid) {
      var _this10 = this;

      var cloneBody = $('#clone').contents().find('.wrapper');

      setTimeout(function () {
        var restoreStyleSheets = _this10.hideUnreadableStyleSheets();
        __WEBPACK_IMPORTED_MODULE_5_dom_to_image___default.a.toJpeg(_this10.domforImage).then(function (thumbnail) {
          restoreStyleSheets();
          var img = new Image();
          img.src = thumbnail;
          // document.body.appendChild(img);
          var slide = { uid: uid, thumbnail: thumbnail };

          if (thumbnail !== "data:,") {
            if (_this10.$route.name === 'segment') {
              _this10.updateSlideThumbnail(slide);
            } else if (_this10.$route.name === 'ListSegment') {

              _this10.updateSegmentListThumbnail(slide);
            } else {
              _this10.updateSegmentThumbnail(slide);
            }
          }

          cloneBody.html('');
        }).catch(function (e) {
          restoreStyleSheets();
          cloneBody.html('');
          console.error('error: ', e);
        });
      }, 500);
    }
  })
});

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__storage_grapes_init__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_Mixin_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_GrapesMixinTranslate__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_duration_handler__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__i18n__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__i18n_en_US__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__i18n_fr_FR__ = __webpack_require__(12);









var juice = __webpack_require__(344);
var scrollPage = 20;







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_Mixin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_GrapesMixinTranslate__["a" /* default */]],
  i18n: {
    messages: {
      en: __WEBPACK_IMPORTED_MODULE_13__i18n_en_US__["a" /* default */],
      fr: __WEBPACK_IMPORTED_MODULE_14__i18n_fr_FR__["a" /* default */]
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])({
    imageWidth: 'common/getImageWidth',
    parentWidth: 'common/getParentWidth',
    someImage: 'common/getSomeImage',
    getCurrentSlideIndex: 'slides/getCurrentSlideIndex',
    getSelected: 'slides/getSelected',
    getSelectedSegments: 'segments/getSelectedSegments',
    getCurrentSegment: 'segments/getCurrent',
    getCurrentSlide: 'slides/getCurrent',
    currentSlide: 'slides/getCurrent',
    paramsClient: 'getParamsClients',
    showIconSave: 'common/getShowIconSave',
    hasPermission: 'hasPermission',
    getSegmentByUid: 'segments/getByUid',
    ListSvgObject: 'common/getListSvgObject'
  }), {
    setMoveAttr: function setMoveAttr() {
      return {
        class: 'fa fa-arrows',
        title: this.$i18n.t('tooltips.move'),
        draggable: true
      };
    },
    setDuplicateAttr: function setDuplicateAttr() {
      return {
        class: 'fa fa-clone',
        title: this.$i18n.t('tooltips.duplicate')
      };
    },
    setRemoveAttr: function setRemoveAttr() {
      return { class: 'fa fa-trash-o', title: this.$t('tooltips.delete') };
    },
    setSettingsAttr: function setSettingsAttr() {
      return { class: 'fa fa-cogs', title: this.$t('tooltips.setting') };
    },
    setEditAttr: function setEditAttr() {
      return { class: 'fa fa-paint-brush', title: this.$t('tooltips.edit') };
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('slides', ['setDelayFragment', 'setOpacityFragment', 'updateSlide', 'updateSlideDuration', 'setCurrentSlide']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('common', ['setDeviceType', 'setDeviceSize', 'setParentWidth', 'setSomeImage', 'setShowIconSave', 'duplicateSvgObject']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('segments', ['updateSlideInsideSegment', 'appendBlankSlideToSegment']), {
    udpdateClocksFontSize: function udpdateClocksFontSize(editor, model) {
      var classes = model.getClasses();
      var cssComposer = editor.CssComposer;
      var css = cssComposer.getClassRule(classes[0]);
      if (classes && classes[0]) {
        var oldStyle = css && css.attributes ? css.attributes.style : {};
        var fontSizeModel = oldStyle['font-size'] ? oldStyle['font-size'] : window.getComputedStyle(model.view.el).fontSize;
        var iframeEl = document.querySelector('.gjs-cv-canvas .gjs-frame');

        var fontVw = void 0;
        if (fontSizeModel.indexOf('vw') > -1) {
          fontVw = parseFloat(fontSizeModel);
        } else {
          fontVw = 100 * parseFloat(fontSizeModel) / parseFloat(window.getComputedStyle(iframeEl).width);
        }

        var width = fontVw * (10 / 0.5) + '%';
        var newStyle = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, oldStyle, { width: width });

        cssComposer.setClassRule(classes[0], newStyle);
      }
    },
    udpdateClocksWidthHeight: function udpdateClocksWidthHeight(editor, model) {
      var classes = model.getClasses();
      var cssComposer = editor.CssComposer;
      var css = cssComposer.getClassRule(classes[0]);
      if (classes && classes[0]) {
        var oldStyle = css && css.attributes ? css.attributes.style : {};
        var widthModel = oldStyle.width && oldStyle.width !== 'auto' ? oldStyle.width : window.getComputedStyle(model.view.el).width;
        var heightModel = oldStyle.height && oldStyle.height !== 'auto' ? oldStyle.height : window.getComputedStyle(model.view.el).height;

        var iframeEl = document.querySelector('.gjs-cv-canvas .gjs-frame');

        if (widthModel.indexOf('px') > -1) {
          var width = parseFloat(widthModel) / parseFloat(window.getComputedStyle(iframeEl).width) * 100 + '%';

          var _newStyle = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, oldStyle, { width: width });
          cssComposer.setClassRule(classes[0], _newStyle);
          widthModel = width;
        }

        if (heightModel.indexOf('px') > -1) {
          var height = parseFloat(heightModel) / parseFloat(window.getComputedStyle(iframeEl).height) * 100 + '%';

          var _newStyle2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, oldStyle, { height: height });
          cssComposer.setClassRule(classes[0], _newStyle2);
        }

        var fontSize = parseFloat(widthModel) / 10 * 0.5;
        var fontnew = fontSize + 'vw';
        var newStyle = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, oldStyle, { 'font-size': fontnew });
        cssComposer.setClassRule(classes[0], newStyle);
      }
    },
    toastDelete: function toastDelete(editor) {
      var _this = this;

      var selected = editor.getSelected();
      if (!selected || !selected.get('removable')) {
        console.warn('The element is not removable', selected);
      } else if (selected) {
        selected.destroy();
        var iconSave = document.querySelector('.icon-save');
        this.$toasted.show("L'élément sélectionné est supprimé", {
          theme: 'bubble',
          position: 'top-center',
          duration: 4000,
          action: [{
            text: 'Annuler',
            onClick: function onClick(e, toastObject) {
              var wrapper = document.querySelector('.gjs-frame').contentWindow.document;
              var um = editor.UndoManager;
              var stacks = um.getStack().models;
              var id = selected.view.el.id;
              var countClass = selected.view.el.classList[0];
              var type = selected.attributes.type;
              window.um = um;
              if (stacks.length > 0) {
                var i = stacks.length - 1;
                var found = false;
                if (id) {
                  while (i > 0 && !found) {
                    // if (type === 'social-icons-weather') {
                    //   selected.set('deleted', true);
                    // }
                    editor.UndoManager.undo();
                    if (type === 'custom-countdown') {
                      found = !!wrapper.querySelector('.' + countClass + '#' + id);
                    } else {
                      found = !!wrapper.getElementById(id);
                    }
                    i--;
                  }
                } else {
                  editor.UndoManager.undo();
                }
                iconSave.classList.add('icon-selected');
                _this.setShowIconSave(true);
              }
              setTimeout(function () {
                var lastSlide = {
                  uid: _this.currentSlide.uid,
                  components: localStorage.getItem('gjs-components'),
                  js: localStorage.getItem('gjs-js'),
                  html: localStorage.getItem('gjs-html'),
                  css: _this.sanitizeCSS(localStorage.getItem('gjs-css')),
                  styles: localStorage.getItem('gjs-styles')
                };
                if (_this.$route.name === 'segment') {
                  _this.updateSlide(lastSlide);
                } else {
                  _this.updateSlideInsideSegment(lastSlide);
                }
                _this.$root.$emit('updateCanvasContent');
              }, 100);

              toastObject.goAway(0);
            }
          }, {
            icon: 'fa-times',
            onClick: function onClick(e, toastObject) {
              toastObject.goAway(0);
            }
          }]
        });

        if (iconSave) {
          iconSave.classList.add('icon-selected');
          this.setShowIconSave(true);
        }
      }
    },
    generateId: function generateId(model) {
      var text = 'i';
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      for (var i = 0; i < 5; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }return text;
    },
    eventStorageLoad: function eventStorageLoad(editor) {
      // Store and load events
      editor.on('storage:load', function (e) {
        console.log('storage:load', e);
      });
    },
    eventStorageStart: function eventStorageStart(editor) {
      // Store and load events
      editor.on('storage:start', function (e) {
        console.log('storage:start', e);
      });
    },
    eventStorageStartStore: function eventStorageStartStore(editor) {
      // Store and load events
      editor.on('storage:start:store', function (e) {
        console.log('storage:start:store', e);
      });
    },
    eventStorageEnd: function eventStorageEnd(editor) {
      editor.on('storage:end', function (e) {
        console.log('storage:end', e);
      });
    },
    eventStorageEndStore: function eventStorageEndStore(editor) {
      var _this2 = this;

      var self = this;
      if (this.$route.name === 'edit') {
        var firstCall = 0;
        editor.on('storage:end:store', function (e) {
          var iconSave = document.querySelector('.icon-save');
          if (iconSave && firstCall < 2) {
            firstCall++;
            iconSave.classList.remove('icon-selected');
            self.setShowIconSave(false);
          }
        });
      }
      editor.on('storage:end:store', function (e) {
        _this2.handleLocalStorage();
      });
    },
    handleLayersPanel: function handleLayersPanel(editor) {
      var _this3 = this;

      var iteration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var layers = document.querySelectorAll('.gjs-pn-views-container > div > .gjs-layer > .gjs-layer-children > .gjs-layers > .gjs-layer');
      if (!layers && iteration < 10) {
        setTimeout(function () {
          _this3.handleLayersPanel(editor, iteration++);
        }, 10);
      }
      var models = editor.getComponents().models;
      var index = 0;
      layers.forEach(function (el) {
        var i = index++;
        var toggler = el.querySelector('[data-toggle-visible]');
        _this3.initializeLayer(el, models[i], editor);
        toggler.onmouseup = function () {
          setTimeout(function () {
            _this3.handleUpdateStyle(models[i], editor);
          }, 100);
        };
      });
    },
    initializeLayer: function initializeLayer(layer, model, editor) {
      var cssComposer = editor.CssComposer;
      var classes = model.getClasses();
      var style = cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes ? cssComposer.getClassRule(classes[0]).attributes.style : {};
      if (layer.innerHTML.includes('Box') && model.attributes.type === '') {
        layer.style.display = 'none';
      }
      if (!this.hasPermission.sort_layers_action) {
        layer.querySelector('.fa-arrows').style.display = 'none';
      }
      if (style.display && style.display === 'none') {
        var toggler = layer.querySelector('[data-toggle-visible]');
        toggler.click();
        model.view.el.style.display = 'none';
      }
    },
    handleUpdateStyle: function handleUpdateStyle(model, editor) {
      var cssComposer = editor.CssComposer;
      var classes = model.getClasses();
      var hidden = model.getStyle().display === 'none';

      var oldStyle = cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes ? cssComposer.getClassRule(classes[0]).attributes.style : {};

      setTimeout(function () {
        cssComposer.setClassRule(classes[0], {});
        cssComposer.setClassRule(classes[0], __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, oldStyle, { display: hidden ? 'none' : 'initial' }));
      }, 100);
    },
    handleLocalStorage: function handleLocalStorage() {
      var gjsComponent = JSON.parse(localStorage.getItem('gjs-components'));

      if (!(gjsComponent && gjsComponent.length > 0)) {
        return;
      }
      var gjsCSS = localStorage.getItem('gjs-css');

      var components = gjsComponent.map(function (c) {
        if (c.style.display === 'none') {
          var id = c.attributes.id;
          c.style = {};
          gjsCSS = gjsCSS.replace('#' + id + '{display:none;}', '');
        }
        return c;
      });

      localStorage.setItem('gjs-components', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(components));
      localStorage.setItem('gjs-css', gjsCSS);
    },
    eventStorageEndLoad: function eventStorageEndLoad(editor) {
      editor.on('storage:end:load', function (e) {
        console.log('storage:end:store', e);
      });
    },
    eventStorageStore: function eventStorageStore(editor) {
      editor.on('storage:store', function (e) {
        console.log('storage:store', e);
      });
    },
    eventComponentDeSelected: function eventComponentDeSelected(editor) {
      editor.on('component:deselected', function (some, argument) {
        console.log('component:deselected', some);
      });
      var iconSave = document.querySelector('.icon-save');
      iconSave.classList.add('icon-selected');
      this.setShowIconSave(true);
    },
    eventCommandRun: function eventCommandRun(editor) {
      var _this4 = this;

      editor.on('undo', function (some, argument) {
        var iconSave = document.querySelector('.icon-save');
        iconSave.classList.add('icon-selected');
        _this4.setShowIconSave(true);
      });
      editor.on('redo', function (some, argument) {
        var iconSave = document.querySelector('.icon-save');
        iconSave.classList.add('icon-selected');
        _this4.setShowIconSave(true);
      });
    },
    updateSelectedComponent: function updateSelectedComponent(editor, getCurrentSlide) {
      var wrapper = editor.DomComponents.getWrapper();
      //editor.setComponents(getCurrentSlide.html);
      var components = getCurrentSlide.components ? getCurrentSlide.components.replace(/"contenteditable":true/g, '"contenteditable":false') : '{}';
      var settings = document.querySelector('.gjs-toolbar');
      settings.style.display = 'block';
      editor.setComponents(JSON.parse(components));

      /*
       *       TODO
       *       The two lines above should be replaced by
       *       editor.setStyle(getCurrentSlide.styles || getCurrentSlide.css);
       *       After Updating to the last version of grapes
       */
      editor.setStyle(getCurrentSlide.style);
      editor.setStyle(getCurrentSlide.css);
      localStorage.setItem('gjs-js', getCurrentSlide.js);
      wrapper.set('style', '');
      if (getCurrentSlide && getCurrentSlide.options && document.querySelector('#selected-element-properties input')) {
        document.querySelector('#selected-element-properties input').value = this.SecToTime(getCurrentSlide.options.duration);
      }
      try {
        editor.select(editor.DomComponents.getWrapper());
      } catch (e) {}
      if (getCurrentSlide.type === 'images') {
        this.updateWrapperProperties(editor, getCurrentSlide.src, null, getCurrentSlide.type);
      } else {
        this.updateWrapperProperties(editor);
      }
      // Re-anchor the screen background onto the wrapper from the stored CSS.
      // updateWrapperProperties relies on getComputedStyle(body).backgroundImage,
      // which can read back 'none' right after setStyle (before the rule paints) and
      // is also independent of whether the image has loaded. When that happens the
      // background-image never gets written onto the wrapper's own style, so the next
      // getCss() drops it and the screen is saved blank (lost on edit -> re-save).
      // Reading the declarations straight from getCurrentSlide.css is deterministic.
      this.anchorBodyBackground(editor, getCurrentSlide.css);
    },
    anchorBodyBackground: function anchorBodyBackground(editor, css) {
      if (!css || typeof css !== 'string') return;
      var bodyRule = css.match(/body\s*\{([^}]*)\}/i);
      if (!bodyRule) return;
      var bg = {};
      bodyRule[1].split(';').forEach(function (decl) {
        var idx = decl.indexOf(':');
        if (idx === -1) return;
        var prop = decl.slice(0, idx).trim().toLowerCase();
        var value = decl.slice(idx + 1).trim();
        if (prop.indexOf('background') === 0 && value) bg[prop] = value;
      });
      var img = bg['background-image'];
      if (!img || img === 'none') return;
      try {
        editor.DomComponents.getWrapper().addStyle(bg);
      } catch (e) {}
    },
    updateWrapperProperties: function updateWrapperProperties(editor, imageSrc, color, type) {
      // Background Color

      if (color) {
        this.$root.$emit('oldBackgroundColor', color);
      }
      var classe = '';
      var cssComposer = editor.CssComposer;
      var selected = editor.getSelected();
      var typeSelected = selected.attributes.type;
      var iframe = document.querySelector('iframe').contentWindow;
      var css = '';
      var element = iframe.document.body;

      if (typeSelected == 'custom_column') {
        element = selected.view.el;
        classe = selected.view.el.classList[0];

        css = cssComposer.getClassRule(classe);
      }
      var bodyStyle = window.getComputedStyle(element);

      var wrapper = editor.getWrapper();
      var bgColor = color || bodyStyle.backgroundColor;
      var backgImage = bodyStyle.backgroundImage;
      // bgColor = bgColor === 'rgb(255, 255, 255)' ? 'initial' : bgColor;
      selected.addStyle({ 'background-color': bgColor });

      var colorPickerEl = document.querySelector('#gjs-sm-background-color .gjs-field-color-picker');
      var colorInputEl = document.querySelector('#gjs-sm-background-color .gjs-input-holder input');

      if (colorPickerEl && colorInputEl) {
        colorPickerEl.style.backgroundColor = bgColor;
        colorInputEl.value = bgColor;
        if (typeSelected === 'custom_column') {
          var newId = 'i' + generateClass().substr(1);
          var attributes = editor.getSelected().getAttributes();
          attributes = attributes ? attributes : {};
          attributes.id = newId;
          editor.getSelected().setAttributes(attributes);
          var oldStyle1 = css && css.attributes ? css.attributes.style : {};
          var newStyle1 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, oldStyle1, { 'background-color': bgColor });
          cssComposer.setIdRule(newId, newStyle1);
          //selected.addStyle(newStyle1);
        }
      }

      if (imageSrc) {
        backgImage = "url('" + imageSrc + "')";
      }
      if (backgImage !== 'none' && backgImage.slice(-6, -2) !== 'none') {
        // Background Image
        document.querySelectorAll('#gjs-sm-close-layer').forEach(function (e) {
          e.click();
        });
        document.querySelector('#gjs-sm-background #gjs-sm-add').click();
        var style = {};

        if (typeSelected !== 'custom_column') {
          __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(bodyStyle).filter(function (k) {
            return bodyStyle[k].indexOf('background') > -1 && bodyStyle[k] !== 'backgroundColor' && bodyStyle[k] !== 'background' && bodyStyle[k];
          }).forEach(function (k) {
            var key = bodyStyle[k].split(/(?=[A-Z])/).join('-').toLowerCase();
            style[key] = bodyStyle.getPropertyValue(bodyStyle[k]);

            var bgProperty = key + '-' + bodyStyle[k];
            if (key === 'background-position-x') {
              bgProperty += ' ' + bodyStyle['background-position-y'];
            }
            var bgPropertyEl = document.getElementById(bgProperty);

            if (bgPropertyEl) {
              bgPropertyEl.click();
            }
          });
        }
        var styleCss = { 'background-image': backgImage };
        if (type === 'images') {
          styleCss = {
            'background-image': backgImage,
            'background-repeat': 'no-repeat',
            'background-position': '100%',
            'background-size': 'cover'
          };
        }
        var newStyle = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, style, styleCss);

        if (typeSelected === 'custom_column') {
          var oldStyle = css && css.attributes ? css.attributes.style : {};
          var _newStyle3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, oldStyle, styleCss);
          cssComposer.setClassRule(classe, _newStyle3);
          selected.addStyle(_newStyle3);
        } else {
          wrapper.addStyle(newStyle);
        }

        document.getElementById('gjs-sm-preview-file').style.backgroundImage = backgImage;
      }
    },
    eventColorPickerListener: function eventColorPickerListener() {
      var _this5 = this;

      var iframe = document.querySelector('iframe').contentWindow;
      var colorPickerEl = document.querySelector('#gjs-sm-background-color .gjs-field-color-picker');
      var colorInputEl = document.querySelector('#gjs-sm-background-color .gjs-input-holder input');

      if (!colorPickerEl) {
        setTimeout(function () {
          _this5.eventColorPickerListener();
        }, 1000);
        return;
      }

      colorPickerEl.addEventListener('click', function () {
        var bodyStyle = window.getComputedStyle(iframe.document.body);
        var bgColor = bodyStyle.backgroundColor;
        var colorThumbsEl = document.querySelectorAll('.sp-thumb-el');

        if (colorPickerEl && colorInputEl) {
          if (colorThumbsEl) {
            colorThumbsEl.forEach(function (thumb) {
              var thumbEl = thumb.querySelector('.sp-thumb-inner');
              if (thumbEl.style.backgroundColor === bgColor) {
                thumb.click();
              }
            });
          }
        }
      });
    },
    updateColorSvg: function updateColorSvg(selectedEl, color) {
      var self = this;
      var invocation = new XMLHttpRequest();
      if (invocation != null) {
        invocation.open('GET', selectedEl.get('src'), true);
        invocation.onreadystatechange = handler;
        invocation.send();
      }
      function handler(evtXHR) {
        if (invocation.readyState === 4) {
          if (invocation.status === 200) {
            //success
            var textSVG = invocation.response;
            if (textSVG) {
              var htmlObject = document.createElement('div');
              htmlObject.innerHTML = textSVG;
              var svgTag = htmlObject.querySelector('svg');
              var allFill = svgTag.querySelectorAll('[fill]');
              var allStrock = svgTag.querySelectorAll('[stroke]');
              if (allStrock) {
                allStrock.forEach(function (e) {
                  e.attributes.stroke.value = color;
                });
              }
              if (allFill) {
                allFill.forEach(function (e) {
                  e.attributes.fill.value = color;
                });
              }
              var svg64 = window.btoa(new XMLSerializer().serializeToString(svgTag));
              var newSrc64 = 'data:image/svg+xml;base64,' + svg64;
              selectedEl.set('src', newSrc64);
              selectedEl.view.iframe.src = newSrc64;
            }
          } else {
            console.log('failure');
          }
        }
      }
    },
    addDefaultColors: function addDefaultColors(editor, type, color) {
      var _this6 = this;

      var colors = color ? color : this.paramsClient.default_colors;
      if (!colors) {
        return;
      }
      var self = this;
      var cssComposer = editor.CssComposer;
      var backgroundProps = document.querySelector('#gjs-sm-' + type + ' .gjs-sm-properties');

      var styleType = type === 'text' ? 'color' : 'background-color';
      var typeEl = document.querySelector('#gjs-sm-' + type);
      if (!(typeEl && backgroundProps)) {
        setTimeout(function () {
          _this6.addDefaultColors(editor, type);
        }, 1000);
        return;
      }
      typeEl.classList.add('hide-picker');
      var old = document.querySelector('#gjs-sm-recent-colors-' + type);
      if (old) {
        old.parentNode.removeChild(old);
      }
      var props = document.createElement('div');
      props.className = 'gjs-sm-property gjs-sm-radio';
      props.id = 'gjs-sm-recent-colors-' + type;

      var labelEl = document.createElement('div');
      labelEl.innerHTML = '\n        <div class="gjs-sm-label">\n          <span class="gjs-sm-icon">\n            Couleurs par d\xE9faut\n          </span>\n        </div>';

      var fieldsEl = document.createElement('div');
      fieldsEl.className = 'gjs-field gjs-field-radio';

      var radioItemEl = document.createElement('div');
      radioItemEl.className = 'gjs-radio-items';

      colors.forEach(function (color) {
        if (color.value && color.value === 'transparent' && type === 'text') {
          return;
        }
        var colorEl = document.createElement('div');
        colorEl.className = 'gjs-radio-item';

        var inputEl = document.createElement('input');
        inputEl.className = 'gjs-sm-radio';
        inputEl.value = color.value;

        var labelEl = document.createElement('label');

        if (color.value && color.value === 'transparent') labelEl.className = 'gjs-sm-icon gjs-radio-item-label gjs-radio-item-label-transparent';else labelEl.className = 'gjs-sm-icon gjs-radio-item-label';
        labelEl.style.backgroundColor = color.value;
        labelEl.setAttribute('title', color.name || color.value);

        colorEl.appendChild(inputEl);
        colorEl.appendChild(labelEl);

        radioItemEl.appendChild(colorEl);

        labelEl.addEventListener('click', function () {
          var selectedEl = editor.getSelected();
          if (selectedEl.get('type') === 'custom_column') {
            self.updateWrapperProperties(editor, null, this.style.backgroundColor);
            selectedEl.set('style', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, styleType, this.style.backgroundColor));
          } else if (selectedEl.get('type') === 'wrapper') {
            self.updateWrapperProperties(editor, null, this.style.backgroundColor);
            selectedEl.set('style', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, styleType, this.style.backgroundColor));
          } else if (selectedEl.get('type') === 'image_media' || selectedEl.get('type') === 'pattern') {
            self.updateColorSvg(selectedEl, this.style.backgroundColor);
          } else {
            var classes = selectedEl.getAttributes().class.split(' ');
            if (classes && classes[0]) {
              var oldStyle = cssComposer.getClassRule(classes[0]).attributes.style;
              var newStyle = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, oldStyle, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, styleType, this.style.backgroundColor));
              cssComposer.setClassRule(classes[0], newStyle);
            }
          }
        });
      });

      fieldsEl.appendChild(radioItemEl);
      props.appendChild(labelEl);
      props.appendChild(fieldsEl);
      backgroundProps.prepend(props);
    },
    eventRunPreview: function eventRunPreview(editor) {
      var _this7 = this;

      editor.on('run:preview', function (model) {
        var elem = document.getElementById('gjs');
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) {
          /* Firefox */
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
          /* Chrome, Safari & Opera */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          /* IE/Edge */
          elem.msRequestFullscreen();
        }
        _this7.getSelectedSlides('fullScreen');
        //this.setAutoplayPlayer(editor);
        _this7.setNoMutedVideo();
      });
    },
    eventStopPreview: function eventStopPreview(editor) {
      editor.on('stop:preview', function (model) {
        try {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
          // this.setNoAutoplayVideo(editor);
          var videoPlayers = ['video', 'player', 'playlist'];
          videoPlayers.forEach(function (player) {
            // this.setPausedVideo(player);
          });
          //this.setMutedVideo(model);
        } catch (e) {
          console.log('eventStopPreview', e);
        }
      });
    },
    eventComponentAdd: function eventComponentAdd(editor) {
      var self = this;
      editor.on('canvas:dragover', function (e, argument) {
        var left = Math.max(e.clientX, 0);
        var top = Math.max(e.clientY, 0);
        window.dragLeft = left;
        window.dragTop = top;
      });

      editor.on('canvas:dragend', function (e, argument) {});
      editor.on('component:add', function (some, argument) {
        var iconSave = document.querySelector('.icon-save');
        if (iconSave) {
          iconSave.classList.add('icon-selected');
          self.setShowIconSave(true);
        }

        var compPlayers = ['player', 'playlist', 'live', 'video_mp4'];
        var compImages = ['image', 'image_media' || 'pattern'];
        if (compPlayers.indexOf(some.attributes.type) > -1 || compImages.indexOf(some.attributes.type) > -1) {
          var type = void 0;
          if (compPlayers.indexOf(some.attributes.type) > -1) {
            type = 'video';
          }

          if (compImages.indexOf(some.attributes.type) > -1) {
            type = 'image';
          }
          self.translatePluginsTitle(some.attributes.type, type);
        }
        if (some.attributes.type === 'video_mp4') {
          // this.setCurrentSlide(Object.assign({}, this.currentSlide, { fullscreenVideo: true }));
        }
        if (some.attributes.type === 'social_media') {
          var _type = 'social-media';
          self.translatePluginsTitle(some.attributes.type, _type);
        }

        var cssComposer = editor.CssComposer;
        var iframe = document.querySelector('.gjs-frame').contentWindow;
        var wrapper = iframe.document.querySelector('#wrapper');
        var id = self.generateId();
        if (!!!some.getAttributes().id) {
          some.set('attributes', { id: id });
        }
        if (some.attributes.type === 'linkedin_widget' || some.attributes.type === 'clocks' || some.attributes.type === 'dateHeure') {
          if (!!!some.getAttributes().class) {
            some.set('attributes', {
              class: self.generateId()
            });
          }
        }
        if (some.attributes.type === 'text' || some.attributes.type === 'link') {
          var modelClass = self.generateId();
          var exist = some.getAttributes()['data-class'] || some.getAttributes().class;
          var newClass = exist;
          if (exist === 'custom-title' || exist === 'custom-sharing') {
            if (some.getAttributes().class) {
              newClass = some.getAttributes().class;
              if (some.getAttributes().class === exist) {
                newClass = modelClass;
              }
            }
            some.addAttributes({
              'data-class': exist,
              class: newClass
            });
          } else if (exist === 'custom-credit') {
            if (some.getAttributes().class) {
              newClass = some.getAttributes().class;
              if (some.getAttributes().class === exist) {
                newClass = modelClass;
              }
            }
            some.addAttributes({
              'data-class': exist,
              'data-rotation': 'vertical',
              class: newClass
            });
          } else {
            some.addAttributes({
              'emp-data-class': 'emp-' + some.attributes.type
            });
          }
          if (self.paramsClient.display_fonts && self.paramsClient.display_fonts.length > 0) {
            var _classes = some.getClasses();
            var fonts = self.paramsClient.display_fonts;
            var custom = [{
              value: 'Din Regular',
              name: 'Din Regular'
            }, {
              value: 'Din bold',
              name: 'Din bold'
            }];
            var _exist = some.getAttributes()['data-class'];
            var style = void 0;

            var _cssComposer = editor.CssComposer;
            var css = _cssComposer.getClassRule(_classes[0]);
            if (_classes && _classes[0]) {
              var oldStyle = _cssComposer.getClassRule(_classes[0]) && _cssComposer.getClassRule(_classes[0]).attributes ? _cssComposer.getClassRule(_classes[0]).attributes.style : {};

              var styleFamilyFont = oldStyle['font-family'];
              var newStyleFamilyFont = oldStyle['new-font-family'];
              var newFont = styleFamilyFont;
              if (styleFamilyFont === undefined || styleFamilyFont === fonts[0].value || styleFamilyFont === custom[0].value) {
                if (_exist) {
                  newFont = custom[0].value;
                } else {
                  newFont = fonts[0].value;
                }
                style = {
                  'font-family': newFont,
                  'new-font-family': newFont
                };
              } else {
                style = {
                  'font-family': styleFamilyFont,
                  'new-font-family': newStyleFamilyFont
                };
              }
              var newStyle = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()(oldStyle, style);
              _cssComposer.setClassRule(_classes[0], newStyle);
            }
          }
        }

        if (some.attributes.name === 'Row') {
          some.attributes.components.models.forEach(function (m) {
            m.set('attributes', { id: self.generateId() });
          });
        }
        var compIframes = ['social_media', 'image_media', 'pattern'];
        if (compIframes.indexOf(some.attributes.type) > -1) {
          var _id = void 0;
          if (some.attributes.type === 'image_media') {
            _id = 'image-media';
          }
          if (some.attributes.type === 'social_media') {
            _id = 'social-media';
          }
          if (some.attributes.type === 'pattern') {
            _id = 'pattern';
          }
          setTimeout(function () {
            var iframe = document.getElementById(_id + '-iframe');
            if (iframe.style.display === 'block') {
              editor.select(some);
            }
          }, 500);
        }

        if (some.attributes.type === 'map') {
          editor.setStyle({
            selectors: [some.cid],
            style: { width: '100%', height: '25%' }
          });
        }

        if (some.attributes.type === 'video') {
          var _cssComposer2 = editor.CssComposer;
          var _classes2 = some.getClasses();
          if (_classes2 && _classes2[0]) {
            var _oldStyle = _cssComposer2.getClassRule(_classes2[0]) && _cssComposer2.getClassRule(_classes2[0]).attributes ? _cssComposer2.getClassRule(_classes2[0]).attributes.style : {};
            var _newStyle4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()(_oldStyle, {
              width: '30%',
              height: '30%',
              'background-color': 'black'
            });
            _cssComposer2.setClassRule(_classes2[0], _newStyle4);
          }
        }
        if (some.attributes.type === 'custom-countdown') {
          var classess = some.getClasses();
          if (classess[0] === 'countdown') {
            some.set('attributes', { class: self.generateId() });
          }

          var _cssComposer3 = editor.CssComposer;
          var _classes3 = some.getClasses();
          if (_classes3 && _classes3[0]) {
            var _oldStyle2 = _cssComposer3.getClassRule(_classes3[0]) && _cssComposer3.getClassRule(_classes3[0]).attributes ? _cssComposer3.getClassRule(_classes3[0]).attributes.style : {};
            var styleAdded = {
              width: _oldStyle2.width ? _oldStyle2.width : '30%',
              height: _oldStyle2.height ? _oldStyle2.height : '15%',
              'font-size': _oldStyle2['font-size'] ? _oldStyle2['font-size'] : '1.5vw'
            };
            if (_classes3 && _classes3[0]) {
              var _newStyle5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, _oldStyle2, styleAdded);
              _cssComposer3.setClassRule(_classes3[0], _newStyle5);
            }
            var oldStyleDigit = _cssComposer3.getClassRule('countdown-digit') && _cssComposer3.getClassRule('countdown-digit').attributes ? _cssComposer3.getClassRule('countdown-digit').attributes.style : {};
            var oldStyleLabel = _cssComposer3.getClassRule('countdown-label') && _cssComposer3.getClassRule('countdown-label').attributes ? _cssComposer3.getClassRule('countdown-label').attributes.style : {};
            var newStyleDigit = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({
              padding: '0.4em',
              'border-radius': '0.2em',
              'background-color': '#dedede',
              color: 'inherit',
              'font-size': '1.6em',
              'text-align': 'center'
            }, oldStyleDigit);
            var newStyleLabel = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({ color: 'inherit', top: '0px', margin: '0.5em 0.2em 0 0.5em', 'font-size': '0.7em' }, oldStyleLabel);

            _cssComposer3.setClassRule('countdown-digit', newStyleDigit);
            _cssComposer3.setClassRule('countdown-label', newStyleLabel);
          }
          some.view.updateScript();
          localStorage.setItem('gjs-js', editor.getJs());
        }
        if (some.attributes.tagName === 'blockquote') {
          var _cssComposer4 = editor.CssComposer;
          var _classes4 = some.getClasses();
          if (_classes4 && _classes4[0]) {
            var _oldStyle3 = _cssComposer4.getClassRule(_classes4[0]) && _cssComposer4.getClassRule(_classes4[0]).attributes ? _cssComposer4.getClassRule(_classes4[0]).attributes.style : {};
            var _newStyle6 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, _oldStyle3);

            if (!!!_newStyle6['font-style']) {
              _newStyle6 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({
                color: '#777',
                'font-weight': '300',
                padding: '10px',
                'box-shadow': '-5px 0 0 0 #ccc',
                'font-style': 'italic',
                margin: '20px 30px'
              }, _newStyle6);
              _cssComposer4.setClassRule(_classes4[0], _newStyle6);
            }
          }
        }

        if (some.attributes.type == 'filet') {
          var _classes5 = some.getClasses();
          if (_classes5 && _classes5[0]) {
            var _iframe = document.querySelector('.gjs-frame');
            var el = some.view.el;

            var _el$getBoundingClient = el.getBoundingClientRect(),
                width = _el$getBoundingClient.width,
                height = _el$getBoundingClient.height;

            var top = Math.max((window.dragTop - height / 2) / _iframe.offsetHeight * 100, 0) + '%';
            var _style = { top: top };
            var _newStyle7 = void 0;
            var _oldStyle4 = cssComposer.getClassRule(_classes5[0]) && cssComposer.getClassRule(_classes5[0]).attributes ? cssComposer.getClassRule(_classes5[0]).attributes.style : {};
            _newStyle7 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, _style, _oldStyle4);
            cssComposer.setClassRule(_classes5[0], _newStyle7);
          }
        }

        if (some.attributes.type === 'text') {
          var _cssComposer5 = editor.CssComposer;
          var _classes6 = some.getClasses();
          if (_classes6 && _classes6[0]) {
            var _oldStyle5 = _cssComposer5.getClassRule(_classes6[0]) && _cssComposer5.getClassRule(_classes6[0]).attributes ? _cssComposer5.getClassRule(_classes6[0]).attributes.style : {};
            var _newStyle8 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({ 'font-family': 'Arial, Helvetica, sans-serif' }, _oldStyle5);
            _cssComposer5.setClassRule(_classes6[0], _newStyle8);
          }
        }
        var componentsArray = ['text', 'link', 'image', 'image_media', 'social_media', 'video', 'player', 'video_mp4', 'playlist', 'live', 'webrtc', 'custom-countdown', 'rss_widget', 'web_widget', 'social-icons-weather', 'clocks', 'facebook_widget', 'social-icons-twitter', 'characters', 'texts', 'shapes', 'dateHeure'];
        var classes = some.getClasses();
        var models = editor.DomComponents.getComponents().models;
        if (componentsArray.indexOf(some.attributes.type) > -1) {
          if (classes && classes[0]) {
            var _style2 = {
              position: 'fixed',
              'z-index': models.length
            };
            var _newStyle9 = void 0;
            var _oldStyle7 = cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes ? cssComposer.getClassRule(classes[0]).attributes.style : {};
            _newStyle9 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, _style2, _oldStyle7);
            cssComposer.setClassRule(classes[0], _newStyle9);
          }
          var _oldStyle6 = cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes ? cssComposer.getClassRule(classes[0]).attributes.style : {};
          if (!_oldStyle6.left && !_oldStyle6.top || !_oldStyle6.left && !_oldStyle6.bottom) {
            var _iframe2 = document.querySelector('.gjs-frame');
            var _el = some.view.el;

            var _el$getBoundingClient2 = _el.getBoundingClientRect(),
                _width = _el$getBoundingClient2.width,
                _height = _el$getBoundingClient2.height;

            var left = Math.max((window.dragLeft - _width / 2) / _iframe2.offsetWidth * 100, 0) + '%';
            var _top = Math.max((window.dragTop - _height / 2) / _iframe2.offsetHeight * 100, 0) + '%';
            var bottom = Math.max(100 - (window.dragTop - _height / 2) / _iframe2.offsetHeight * 100, 0) + '%';

            // custom credit
            var _style3 = {};
            var _exist2 = some.attributes.attributes['data-class'];
            if (_exist2 && _exist2 === 'custom-credit') {
              left = '0%';
              bottom = '1%';
              _style3 = {
                left: left,
                bottom: bottom
              };
            } else {
              _style3 = {
                left: left,
                top: _top
              };
            }

            var s = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, _oldStyle6, _style3);
            cssComposer.setClassRule(classes[0], s);

            /*const toolbar = document.querySelector('.gjs-rte-toolbar');
            toolbar.style.top = window.dragTop - height / 2 - 38 + 15 + 'px';
            toolbar.style.left =
              window.dragLeft - width / 2 + iframe.getBoundingClientRect().left + 'px';*/
          }
        }
      });
    },
    ckEditorsUpdated: function ckEditorsUpdated(exist) {
      var linkckEditors = { name: 'links', groups: ['links', 'Unlinks'] };
      var ckeditors = __WEBPACK_IMPORTED_MODULE_8__storage_grapes_init__["a" /* default */].pluginsOpts['gjs-plugin-ckeditor'];
      var toolbarGroups = ckeditors.options.toolbarGroups;
      var removed = [];
      var extraPluginsArray = [];
      var extraPlugins = ckeditors.options['extraPlugins'];
      for (var index = 0; index < toolbarGroups.length; index++) {
        if (toolbarGroups[index].name === 'links') {
          removed = toolbarGroups.splice(index, 1);
          index--;
        }
      }
      extraPluginsArray = extraPlugins.split(',');
      if (extraPluginsArray.indexOf('lineheight') === -1) {
        extraPluginsArray.push('lineheight');
      }

      if (exist === 'custom-title' || exist === 'custom-sharing' || exist === 'custom-credit') {
        for (var i = 0; i < extraPluginsArray.length; i++) {
          if (extraPluginsArray[i] === 'lineheight') {
            extraPluginsArray.splice(i, 1);
          }
        }
        if (exist === 'custom-sharing') {
          if (toolbarGroups.indexOf(linkckEditors) === -1) {
            toolbarGroups.push(linkckEditors);
          }
        }
      }
      extraPlugins = extraPluginsArray.toString();
      ckeditors.options['extraPlugins'] = extraPlugins;
    },
    eventComponentStyleAlign: function eventComponentStyleAlign(editor) {
      editor.on('component:styleUpdate:float', function (model) {
        if (window.floatPressed) {
          return;
        }

        window.floatPressed = true;
        setTimeout(function () {
          window.floatPressed = false;
        }, 200);

        var cssComposer = editor.CssComposer;
        var classes = model.getClasses();
        var id = model.getAttributes().id;
        var iframeEl = document.querySelector('.gjs-frame');

        var iframeWidth = iframeEl.getBoundingClientRect().width;
        var modelWidth = model.view.el.getBoundingClientRect().width;
        var modelLeft = model.view.el.getBoundingClientRect().left;

        var leftEl = Math.max(modelLeft / iframeWidth, 0) * 100;
        var rightEl = Math.max(1 - (modelLeft + modelWidth) / iframeWidth, 0) * 100;

        var oldStyleClass = cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes ? cssComposer.getClassRule(classes[0]).attributes.style : {};

        var oldStyleId = cssComposer.getIdRule(id) ? cssComposer.getIdRule(id).attributes.style : {};

        var styleAttribute = {};
        var isImage = model.get('type') === 'image' || model.get('type') === 'image_media' || model.get('type') === 'social_media';
        if (isImage) {
          styleAttribute.left = oldStyleClass.left;
        }

        var float = oldStyleClass.float;


        var newStyleId = {};
        var newStyleClass = {};

        if (!float || float === 'left' && leftEl < rightEl || float === 'right' && rightEl < leftEl) {
          return;
        }

        if (float === 'none') {
          var oldLeft = oldStyleId.oldLeft || oldStyleClass.oldLeft;
          newStyleId = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, oldStyleId, { left: oldLeft, right: 'auto' });
          newStyleClass = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, oldStyleClass, { left: oldLeft, right: 'auto' });
        } else if (float === 'right') {
          newStyleId = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, oldStyleId, {
            left: 'auto',
            right: leftEl + '%'
          });
          newStyleClass = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, oldStyleClass);
        } else if (float === 'left') {
          newStyleId = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, oldStyleId, {
            left: rightEl + '%',
            right: 'auto'
          });
          newStyleClass = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, oldStyleClass);
        }

        if (isImage) {
          model.view.el.setAttribute('style', '');
          cssComposer.setClassRule(classes[0], __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, newStyleClass, newStyleId));
        } else {
          cssComposer.setIdRule(id, newStyleId);
          cssComposer.setClassRule(classes[0], newStyleClass);
        }
      });
    },
    eventComponentUpdateImage: function eventComponentUpdateImage(editor) {
      var self = this;
      editor.on('component:update:src', function (model, argument) {
        if (model.attributes.type === 'image') {
          // noinspection JSAnnotator
          var _getImageSize = function _getImageSize(url) {
            var img = new Image();
            var width = 0;
            img.onload = function () {
              width = img.width;
              window.eventHub.$emit('updateWidthImage', { className: model.getClasses()[0], img: img });
            };
            img.src = url;
            return img.width;
          };

          var srcImage = model.attributes.src;
          if (srcImage.indexOf('/mini/') !== -1) {
            var srcImageOrigin = srcImage.replace('/mini/', '/');
            srcImage = srcImageOrigin;
            model.attributes.src = srcImage;
            model.attributes.attributes.src = srcImage;
            model.view.el.src = srcImage;
            _getImageSize(srcImage);
          } else {
            _getImageSize(srcImage);
          }
        }
      });
      editor.on('stop:open-assets', function (e, f, v, c) {
        var getAllComponents = function getAllComponents(model) {
          var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

          result.push(model);
          model.components().each(function (mod) {
            return getAllComponents(mod, result);
          });
          return result;
        };
        var all = getAllComponents(editor.DomComponents.getWrapper());

        for (var i = 0; i < all.length; i++) {
          var type = all[i].attributes.type;
          var src = all[i].attributes.src;
          if (type === 'image') {
            if (!src) {
              grapesjsEMP.editors[0].UndoManager.undo();
            }
          }
        }
      });
    },
    eventComponentCloneElement: function eventComponentCloneElement(editor) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var cssComposer, self;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                cssComposer = editor.CssComposer;
                self = _this8;

                editor.on('component:clone', function (some, argument, e) {
                  var iconSave = document.querySelector('.icon-save');
                  if (iconSave) {
                    iconSave.classList.add('icon-selected');
                    _this8.setShowIconSave(true);
                  }
                  var selectedEl = editor.getSelected();
                  var conpounedTypes = ['social-icons-twitter', 'clocks', 'dateHeure'];
                  if (conpounedTypes.indexOf(selectedEl.attributes.type > -1) && selectedEl.attributes.type !== some.attributes.type) {
                    return;
                  }
                  var modelId = self.generateId();
                  var modelClass = self.generateId();
                  some.set('attributes', { id: modelId });
                  var positionLeft = void 0;
                  var positionTop = void 0;
                  var zIndex = void 0;
                  var left = 2;
                  var top = 2;
                  var newStyle = void 0;
                  if (some.attributes.copyable) {
                    var id = selectedEl.getAttributes().id;
                    var oldClass = selectedEl.getAttributes().class;
                    var newClass = '';

                    var dataId = { oldid: id, newid: modelId };
                    self.duplicateSvgObject(dataId);
                    /**/
                    var exist = selectedEl.getAttributes()['data-class'];
                    if (exist && (exist === 'custom-title' || exist === 'custom-sharing' || exist === 'custom-credit')) {
                      if (oldClass) {
                        newClass = { class: oldClass };
                      }
                      some.addAttributes({
                        'data-class': exist,
                        newClass: newClass
                      });
                    }

                    if (cssComposer.getIdRule(id)) {
                      var oldStyle = cssComposer.getIdRule(id).attributes.style;
                      cssComposer.setIdRule(modelId, oldStyle);
                      var position = oldStyle.position;
                      positionLeft = oldStyle.left;
                      positionTop = oldStyle.top;
                      zIndex = parseInt(oldStyle['z-index']);
                      var obj = { position: position, left: left + '%', top: top + '%' };
                      if (positionLeft && positionTop) {
                        var posLeft = parseInt(positionLeft) + 2 + '%';
                        var posTop = parseInt(positionTop) + 2 + '%';
                        if (some.attributes.type === 'filet') {
                          posLeft = '50%';
                          posTop = parseInt(positionTop) + 10 + '%';
                        }
                        obj.left = posLeft;
                        obj.top = posTop;
                        newStyle = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, oldStyle, obj);
                      }
                      if (!isNaN(zIndex)) {
                        obj = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, obj, { 'z-index': zIndex + 1 });
                      }
                      cssComposer.setIdRule(modelId, obj);
                    } else if (cssComposer.getClassRule(oldClass)) {
                      var _oldStyle8 = cssComposer.getClassRule(oldClass).attributes.style;
                      cssComposer.setClassRule(modelClass, _oldStyle8);
                      var _position = _oldStyle8.position;
                      positionLeft = _oldStyle8.left;
                      positionTop = _oldStyle8.top;
                      zIndex = parseInt(_oldStyle8['z-index']);
                      var _obj = { position: _position, left: left + '%', top: top + '%' };
                      if (positionLeft && positionTop) {
                        var posLeft = parseInt(positionLeft) + 2 + '%';
                        var posTop = parseInt(positionTop) + 2 + '%';
                        if (some.attributes.type === 'filet') {
                          posLeft = '50%';
                          posTop = parseInt(positionTop) + 10 + '%';
                        }
                        _obj.left = posLeft;
                        _obj.top = posTop;
                        newStyle = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, _oldStyle8, _obj);
                      }
                      if (!isNaN(zIndex)) {
                        _obj = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, _obj, { 'z-index': zIndex + 1 });
                      }
                      cssComposer.setClassRule(modelClass, _obj);
                    }
                    var classes = editor.getSelected().getAttributes().class;
                    if (classes) {
                      classes = classes.split(' ');
                      if (classes && classes[0]) {
                        var _oldStyle9 = cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes ? cssComposer.getClassRule(classes[0]).attributes.style : {};
                        var _position2 = _oldStyle9.position;
                        positionLeft = _oldStyle9.left;
                        positionTop = _oldStyle9.top;

                        var _obj2 = { left: left + '%', top: top + '%' };
                        if (_oldStyle9.position === 'absolute' || _oldStyle9.position === 'fixed') {
                          if (positionLeft && positionTop) {
                            var posLeft = parseInt(positionLeft) + 2 + '%';
                            var posTop = parseInt(positionTop) + 2 + '%';
                            if (some.attributes.type === 'filet') {
                              posLeft = '50%';
                              posTop = parseInt(positionTop) + 10 + '%';
                            }
                            _obj2.left = posLeft;
                            _obj2.top = posTop;
                          }
                          newStyle = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, _oldStyle9, _obj2);
                        } else {
                          newStyle = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, _obj2, _oldStyle9);
                        }
                        if (!isNaN(zIndex)) {
                          newStyle = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, newStyle, { 'z-index': zIndex + 1 });
                        }
                        some.removeClass(classes[0]);
                        some.addClass(modelClass);

                        cssComposer.setClassRule(modelClass, newStyle);
                      }
                    }
                    self.setNoAutoplayDuplicateVideo(editor, modelId);
                    if (some.attributes.type === 'image' || some.attributes.type === 'image_media') {
                      some.attributes.attributes.src = some.attributes.src;
                    }
                    if (some.attributes.type === 'text' || some.attributes.type === 'link') {
                      if (self.paramsClient.display_fonts && self.paramsClient.display_fonts.length > 0) {
                        var _classes7 = some.getClasses();

                        var _cssComposer6 = editor.CssComposer;
                        var css = _cssComposer6.getClassRule(_classes7[0]);
                        if (_classes7 && _classes7[0]) {
                          var _oldStyle10 = _cssComposer6.getClassRule(_classes7[0]) && _cssComposer6.getClassRule(_classes7[0]).attributes ? _cssComposer6.getClassRule(_classes7[0]).attributes.style : {};
                          var oldStyleFamilyFont = _oldStyle10['font-family'];
                          var _newStyle10 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()(_oldStyle10, {
                            'font-family': oldStyleFamilyFont
                          });
                          _cssComposer6.setClassRule(_classes7[0], _newStyle10);
                        }
                      }
                    }
                    if (some.attributes.type === 'video') {
                      var isvideoAutoplay = selectedEl.attributes.autoplay;
                      var srcVideo = selectedEl.attributes.src;
                      var muted = selectedEl.attributes.muted;
                      var extension = srcVideo.split('.').pop();
                      if (extension.indexOf('mp4') > -1) {
                        selectedEl.addAttributes({
                          autoplay: isvideoAutoplay,
                          muted: muted
                        });
                        some.addAttributes({
                          autoplay: isvideoAutoplay,
                          muted: muted
                        });
                        self.getSourceVideo(srcVideo, isvideoAutoplay, some, some.attributes.type);
                      }
                    }
                    if (some.attributes.type === 'clocks') {
                      some.set('copied', true);
                      setTimeout(function () {
                        some.set('copied', false);
                      }, 100);
                    }
                  }

                  setTimeout(function () {
                    editor.select(editor.DomComponents.getWrapper());
                  }, 100);
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this8);
      }))();
    },
    eventDelete: function eventDelete(editor) {
      var self = this;
      editor.Keymaps.remove('core:component-delete');
      editor.Keymaps.add('emp:component-delete', 'delete', 'emp-delete');

      editor.Commands.add('emp-delete', function (ed) {
        var model = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, ed.getSelected());
        if (!model || model && model.attributes && model.attributes.type === 'text') {
          return;
        }
        editor.UndoManager.undo();
        self.toastDelete(editor);
      });
      editor.Commands.add('tlb-delete', function (ed) {
        self.toastDelete(editor);
      });
    },
    eventFullScreen: function eventFullScreen(editor) {
      editor.Commands.add('fullscreen', function (ed) {});
    },
    eventImageAdded: function eventImageAdded(editor) {
      var self = this;
      var cssComposer = editor.CssComposer;
      editor.on('component:add', function (some, argument) {
        if (some.attributes.type === 'image' || some.attributes.type === 'image_media') {
          var classElement = some.getAttributes().class;
          if (classElement) {
            var classElementFirst = classElement.split(' ')[0];

            if (classElementFirst && some.parent()) {
              var id = some.parent().getAttributes().id;
              var offsetWidth = some.parent().view.el.offsetWidth;
              self.setParentWidth(offsetWidth);

              var someImage = {
                className: classElementFirst,
                idParent: id
              };
              self.setSomeImage(someImage);
            }
          }

          if (!some.view.el.src) {
            // some.view.el.src =
            //   'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImZpbGw6IHJnYmEoMCwwLDAsMC4xNSk7IHRyYW5zZm9ybTogc2NhbGUoMC43NSkiPgogICAgICAgIDxwYXRoIGQ9Ik04LjUgMTMuNWwyLjUgMyAzLjUtNC41IDQuNSA2SDVtMTYgMVY1YTIgMiAwIDAgMC0yLTJINWMtMS4xIDAtMiAuOS0yIDJ2MTRjMCAxLjEuOSAyIDIgMmgxNGMxLjEgMCAyLS45IDItMnoiPjwvcGF0aD4KICAgICAgPC9zdmc+';
            // editor.UndoManager.undo();
          }
        }
      });
    },
    eventClockAdded: function eventClockAdded(editor) {
      editor.on('component:add', function (some, argument) {
        if (some.attributes.type === 'clocks') {
          var cssComposer = editor.CssComposer;
          var classes = some.getClasses();

          var oldStyle = cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes ? cssComposer.getClassRule(classes[0]).attributes.style : {};

          var styleAdded = {
            width: oldStyle.width ? oldStyle.width : '20%',
            height: oldStyle.height ? oldStyle.height : 'auto',
            'font-size': oldStyle['font-size'] ? oldStyle['font-size'] : '1vw'
          };
          if (classes && classes[0]) {
            var newStyle = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, oldStyle, styleAdded);
            cssComposer.setClassRule(classes[0], newStyle);
          }
          some.view.updateScript();
          localStorage.setItem('gjs-js', editor.getJs());
        }
      });
    },
    eventDateHeureAdded: function eventDateHeureAdded(editor) {
      editor.on('component:add', function (some, argument) {
        if (some.attributes.type === 'dateHeure') {
          var cssComposer = editor.CssComposer;
          var classes = some.getClasses();

          var oldStyle = cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes ? cssComposer.getClassRule(classes[0]).attributes.style : {};

          var styleAdded = {
            width: oldStyle.width ? oldStyle.width : 'auto%',
            height: oldStyle.height ? oldStyle.height : 'auto',
            'font-size': oldStyle['font-size'] ? oldStyle['font-size'] : '2.1vw'
          };
          if (classes && classes[0]) {
            var newStyle = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, oldStyle, styleAdded);
            cssComposer.setClassRule(classes[0], newStyle);
          }
          some.view.updateScript();
          localStorage.setItem('gjs-js', editor.getJs());
        }
      });
    },
    addSettingButton: function addSettingButton(editor) {
      if (editor) {
        var selected = editor.getSelected();
        var tb = [];
        var type = selected.get('type');
        var attributes = selected.getAttributes();
        if (type === 'text' && attributes['data-class'] === 'custom-credit') {
          if (selected.get('removable')) {
            selected.set('resizable', false);
            tb.push({
              attributes: { class: 'fa fa-undo', title: 'Rotate' },
              command: 'rotate-element'
            });
            // }
          }
        }
        if (type === 'image_media' || type === 'pattern') {
          /*let src =
            type === 'image' ? selected.attributes.attributes.src : selected.view.el.firstChild.src;
          let extension = src.split('.').pop();
          if ((extension && extension === 'svg') || selected.attributes.svg === 'svg') {
            selected.set('svg', 'svg');*/
          if (selected.get('removable')) {
            tb.push({
              attributes: { class: 'fa fa-object-group', title: 'svg mator' },
              command: 'show-svg-mator'
            });
            // }
          }
        }
        if (selected.collection && selected.collection.parent) {
          // tb.push({
          //   attributes: { class: 'fa fa-arrow-up', title: 'Sélectionner parent' },
          //   command: 'select-parent'
          // });
        } else if (selected.attributes.type === 'wrapper' && this.hasPermission('edit_duration_segment_action')) {
          tb.push({
            attributes: { class: 'fa fa-cogs', title: "Paramètres de l'écran" },
            command: 'screen-settings'
          });
        }
        var classElementFirst = void 0;
        if (selected.attributes.type === '') {
          var classCountDown = selected.parent().parent().getAttributes().class;
          if (classCountDown) {
            classElementFirst = classCountDown;
          }
        }

        if (selected.get('copyable') && !selected.getAttributes()['data-js'] && !classElementFirst) {
          tb.push({
            attributes: this.setDuplicateAttr,
            command: 'tlb-clone'
          });
        }
        if (selected.get('removable') && !selected.getAttributes()['data-js'] && !classElementFirst) {
          tb.push({
            attributes: this.setRemoveAttr,
            command: 'tlb-delete'
          });
        }

        if (selected.get('removable')) {
          tb.push({
            attributes: this.setEditAttr,
            command: 'show-editor'
          });
        }
        if (selected.get('removable') && !selected.getAttributes()['data-js'] && !classElementFirst) {
          tb.push({
            attributes: this.setSettingsAttr,
            command: 'show-setting'
          });
        }

        var delay = selected.getAttributes().value;
        if (delay) {
          this.setDelayFragment(delay);
          this.$root.$emit('change-delay', delay);
        } else {
          this.$root.$emit('change-delay', '');
          this.setDelayFragment('');
        }
        var attributeElement = selected.getAttributes();
        if (selected && attributeElement) {
          var classElement = selected.getAttributes().class;
          if (classElement) {
            var _classElementFirst = classElement.split(' ')[0];
            if (_classElementFirst) {
              var elemnt = '.' + _classElementFirst + ' ';
              var element = document.querySelector('.gjs-frame').contentWindow.document.querySelector(elemnt);
              if (element && selected) {
                var style = getComputedStyle(element);
                if (style) {
                  var opacityElement = style.opacity;
                  this.setOpacityFragment(opacityElement * 100);
                  this.$root.$emit('change-opacity', opacityElement * 100);
                } else {
                  this.$root.$emit('change-opacity', 100);
                  this.setOpacityFragment(100);
                }
              }
            }
          }
        }
        if (type === 'video_mp4') {
          tb.push({
            attributes: { class: 'fa fa-arrows-alt', title: 'FullScreen' },
            command: 'full-screen-video'
          });
        }

        /*
        if(type ==="image_media"){
          tb.push({
            attributes: { class: 'icon-expand-in full-BG BG-icon', title: 'Arrière plan' },
            command: 'full-background-img',
          });
        }
         if(type==="wrapper"){
          tb=[];
          tb.push({
            attributes: { class: 'icon-resize-out reset-full-BG BG-icon', title: 'Réinitialiser arrière plan' },
            command: 'reset-full-background-img',
          });
         }
         */
        if (selected.get('draggable') && this.paramsClient.isDisplayVideo !== null && this.paramsClient.isDisplayVideo && !selected.getAttributes()['data-js'] && !classElementFirst) {
          tb.push({
            attributes: {
              class: 'fa fa-arrows',
              title: 'Déplacement libre',
              draggable: true
            },
            command: 'emp-move'
          });
        } else if (selected.get('draggable') && !selected.getAttributes()['data-js'] && !classElementFirst) {
          tb.push({
            attributes: this.setMoveAttr,
            command: 'tlb-move'
          });
        }
        selected.set('toolbar', tb);

        if (selected.attributes.type === 'custom_column' || selected.attributes.type === 'video_mp4') {
          tb = [];
          selected.set('toolbar', tb);
        }
        if (selected.attributes.type === 'custom_column2') {
          tb = [];
          tb.push({
            attributes: this.setRemoveAttr,
            command: 'tlb-delete'
          });
          selected.set('toolbar', tb);
        }
      }
    },
    eventComponentStyleUpdateImageHeightOrWidht: function eventComponentStyleUpdateImageHeightOrWidht(editor) {
      var _this9 = this;

      var self = this;
      var styleBusy = { clocks: false, countdown: false };
      var fontBusy = { clocks: false, countdown: false };

      editor.on('component:styleUpdate:height component:styleUpdate:width', function (model) {
        if (model.attributes.type === 'image' || model.attributes.type === 'image_media' || model.attributes.type === 'pattern') {
          var classes = model.getClasses();
          var cssComposer = editor.CssComposer;
          var css = cssComposer.getClassRule(classes[0]);
          if (classes && classes[0]) {
            var oldStyle = css && css.attributes ? css.attributes.style : {};
            var heightModel = oldStyle.height && oldStyle.height !== 'auto' ? oldStyle.height : window.getComputedStyle(model.view.el).height;
            var widthModel = oldStyle.width ? oldStyle.width : window.getComputedStyle(model.view.el).width;

            var iframeEl = document.querySelector('.gjs-cv-canvas .gjs-frame');
            if (heightModel.indexOf('px') > -1 || heightModel.indexOf('%') === -1) {
              var h = isNaN(parseFloat(heightModel)) ? parseFloat(window.getComputedStyle(model.view.el).height) : parseFloat(heightModel);

              var height = h / parseFloat(window.getComputedStyle(iframeEl).height) * 100 + '%';
              var newStyle = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, oldStyle, { height: height });
              cssComposer.setClassRule(classes[0], newStyle);
            }
            if (widthModel.indexOf('px') > -1 || widthModel.indexOf('%') === -1) {
              var w = isNaN(parseFloat(widthModel)) ? parseFloat(window.getComputedStyle(model.view.el).width) : parseFloat(widthModel);

              var width = w / parseFloat(window.getComputedStyle(iframeEl).width) * 100 + '%';
              var _newStyle11 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, oldStyle, { width: width });
              cssComposer.setClassRule(classes[0], _newStyle11);
            }
          }
        }

        if (model.attributes.type === 'text') {
          var _classes8 = model.getClasses();
          var _cssComposer7 = editor.CssComposer;
          var _css = _cssComposer7.getClassRule(_classes8[0]);
          if (_classes8 && _classes8[0]) {
            var _oldStyle11 = _css && _css.attributes ? _css.attributes.style : {};
            var _heightModel = _oldStyle11.height && _oldStyle11.height !== 'auto' ? _oldStyle11.height : window.getComputedStyle(model.view.el).height;

            var _widthModel = _oldStyle11.width ? _oldStyle11.width : window.getComputedStyle(model.view.el).width;

            var _iframeEl = document.querySelector('.gjs-cv-canvas .gjs-frame');
            if (_heightModel.indexOf('px') > -1) {
              var _height2 = parseFloat(_heightModel) / parseFloat(window.getComputedStyle(_iframeEl).height) * 100 + '%';
              var _newStyle12 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, _oldStyle11, { height: _height2 });
              _cssComposer7.setClassRule(_classes8[0], _newStyle12);
            }
            if (_widthModel.indexOf('px') > -1) {
              var _width2 = parseFloat(_widthModel) / parseFloat(window.getComputedStyle(_iframeEl).width) * 100 + '%';
              var _newStyle13 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, _oldStyle11, { width: _width2 });
              _cssComposer7.setClassRule(_classes8[0], _newStyle13);
            }
          }
          self.updateEditableTextHeightWidth(editor);
        }
        var type = model.attributes.type;
        if (type === 'countdown' && !styleBusy[type]) {
          // || type === 'clocks'
          styleBusy[type] = true;
          setTimeout(function () {
            styleBusy[type] = false;
            _this9.udpdateClocksWidthHeight(editor, model);
            setTimeout(function () {
              if (!styleBusy[type]) {
                var _classes9 = model.getClasses();
                var _cssComposer8 = editor.CssComposer;
                var _css2 = _cssComposer8.getClassRule(_classes9[0]);
                if (_classes9 && _classes9[0]) {
                  var _oldStyle12 = _css2 && _css2.attributes ? _css2.attributes.style : {};
                  var _newStyle14 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, _oldStyle12, { height: 'auto' });
                  _cssComposer8.setClassRule(_classes9[0], _newStyle14);
                }
              }
            }, 300);
          }, 100);
          _this9.udpdateClocksWidthHeight(editor, model);
        }

        if (model.attributes.type === 'linkedin_widget') {
          var _classes10 = model.getClasses();
          var _cssComposer9 = editor.CssComposer;
          var _css3 = _cssComposer9.getClassRule(_classes10[0]);

          if (_classes10 && _classes10[0]) {
            var _oldStyle13 = _css3 && _css3.attributes ? _css3.attributes.style : {};
            var _heightModel2 = _oldStyle13.height ? _oldStyle13.height : window.getComputedStyle(model.view.el).height;

            var _widthModel2 = _oldStyle13.width ? _oldStyle13.width : window.getComputedStyle(model.view.el).width;

            var _iframeEl2 = document.querySelector('.gjs-cv-canvas .gjs-frame');

            if (_heightModel2.indexOf('px') > -1) {
              var _height3 = parseFloat(_heightModel2) / parseFloat(window.getComputedStyle(_iframeEl2).height) * 100 + '%';
              var _newStyle15 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, _oldStyle13, { height: _height3 });
              _cssComposer9.setClassRule(_classes10[0], _newStyle15);
            }
            if (_widthModel2.indexOf('px') > -1) {
              var _width3 = parseFloat(_widthModel2) / parseFloat(window.getComputedStyle(_iframeEl2).width) * 100 + '%';
              var _newStyle16 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, _oldStyle13, { width: _width3 });
              _cssComposer9.setClassRule(_classes10[0], _newStyle16);
            }
          }
        }

        if (model.attributes.type === 'linkedin_widget' || model.attributes.type === 'facebook_widget' || model.attributes.type === 'social-icons-twitter') {
          var _classes11 = model.getClasses();
          var _cssComposer10 = editor.CssComposer;
          var _css4 = _cssComposer10.getClassRule(_classes11[0]);

          if (_classes11 && _classes11[0]) {
            var _oldStyle14 = _css4 && _css4.attributes ? _css4.attributes.style : {};
            var _heightModel3 = _oldStyle14.height ? _oldStyle14.height : window.getComputedStyle(model.view.el).height;

            var _widthModel3 = _oldStyle14.width ? _oldStyle14.width : window.getComputedStyle(model.view.el).width;

            var _iframeEl3 = document.querySelector('.gjs-cv-canvas .gjs-frame');

            if (_heightModel3.indexOf('px') > -1) {
              var _height4 = parseFloat(_heightModel3) / parseFloat(window.getComputedStyle(_iframeEl3).height) * 100 + '%';
              var _newStyle17 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, _oldStyle14, { height: _height4 });
              _cssComposer10.setClassRule(_classes11[0], _newStyle17);
            }
            if (_widthModel3.indexOf('px') > -1) {
              var _width4 = parseFloat(_widthModel3) / parseFloat(window.getComputedStyle(_iframeEl3).width) * 100 + '%';
              var _newStyle18 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, _oldStyle14, { width: _width4 });
              _cssComposer10.setClassRule(_classes11[0], _newStyle18);
            }
            if (model.attributes.type === 'facebook_widget') {
              model.view.updateScript();
              localStorage.setItem('gjs-js', editor.getJs());
            }
          }
        }
      });

      editor.on('component:styleUpdate:font-size', function (model) {
        var type = model.get('type');
        if ((type === 'custom-countdown' || type === 'clocks') && !fontBusy[type]) {
          // || type === 'clocks'
          fontBusy[type] = true;
          setTimeout(function () {
            fontBusy[type] = false;
            _this9.udpdateClocksFontSize(editor, model);
          }, 100);
          _this9.udpdateClocksFontSize(editor, model);
        }
      });
    },
    eventComponentStyleUpdate: function eventComponentStyleUpdate(editor) {
      var _this10 = this;

      editor.on('component:styleUpdate', function (model) {
        var wrapper = document.getElementsByClassName('gjs-frame')[0];
        if (wrapper) {
          wrapper.contentDocument.all[2].style.overflow = 'hidden';
        }
        //editor.CssComposer.clear();
        //var model = editor.getSelected();

        var iconSave = document.querySelector('.icon-save');
        if (iconSave) {
          iconSave.classList.add('icon-selected');
          _this10.setShowIconSave(true);
        }
      });
    },
    eventComponentUpdate: function eventComponentUpdate(editor) {
      var _this11 = this;

      editor.on('component:update', function (e) {
        /* var iconSave = document.querySelector('.icon-save');
          if (iconSave) {
              iconSave.classList.add('icon-selected');
          }*/
        _this11.updateCustomColumn(editor, e);
        _this11.updateToolbarPosition();
      });
    },
    updateCustomColumn: function updateCustomColumn(editor, model) {
      if (model && model.attributes && model.attributes.type == 'custom_column') {
        if (model.attributes.style && model.attributes.style['background-image'] && model.attributes.style['background-image'] !== 'none') {
          var selected = editor.getSelected();
          if (selected && selected.attributes.getClasses()[0] == model.attributes.getClasses()[0]) {
            var oldStyle = selected.view.el ? selected.view.el.getComputedStyle() : {};
            var newStyle = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, model.attributes.style, oldStyle);
            newStyle['background-image'] = oldStyle['background-image'].indexOf('none') > 0 ? model.attributes.style['background-image'] : oldStyle['background-image'];
            newStyle['background-repeat'] = oldStyle['background-repeat'] === 'row' ? model.attributes.style['background-repeat'] : oldStyle['background-repeat'];
            newStyle['background-position'] = oldStyle['background-position'] === 'row' ? model.attributes.style['background-position'] : oldStyle['background-position'];
            newStyle['background-size'] = oldStyle['background-size'] === 'row' ? model.attributes.style['background-size'] : oldStyle['background-size'];
            selected.addStyle(newStyle);
          }
        }
      }
    },
    eventComponentUpdateWidthSrc: function eventComponentUpdateWidthSrc(editor) {
      var _this12 = this;

      editor.on('component:styleUpdate:height component:styleUpdate:width component:update:src', function (model) {
        var modelEl = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(model.view.el.getBoundingClientRect()));
        var iframeEl = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(document.querySelector('.gjs-frame').getBoundingClientRect()));
        var margin = 10;
        /*if (
          (model.get('type') === 'player' || model.get('type') === 'video_mp4') &&
          ((modelEl.left <= margin && modelEl.width + margin >= iframeEl.width) ||
            (modelEl.top <= margin && modelEl.height + margin >= iframeEl.height))
        ) {
          if (this.$route.name !== 'segment') {
            this.updateSegmentDuration({
              duration: model.attributes.duration,
              uid: this.currentSlide.uid,
              fullscreenVideo: true,
              originalDuration: model.attributes.duration,
            });
            if (!window.selected) {
              this.handleIsMultipleBy30Segment(this.currentSlide.uid, model.attributes.duration);
            }
          } else {
            this.updateSlideDuration({
              duration: model.attributes.duration,
              uid: this.currentSlide.uid,
            });
          }
        }*/
        if (model.get('type') === 'clocks') {
          _this12.udpdateClocksWidthHeight(editor, model);
        }
      });
    },
    eventComponentUpdateStyleBackgroundImage: function eventComponentUpdateStyleBackgroundImage(editor) {
      editor.on('component:styleUpdate:background-image', function (e) {
        if (e && e.attributes && e.attributes.style['background-image']) {
          var srcImage = e.attributes.style['background-image'];
          if (srcImage.indexOf('/mini/')) {
            srcImage = srcImage.replace('/mini/', '/');
            e.attributes.style['background-image'] = srcImage;
            e.view.el.style['background-image'] = srcImage;
          }
        }
      });
    },
    updateToolbarPosition: function updateToolbarPosition() {
      setTimeout(function () {
        var canvasEl = document.querySelector('.gjs-frame');
        var toolbarEl = document.querySelector('.gjs-toolbar');

        var canvas = canvasEl.getBoundingClientRect();
        var toolbar = toolbarEl.getBoundingClientRect();

        var width = canvas.width,
            height = canvas.height,
            left = canvas.left,
            top = canvas.top;

        if (toolbar.left + toolbar.width > left + width) {
          toolbarEl.style.left = left + width - toolbar.width + 'px';
        }
        if (toolbar.top + toolbar.height > height + 15) {
          toolbarEl.style.top = height + 15 - toolbar.height + 'px';
        }
      }, 100);
    },
    timeToSec: function timeToSec(time) {
      try {
        var sec = time.split(':').reverse().reduce(function (prev, curr, i) {
          return prev + curr * Math.pow(60, i);
        }, 0);
        return isNaN(sec) ? 5 : sec;
      } catch (e) {
        console.log('catch timeToSec', time);
      }
      return time;
    },
    SecToTime: function SecToTime(seconds) {
      var sec = parseInt(seconds, 10);
      if (isNaN(sec)) {
        return '00:00:20';
      }
      var h = Math.floor(sec / 3600);
      var m = Math.floor((sec - h * 3600) / 60);
      var s = sec - h * 3600 - m * 60;

      if (h < 10) {
        h = '0' + h;
      }
      if (m < 10) {
        m = '0' + m;
      }
      if (s < 10) {
        s = '0' + s;
      }
      return h + ':' + m + ':' + s;
    },
    setDeviceManagerEditor: function setDeviceManagerEditor(editor, getParamsClients) {
      var self = this;
      if (getParamsClients.display_devices !== null || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(getParamsClients.display_devices).length > 0) {
        var devices = getParamsClients.display_devices.map(function (device) {
          return device.name;
        });
        var classNames = getParamsClients.display_devices.map(function (item) {
          return item.className;
        });
        var sizeX = getParamsClients.display_devices.map(function (item) {
          return item.x;
        });
        var sizeY = getParamsClients.display_devices.map(function (item) {
          return item.y;
        });
        var Height = getParamsClients.display_devices.map(function (item) {
          return item.height;
        });
        var Width = getParamsClients.display_devices.map(function (item) {
          return item.width;
        });
        devices.forEach(function (device, index) {
          for (var i = 0; i < device.length; i++) {
            editor.DeviceManager.add('pc-' + device, Width, {
              height: Height,
              widthMedia: '' // the width that will be used for the CSS media
            });
          }
        });
      }
    },
    updateActiveDevice: function updateActiveDevice(model) {
      model.collection.deactivateAll(model.get('context'), model);
      model.set('active', true, { silent: true }).trigger('checkActive');
    },
    setDeviceEditor: function setDeviceEditor(editor, getParamsClients) {
      var self = this;
      var devices = getParamsClients.display_devices.map(function (device) {
        return device.name;
      });
      var classNames = getParamsClients.display_devices.map(function (item) {
        return item.className;
      });
      var sizeX = getParamsClients.display_devices.map(function (item) {
        return item.x;
      });
      var sizeY = getParamsClients.display_devices.map(function (item) {
        return item.y;
      });
      var buttons = [];
      devices.forEach(function (device, index) {
        var buttonsPanel = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({});

        buttonsPanel.position = 'barista';
        buttons.push({
          id: 'set-pc-' + device,
          className: classNames[index],
          active: true,
          command: 'device-' + device
        });
      });
      editor.Panels.addPanel({
        id: 'devices-b',
        visible: true,

        buttons: buttons
      });
      devices.forEach(function (device, index) {
        editor.Commands.add('device-' + device, {
          run: function run(editor, Model, sender) {
            editor.setDevice('pc-' + device);
            self.setDeviceType(device);
            var size = {
              x: sizeX[index],
              y: sizeY[index]
            };
            self.setDeviceSize(size);
            self.updateCanvasDimensions();
            self.updateActiveDevice(Model);

            if (sender) {
              sender.sender.set('active', true);
            }
          },
          stop: function stop(editor, sender) {}
        });
      });

      editor.Panels.removePanel('devices-c');
      editor.on('load', function () {
        editor.Panels.getButton('views', 'open-blocks').set('active', true);
        editor.setDevice('pc-landscape');
      });
    },
    eventComponentUpdateCountDown: function eventComponentUpdateCountDown(editor) {
      var self = this;
      var busy = { clocks: false, countdown: false, dateHeure: false };
      editor.on('component:update:startfrom component:update:endText component:styleUpdate component:update', function (model) {
        var type = model.get('type');
        if ((type === 'custom-countdown' || type === 'clocks' || type === 'dateHeure') && !busy[type]) {
          busy[type] = true;
          setTimeout(function () {
            busy[type] = false;
          }, 1000);

          model.view.updateScript();
          localStorage.setItem('gjs-js', editor.getJs());
          var localStorageComponents = JSON.parse(localStorage.getItem('gjs-components')).map(function (item) {
            if (item.attributes.id === model.getAttributes().id) {
              item = model;
            }
            return item;
          });
          localStorage.setItem('gjs-components', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(localStorageComponents));
        }
      });
    },
    eventEditText: function eventEditText(editor) {
      if (typeof jQuery === 'undefined') {
        return;
      }
      var self = this;
      var iframeBody = editor.Canvas.getBody();
      var settings = document.querySelector('.gjs-toolbar');

      $(iframeBody).on('focus', '[contenteditable="true"]', function (e) {
        settings.style.display = 'none';
      });

      $(iframeBody).on('keyup', '[contenteditable="true"]', function (e) {
        self.updateEditableTextHeightWidth(editor);
        settings.style.display = 'none';
      });
    },
    updateEditableTextHeight: function updateEditableTextHeight(editor) {
      editor.on('component:styleUpdate:width', function (model) {
        if (model.attributes.type !== 'text') {
          return;
        }
        var id = model.getAttributes().id;
        var cssComposer = editor.CssComposer;

        var classes = model.getClasses();
        var oldStyle = cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes ? cssComposer.getClassRule(classes[0]).attributes.style : {};

        var iframeEl = document.querySelector('.gjs-frame');
        var el = iframeEl.contentWindow.document.getElementById(id);

        var newStyle = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, oldStyle, { height: 'auto' });
        cssComposer.setClassRule(classes[0], newStyle);
      });
    },
    updateEditableTextHeightWidth: function updateEditableTextHeightWidth(editor) {
      var model = editor.getSelected();
      var id = model.getAttributes().id;
      var cssComposer = editor.CssComposer;

      var classes = model.getClasses();
      var oldStyle = cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes ? cssComposer.getClassRule(classes[0]).attributes.style : {};

      var iframeEl = document.querySelector('.gjs-frame');
      var el = iframeEl.contentWindow.document.getElementById(id);
      var iframeHeight = parseFloat(window.getComputedStyle(iframeEl).height);
      var iframeWidth = parseFloat(window.getComputedStyle(iframeEl).width);

      if (el.scrollHeight > el.offsetHeight || el.scrollWidth > el.offsetWidth) {
        var height = el.scrollHeight / iframeHeight * 100 + '%';
        var width = el.scrollWidth / iframeWidth * 100 + '%';
        var newStyle = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, oldStyle, { height: height, width: width });
        cssComposer.setClassRule(classes[0], newStyle);
      }

      var resizer = document.querySelector('.gjs-resizer-c');
      var elHeight = el.getBoundingClientRect().height;
      var elWidth = el.getBoundingClientRect().width;
      if (resizer) {
        resizer.style.height = elHeight + 'px';
        resizer.style.width = elWidth + 'px';
      }
    },
    eventDragEnd: function eventDragEnd(editor) {
      var _this13 = this;

      editor.on('component:add', function (model, argument) {
        if (model.attributes.type === 'image') {
          _this13.renderAssets(editor);
        }
      });
      editor.on('run:open-assets', function () {
        _this13.renderAssets(editor);
      });
    },
    renderAssets: function renderAssets(editor) {
      var am = editor.AssetManager;

      setTimeout(function () {
        scrollPage = 20;
        am.render(am.getAll().filter(function (a, i) {
          return i < scrollPage;
        }));
        var assetsWrapper = document.querySelector('.gjs-am-assets');
        var loading = false;
        if (assetsWrapper) {
          if (scrollPage === 20) {
            am.render(am.getAll().filter(function (a, i) {
              return i < scrollPage;
            }));
          }
          assetsWrapper.addEventListener('scroll', function (e) {
            if (assetsWrapper.scrollTop + assetsWrapper.offsetHeight >= assetsWrapper.scrollHeight && !loading) {
              loading = true;
              scrollPage += 20;
              am.render(am.getAll().filter(function (a, i) {
                return i < scrollPage;
              }));
            } else {
              loading = false;
            }
          });
        }
      }, 100);
    },
    eventPausedPlayer: function eventPausedPlayer(editor) {
      var _this14 = this;

      editor.on('component:add component:update:src component:update:autoplay ', function (model, argument) {
        var videoArray = ['video', 'player', 'video_mp4', 'playlist'];
        var attrAutoplay = void 0;
        if (videoArray.indexOf(model.attributes.type) > -1) {
          var srcVideoOrigin = void 0;
          _this14.srcVideo = model.attributes.src;
          if (_this14.srcVideo && _this14.srcVideo !== null) {
            var extension = _this14.srcVideo.split('.').pop();
            if (model.attributes.type === 'video' || model.attributes.type.indexOf('video') > -1) {
              attrAutoplay = 'autoplay';
              _this14.handleVideo(model);
            } else {
              attrAutoplay = 'a';
              _this14.setPausedVideo(model.attributes.type);
            }
            if (extension.indexOf('mp4') === -1) {
              if (_this14.srcVideo.indexOf(attrAutoplay + '=1') === -1) {
                _this14.isvideoAutoplayed = 0;
              }
              if (_this14.srcVideo.indexOf(attrAutoplay + '=1') > -1) {
                _this14.isvideoAutoplayed = 1;
              }
            }
            srcVideoOrigin = _this14.srcVideo;
            _this14.getSourceVideo(srcVideoOrigin, _this14.isvideoAutoplayed, model, videoArray);
          }
        }
      });
    },
    handleVideo: function handleVideo(model) {
      this.srcVideo = model.attributes.src;
      var extension = this.srcVideo.split('.').pop();
      if (extension.indexOf('mp4') === -1) {
        this.setNotMp4Players(model);
      } else {
        this.setMp4Players(model);
      }
    },
    setNotMp4Players: function setNotMp4Players(model) {
      var attr = void 0;
      var videoId = model.attributes.attributes.id;
      var iframe = document.querySelector('.gjs-frame').contentWindow;
      if (this.srcVideo.indexOf('vimeo') > -1) {
        if (this.srcVideo.indexOf('&muted=true') === -1) {
          attr = '&muted=true';
        }
      } else {
        if (this.srcVideo.indexOf('&mute=1') === -1) {
          attr = '&mute=1';
        }
      }
      if (attr) {
        this.srcVideo = this.srcVideo.replace(this.srcVideo, this.srcVideo + attr);
      }
      if (videoId) {
        var videoEl = iframe.document.querySelector('#' + videoId);
        if (videoEl) {
          videoEl.setAttribute('src', this.srcVideo);
        }
      }
    },
    setMp4Players: function setMp4Players(model) {
      var iframe = document.querySelector('.gjs-frame').contentWindow;
      var videoId = model.attributes.attributes.id;
      var videoElIframe = iframe.document.querySelector('#' + videoId);
      var videoEl = iframe.document.querySelector('#' + videoId + '> video');
      var isAutoplay = model.attributes.autoplay;
      if (videoElIframe) {
        videoElIframe.muted = true;
        if (videoEl) {
          videoEl.muted = true;
        }

        if (isAutoplay !== null && (isAutoplay !== '0' || isAutoplay !== 0 || isAutoplay === '')) {
          this.isvideoAutoplayed = 1;
        } else {
          this.isvideoAutoplayed = 0;
        }

        var obj = {
          autoplay: this.isvideoAutoplayed,
          muted: true
        };
        model.addAttributes(obj);
      }
    },
    setNoMutedVideo: function setNoMutedVideo() {
      var slides = void 0;
      if (this.$route.name === 'segment' || this.$route.name === 'edit') {
        slides = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.getCurrentSegment));
      } else {
        slides = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.getCurrentSlide));
      }
      return JSON.parse(this.getSanitizedHtml(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(slides.screens[0].html)));
    },
    eventAutoPlayVideo: function eventAutoPlayVideo(editor) {
      var _this15 = this;

      editor.on('component:update:src', function (model, argument) {
        var isvideoAutoplay = 0;
        var attrAutoplay = void 0;
        var videoArray = ['video'];
        if (videoArray.indexOf(model.attributes.type) > -1) {
          var srcVideo = model.attributes.src;
          if (srcVideo && srcVideo !== null) {
            var srcVideoOrigin = srcVideo;
            if (model.attributes.type === 'video') {
              attrAutoplay = 'autoplay';
            } else {
              attrAutoplay = 'a';
            }
            if (srcVideo.indexOf(attrAutoplay + '=1') === -1) {
              isvideoAutoplay = 0;
              srcVideoOrigin = srcVideo;
            }
            if (srcVideo.indexOf(attrAutoplay + '=1') > -1) {
              isvideoAutoplay = 1;
              srcVideo = srcVideo.replace(attrAutoplay + '=1', attrAutoplay + '=0');
              srcVideoOrigin = srcVideo;
            }
            _this15.getSourceVideo(srcVideoOrigin, isvideoAutoplay, model, videoArray);
          }
        }
      });
    },
    getSourceVideo: function getSourceVideo(srcVideoOrigin, isvideoAutoplay, model, videoArray) {
      var iframe = document.querySelector('.gjs-frame').contentWindow;
      var srcVideo = srcVideoOrigin;
      model.attributes.src = srcVideo;
      model.attributes.attributes.src = srcVideo;
      if (model.view) {
        model.view.el.src = srcVideo;
      }
      model.attributes.autoplay = isvideoAutoplay;
      model.attributes.muted = true;
      var videoId = model.attributes.attributes.id;
      if (videoId) {
        var videoEl = iframe.document.querySelector('#' + videoId);
        var videoElIframe = iframe.document.querySelector('#' + videoId + ' > iframe');
        var iframeVideo = iframe.document.querySelector('#' + videoId + ' > video');
        if (videoEl) {
          videoEl.setAttribute('src', srcVideo);
        }
        if (videoElIframe) {
          videoElIframe.setAttribute('src', srcVideo);
        }

        if (iframeVideo && model.attributes.type.indexOf('video_mp4') === -1) {
          iframeVideo.setAttribute('src', srcVideo);
          iframeVideo.setAttribute('autoplay', isvideoAutoplay);
          iframeVideo.setAttribute('muted', true);
        }
      }
      var comps = JSON.parse(localStorage.getItem('gjs-components'));
      this.updateVideoComponent(model, comps, videoArray, isvideoAutoplay, srcVideo);
    },
    updateVideoComponent: function updateVideoComponent(model, comps, videoArray, isvideoAutoplay, srcVideo) {
      var _this16 = this;

      var videoId = model.attributes.attributes.id;
      if (comps && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(comps).length > 0) {
        comps.forEach(function (comp) {
          if (comp.attributes.id === videoId && videoArray.indexOf(comp.type) > -1) {
            comp.slide = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(_this16.getCurrentSlideIndex));
            comp.src = srcVideo;
            comp.attributes.src = srcVideo;
            comp.autoplay = isvideoAutoplay;
            comp.attributes.autoplay = isvideoAutoplay;
            comp.attributes.muted = true;
            _this16.$root.$emit('isVideoAutoplay', { model: model, video: comp });
          }
        });
      }
    },
    eventSupSelectedText: function eventSupSelectedText(editor) {
      var rte = editor.RichTextEditor;
      rte.add('Sup', {
        icon: '<sup>2</sup>',
        attributes: { title: 'Sup' },
        result: function result(rte) {
          return rte.insertHTML('<sup>' + rte.selection() + '</sup>');
        }
      });
    },
    handleIsMultipleBy30Segment: function handleIsMultipleBy30Segment(uid, durationVid) {
      if (!__WEBPACK_IMPORTED_MODULE_11__helpers_duration_handler__["e" /* isMultipleBy30 */]()) {
        return true;
      }
      var segment = this.getSegmentByUid(uid);
      if (segment.duration % 30 === 0) {
        return true;
      }
      /*const fullscreenVideo = segment.screens.find(s => s.fullscreenVideo);
      if (!fullscreenVideo) {
        return false;
      }
       if (durationVid <= 30) {
        this.$root.$emit('eventExtendDuration', { duration: durationVid, uid: segment.uid });
      } else {
        this.$root.$emit('eventExtendSegmentDuration', { uid: segment.uid });
      }
      */
    },
    updatePositionCkeditors: function updatePositionCkeditors(editor) {
      var selected = editor.getSelected();
      var self = this;
      if (selected) {
        if (selected.view.el) {
          selected.view.el.addEventListener('dblclick', function (e) {
            var canvasEl = document.querySelector('.gjs-frame');
            var ckeditorsEl = document.querySelector('.gjs-rte-toolbar');
            setTimeout(function () {
              var canvas = canvasEl.getBoundingClientRect();
              var ckeditor = ckeditorsEl.getBoundingClientRect();
              var width = ckeditor.width,
                  height = ckeditor.height,
                  right = ckeditor.right,
                  left = ckeditor.left;

              if (ckeditor.height > 50) {
                ckeditorsEl.style.right = '45px';
                ckeditorsEl.style.left = 'auto';
              } else {
                ckeditorsEl.style.right = 'auto';
                ckeditorsEl.style.left = left + 'px';
              }
            }, 10);
          });
        }
      }
    }
  })
});

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Mixin__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Mixin__["a" /* default */]],
  methods: {
    translateBlocksName: function translateBlocksName(blocks) {
      var self = this;
      blocks.forEach(function (item) {
        if (item.attributes.label.indexOf('gjs-block-label') > -1) {
          var block1 = item.attributes.label.slice(0, item.attributes.label.indexOf('gjs-block-label">') + 17);
          item.set({
            label: block1 + self.$t('blocks.' + item.id),
            parent: block1 + self.$t('blocks.' + item.id),
            title: block1 + self.$t('blocks.' + item.id) + '</div>'
          });
        } else {
          item.set({
            label: self.$t('blocks.' + item.id),
            parent: self.$t('blocks.' + item.id),
            title: self.$t('blocks.' + item.id)
          });
        }
      });
    },
    translateStyleManagerName: function translateStyleManagerName(blocks) {
      var self = this;
      blocks.forEach(function (item) {
        if (item) {
          item.set({
            label: self.$t('blocks.' + item.id),
            name: self.$t('blocks.' + item.id)
          });
          var title = document.querySelector('.gjs-sm-sectors #gjs-sm-' + item.id.toLowerCase() + ' > div.gjs-sm-title');
          var caret = document.querySelector('.gjs-sm-sectors #gjs-sm-' + item.id.toLowerCase() + ' > div.gjs-sm-title #gjs-sm-caret');
          if (title) {
            title.innerHTML = '<i id="gjs-sm-caret" class="fa fa-caret-right"></i>' + self.$t('blocks.' + item.id);
            if (title.classList.contains('gjs-sm-open')) {
              caret.className = 'fa fa-caret-down';
            } else {
              caret.className = 'fa fa-caret-right';
            }
          }
        }
      });
    },
    translatePluginsTitle: function translatePluginsTitle(comp, type) {
      var self = this;
      var id = void 0;
      if (comp === 'image_media') {
        id = 'image-media';
      } else if (comp === 'social_media') {
        id = 'social-media';
      } else if (comp === 'pattern') {
        id = 'pattern';
      }
      var title = void 0,
          buttonCLoseId = void 0;
      var titlePluginsMedia = document.querySelector('#' + id + '-iframe .gjs-mdl-container .gjs-mdl-dialog.gjs-one-bg .gjs-mdl-header.modal-' + id);
      var titleImage = document.querySelector('.gjs-mdl-container .gjs-mdl-dialog.gjs-one-bg.gjs-two-color .gjs-mdl-header');
      setTimeout(function () {
        var dropFiles = document.querySelector('.gjs-mdl-container .gjs-mdl-dialog.gjs-one-bg.gjs-two-color .gjs-mdl-content #gjs-mdl-c .gjs-asset-manager .gjs-am-file-uploader > form  #gjs-am-title');
        if (dropFiles) {
          dropFiles.innerText = self.$t('blocks.drop_files');
        }
      }, 100);
      if (titleImage) {
        title = titleImage;
        buttonCLoseId = 'image';
      }
      if (titlePluginsMedia && comp === 'image_media') {
        title = titlePluginsMedia;
        titleImage = null;
        buttonCLoseId = id;
      } else if (titlePluginsMedia && comp === 'social_media') {
        title = titlePluginsMedia;
        titleImage = null;
        buttonCLoseId = id;
      } else if (titlePluginsMedia && comp === 'pattern') {
        title = titlePluginsMedia;
        titleImage = null;
        buttonCLoseId = id;
      }
      if (type === 'image' || type === 'pattern' || type === 'video') {
        type = 'select_' + type;
      }
      self.setTitleImage(title, type, buttonCLoseId);
      self.setCloseImageModal(comp, buttonCLoseId);
    },
    setTitleImage: function setTitleImage(title, type, buttonCLoseId) {
      title.innerHTML = '<div class="gjs-mdl-title">' + __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].t('blocks.' + type) + '</div><div id="close-modal-' + buttonCLoseId + '" class="gjs-mdl-btn-close" data-close-modal>⨯</div>';
    }
  }
});

/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bus", function() { return bus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_sweetalert2__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_progressbar__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_i18n__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_index__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_toasted__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_toasted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_v_animate_css__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_vue__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_bootstrap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_carousel__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_v_tooltip__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_top_progress__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_top_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_top_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuejs_dialog__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuejs_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuejs_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuejs_dialog_dist_vuejs_dialog_min_css__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuejs_dialog_dist_vuejs_dialog_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vuejs_dialog_dist_vuejs_dialog_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_fullscreen__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_fullscreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_fullscreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_select__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_infinite_loading__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_lazyload__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__i18n_en_US_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__i18n_fr_FR_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__filters__ = __webpack_require__(213);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
















// include the default style



var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('v-select', __WEBPACK_IMPORTED_MODULE_16_vue_select___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_17_vue_infinite_loading___default.a, {
  /* options */
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_18_vue_lazyload__["a" /* default */], {
  preLoad: 1.3,
  error: 'static/images/404.jpg',
  loading: 'static/images/loading.svg',
  attempt: 1
});
// Tell Vue to install the plugin.
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13_vuejs_dialog___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15_vue_fullscreen___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue_top_progress___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_carousel___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_bootstrap_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_v_animate_css__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_toasted___default.a, {
  iconPack: 'fontawesome' // set your iconPack, defaults to material. material|fontawesome|custom-class
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_sweetalert2__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_v_tooltip__["a" /* default */]);




__webpack_require__(214);



__WEBPACK_IMPORTED_MODULE_21__filters__["a" /* default */].forEach(function (f) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter(f.name, f.execute);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_progressbar___default.a, {
  color: 'rgb(248, 151, 5)',
  failedColor: 'red',
  height: '5px'
});

var locale = 'fr';
bus.$on('setFormLang', function (lang) {
  locale = lang;
});

// Create VueI18n instance with options
var i18n = new __WEBPACK_IMPORTED_MODULE_5_vue_i18n__["a" /* default */]({
  locale: locale, // set locale
  messages: {
    en: __WEBPACK_IMPORTED_MODULE_19__i18n_en_US_js__["a" /* default */],
    fr: __WEBPACK_IMPORTED_MODULE_20__i18n_fr_FR_js__["a" /* default */]
  }
});
/* eslint-disable no-new */
window.eventHub = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
window.generateClass = function () {
  var text = 'c';
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (var i = 0; i < 5; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin({
  methods: {
    generateClass: function generateClass() {
      var text = 'c';
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      for (var i = 0; i < 5; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text;
    }
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  i18n: i18n,
  store: __WEBPACK_IMPORTED_MODULE_6__store_index__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_en_US__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_fr_FR__ = __webpack_require__(12);






/* harmony default export */ __webpack_exports__["a"] = ({
  i18n: {
    messages: {
      en: __WEBPACK_IMPORTED_MODULE_4__i18n_en_US__["a" /* default */],
      fr: __WEBPACK_IMPORTED_MODULE_5__i18n_fr_FR__["a" /* default */]
    }
  },
  computed: {
    setChangeSaveAttr: function setChangeSaveAttr() {
      return {
        title: this.$i18n.t('tooltips.save'),
        'data-tooltip-pos': 'bottom'
      };
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('slides', ['reorderSlides']), {
    showBorders: function showBorders(panels) {
      // Show borders by default
      panels.getButton('options', 'sw-visibility').set('active', 1);
    },
    addSaveOptions: function addSaveOptions(panels) {
      var self = this;

      panels.addButton('options', {
        id: 'save-template',
        className: self.$route.name === 'segment' ? 'icon-save only-save' : 'icon-save',
        command: function command() {
          var iconSave = document.querySelector('.icon-save');
          if (iconSave.classList.contains('icon-selected')) {
            self.editor.runCommand('save-template');
          }
        },
        attributes: this.setChangeSaveAttr
      });
    },
    removeButtons: function removeButtons(panels) {
      //remove button export template
      panels.removeButton('options', { id: 'export-template' });
      //remove button import template
      panels.removeButton('options', { id: 'gjs-open-import-webpage' });
    },
    loadScreens: function loadScreens(panels) {
      panels.addPanel({
        id: 'disposition',
        visible: true
      });
    },
    loadPages: function loadPages(panels) {
      panels.addPanel({
        id: 'pages',
        visible: true,
        buttons: [{
          id: 'btn-pages',
          // active by default
          className: 'fa fa-file page-list',
          label: '',
          active: false,
          // Built-in command
          command: 'list-page-show'
        }]
      });
    },
    addPanels: function addPanels(panels) {
      var panelTop = { id: 'panel-top' };
      var panelBasicActions = {
        id: 'panel-basic'
      };
      panels.addPanel(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, panelTop, {
        el: '#panel__left'
      }));
      panels.addPanel(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, panelBasicActions, {
        el: '#panel__list-page'
      }));
    },
    addBeautifyTooltips: function addBeautifyTooltips(panels) {
      var self = this;
      // Add and beautify tooltips
      var tools = ['sw-visibility', 'preview', 'fullscreen', 'preview-screens', 'save-template', 'undo', 'redo', 'canvas-clear', 'gjs-open-import-webpage', 'export-template'];
      var blockTools = ['open-sm', 'open-layers', 'open-blocks'];
      tools.forEach(function (item) {
        if (panels.getButton('options', item)) {
          panels.getButton('options', item).set('attributes', {
            title: self.$i18n.t('tooltips.' + item),
            'data-tooltip-pos': 'bottom'
          });
        }
      });
      blockTools.forEach(function (item) {
        if (panels.getButton('views', item)) {
          panels.getButton('views', item).set('attributes', {
            title: self.$i18n.t('tooltips.' + item),
            'data-tooltip': self.$i18n.t('tooltips.' + item),
            'data-tooltip-pos': 'bottom'
          });
        }
      });
      var titles = document.querySelectorAll('*[title]');
      for (var i = 0; i < titles.length; i++) {
        var el = titles[i];
        var title = el.getAttribute('title');
        title = title ? title.trim() : '';
        if (!title) break;
        el.setAttribute('data-tooltip', title);
        el.setAttribute('title', '');
      }
    },
    scrollHorizontally: function scrollHorizontally(e) {
      e = window.event || e;
      var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
      this.$refs.ps.$el.scrollLeft -= delta * 40;
      e.preventDefault();
    },
    getList: function getList() {
      this.list = this.all;
    },
    dragSlide: function dragSlide(event, position, moduleList) {
      var allSliders = document.querySelector('.scroll-area').getBoundingClientRect();
      var cardWrapper = document.querySelector('.card-wrapper');
      if (moduleList) {
        allSliders = document.querySelector('#' + moduleList + ' .scroll-area').getBoundingClientRect();
        cardWrapper = document.querySelector('#' + moduleList + ' .card-wrapper');
      }
      if (cardWrapper) {
        var cardWidth = cardWrapper.clientWidth * 1.5;
        if (moduleList) {
          cardWidth = cardWrapper.clientWidth;
        }
        var cardPosition = event.clientX;
        if (event.originalEvent && event.originalEvent.clientX) {
          cardPosition = event.originalEvent.clientX;
        }
        var scrollToRightArea = allSliders.x + allSliders.width - cardWidth;
        var scrollToLeftArea = allSliders.x + cardWidth;
        if (cardPosition > scrollToRightArea || cardPosition < scrollToLeftArea || moduleList) {
          var delta = cardPosition > scrollToRightArea ? 1 : -1;
          var scroll = delta * 5;
          if (position) {
            delta = position;
            scroll = delta * scrollToLeftArea;
          }
          this.setScrollInterval(scroll, position);
        } else if (this.scrollInterval) {
          clearInterval(this.scrollInterval);
          this.scrollInterval = null;
        }
      }
    },
    setScrollInterval: function setScrollInterval(scroll, position) {
      var _this = this;

      if (this.scrollInterval) {
        return;
      }
      if (this.$refs.ps) {
        if (position) {
          setTimeout(function () {
            _this.$refs.ps.$el.scrollLeft += scroll;
          }, 20);
          this.$refs.ps.$el.style['scroll-behavior'] = 'smooth';
        } else {
          this.scrollInterval = setInterval(function () {
            if (_this.$refs.ps) {
              _this.$refs.ps.$el.scrollLeft += scroll;
            }
          }, 20);
        }
      }
    },
    removeSmoothing: function removeSmoothing() {
      this.$refs.ps.$el.style['scroll-behavior'] = 'auto';
    }
  })
});

/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(697)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(844),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  paramsClient: {
    client: '',
    code: '',
    show_generic_display: '0',
    show_video_intro: '0',
    display_default_urls: {
      facebook: '',
      twitter: '',
      video: '',
      youtube: '',
      linkedin: '',
      image_url: '',
      url_media: ''
    },
    display_default_blocks: [{
      name: 'Areas',
      blocks: ['column1', 'column2', 'column3', 'column3-7']
    }, {
      name: 'Text',
      blocks: ['text', 'custom-title', 'custom-sharing', 'link', 'link-block', 'quote']
    }],
    display_devices: [{
      name: 'landscape',
      className: 'icon-landscape',
      x: '70',
      y: '39.375',
      height: '39.375vw',
      width: '70vw',
      widthMedia: ''
    }, {
      name: 'portrait',
      className: 'icon-portrait',
      x: '30',
      y: '40',
      height: '40vw',
      width: '30vw',
      widthMedia: ''
    }],
    display_fonts: [{
      value: 'Corporate A BQ',
      name: 'Corporate A BQ'
    }],
    display_custom_style_manager: [{
      name: 'Disposition',
      buildProps: ['float', 'params-disposition', 'display', 'position', 'top', 'right', 'left', 'bottom'],
      properties: [{
        name: 'Alignment',
        property: 'float',
        type: 'radio',
        defaults: 'none',
        list: [{
          value: 'none',
          className: 'fa fa-times'
        }, {
          value: 'left',
          className: 'fa fa-align-left'
        }, {
          value: 'right',
          className: 'fa fa-align-right'
        }]
      }, {
        property: 'position',
        type: 'select',
        defaults: 'relative'
      }, {
        property: 'params-disposition',
        icon: ''
      }]
    }, {
      name: 'Dimension',
      open: false,
      buildProps: ['width', 'flex-width', 'height', 'params-dimension', 'max-width', 'min-height'],
      properties: [{
        property: 'params-dimension',
        icon: ''
      }, {
        name: 'Width',
        property: 'width',
        unit: '%',
        units: ['%']
      }, {
        name: 'Height',
        property: 'height',
        unit: '%',
        units: ['%']
      }, {
        name: 'Max width',
        property: 'max-width',
        unit: '%',
        units: ['%']
      }, {
        name: 'Min height',
        property: 'min-height',
        unit: '%',
        units: ['%']
      }, {
        id: 'flex-width',
        type: 'integer',
        name: 'Width',
        units: ['px', '%'],
        property: 'flex-basis',
        defaults: '50',
        toRequire: 1
      }]
    }, {
      name: 'Spacing',
      open: false,
      buildProps: ['margin', 'padding'],
      properties: [{
        property: 'margin',
        properties: [{
          name: 'Top',
          property: 'margin-top'
        }, {
          name: 'Right',
          property: 'margin-right'
        }, {
          name: 'Bottom',
          property: 'margin-bottom'
        }, {
          name: 'Left',
          property: 'margin-left'
        }]
      }, {
        property: 'padding',
        properties: [{
          name: 'Top',
          property: 'padding-top'
        }, {
          name: 'Right',
          property: 'padding-right'
        }, {
          name: 'Bottom',
          property: 'padding-bottom'
        }, {
          name: 'Left',
          property: 'padding-left'
        }]
      }]
    }, {
      name: 'Text',
      open: false,
      buildProps: ['font-family', 'font-size', 'font-weight', 'letter-spacing', 'color', 'line-height', 'text-align', 'text-decoration', 'text-shadow'],
      properties: [{
        name: 'Font size',
        property: 'font-size',
        unit: 'vw',
        units: ['vw', 'vh'],
        defaults: '1'
      }, {
        name: 'Font',
        property: 'font-family'
      }, {
        name: 'Weight',
        property: 'font-weight'
      }, {
        name: 'Font color',
        property: 'color'
      }, {
        name: 'Letter spacing',
        property: 'letter-spacing'
      }, {
        property: 'text-align',
        type: 'radio',
        defaults: 'left',
        list: [{
          value: 'left',
          name: 'Left',
          className: 'fa fa-align-left'
        }, {
          value: 'center',
          name: 'Center',
          className: 'fa fa-align-center'
        }, {
          value: 'right',
          name: 'Right',
          className: 'fa fa-align-right'
        }, {
          value: 'justify',
          name: 'Justify',
          className: 'fa fa-align-justify'
        }]
      }, {
        property: 'text-decoration',
        type: 'radio',
        defaults: 'none',
        list: [{
          value: 'none',
          name: 'None',
          className: 'fa fa-times'
        }, {
          value: 'underline',
          name: 'underline',
          className: 'fa fa-underline'
        }, {
          value: 'line-through',
          name: 'Line-through',
          className: 'fa fa-strikethrough'
        }]
      }, {
        property: 'text-shadow',
        properties: [{
          name: 'X position',
          property: 'text-shadow-h'
        }, {
          name: 'Y position',
          property: 'text-shadow-v'
        }, {
          name: 'Blur',
          property: 'text-shadow-blur'
        }, {
          name: 'Color',
          property: 'text-shadow-color'
        }]
      }]
    }, {
      name: 'Background',
      open: false,
      buildProps: ['background-color', 'background'],
      properties: [{
        property: 'background',
        properties: [{
          name: 'Image',
          property: 'background-image',
          className: 'background-image-upload'
        }, {
          name: 'Repeat',
          property: 'background-repeat',
          type: 'radio',
          defaults: 'row',
          list: [{
            value: 'repeat',
            name: 'Repeat',
            className: 'icons-layers-background icon-repeat',
            title: 'Repeat'
          }, {
            value: 'repeat-x',
            name: 'Repeat-x',
            className: 'icons-layers-background icon-repeat-x',
            title: 'Repeat-x'
          }, {
            value: 'repeat-y',
            name: 'Repeat-y',
            title: 'Repeat-y',
            className: 'icons-layers-background icon-repeat-y'
          }, {
            value: 'no-repeat',
            name: 'no-repeat',
            title: 'no-repeat',
            className: 'icons-layers-background icon-no-repeat'
          }]
        }, {
          name: 'Size',
          property: 'background-size',
          type: 'radio',
          defaults: 'row',
          list: [{
            value: 'auto',
            name: 'Auto',
            className: 'icons-layers-size icon-auto',
            title: 'Auto'
          }, {
            value: 'cover',
            name: 'Cover',
            className: 'icons-layers-size icon-cover',
            title: 'Cover'
          }, {
            value: 'contain',
            name: 'Contain',
            title: 'Contain',
            className: 'icons-layers-size icon-contain'
          }]
        }, {
          name: 'Position',
          property: 'background-position',
          type: 'radio',
          defaults: 'row',
          list: [{
            value: '0% 0%',
            name: 'left top',
            className: 'icon-background-position icon-left-top',
            title: 'En haut à gauche'
          }, {
            value: '50% 0%',
            name: 'center top',
            className: 'icon-background-position icon-center-top',
            title: 'En haut au centre'
          }, {
            value: '100% 0%',
            name: 'right top',
            className: 'icon-background-position icon-right-top',
            title: 'En haut à droite'
          }, {
            value: '0% 50%',
            name: 'left center',
            className: 'icon-background-position icon-left-center',
            title: 'Au centre à gauche'
          }, {
            value: '50% 50%',
            name: 'center center',
            className: 'icon-background-position icon-center-center',
            title: 'Au centre au centre'
          }, {
            value: '100% 50%',
            name: 'right center',
            className: 'icon-background-position icon-right-center',
            title: 'Au centre à droite'
          }, {
            value: '0% 100%',
            name: 'left bottom',
            className: 'icon-background-position icon-left-bottom',
            title: 'En bas à gauche'
          }, {
            value: '50% 100%',
            name: 'center bottom',
            className: 'icon-background-position icon-center-bottom',
            title: 'En bas au centre'
          }, {
            value: '100% 100%',
            name: 'right bottom',
            className: 'icon-background-position icon-right-bottom',
            title: 'En bas à droite'
          }]
        }, {
          name: 'Attachment',
          property: 'background-attachment'
        }]
      }]
    }, {
      name: 'Border',
      open: false,
      buildProps: []
    }, {
      name: 'Decoration',
      open: false,
      buildProps: ['opacity', 'box-shadow', 'params-decoration', 'transition', 'perspective', 'transform'],
      properties: [{
        property: 'params-decoration',
        icon: ''
      }, {
        type: 'slider',
        property: 'opacity',
        defaults: 1,
        step: 0.01,
        max: 1,
        min: 0
      }, {
        property: 'box-shadow',
        properties: [{
          name: 'X position',
          property: 'box-shadow-h'
        }, {
          name: 'Y position',
          property: 'box-shadow-v'
        }, {
          name: 'Blur',
          property: 'box-shadow-blur'
        }, {
          name: 'Spread',
          property: 'box-shadow-spread'
        }, {
          name: 'Color',
          property: 'box-shadow-color'
        }, {
          name: 'Shadow type',
          property: 'box-shadow-type'
        }]
      }, {
        property: 'transition',
        properties: [{
          name: 'Property',
          property: 'transition-property'
        }, {
          name: 'Duration',
          property: 'transition-duration'
        }, {
          name: 'Easing',
          property: 'transition-timing-function'
        }]
      }, {
        property: 'transform',
        properties: [{
          name: 'Rotate X',
          property: 'transform-rotate-x'
        }, {
          name: 'Rotate Y',
          property: 'transform-rotate-y'
        }, {
          name: 'Rotate Z',
          property: 'transform-rotate-z'
        }, {
          name: 'Scale X',
          property: 'transform-scale-x'
        }, {
          name: 'Scale Y',
          property: 'transform-scale-y'
        }, {
          name: 'Scale Z',
          property: 'transform-scale-z'
        }]
      }]
    }, {
      name: 'Responsive',
      open: false,
      properties: [{
        name: 'Flex Container',
        property: 'display',
        type: 'select',
        defaults: 'block',
        list: [{
          value: 'block',
          name: 'Disable'
        }, {
          value: 'flex',
          name: 'Enable'
        }]
      }, {
        name: 'Flex Parent',
        property: 'label-parent-flex',
        type: 'integer'
      }, {
        name: 'Direction',
        property: 'flex-direction',
        type: 'radio',
        defaults: 'row',
        list: [{
          value: 'row',
          name: 'Row',
          className: 'icons-flex icon-dir-row',
          title: 'Row'
        }, {
          value: 'row-reverse',
          name: 'Row reverse',
          className: 'icons-flex icon-dir-row-rev',
          title: 'Row reverse'
        }, {
          value: 'column',
          name: 'Column',
          title: 'Column',
          className: 'icons-flex icon-dir-col'
        }, {
          value: 'column-reverse',
          name: 'Column reverse',
          title: 'Column reverse',
          className: 'icons-flex icon-dir-col-rev'
        }]
      }, {
        name: 'Justify',
        property: 'justify-content',
        type: 'radio',
        defaults: 'flex-start',
        list: [{
          value: 'flex-start',
          className: 'icons-flex icon-just-start',
          title: 'Start'
        }, {
          value: 'flex-end',
          title: 'End',
          className: 'icons-flex icon-just-end'
        }, {
          value: 'space-between',
          title: 'Space between',
          className: 'icons-flex icon-just-sp-bet'
        }, {
          value: 'space-around',
          title: 'Space around',
          className: 'icons-flex icon-just-sp-ar'
        }, {
          value: 'center',
          title: 'Center',
          className: 'icons-flex icon-just-sp-cent'
        }]
      }, {
        name: 'Align',
        property: 'align-items',
        type: 'radio',
        defaults: 'center',
        list: [{
          value: 'flex-start',
          title: 'Start',
          className: 'icons-flex icon-al-start'
        }, {
          value: 'flex-end',
          title: 'End',
          className: 'icons-flex icon-al-end'
        }, {
          value: 'stretch',
          title: 'Stretch',
          className: 'icons-flex icon-al-str'
        }, {
          value: 'center',
          title: 'Center',
          className: 'icons-flex icon-al-center'
        }]
      }, {
        name: 'Flex Children',
        property: 'label-parent-flex',
        type: 'integer'
      }, {
        name: 'Order',
        property: 'order',
        type: 'integer',
        defaults: 0,
        min: 0
      }, {
        name: 'Flex',
        property: 'flex',
        type: 'composite',
        properties: [{
          name: 'Grow',
          property: 'flex-grow',
          type: 'integer',
          defaults: 0,
          min: 0
        }, {
          name: 'Shrink',
          property: 'flex-shrink',
          type: 'integer',
          defaults: 0,
          min: 0
        }, {
          name: 'Basis',
          property: 'flex-basis',
          type: 'integer',
          units: ['px', '%', ''],
          unit: '',
          defaults: 'auto'
        }]
      }, {
        name: 'Align',
        property: 'align-self',
        type: 'radio',
        defaults: 'auto',
        list: [{
          value: 'auto',
          name: 'Auto'
        }, {
          value: 'flex-start',
          title: 'Start',
          className: 'icons-flex icon-al-start-flex'
        }, {
          value: 'flex-end',
          title: 'End',
          className: 'icons-flex icon-al-end-flex'
        }, {
          value: 'stretch',
          title: 'Stretch',
          className: 'icons-flex icon-al-str-flex'
        }, {
          value: 'center',
          title: 'Center',
          className: 'icons-flex icon-al-center-flex'
        }]
      }]
    }]
  },
  permissions: []
};
// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
var mutations = {
  pushParamsClient: function pushParamsClient(state, Params) {
    state.paramsClient = Params;
  },
  setPermissions: function setPermissions(state, modules) {
    state.permissions = modules;
  },
  setUrlMedia: function setUrlMedia(state, urlMedia) {
    state.paramsClient.display_default_urls.url_media = urlMedia;
  }
};

// actions are functions that cause side effects and can involve
// asynchronous operations.
var actions = {
  pushParamsClient: function pushParamsClient(_ref, Params) {
    var state = _ref.state,
        commit = _ref.commit;
    return commit('pushParamsClient', Params);
  },
  setPermissions: function setPermissions(_ref2, modules) {
    var state = _ref2.state,
        commit = _ref2.commit;
    return commit('setPermissions', modules);
  },
  setUrlMedia: function setUrlMedia(_ref3, urlMedia) {
    var state = _ref3.state,
        commit = _ref3.commit;
    return commit('setUrlMedia', urlMedia);
  }
};

// getters are functions
var getters = {
  /**
   * Get
   */
  getParamsClients: function getParamsClients(state) {
    return state.paramsClient;
  },
  hasPermission: function hasPermission(state) {
    return function (permissions) {
      return permissions.split(',').some(function (v) {
        return state.permissions[v];
      });
    };
  },
  getPermissions: function getPermissions(state) {
    return state.permissions;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(698)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(845),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9609ab20",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  base_url: '',
  routes: {
    api_media_get_media: {
      tokens: [['text', '/media/medias/list']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_get_live_pagination: {
      tokens: [['text', '/lives/Lives-pagination-grape']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_templateDisplay_post_screen_shot_html: {
      tokens: [['text', '/templateDisplay/screen-shot-html']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_screenDisplay_get_screen: {
      tokens: [['text', '/screenDisplay/get-one/']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_templateDisplay_get_template: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/templateDisplay/get-one-template']],
      defaults: [],
      requirements: {
        id: '\\d+'
      },
      hosttokens: []
    },
    api_programDisplay_get_params_display: {
      tokens: [['text', '/programDisplay/params-display']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_screenDisplay_post_add_edit_screen: {
      tokens: [['text', '/screenDisplay/add-edit']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_get_list_playlists_pagination: {
      tokens: [['text', '/playlist/list-pagination']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },

    api_templateDisplay_post_add_edit_template: {
      tokens: [['text', '/templateDisplay/add-edit-template']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_bloc_post_thumb: {
      tokens: [['text', '/bloc/upload/thumb']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_bloc_get_images_stored: {
      tokens: [['text', '/video-api/bloc/stored/images']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_screenDisplay_get_existant_screen: {
      tokens: [['text', '/screenDisplay/screen-existance']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_screenDisplay_check_existence_disposition: {
      tokens: [['text', '/screenDisplay/disposition-existence']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_screenDisplay_get_all_disposition: {
      tokens: [['text', '/screenDisplay/list-dispositions']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_screenDisplay_edit_title_disposition: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/screenDisplay/edit-title-disposition']],
      defaults: [],
      requirements: {
        id: '\\d+'
      },
      hosttokens: []
    },
    api_screenDisplay_post_edit_screen: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/screenDisplay/edit-screen-title']],
      defaults: [],
      requirements: {
        id: '\\d+'
      },
      hosttokens: []
    },
    api_templateDisplay_get_templates_by_rmbox: {
      tokens: [['variable', '/', '[^/]++', 'idRmbox'], ['text', '/templateDisplay/templates-by-rmbox']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_templateDisplay_get_templates_by_program: {
      tokens: [['variable', '/', '[^/]++', 'idProgram'], ['text', '/templateDisplay/templates-by-program']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_segmentDisplay_post_add_segment: {
      tokens: [['text', '/segmentDisplay/add']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_segmentDisplay_get_list_segments: {
      tokens: [['text', '/segmentDisplay/list-segments']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_segmentDisplay_post_edit_title_segment: {
      tokens: [['variable', '/', 'd+', 'id'], ['text', '/segmentDisplay/edit-segment-title']],
      defaults: [],
      requirements: {
        id: 'd+'
      },
      hosttokens: []
    },
    api_log: {
      tokens: [['text', '/global/log']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_templateDisplay_get_template_urls: {
      tokens: [['variable', '/', 'd+', 'id'], ['text', '/templateDisplay/get-template-urls']],
      defaults: [],
      requirements: {
        id: 'd+'
      },
      hosttokens: []
    },
    api_media_get_contributors: {
      tokens: [['text', '/video/videos/contributors/list']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_parameters_get_themes: {
      tokens: [['text', '/theme']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_segmentDisplay_delete_one: {
      tokens: [['variable', '/', 'd+', 'id'], ['text', '/segmentDisplay/delete-segment']],
      defaults: [],
      requirements: {
        id: 'd+'
      },
      hosttokens: []
    },
    api_segmentDisplay_post_duplicate_segment: {
      tokens: [['variable', '/', 'd+', 'id'], ['text', '/segmentDisplay/duplicate-segment']],
      defaults: [],
      requirements: {
        id: 'd+'
      },
      hosttokens: []
    },
    api_parameters_get_themes_children_per_canal: {
      tokens: [['text', '/theme/themes-children-per-canal']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_segmentDisplay_get_one_segments: {
      tokens: [['variable', '/', 'd+', 'id'], ['text', '/segmentDisplay/one-segment']],
      defaults: [],
      requirements: {
        id: 'd+'
      },
      hosttokens: []
    }

    /*Todo add api routing playlist*/
  },
  prefix: '',
  host: 'localhost',
  scheme: 'http'
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  base_url: '',
  routes: {
    api_media_get_media: {
      tokens: [['text', '/media/medias/list']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_get_live_pagination: {
      tokens: [['text', '/lives/Lives-pagination-grape']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_templateDisplay_post_screen_shot_html: {
      tokens: [['text', '/templateDisplay/screen-shot-html']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_screenDisplay_get_screen: {
      tokens: [['text', '/screenDisplay/get-one/']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_templateDisplay_get_template: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/templateDisplay/get-one']],
      defaults: [],
      requirements: {
        id: '\\d+'
      },
      hosttokens: []
    },
    api_programDisplay_get_params_display: {
      tokens: [['text', '/programDisplay/params-display']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_screenDisplay_post_add_edit_screen: {
      tokens: [['text', '/screenDisplay/add-edit']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_get_list_playlists_pagination: {
      tokens: [['text', '/playlist/list-pagination']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },

    api_templateDisplay_post_add_edit_template: {
      tokens: [['text', '/templateDisplay/add-edit']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_bloc_post_thumb: {
      tokens: [['text', '/bloc/upload/thumb']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_bloc_get_images_stored: {
      tokens: [['text', '/video-api/bloc/stored/images']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_screenDisplay_get_existant_screen: {
      tokens: [['text', '/screenDisplay/screen-existance']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_screenDisplay_check_existence_disposition: {
      tokens: [['text', '/screenDisplay/disposition-existence']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_screenDisplay_get_all_disposition: {
      tokens: [['text', '/screenDisplay/list-dispositions']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_screenDisplay_edit_title_disposition: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/screenDisplay/edit-title-disposition']],
      defaults: [],
      requirements: {
        id: '\\d+'
      },
      hosttokens: []
    },
    api_screenDisplay_post_edit_screen: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/screenDisplay/edit-screen-title']],
      defaults: [],
      requirements: {
        id: '\\d+'
      },
      hosttokens: []
    },
    api_templateDisplay_get_templates_by_rmbox: {
      tokens: [['text', '.json'], ['variable', '/', '[^/]++', 'idRmbox'], ['text', '/templateDisplay/templates-by-rmbox']],
      defaults: [],
      requirements: [],
      hosttokens: []
    },
    api_templateDisplay_get_templates_by_program: {
      tokens: [['text', '.json'], ['variable', '/', '[^/]++', 'idProgram'], ['text', '/templateDisplay/templates-by-program']],
      defaults: [],
      requirements: [],
      hosttokens: []
    }
    /*Todo add api routing playlist*/
  },
  prefix: '',
  host: 'localhost',
  scheme: 'http'
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    canvasSize: 'common/getCanvasSize',
    deviceType: 'common/getDeviceType',
    paramsClient: 'getParamsClients'
  })),
  methods: {
    postcss: function postcss(css, orientation) {
      var _this = this;

      var mode = {};
      if (this.paramsClient.display_devices !== null || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.paramsClient.display_devices).length > 0) {
        var nameDevices = this.paramsClient.display_devices.map(function (item) {
          return item.name;
        });
        var widthDevice = this.paramsClient.display_devices.map(function (item) {
          return item.width;
        });

        this.paramsClient.display_devices.forEach(function (item, index) {
          mode = _this.addToObject(mode, nameDevices[index], widthDevice[index]);
        });

        var orientationMode = mode[orientation] ? mode[orientation] : mode[__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(mode)[0]];
        var unitCss = innerWidth * parseFloat(orientationMode.replace('vw', '')) / 100 / 100;
        css = this.fontSizeToVw(css);

        if (this.paramsClient.display_devices && this.paramsClient.display_devices[0] && !!!this.paramsClient.display_devices[0].fixedSize) {
          css = this.fontSizePtTovw(css);
        }
        css = this.fontSizeEmTovw(css);
        css = this.widthHeightToViewport(css, true);

        return css ? css.replace(/[\d.]+vw/g, function (val) {
          return unitCss * parseFloat(val) + 'px';
        }) : "";
      }
    },
    addToObject: function addToObject(obj, key, value, index) {
      var temp = {};
      var i = 0;
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          if (i === index && key && value) {
            temp[key] = value;
          }
          temp[prop] = obj[prop];
          i++;
        }
      }
      if (!index && key && value) {
        temp[key] = value;
      }
      return temp;
    },
    fontSizeToVw: function fontSizeToVw(css) {
      var unitCss = this.canvasSize.width / 100;
      return css.replace(/font-size:((\d)+\.?(\d)*)px/g, function (val) {
        var newVal = parseFloat(val.replace('font-size:', '').replace('px', ''));
        return 'font-size:' + newVal / unitCss + 'vw';
      });
    },
    fontSizePtTovw: function fontSizePtTovw(css) {
      var unitCss = this.canvasSize.width / 100;
      return css.replace(/font-size:((\d)+\.?(\d)*)pt/g, function (val) {
        var Val = parseFloat(val.replace('font-size:', '').replace('pt', ''));
        var newVal = Val / (3 / 4);
        return 'font-size:' + newVal / unitCss + 'vw';
      });
    },
    fontSizeEmTovw: function fontSizeEmTovw(css) {
      // this for  height Filet in  preview
      var unitCss = this.canvasSize.width / 100;
      return css.replace(/height:((\d)+\.?(\d)*)em/g, function (val) {
        var Val = parseFloat(val.replace('height:', '').replace('em', ''));
        var newVal = Val * 16;
        return 'height:' + newVal / unitCss + 'vw';
      });
    },
    widthHeightToViewport: function widthHeightToViewport(css, isPreviewMode) {
      var _this2 = this;

      //TODO should be dynamic
      var devices = {};
      if (this.paramsClient.display_devices !== null || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.paramsClient.display_devices).length > 0) {
        var nameDevices = this.paramsClient.display_devices.map(function (item) {
          return item.name;
        });
        var widthDevice = this.paramsClient.display_devices.map(function (item) {
          return item.width;
        });
        var heightDevice = this.paramsClient.display_devices.map(function (item) {
          return item.height;
        });

        this.paramsClient.display_devices.forEach(function (item, index) {
          var sizeDevices = {
            w: widthDevice[index],
            h: heightDevice[index]
          };
          devices = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(devices, _this2.addToObject({}, nameDevices[index], sizeDevices));
        });

        var deviceType = devices[this.deviceType] ? devices[this.deviceType] : devices[__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(devices)[0]];
        var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        var offsetWidth = w * (isPreviewMode ? deviceType.w : 100) / 100;
        var offsetHeight = w * (isPreviewMode ? deviceType.h : 100 * h / w) / 100;
        var prop = { w: offsetWidth / w, h: offsetHeight / h };
        return css.replace(/(height|width):\d+\.?\d*px/g, function (val) {
          return val.replace('px', 'v' + val.charAt(0)).replace(/\d+\.?\d*/g, function (v) {
            return v / _this2.canvasSize[val.split(':')[0]] * 100 * prop[val.charAt(0)];
          });
        });
      }
    }
  }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_router_router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_http_http_token__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_http_http_file_common__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_index_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_paramsClient_data_js__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_modules_route_data_js__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_modules_common_data_js__ = __webpack_require__(231);









var self = this;
var urlParams = new URLSearchParams(window.location.search);
var lang = urlParams.get('lang') ? urlParams.get('lang') : 'fr';
__WEBPACK_IMPORTED_MODULE_3__i18n_index_js__["a" /* default */].locale = lang;
var storage_init = {
  i18n: {
    locale: 'fr',
    messages: {
      fr: {

        // Here just as a reference, GrapesJS core doesn't contain any block,
        // so this should be omitted from other local files
        blockManager: {
          labels: {
            // 'block-id': 'Block Label',
          },
          categories: {
            // 'category-id': 'Category Label',
          }
        },
        domComponents: {
          names: {
            '': 'Box',
            wrapper: 'Body',
            text: 'Text',
            comment: 'Comment',
            image: 'Image',
            video: 'Video',
            label: 'Label',
            link: 'Link',
            map: 'Map',
            tfoot: 'Table foot',
            tbody: 'Table body',
            thead: 'Table head',
            table: 'Table',
            row: 'Table row',
            cell: 'Table cell'
          }
        },
        deviceManager: {
          device: 'Device',
          devices: {
            desktop: 'Desktop',
            tablet: 'Tablet',
            mobileLandscape: 'Mobile Landscape',
            mobilePortrait: 'Mobile Portrait'
          }
        },
        panels: {
          buttons: {
            titles: {
              preview: 'Aperçu',
              fullscreen: 'Plein écran',
              'sw-visibility': 'View components',
              'open-tm': 'Paramètres',
              'open-sm': 'Gestionnaire de style',
              'open-layers': 'Layers',
              'open-blocks': 'Blocs'
            }
          }
        },
        selectorManager: {
          label: 'Classes',
          selected: 'Selected',
          emptyState: '- State -',
          states: {
            hover: 'Hover',
            active: 'Click',
            'nth-of-type(2n)': 'Even/Odd'
          }
        },
        styleManager: {
          empty: 'Sélectionnez un élément avant d\'utiliser le Gestionnaire de styles',
          layer: 'Layer',
          fileButton: 'Images',
          sectors: {
            general: 'General',
            layout: 'Layout',
            typography: 'Typography',
            decorations: 'Decorations',
            extra: 'Extra',
            flex: 'Flex',
            dimension: 'Dimension'
          },
          // The core library generates the name by their `property` name
          properties: {
            // float: 'Float',
          }
        },
        traitManager: {
          empty: 'Sélectionnez un élément avant d\'utiliser Trait Manager',
          label: 'Component settings',
          traits: {
            // The core library generates the name by their `name` property
            labels: {
              // id: 'Id',
              // alt: 'Alt',
              // title: 'Title',
              // href: 'Href',
            },
            // In a trait like select, these are used to translate option names
            options: {
              target: {
                false: 'This window',
                _blank: 'New window'
              }
            }
          }
        }
      }
    }
  },
  height: '100%',
  container: '#gjs',
  style: '',
  protectedCss: '.gjs-hovered{width: unsetnone;height: unsetnone;}[data-class="custom-credit"], .custom-credit{z-index: 9999!important ; font-size: 20pt;font-family:  Din Regular ;  left: 0%!important; bottom: 1%!important; top: auto!important; text-align: center;padding: 10px 0.2em;color: #252e63;    width: auto!important; height: auto!important;  }[data-rotation="vertical"]{writing-mode: vertical-rl;text-orientation: mixed;transform: rotate(-180deg);}div[data-class="custom-sharing"]{  font-family:  Din Bold !important; }video{background-color: black;}[emp-data-class="emp-text"]{ color: #252e63; }[data-gjs-type="countdown"]{padding: 0.2em;}[data-gjs-type="filet"]{ left: 50% !important;} a:-webkit-any-link {color: inherit !important; text-decoration: none !important;}p{margin:0}a {pointer-events:none;} span[data-cke-magic-line] {\n' + '    display: none!important;\n' + '}',
  fromElement: 1,
  showOffsets: 0,
  assetManager: {
    uploadText: __WEBPACK_IMPORTED_MODULE_3__i18n_index_js__["a" /* default */].t('blocks.drop_files'),
    modalTitle: __WEBPACK_IMPORTED_MODULE_3__i18n_index_js__["a" /* default */].t('blocks.select_image'),
    embedAsBase64: 1,
    uploadFile: function uploadFile(e) {
      var files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
      for (var i in files) {
        var formData = new FormData();
        formData.append('empApiFileForm[thumb]', files[i]); //containing all the selected images from local
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_http_http_file_common__["a" /* HTTP_FILES */])(window.ApiToken).post(__WEBPACK_IMPORTED_MODULE_0__core_router_router__["a" /* default */].generate('api_bloc_post_thumb'), formData).then(function (response) {
          if (response && response.data && response.data.code == 200) {
            var image = response.data.location.url;
            for (i = 0; i < grapesjs.editors.length; i++) {
              grapesjs.editors[i].AssetManager.add(image);
            }
          }
        }, function (response) {
          //self.hideLoader();
        });
      }
    },
    assets: []
  },
  richTextEditor: {
    autoEdit: false
  },
  tagVarStart: '{[ ',
  tagVarEnd: ' ]}',
  plugins: ['gjs-preset-webpage', 'grapesjs-lory-slider', 'display-facebook-plugin', 'display-linkedin-plugin', 'display-rss-plugin', 'display-web-plugin', 'display-playlist-plugin', 'display-player-plugin', 'display-live-plugin', 'display-twitter-plugin', 'display-weather-plugin', 'display-filet-plugin', 'display-clock-plugin', 'display-webrtc-plugin', 'display-ticker-plugin', 'display-dateHeure-plugin', 'display-image-plugin', 'display-player-mp4-plugin', 'display-social-media-plugin', 'display-pattern-plugin'],
  pluginsOpts: {
    'grapesjs-lory-slider': {
      sliderBlock: {
        category: 'Extra'
      }
    },
    'gjs-preset-webpage': {
      modalImportTitle: 'Import Template',
      modalImportLabel: '<div style="margin-bottom: 10px; font-size: 13px;">' + __WEBPACK_IMPORTED_MODULE_3__i18n_index_js__["a" /* default */].t('past_css') + '</div>',
      modalImportContent: function modalImportContent(editor) {
        return editor.getHtml() + '<style>' + editor.getCss() + '</style>';
      },
      filestackOpts: { key: 'AYmqZc2e8RLGLE7TGkX3Hz' },
      aviaryOpts: false,
      countdownOpts: {
        startTime: '2020-12-12 00:00',
        labelCountdownCategory: 'Widget',
        endText: __WEBPACK_IMPORTED_MODULE_3__i18n_index_js__["a" /* default */].t('blocks.endText'),
        labelDays: __WEBPACK_IMPORTED_MODULE_3__i18n_index_js__["a" /* default */].t('blocks.labelDays'),
        labelHours: __WEBPACK_IMPORTED_MODULE_3__i18n_index_js__["a" /* default */].t('blocks.labelHours'),
        labelMinutes: __WEBPACK_IMPORTED_MODULE_3__i18n_index_js__["a" /* default */].t('blocks.labelMinutes'),
        labelSeconds: __WEBPACK_IMPORTED_MODULE_3__i18n_index_js__["a" /* default */].t('blocks.labelSeconds'),
        defaultStyle: false
      },
      blocksBasicOpts: { flexGrid: 1 },
      customStyleManager: []
    },

    'display-player-plugin': {
      api_routing: 'api_media_get_media',
      http: __WEBPACK_IMPORTED_MODULE_1__core_http_http_token__["a" /* HTTP */],
      routing: __WEBPACK_IMPORTED_MODULE_0__core_router_router__["a" /* default */],
      client: __WEBPACK_IMPORTED_MODULE_4__store_modules_paramsClient_data_js__["a" /* default */].state,
      translate: __WEBPACK_IMPORTED_MODULE_3__i18n_index_js__["a" /* default */].t('display-player-plugin')
    },
    'display-image-plugin': {
      api_params_display: 'api_programDisplay_get_params_display',
      http: __WEBPACK_IMPORTED_MODULE_1__core_http_http_token__["a" /* HTTP */],
      routing: __WEBPACK_IMPORTED_MODULE_0__core_router_router__["a" /* default */],
      route: __WEBPACK_IMPORTED_MODULE_5__store_modules_route_data_js__["a" /* default */].state,
      translate: __WEBPACK_IMPORTED_MODULE_3__i18n_index_js__["a" /* default */].t('display-image-plugin')
    },
    'display-pattern-plugin': {
      api_params_display: 'api_programDisplay_get_params_display',
      http: __WEBPACK_IMPORTED_MODULE_1__core_http_http_token__["a" /* HTTP */],
      routing: __WEBPACK_IMPORTED_MODULE_0__core_router_router__["a" /* default */],
      route: __WEBPACK_IMPORTED_MODULE_5__store_modules_route_data_js__["a" /* default */].state,
      translate: __WEBPACK_IMPORTED_MODULE_3__i18n_index_js__["a" /* default */].t('display-pattern-plugin')
    },
    'display-social-media-plugin': {
      route: __WEBPACK_IMPORTED_MODULE_4__store_modules_paramsClient_data_js__["a" /* default */].state
    },
    'display-player-mp4-plugin': {
      api_routing: 'api_media_get_media',
      http: __WEBPACK_IMPORTED_MODULE_1__core_http_http_token__["a" /* HTTP */],
      routing: __WEBPACK_IMPORTED_MODULE_0__core_router_router__["a" /* default */],
      client: __WEBPACK_IMPORTED_MODULE_4__store_modules_paramsClient_data_js__["a" /* default */].state,
      translate: __WEBPACK_IMPORTED_MODULE_3__i18n_index_js__["a" /* default */].t('display-player-plugin')
    },
    'display-live-plugin': {
      api_routing_live: 'api_get_live_pagination',
      http: __WEBPACK_IMPORTED_MODULE_1__core_http_http_token__["a" /* HTTP */],
      routing: __WEBPACK_IMPORTED_MODULE_0__core_router_router__["a" /* default */],
      client: __WEBPACK_IMPORTED_MODULE_4__store_modules_paramsClient_data_js__["a" /* default */].state,
      translate: __WEBPACK_IMPORTED_MODULE_3__i18n_index_js__["a" /* default */].t('blocks.select_video')
    },

    'display-facebook-plugin': { state: __WEBPACK_IMPORTED_MODULE_4__store_modules_paramsClient_data_js__["a" /* default */].state },
    'display-twitter-plugin': { state: __WEBPACK_IMPORTED_MODULE_4__store_modules_paramsClient_data_js__["a" /* default */].state },
    'display-linkedin-plugin': { state: __WEBPACK_IMPORTED_MODULE_4__store_modules_paramsClient_data_js__["a" /* default */].state },

    /*Todo change api routing playlist*/
    'display-playlist-plugin': {
      api_routing_playlist: 'api_get_list_playlists_pagination',
      http: __WEBPACK_IMPORTED_MODULE_1__core_http_http_token__["a" /* HTTP */],
      routing: __WEBPACK_IMPORTED_MODULE_0__core_router_router__["a" /* default */],
      client: __WEBPACK_IMPORTED_MODULE_4__store_modules_paramsClient_data_js__["a" /* default */].state,
      translate: __WEBPACK_IMPORTED_MODULE_3__i18n_index_js__["a" /* default */].t('blocks.select_video')
    },
    'display-weather-plugin': {
      translate: __WEBPACK_IMPORTED_MODULE_3__i18n_index_js__["a" /* default */].t('display-weather-plugin')
    },
    'display-clock-plugin': {
      translate: __WEBPACK_IMPORTED_MODULE_3__i18n_index_js__["a" /* default */].t('display-clock-plugin')
    },
    'display-dateHeure-plugin': {
      translate: __WEBPACK_IMPORTED_MODULE_3__i18n_index_js__["a" /* default */].t('display-clock-plugin')
    },
    'display-ticker-plugin': {
      translate: __WEBPACK_IMPORTED_MODULE_3__i18n_index_js__["a" /* default */].t('display-ticker-plugin')
    }
  },
  storageManager: {
    id: 'gjs-', // Prefix identifier that will be used inside storing and loading
    type: 'local', // Type of the storage
    autosave: true, // Store data automatically
    autoload: true, // Autoload stored data on init
    stepsBeforeSave: 1, // If autosave enabled, indicates how many changes are necessary before store method is triggered
    storeComponents: true, // Enable/Disable storing of components in JSON format
    storeStyles: true, // Enable/Disable storing of rules/style in JSON format
    storeHtml: true, // Enable/Disable storing of components as HTML string
    storeCss: true // Enable/Disable storing of rules/style as CSS string
  },
  styleManager: {
    textNoElement: "Sélectionner un élément avant d'utiliser le Gestionnaire de styles"
  },
  canvas: {
    customBadgeLabel: function customBadgeLabel(c) {
      try {
        if (c.attributes.attributes['data-class'] == 'custom-sharing') return 'Link';
        if (c.attributes.attributes['data-class'] == 'custom-title') return 'Title';
        if (c.attributes.attributes['data-class'] == 'custom-credit') return 'Credit';
      } catch (e) {
        return c.getName();
      }
      return c.getName();
    },
    scripts: ['display/plugins/ticker/jquery.min.js', 'display/plugins/ticker/ticker.min.js', 'display/static/js/mouse-events.js', 'display/static/js/froogaloop2.min.js'],
    styles: ['display/plugins/ticker/ticker.css', 'display/plugins/clock/clock.css', 'display/plugins/weather/weather.css',
    // Police d'icônes des cartes pays du widget météo (glyphe .pays-icon-fr).
    // Sans elle le bloc carte s'effondre (hauteur 0) et décale la température.
    'display/static/css/pays-icon.css', 'display/static/css/fonts.css', 'display/static/css/text-animation.css', 'display/static/css/countdown.css', 'display/plugins/dateHeure/dateHeure.css', 'display/static/socialMedia.css', 'display/plugins/weather/weather.css']
  }
};
/* harmony default export */ __webpack_exports__["a"] = (storage_init);

/***/ }),
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

/***/ }),
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(689)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(836),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5542424c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 211 */,
/* 212 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var filters = [{
  name: 'FormatTime',
  execute: function execute(value) {
    if (value != null) {
      var hours = Math.floor(value / 3600);
      value %= 3600;
      var minutes = Math.floor(value / 60);
      var seconds = value % 60;
      var addZero = function addZero(v) {
        return v < 10 ? '0' + v : v;
      };
      var t = [];

      t.push(addZero(hours));
      t.push(addZero(minutes));
      t.push(addZero(seconds));

      while (+t[0] === 0 && t.length > 1) {
        t.shift();
      }
      return t.length === 1 ? t[0] + 's' : t.join(':');
    }
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (filters);

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-undef */
window.grapesjs = __webpack_require__(16);
__webpack_require__(712);
__webpack_require__(711);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_screens_data_js__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_segments_data_js__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_grapes_data_js__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_images_data_js__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_players_data_js__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_dispositions_data_js__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_paramsClient_data_js__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_route_data_js__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_slides_data_js__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_common_data_js__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_player__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_medias_data_js__ = __webpack_require__(446);
















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    player: __WEBPACK_IMPORTED_MODULE_12__modules_player__["a" /* default */],
    slides: __WEBPACK_IMPORTED_MODULE_10__modules_slides_data_js__["a" /* default */],
    common: __WEBPACK_IMPORTED_MODULE_11__modules_common_data_js__["a" /* default */],
    grapes: __WEBPACK_IMPORTED_MODULE_4__modules_grapes_data_js__["a" /* default */],
    screens: __WEBPACK_IMPORTED_MODULE_2__modules_screens_data_js__["a" /* default */],
    segments: __WEBPACK_IMPORTED_MODULE_3__modules_segments_data_js__["a" /* default */],
    dispositions: __WEBPACK_IMPORTED_MODULE_7__modules_dispositions_data_js__["a" /* default */],
    imagesData: __WEBPACK_IMPORTED_MODULE_5__modules_images_data_js__["a" /* default */],
    playersData: __WEBPACK_IMPORTED_MODULE_6__modules_players_data_js__["a" /* default */],
    paramsClientData: __WEBPACK_IMPORTED_MODULE_8__modules_paramsClient_data_js__["a" /* default */],
    routeData: __WEBPACK_IMPORTED_MODULE_9__modules_route_data_js__["a" /* default */],
    medias: __WEBPACK_IMPORTED_MODULE_13__modules_medias_data_js__["a" /* default */]
  },
  strict: debug
}));

/***/ }),
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = HTTP_FILES;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


// Force the API host to https so CORS preflight requests are not redirected
// (http://  or protocol-relative //  -> https://). A redirect on a preflight
// request is rejected by the browser.
function toHttps(host) {
  if (!host) return host;
  return host.trim().replace(/^http:\/\//i, 'https://').replace(/^\/\//, 'https://');
}

function HTTP_FILES(token) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    baseURL: toHttps(window.process.env.API_HOST_GLOBAL),
    headers: {
      Authorization: token,
      'Content-Type': 'multipart/form-data'
    }
  });
}

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HTTP_GO */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


function HTTP_GO(token) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    baseURL: "undefined",
    headers: {
      Authorization: token
    }
  });
}

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateSegmentsTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

var getSortedSlides = function getSortedSlides(segments) {
  var slides = [];
  segments.forEach(function (segment) {
    slides.push.apply(slides, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(segment.screens));
  });
  return slides;
};

var updateSegmentsTransition = function updateSegmentsTransition(segments) {
  var slides = getSortedSlides(segments);
  slides.forEach(function (s, i) {
    if (i > 0) {
      if (s.transition.in.includes('-in')) {
        slides[i - 1].transition.out = s.transition.in.replace('-in', '-out');
      } else {
        slides[i - 1].transition.out = '';
      }
    }
  });

  return segments.map(function (segment) {
    segment.screens = segment.screens.map(function (screen) {
      screen.transition.out = slides.find(function (s) {
        return s.uid === screen.uid;
      }).transition.out;
      return screen;
    });
    return segment;
  });
};



/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    updateStyleClassElement: function updateStyleClassElement(style, classe) {
      var cssComposer = grapesjsEMP.editors[0].CssComposer;
      if (grapesjsEMP.editors[0] && grapesjsEMP.editors[0].getSelected()) {
        var classes = grapesjsEMP.editors[0].getSelected().getAttributes().class;
        if (classes) {
          classes = classes.split(' ');
          if (classes && classes[0]) {
            var oldStyle = cssComposer.getClassRule(classes[0]).attributes.style;
            var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, oldStyle, style);
            var rule = cssComposer.setClassRule(classes[0], newStyle);
            this.$root.$emit('change-opacity', style['opacity'] * 100);
          } else {
            grapesjsEMP.editors[0].getSelected().addClass(classe);
            cssComposer.setClassRule(classe, style);
          }
        }
      }
    },
    addStyleClassElement: function addStyleClassElement(style, classe) {
      var cssComposer = grapesjsEMP.editors[0].CssComposer;
      if (grapesjsEMP.editors[0] && grapesjsEMP.editors[0].getSelected()) {
        grapesjsEMP.editors[0].getSelected().addClass(classe);
        cssComposer.setClassRule(classe, style);
      }
    },
    removeStyleClassElement: function removeStyleClassElement(prefix_class) {
      if (grapesjsEMP.editors[0] && grapesjsEMP.editors[0].getSelected()) {
        var classes = grapesjsEMP.editors[0].getSelected().getAttributes().class;
        if (classes) {
          classes = classes.split(' ');
          classes.forEach(function (classe) {
            if (classe.indexOf(prefix_class) >= 0) {
              grapesjsEMP.editors[0].getSelected().removeClass(classe);
            }
          });
        }
      }
    },
    updateClassGrapesElement: function updateClassGrapesElement(classElement) {
      var selected = grapesjsEMP.editors[0].getSelected();
      selected.addAttributes({ 'data-animation': 'fragment ' + classElement });
      selected.addAttributes({ animation: 'start' });
    },
    updateDelayGrapesElement: function updateDelayGrapesElement(delay) {
      if (grapesjsEMP.editors[0] && grapesjsEMP.editors[0].getSelected()) {
        var attributesElement = grapesjsEMP.editors[0].getSelected().getAttributes();
        var attributeDelay = { 'data-autoslide': delay, value: delay };
        var attributes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributesElement, attributeDelay);
        grapesjsEMP.editors[0].getSelected().set('attributes', attributes);
      }
    },
    hasClassRegexSelectedElement: function hasClassRegexSelectedElement(initClass) {
      var hasClass = false;
      if (grapesjsEMP.editors[0] && grapesjsEMP.editors[0].getSelected()) {
        var classes = grapesjsEMP.editors[0].getSelected().getAttributes().class;
        if (classes) {
          classes = classes.split(' ');
          if (classes && classes[0]) {
            classes.forEach(function (classe) {
              if (classe.indexOf(initClass) >= 0) {
                hasClass = true;
              }
            });
          }
        }
      }
      return hasClass;
    },
    getZIndexCurrentSlide: function getZIndexCurrentSlide() {
      var empZIndex = 0;
      if (grapesjsEMP.editors[0] && grapesjsEMP.editors[0].getSelected()) {
        var classes = grapesjsEMP.editors[0].getSelected().getAttributes().class;
        if (classes) {
          classes = classes.split(' ');
          if (classes && classes[0]) {
            classes.forEach(function (classe) {
              if (classe.indexOf('emp-z-index-') >= 0) {
                empZIndex = classe.substring(12);
              }
            });
          }
        }
      }
      return empZIndex;
    },
    getAllComponets: function getAllComponets() {
      return grapesjsEMP.editors[0].DomComponents.getComponents().models;
    }
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return countdownRef; });
var countdownRef = 'custom-countdown';

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var domc = editor.DomComponents;
  var defaultType = domc.getType('default');
  var defaultModel = defaultType.model;
  var defaultView = defaultType.view;
  var modal = null;
  var self;
  domc.addType('image_media', {
    model: defaultModel.extend({
      defaults: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, defaultModel.prototype.defaults, {
        'custom-name': 'image',
        config: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config),
        tagName: 'div',
        src: '',
        width: '100%',
        height: '100%'
      }),
      toHTML: function toHTML() {
        return this.view && this.view.el.getAttribute('data-gjs-type') === 'image_media' ? this.view.el.outerHTML : '';
      },
      isComponent: function isComponent(el) {
        var result = '';
        if (el.tagName === 'div') {
          result = { type: 'image_media', src: el.src };
        }
        return result;
      }
    }, {
      isComponent: function isComponent(el) {
        var result = '';
        if (el.tagName === 'div') {
          result = { type: 'image_media', src: el.src };
        }
        return result;
      }
    }),
    view: defaultView.extend({
      events: {
        // click: 'eventPostMessage',
        dblclick: 'openModal'
      },
      initialize: function initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
        self = this;
        this.model.listenTo(this.model, 'active', self.insertIframe);
        this.listenTo(this.model, 'change:title', this.updateScript);
        modal = editor.Modal;
        modal.setTitle(config.translate['select_image-media']);
      },
      getIframe: function getIframe() {
        if (!this.iframe) {
          var ifrm = document.createElement('img');
          ifrm.className = this.ppfx + 'no-pointer';
          ifrm.src = this.model.get('src');
          ifrm.id = 'image-media-' + __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__["a" /* default */].methods.makeId();
          ifrm.style = 'width:100%;height:100%;border:none;overflow:hidden';

          this.iframe = ifrm;
        }
        return this.iframe;
      },
      insertIframe: function insertIframe() {
        self.el.appendChild(self.getIframe());
        document.getElementById('CanvOverlay').style.display = 'block';
        self.openModal();
      },
      closeModal: function closeModal() {
        var iframeEl = document.getElementById('image-media-iframe');
        if (iframeEl) {
          iframeEl.style.display = 'none';
        }
        document.getElementById('CanvOverlay').style.display = 'none';
        this.handleEmptyImage();
      },
      setCloseImageModal: function setCloseImageModal(comp, id) {
        var self = this;
        if (document.getElementById('close-modal-' + id)) {
          document.getElementById('close-modal-' + id).addEventListener('click', function (e) {
            self.closeModal(comp, id);
          });
        }
      },
      openModal: function openModal() {
        var iframeEl = document.getElementById('image-media-iframe');
        if (iframeEl) {
          iframeEl.style.display = 'block';
        }

        var conf = __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__["a" /* default */].methods.getLangCode('display-image-plugin');
        this.model.set('config', conf);
        var id = 'image-media';
        self.setCloseImageModal('image_media', id);
        modal.getModel().once('change:open', function () {
          document.getElementById('CanvOverlay').style.display = 'none';
          self.handleEmptyImage();
        });
      },
      render: function render() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        defaultView.prototype.render.apply(this, args);
        if (this.model.get('src')) {
          this.el.appendChild(this.getIframe());
        }
        this.updateClasses();
        this.updateAttributes();
        return this;
      },
      handleEmptyImage: function handleEmptyImage() {
        var getAllComponents = function getAllComponents(model) {
          var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

          result.push(model);
          model.components().each(function (mod) {
            return getAllComponents(mod, result);
          });
          return result;
        };
        var all = getAllComponents(editor.DomComponents.getWrapper());
        var found = all.some(function (c) {
          return c.attributes.type === 'image_media' && !c.attributes.src;
        });
        while (found) {
          editor.UndoManager.undo();
          var _all = getAllComponents(editor.DomComponents.getWrapper());
          found = _all.some(function (c) {
            return c.attributes.type === 'image_media' && !c.attributes.src;
          });
        }
      }
    })
  });
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export service */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_photoprism_service_api__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_photoprism_service_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuex_photoprism_service_api__);
// eslint-disable-next-line import/extensions,import/no-unresolved


function service(token) {
  return new __WEBPACK_IMPORTED_MODULE_0_vuex_photoprism_service_api___default.a({
    baseURL: "undefined",
    token: token ? token.replace("Bearer ", "") : "eyJhbGciOiJSUzI1NiJ9.eyJ1c2VybmFtZSI6InVzZXJfcGhvdG9wcmlzbSIsImlkIjoxMCwicm9sZXMiOlsiUk9MRV9VU0VSIl0sImlhdCI6MTU3NDY5Nzc4MywiZXhwIjo3ODgxODk3NzgzfQ.FwBMnJND_bYSRTxKPBeZk7hipgHx9wBcuSnE0ZQqPE2H5p89awb4Skrg6_jzLkUuPORehVu12Z4qZMkOw-HUpAqB8eNSC3lxGA_QKbmEU5P44hl6wncZywRcyCZEMUz-fYWU0DUfGZyyUnKdf0pEat-uhs3AcS2bdVY2J2cZE53C8B-ohyHAnpKySbD-WWVnhy5REusC_CZGJfatjqAbDyOvRpr8Ff1IvgwJrgKTfCb9gNjE-NoPgzSzfqvfSPilbMKPv2nxj6CyrPEKmFqRUEb6KOXNNSoyOFDYadsC0Y2Xw1Yd0U09wz5RlyIrjp1RwUDjvDyvdZm97aa103dx3ZRVuYAYhge3Mo_WkGJw_5hOzwAbGzPbYhM6H6OSp0FOpk6ltFuu7K7--Q3RFq98o4RkgxKWbQoKDQdpkfIrnzzKDUvo9ZIFbXueGEfgSdB8HRU5A4dkPDuy5aBNPqnDTKASgpXBPvlk0buStM-lVPP42bspZl7NqVMzYeUQCWjzVTfbuUw4nu8OVa-C0PeB0U5bevAq0Lp-RhdcPN76kpA4mYaCSNdnIVyKbYKpNK2IKE1k99gq1fgF0QOGSDKjHynVTrSWdD2i3otp1mSeOJgYtLmTK6bb9HxQVnfs91p20QEN5Jdfm8txoHav6aUlgEwA10tUrq3JLa_lUqb0HWg"
  });
}

/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var lp = './img/';
var plp = '//placehold.it/350x250/';

var storage = {
    images: [lp + 'team1.jpg', lp + 'team2.jpg', lp + 'team3.jpg', plp + '78c5d6/fff/image1.jpg', plp + '459ba8/fff/image2.jpg', plp + '79c267/fff/image3.jpg', plp + 'c5d647/fff/image4.jpg', plp + 'f28c33/fff/image5.jpg', plp + 'e868a2/fff/image6.jpg', plp + 'cc4360/fff/image7.jpg', lp + 'work-desk.jpg', lp + 'phone-app.png', lp + 'bg-gr-v.png'],
    screens: [],
    players: [{
        id: 1,
        title: 'player 1',
        lien: 'http://ahedia-web-dev.webtv-solution.com/uep_v2/dist/nV2g409KY0SaH5KLTNH0D6dN69Y1FhY6sNepprxRbsM',
        preview: "data:image/png;base64,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"
    }, {
        id: 2,
        title: 'player 2',
        lien: 'http://nbouaziz-web-dev.webtv-solution.com/version/uep_v2/docs/wjX75sp7U7c9Br5_ALKXJkFS6ra_WPv7F7Bh2sz3L-c?plugin=simple',
        preview: 'data:image/png;base64,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'
    }],
    playlists: [{
        id: 1,
        title: 'player 1',
        lien: 'http://ahedia-web-dev.webtv-solution.com/uep_v2/dist/nV2g409KY0SaH5KLTNH0D6dN69Y1FhY6sNepprxRbsM',
        preview: "data:image/png;base64,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"
    }, {
        id: 2,
        title: 'player 2',
        lien: 'http://nbouaziz-web-dev.webtv-solution.com/version/uep_v2/docs/wjX75sp7U7c9Br5_ALKXJkFS6ra_WPv7F7Bh2sz3L-c?plugin=simple',
        preview: 'data:image/png;base64,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'
    }],
    dispositions: []
};
/* harmony default export */ __webpack_exports__["a"] = (storage);

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);



var state = {
  maxLength: 19,
  listSvgObject: [],
  canvasSize: {
    width: 0,
    height: 0
  },
  settingModalPos: {
    left: 0,
    top: 0
  },
  imageEdited: '',
  imageConverted: {},
  deviceType: 'landscape',
  deviceSize: {
    x: 0,
    y: 0
  },
  showSave: false,
  showIconSave: false,
  changedSave: false,
  // Becomes false while a program is being loaded for edit and true once fully
  // loaded. Used to block a premature "Enregistrer" that would otherwise save a
  // screen before its content/background is loaded (losing it).
  editorReady: true,
  imageWidth: '',
  parentWidth: 0,
  someImage: {
    className: '',
    idParent: ''
  },
  rotationIconPos: {
    left: 0,
    top: 0,
    transform: 0
  },
  generic: {
    selectedId: '',
    searchTitle: ''
  },
  OptionsThemeSelect: [],
  themId: 0,
  saveVideo: false,
  reclamation: false,
  causeReclamation: {}
};

var mutations = {
  animatE: function animatE(state) {
    TweenMax.killTweensOf(ob.element);
    var origin = 'center center';
    var ease = ob.tween.ease || 'Expo.easeInOut';
    var duration = ob.tween.duration || 1;
    var delay = ob.tween.delay || 0;
    var subdelay = ob.tween.subdelay || 0.1;
    var repeat = ob.tween.repeat || 0;
    var el = ob.element;
    var stagger = ob.stagger;
    if (stagger) el = el.querySelector('g').children;
    if (ob.transition) {
      ob.tween.properties.forEach(function (p) {
        if (p.value !== '') {
          var _ease = p.ease || ease;
          var _duration = p.duration || duration;
          var _delay = p.delay || delay;
          var tob = { transformOrigin: origin, ease: _ease, delay: +_delay };
          tob[p.prop] = p.value;
          if (stagger) {
            var _subdelay = p.subdelay || subdelay;
            TweenMax.staggerFrom(el, +_duration, tob, _subdelay);
          } else {
            TweenMax.from(el, +_duration, tob);
          }
        }
      });
    }
  },
  setMaxLength: function setMaxLength(state, max) {
    state.maxLength = max;
  },
  setSettingModalPos: function setSettingModalPos(state, data) {
    state.settingModalPos = data;
  },
  addToListSvgObject: function addToListSvgObject(state, data) {
    if (state.listSvgObject.length > 0) {
      var index = state.listSvgObject.findIndex(function (item, i) {
        return item.getImgId === data.getImgId;
      });

      if (index !== -1) {
        state.listSvgObject = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.listSvgObject.slice(0, index)), [data], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.listSvgObject.slice(index + 1)));
      } else {
        state.listSvgObject.push(data);
      }
    } else {
      state.listSvgObject.push(data);
    }
  },
  duplicateSvgObject: function duplicateSvgObject(state, data) {
    var object = null;
    var newList = state.listSvgObject;
    var ExisteId = state.listSvgObject.find(function (svg) {
      object = svg;
      return svg.getImgId === data.oldid;
    });
    if (ExisteId) {
      var newsvg = {
        getImgId: data.newid,
        file: {
          idImg: data.newid,
          conf: object.file.conf,
          svg: object.file.svg
        },
        currentConf: {
          idImg: data.newid,
          conf: object.currentConf.conf,
          svg: object.currentConf.svg
        }
      };
      newList.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(object)), newsvg));
      var obj = {
        duplicate: true,
        duplicatedata: { newid: data.newid, oldid: data.oldid }
      };
      window.frames['svg-iframe'].contentWindow.postMessage(obj, '*');
    }
    state.listSvgObject = newList;
  },
  setImageEdited: function setImageEdited(state, image) {
    state.imageEdited = image;
  },
  setDeviceType: function setDeviceType(state, data) {
    state.deviceType = data;
  },
  setDeviceSize: function setDeviceSize(state, data) {
    state.deviceSize = data;
  },
  setImageWidth: function setImageWidth(state, data) {
    state.imageWidth = data;
  },
  setParentWidth: function setParentWidth(state, data) {
    state.parentWidth = data;
  },
  setSomeImage: function setSomeImage(state, data) {
    state.someImage = data;
  },
  setCanvasSize: function setCanvasSize(state, data) {
    state.canvasSize = data;
  },
  setImageConverted: function setImageConverted(state, image) {
    state.imageConverted = image;
  },
  setShowSave: function setShowSave(state, data) {
    state.showSave = data;
  },
  setShowIconSave: function setShowIconSave(state, data) {
    state.showIconSave = data;
  },
  setEditorReady: function setEditorReady(state, data) {
    state.editorReady = data;
  },
  setChangedSave: function setChangedSave(state, data) {
    state.changedSave = data;
  },
  setSelectedVideo: function setSelectedVideo(state, id) {
    state.generic.selectedId = id;
  },
  searchGenericVideo: function searchGenericVideo(state, title) {
    state.generic.searchTitle = title;
  },
  setGenericThem: function setGenericThem(state, them) {
    state.themId = them;
  },
  setOptionsThemeSelect: function setOptionsThemeSelect(state, options) {
    state.OptionsThemeSelect = options;
  },
  setSaveVideo: function setSaveVideo(state, value) {
    state.saveVideo = value;
  },
  setReclamation: function setReclamation(state, value) {
    state.reclamation = value;
  },
  setCauseReclamation: function setCauseReclamation(state, value) {
    state.causeReclamation = value;
  }
};

var actions = {
  setSettingModalPos: function setSettingModalPos(_ref, data) {
    var state = _ref.state,
        commit = _ref.commit;
    return commit('setSettingModalPos', data);
  },
  setDeviceSize: function setDeviceSize(_ref2, data) {
    var state = _ref2.state,
        commit = _ref2.commit;
    return commit('setDeviceSize', data);
  },
  setImageEdited: function setImageEdited(_ref3, data) {
    var state = _ref3.state,
        commit = _ref3.commit;
    return commit('setImageEdited', data);
  },
  setDeviceType: function setDeviceType(_ref4, data) {
    var state = _ref4.state,
        commit = _ref4.commit;
    return commit('setDeviceType', data);
  },
  setImageWidth: function setImageWidth(_ref5, data) {
    var state = _ref5.state,
        commit = _ref5.commit;
    return commit('setImageWidth', data);
  },
  setParentWidth: function setParentWidth(_ref6, data) {
    var state = _ref6.state,
        commit = _ref6.commit;
    return commit('setParentWidth', data);
  },
  setSomeImage: function setSomeImage(_ref7, data) {
    var state = _ref7.state,
        commit = _ref7.commit;
    return commit('setSomeImage', data);
  },
  setCanvasSize: function setCanvasSize(_ref8, data) {
    var state = _ref8.state,
        commit = _ref8.commit;
    return commit('setCanvasSize', data);
  },
  setImageConverted: function setImageConverted(_ref9, data) {
    var state = _ref9.state,
        commit = _ref9.commit;
    return commit('setImageConverted', data);
  },
  setShowSave: function setShowSave(_ref10, data) {
    var state = _ref10.state,
        commit = _ref10.commit;
    return commit('setShowSave', data);
  },
  setChangedSave: function setChangedSave(_ref11, data) {
    var state = _ref11.state,
        commit = _ref11.commit;
    return commit('setChangedSave', data);
  },
  addToListSvgObject: function addToListSvgObject(_ref12, data) {
    var state = _ref12.state,
        commit = _ref12.commit;
    return commit('addToListSvgObject', data);
  },
  setShowIconSave: function setShowIconSave(_ref13, data) {
    var state = _ref13.state,
        commit = _ref13.commit;
    return commit('setShowIconSave', data);
  },
  setEditorReady: function setEditorReady(_ref14, data) {
    var commit = _ref14.commit;
    return commit('setEditorReady', data);
  },
  setSelectedVideo: function setSelectedVideo(_ref15, id) {
    var state = _ref15.state,
        commit = _ref15.commit;
    return commit('setSelectedVideo', id);
  },
  searchGenericVideo: function searchGenericVideo(_ref16, title) {
    var state = _ref16.state,
        commit = _ref16.commit;
    return commit('searchGenericVideo', title);
  },
  setGenericThem: function setGenericThem(_ref17, them) {
    var state = _ref17.state,
        commit = _ref17.commit;
    return commit('setGenericThem', them);
  },
  setOptionsThemeSelect: function setOptionsThemeSelect(_ref18, OptionsThemeSelect) {
    var state = _ref18.state,
        commit = _ref18.commit;
    return commit('setOptionsThemeSelect', OptionsThemeSelect);
  },
  setSaveVideo: function setSaveVideo(_ref19, value) {
    var state = _ref19.state,
        commit = _ref19.commit;
    return commit('setSaveVideo', value);
  },
  setReclamation: function setReclamation(_ref20, value) {
    var state = _ref20.state,
        commit = _ref20.commit;
    return commit('setReclamation', value);
  },
  setCauseReclamation: function setCauseReclamation(_ref21, value) {
    var state = _ref21.state,
        commit = _ref21.commit;
    return commit('setCauseReclamation', value);
  },
  duplicateSvgObject: function duplicateSvgObject(_ref22, data) {
    var state = _ref22.state,
        commit = _ref22.commit;
    return commit('duplicateSvgObject', data);
  }
};

// getters are functions
var getters = {
  getmaxLength: function getmaxLength(state) {
    return state.maxLength;
  },
  getSettingModalPos: function getSettingModalPos(state) {
    return state.settingModalPos;
  },
  getDeviceSize: function getDeviceSize(state) {
    return state.deviceSize;
  },
  getImageEdited: function getImageEdited(state) {
    return state.imageEdited;
  },
  getDeviceType: function getDeviceType(state) {
    return state.deviceType;
  },
  getImageWidth: function getImageWidth(state) {
    return state.imageWidth;
  },
  getParentWidth: function getParentWidth(state) {
    return state.parentWidth;
  },
  getSomeImage: function getSomeImage(state) {
    return state.someImage;
  },
  getCanvasSize: function getCanvasSize(state) {
    return state.canvasSize;
  },
  getImageConverted: function getImageConverted(state) {
    return state.imageConverted;
  },
  getShowSave: function getShowSave(state) {
    return state.showSave;
  },
  getChangedSave: function getChangedSave(state) {
    return state.changedSave;
  },
  getListSvgObject: function getListSvgObject(state) {
    return state.listSvgObject;
  },
  getShowIconSave: function getShowIconSave(state) {
    return state.showIconSave;
  },
  getEditorReady: function getEditorReady(state) {
    return state.editorReady;
  },
  getSelectedVideo: function getSelectedVideo(state) {
    return state.generic.selectedId;
  },
  getGenericThem: function getGenericThem(state) {
    return state.themId;
  },
  getOptionsThemeSelect: function getOptionsThemeSelect(state) {
    return state.OptionsThemeSelect;
  },
  getSaveVideo: function getSaveVideo(state) {
    return state.saveVideo;
  },
  getReclamation: function getReclamation(state) {
    return state.reclamation;
  },
  getCauseReclamation: function getCauseReclamation(state) {
    return state.causeReclamation;
  },
  getConfigurationSvg: function getConfigurationSvg(state) {
    return function (id) {
      return state.listSvgObject.find(function (s) {
        return s.getImgId === id;
      });
    };
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  editor: null,
  blockManager: null,
  panels: null,
  commands: null,
  modal: null,
  title: null,
  assetManager: []
};

var mutations = {
  setEditor: function setEditor(state, editor) {
    state.editor = null;
    state.blockManager = editor.BlockManager;
    state.panels = editor.Panels;
    state.modal = editor.Modal;
    state.commands = editor.Commands;
  },
  setAssetManager: function setAssetManager(state, assetManager) {
    state.assetManager = assetManager;
  }
};

var actions = {
  setEditor: function setEditor(_ref, editor) {
    var state = _ref.state,
        commit = _ref.commit;
    return commit('setEditor', editor);
  },
  setAssetManager: function setAssetManager(_ref2, assetManager) {
    var state = _ref2.state,
        commit = _ref2.commit;
    return commit('setAssetManager', assetManager);
  }
};

var getters = {
  getEditor: function getEditor(state) {
    return state.editor;
  },
  getModal: function getModal(state) {
    return state.modal;
  },
  getAssetManager: function getAssetManager(state) {
    return state.assetManager;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  route: '',
  cryptext: ''
};

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
var mutations = {
  setRoute: function setRoute(state, Param) {
    state.route = Param;
  },
  setTmpId: function setTmpId(state, Param) {
    state.tmpId = Param;
  },
  setRouteCryptext: function setRouteCryptext(state, cryptext) {
    state.cryptext = cryptext;
  }
};

// actions are functions that cause side effects and can involve
// asynchronous operations.
var actions = {
  setRoute: function setRoute(_ref, Param) {
    var state = _ref.state,
        commit = _ref.commit;
    return commit('setRoute', Param);
  },
  setTmpId: function setTmpId(_ref2, Param) {
    var state = _ref2.state,
        commit = _ref2.commit;
    return commit('setTmpId', Param);
  },
  setRouteCryptext: function setRouteCryptext(_ref3, cryptext) {
    var state = _ref3.state,
        commit = _ref3.commit;
    return commit('setRouteCryptext', cryptext);
  }
};

// getters are functions
var getters = {
  /**
   * Get days
   */
  getRoute: function getRoute(state) {
    return state.route;
  },
  getTmpId: function getTmpId(state) {
    return state.tmpId;
  },
  getRouteCryptext: function getRouteCryptext(state) {
    return state.cryptext;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_router_router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_http_http_token__ = __webpack_require__(25);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      templates: {},
      currentIndexTemplate: 0,
      currentSrc: null,
      loop: false,
      indexNextTemplate: 0,
      sockets: [],
      wsClosing: false,
      reloadToken: 0,
      previewWidth: '37.5vw',
      previewHeight: '30vw',
      previewTitle: 'Loading...'
    };
  },

  props: {
    isRmBox: Boolean
  },
  computed: {
    isPreview: function isPreview() {
      return !!this.$route.params.cryptext;
    },
    currentTemplateId: function currentTemplateId() {
      var current = Array.isArray(this.templates) && this.templates[this.currentIndexTemplate];
      return current ? current.id : null;
    },
    iframeSrc: function iframeSrc() {
      if (!this.currentSrc) {
        return null;
      }
      if (this.reloadToken === 0) {
        return this.currentSrc;
      }
      // Cache-buster pour forcer le rechargement de l'iframe sur message WebSocket "reload"
      var separator = this.currentSrc.indexOf('?') === -1 ? '?' : '&';
      return this.currentSrc + separator + '_reload=' + this.reloadToken;
    }
  },
  watch: {
    currentTemplateId: function currentTemplateId(id) {
      if (this.isPreview && id !== null && id !== undefined) {
        this.loadPreviewInfos(id);
      }
    }
  },
  methods: {
    loadPreviewInfos: function loadPreviewInfos(templateId) {
      var self = this;
      var token = window.ApiToken ? window.ApiToken : 'Bearer ' + (window.process && window.process.env && window.process.env.API_TOKEN || localStorage.getItem('authToken'));
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_http_http_token__["a" /* HTTP */])(token).get(__WEBPACK_IMPORTED_MODULE_1__core_router_router__["a" /* default */].generate('api_templateDisplay_get_template_urls', { id: templateId })).then(function (response) {
        var data = response.data && response.data.data;
        if (!data || String(templateId) !== String(self.currentTemplateId)) {
          return;
        }
        self.previewTitle = data.title || '';
        var device = data.display_devices && data.display_devices[0];
        if (device) {
          self.previewWidth = device.width;
          self.previewHeight = device.height;
        }
      }, function () {
        // En cas d'échec on garde les dimensions par défaut
        self.previewTitle = '';
      });
    },

    // Ouvre les WebSockets : un seul par rmbox (rmboxId) sur la route show-schedule-by-rmbox,
    // sinon un par template retourné par l'API (templateId = template.id)
    initWebSockets: function initWebSockets() {
      var self = this;
      self.closeWebSockets();
      self.wsClosing = false;
      if (self.isRmBox) {
        // L'id de la route peut être suffixé (ex: "1-bo") : on ne garde que la partie numérique
        var routeId = self.$route.params.id;
        var rmboxId = routeId !== undefined && routeId !== null ? String(routeId).split('-')[0] : routeId;
        if (rmboxId !== undefined && rmboxId !== null && rmboxId !== '') {
          self.openSocket({ rmboxId: rmboxId });
        }
        return;
      }
      var templates = Array.isArray(self.templates) ? self.templates : [];
      var seen = {};
      templates.forEach(function (template) {
        var templateId = template && template.id;
        if (templateId === undefined || templateId === null || seen[templateId]) {
          return;
        }
        seen[templateId] = true;
        self.openSocket({ templateId: templateId });
      });
    },
    openSocket: function openSocket(target) {
      var self = this;
      // Fallback en dur si env-config.js (servi au runtime) n'expose pas encore WS_RELAY_URL
      var baseUrl = window.process && window.process.env && window.process.env.WS_RELAY_URL || 'wss://ws-relay.webtv.workers.dev/ws';
      var clientName = window.process && window.process.env && window.process.env.CLIENT_NAME || '';
      // En mode rmbox on connecte avec rmboxId, sinon avec templateId
      var queryParam = target.rmboxId !== undefined && target.rmboxId !== null ? 'rmboxId=' + encodeURIComponent(target.rmboxId) : 'templateId=' + encodeURIComponent(target.templateId);
      var url = baseUrl + '?' + queryParam + '&clientName=' + encodeURIComponent(clientName);
      var socket = { target: target, ws: null, reconnectTimer: null };
      self.sockets.push(socket);
      var connect = function connect() {
        if (self.wsClosing) {
          return;
        }
        try {
          socket.ws = new WebSocket(url);
        } catch (e) {
          self.scheduleReconnect(socket, connect);
          return;
        }
        socket.ws.onmessage = function (event) {
          var payload = event.data;
          try {
            payload = JSON.parse(event.data);
          } catch (e) {
            // message non-JSON : on garde la valeur brute
          }
          var type = payload && (typeof payload === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(payload)) === 'object' ? payload.type : payload;
          if (type === 'reload') {
            if (target.rmboxId !== undefined) {
              // En mode rmbox : on rappelle l'API pour récupérer le templateHtml mis à jour
              // et le réinjecter dans l'iframe.
              self.refreshTemplatesFromApi();
            } else if (self.isCurrentTemplate(target.templateId)) {
              // Sinon on ne recharge que si le message concerne le template affiché.
              self.reloadIframe();
            }
          }
        };
        socket.ws.onclose = function () {
          socket.ws = null;
          if (!self.wsClosing) {
            self.scheduleReconnect(socket, connect);
          }
        };
        socket.ws.onerror = function () {
          if (socket.ws) {
            socket.ws.close();
          }
        };
      };
      connect();
    },
    scheduleReconnect: function scheduleReconnect(socket, connect) {
      var self = this;
      if (self.wsClosing || socket.reconnectTimer) {
        return;
      }
      socket.reconnectTimer = setTimeout(function () {
        socket.reconnectTimer = null;
        connect();
      }, 5000);
    },
    isCurrentTemplate: function isCurrentTemplate(templateId) {
      var current = this.templates && this.templates[this.currentIndexTemplate];
      return !!current && String(current.id) === String(templateId);
    },
    closeWebSockets: function closeWebSockets() {
      this.wsClosing = true;
      this.sockets.forEach(function (socket) {
        if (socket.reconnectTimer) {
          clearTimeout(socket.reconnectTimer);
          socket.reconnectTimer = null;
        }
        if (socket.ws) {
          socket.ws.close();
          socket.ws = null;
        }
      });
      this.sockets = [];
    },
    reloadIframe: function reloadIframe() {
      this.reloadToken++;
    },

    // En mode rmbox : récupère à nouveau la liste des templates via l'API pour obtenir
    // le templateHtml mis à jour, puis le réinjecte dans l'iframe (avec cache-buster).
    refreshTemplatesFromApi: function refreshTemplatesFromApi() {
      var self = this;
      var token = 'Bearer ' + (window.process && window.process.env && window.process.env.API_TOKEN);
      var data = { idRmbox: this.$route.params.id };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_http_http_token__["a" /* HTTP */])(token).get(__WEBPACK_IMPORTED_MODULE_1__core_router_router__["a" /* default */].generate('api_templateDisplay_get_templates_by_rmbox', data)).then(function (response) {
        var templates = response.data && response.data.data && response.data.data.templates || [];
        self.templates = templates;
        if (self.currentIndexTemplate >= templates.length) {
          self.currentIndexTemplate = 0;
        }
        var current = templates[self.currentIndexTemplate];
        if (current) {
          self.currentSrc = current.templateHtml;
        }
        // Force le rechargement de l'iframe même si l'URL du templateHtml est inchangée.
        self.reloadIframe();
      }, function () {
        // En cas d'échec on garde l'affichage courant
      });
    },
    updateTemplate: function updateTemplate() {
      var self = this;
      var interval = 0;
      self.currentIndexTemplate++;
      var dateCurrent = new Date();
      var inf_interval = new Date(self.templates[self.currentIndexTemplate].start_date).getTime();
      if (self.currentIndexTemplate - 1 !== self.templates.length) {
        self.currentSrc = self.templates[self.currentIndexTemplate].templateHtml;
        var duration = self.templates[self.currentIndexTemplate].duration_template * 1000;
        if (self.currentIndexTemplate + 1 !== self.templates.length) {
          var sup_interval = new Date(self.templates[self.currentIndexTemplate + 1].start_date).getTime();
          if (self.getDateString(self.templates[self.currentIndexTemplate].start_date) < self.getDateString('now')) {
            self.loop = false;
            var new_index = self.searchTemplateDay(self.getDateString('now'), self.templates);
            if (new_index) {
              self.currentIndexTemplate = new_index - 1;
              sup_interval = new Date().getTime();
            } else {
              self.currentIndexTemplate = self.indexNextTemplate - 1;
              sup_interval = new Date(self.templates[self.currentIndexTemplate + 1].start_date).getTime();
            }
            inf_interval = new Date().getTime();
          } else if (self.getDateString(self.templates[self.currentIndexTemplate + 1].start_date) > self.getDateString('now')) {
            self.indexNextTemplate = self.currentIndexTemplate + 1;
            if (self.searchTemplateDay(self.getDateString('now'), self.templates) !== self.currentIndexTemplate) {
              self.currentIndexTemplate = self.searchTemplateDay(self.getDateString('now'), self.templates) - 1;
              self.loop = true;
            }
          }

          if (self.loop) {
            interval = duration;
          } else {
            interval = sup_interval - inf_interval;
          }
          setTimeout(self.updateTemplate, interval);
        }
      }
    },
    getDateString: function getDateString(date) {
      if (date === 'now') {
        var mydate = new Date();
      } else {
        var mydate = new Date(date);
      }
      var dd = String(mydate.getDate()).padStart(2, '0');
      var mm = String(mydate.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = mydate.getFullYear();

      mydate = yyyy + '-' + mm + '-' + dd;
      return mydate;
    },
    searchTemplateDay: function searchTemplateDay(day, myArray) {
      var self = this;
      for (var i = 0; i < myArray.length; i++) {
        if (self.getDateString(myArray[i].start_date) <= day && day <= self.getDateString(myArray[i].end_date)) {
          return i;
        }
      }
    },
    ajaxCallApi: function ajaxCallApi() {
      var self = this;
      var token = 'Bearer ' + (window.process && window.process.env && window.process.env.API_TOKEN);
      var apiDisplayTemplates = this.isRmBox ? 'api_templateDisplay_get_templates_by_rmbox' : 'api_templateDisplay_get_templates_by_program';
      var interval = 0;
      var intervalAjax = 0;
      var data = this.isRmBox ? {
        idRmbox: this.$route.params.id
      } : {
        idProgram: this.$route.params.id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_http_http_token__["a" /* HTTP */])(token).get(__WEBPACK_IMPORTED_MODULE_1__core_router_router__["a" /* default */].generate(apiDisplayTemplates, data)).then(function (response) {
        self.templates = response.data.data.templates;
        self.currentIndexTemplate = 0;
        self.currentSrc = self.templates[self.currentIndexTemplate].templateHtml;
        // Ouvre un WebSocket par template une fois la liste chargée
        self.initWebSockets();

        if (self.templates.length > 1) {
          interval = new Date(self.templates[self.currentIndexTemplate + 1].start_date).getTime() - new Date().getTime();
          setTimeout(self.updateTemplate, interval);
        }
        var dayOfWeek = 6;
        var date = new Date();
        date.setHours(23, 55, 0, 0);
        date.setDate(date.getDate() + (dayOfWeek + 7 - date.getDay()) % 7);
        intervalAjax = date.getTime() - new Date().getTime();
        setTimeout(self.ajaxCallApi, intervalAjax);
      }, function (response) {
        //self.hideLoader();
      });
    }
  },
  created: function created() {
    var self = this;
    self.ajaxCallApi();
  },
  beforeDestroy: function beforeDestroy() {
    this.closeWebSockets();
  }
});

/***/ }),
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */
/***/ (function(module, exports) {

module.exports = {"universal":50,"tag":30,"attribute":1,"pseudo":0,"descendant":-1,"child":-1,"parent":-1,"sibling":-1,"adjacent":-1}

/***/ }),
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

/***/ }),
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","QUOT":"\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 323 */,
/* 324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(684)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(831),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(327)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(369),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a08b5b66",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(670)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(818),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(678)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(826),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(685)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(832),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(700)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(847),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(679)
  __webpack_require__(680)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(827),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(675)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(823),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2df76069",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "schedule",
    class: {
      'schedule--preview': _vm.isPreview
    }
  }, [(_vm.isPreview) ? _c('div', {
    staticClass: "main-container",
    style: ({
      width: _vm.previewWidth
    })
  }, [_c('div', {
    staticClass: "main-container__card"
  }, [_c('div', {
    staticClass: "main-container__card__header"
  }, [_c('p', {
    staticClass: "title_template"
  }, [_vm._v(_vm._s(_vm.previewTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "iframe-container",
    style: ({
      width: _vm.previewWidth,
      height: _vm.previewHeight
    })
  }, [(_vm.currentSrc) ? _c('iframe', {
    staticClass: "current-template",
    attrs: {
      "src": _vm.iframeSrc
    }
  }) : _vm._e()])])]) : (_vm.currentSrc) ? _c('iframe', {
    staticClass: "current-template",
    attrs: {
      "src": _vm.iframeSrc
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HTTP; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


// env-config.js (loaded via a <script> tag in each entry page) sets
// window.process.env. Fall back to an empty object so a page that forgets that
// tag degrades to failing API calls instead of throwing here at import time,
// which would leave the whole app unmounted on a blank white screen.
var ENV = window.process && window.process.env || {};

// Force the API host to https so CORS preflight requests are not redirected
// (http://  or protocol-relative //  -> https://). A redirect on a preflight
// request is rejected by the browser.
function toHttps(host) {
    if (!host) return host;
    return host.trim().replace(/^http:\/\//i, 'https://').replace(/^\/\//, 'https://');
}

var HTTP = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    baseURL: toHttps(ENV.API_HOST_GLOBAL),
    headers: {
        Authorization: window.ApiToken ? window.ApiToken : 'Bearer ' + ENV.API_TOKEN
    }
});

function getHttp() {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
        baseURL: toHttps(ENV.API_HOST_GLOBAL),
        headers: {
            Authorization: window.ApiToken ? window.ApiToken : 'Bearer ' + ENV.API_TOKEN
        }
    });
}

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(671)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(819),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(690)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(837),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Editor__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_404__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AddScreen__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AddScreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_AddScreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AppSegment_ListSegment_vue__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AppSegment_ListSegment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_AppSegment_ListSegment_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AppSegment_EditSegment_vue__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AppSegment_EditSegment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_AppSegment_EditSegment_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AppSchedule_Schedule_vue__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AppSchedule_Schedule_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_AppSchedule_Schedule_vue__);





//import Template from '@/components/AppPrograms/Template';




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/display/',
    name: 'Page404',
    component: __WEBPACK_IMPORTED_MODULE_3__components_404___default.a
  }, {
    name: 'add',
    path: '/display/:cryptext',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Editor___default.a
  }, {
    name: 'edit',
    path: '/display/edit/:cryptext/:id',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Editor___default.a
  }, {
    name: 'segment',
    path: '/display/add-edit/segment/:cryptext',
    component: __WEBPACK_IMPORTED_MODULE_5__components_AppSegment_ListSegment_vue___default.a,
    props: {
      typeS: "segment"
    }
  }, {
    name: 'ListSegment',
    path: '/display/list-segment/:cryptext',
    component: __WEBPACK_IMPORTED_MODULE_5__components_AppSegment_ListSegment_vue___default.a,
    props: {
      typeS: "segment"
    }
  }, {
    name: 'EditSegment',
    path: '/display/edit-segment/:id/:cryptext',
    component: __WEBPACK_IMPORTED_MODULE_6__components_AppSegment_EditSegment_vue___default.a,
    props: {
      typeS: "segment"
    }
  }, {
    name: 'AddSegment',
    path: '/display/add-segment/:cryptext',
    component: __WEBPACK_IMPORTED_MODULE_6__components_AppSegment_EditSegment_vue___default.a
  }, {
    name: 'AddScreenToSegment',
    path: '/display/add-screen/:cryptext',
    component: __WEBPACK_IMPORTED_MODULE_6__components_AppSegment_EditSegment_vue___default.a
  }, {
    name: 'schedule',
    path: '/display/show-schedule/:id/:cryptext',
    component: __WEBPACK_IMPORTED_MODULE_7__components_AppSchedule_Schedule_vue___default.a
  }, {
    name: 'schedule_by_rmbox',
    path: '/display/show-schedule-by-rmbox/:id',
    component: __WEBPACK_IMPORTED_MODULE_7__components_AppSchedule_Schedule_vue___default.a,
    props: { isRmBox: true }
  }],
  mode: 'history'
}));

/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(683)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(830),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 381 */,
/* 382 */,
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_en_US__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_fr_FR__ = __webpack_require__(12);







/* harmony default export */ __webpack_exports__["a"] = ({
  i18n: {
    messages: {
      en: __WEBPACK_IMPORTED_MODULE_5__i18n_en_US__["a" /* default */],
      fr: __WEBPACK_IMPORTED_MODULE_6__i18n_fr_FR__["a" /* default */]
    }
  },
  computed: {},
  methods: {
    addBlockCustom_Column2: function addBlockCustom_Column2(blockManager) {
      blockManager.add('custom_column2', {
        label: this.$i18n.t('blocks.custom_column2'),
        category: 'Areas',
        resizable: false,
        name: 'custom_column2',
        attributes: {
          class: 'gjs-fonts gjs-f-b2 ', //icon in the panel
          type: 'custom_column2'
        },
        content: '\n\t      <div class="row-custom"  data-gjs-type="custom_column2" data-gjs-droppable=".row-cell" data-gjs-custom-name="Row">\n\t\t      <div data-gjs-type="custom_column" data-gjs-custom-name="Col"  class="row-cell-1" data-gjs-draggable=".row"></div>\n\t\t      <div data-gjs-type="custom_column" data-gjs-custom-name="Col" class="row-cell-2" data-gjs-draggable=".row"></div>\n\t      </div>\n\t      <style>\n\t\t      .row-custom {\n\t\t          display: flex;\n\t\t          justify-content: flex-start;\n\t\t          align-items: stretch;\n\t\t          flex-wrap: nowrap;\n\t\t          height: 100%;\n\t\t      }\n\t\t      .row-cell-1,.row-cell-2 {\n\t\t         flex-grow: 1;\n\t\t         flex-basis: 100%;\n\t\t       }\n\t      </style>\n      '
      });
    },
    updateCategoryBlockManger: function updateCategoryBlockManger(editor, getParamsClients) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var allBlocks, CurrentBlock, blocks, names, bg, borderBlock, labelBlock, hiddenBlock, styleNew;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                allBlocks = editor.BlockManager.getAll().models.map(function (block) {
                  return block.id;
                });
                CurrentBlock = [];

                if (getParamsClients.display_default_blocks !== null || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(getParamsClients.display_default_blocks).length > 0) {
                  blocks = getParamsClients.display_default_blocks.map(function (block) {
                    return block.blocks;
                  });
                  names = getParamsClients.display_default_blocks.map(function (item) {
                    return item.name;
                  });
                  bg = ['#ff9800', '#039be5', '#8bc34a', '#9872e8', '#f44336'];
                  borderBlock = 'gjs-four-color-h';
                  labelBlock = 'gjs-block-label';
                  hiddenBlock = 'emp-gjs-block';
                  styleNew = '<style>\n           .' + borderBlock + '{\n                 border: 1px solid #b7bbc5 !important;\n             }\n             .' + labelBlock + '{\n                 font-size: 0.9rem;\n                 font-weight: 600;\n             }\n              .' + hiddenBlock + ' {\n            display: none!important;\n            }\n          </style>';


                  blocks.forEach(function (block, index) {
                    for (var i = 0; i < block.length; i++) {
                      //Add new custom_column2
                      if (block[i] === 'custom_column2') {
                        _this.addBlockCustom_Column2(editor.BlockManager);
                      }
                      if (block[i].indexOf('custom-title') > -1 || block[i].indexOf('custom-sharing') > -1 || block[i].indexOf('custom-credit') > -1) {
                        _this.addSpecificBlocText(block[i], editor);
                      }
                      if (!editor.BlockManager.get(block[i])) {
                        continue;
                      }
                      var parentClass = 'block-parent' + index;
                      var style = '<style>\n            .' + parentClass + ' {\n               color:' + bg[index] + '!important;\n             }           \n          </style>';
                      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(getParamsClients.display_default_blocks).length <= 2) {
                        bg = '#78929f';
                        var parentBlocks = 'gjs-blocks-c';
                        style = '<style>\n             .' + parentBlocks + ' {\n              display: flex;\n              flex-direction: column;\n            }\n            .' + parentClass + ' {\n               color:' + bg + '!important;\n               display: flex;\n               flex-direction: column;\n               width: 100%!important;\n             }\n          \n          </style>' + styleNew;
                      }
                      CurrentBlock = CurrentBlock.concat(block[i]);

                      editor.BlockManager.get(block[i]).set({
                        category: style + ' <div class="emp-gjs-block " id="emp-gjs-block-' + names[index].toLowerCase() + '" style="background:' + bg[index] + '; color: white;margin-top: 5px;" title="' + _this.$i18n.t('blocks.' + names[index]) + '" draggable="true"><div class="gjs-block-column-label">' + _this.$i18n.t('blocks.' + names[index]) + '</div></div>',

                        style: {
                          color: bg[index] + '!important'
                        },
                        label: _this.$i18n.t('blocks.' + block[i]),
                        parent: _this.$i18n.t('blocks.' + names[index]),
                        title: _this.$i18n.t('blocks.' + names[index])
                      });
                      var title = document.querySelector('.gjs-block-categories .gjs-block-category .gjs-title > div#emp-gjs-block-' + names[index].toLowerCase());
                      if (title) {
                        title.innerHTML = '<div class="gjs-block-column-label">' + editor.BlockManager.get(block[i]).get('parent') + '</div>';
                      }
                      var getClassBlocks = editor.BlockManager.get(block[i]).attributes.attributes.class;
                      var classBlocks = [getClassBlocks, 'block-parent' + index];
                      var classes = '';
                      for (var j = 0; j < classBlocks.length; j++) {
                        classes = classes + ' ' + classBlocks[j];
                      }
                      editor.BlockManager.get(block[i]).attributes.attributes.class = classes;
                    }
                  });

                  CurrentBlock = allBlocks.filter(function (item) {
                    return !CurrentBlock.includes(item) ? true : CurrentBlock.splice(CurrentBlock.indexOf(item), 1) && false;
                  });
                  CurrentBlock.forEach(function (block) {
                    editor.BlockManager.remove(block);
                  });
                }
                // Remove the "Réseaux sociaux" (Social) widgets from the block panel
                // (Facebook / Twitter / LinkedIn). The component types stay registered so
                // existing saved programs that already use them still render correctly.
                ['facebook_widget', 'social-icons-twitter', 'linkedin_widget'].forEach(function (id) {
                  if (editor.BlockManager.get(id)) {
                    editor.BlockManager.remove(id);
                  }
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setHiddenBlockManager: function setHiddenBlockManager() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var allCategories;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                allCategories = document.querySelectorAll('.gjs-block-categories .gjs-block-category');


                allCategories.forEach(function (categry, i) {
                  if (i !== 0) {
                    allCategories[i].classList.remove('gjs-open');
                  } else {
                    allCategories[i].classList.add('remove-open-block');
                  }
                  allCategories[i].addEventListener('click', function () {
                    if (allCategories[i].classList.contains('gjs-open')) {
                      allCategories[i].classList.remove('gjs-open');
                      allCategories[i].classList.add('remove-open-block');
                    } else {
                      allCategories[i].classList.add('gjs-open');
                      allCategories[i].classList.remove('remove-open-block');
                    }
                    if (allCategories[i].classList.contains('remove-open-block')) {
                      allCategories[i].classList.remove('remove-open-block');
                    } else {
                      allCategories[i].classList.add('remove-open-block');
                    }
                  });
                });

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    createBorderProperty: function createBorderProperty(editor) {
      var _this3 = this;

      var styleManager = editor.StyleManager;
      var positions = ['top', 'right', 'bottom', 'left'];
      var self = this;
      var borderRadiusSelector = {
        name: 'Rayon',
        property: 'border-radius-selector',
        type: 'radio',
        defaults: 'full-border-radius',
        list: [{ value: 'full-border-radius', className: 'icon icon-border-full' }, { value: 'details-border-radius', className: 'icon icon-border-details' }]
      };
      var borderRadiusValue = {
        name: ' ',
        property: 'border-radius',
        type: 'slider',
        units: ['px', '%'],
        defaults: 0,
        step: 1,
        max: 100,
        min: 0
      };
      var borderRadiusValues = {
        name: ' ',
        property: 'border-radius',
        type: 'composite',
        properties: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(positions.map(function (p) {
          return {
            name: ' ',
            property: 'border-' + p + '-left-radius',
            type: 'integer',
            units: ['px', '%'],
            defaults: '0px',
            min: 0
          };
        })))
      };
      var borderEdgesSelector = {
        name: ' ',
        property: 'border-edges-selector',
        type: 'radio',
        defaults: 'full-border-edges',
        list: [{ value: 'top-border-edges', className: 'icon icon-border-edge-top' }, { value: 'left-border-edges', className: 'icon icon-border-edge-left' }, { value: 'full-border-edges', className: 'icon icon-border-edge-full' }, { value: 'right-border-edges', className: 'icon icon-border-edge-right' }, { value: 'bottom-border-edges', className: 'icon icon-border-edge-bottom' }]
      };
      var borderStyleValue = function borderStyleValue(p) {
        p = p ? p + '-' : '';
        return {
          name: 'Border',
          property: 'border-' + p + 'style',
          type: 'radio',
          defaults: 'none',
          list: [{
            value: 'none',
            name: 'none',
            className: 'icon icon-border-style none',
            title: 'sans bordure'
          }, {
            value: 'solid',
            name: 'solid',
            className: 'icon icon-border-style solid',
            title: 'Solide'
          }, {
            value: 'dashed',
            name: 'dashed',
            className: 'icon icon-border-style dashed',
            title: 'Dashed'
          }, {
            value: 'dotted',
            name: 'dotted',
            className: 'icon icon-border-style dotted',
            title: 'Dotted'
          }]
        };
      };
      var borderWidthValue = function borderWidthValue(p) {
        p = p ? p + '-' : '';
        return {
          name: 'Largeur',
          property: 'border-' + p + 'width',
          type: 'integer',
          units: ['px', '%', ''],
          defaults: 0,
          min: 0
        };
      };
      var borderColorValue = function borderColorValue(p) {
        p = p ? p + '-' : '';
        return {
          name: 'Couleur',
          property: 'border-' + p + 'color',
          type: 'color',
          defaults: 'black'
        };
      };

      styleManager.addProperty('Border', borderRadiusSelector);
      styleManager.addProperty('Border', borderRadiusValue);
      styleManager.addProperty('Border', borderRadiusValues);
      styleManager.addProperty('Border', borderStyleValue());
      positions.forEach(function (p) {
        return styleManager.addProperty('Border', borderStyleValue(p));
      });
      styleManager.addProperty('Border', borderEdgesSelector);
      styleManager.addProperty('Border', borderWidthValue());
      positions.forEach(function (p) {
        return styleManager.addProperty('Border', borderWidthValue(p));
      });
      styleManager.addProperty('Border', borderColorValue());
      positions.forEach(function (p) {
        return styleManager.addProperty('Border', borderColorValue(p));
      });

      var index = 0;
      var interval = setInterval(function () {
        var borderBlockEl = document.getElementById('gjs-sm-border');
        index++;
        if (borderBlockEl) {
          clearInterval(interval);
          _this3.addSelectorsEvent();
        }
        if (index === 100) {
          clearInterval(interval);
        }
      }, 100);
    },
    addSelectorsEvent: function addSelectorsEvent() {
      var borderRadiusEls = document.querySelectorAll('input[type=radio][name=border-radius-selector]');
      var borderEdgesEls = document.querySelectorAll('input[type=radio][name=border-edges-selector]');
      var borderBlockEl = document.getElementById('gjs-sm-border');
      borderBlockEl.classList.add('full-border-radius');
      borderBlockEl.classList.add('full-border-edges');

      borderRadiusEls.forEach(function (e) {
        e.addEventListener('change', function (e) {
          var value = e.target.value;
          borderBlockEl.className = borderBlockEl.classList.value.split(' ').filter(function (e) {
            return e.indexOf('radius') === -1;
          }).join(' ');
          borderBlockEl.classList.add(value);
        });
      });

      borderEdgesEls.forEach(function (e) {
        e.addEventListener('change', function (e) {
          var value = e.target.value;
          borderBlockEl.className = borderBlockEl.classList.value.split(' ').filter(function (e) {
            return e.indexOf('edges') === -1;
          }).join(' ');
          borderBlockEl.classList.add(value);
        });
      });
    },

    // addCustomStyleManager(editor, getParamsClient) {
    //   const styleManager = editor.StyleManager;
    //   const sectors = getParamsClient.display_custom_style_manager.map(sector => {
    //     return sector.name;
    //   });
    //   const buildProps = getParamsClient.display_custom_style_manager.map(property => {
    //     return property.buildProps;
    //   });
    //   const properties = getParamsClient.display_custom_style_manager.map(property => {
    //     return property.properties;
    //   });
    //
    //   sectors.forEach(sector => {
    //     styleManager.addSector(sector, {
    //       name: sector,
    //       open: true,
    //       properties: [
    //         {
    //           name: buildProps.forEach(prop => {
    //             return prop;
    //           })
    //         }
    //       ]
    //     });
    //     const property = properties.forEach(prop => {
    //       return prop.map(p => {
    //         return p;
    //       });
    //     });
    //     styleManager.addProperty(sector, property);
    //   });
    // },
    addSpecificBlocText: function addSpecificBlocText(customBlock, editor) {
      var self = this;
      var iconClass = 'font';
      var style = '<style>\n   [data-class=\'custom-title\'], .custom-title{\n   color: #FFFFFF;\n   background-color: #E42313;\n   font-family: Corporate A BQ !important;\n   font-size: 25pt;\n   padding: 10px 0.2em;\n   text-align: center;\n   }\n   \n  [data-class=\'custom-sharing\'], .custom-sharing{\n   font-size: 20pt;\n   font-family:  Din Bold !important;\n   text-align: center;\n   padding: 10px 0.2em;\n   color: #252e63;\n   }\n   [data-class=\'custom-credit\'], .custom-credit{\n   z-index: 9999!important;\n   font-size: 8pt;\n   font-family:  Din Regular ;\n   text-align: center;\n   padding: 10px 0.2em;\n   color: #ffffff;\n     width: auto!important;\n    height: auto!important;\n   }\n \n  </style>';

      if (customBlock === 'custom-sharing') {
        iconClass = 'fa fa-share';
      }
      if (customBlock === 'custom-credit') {
        iconClass = 'icon-icon-block-c';
      }
      if (customBlock === 'custom-title') {
        iconClass = 'fa fa-font';
      }
      editor.BlockManager.add(customBlock, {
        label: customBlock,
        category: 'Text',
        content: '<div data-gjs-type="text" data-class="' + customBlock + '" class="' + customBlock + '" >Insert your text here</div>\n        ' + style + '\n      ',
        attributes: {
          class: iconClass
        }
      });
    }
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Mixin_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_GrapesMixinEditors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_image_components__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Mixin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_GrapesMixinEditors__["a" /* default */]],
  methods: {
    loadCanvasClear: function loadCanvasClear(commands) {
      var self = this;
      commands.add('canvas-clear', function () {
        self.$swal.fire({
          title: 'Êtes-vous sûr de réinitialiser le diapositive?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#F44336',
          cancelButtonColor: '#2196F3',
          confirmButtonText: self.$t('modal.delete.btn_confirm'),
          cancelButtonText: self.$t('modal.delete.btn_cancel'),
          customClass: 'swal-delete'
        }).then(function (result) {
          if (result.value) {
            self.editor.DomComponents.clear();
            self.editor.select(self.editor.DomComponents.getWrapper());
            setTimeout(function () {
              localStorage.clear();
            }, 0);
            self.$swal.fire({
              title: 'Supprimé!',
              type: 'success',
              showConfirmButton: false,
              timer: 2000
            });
            var iconSave = document.querySelector('.icon-save');
            if (iconSave) {
              iconSave.classList.add('icon-selected');
            }
          }
        });
      });
    },
    loadShowListPages: function loadShowListPages(commands) {
      commands.add('list-page-show', function (e) {
        var panels_list_pages = document.querySelector('#panel__left');
        if (panels_list_pages.classList.contains('show_panel')) {
          panels_list_pages.classList.remove('show_panel');
        } else {
          panels_list_pages.classList.add('show_panel');
        }
      });
    },
    dragCreditBlock: function dragCreditBlock(el, cssComposer, editor, left, top, iframe, model) {
      var self = this;

      var heightCredit = el.getBoundingClientRect().height;
      var style = {
        position: 'fixed',
        left: left / iframe.offsetWidth * 100 + '%',
        bottom: 100 - top / iframe.offsetHeight * 100 - heightCredit / iframe.offsetHeight * 100 + '%',
        right: ''
      };
      el.style.position = style.position;
      el.style.left = style.left;
      el.style.bottom = style.bottom;
      var id = model.getAttributes().id;
      var newId = 'i' + generateClass().substr(1);
      if (!id) {
        var attributes = editor.getSelected().getAttributes();
        attributes = attributes ? attributes : {};
        attributes.id = newId;
        editor.getSelected().setAttributes(attributes);
        style.oldLeft = style.left;
        cssComposer.setIdRule('classe', style);
        self.updateAlignement();
      } else {
        var oldStyle = cssComposer.getIdRule(id) && cssComposer.getIdRule(id).attributes ? cssComposer.getIdRule(id).attributes.style : {};

        oldStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(oldStyle, style, { oldLeft: style.left });
        var _attributes = editor.getSelected().getAttributes();
        _attributes = _attributes ? _attributes : {};
        _attributes.id = newId;
        editor.getSelected().setAttributes(_attributes);
        cssComposer.setIdRule(newId, oldStyle);
        self.updateAlignement();
      }
    },
    dragElements: function dragElements(commands) {
      var self = this;
      commands.add('emp-move', {
        run: function run(editor, sender, opts) {
          var iframe = document.querySelectorAll('.gjs-frame')[0];
          var cssComposer = editor.CssComposer;
          var style = {};
          var iconSave = document.querySelector('.icon-save');
          var rteToolbar = document.querySelector('.gjs-rte-toolbar');
          if (iconSave) {
            iconSave.classList.add('icon-selected');
          }
          function viewMove(e) {
            if (!dragEnabled) {
              editor.select(editor.DomComponents.getWrapper());
              iframe.contentWindow.removeEventListener('mousemove', viewMove, true);
              return;
            }
            var toolbar = document.querySelector('.gjs-toolbar');
            var resizer = document.querySelector('.gjs-resizer-c');
            var badge = document.querySelector('.gjs-badge');

            rteToolbar.style.display = 'none';
            toolbar.style.display = 'none';
            badge.style.display = 'none';
            if (resizer) {
              resizer.style.display = 'none';
            }

            var model = editor.getSelected();
            var el = model.view.el;

            var _el$getBoundingClient = el.getBoundingClientRect(),
                width = _el$getBoundingClient.width;

            var left = Math.max(e.clientX - width + Math.min(width, 130), 0);
            var top = Math.max(e.clientY - 10, 0);

            var style = {
              position: 'fixed',
              left: left / iframe.offsetWidth * 100 + '% ',
              top: top / iframe.offsetHeight * 100 + '%'
            };

            //------------------------------------------------------------------
            if (editor.getSelected().get('type') === 'dateHeure') {
              var classes = model.getAttributes().class;
              if (classes) {
                classes = classes.split(' ');
                if (classes && classes[0]) {
                  var oldStyle = cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes ? cssComposer.getClassRule(classes[0]).attributes.style : {};
                  var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, oldStyle, style);
                  cssComposer.setClassRule(classes[0], newStyle);
                }
              }
            }
            //--------------------------------------------------------------------
            else {
                el.style.position = style.position;
                el.style.left = style.left;
                el.style.top = style.top;

                var id = model.getAttributes().id;
                if (editor.getSelected().get('type') !== 'image') {
                  var newId = 'i' + generateClass().substr(1);
                  if (!id) {
                    editor.getSelected().setAttributes({ id: newId });
                    cssComposer.setIdRule('classe', style);
                  } else {
                    var _oldStyle = cssComposer.getIdRule(id) && cssComposer.getIdRule(id).attributes ? cssComposer.getIdRule(id).attributes.style : {};

                    _oldStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_oldStyle, style);
                    editor.getSelected().setAttributes({ id: newId });
                    cssComposer.setIdRule(newId, _oldStyle);
                  }
                } else {
                  var _classes = model.getAttributes().class;
                  if (_classes) {
                    _classes = _classes.split(' ');
                    if (_classes && _classes[0]) {
                      var _oldStyle2 = cssComposer.getClassRule(_classes[0]) && cssComposer.getClassRule(_classes[0]).attributes ? cssComposer.getClassRule(_classes[0]).attributes.style : {};
                      _oldStyle2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_oldStyle2, style);
                      cssComposer.setClassRule(_classes[0], _oldStyle2);
                    }
                  } else {
                    var _oldStyle3 = cssComposer.getIdRule(id) && cssComposer.getIdRule(id).attributes ? cssComposer.getIdRule(id).attributes.style : {};
                    _oldStyle3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_oldStyle3, style);
                    model.addClass('classe' + id);
                    cssComposer.setClassRule('classe' + id, _oldStyle3);
                  }
                }
                if (model.attributes.type === 'social-icons-twitter') {
                  model.view.updateScript();
                  localStorage.setItem('gjs-js', editor.getJs());
                }
              } //--- end else
          }

          function mouseUp(e) {
            var model = editor.getSelected();
            if (editor && model) {
              if (model.get('type') === 'image') {
                var classes = model.getAttributes().class;
                if (classes) {
                  classes = classes.split(' ');
                  if (classes && classes[0]) {
                    var oldStyle = cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes ? cssComposer.getClassRule(classes[0]).attributes.style : {};
                    if (!(oldStyle.position && oldStyle.position === 'fixed')) {
                      style = {};
                    }
                    var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, oldStyle, style);
                    var newClass = self.generateClass();
                    grapesjsEMP.editors[0].getSelected().removeClass(classes[0]);
                    grapesjsEMP.editors[0].getSelected().addClass(newClass);
                    cssComposer.setClassRule(newClass, newStyle);
                  }
                }
              } else if (model.get('type') === 'social-icons-twitter') {
                var _classes2 = model.getAttributes().class;
                var id = model.getAttributes().id;
                if (_classes2) {
                  _classes2 = _classes2.split(' ');
                  if (_classes2[0] && id) {
                    var _oldStyle4 = cssComposer.getClassRule(_classes2[0]) && cssComposer.getClassRule(_classes2[0]).attributes ? cssComposer.getClassRule(_classes2[0]).attributes.style : {};
                    var _newStyle = cssComposer.getIdRule(id) && cssComposer.getIdRule(id).attributes ? cssComposer.getIdRule(id).attributes.style : {};
                    var _style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _oldStyle4, _newStyle);
                    cssComposer.setClassRule(_classes2[0], _style);
                  }
                }
              }
              if (model.get('type') === 'countdown' || model.get('type') === 'clocks') {
                model.view.updateScript();
                localStorage.setItem('gjs-js', editor.getJs());
              }
            }
            var iframe = document.querySelectorAll('.gjs-frame')[0];
            iframe.contentWindow.removeEventListener('mousemove', viewMove, true);
            iframe.contentWindow.removeEventListener('mouseup', mouseUp, true);

            var el = model.view.el;
            var margin = 15;
            var toolbar = document.querySelector('.gjs-toolbar');
            var resizer = document.querySelector('.gjs-resizer-c');
            var badge = document.querySelector('.gjs-badge');

            var _el$getBoundingClient2 = el.getBoundingClientRect(),
                top = _el$getBoundingClient2.top,
                left = _el$getBoundingClient2.left,
                width = _el$getBoundingClient2.width,
                height = _el$getBoundingClient2.height;

            var iframeLeft = iframe.getBoundingClientRect().left;
            var iframeTop = iframe.getBoundingClientRect().top;
            var iframeWidth = iframe.getBoundingClientRect().width;
            var element = e.target;
            var viewportTop = window.pageYOffset || document.documentElement.scrollTop;
            var elementTop = element.offsetTop;
            var topPosition = elementTop - viewportTop;
            toolbar.style.display = 'block';

            var toolbarWidth = toolbar.getBoundingClientRect().width;
            var toolbarHeight = toolbar.getBoundingClientRect().height;

            if (resizer && model.attributes.resizable) {
              resizer.style.display = 'block';
              //resizer.style.top =  margin + iframeTop/2 + top + 'px';
              resizer.style.top = margin + top + 'px';
              resizer.style.left = iframeLeft + left + 'px';

              if (model.attributes.type === 'text') {
                resizer.style.width = width + 'px';
                resizer.style.height = height + 'px';
              }
            }
            toolbar.style.top = Math.max(margin + top - toolbarHeight, 15) + 'px';
            toolbar.style.left = iframeLeft + Math.min(left + width, iframeWidth) - toolbarWidth + 'px';

            badge.style.top = Math.max(margin + top - 18, 15) + 'px';
            badge.style.left = iframeLeft + left + 'px';
            badge.style.display = 'block';
          }

          iframe.contentWindow.removeEventListener('mouseup', mouseUp, true);
          iframe.contentWindow.removeEventListener('mousemove', viewMove, true);

          if (event.type === 'mousedown') {
            iframe.contentWindow.addEventListener('mousemove', viewMove, true);
            iframe.contentWindow.addEventListener('mouseup', mouseUp, true);
          }
        },
        stop: function stop(editor, sender, opts) {
          var event = opts && opts.event;
          var rteToolbar = document.querySelector('.gjs-rte-toolbar');
          rteToolbar.style.display = 'block';
        }
      });
    },
    getCurrentRotationFixed: function getCurrentRotationFixed(element) {
      var st = window.getComputedStyle(element, null);
      var tr = st.getPropertyValue('-webkit-transform') || st.getPropertyValue('-moz-transform') || st.getPropertyValue('-ms-transform') || st.getPropertyValue('-o-transform') || st.getPropertyValue('transform') || 'fail...';

      if (tr !== 'none') {
        var values = tr.split('(')[1];
        values = values.split(')')[0];
        values = values.split(',');
        var a = values[0];
        var b = values[1];
        var c = values[2];
        var d = values[3];

        var scale = Math.sqrt(a * a + b * b);

        // First option, don't check for negative result
        // Second, check for the negative result
        /**/
        var radians = Math.atan2(b, a);
        var angle;
        angle = Math.round(radians * (180 / Math.PI));
      } else {
        angle = 0;
      }

      // works!
      return angle;
    },
    getRectOfElement: function getRectOfElement(element) {
      var iframe = document.querySelector('iframe.gjs-frame');
      var transform = element.style.transform;
      element.style.transform = 'rotate(0)';
      var clientRect = element.getBoundingClientRect();
      var iframeRect = iframe.getBoundingClientRect();
      var style = window.getComputedStyle(element);
      var clientCenter = {
        x: iframeRect.left + clientRect.left + parseFloat(style.width) / 2,
        y: iframeRect.top + clientRect.top - 55,
        width: parseFloat(style.width),
        height: parseFloat(style.height)
      };
      element.style.transform = transform;
      return clientCenter;
    },
    changeModalBackgImage: function changeModalBackgImage(editor, comp, id) {
      var self = this;
      editor.on('run:open-assets', function () {
        editor.Modal.close();
        self.openModal(id, comp);
      });
    },
    openModal: function openModal(id, comp) {
      var self = this;
      if (document.getElementById(id + '-iframe')) {
        document.getElementById(id + '-iframe').style.display = 'block';
        document.getElementById('CanvOverlay').style.display = 'block';
        self.translatePluginsTitle(comp, 'image');
        self.setCloseImageModal(comp, id);
      }
    }
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    clickPreview: function clickPreview() {
      document.querySelector('.gjs-pn-btn.fa.fa-eye').addEventListener('click', function () {
        var leftPanel = document.getElementById('panel__left');
        var pages = document.getElementById('pages');
        pages.insertBefore(leftPanel, pages.childNodes[0]);
      });
    },
    clickFullScreen: function clickFullScreen() {
      /*document.querySelector('.gjs-pn-btn.fa.fa-arrows-alt').addEventListener('click', function() {
        let leftPanel = document.getElementById('panel__left');
        let gjs = document.getElementById('gjs');
        // Show  ( information panel,newInformation and dropdownSave )
        let information = document.getElementById('list-informations');
        let newInformation = document.getElementById('list-informations-new');
        let dropdownSave= document.getElementById('dropdown-save');
        gjs.insertBefore(dropdownSave, gjs.childNodes[0]);
        gjs.insertBefore(newInformation, gjs.childNodes[0]);
        gjs.insertBefore(information, gjs.childNodes[0]);
         //show slide-list-modal in fullscreen
        let slidelistmodal= document.getElementById('slide-list');
        gjs.insertBefore(slidelistmodal, gjs.childNodes[0]);
        gjs.insertBefore(leftPanel, gjs.childNodes[0]);
      });
      */
    },
    listenerFullScreen: function listenerFullScreen() {
      document.addEventListener('fullscreenchange', exitHandler);
      document.addEventListener('webkitfullscreenchange', exitHandler);
      document.addEventListener('mozfullscreenchange', exitHandler);
      document.addEventListener('MSFullscreenChange', exitHandler);

      function exitHandler() {
        if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
          try {
            document.querySelector('.gjs-off-prv').click();
          } catch (error) {}
        }
      }
    }
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var bm = editor.BlockManager;
  var pfx = 'emp-clock';
  var style = '<style>\n    .' + pfx + ' {\n     height: 15%;\n     width: 20%;\n    } \n    .' + pfx + '-container {\n     width: 100%;\n    }\n    .' + pfx + '-container-header {\n    color: #fff;\n    padding: 6px;\n    font-family: Helvetica;\n    }\n    .' + pfx + '-container-content {\n     display: flex;\n     flex-direction: row;\n     height: 100%;\n    justify-content: center;\n    }\n    .' + pfx + '-container-time-current {\n      padding-left: 0.4em;\n      padding-right: 0.4em;\n    } \n    .' + pfx + '-container-date-current {\n      display: flex;\n      flex-direction: column;\n      padding-left: 0.6em;\n      justify-content: center;\n      font-family: sans-serif;\n    }\n   \n  </style>';
  bm.add('Clock', {
    label: 'Clock',
    category: 'Widget',
    content: '<div data-gjs-type="clocks" ></div>\n        ' + style + '\n      ',
    attributes: {
      class: 'fa fa-clock-o' //icon in the panel,
    }
  });
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Mixin_js__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var domc = editor.DomComponents;
  var defaultType = domc.getType('default');
  var defaultModel = defaultType.model;
  var defaultView = defaultType.view;
  var wrapper = editor.DomComponents.getWrapper();
  var random = __WEBPACK_IMPORTED_MODULE_3__mixins_Mixin_js__["a" /* default */].methods.makeId();
  var image;
  var holidaysApi = {
    url: 'https://jours-feries-france.antoine-augusti.fr/api'
  };
  domc.addType('clocks', {
    model: defaultModel.extend({
      defaults: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, defaultModel.prototype.defaults, {
        'custom-name': 'clock',
        config: btoa(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(config)),
        tagName: 'div',
        selectable: true,
        random: random,
        resizable: {
          step: 0.2,
          minDim: 20,
          maxDim: 100,
          currentUnit: 1,
          autoHeight: true,
          tl: 1, // Top left
          tc: 0, // Top center
          tr: 1, // Top right
          cl: 0, // Center left
          cr: 0, // Center right
          bl: 1, // Bottom left
          bc: 0, // Bottom center
          br: 1 // Bottom right
        },
        traits: [{
          type: 'search',
          label: 'Localité',
          name: 'locality',
          changeProp: 1,
          defaults: 'Paris,France'
          //  attributes: { 'data-related-type': 'rss' },
        }, {
          type: 'select',
          label: 'Source',
          name: 'source',
          options: [{ value: 'analogic1', name: 'Analogique1' }, { value: 'analogic2', name: 'Analogique2' }, { value: 'numeric', name: 'Numérique' }],
          changeProp: 1
        }, {
          type: 'select',
          label: 'Date',
          name: 'hasDate',
          options: [{ value: 'yes', name: 'Oui' }, { value: 'no', name: 'Non' }],
          changeProp: 1
        }, {
          type: 'color',
          label: 'Couleur horloge',
          name: 'clock_color',
          changeProp: 1,
          defaults: 'black'
        }, {
          type: 'color',
          label: 'Couleur Texte',
          name: 'text_color',
          changeProp: 1,
          defaults: 'black'
        }, {
          type: 'color',
          label: "couleurs d'arrière plans",
          name: 'background_color',
          changeProp: 1,
          defaults: 'black'
        }],
        hasDate: 'yes',
        source: 'analogic1',
        locality: 'Paris',
        holidays: [],
        style: {
          width: '40%',
          height: '16.6%',
          'font-size': '2vw'
        },
        copyable: true,
        copied: false,
        saved: false,
        script: function script() {
          var css_file = document.createElement('link');
          css_file.setAttribute('rel', 'stylesheet');
          css_file.setAttribute('type', 'text/css');
          css_file.setAttribute('href', '//s.bookcdn.com//css/cl/bw-cl-180x170r1.css');
          document.getElementsByTagName('head')[0].appendChild(css_file);
          function setWidgetData_424274807(data) {
            if (typeof data != 'undefined' && data.results.length > 0) {
              for (var i = 0; i < data.results.length; ++i) {
                var objMainBlock = '';
                var params = data.results[i];
                objMainBlock = document.getElementById('tw_' + params.widget_type + '_' + params.widget_id);
                if (objMainBlock !== null) objMainBlock.innerHTML = params.html_code;
              }
            }
          }
          var config = '{[ config ]}';
          var conf = JSON.parse(atob(config));
          var id = this.id;

          function updateClock(hours, minutes, seconds) {
            var hourDegrees = hours * 30;
            var minuteDegrees = minutes * 6;
            var secondDegrees = seconds * 6;
            var hour = $('#' + id + ' .hour-hand');
            var minute = $('#' + id + ' .minute-hand');
            var second = $('#' + id + ' .second-hand');
            if (hour) {
              hour.css({
                transform: 'rotate(' + hourDegrees + 'deg)'
              });
            }
            if (minute) {
              minute.css({
                transform: 'rotate(' + minuteDegrees + 'deg)'
              });
            }
            if (second) {
              second.css({
                transform: 'rotate(' + secondDegrees + 'deg)'
              });
            }
          }

          setClockWithCurrentTime();
          function setClockWithCurrentTime() {
            var date = new Date();
            var hours = (date.getHours() + 11) % 12 + 1;
            var minutes = date.getMinutes();
            var seconds = date.getSeconds();
            setTimeout(function () {
              updateClock(hours, minutes, seconds);
            }, 100);
          }

          setInterval(setClockWithCurrentTime, 1000);
          function getDateTime() {
            var now = new Date();
            var hour = now.getHours();
            var minute = now.getMinutes();
            var second = now.getSeconds();
            if (hour.toString().length === 1) {
              hour = '0' + hour;
            }
            if (minute.toString().length === 1) {
              minute = '0' + minute;
            }
            if (second.toString().length === 1) {
              second = '0' + second;
            }
            var dateTime = hour + ':' + minute + ':' + second;
            return dateTime;
          }
          function getFullDate() {
            var now = new Date();
            var year = now.getFullYear();
            var months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
            var month = months[now.getMonth()];
            var day = now.getDate();
            var fullDate = day + ' ' + conf.translate[month]; // + ' ' + year;
            return fullDate;
          }
          function getDay() {
            var now = new Date();
            var days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
            var day = days[now.getDay()];
            return conf.translate[day] + ' ';
          }
          function getHolidays() {
            var holidays = JSON.parse(localStorage.getItem('gjs-holidays-' + new Date().getFullYear())) || [];
            var holiday = holidays.find(function (h) {
              return Math.floor((new Date().getTime() - new Date(h.date).getTime()) / (1000 * 60 * 60 * 24)) === 0;
            });
            return holiday ? 'Fête du jour: ' + holiday.nom_jour_ferie : '';
          }
          var clock = document.getElementById(id);
          clock.className.replace('gjs-comp-selected', '');
          var c = clock.className;
          var allclock = document.querySelectorAll('.' + c);
          allclock.forEach(function (clock) {
            var timeEl = clock.querySelector('[data-js=clock-time]');
            var dayEl = clock.querySelector('[data-js=clock-day]');
            var fullDateEl = clock.querySelector('[data-js=clock-date]');
            var holidays = clock.querySelector('[data-js=clock-holidays]');
            var title = clock.querySelector('[data-js=clock-title]');
            // example usage: realtime clock
            if (timeEl) {
              timeEl.innerHTML = '<h3>' + getDateTime() + '</h3>';
              setInterval(function () {
                timeEl.innerHTML = '<h3>' + getDateTime() + '</h3>';
              }, 1000);
            }
            if (dayEl) {
              dayEl.innerHTML = '<strong>' + getDay() + '</strong>';
            }
            if (fullDateEl) {
              fullDateEl.innerHTML = '<strong>' + getFullDate() + '</strong>';
            }
            if (title) {
              title.innerHTML = conf.translate.title_clock;
            }
            if (holidays) {
              holidays.innerHTML = getHolidays();
            }
          });
        }
      })
    }, {
      isComponent: function isComponent(el) {
        var result = '';
        if (el.tagName === 'div') {
          result = { type: 'clocks' };
        }
        return result;
      }
    }),
    view: defaultView.extend({
      initialize: function initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
        this.listenTo(this.model, 'change:hasDate', this.handleUpdateSrc);
        this.listenTo(this.model, 'change:source', this.handleUpdateSrc);
        this.listenTo(this.model, 'change:locality', this.handleUpdateLocality);
        this.listenTo(this.model, 'change:text_color', this.handleTextColor);
        this.listenTo(this.model, 'change:clock_color', this.handleClockColor);
        this.listenTo(this.model, 'change:background_color', this.handleBackgroundColor);
      },
      buildUrl: function buildUrl() {
        return holidaysApi.url + '/' + this.getYear();
      },
      getYear: function getYear() {
        var now = new Date();
        var year = now.getFullYear();
        return year;
      },
      handleUpdateSrc: function handleUpdateSrc() {
        var _this = this;

        var cssComposer = editor.CssComposer;
        var classes = this.model.getClasses();
        var style = cssComposer.getClassRule(classes[0]);
        var newDim = void 0;
        var resizable = this.model.get('resizable');
        this.model.set('random', __WEBPACK_IMPORTED_MODULE_3__mixins_Mixin_js__["a" /* default */].methods.makeId());
        if (this.model.get('source') === 'analogic1') {
          style = {
            width: '40%',
            height: '16.6%',
            'font-size': '2vw'
          };
          newDim = {
            minDim: 15
          };
          this.getAnalogicClock1();
        } else if (this.model.get('source') === 'analogic2') {
          style = {
            width: '32%',
            height: '24%',
            'font-size': '1.6vw'
          };
          newDim = {
            minDim: 20
          };
          this.getAnalogicClock2();
        } else {
          style = {
            width: '30%',
            height: '20%',
            'font-size': '1.45vw'
          };
          newDim = {
            minDim: 10
          };
          this.getNumericClock();
        }
        this.model.set('resizable', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, resizable, newDim));
        this.handleTextColor(classes);
        this.handleBackgroundColor(classes);
        this.handleClockColor(classes);
        editor.select(wrapper);
        if (classes && classes[0] && style) {
          var oldStyle = cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes ? cssComposer.getClassRule(classes[0]).attributes.style : {};
          var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, oldStyle, style);
          cssComposer.setClassRule(classes[0], newStyle);
        }
        var tidesModel = editor.getComponents().models.find(function (item) {
          return _this.view && item.attributes.attributes.id === _this.view.el.id;
        });
        var localStorageComponents = JSON.parse(localStorage.getItem('gjs-components')).map(function (item) {
          if (_this.view && item.attributes.id === _this.view.el.id) {
            item = tidesModel;
          }
          return item;
        });
        this.model.view.el.className.replace('gjs-comp-selected', '');
        localStorage.setItem('gjs-js', editor.getJs());
        localStorage.setItem('gjs-html', editor.getHtml());
        localStorage.setItem('gjs-components', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(localStorageComponents));
      },
      handleUpdateLocality: function handleUpdateLocality() {
        var locality = this.model.get('locality').toLowerCase();
        if (locality.indexOf('paris') + locality.indexOf('france') > -2) {
          var holidays = localStorage.getItem('gjs-holidays-' + this.model.view.getYear());
          if (holidays) {
            this.model.set('holidays', JSON.parse(holidays));
          } else {
            var xhttp = new XMLHttpRequest();
            var self = this;
            xhttp.onreadystatechange = function () {
              if (this.readyState === 4 && this.status === 200) {
                var data = JSON.parse(this.response);
                localStorage.setItem('gjs-holidays-' + self.model.view.getYear(), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
                self.model.set('holidays', data);
              }
            };
            xhttp.open('GET', self.buildUrl(), true);
            xhttp.send();
          }
        }
      },
      handleClockColor: function handleClockColor() {
        var color = this.model.get('clock_color');
        var id = this.el.id;

        var classes = ['clock-' + this.model.get('random'), 'icon-clock-' + this.model.get('random')];
        if (this.model.get('source') === 'analogic1') {
          classes = ['clock-' + this.model.get('random')];
        } else if (this.model.get('source') === 'analogic2') {
          classes = ['icon-clock-' + this.model.get('random')];
        }

        var cssComposer = editor.CssComposer;
        if (!(color && id)) {
          return;
        }
        var iframe = document.querySelector('.gjs-frame').contentWindow;
        var el = iframe.document.querySelector('#' + id + ' .clock,  #' + id + ' .icon-clock');
        var style = {
          'background-color': color,
          'background-image': 'radial-gradient(circle at center, #ffffff 0.3em, transparent 0.2em),\n    radial-gradient(circle at center, ' + color + ' 50%, transparent 50%, transparent 65%, ' + color + ' 65%),\n    linear-gradient(to right, transparent 49%, #ffffff 49%, #ffffff 51%, transparent 51%),\n    linear-gradient(to bottom, transparent 49%, #ffffff 49%, #ffffff 51%, transparent 51%),\n    linear-gradient(-30deg, transparent 49.8%, #ffffff 49.8%, #ffffff 50.2%, transparent 50.2%),\n    linear-gradient(30deg, transparent 49.8%, #ffffff 49.8%, #ffffff 50.2%, transparent 50.2%),\n    linear-gradient(60deg, transparent 49.8%, #ffffff 49.8%, #ffffff 50.2%, transparent 50.2%),\n    linear-gradient(-60deg, transparent 49.8%, #ffffff 49.8%, #ffffff 50.2%, transparent 50.2%)'
        };
        if (el) {
          el.style.backgroundColor = style['background-color'];
          el.style.backgroundImage = style['background-image'];
          if (classes && classes.length > 0 && style) {
            for (var i = 0; i < classes.length; i++) {
              var oldStyle = cssComposer.getClassRule(classes[i]) && cssComposer.getClassRule(classes[i]).attributes ? cssComposer.getClassRule(classes[i]).attributes.style : {};
              var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, oldStyle, style);
              // let newClass ='i-'+classes[i];
              // grapesjsEMP.editors[0].getSelected().removeClass(classes[i]);
              // grapesjsEMP.editors[0].getSelected().addClass(newClass);
              // cssComposer.setClassRule(newClass, newStyle);
              cssComposer.setClassRule(classes[i], newStyle);
            }
          }
        }
      },
      handleTextColor: function handleTextColor() {
        var color = this.model.get('text_color');
        var id = this.el.id;

        var classes = ['emp-clock-container-date-current-' + this.model.get('random'), 'emp-clock-container-time-current-' + this.model.get('random'), 'numeric-date-' + this.model.get('random')];

        if (this.model.get('source') === 'analogic1') {
          classes = ['emp-clock-container-date-current-' + this.model.get('random')];
        } else if (this.model.get('source') === 'analogic2') {
          classes = ['emp-clock-container-date-current-' + this.model.get('random')];
        } else {
          classes = ['emp-clock-container-time-current-' + this.model.get('random'), 'numeric-date-' + this.model.get('random')];
        }

        var cssComposer = editor.CssComposer;
        if (!(color && id)) {
          return;
        }
        var iframe = document.querySelector('.gjs-frame').contentWindow;
        var el = iframe.document.querySelector('#' + id + ' .emp-clock-container-date-current, #' + id + ' .emp-clock-container-time-current');
        var elDate = iframe.document.querySelector('#' + id + ' .numeric-date');
        var style = {
          color: color
        };
        if (el) {
          el.style.color = style.color;
        }
        if (elDate) {
          elDate.style.color = style.color;
        }

        if (el || elDate) {
          if (classes && classes.length > 0 && style) {
            for (var i = 0; i < classes.length; i++) {
              var oldStyle = cssComposer.getClassRule(classes[i]) && cssComposer.getClassRule(classes[i]).attributes ? cssComposer.getClassRule(classes[i]).attributes.style : {};
              var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, oldStyle, style);
              cssComposer.setClassRule(classes[i], newStyle);
            }
          }
        }
      },
      handleBackgroundColor: function handleBackgroundColor() {
        var color = this.model.get('background_color');
        var id = this.el.id;

        var classes = ['emp-clock-container-' + this.model.get('random'), 'icon-clock-' + this.model.get('random')];
        if (this.model.get('source') === 'analogic1') {
          classes = ['emp-clock-container-' + this.model.get('random')];
        } else if (this.model.get('source') === 'analogic2') {
          classes = ['emp-clock-container-' + this.model.get('random')];
        } else {
          classes = ['emp-clock-container-' + this.model.get('random'), 'icon-clock-' + this.model.get('random')];
        }

        var cssComposer = editor.CssComposer;
        if (!(color && id)) {
          return;
        }
        var iframe = document.querySelector('.gjs-frame').contentWindow;
        var el = iframe.document.querySelector('#' + id + ' .emp-clock-container, #' + id + ' .icon-clock');
        var style = {
          'background-color': color
        };
        if (el) {
          el.style.backgroundColor = style['background-color'];
          if (classes && classes.length > 0 && style) {
            for (var i = 0; i < classes.length; i++) {
              var oldStyle = cssComposer.getClassRule(classes[i]) && cssComposer.getClassRule(classes[i]).attributes ? cssComposer.getClassRule(classes[i]).attributes.style : {};
              var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, oldStyle, style);
              cssComposer.setClassRule(classes[i], newStyle);
            }
          }
        }
      },
      getFullDate: function getFullDate() {
        var now = new Date();
        var year = now.getFullYear();
        var month = now.getMonth();
        if (month < 10) {
          month = '0' + month;
        }
        var day = now.getDate();
        var fullDate = year + '-' + month + '-' + day;
        return fullDate;
      },
      getNumericClock: function getNumericClock() {
        var comps = this.model.get('components');
        // Add a basic countdown template if it's not yet initialized

        var content = '\n          <div id="clock-grapes" class="emp-clock-container-' + this.model.get('random') + ' emp-clock-container ">\n              <div id="digital-clock" class="emp-clock-container-content digital-clock">\n                  <div data-js="clock-time" class="emp-clock-container-time-current-' + this.model.get('random') + '  emp-clock-container-time-current" >\n                      <h3>--:--:--</h3>\n                  </div>\n                  <div class="numeric-date-' + this.model.get('random') + ' numeric-date" ' + (this.model.get('hasDate') === 'yes' ? '' : 'hidden') + '>\n                    <span data-js="clock-day">Lundi</span>\n                    <span data-js="clock-date">01 janvier</span>\n                  </div>\n              </div>\n          </div>';
        if (comps.length === 0) {
          comps.reset();
          comps.add(content);
        } else {
          // setTimeout(() => {
          this.model.set('components', content);
          //}, 1000);
        }
      },
      getAnalogicClock1: function getAnalogicClock1() {
        var comps = this.model.get('components');
        // Add a basic countdown template if it's not yet initialized
        var content = '\n              <div id="clock-grapes" class="emp-clock-container-' + this.model.get('random') + ' emp-clock-container">\n                  <div class="emp-clock-container-content">\n                      <div class="clock-' + this.model.get('random') + ' clock">\n                          <div id="hour" class=" hour-hand hour"></div>\n                          <div id="min" class=" minute-hand min"></div>\n                          <div id="sec" class=" second-hand sec"></div>\n                      </div>\n                      <div class="emp-clock-container-time-date">\n                          <div class="emp-clock-container-date-current-' + this.model.get('random') + ' emp-clock-container-date-current">\n                              <div class="date-analog2" ' + (this.model.get('hasDate') === 'yes' ? '' : 'hidden') + '>\n                                  <span data-js="clock-day"><strong>Lundi</strong></span>\n                                  <span data-js="clock-date" ><strong>01 janvier</strong></span>\n                               </div>\n                              <div data-js="clock-holidays" class="holiday"></div>\n                          </div>\n                      </div>\n                  </div>\n              </div>';
        if (comps.length === 0) {
          comps.reset();
          comps.add(content);
        } else {
          this.model.set('components', content);
        }
      },
      getAnalogicClock2: function getAnalogicClock2() {
        var comps = this.model.get('components');
        // Add a basic countdown template if it's not yet initialized

        var content = '\n        <div id="clock-grapes" class="emp-clock-container-' + this.model.get('random') + ' emp-clock-container ">\n            <div class="emp-clock-container-content analog2">\n                <div class=" icon-clock-' + this.model.get('random') + '   icon-large icon-clock ">\n                    <div class="clock2">\n                        <ol>\n                            <li></li>\n                            <li></li>\n                            <li></li>\n                            <li></li>\n                            <li></li>\n                            <li></li>\n                            <li></li>\n                            <li></li>\n                            <li></li>\n                            <li></li>\n                            <li></li>\n                            <li></li>\n                        </ol>\n                        <div id="hour" class="hour-hand hour"></div>\n                        <div id="min" class="minute-hand min"></div>\n                        <div id="sec" class="second-hand sec"></div>\n                    </div>\n                </div>\n                <div class="emp-clock2-container-time-date">\n                    <div class="emp-clock-container-date-current-' + this.model.get('random') + ' emp-clock-container-date-current">\n                    <div class="date-analog2" ' + (this.model.get('hasDate') === 'yes' ? '' : 'hidden') + '>\n                        <span data-js="clock-day"><strong>Lundi</strong></span>\n                        <span data-js="clock-date"><strong>01 janvier</strong></span>\n                    </div>\n                    <span data-js="clock-holidays" class="holiday" ' + (this.getHoliday() ? '' : 'hidden') + '><strong>' + this.getHoliday() + '</strong></span>\n                    </div>\n                </div>\n            </div>\n        </div>';
        if (comps.length === 0) {
          comps.reset();
          comps.add(content);
        } else {
          this.model.set('components', content);
        }
      },
      getHoliday: function getHoliday() {
        var holidays = this.model.get('holidays') || [];
        var holiday = holidays.find(function (h) {
          return Math.floor((new Date().getTime() - new Date(h.date).getTime()) / (1000 * 60 * 60 * 24)) === 0;
        });
        return holiday ? 'Fête du jour: ' + holiday.nom_jour_ferie : null;
      },
      render: function render() {
        var _this2 = this;

        setTimeout(function () {
          _this2.handleClockColor();
          _this2.handleTextColor();
          _this2.handleBackgroundColor();
          _this2.handleUpdateLocality();
        }, 100);
        if (!this.model.get('saved')) {
          this.model.set('random', __WEBPACK_IMPORTED_MODULE_3__mixins_Mixin_js__["a" /* default */].methods.makeId());
        }

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        defaultView.prototype.render.apply(this, args);
        this.updateClasses();
        if (this.el.getElementsByTagName('DIV').length === 0) {
          this.getAnalogicClock1();
        }
        if (this.model.get('copied')) {
          this.handleUpdateSrc();
        }
        this.updateScript();
        return this;
      }
    })
  });
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_grapesjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blocks__ = __webpack_require__(386);




/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_grapesjs___default.a.plugins.add('display-clock-plugin', function (editor) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // Add components
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */])(editor, opts);

  //  // Add blocks
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__blocks__["a" /* default */])(editor, opts);
}));

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(227);


/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var c = opt;
  var bm = editor.BlockManager;
  var pfx = c.countdownClsPfx;
  var style = c.defaultStyle ? '<style>\n    .' + pfx + ' {\n      text-align: center;\n      font-family: Helvetica, serif;\n      padding: 1em !important;\n    }\n\n    .' + pfx + '-block {\n      display: inline-block;\n      margin: 0 10px;\n      padding: 10px;\n    }\n\n    /*.' + pfx + '-digit {\n      font-size: 5rem;\n    }*/\n.' + pfx + '-container{\ndisplay : flex;\nflex-direction: column;\npointer-events: none;\nwidth: 100%;\nheight: 100%;\n}\n    .' + pfx + '-cont,\n    .' + pfx + '-block {\n      display: inline-block;\n    }\n\n  </style>' : '';

  if (c.blocks.indexOf(__WEBPACK_IMPORTED_MODULE_0__consts__["a" /* countdownRef */]) >= 0) {
    bm.add(__WEBPACK_IMPORTED_MODULE_0__consts__["a" /* countdownRef */], {
      label: c.labelCountdown,
      category: c.labelCountdownCategory,
      attributes: { class: 'fa fa-clock-o' },
      content: '\n        <div class="' + pfx + '" data-gjs-type="custom-countdown"></div>\n        ' + style + '\n      '
    });
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var c = config;
  var domc = editor.DomComponents;
  var defaultType = domc.getType('default');
  var defaultModel = defaultType.model;
  var defaultView = defaultType.view;
  var pfx = c.countdownClsPfx;
  var Modele;
  domc.addType('custom-countdown', {
    model: defaultModel.extend({
      defaults: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, defaultModel.prototype.defaults, {
        'custom-name': 'custom-countdown',
        config: btoa(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config)),
        tagName: 'div',
        selectable: true,
        traits: [{
          type: 'select',
          label: 'Model',
          name: 'Modele',
          options: [{ value: 'CountDown1', name: c.countdown1 }, { value: 'CountDown2', name: c.countdown2 }, { value: 'CountDown3', name: c.countdown3 }],
          changeProp: 1
        }, {
          type: c.dateInputType,
          label: 'Date cible',
          name: 'startfrom',
          changeProp: 1
        }, {
          type: 'time',
          label: 'Temps cible',
          name: 'hourfrom',
          changeProp: 1
        }, {
          type: 'checkbox',
          label: 'Afficher la date de début',
          name: 'showStartDate',
          valueTrue: 'show',
          valueFalse: 'hide',
          changeProp: 1
        }, {
          type: 'select',
          label: 'Position',
          name: 'position',
          options: [{ value: 'start', name: c.textBefore }, { value: 'end', name: c.textAfter }],
          changeProp: 1
        }, {
          type: 'select',
          label: 'Choisir le format',
          name: 'source',
          options: [{ value: 'JJ/MM/AAAA', name: '01/01/2020' }, { value: 'JJ/MMMM/AAAA', name: '01 january 2020' },
          //{ value: 'JJ/MMMMM/AAAA', name: '01/january/2020' },
          { value: 'JJ/MM', name: '01/01' }, { value: 'JJ/MMMM', name: '01 january' }],
          changeProp: 1
        }, {
          label: 'Texte de début',
          name: 'startText',
          changeProp: 1
        }, {
          type: 'select',
          label: c.labelDays,
          name: 'formJours',
          options: [{ value: c.labelDays, name: c.labelDays }, { value: 'Jr', name: 'Jr' }, { value: 'J', name: 'J' }],
          changeProp: 1
        }, {
          type: 'select',
          label: c.labelHours,
          name: 'formHeures',
          options: [{ value: c.labelHours, name: c.labelHours }, { value: 'Hr', name: 'Hr' }, { value: 'H', name: 'Hr' }],
          changeProp: 1
        }, {
          type: 'select',
          label: c.labelMinutes,
          name: 'formMinutes',
          options: [{ value: c.labelMinutes, name: c.labelMinutes }, { value: 'Mn', name: 'Mn' }, { value: 'M', name: 'M' }],
          changeProp: 1
        }, {
          type: 'select',
          label: c.labelSeconds,
          name: 'formSecondes',
          options: [{ value: c.labelSeconds, name: c.labelSeconds }, { value: 'Sec', name: 'Sec' }, { value: 'S', name: 'S' }],
          changeProp: 1
        }, {
          label: 'End text',
          name: 'endText',
          changeProp: 1
        }],
        copyable: true,
        endText: c.endText,
        showStartDate: 'show',
        source: 'JJ/MM/AAAA',
        position: 'start',
        formJours: c.labelDays,
        formHeures: c.labelHours,
        formSecondes: c.labelSeconds,
        formMinutes: c.labelMinutes,
        // resizable: {
        //   step: 0.2,
        //   minDim: 15,
        //   maxDim: 100,
        //   currentUnit: 1,
        //   autoHeight: true,
        //   tl: 1, // Top left
        //   tc: 0, // Top center
        //   tr: 1, // Top right
        //   cl: 0, // Center left
        //   cr: 0, // Center right
        //   bl: 1, // Bottom left
        //   bc: 0, // Bottom center
        //   br: 1, // Bottom right
        // },
        init: function init() {
          this.listenTo(this.model, 'change:Modele', this.updateScript);
          this.listenTo(this.model, 'change:startfrom change:hourfrom change:showStartDate change:endText change:position', this.updateScript);
        },
        updateScript: function updateScript() {
          this.script();
        },

        script: function script() {
          var startfrom = '{[ startfrom ]}';
          var hourfrom = '{[ hourfrom ]}';
          var showText = '{[ showStartDate ]}';
          var endTxt = '{[ endText ]}';
          var position = '{[ position ]}';

          var countDownDate = new Date(startfrom).getTime();
          var countdownCont = this.querySelector('[data-js=countdown-cont]');
          var countdownEl = this.querySelector('[data-js=countdown]');
          var endTextEl = this.querySelector('[data-js=countdown-endtext]');
          var textEl = this.querySelector('[data-js=countdown-text]');
          var dateEl = this.querySelector('[data-js=countdown-date]');
          var dayEl = this.querySelector('[data-js=countdown-day]');
          var hourEl = this.querySelector('[data-js=countdown-hour]');
          var minuteEl = this.querySelector('[data-js=countdown-minute]');
          var secondEl = this.querySelector('[data-js=countdown-second]');
          var oldInterval = this.gjs_countdown_interval;
          if (endTextEl) {
            endTextEl.style.display = 'none';
          }
          if (oldInterval) {
            oldInterval && clearInterval(oldInterval);
          }
          if (showText) {
            if (textEl) {
              if (showText === 'show') {
                textEl.style.display = 'flex';
              } else {
                textEl.style.display = 'none';
              }
            }
            var setCircleAnimation = function setCircleAnimation(days, hours, minutes, seconds) {
              var xSeconds = 60 / seconds;
              var xMinute = 60 / minutes;
              var xHours = 24 / hours;
              var xDays = 365 / days;
              var initialOffsetxSeconds = 440 - 440 / xSeconds;
              var initialOffsetxMinute = 440 - 440 / xMinute;
              var initialOffsetxHours = 440 - 440 / xHours;
              var initialOffsetxDays = 440 - 440 / xDays;
              if ('00' === seconds) {
                return;
              }

              $('.circle_animation_second').css('stroke-dashoffset', initialOffsetxSeconds);
              $('.circle_animation_minute').css('stroke-dashoffset', initialOffsetxMinute);
              $('.circle_animation_hour').css('stroke-dashoffset', initialOffsetxHours);
              $('.circle_animation_day').css('stroke-dashoffset', initialOffsetxDays);
            };

            var setTimer = function setTimer(days, hours, minutes, seconds) {
              setCircleAnimation(days, hours, minutes, seconds);
              dayEl.innerHTML = days < 10 ? '0' + days : days;
              hourEl.innerHTML = hours < 10 ? '0' + hours : hours;
              minuteEl.innerHTML = minutes < 10 ? '0' + minutes : minutes;
              secondEl.innerHTML = seconds < 10 ? '0' + seconds : seconds;
            };
          }
          var moveTimer = function moveTimer() {
            var now = new Date().getTime();
            if (hourfrom) {
              countDownDate = new Date(startfrom + 'T' + hourfrom).getTime();
            }
            var distance = countDownDate - now;

            var days = Math.floor(distance / 86400000);
            var hours = Math.floor(distance % 86400000 / 3600000);
            var minutes = Math.floor(distance % 3600000 / 60000);
            var seconds = Math.floor(distance % 60000 / 1000);

            setTimer(days, hours, minutes, seconds);

            /* If the count down is finished, write some text */
            if (distance < 0) {
              clearInterval(interval);
              endTextEl.innerHTML = endTxt;
              countdownEl.style.display = 'none';
              if (countdownCont) {
                countdownCont.style.padding = '0.8em 10em';
              }
              if (textEl) {
                textEl.style.display = 'none';
              }
              if (dateEl) {
                dateEl.style.display = 'none';
              }
              endTextEl.style.display = '';
            }
          };

          if (countDownDate) {
            var interval = setInterval(moveTimer, 1000);
            this.gjs_countdown_interval = interval;
            endTextEl.style.display = 'none';
            if (countdownCont) {
              if (position === 'start') {
                countdownCont.style.padding = '0.8em 0 0 0em';
              } else {
                countdownCont.style.padding = '0 0 0.8em 0em';
              }
            }
            countdownEl.style.height = '';

            moveTimer();
          } else {
            setTimer(0, 0, 0, 0);
          }
        }
      }),
      init: function init() {
        this.listenTo(this, 'change:Modele change:formJours change:formHeures change:formSecondes change:formMinutes  ', this.updateModele);
        this.listenTo(this, 'change:position change:showStartDate change:startfrom change:hourfrom change:startText change:source', this.updatePositionText);
        this.listenTo(this.model, 'change:startfrom change:hourfrom change:endText change:position', this.updateScript);

        var configMixin = __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin__["a" /* default */].methods.getLangCode('display-countdown-plugin');
        window.y = this;
        this.attributes.traits.models.forEach(function (p, index) {
          var name = p.attributes.name;
          p.set('label', configMixin.translate[name]);
          p.set('title', configMixin.translate[name]);
        });
      },
      toHTML: function toHTML() {
        return this.view && this.view.el.getAttribute('data-gjs-type') === 'custom-countdown' ? this.view.el.outerHTML : '';
      },
      updateModele: function updateModele() {
        this.view.changeModele(this.get('Modele'));
      },
      updatePositionText: function updatePositionText() {
        this.view.changePositionText(this.get('position'), this.get('showStartDate'), this.get('startfrom'), this.get('hourfrom'), this.get('startText'), this.get('source'));
      },
      isComponent: function isComponent(el) {
        if (el.getAttribute('data-gjs-type') === 'custom-countdown') {
          return {
            type: 'custom-countdown'
          };
        }
      }
    }, {
      isComponent: function isComponent(el) {
        var result = '';
        if (el.tagName === 'div') {
          result = { type: 'custom-countdown' };
        }
        return result;
      }
    }),
    view: defaultView.extend({
      init: function init() {
        this.listenTo(this, 'change:Modele', this.updateModele);
        this.listenTo(this.model, 'change:startfrom change:hourfrom change:showStartDate change:endText change:position', this.updateScript);
      },
      initialize: function initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
      },


      /**
       * Update the map on the canvas
       * @private
       */

      changeType: function changeType(input, type) {
        var now = new Date(input);
        var year = now.getFullYear();
        var date = now.getDate();
        var months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
        var month = months[now.getMonth()];
        //var monthTra = conf.translate[month];
        var JJ_MM_AAAA = date + '/' + Number(months.indexOf(month) + 1) + '/' + year;
        var JJ_MM = date + '/' + Number(months.indexOf(month) + 1);
        var JJMMMMAAAA = date + ' ' + months[now.getMonth()] + ' ' + year;
        var JJMMMM = date + ' ' + months[now.getMonth()];
        if (type === 'JJ/MM/AAAA') return JJ_MM_AAAA;
        if (type === 'JJ/MMMM/AAAA') return JJMMMMAAAA;
        if (type === 'JJ/MM') return JJ_MM;
        if (type === 'JJ/MMMM') return JJMMMM;
        if (type === ' ' || !type) return ' ';
      },
      changePositionText: function changePositionText(position, showText, startfrom, hourfrom, startText, type) {
        if (position) {
          localStorage.setItem('position', position);
        }
        if (startfrom) {
          var newVal = this.changeType(startfrom, type);
          localStorage.setItem('startfrom', newVal);
          if (new Date(startfrom).getTime() > new Date().getTime()) {
            this.model.set('showstartdate', 'show');
          }
        }

        if (showText) {
          localStorage.setItem('showText', showText);
          this.model.set('showstartdate', showText);
          this.displayDateTraits(showText);
        }
        if (startText) {
          // localStorage.setItem('startText', startText);
        }
        localStorage.setItem('gjs-js', editor.getJs());
        this.handleUpdate();
        var comps = this.model.get('components');
        if (comps.length !== 0) {
          this.getComponent();
        }
      },
      displayDateTraits: function displayDateTraits(showText) {
        window.z = this.model;
        var traits = ['position', 'startText', 'source'];
        if (this.model.get('traits') && this.model.get('traits').models && this.model.get('traits').length > 0) {
          for (var i = 0; i < this.model.get('traits').models.length; i++) {
            if (traits.indexOf(this.model.get('traits').models[i].attributes.name) > -1) {
              this.model.get('traits').models[i].set('showStartDate', showText);
              if (this.model.get('traits').models[i].view.el) {
                if (showText === 'show') {
                  this.model.get('traits').models[i].view.el.style.display = 'flex';
                } else {
                  this.model.get('traits').models[i].view.el.style.display = 'none';
                }
              }
            }
          }
        }
      },
      changeModele: function changeModele(Modeles, self) {
        if (Modeles) {
          Modele = Modeles;
          localStorage.setItem('Modele', Modele);
        }
        this.model.set('Modele', Modele);
        var classes = this.model.getClasses();
        var cssComposer = editor.CssComposer;
        var style = {};
        localStorage.setItem('gjs-js', editor.getJs());
        this.handleUpdate();
        var comps = this.model.get('components');
        if (comps.length !== 0) {
          this.getComponent();
        }
        //--------------------------------------
        if (classes && classes[0]) {
          var oldStyle = cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes ? cssComposer.getClassRule(classes[0]).attributes.style : {};
          style = {
            'border-radius': '0px;'
          };
          if (Modeles === 'CountDown2') {
            style = {
              'border-radius': '10.6px;'
            };
          }
          var newStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, oldStyle, style);
          cssComposer.setClassRule(classes[0], newStyle);
        }
      },
      handleUpdate: function handleUpdate() {
        var _this = this;

        var tidesModel = editor.getComponents().models.find(function (item) {
          return _this.view && item.attributes.attributes.id === _this.view.el.id;
        });
        var localStorageComponents = JSON.parse(localStorage.getItem('gjs-components')).map(function (item) {
          if (_this.view && item.attributes.id === _this.view.el.id) {
            item = tidesModel;
          }
          return item;
        });
        this.updateScript();
        localStorage.setItem('gjs-js', editor.getJs());
        localStorage.setItem('gjs-html', editor.getHtml());
        localStorage.setItem('gjs-components', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(localStorageComponents));
      },
      getComponent: function getComponent() {
        this.model.set('config', btoa(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_2__mixins_Mixin__["a" /* default */].methods.getLangCode('display-countdown-plugin'))));
        var styleModel = localStorage.getItem('Modele') || this.model.get('Modele') || 'CountDown1';
        var startEnd = localStorage.getItem('position') || this.model.get('position') || 'start';
        var startfrom = localStorage.getItem('startfrom') || this.model.get('startfrom') || ' ';
        var startText = localStorage.getItem('startText') || this.model.get('startText') || ' ';
        //  let showText = localStorage.getItem('startText') || this.model.get('startText') || ' ';
        var endText = localStorage.getItem('endText') || this.model.get('endText') || ' ';

        var formJours = this.model.get('formJours');
        var formHeures = this.model.get('formHeures');
        var formSecondes = this.model.get('formSecondes');
        var formMinutes = this.model.get('formMinutes');

        var comps = this.model.get('components');
        var content = '  \n           <div class="countdown-container">\n          <span data-js="countdown-cont" class=" ' + pfx + '-cont ' + styleModel + '">\n        \n           <div data-js="countdown-text" class="' + pfx + '-text-' + startEnd + '  showText" >    ' + (startText + ' ') + '  \n             <span data-js="countdown-date" class="countdown-date">  ' + startfrom + '  </span>     \n            </div>\n           <span data-js="countdown"    class="' + pfx + '-cont">\n              <div class="' + pfx + '-block">\n               <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" class="svg ' + styleModel + '">\n                 <g>\n                  <circle id="circle" class="circle_animation_day" r="69.85699" cy="81" cx="81" stroke-width="8" stroke="#029ce5" fill="none"/>\n                 </g>\n                </svg>\n                <div data-js="countdown-day" class="' + pfx + '-digit"></div>\n                <div class="' + pfx + '-label">' + formJours + '</div>\n              </div>\n             <div class="point"> :</div>\n              <div class="' + pfx + '-block">\n               <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" class="svg ' + styleModel + '">\n                 <g>\n                  <circle id="circle" class="circle_animation_hour" r="69.85699" cy="81" cx="81" stroke-width="8" stroke="#029ce5" fill="none"/>\n                 </g>\n                </svg>\n                <div data-js="countdown-hour" class="' + pfx + '-digit"></div>\n                <div class="' + pfx + '-label">' + formHeures + '</div>\n              </div>\n              <div class="point"> :</div>\n              <div class="' + pfx + '-block">\n               <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" class="svg ' + styleModel + '">\n                 <g>\n                  <circle id="circle" class="circle_animation_minute" r="69.85699" cy="81" cx="81" stroke-width="8" stroke="#029ce5" fill="none"/>\n                 </g>\n                </svg>\n                <div data-js="countdown-minute" class="' + pfx + '-digit"></div>\n                <div class="' + pfx + '-label">' + formMinutes + '</div>\n              </div>\n              <div class="point"> :</div>\n              <div class="' + pfx + '-block">\n                <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" class="svg ' + styleModel + '">\n                 <g>\n                  <circle id="circle" class="circle_animation_second" r="69.85699" cy="81" cx="81" stroke-width="8" stroke="#029ce5" fill="none"/>\n                 </g>\n                </svg>\n                <div data-js="countdown-second" class="' + pfx + '-digit"></div>\n                <div class="' + pfx + '-label">' + formSecondes + '</div>\n              </div>\n            </span>\n            <span data-js="countdown-endtext" class="' + pfx + '-endtext">' + endText + '</span>\n\n           </span>  \n</div>\n          \n\n';
        if (comps.length === 0) {
          comps.reset();
          comps.add(content);
        } else {
          this.model.set('components', content);
        }
      },
      render: function render() {
        var config = btoa(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_2__mixins_Mixin__["a" /* default */].methods.getLangCode('display-countdown-plugin')));
        this.model.set('config', config);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        defaultView.prototype.render.apply(this, args);
        this.updateClasses();
        if (this.el.getElementsByTagName('DIV').length === 0) {
          Modele = this.model.get('Modele') || 'CountDown1';
          localStorage.setItem('position', 'start');
          localStorage.setItem('startfrom', '');
          this.model.set('showStartDate', 'show');
          this.changeModele(Modele);
          this.getComponent();
        }
        return this;
      }
    })
  });
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grapesjs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grapesjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_grapesjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blocks__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__consts__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_Mixin__ = __webpack_require__(3);







/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_1_grapesjs___default.a.plugins.add('display-countdown-plugin', function (editor) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var c = opts;
  var defaults = {
    blocks: [__WEBPACK_IMPORTED_MODULE_4__consts__["a" /* countdownRef */]],
    labelstartfrom: 'Date cible',
    // Default style
    defaultStyle: true,

    // Default start time, eg. '2018-01-25 00:00'
    startTime: '',

    // Text to show when the countdown is ended
    endText: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_5__mixins_Mixin__["a" /* default */].methods.getLangCode('display-countdown-plugin').translate.endText)),
    countdown1: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_5__mixins_Mixin__["a" /* default */].methods.getLangCode('display-countdown-plugin').translate.countdown1)),
    countdown2: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_5__mixins_Mixin__["a" /* default */].methods.getLangCode('display-countdown-plugin').translate.countdown2)),
    countdown3: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_5__mixins_Mixin__["a" /* default */].methods.getLangCode('display-countdown-plugin').translate.countdown3)),
    // Date input type, eg, 'date', 'datetime-local'
    dateInputType: 'date',

    // Countdown class prefix
    countdownClsPfx: 'countdown',
    textBefore: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_5__mixins_Mixin__["a" /* default */].methods.getLangCode('display-countdown-plugin').translate.textBefore)),
    textAfter: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_5__mixins_Mixin__["a" /* default */].methods.getLangCode('display-countdown-plugin').translate.textAfter)),
    // Countdown label
    labelCountdown: 'Countdown',

    // Countdown category label
    labelCountdownCategory: 'Extra',

    // Days label text used in component
    labelDays: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_5__mixins_Mixin__["a" /* default */].methods.getLangCode('display-countdown-plugin').translate.labelDays)),

    // Hours label text used in component
    labelHours: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_5__mixins_Mixin__["a" /* default */].methods.getLangCode('display-countdown-plugin').translate.labelHours)),

    // Minutes label text used in component
    labelMinutes: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_5__mixins_Mixin__["a" /* default */].methods.getLangCode('display-countdown-plugin').translate.labelMinutes)),

    // Seconds label text used in component
    labelSeconds: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_5__mixins_Mixin__["a" /* default */].methods.getLangCode('display-countdown-plugin').translate.labelSeconds))
  };

  // Load defaults
  for (var name in defaults) {
    if (!(name in c)) c[name] = defaults[name];
  }

  // Add components
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components__["a" /* default */])(editor, c);

  // Add components
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__blocks__["a" /* default */])(editor, c);
}));

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var bm = editor.BlockManager;
  var pfx = 'emp-dateHeure';
  var style = '<style>\n    .' + pfx + ' {\n    } \n    .' + pfx + '-container {\n    align-items: baseline;\n  display: flex !important;\n  flex-direction: row;\n  -webkit-flex-flow: row wrap;\n  -webkit-border-radius: 0.2em;\n  -moz-border-radius: 0.2em;\n  border-radius: 0.2em;\n    }\n    .' + pfx + '-container-header {\n    padding: 6px;\n    font-family: Arial;\n    }\n    .' + pfx + '-container-content {\n     display: flex;\n     flex-direction: row;\n    }\n    .' + pfx + '-container-time-current {\n      padding-left: 0.4em;\n      padding-right: 0.4em;\n    } \n    .' + pfx + '-container-date-current {\n      display: flex;\n      flex-direction: column;\n      padding-left: 0.6em;\n      justify-content: center;\n      font-family: sans-serif;\n    }\n   \n  </style>';
  bm.add('dateHeure', {
    label: 'Date et Heure',
    title: 'Date et Heure',
    category: 'Widget',
    content: '\n        <div   data-gjs-type="dateHeure"></div>\n        ' + style + '\n      ',
    attributes: {
      class: 'fa fa-calendar' //icon in the panel
    }
  });
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var domc = editor.DomComponents;
  var defaultType = domc.getType('default');
  var defaultModel = defaultType.model;
  var defaultView = defaultType.view;
  var image;
  domc.addType('dateHeure', {
    model: defaultModel.extend({
      defaults: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, defaultModel.prototype.defaults, {
        'custom-name': 'Date et Heure',
        config: btoa(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config)),
        tagName: 'div',
        selectable: true,
        resizable: {
          step: 0.2,
          minDim: 10,
          maxDim: 100,
          currentUnit: 1,
          autoHeight: true,
          tl: 1, // Top left
          tc: 0, // Top center
          tr: 1, // Top right
          cl: 0, // Center left
          cr: 0, // Center right
          bl: 1, // Bottom left
          bc: 0, // Bottom center
          br: 1 // Bottom right
        },
        copyable: true,
        traits: [{
          type: 'select',
          label: 'Choisir le format',
          name: 'source',
          options: [{ value: 'Jour+JJ/MM/AAAA+hh:mm:ss', name: 'Mercredi 19/10/2016 10:24:00' }, { value: 'Jour+JJ MMMM AAAA+hh:mm:ss', name: 'Mercredi 19 octobre 2016 10:24:00' }, { value: '+JJ/MM/AAAA+hh:mm:ss', name: '19/10/2016 10:24:00' }, { value: '+JJ MMMM AAAA+hh:mm:ss', name: '19 octobre 2016 10:24:00' }, { value: '+JJ/MM+hh:mm:ss', name: '19/10 10:24:00' }, { value: '+JJ MMMM+hh:mm:ss', name: '19 octobre 10:24:00' }, { value: '+ +hh:mm:ss', name: '10:24:00' }],
          changeProp: 1
        }],
        attributes: { style: 'display: none' },
        init: function init() {
          this.listenTo(this.model, 'change:source', this.updateType);
        },
        updateType: function updateType() {
          this.script();
        },

        script: function script() {
          var config = '{[ config ]}';
          var conf = JSON.parse(atob(config));
          var source = '{[ source ]}';
          if (source.length < 1) source = 'Jour+JJ/MM/AAAA+hh:mm:ss';
          /* get Time  */
          function getDateTime() {
            var now = new Date();
            var hour = now.getHours();
            var minute = now.getMinutes();
            var second = now.getSeconds();

            if (hour.toString().length === 1) {
              hour = '0' + hour;
            }

            if (minute.toString().length === 1) {
              minute = '0' + minute;
            }

            if (second.toString().length === 1) {
              second = '0' + second;
            }

            var dateTime = hour + ':' + minute + ':' + second;
            return dateTime;
          }
          /* get day */
          function getDay() {
            var now = new Date();
            var days = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
            var day = days[now.getDay()];
            if (source.split('+')[0] === 'Jour') return day;else return '';
          }
          function getFullDate() {
            var now = new Date();
            var year = now.getFullYear();

            var months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
            var month = months[now.getMonth()];
            var day = now.getDate();
            var monthTra = conf.translate[month];
            var pad2 = function pad2(n) {
              return n.toString().length === 1 ? '0' + n : '' + n;
            };
            var dayNum = pad2(day);
            var monthNum = pad2(now.getMonth() + 1);
            var JJ_MM_AAAA = dayNum + '/' + monthNum + '/' + year;
            var JJ_MM = dayNum + '/' + monthNum;
            var JJMMMMAAAA = day + ' ' + monthTra + ' ' + year;
            var JJMMMM = day + ' ' + monthTra;
            if (source.split('+')[1] === 'JJ/MM/AAAA') return JJ_MM_AAAA;
            if (source.split('+')[1] === 'JJ MMMM AAAA') return JJMMMMAAAA;
            if (source.split('+')[1] === 'JJ/MM') return JJ_MM;
            if (source.split('+')[1] === 'JJ MMMM') return JJMMMM;
            if (source.split('+')[1] === ' ') return ' ';
          }
          var id = this.id;
          //---------
          var c = document.getElementById(id).className.replace('gjs-comp-selected', '');
          var allDate = document.querySelectorAll('.' + c);
          // Refresh the day, date AND time together on every tick. Previously only
          // the time was updated inside the interval, so the date and weekday stayed
          // frozen on the previous day after midnight on long-running displays.
          function refreshDateHeure() {
            allDate.forEach(function (dateHeure) {
              var timeEl = dateHeure.querySelector('[data-js=dateHeure-time]');
              var fullDateEl = dateHeure.querySelector('[data-js=dateHeure-date]');
              var dayEl = dateHeure.querySelector('[data-js=dateHeure-day]');
              if (dayEl) dayEl.innerHTML = '' + getDay() + '';
              if (fullDateEl) fullDateEl.innerHTML = getFullDate();
              if (timeEl) timeEl.innerHTML = '' + getDateTime() + '';
            });
          }
          // Clear any previous timer for this widget so the script re-running
          // (e.g. on format change or re-render) doesn't stack multiple intervals.
          window.__dateHeureTimers = window.__dateHeureTimers || {};
          if (window.__dateHeureTimers[id]) {
            clearInterval(window.__dateHeureTimers[id]);
          }
          refreshDateHeure();
          window.__dateHeureTimers[id] = setInterval(refreshDateHeure, 1000);
        }
      })
    }, {
      isComponent: function isComponent(el) {
        var result = '';
        if (el.tagName === 'div') {
          result = { type: 'dateHeure' };
        }
        return result;
      }
    }),
    view: defaultView.extend({
      initialize: function initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
      },
      handleUpdate: function handleUpdate() {
        var _this = this;

        var tidesModel = editor.getComponents().models.find(function (item) {
          return _this.view && item.attributes.attributes.id === _this.view.el.id;
        });
        var localStorageComponents = JSON.parse(localStorage.getItem('gjs-components')).map(function (item) {
          if (_this.view && item.attributes.id === _this.view.el.id) {
            item = tidesModel;
          }
          return item;
        });
        localStorage.setItem('gjs-js', editor.getJs());
        localStorage.setItem('gjs-html', editor.getHtml());
        localStorage.setItem('gjs-components', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(localStorageComponents));
      },
      getComponent: function getComponent() {
        var _this2 = this;

        this.model.set('config', btoa(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_2__mixins_Mixin__["a" /* default */].methods.getLangCode('display-dateHeure-plugin'))));
        var comps = this.model.get('components');
        // Add a basic countdown template if it's not yet initialized
        var content = '\n          <div id="dateHeure-grapes" class="emp-dateHeure-container">\n           <span class="margin"data-js="dateHeure-day">Lundi </span>\n           <span class="margin" data-js="dateHeure-date">  01 janvier </span>\n           <span  class="margin" data-js="dateHeure-time" > --:--:-- </span>\n          </div>\n          ';

        if (comps.length === 0) {
          comps.reset();
          comps.add(content);
        } else {
          setTimeout(function () {
            _this2.model.set('components', content);
          }, 1000);
        }
      },
      render: function render() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        defaultView.prototype.render.apply(this, args);
        this.updateClasses();
        if (this.el.getElementsByTagName('DIV').length === 0) {
          this.getComponent(image);
        }
        this.updateScript();
        return this;
      }
    })
  });
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_grapesjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blocks__ = __webpack_require__(392);




/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_grapesjs___default.a.plugins.add('display-dateHeure-plugin', function (editor) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // Add components
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */])(editor, opts);

  //  // Add blocks
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__blocks__["a" /* default */])(editor, opts);
}));

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var bm = editor.BlockManager;
  bm.add('facebook_widget', {
    label: 'Facebook',
    category: 'Social',
    content: {
      type: 'facebook_widget',
      resizable: {
        step: 0.2,
        minDim: 10,
        currentUnit: 1,
        autoHeight: true
      },
      style: {
        width: '500px',
        height: '600px',
        transform: "scale(1.2)"
      }
    },
    attributes: {
      class: 'fa fa-facebook' //icon in the panel
    }
  });
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var domc = editor.DomComponents;
  var defaultType = domc.getType('default');
  var defaultModel = defaultType.model;
  var defaultView = defaultType.view;

  var defaultUrls = config.state.paramsClient.display_default_urls;
  var URL = defaultUrls && defaultUrls.facebook !== '' ? defaultUrls.facebook : 'https://www.facebook.com/facebook';

  domc.addType('facebook_widget', {
    model: defaultModel.extend({
      defaults: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultModel.prototype.defaults, {
        'custom-name': 'facebook',
        tagName: 'div',
        src: URL,
        width: '500',
        height: '600',
        traits: [{
          type: 'text',
          label: 'src',
          name: 'src',
          changeProp: 1
        }],
        script: function script() {
          var _this = this;

          setTimeout(function () {
            var id = _this.id;
            var element = document.querySelector('#' + id);
            var fbWrapper = element.querySelector('.iframe-facebook-wrapper');
            var fbIframe = element.querySelector('iframe');

            var elWidth = element.clientWidth;
            var elHeight = element.clientHeight;

            var fbWidth = Math.min(elWidth, 500);
            var fbHeight = elHeight;
            var scale = 1;
            var src = fbIframe.src;

            if (elWidth > 500) {
              scale = elWidth / 500;
              fbHeight = elHeight / scale;
            }

            fbWrapper.style.transform = 'scale(' + scale + ')';
            fbWrapper.style['transform-origin'] = '0 0';
            fbWrapper.style.width = fbWidth + 'px';
            fbWrapper.style.height = fbHeight + 'px';

            src = src.replace(/width=\d+/, 'width=' + Math.floor(fbWidth));
            src = src.replace(/height=\d+/, 'height=' + Math.floor(fbHeight));
            fbIframe.src = src;
          }, 100);
        }
      }),
      init: function init() {
        var _this2 = this;

        this.listenTo(this, 'change:src', this.updateSrc);
        setTimeout(function () {
          _this2.view.updateScript();
        }, 1000);
      },
      toHTML: function toHTML() {
        return this.view && this.view.el.getAttribute('data-gjs-type') == 'facebook_widget' ? this.view.el.outerHTML : '';
      },
      updateSrc: function updateSrc() {
        this.view.getIframe().src = this.createUri();
        this.view.updateScript();
      },
      createUri: function createUri() {
        return 'https://www.facebook.com/plugins/page.php?href=' + this.get('src') + '&tabs=timeline&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&width=500&height=600';
      }
    }, {
      isComponent: function isComponent(el) {
        var result = '';
        if (el.tagName == 'div') {
          result = { type: 'facebook_widget' };
        }
        return result;
      }
    }),
    view: defaultView.extend({
      initialize: function initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
      },
      getIframe: function getIframe() {
        if (!this.iframe) {
          var ifrm = document.createElement('iframe');

          // if (this.model.get('src') !== URL) {
          ifrm.src = this.model.createUri();
          // } else {
          //   ifrm.src =
          //     'https://www.facebook.com/plugins/page.php?href=' +
          //     URL +
          //     '&tabs=timeline&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&width=500&height=600';
          // }

          ifrm.className = this.ppfx + 'no-pointer';
          ifrm.width = '100%';
          ifrm.height = '100%';
          ifrm.frameBorder = '0';
          ifrm.style.border = 'none;';
          ifrm.style.overflow = 'scroll';
          ifrm.scrolling = 'no';
          ifrm.frameborder = '0';
          ifrm.allowtransparency = 'true';
          ifrm.allow = 'encrypted-media';

          this.iframe = ifrm;
        }
        return this.iframe;
      },
      render: function render() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        defaultView.prototype.render.apply(this, args);
        this.updateClasses();
        if (this.el.getElementsByTagName('IFRAME').length == 0) {
          var div = document.createElement('div');
          div.classList.add('iframe-facebook-wrapper');
          div.style.width = '100%';
          div.appendChild(this.getIframe());
          this.el.appendChild(div);
        }
        return this;
      }
    })
  });
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_grapesjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blocks__ = __webpack_require__(395);




/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_grapesjs___default.a.plugins.add('display-facebook-plugin', function (editor) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // Add components
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */])(editor, opts);

  //  // Add blocks
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__blocks__["a" /* default */])(editor, opts);
}));

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var bm = editor.BlockManager;
  var style = '<style>\n  </style>';
  bm.add('filet', {
    label: 'filet',
    title: 'filet',
    category: 'Widget',
    content: '\n        <span data-gjs-type="filet"  style="z-index: 5;\n            position: absolute;\n            left: 50%;\n            width: 3pt;\n            height:3em;\n            background-color: #E42313;">  \n        </span>\n        ' + style + '\n      ',
    attributes: {
      class: 'icon-separator' //icon in the panel
    }
  });
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var domc = editor.DomComponents;
  var defaultType = domc.getType('default');
  var defaultModel = defaultType.model;
  var defaultView = defaultType.view;
  var filet;
  domc.addType('filet', {
    model: defaultModel.extend({
      defaults: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, defaultModel.prototype.defaults, {
        'custom-name': 'Filet',
        config: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config),
        tagName: 'div',
        selectable: true,
        resizable: {
          minDim: 1,
          step: 0.1,
          currentUnit: 1,
          autoHeight: true,
          tl: 0, // Top left
          tc: 1, // Top center
          tr: 0, // Top right
          cl: 0, // Center left
          cr: 0, // Center right
          bl: 0, // Bottom left
          bc: 1, // Bottom center
          br: 0 // Bottom right
        }
      })
    }, {
      isComponent: function isComponent(el) {
        var result = '';
        if (el.tagName === 'div') {
          result = { type: 'filet' };
        }
        return result;
      }
    }),
    view: defaultView.extend({
      initialize: function initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
      },
      handleUpdate: function handleUpdate() {
        var _this = this;

        var tidesModel = editor.getComponents().models.find(function (item) {
          return _this.view && item.attributes.attributes.id === _this.view.el.id;
        });
        var localStorageComponents = JSON.parse(localStorage.getItem('gjs-components')).map(function (item) {
          if (_this.view && item.attributes.id === _this.view.el.id) {
            item = tidesModel;
          }
          return item;
        });
        localStorage.setItem('gjs-js', editor.getJs());
        localStorage.setItem('gjs-html', editor.getHtml());
        localStorage.setItem('gjs-components', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(localStorageComponents));
      },
      getComponent: function getComponent() {
        var _this2 = this;

        this.model.set('config', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_2__mixins_Mixin__["a" /* default */].methods.getLangCode('display-filet-plugin')));
        var comps = this.model.get('components');
        // Add a basic countdown template if it's not yet initialized
        var content = '';
        if (comps.length === 0) {
          comps.reset();
          comps.add(content);
        } else {
          setTimeout(function () {
            _this2.model.set('components', content);
          }, 1000);
        }
      },
      render: function render() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        defaultView.prototype.render.apply(this, args);
        this.updateClasses();
        if (this.el.getElementsByTagName('DIV').length === 0) {
          this.getComponent(filet);
        }
        return this;
      }
    })
  });
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_grapesjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blocks__ = __webpack_require__(398);




/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_grapesjs___default.a.plugins.add('display-filet-plugin', function (editor) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // Add components
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */])(editor, opts);

  //  // Add blocks
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__blocks__["a" /* default */])(editor, opts);
}));

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var bm = editor.BlockManager;
  bm.add('image_media', {
    label: 'Image',
    category: 'Media',
    content: {
      activeOnRender: 1,
      droppable: false,
      resizable: {
        step: 0.2,
        minDim: 3,
        currentUnit: 1,
        autoHeight: true
      },
      void: true,
      type: 'image_media',
      style: {
        width: '50%',
        height: '50%'
      }
    },
    attributes: {
      class: 'fa fa-image' //icon in the panel
    }
  });
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_grapesjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blocks__ = __webpack_require__(401);




/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_grapesjs___default.a.plugins.add('display-image-plugin', function (editor) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var c = opts;
  // Add components
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */])(editor, c);
  //  // Add blocks
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__blocks__["a" /* default */])(editor, c);
}));

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var bm = editor.BlockManager;

  var pfx = '[data-gjs-type="linkedin_widget"]';
  var style = '<style>\n    ' + pfx + ' {\n      height: 70%;\n      width: 60%;\n      position: relative;\n    }\n    ' + pfx + ':after {\n      content: \'\';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n    }\n    section ' + pfx + ':after {\n      content: none;\n    }\n  </style>';
  bm.add('linkedin_widget', {
    label: 'Linkedin',
    category: 'Social',
    content: '\n        <div data-gjs-type="linkedin_widget"></div>\n        ' + style + '\n      ',
    attributes: {
      class: 'fa fa-linkedin-square' //icon in the panel
    }
  });
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var domc = editor.DomComponents;
  var defaultType = domc.getType('default');
  var defaultModel = defaultType.model;
  var defaultView = defaultType.view;

  var defaultUrls = config.state.paramsClient.display_default_urls;
  var URL = defaultUrls && defaultUrls.linkedin !== '' ? defaultUrls.linkedin : 'https://www.linkedin.com/embed/feed/update/urn:li:share:6544966475646590976';

  domc.addType('linkedin_widget', {
    model: defaultModel.extend({
      defaults: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultModel.prototype.defaults, {
        'custom-name': 'linkedin',
        tagName: 'div',
        src: '<iframe src="' + URL + '" height="100%" width="100%" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>',
        resizable: {
          minDim: 10
        },
        traits: [{
          type: 'text',
          label: 'src',
          name: 'src',
          changeProp: 1,
          attributes: { 'data-related-type': 'linkedin' }
        }]
      }),
      init: function init() {
        this.listenTo(this, 'change:src', this.updateSrc);
      },
      toHTML: function toHTML() {
        return this.view && this.view.el.getAttribute('data-gjs-type') === 'linkedin_widget' ? this.view.el.outerHTML : '';
      },
      updateSrc: function updateSrc() {
        var src = this.get('src');
        src = src.replace(/(height|width)="\d+"/g, function (val) {
          return val.replace(/\d+/g, '100%');
        });
        this.set('src', src);
        this.view.getIframe();
        this.view.render();
      }
    }, {
      isComponent: function isComponent(el) {
        var result = '';
        if (el.tagName === 'div') {
          result = { type: 'linkedin_widget' };
        }
        return result;
      }
    }),
    view: defaultView.extend({
      initialize: function initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
      },
      getIframe: function getIframe() {
        var ifrm = document.createElement('div');
        ifrm.style.height = '100%';
        ifrm.style.width = '100%';
        ifrm.innerHTML = this.model.get('src');
        this.iframe = ifrm;
        return this.iframe;
      },
      render: function render() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        defaultView.prototype.render.apply(this, args);
        if (this.el.getElementsByTagName('DIV').length === 0 || this.el.querySelector('.content_iframe')) {
          this.getIframe();
        }
        this.el.appendChild(this.getIframe());
        return this;
      }
    })
  });
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_grapesjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blocks__ = __webpack_require__(403);




/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_grapesjs___default.a.plugins.add('display-linkedin-plugin', function (editor) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // Add components
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */])(editor, opts);

  //  // Add blocks
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__blocks__["a" /* default */])(editor, opts);
}));

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var bm = editor.BlockManager;
    bm.add('live', {
        label: 'live',
        category: 'Media',
        content: {
            activeOnRender: 1,
            resizable: true,
            type: 'live',
            style: {
                width: "640px",
                height: "360px"
            }
        },
        attributes: {
            class: 'fa fa-dot-circle-o' //icon in the panel
        }
    });
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Mixin_js__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var domc = editor.DomComponents;
  var defaultType = domc.getType('default');
  var defaultModel = defaultType.model;
  var defaultView = defaultType.view;
  var modal = null;
  var self;
  var live = [];
  var page = 0;
  var total_number = 1;
  var initialise = false;

  domc.addType('live', {
    model: defaultModel.extend({
      defaults: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultModel.prototype.defaults, {
        'custom-name': 'live',
        tagName: 'div',
        src: '',
        width: '100%',
        height: '100%',
        traits: [{
          type: 'text',
          label: 'src',
          name: 'src',
          changeProp: 1
        }, {
          type: 'checkbox',
          label: 'autoplay',
          name: 'autoplay',
          changeProp: 1
        }, {
          type: 'checkbox',
          label: 'loop',
          name: 'loop',
          changeProp: 1
        }, {
          type: 'checkbox',
          label: 'controls',
          name: 'controls',
          changeProp: 1
        }]
      }),
      init: function init() {
        this.listenTo(this, 'change:src', this.updateSrc);
        this.listenTo(this, 'change:autoplay', this.updateAutoplay);
        this.listenTo(this, 'change:loop', this.updateLoop);
        this.listenTo(this, 'change:controls', this.updateControl);
      },
      toHTML: function toHTML() {
        return this.view.el.getAttribute('data-gjs-type') == 'live' ? this.view.el.outerHTML : '';
      },
      updateSrc: function updateSrc() {
        this.view.getIframe().src = this.get('src');
      },
      updateAutoplay: function updateAutoplay() {
        this.updateUrlVid(this.get('autoplay'), 'a', 1);
      },
      updateLoop: function updateLoop() {
        this.updateUrlVid(this.get('loop'), 'loop', 1);
      },
      updateControl: function updateControl() {
        this.updateUrlVid(this.get('controls'), 'sc', 0);
      },
      updateUrlVid: function updateUrlVid(valueCheck, option, val) {
        var url = this.get('src');
        if (valueCheck) {
          if (url.indexOf('?') === -1) {
            url += '?' + option + '=' + val;
          } else {
            url += '&' + option + '=' + val;
          }
        } else {
          if (url.indexOf('?' + option + '=' + val) !== -1) {
            url = url.replace('?' + option + '=' + val, '');

            var index = url.indexOf('&');
            if (index !== -1) url = url.replace('&', '?');
          } else if (url.indexOf('&' + option + '=' + val) !== -1) {
            url = url.replace('&' + option + '=' + val, '');
          }
        }
        this.set('src', url);
        this.view.getIframe().src = url;
      }
    }, {
      isComponent: function isComponent(el) {
        var result = '';
        if (el.tagName == 'div') {
          result = { type: 'live' };
        }
        return result;
      }
    }),
    view: defaultView.extend({
      events: {
        dblclick: 'openModal'
      },
      initialize: function initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
        self = this;
        this.model.listenTo(this.model, 'active', self.insertIframe);
        modal = editor.Modal;
        modal.setTitle(config.translate);
      },
      getIframe: function getIframe() {
        if (!this.iframe) {
          var ifrm = document.createElement('iframe');
          ifrm.className = this.ppfx + 'no-pointer';
          ifrm.src = this.model.get('src');
          ifrm.id = 'live-' + __WEBPACK_IMPORTED_MODULE_1__mixins_Mixin_js__["a" /* default */].methods.makeId();
          ifrm.width = this.model.get('width');
          ifrm.height = this.model.get('height');
          ifrm.style = 'border:none;overflow:hidden';
          ifrm.scrolling = 'no';
          ifrm.frameborder = '0';
          ifrm.allowtransparency = 'true';
          ifrm.allow = 'encrypted-media';

          this.iframe = ifrm;
        }
        return this.iframe;
      },
      insertIframe: function insertIframe() {
        self.el.appendChild(self.getIframe());
        document.getElementById('CanvOverlay').style.display = 'block';

        self.openModal();
      },
      noVideos: function noVideos() {
        modal.setContent('<div id="modal-live-list" class="container" style=" min-height: 100px;padding:5px;display: inline-block;max-height: 660px; overflow-y: auto">\n                                        <span><img src="\n                    static/images/nofound.png" alt="nofound image"></span>\n                                   </div>');
      },
      reloadPlayersList: function reloadPlayersList() {
        page = page + 1;
        var modalContent = document.getElementById('modal-live-list');
        if (live.length < total_number) {
          self.showLoader();
          config.http(window.ApiToken).get(config.routing.generate(config.api_routing_live, {
            id: '',
            page: page,
            nbParPage: 20,
            client: config.client.paramsClient.client
          })).then(function (response) {
            self.hideLoader();

            if (response.data.code === 200) {
              var selected = 0;
              total_number = response.data.nombre_total;
              if (response.data.nombre_total === 0 && live.length === 0) {
                self.noVideos();
              } else {
                response.data.lives.forEach(function (val) {
                  var element = document.createElement('div');
                  element.id = 'i' + val.id;
                  element.className = 'player-item';
                  var srcImage;
                  if (val.thumbnail && val.thumbnail !== '') {
                    srcImage = val.thumbnail;
                  } else {
                    srcImage = '/static/images/vignette.jpg';
                  }
                  element.innerHTML = '<img src="' + srcImage + '" alt="Card image" style="height: 100px; cursor: pointer">\n                                        <div class="vidPlayer">\n                                             <h5 class="descriptionPlayer">' + val.title + '</h5>\n                                        </div>';
                  modalContent.appendChild(element);
                });

                response.data.lives.forEach(function (val) {
                  document.getElementById('i' + val.id).addEventListener('click', function () {
                    if (selected != 0) {
                      document.getElementById('i' + selected).style.removeProperty('background-color');
                      document.getElementById('i' + selected).firstElementChild.style.removeProperty('opacity');
                    }
                    selected = val.id;

                    document.getElementById('i' + val.id).style.backgroundColor = 'rgba(26, 147, 240, 0.65)';
                    document.getElementById('i' + val.id).firstElementChild.style.opacity = '0.8';
                    self.getIframe().src = val.lien;
                    self.model.set('src', val.lien);
                    self.model.updateAutoplay();
                    self.model.updateLoop();
                    self.model.updateControl();
                  });
                  document.getElementById('i' + val.id).addEventListener('dblclick', function () {
                    document.querySelector('.gjs-mdl-btn-close').click();
                  });
                });

                live = live.concat(response.data.lives);
                if (live.length === total_number) {
                  document.getElementById('modal-live-container').removeEventListener('scroll', function () {
                    var listElm = document.getElementById('modal-live-container');
                    if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
                      self.reloadPlayersList();
                    }
                  });
                  self.hideLoader();
                } else {
                  if (!initialise) {
                    document.getElementById('modal-live-container').addEventListener('scroll', function () {
                      var listElm = document.getElementById('modal-live-container');
                      if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
                        self.reloadPlayersList();
                      }
                    });
                    initialise = true;
                  }
                }
              }
            }
          }, function (response) {
            self.hideLoader();
          });
        }
      },
      hideLoader: function hideLoader() {
        document.getElementById('loader-live-list').style.visibility = 'hidden';
      },
      showLoader: function showLoader() {
        document.getElementById('loader-live-list').style.visibility = 'visible';
      },
      onScroll: function onScroll() {
        var listElm = document.getElementById('modal-live-container');
        if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
          self.reloadPlayersList();
        }
      },
      openModal: function openModal() {
        page = 0;
        live = [];
        initialise = false;
        modal.setContent('<div id="modal-live-container" class="players-list container">\n                                       <div id="modal-live-list" class="players-wrapper"></div>\n                                       <div id="loader-live-list" class="loader-4 center"><span></span></div>\n                                   </div>');
        self.reloadPlayersList();
        modal.open();
        modal.getModel().once('change:open', function () {
          document.getElementById('CanvOverlay').style.display = 'none';
          var getAllComponents = function getAllComponents(model) {
            var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            result.push(model);
            model.components().each(function (mod) {
              return getAllComponents(mod, result);
            });
            return result;
          };
          var all = getAllComponents(editor.DomComponents.getWrapper());

          for (var i = 0; i < all.length; i++) {
            var type = all[i].attributes.type;
            var src = all[i].attributes.src;
            if (type === 'player' || type === 'playlist' || type === 'live') {
              if (!src) {
                grapesjsEMP.editors[0].UndoManager.undo();
              }
            }
          }
        });
      },
      render: function render() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        defaultView.prototype.render.apply(this, args);
        this.updateClasses();
        this.updateAttributes();
        return this;
      }
    })
  });
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_grapesjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blocks__ = __webpack_require__(406);




/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_grapesjs___default.a.plugins.add('display-live-plugin', function (editor) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // Add components
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */])(editor, opts);

  //  // Add blocks
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__blocks__["a" /* default */])(editor, opts);
}));

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var bm = editor.BlockManager;
  var type = 'social_media';
  bm.add(type, {
    label: type,
    category: 'Social',
    content: {
      activeOnRender: 1,
      void: true,
      type: type,
      style: {
        width: '30%',
        height: '60%',
        overflow: 'hidden'
      },
      resizable: {
        step: 0.2,
        minDim: 10,
        currentUnit: 1,
        autoHeight: true
      }
    },
    attributes: {
      class: 'fa fa-play' //icon in the panel
    }
  });
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var domc = editor.DomComponents;
  var defaultType = domc.getType('default');
  var defaultModel = defaultType.model;
  var defaultView = defaultType.view;
  var modal = null;
  var self;
  var id = 'social-media';
  var type = 'social_media';
  var typeMedia = type;
  domc.addType(type, {
    model: defaultModel.extend({
      defaults: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, defaultModel.prototype.defaults, {
        'custom-name': typeMedia,
        type: typeMedia,
        config: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config),
        tagName: 'div',
        objectMedia: {
          data: '',
          jsonData: '',
          jsonStyle: '',
          mediaType: '',
          typeShow: ''
        },
        width: '100%',
        height: '100%',
        attributes: { style: 'display: none' },
        style: {
          width: '30%',
          height: '60%',
          overflow: 'hidden'
        }
      }),
      toHTML: function toHTML() {
        return this.view && this.view.el.getAttribute('data-gjs-type') === type ? this.view.el.outerHTML : '';
      },
      isComponent: function isComponent(el) {
        var result = '';
        if (el.tagName === 'div') {
          result = { type: type, src: el.src };
        }
        return result;
      }
    }, {
      isComponent: function isComponent(el) {
        var result = '';
        if (el.tagName === 'div') {
          result = { type: type, src: el.src };
        }
        return result;
      }
    }),
    view: defaultView.extend({
      events: {
        // click: 'sendPostMessage',
        dblclick: 'openModal'
      },
      initialize: function initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
        self = this;
        this.listenTo(this.model, 'active', self.insertIframe);
        this.listenTo(this.model, 'change:objectMedia', this.handleUpdate);
        modal = editor.Modal;
      },
      handleUpdate: function handleUpdate() {
        this.getIframe().innerHTML = this.model.get('objectMedia').data;
        if (this.model.get('objectMedia').data) {
          this.el.innerHTML = this.model.get('objectMedia').data;
        }
      },
      getIframe: function getIframe() {
        if (!this.iframe) {
          var ifrm = document.createElement('div');
          ifrm.className = this.ppfx + 'no-pointer';
          ifrm.id = id + '-' + __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__["a" /* default */].methods.makeId();
          ifrm.style = 'width:100%;height:100%;border:none;overflow:hidden';

          this.iframe = ifrm;
        }
        return this.iframe;
      },
      insertIframe: function insertIframe() {
        self.el.appendChild(self.getIframe());

        document.getElementById('CanvOverlay').style.display = 'block';
        document.getElementById(id + '-iframe').style.display = 'block';
        var config = JSON.parse(this.model.get('config'));
        var iframeHeight = '800';

        var defaultsUrls = config.route.paramsClient.display_default_urls;
        if (defaultsUrls) {
          var modalContent = document.getElementById('gjs-mdl-c-' + id);
          var imageUrl = defaultsUrls.social_media_url;
          if (imageUrl) {
            modalContent.innerHTML = __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__["a" /* default */].methods.setIframePlugin(id, imageUrl, iframeHeight);
          }
        }
        self.openModal();
      },
      closeModal: function closeModal() {
        document.getElementById(id + '-iframe').style.display = 'none';
        document.getElementById('CanvOverlay').style.display = 'none';
        this.handleEmptySocialMedia();
      },
      openModal: function openModal() {
        document.getElementById(id + '-iframe').style.display = 'block';
        self.sendPostMessage();
        modal.getModel().once('change:open', function () {
          document.getElementById('CanvOverlay').style.display = 'none';
          self.handleEmptySocialMedia();
        });
      },
      sendPostMessage: function sendPostMessage() {
        var selected = grapesjsEMP.editors[0].getSelected();
        window.w = selected;

        if (selected) {
          typeMedia = selected.attributes.objectMedia.currentPost.TypeSocial;
          var objectMedia = selected.attributes.objectMedia;
          var iframeEl = document.getElementById('iframe-' + id);

          var message = {
            info: 'updateSocialMedia',
            currentPost: objectMedia.currentPost,
            data: objectMedia.data
          };
          iframeEl.contentWindow.postMessage(message, '*');
        }
      },
      render: function render() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        defaultView.prototype.render.apply(this, args);

        if (this.model.get('objectMedia').data) {
          this.el.innerHTML = this.model.get('objectMedia').data;
        }
        this.updateClasses();
        this.updateAttributes();
        return this;
      },
      handleEmptySocialMedia: function handleEmptySocialMedia() {
        var getAllComponents = function getAllComponents(model) {
          var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

          result.push(model);
          model.components().each(function (mod) {
            return getAllComponents(mod, result);
          });
          return result;
        };
        var all = getAllComponents(editor.DomComponents.getWrapper());
        var found = all.some(function (c) {
          return c.attributes.type === type && !c.attributes.objectMedia.data;
        });
        while (found) {
          editor.UndoManager.undo();
          var _all = getAllComponents(editor.DomComponents.getWrapper());
          found = _all.some(function (c) {
            return c.attributes.type === type && !c.attributes.objectMedia.data;
          });
        }
      }
    })
  });
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_grapesjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blocks__ = __webpack_require__(409);




/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_grapesjs___default.a.plugins.add('display-social-media-plugin', function (editor) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var c = opts;
  // Add components
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */])(editor, c);
  //  // Add blocks
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__blocks__["a" /* default */])(editor, c);
}));

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var bm = editor.BlockManager;
  bm.add('pattern', {
    label: 'Pattern',
    category: 'Motif',
    content: {
      activeOnRender: 1,
      droppable: false,
      resizable: {
        step: 0.2,
        minDim: 3,
        currentUnit: 1,
        autoHeight: true
      },
      void: true,
      type: 'pattern',
      style: {
        width: '50%',
        height: '50%'
      }
    },
    attributes: {
      class: 'icon-Shape' //icon in the panel
    }
  });
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var domc = editor.DomComponents;
  var defaultType = domc.getType('default');
  var defaultModel = defaultType.model;
  var defaultView = defaultType.view;
  var modal = null;
  var self;
  domc.addType('pattern', {
    model: defaultModel.extend({
      defaults: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, defaultModel.prototype.defaults, {
        'custom-name': 'pattern',
        config: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config),
        tagName: 'div',
        src: '',
        width: '100%',
        height: '100%'
      }),
      toHTML: function toHTML() {
        return this.view && this.view.el.getAttribute('data-gjs-type') === 'pattern' ? this.view.el.outerHTML : '';
      },
      isComponent: function isComponent(el) {
        var result = '';
        if (el.tagName === 'div') {
          result = { type: 'pattern', src: el.src };
        }
        return result;
      }
    }, {
      isComponent: function isComponent(el) {
        var result = '';
        if (el.tagName === 'div') {
          result = { type: 'pattern', src: el.src };
        }
        return result;
      }
    }),
    view: defaultView.extend({
      events: {
        // click: 'eventPostMessage',
        dblclick: 'openModal'
      },
      initialize: function initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
        self = this;
        this.model.listenTo(this.model, 'active', self.insertIframe);
        this.listenTo(this.model, 'change:title', this.updateScript);
        modal = editor.Modal;
        modal.setTitle(config.translate['select_pattern']);
      },
      getIframe: function getIframe() {
        if (!this.iframe) {
          var ifrm = document.createElement('img');
          ifrm.className = this.ppfx + 'no-pointer';
          ifrm.src = this.model.get('src');
          ifrm.id = 'pattern-' + __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__["a" /* default */].methods.makeId();
          ifrm.style = 'width:100%;height:100%;border:none;overflow:hidden';

          this.iframe = ifrm;
        }
        return this.iframe;
      },
      insertIframe: function insertIframe() {
        self.el.appendChild(self.getIframe());
        document.getElementById('CanvOverlay').style.display = 'block';
        self.openModal();
      },
      closeModal: function closeModal() {
        var iframeEl = document.getElementById('pattern-iframe');
        if (iframeEl) {
          iframeEl.style.display = 'none';
        }
        document.getElementById('CanvOverlay').style.display = 'none';
        this.handleEmptyImage();
      },
      setCloseImageModal: function setCloseImageModal(comp, id) {
        var self = this;
        if (document.getElementById('close-modal-' + id)) {
          document.getElementById('close-modal-' + id).addEventListener('click', function (e) {
            self.closeModal(comp, id);
          });
        }
      },
      openModal: function openModal() {
        var iframeEl = document.getElementById('pattern-iframe');
        if (iframeEl) {
          iframeEl.style.display = 'block';
        }

        var conf = __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__["a" /* default */].methods.getLangCode('display-pattern-plugin');
        this.model.set('config', conf);
        var id = 'pattern';
        self.setCloseImageModal('pattern', id);
        modal.getModel().once('change:open', function () {
          document.getElementById('CanvOverlay').style.display = 'none';
          self.handleEmptyImage();
        });
      },
      render: function render() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        defaultView.prototype.render.apply(this, args);
        if (this.model.get('src')) {
          this.el.appendChild(this.getIframe());
        }
        this.updateClasses();
        this.updateAttributes();
        return this;
      },
      handleEmptyImage: function handleEmptyImage() {
        var getAllComponents = function getAllComponents(model) {
          var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

          result.push(model);
          model.components().each(function (mod) {
            return getAllComponents(mod, result);
          });
          return result;
        };
        var all = getAllComponents(editor.DomComponents.getWrapper());
        var found = all.some(function (c) {
          return c.attributes.type === 'pattern' && !c.attributes.src;
        });
        while (found) {
          editor.UndoManager.undo();
          var _all = getAllComponents(editor.DomComponents.getWrapper());
          found = _all.some(function (c) {
            return c.attributes.type === 'pattern' && !c.attributes.src;
          });
        }
      }
    })
  });
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_grapesjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blocks__ = __webpack_require__(412);




/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_grapesjs___default.a.plugins.add('display-pattern-plugin', function (editor) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var c = opts;
  // Add components
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */])(editor, c);
  //  // Add blocks
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__blocks__["a" /* default */])(editor, c);
}));

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var bm = editor.BlockManager;
  bm.add('video_mp4', {
    label: 'Player',
    category: 'Media',
    content: {
      activeOnRender: 1,
      resizable: {
        step: 0.2,
        minDim: 10,
        maxDim: 100,
        currentUnit: 1,
        autoHeight: true
      },
      void: true,
      type: 'video_mp4',
      style: {
        width: '100%',
        height: '100%',
        top: '0% !important',
        left: '0% !important'
      }
    },
    attributes: {
      class: 'fa fa-play' //icon in the panel
    }
  });
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Mixin_js__ = __webpack_require__(3);


var event = document.createEvent('Event');

// Define that the event name is 'build'.
event.initEvent('callFullScreenMethode', true, true);
/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var domc = editor.DomComponents;
  var defaultType = domc.getType('default');
  var defaultModel = defaultType.model;
  var defaultView = defaultType.view;
  var modal = null;
  var self;

  var players = [];
  var page = 0;
  var totalNumber = 1;
  var initialise = false;
  var dbl = false;
  domc.addType('video_mp4', {
    model: defaultModel.extend({
      defaults: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultModel.prototype.defaults, {
        'custom-name': 'video_mp4',
        tagName: 'video',
        src: '',
        width: '100%',
        height: '100%',
        traits: [{
          type: 'text',
          label: 'src',
          name: 'src',
          changeProp: 1
        }, {
          type: 'checkbox',
          label: 'autoplay',
          name: 'autoplay',
          changeProp: 0
        }, {
          type: 'checkbox',
          label: 'loop',
          name: 'loop',
          changeProp: 0
        }, {
          type: 'checkbox',
          label: 'controls',
          name: 'controls',
          changeProp: 0
        }]
      }),
      init: function init() {
        this.listenTo(this, 'change:src', this.updateSrc);
        this.listenTo(this, 'change:autoplay', this.updateAttrAutoplay);
        this.listenTo(this, 'change:loop', this.updateAttrLoop);
        this.listenTo(this, 'change:controls', this.updateAttrControls);
      },
      toHTML: function toHTML() {
        return this.view && this.view.el.getAttribute('data-gjs-type') === 'video_mp4' ? this.view.el.outerHTML : '';
      },
      updateSrc: function updateSrc() {
        var src = this.view.el.getAttribute('src') || this.view.getIframe().src;
        if (src.indexOf(this.get('src')) === -1 && !dbl) {
          this.updateAttrAutoplay();
          this.updateAttrLoop();
          this.updateAttrControls();
        }
      },
      updateAttrAutoplay: function updateAttrAutoplay() {
        var playerIframe = this.view.el;
        playerIframe.setAttribute('autoplay', this.get('autoplay'));
        this.set('autoplay', this.get('autoplay'));
        this.view.getIframe().autoplay = 'autoplay';
        playerIframe.setAttribute('data-autoplay', this.get('autoplay'));
        this.set('data-autoplay', this.get('autoplay'));
        this.view.getIframe()['data-autoplay'] = 'autoplay';
      },
      updateAttrLoop: function updateAttrLoop() {
        var playerIframe = this.view.el;
        playerIframe.setAttribute('loop', this.get('loop'));
        this.set('loop', this.get('loop'));
        this.view.getIframe().loop = 'loop';
      },
      updateAttrControls: function updateAttrControls() {
        var playerIframe = this.view.el;
        playerIframe.setAttribute('controls', this.get('controls'));
        this.set('controls', this.get('controls'));
        this.view.getIframe().controls = 'controls';
      },
      isComponent: function isComponent(el) {
        var result = '';
        if (el.tagName === 'div') {
          result = { type: 'video_mp4', src: el.src };
        }
        return result;
      }
    }, {
      isComponent: function isComponent(el) {
        var result = '';
        if (el.tagName === 'div') {
          result = { type: 'video_mp4', src: el.src };
        }
        return result;
      }
    }),
    view: defaultView.extend({
      events: {
        click: 'updateSrcField',
        dblclick: 'openModal'
      },
      initialize: function initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
        self = this;
        this.model.listenTo(this.model, 'active', self.insertIframe);
        modal = editor.Modal;
        modal.setTitle(config.translate);
      },
      getIframe: function getIframe() {
        if (!this.iframe) {
          var ifrm = document.createElement('video');
          ifrm.className = this.ppfx + 'no-pointer';
          ifrm.src = this.model.get('src');
          ifrm.id = 'video_mp4-' + __WEBPACK_IMPORTED_MODULE_1__mixins_Mixin_js__["a" /* default */].methods.makeId();
          ifrm.width = this.model.get('width');
          ifrm.height = this.model.get('height');
          ifrm.style = 'border:none;overflow:hidden;height:100%;width:100%';
          ifrm.scrolling = 'no';
          ifrm.frameborder = '0';
          ifrm.allowtransparency = 'true';
          ifrm.allow = 'encrypted-media';

          this.iframe = ifrm;
        }
        return this.iframe;
      },
      insertIframe: function insertIframe() {
        //self.el.appendChild(self.getIframe());
        document.getElementById('CanvOverlay').style.display = 'block';

        self.openModal();
      },
      noVideos: function noVideos() {
        modal.setContent('<div id="modal-players-mp4-list" class="container" style=" min-height: 100px;padding:5px;display: inline-block;max-height: 660px; overflow-y: auto">\n                                        <span><img src="\n                    static/images/nofound.png" alt="nofound image"></span>\n                                   </div>');
      },
      reloadPlayersMP4List: function reloadPlayersMP4List() {
        var titleVideo = document.getElementById('myInput');
        var noVideo = document.getElementById('noVideo');
        if (noVideo != null) {
          noVideo.style.display = 'none';
        }

        page = page + 1;
        var modalContent = document.getElementById('modal-players-mp4-list');
        if (titleVideo.value !== '') {
          page = 1;
        }
        self.showLoader();
        config.http(window.ApiToken).get(config.routing.generate(config.api_routing, {
          id: '',
          page: page,
          nbParPage: 20,
          client: config.client.paramsClient.client,
          searchWord: titleVideo.value,
          maxBitrate: true
        })).then(function (response) {
          self.hideLoader();
          if (response.data.code === 200) {
            var selected = 0;
            totalNumber = response.data.nombre_total;
            document.querySelector('.gjs-mdl-dialog.gjs-one-bg.gjs-two-color').style.display = 'block';

            if (response.data.medias.length === 0 && players.length === 0) {
              self.noVideos();
            } else if (response.data.medias.length === 0 && titleVideo.value !== '') {
              modalContent.innerHTML = '';
              var element = document.createElement('div');
              element.className = 'no-found-video';
              element.id = 'noVideo';
              element.innerHTML = '<img src="' + 'static/images/nofound.png' + '" alt="nofound image">\n                         ';
              modalContent.appendChild(element);
            } else {
              if (titleVideo.value !== '') {
                modalContent.innerHTML = '';
              }
              response.data.medias.forEach(function (val) {
                var element = document.createElement('div');
                element.setAttribute('data-duration', val.duration);
                element.id = 'mp4i' + val.id;
                element.className = 'player-mp4-item';
                var srcImage;
                if (val.logo && val.logo !== '') {
                  srcImage = val.logo;
                } else {
                  srcImage = '/display/static/images/vignette.jpg';
                }
                element.innerHTML = '<img src="' + srcImage + '" alt="Card image">\n                          <div class="vidPlayerMP4 vid-position">\n                               <h5 class="descriptionPlayerMP4 desc-position" title="' + val.title + '">' + val.title + '</h5>\n                                </div><div :title="' + val.duration + '" class=" durationPlayerMP4 duration-style">' + __WEBPACK_IMPORTED_MODULE_1__mixins_Mixin_js__["a" /* default */].methods.getDuration(val.duration) + '</div>  <img\n                  src="/display/static/images/tick.svg"\n                  class="tick-img-player-mp4"\n                  style=" display: none;"\n             \n                />';
                modalContent.appendChild(element);
              });

              response.data.medias.forEach(function (val) {
                var el = document.getElementById('mp4i' + val.id);

                el.addEventListener('click', function () {
                  if (selected !== 0) {
                    document.getElementById('mp4i' + selected).classList.remove('selected');
                  }

                  selected = val.id;
                  document.getElementById('mp4i' + val.id).classList.add('selected');

                  // Problème 12 : on retient l'image de la médiathèque comme
                  // `poster`. Sans elle, un écran vidéo n'a aucune image à
                  // afficher — ni pour la vignette (dom-to-image ne sait pas
                  // rasteriser un <video>), ni avant le démarrage de la lecture.
                  var poster = val.logo && val.logo !== '' ? val.logo : '';

                  var selectedElement = grapesjsEMP.editors[0].getSelected();
                  if (selectedElement !== undefined) {
                    try {
                      grapesjsEMP.editors[0].getSelected().view.el.querySelector('video').setAttribute('src', val.lienMp4);
                    } catch (e) {}
                    selectedElement.set('duration', val.duration);
                    self.getIframe().src = val.lienMp4;
                    selectedElement.set('src', val.lienMp4);
                    self.getIframe().setAttribute('duration', val.duration);
                    if (poster) {
                      selectedElement.addAttributes({ poster: poster });
                      self.getIframe().setAttribute('poster', poster);
                    }
                  } else {
                    self.getIframe().src = val.lienMp4;
                    self.model.set('src', val.lienMp4);
                    self.getIframe().setAttribute('duration', val.duration);
                    self.model.set('duration', val.duration);
                    if (poster) {
                      self.model.addAttributes({ poster: poster });
                      self.getIframe().setAttribute('poster', poster);
                    }
                  }
                  if (poster) {
                    try {
                      self.model.view.el.setAttribute('poster', poster);
                    } catch (e) {}
                  }
                  /*to do full screen default */
                  /*to do full screen default */
                  event.myDuration = val.duration;
                  document.dispatchEvent(event);
                  self.model.view.el.pause();
                  self.model.view.el.controls = false;
                  // self.model.updateUrlVid();
                  //  self.model.updateAttrVid();
                });
                el.addEventListener('dblclick', function (e) {
                  document.querySelector('.gjs-mdl-btn-close').click();
                  dbl = true;
                });
                el.addEventListener('click', function (e) {
                  dbl = true;
                });
              });

              players = players.concat(response.data.medias);
              if (players.length === totalNumber) {
                document.getElementById('modal-players-mp4-container').removeEventListener('scroll', function () {
                  var listElm = document.getElementById('modal-players-mp4-container');
                  if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
                    self.reloadPlayersMP4List();
                  }
                });
                self.hideLoader();
              } else {
                if (!initialise) {
                  document.getElementById('modal-players-mp4-container').addEventListener('scroll', function () {
                    var listElm = document.getElementById('modal-players-mp4-container');
                    if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
                      self.reloadPlayersMP4List();
                    }
                  });
                  initialise = true;
                }
              }
            }
          }
        }, function (response) {
          self.hideLoader();
        });
      },
      hideLoader: function hideLoader() {
        document.getElementById('loader-list').style.visibility = 'hidden';
      },
      showLoader: function showLoader() {
        document.getElementById('loader-list').style.visibility = 'visible';
      },
      onScroll: function onScroll() {
        var listElm = document.getElementById('modal-players-mp4-container');
        //var titleVideo = document.getElementById('myInput');

        if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
          self.reloadPlayersMP4List();
        }
      },
      openModal: function openModal() {
        page = 0;
        players = [];
        initialise = false;
        modal.setContent('<div id="modal-players-mp4-container" class="players-mp4-list">\n                            <div id="search-list" class="search-wrapper">\n                                      <input type="text" id="myInput"  placeholder="Chercher une video.."  />\n                                    </div>\n                                       <div id="modal-players-mp4-list" class="players-mp4-wrapper"></div>\n                                       <div id="loader-list" class="loader-4 center"><span></span></div>\n                                   </div>');

        var titleVideo = document.getElementById('myInput');
        var configMixin = __WEBPACK_IMPORTED_MODULE_1__mixins_Mixin_js__["a" /* default */].methods.getLangCode('display-player-plugin');
        if (titleVideo) titleVideo.placeholder = configMixin.translate.placeholder;
        self.reloadPlayersMP4List();
        modal.open();
        modal.getModel().once('change:open', function () {
          document.getElementById('CanvOverlay').style.display = 'none';

          var getAllComponents = function getAllComponents(model) {
            var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            result.push(model);
            model.components().each(function (mod) {
              return getAllComponents(mod, result);
            });
            return result;
          };
          var all = getAllComponents(editor.DomComponents.getWrapper());

          for (var i = 0; i < all.length; i++) {
            var type = all[i].attributes.type;
            var src = all[i].attributes.src;
            if (type === 'video_mp4' || type === 'playlist' || type === 'live') {
              if (!src) {
                grapesjsEMP.editors[0].UndoManager.undo();
              }
            }
          }
        });

        var textInput = document.getElementById('myInput');
        textInput.addEventListener('input', self.reloadPlayersMP4List);
      },
      updateSrcField: function updateSrcField() {
        var src = this.model.get('src') || this.el.getAttribute('src') || this.getIframe().src;
        var duration = this.model.get('duration') || this.el.getAttribute('duration') || this.getIframe().getAttribute('duration');
        this.model.set('src', src);
        this.model.set('duration', duration);
      },
      render: function render() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        defaultView.prototype.render.apply(this, args);
        if (this.model.get('src')) {
          // this.el.appendChild(this.getIframe());
        }
        this.updateClasses();
        this.updateAttributes();
        return this;
      }
    })
  });
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_grapesjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blocks__ = __webpack_require__(415);




/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_grapesjs___default.a.plugins.add('display-player-mp4-plugin', function (editor) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var c = opts;
  // Add components
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */])(editor, c);
  //  // Add blocks
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__blocks__["a" /* default */])(editor, c);
}));

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var bm = editor.BlockManager;
  bm.add('player', {
    label: 'Player',
    category: 'Media',
    content: {
      activeOnRender: 1,
      resizable: {
        step: 0.2,
        minDim: 10,
        maxDim: 100,
        currentUnit: 1,
        autoHeight: true
      },
      void: true,
      type: 'player',
      style: {
        width: '30%',
        height: '30%'
      }
    },
    attributes: {
      class: 'fa fa-play' //icon in the panel
    }
  });
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Mixin_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_modules_grapes_data__ = __webpack_require__(232);



/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var domc = editor.DomComponents;
  var defaultType = domc.getType('default');
  var defaultModel = defaultType.model;
  var defaultView = defaultType.view;
  var modal = null;
  var self;

  var players = [];
  var page = 0;
  var total_number = 1;
  var initialise = false;
  domc.addType('player', {
    model: defaultModel.extend({
      defaults: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultModel.prototype.defaults, {
        'custom-name': 'player',
        tagName: 'div',
        src: '',
        width: '100%',
        height: '100%',
        traits: [{
          type: 'text',
          label: 'src',
          name: 'src',
          changeProp: 1
        }, {
          type: 'checkbox',
          label: 'autoplay',
          name: 'autoplay',
          changeProp: 1
        }, {
          type: 'checkbox',
          label: 'loop',
          name: 'loop',
          changeProp: 1
        }, {
          type: 'checkbox',
          label: 'controls',
          name: 'controls',
          changeProp: 1
        }]
      }),
      init: function init() {
        this.listenTo(this, 'change:src', this.updateSrc);
        this.listenTo(this, 'change:autoplay', this.updateUrlVid);
        this.listenTo(this, 'change:loop', this.updateUrlVid);
        this.listenTo(this, 'change:controls', this.updateUrlVid);
      },
      toHTML: function toHTML() {
        return this.view && this.view.el.getAttribute('data-gjs-type') == 'player' ? this.view.el.outerHTML : '';
      },
      updateSrc: function updateSrc() {
        this.view.el.setAttribute('src', this.get('src'));
        this.view.el.setAttribute('data-thumbnail', this.get('thumbnail'));
        this.view.getIframe().src = this.get('src');
        this.updateAutoplay();
        this.updateLoop();
        this.updateControl();
      },
      updateAutoplay: function updateAutoplay() {
        this.updateUrlVid(this.get('autoplay'), 'a', 1);
      },
      updateLoop: function updateLoop() {
        this.updateUrlVid(this.get('loop'), 'loop', 1);
      },
      updateControl: function updateControl() {
        this.updateUrlVid(this.get('controls'), 'sc', 1);
      },
      updateUrlVid: function updateUrlVid() {
        var _this = this;

        var url = this.get('src').split('?')[0] + '?';
        var params = [{ name: 'autoplay', value: 'a' }, { name: 'loop', value: 'loop' }, { name: 'controls', value: 'sc' }];

        url += params.map(function (param) {
          return param.value + '=' + (_this.get(param.name) ? 1 : 0);
        }).join('&');

        this.view.el.setAttribute('src', url);
        this.set('src', url);
        this.view.getIframe().src = url;
      },
      isComponent: function isComponent(el) {
        var result = '';
        if (el.tagName == 'div') {
          result = { type: 'player', src: el.src };
        }
        return result;
      }
    }, {
      isComponent: function isComponent(el) {
        var result = '';
        if (el.tagName == 'div') {
          result = { type: 'player', src: el.src };
        }
        return result;
      }
    }),
    view: defaultView.extend({
      events: {
        click: 'updateSrcField',
        dblclick: 'openModal'
      },
      initialize: function initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
        self = this;
        this.model.listenTo(this.model, 'active', self.insertIframe);
        modal = editor.Modal;
        modal.setTitle(config.translate.select_new);
      },
      getIframe: function getIframe() {
        if (!this.iframe) {
          var ifrm = document.createElement('iframe');
          ifrm.className = this.ppfx + 'no-pointer';
          ifrm.src = this.model.get('src');
          ifrm.id = 'player-' + __WEBPACK_IMPORTED_MODULE_1__mixins_Mixin_js__["a" /* default */].methods.makeId();
          ifrm.width = this.model.get('width');
          ifrm.height = this.model.get('height');
          ifrm.style = 'border:none;overflow:hidden';
          ifrm.scrolling = 'no';
          ifrm.frameborder = '0';
          ifrm.allowtransparency = 'true';
          ifrm.allow = 'encrypted-media';

          this.iframe = ifrm;
        }
        return this.iframe;
      },
      insertIframe: function insertIframe() {
        self.el.appendChild(self.getIframe());
        document.getElementById('CanvOverlay').style.display = 'block';

        self.openModal();
      },
      noVideos: function noVideos() {
        modal.setContent('<div id="modal-players-list" class="container" style=" min-height: 100px;padding:5px;display: inline-block;max-height: 660px; overflow-y: auto">\n                                        <span><img src="\n                    static/images/nofound.png" alt="nofound image"></span>\n                                   </div>');
      },
      reloadPlayersList: function reloadPlayersList() {
        var titleVideo = document.getElementById('myInput');
        var noVideo = document.getElementById('noVideo');
        if (noVideo != null) {
          noVideo.style.display = 'none';
        }

        page = page + 1;
        var modalContent = document.getElementById('modal-players-list');
        if (titleVideo.value !== '') {
          page = 1;
        }
        self.showLoader();
        config.http(window.ApiToken).get(config.routing.generate(config.api_routing, {
          id: '',
          page: page,
          nbParPage: 20,
          client: config.client.paramsClient.client,
          searchWord: titleVideo.value,
          maxBitrate: true
        })).then(function (response) {
          self.hideLoader();
          if (response.data.code === 200) {
            var selected = 0;
            total_number = response.data.nombre_total;
            document.querySelector('.gjs-mdl-dialog.gjs-one-bg.gjs-two-color').style.display = 'block';
            if (response.data.medias.length === 0 && players.length === 0) {
              self.noVideos();
            } else if (response.data.medias.length === 0 && titleVideo.value !== '') {
              modalContent.innerHTML = '';
              var element = document.createElement('div');
              element.className = 'no-found-video';
              element.id = 'noVideo';
              element.innerHTML = '<img src="' + 'static/images/nofound.png' + '" alt="nofound image">\n                         ';
              modalContent.appendChild(element);
            } else {
              if (titleVideo.value !== '') {
                modalContent.innerHTML = '';
              }
              response.data.medias.forEach(function (val) {
                var element = document.createElement('div');
                element.setAttribute('data-duration', val.duration);
                element.id = 'i' + val.id;
                element.className = 'player-item';
                var srcImage;
                if (val.logo && val.logo !== '') {
                  srcImage = val.logo;
                } else {
                  srcImage = '/static/images/vignette.jpg';
                }
                element.innerHTML = '<img src="' + srcImage + '" alt="Card image">\n                          <div class="vidPlayer">\n                               <h5 class="descriptionPlayer" title="' + val.title + '">' + val.title + '</h5>\n                                        </div>';
                modalContent.appendChild(element);
              });
              response.data.medias.forEach(function (val) {
                var el = document.getElementById('i' + val.id);

                el.addEventListener('click', function () {
                  if (selected !== 0) {
                    document.getElementById('i' + selected).classList.remove('selected');
                  }

                  selected = val.id;
                  document.getElementById('i' + val.id).classList.add('selected');

                  var selectedElement = grapesjsEMP.editors[0].getSelected();
                  if (selectedElement !== undefined) {
                    try {
                      var iframe = grapesjsEMP.editors[0].getSelected().view.el.querySelector('iframe');
                      iframe.setAttribute('src', val.lien);
                      iframe.setAttribute('data-thumbnail', val.thumbnail);
                    } catch (e) {}
                    self.model.set('duration', val.duration);
                    grapesjsEMP.editors[0].getSelected().set('src', val.lien);
                  } else {
                    self.model.set('duration', val.duration);
                    self.getIframe().src = val.lien;
                    self.model.set('src', val.lien);
                    self.getIframe().setAttribute('duration', val.duration);
                    self.model.set('thumbnail', val.logo);
                  }
                  self.model.updateUrlVid();
                });
                el.addEventListener('dblclick', function () {
                  document.querySelector('.gjs-mdl-btn-close').click();
                });
              });

              players = players.concat(response.data.medias);
              if (players.length === total_number) {
                document.getElementById('modal-players-container').removeEventListener('scroll', function () {
                  var listElm = document.getElementById('modal-players-container');
                  if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
                    self.reloadPlayersList();
                  }
                });
                self.hideLoader();
              } else {
                if (!initialise) {
                  document.getElementById('modal-players-container').addEventListener('scroll', function () {
                    var listElm = document.getElementById('modal-players-container');
                    if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
                      self.reloadPlayersList();
                    }
                  });
                  initialise = true;
                }
              }
            }
          }
        }, function (response) {
          self.hideLoader();
        });
      },
      hideLoader: function hideLoader() {
        document.getElementById('loader-list').style.visibility = 'hidden';
      },
      showLoader: function showLoader() {
        document.getElementById('loader-list').style.visibility = 'visible';
      },
      onScroll: function onScroll() {
        var listElm = document.getElementById('modal-players-container');
        var titleVideo = document.getElementById('myInput');

        if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
          self.reloadPlayersList();
        }
      },
      openModal: function openModal() {
        page = 0;
        players = [];
        initialise = false;
        modal.setContent('<div id="modal-players-container" class="players-list">\n                            <div id="search-list" class="search-wrapper">\n                                      <input type="text" id="myInput"  placeholder="..."  />\n                                    </div>\n                                       <div id="modal-players-list" class="players-wrapper"></div>\n                                       <div id="loader-list" class="loader-4 center"><span></span></div>\n                                   </div>');

        self.reloadPlayersList();
        modal.open();
        var titleVideo = document.getElementById('myInput');
        var configMixin = __WEBPACK_IMPORTED_MODULE_1__mixins_Mixin_js__["a" /* default */].methods.getLangCode('display-player-plugin');
        if (titleVideo) titleVideo.placeholder = configMixin.translate.placeholder;
        modal.getModel().once('change:open', function () {
          document.getElementById('CanvOverlay').style.display = 'none';

          var getAllComponents = function getAllComponents(model) {
            var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            result.push(model);
            model.components().each(function (mod) {
              return getAllComponents(mod, result);
            });
            return result;
          };
          var all = getAllComponents(editor.DomComponents.getWrapper());

          for (var i = 0; i < all.length; i++) {
            var type = all[i].attributes.type;
            var src = all[i].attributes.src;
            if (type === 'player' || type === 'playlist' || type === 'live') {
              if (!src) {
                grapesjsEMP.editors[0].UndoManager.undo();
              }
            }
          }
        });

        var textInput = document.getElementById('myInput');
        textInput.addEventListener('input', self.reloadPlayersList);
      },
      updateSrcField: function updateSrcField() {
        var src = this.model.get('src') || this.el.getAttribute('src') || this.getIframe().src;
        var duration = this.model.get('duration') || this.el.getAttribute('duration') || this.getIframe().getAttribute('duration');
        this.model.set('src', src);
        this.model.set('duration', duration);

        var thumbnail = this.model.get('thumbnail') || this.el.getAttribute('data-thumbnail');
        this.model.set('thumbnail', thumbnail);
      },
      render: function render() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        defaultView.prototype.render.apply(this, args);
        if (this.model.get('src')) {
          this.el.appendChild(this.getIframe());
        }
        this.updateClasses();
        this.updateAttributes();
        return this;
      }
    })
  });
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_grapesjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blocks__ = __webpack_require__(418);




/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_grapesjs___default.a.plugins.add('display-player-plugin', function (editor) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var c = opts;
  // Add components
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */])(editor, c);
  //  // Add blocks
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__blocks__["a" /* default */])(editor, c);
}));

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var bm = editor.BlockManager;
  bm.add('playlist', {
    label: 'Playlist',
    category: 'Media',
    content: {
      activeOnRender: 1,
      resizable: {
        step: 0.2,
        minDim: 10,
        maxDim: 100,
        currentUnit: 1,
        autoHeight: true
      },
      type: 'playlist',
      style: {
        width: '30%',
        height: '30%'
      }
    },
    attributes: {
      class: 'fa fa-indent' //icon in the panel
    }
  });
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Mixin_js__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var domc = editor.DomComponents;
  var defaultType = domc.getType('default');
  var defaultModel = defaultType.model;
  var defaultView = defaultType.view;
  var modal = null;
  var self;
  var playlist = [];
  var page = 0;
  var total_number = 1;
  var initialise = false;
  domc.addType('playlist', {
    model: defaultModel.extend({
      defaults: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultModel.prototype.defaults, {
        'custom-name': 'playlist',
        tagName: 'div',
        src: '',
        width: '100%',
        height: '100%',
        traits: [{
          type: 'text',
          label: 'src',
          name: 'src',
          changeProp: 1
        }, {
          type: 'checkbox',
          label: 'autoplay',
          name: 'autoplay',
          changeProp: 1
        }, {
          type: 'checkbox',
          label: 'loop',
          name: 'loop',
          changeProp: 1
        }, {
          type: 'checkbox',
          label: 'controls',
          name: 'controls',
          changeProp: 1
        }]
      }),
      init: function init() {
        this.listenTo(this, 'change:src', this.updateSrc);
        this.listenTo(this, 'change:autoplay', this.updateAutoplay);
        this.listenTo(this, 'change:loop', this.updateLoop);
        this.listenTo(this, 'change:controls', this.updateControl);
      },
      toHTML: function toHTML() {
        return this.view.el.getAttribute('data-gjs-type') == 'playlist' ? this.view.el.outerHTML : '';
      },
      updateSrc: function updateSrc() {
        this.view.el.setAttribute('src', this.get('src'));
        this.view.getIframe().src = this.get('src');
        this.updateAutoplay();
        this.updateLoop();
        this.updateControl();
      },
      updateAutoplay: function updateAutoplay() {
        this.updateUrlVid(this.get('autoplay'), 'a', 1);
      },
      updateLoop: function updateLoop() {
        this.updateUrlVid(this.get('loop'), 'loop', 1);
      },
      updateControl: function updateControl() {
        this.updateUrlVid(this.get('controls'), 'sc', 1);
      },
      updateUrlVid: function updateUrlVid(valueCheck, option, val) {
        var url = this.get('src');
        if (url.indexOf(option + '=' + val) > -1 && valueCheck) {
          return;
        }
        if (valueCheck) {
          if (url.indexOf('?') === -1) {
            url += '?' + option + '=' + val;
          } else {
            url += '&' + option + '=' + val;
          }
        } else {
          if (url.indexOf('?' + option + '=' + val) !== -1) {
            url = url.replace('?' + option + '=' + val, '');

            var index = url.indexOf('&');
            if (index !== -1) url = url.replace('&', '?');
          } else if (url.indexOf('&' + option + '=' + val) !== -1) {
            url = url.replace('&' + option + '=' + val, '');
          }
        }
        this.set('src', url);
        this.view.getIframe().src = url;
      }
    }, {
      isComponent: function isComponent(el) {
        var result = '';
        if (el.tagName == 'div') {
          result = { type: 'playlist' };
        }
        return result;
      }
    }),
    view: defaultView.extend({
      events: {
        dblclick: 'openModal'
      },
      initialize: function initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
        self = this;
        this.model.listenTo(this.model, 'active', self.insertIframe);
        modal = editor.Modal;
        modal.setTitle(config.translate);
      },
      getIframe: function getIframe() {
        if (!this.iframe) {
          var ifrm = document.createElement('iframe');
          ifrm.className = this.ppfx + 'no-pointer';
          ifrm.src = this.model.get('src');
          ifrm.id = 'playlist-' + __WEBPACK_IMPORTED_MODULE_1__mixins_Mixin_js__["a" /* default */].methods.makeId();
          ifrm.width = this.model.get('width');
          ifrm.height = this.model.get('height');
          ifrm.style = 'border:none;overflow:hidden';
          ifrm.scrolling = 'no';
          ifrm.frameborder = '0';
          ifrm.allowtransparency = 'true';
          ifrm.allow = 'encrypted-media';

          this.iframe = ifrm;
        }
        return this.iframe;
      },
      insertIframe: function insertIframe() {
        self.el.appendChild(self.getIframe());
        document.getElementById('CanvOverlay').style.display = 'block';
        self.openModal();
      },
      noVideos: function noVideos() {
        modal.setContent('<div id="modal-playlist-list" class="container" style=" min-height: 100px;padding:5px;display: inline-block;max-height: 660px; overflow-y: auto">\n                                        <span><img src="\n                    static/images/nofound.png" alt="nofound image"></span>\n                                   </div>');
      },
      reloadPlayersList: function reloadPlayersList() {
        page = page + 1;
        var modalContent = document.getElementById('modal-playlist-list');
        if (playlist.length < total_number) {
          self.showLoader();
          config.http(window.ApiToken).get(config.routing.generate(config.api_routing_playlist, {
            id: '',
            page: page,
            nbParPage: 20,
            client: config.client.paramsClient.client
          })).then(function (response) {
            self.hideLoader();
            if (response.data.code === 200) {
              var selected = 0;
              total_number = response.data.nombre_total;
              if (response.data.playlists.length === 0 && playlist.length === 0) {
                self.noVideos();
              } else {
                response.data.playlists.forEach(function (val) {
                  var element = document.createElement('div');
                  element.id = 'i' + val.id;
                  element.className = 'player-item';
                  var srcImage;
                  if (val.logo && val.logo !== '') {
                    srcImage = val.logo;
                  } else {
                    srcImage = '/static/images/vignette.jpg';
                  }
                  element.innerHTML = '<img src="' + srcImage + '" alt="Card image" style="height: 100px;cursor: pointer">\n                                        <div class="vidPlayer">\n                                             <h5  class="descriptionPlayer">' + val.title + '</h5>\n                                        </div>';
                  modalContent.appendChild(element);
                });

                response.data.playlists.forEach(function (val) {
                  document.getElementById('i' + val.id).addEventListener('click', function () {
                    if (selected != 0) {
                      document.getElementById('i' + selected).style.removeProperty('background-color');
                      document.getElementById('i' + selected).firstElementChild.style.removeProperty('opacity');
                    }
                    selected = val.id;
                    document.getElementById('i' + val.id).style.backgroundColor = 'rgba(255,255,255,0.1)';
                    document.getElementById('i' + val.id).firstElementChild.style.opacity = '0.8';
                    self.getIframe().src = val.lien;
                    self.model.set('src', val.lien);
                    self.model.updateAutoplay();
                    self.model.updateLoop();
                    self.model.updateControl();
                  });
                  document.getElementById('i' + val.id).addEventListener('dblclick', function () {
                    document.querySelector('.gjs-mdl-btn-close').click();
                  });
                });

                playlist = playlist.concat(response.data.playlists);
                if (playlist.length === total_number) {
                  document.getElementById('modal-playlist-container').removeEventListener('scroll', function () {
                    var listElm = document.getElementById('modal-playlist-container');
                    if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
                      self.reloadPlayersList();
                    }
                  });
                  self.hideLoader();
                } else {
                  if (!initialise) {
                    document.getElementById('modal-playlist-container').addEventListener('scroll', function () {
                      var listElm = document.getElementById('modal-playlist-container');
                      if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
                        self.reloadPlayersList();
                      }
                    });
                    initialise = true;
                  }
                }
              }
            }
          }, function (response) {
            self.hideLoader();
          });
        }
      },
      hideLoader: function hideLoader() {
        document.getElementById('loader-playlist-list').style.visibility = 'hidden';
      },
      showLoader: function showLoader() {
        document.getElementById('loader-playlist-list').style.visibility = 'visible';
      },
      onScroll: function onScroll() {
        var listElm = document.getElementById('modal-playlist-container');
        if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
          self.reloadPlayersList();
        }
      },
      openModal: function openModal() {
        page = 0;
        playlist = [];
        initialise = false;
        modal.setContent('<div id="modal-playlist-container" class="players-list container">\n                                       <div id="modal-playlist-list" class="players-wrapper"></div>\n                                       <div id="loader-playlist-list" class="loader-4 center"><span></span></div>\n                                   </div>');
        self.reloadPlayersList();
        modal.open();
        modal.getModel().once('change:open', function () {
          document.getElementById('CanvOverlay').style.display = 'none';
          var getAllComponents = function getAllComponents(model) {
            var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            result.push(model);
            model.components().each(function (mod) {
              return getAllComponents(mod, result);
            });
            return result;
          };
          var all = getAllComponents(editor.DomComponents.getWrapper());

          for (var i = 0; i < all.length; i++) {
            var type = all[i].attributes.type;
            var src = all[i].attributes.src;
            if (type === 'player' || type === 'playlist' || type === 'live') {
              if (!src) {
                grapesjsEMP.editors[0].UndoManager.undo();
              }
            }
          }
        });
      },
      updateSrcField: function updateSrcField() {
        var src = this.model.get('src') || this.el.getAttribute('src') || this.getIframe().src;
        this.model.set('src', src + '?a=0');
      },
      render: function render() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        defaultView.prototype.render.apply(this, args);
        if (this.model.get('src')) {
          this.model.set('src', this.model.get('src'));
          this.el.appendChild(this.getIframe());
        }
        this.updateClasses();
        this.updateAttributes();
        return this;
      }
    })
  });
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_grapesjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blocks__ = __webpack_require__(421);




/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_grapesjs___default.a.plugins.add('display-playlist-plugin', function (editor) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // Add components
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */])(editor, opts);

  //  // Add blocks
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__blocks__["a" /* default */])(editor, opts);
}));

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (editor) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var bm = editor.BlockManager;
    bm.add('rss_widget', {
        label: 'Rss',
        category: 'Widget',
        content: {
            type: 'rss_widget',
            resizable: true,
            style: {
                width: "320px",
                height: "400px"
            }
        },
        attributes: {
            class: 'fa fa-rss' //icon in the panel
        }
    });
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var domc = editor.DomComponents;
  var defaultType = domc.getType('default');
  var defaultModel = defaultType.model;
  var defaultView = defaultType.view;

  domc.addType('rss_widget', {
    model: defaultModel.extend({
      defaults: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultModel.prototype.defaults, {
        'custom-name': 'Rss',
        tagName: 'div',
        // Problème 6 : l'URL par défaut pointait vers un widget FeedWind
        // (feed.mikle.com/widget/v2/16484/) dont le compte est hors quota —
        // il répond « You have exceeded the widget limit », donc tout bloc RSS
        // fraîchement déposé affichait une erreur. On part désormais d'un bloc
        // vide invitant à saisir l'URL du widget.
        src: '',
        width: '320',
        height: '400',
        traits: [{
          type: 'text',
          label: 'src',
          name: 'src',
          changeProp: 1
        }, {
          type: 'number',

          label: 'width',
          name: 'width',
          changeProp: 1
        }, {
          type: 'number',
          label: 'height',
          name: 'height',
          changeProp: 1
        }]
      }),
      init: function init() {
        this.listenTo(this, 'change:src', this.updateSrc);
        this.listenTo(this, 'change:width ', this.updateWidth);
        this.listenTo(this, 'change:height ', this.updateHeight);
      },
      toHTML: function toHTML() {
        return this.view && this.view.el.getAttribute('data-gjs-type') == 'rss_widget' ? this.view.el.outerHTML : '';
      },
      updateSrc: function updateSrc() {
        this.view.getIframe().src = this.createUri();
      },
      createUri: function createUri() {
        // this.updateWidth();
        // this.updateHeight();
        return this.get('src');
      },
      updateWidth: function updateWidth() {
        this.view.getIframe().width = this.get('width');
        this.view.getIframe().parentNode.style.width = this.get('width');
      },
      updateHeight: function updateHeight() {
        this.view.getIframe().height = this.get('height');
        this.view.getIframe().parentNode.style.height = this.get('height');
      }
    }, {
      isComponent: function isComponent(el) {
        var result = '';
        if (el.tagName == 'div') {
          result = { type: 'rss_widget' };
        }
        return result;
      }
    }),
    view: defaultView.extend({
      getIframe: function getIframe() {
        if (!this.iframe) {
          var ifrm = document.createElement('iframe');
          // Sans src on laisse l'iframe vide plutôt que de recharger l'éditeur
          // lui-même (src="" est résolu comme l'URL de la page courante).
          var src = this.model.createUri();
          if (src) ifrm.src = src;
          ifrm.className = this.ppfx + 'no-pointer';
          ifrm.width = this.model.get('width');
          ifrm.height = this.model.get('height');
          ifrm.style.border = 'none;';
          ifrm.style.overflow = 'scroll';
          ifrm.scrolling = 'yes';
          ifrm.frameborder = '0';
          ifrm.allowtransparency = 'true';
          ifrm.allow = 'encrypted-media';
          ifrm.setAttribute('data-gjs-type', 'rss_widget_iframe');
          this.iframe = ifrm;
        }
        return this.iframe;
      },
      render: function render() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        defaultView.prototype.render.apply(this, args);
        this.updateClasses();
        if (this.el.getElementsByTagName('IFRAME').length == 0) {
          this.el.appendChild(this.getIframe());
        }
        return this;
      }
    })
  });
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_grapesjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blocks__ = __webpack_require__(424);


// eslint-disable-next-line no-unused-vars


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_grapesjs___default.a.plugins.add('display-rss-plugin', function (editor) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // Add components
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */])(editor, opts);

  // RSS continuent de s'ouvrir et de s'afficher normalement.
  // Pour le réactiver : décommenter la ligne ci-dessous.
  // loadBlocks(editor, opts);
}));

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var bm = editor.BlockManager;
  var pfx = 'emp-ticker';
  var style = '<style>\n    .' + pfx + ' {\n        height: 8vh;\n        line-height: 8vh;\n        width: 100%;\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        font-family: Arial, Helvetica, sans-serif;\n        font-weight: 700;\n        background-color: #F44336;\n        color: #ffffff;\n        font-size: 2.8vh;\n        z-index: 999;\n     } \n  </style>';
  var textLoading = config.translate.loading;

  bm.add('ticker', {
    label: 'Ticker',
    category: 'Text',
    content: '<div class="' + pfx + '" data-gjs-type="ticker">\n                <div id="newsTicker" class="breaking-news-ticker" >\n                   <div class="bn-news">\n                    <ul>\n                      <li><span class="bn-loader-text">' + config.translate.loading + '</span></li>\n                    </ul>\n                  </div>\n                  <div class="bn-controls">\n                      <button>\n                          <span class="bn-arrow bn-prev"></span>\n                      </button>\n                      <button><span class="bn-action"></span></button>\n                      <button>\n                          <span class="bn-arrow bn-next"></span>\n                      </button>\n                  </div>\n                </div>\n              </div>\n              ' + style + '\n            ',
    attributes: {
      class: 'icon-news' //icon in the panel
    }
  });
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var domc = editor.DomComponents;
  var defaultType = domc.getType('default');
  var defaultModel = defaultType.model;
  var defaultView = defaultType.view;
  var TICKER_TYPE = 'ticker';
  var modal = null;
  domc.addType(TICKER_TYPE, {
    model: defaultModel.extend({
      defaults: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, defaultModel.prototype.defaults, {
        source: 'rss',
        config: btoa(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config)),
        url: 'https://www.xul.fr/rss.xml',
        field: 'title',
        limit: 10,
        speed: 2,
        text: '1. Entrer votre texte ici.\n' + '2. Entrer votre texte ici.\n' + '3. Entrer votre texte ici.\n' + '4. Entrer votre texte ici.',
        jsonData: btoa('[]'),
        droppable: false,
        traits: [{
          type: 'select',
          label: 'Source',
          name: 'source',
          options: [{ value: 'rss', name: 'RSS' }, { value: 'text', name: 'Text' }],
          changeProp: 1
        }, {
          type: 'text',
          label: 'URL',
          name: 'url',
          changeProp: 1,
          attributes: { 'data-related-type': 'rss' }
        }, {
          type: 'text',
          label: 'Champ',
          name: 'field',
          changeProp: 1,
          attributes: { 'data-related-type': 'rss' }
        }, {
          type: 'number',
          label: 'Limit',
          name: 'limit',
          changeProp: 1,
          attributes: { 'data-related-type': 'rss' }
        }, {
          type: 'number',
          label: 'Vitesse',
          name: 'speed',
          changeProp: 1
        }],
        script: function script() {
          var config = '{[ config ]}';
          var conf = JSON.parse(atob(config));
          var loadingBtn = document.querySelector('.bn-loader-text');
          if (loadingBtn) loadingBtn.innerHTML = conf.translate.loading;
          var source = '{[ source ]}';
          var url = '{[ url ]}';
          var jsonData = '{[ jsonData ]}';
          var field = '{[ field ]}';
          var limit = '{[ limit ]}';
          var speed = '{[ speed ]}';
          var id = this.id;
          var opts = {
            scrollSpeed: speed,
            seperator: '<span class="bn-seperator">&#8226;</span>',
            errorMsg: 'Flux RSS non chargé. Veuillez réessayer.'
          };
          console.log(source);
          console.log('rss');
          console.log(source == 'rss');
          console.log(source === 'rss');
          console.log(source.indexOf('rss'));
          console.log(source.localeCompare('rss'));
          if (source == 'rss') {
            opts.type = 'rss';
            opts.usingApi = 'rss2json';
            opts.rss2jsonApiKey = 'sniu6hkmcvlqlrq3ep2g6s1o294xtccoqrvwzjtd'; //'5ivfzdrkuqwmoe0dgxeqvhfz0knlo7yq4fw20bt0'
            opts.limit = limit;
            opts.url = url;
            opts.showingField = field;
          } else {
            opts.type = 'localJson';
            opts.jsonData = atob(jsonData);
            opts.showingField = 'title';
          }
          $(document).ready(function () {
            $('#' + id + ' #newsTicker').breakingNews({ source: opts });
            if (!$('.reveal').length) {
              $('#' + id + ' #newsTicker .bn-play').click();
              $('#' + id).click();
            }
          });
        }
      }),
      isComponent: function isComponent(el) {
        if (el.getAttribute('data-gjs-type') === TICKER_TYPE) {
          return {
            type: TICKER_TYPE
          };
        }
      }
    }, {
      isComponent: function isComponent(el) {
        var result = '';
        if (el.tagName == 'div') {
          result = { type: TICKER_TYPE };
        }
        return result;
      }
    }),
    view: defaultView.extend({
      init: function init() {
        var _this = this;

        this.listenTo(this.model, 'change:url change:field change:limit change:speed', this.handleUpdate);
        this.listenTo(this.model, 'change:source', this.handleUpdateSource);
        this.listenTo(this.model, 'change:text', this.handleUpdateJsonData);
        this.model.set('config', btoa(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_2__mixins_Mixin__["a" /* default */].methods.getLangCode('display-ticker-plugin'))));

        modal = editor.Modal;
        setTimeout(function () {
          _this.handleUpdate();
          var propertiesEl = document.getElementById('selected-element-properties');
          if (propertiesEl) {
            if (_this.model.get('source') === 'text') {
              propertiesEl.classList.add('text');
            } else {
              propertiesEl.classList.remove('text');
            }
          }
        }, 1000);
      },

      events: {
        dblclick: 'openModal'
      },
      openModal: function openModal() {
        var _this2 = this;

        if (this.model.get('source') === 'rss') {
          return;
        }
        modal.setContent('\n        <div class="modal-body">\n          <textarea name="text" id="ticker-textarea" cols="30" rows="10" class="form-control">\n            ' + this.model.get('text') + '\n          </textarea>\n        </div>\n        <div class="modal-footer">\n          <button type="button" class="btn btn-primary" id="save-ticker-text">\n            ' + config.translate.save + '\n          </button>\n        </div>\n       ');
        modal.setTitle(config.translate.modalTitle);
        modal.open();

        document.getElementById('save-ticker-text').addEventListener('click', function (e) {
          e.stopPropagation();
          _this2.model.set('text', document.getElementById('ticker-textarea').value);
          modal.close();
        });
      },
      handleUpdate: function handleUpdate() {
        var _this3 = this;

        var getAllComponents = function getAllComponents(model) {
          var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

          result.push(model);
          model.components().each(function (mod) {
            return getAllComponents(mod, result);
          });
          return result;
        };
        var all = getAllComponents(editor.DomComponents.getWrapper());

        var tickerModel = all.find(function (item) {
          return item.attributes.attributes.id === _this3.el.id;
        });

        var localStorageComponents = JSON.parse(localStorage.getItem('gjs-components'));

        var updateComponent = function updateComponent(arr, index) {
          if (arr[index].attributes.id === _this3.el.id) {
            arr[index] = tickerModel;
          } else {
            arr[index].components.forEach(function (m, i, a) {
              return updateComponent(a, i);
            });
          }
        };

        localStorageComponents.forEach(function (m, index, arr) {
          return updateComponent(arr, index);
        });

        this.updateScript();
        localStorage.setItem('gjs-js', editor.getJs());
        localStorage.setItem('gjs-html', editor.getHtml());
        localStorage.setItem('gjs-components', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(localStorageComponents));
      },


      handleUpdateSource: function handleUpdateSource() {
        var propertiesEl = document.getElementById('selected-element-properties');
        if (this.model.get('source') === 'text') {
          this.handleUpdateJsonData();
          this.openModal();
          propertiesEl.classList.add('text');
        } else {
          propertiesEl.classList.remove('text');
        }
        this.handleUpdate();
      },
      handleUpdateJsonData: function handleUpdateJsonData() {
        var data = this.model.get('text').split('\\n').map(function (t) {
          return { title: t };
        });
        this.model.set('jsonData', btoa(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)));
        this.handleUpdate();
      }
    }
    /*      getWrapper() {
      if (!this.wrapper) {
        this.wrapper = document.createElement('div');
      }
      return this.wrapper;
    },
    render(...args) {
      defaultView.prototype.render.apply(this, args);
      this.updateClasses();
      this.updateAttributes();
      this.el.appendChild(this.getWrapper());
      return this;
    }*/
    )
  });
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_grapesjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blocks__ = __webpack_require__(427);




/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_grapesjs___default.a.plugins.add('display-ticker-plugin', function (editor) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // Add components
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */])(editor, opts);

  //  // Add blocks
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__blocks__["a" /* default */])(editor, opts);
}));

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var bm = editor.BlockManager;
  var pfx = 'emp-twitter';
  var style = '<style>\n    \n      .content_iframe{\n          height: 100%;\n     }\n  </style>';
  bm.add('social-icons-twitter', {
    label: 'Twitter',
    category: 'Social',
    content: '<div data-gjs-type="social-icons-twitter">\n<div class="content_iframe gjs-no-pointer">                \n<a href="https://twitter.com/twitter" class="twitter-timeline gjs-no-pointer" id ="twitt_widget_new">Tweet</a><script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>\n </div>\n              </div>\n               ' + style + '\n            ',

    attributes: {
      class: 'fa fa-twitter' //icon in the panel
    }
  });
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);


/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var domc = editor.DomComponents;
  var defaultType = domc.getType('default');
  var defaultModel = defaultType.model;
  var defaultView = defaultType.view;

  var defaultUrls = config.state.paramsClient.display_default_urls;
  var URL = defaultUrls && defaultUrls.twitter !== '' ? defaultUrls.twitter : 'https://twitter.com/twitter';

  domc.addType('social-icons-twitter', {
    model: defaultModel.extend({
      defaults: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, defaultModel.prototype.defaults, {
        'custom-name': 'twitter',
        tagName: 'div',
        src: URL,
        resizable: {
          step: 0.2,
          minDim: 10,
          currentUnit: 1,
          autoHeight: true
        },
        traits: [{
          type: 'text',
          label: 'src',
          name: 'src',
          changeProp: 1
        }],
        script: function script() {
          var _this = this;

          setTimeout(function () {
            var id = _this.id;
            var src = '{[ src ]}';

            var element = document.querySelector('#' + id);
            var elementHref = element.querySelector('.twitter-timeline');
            elementHref.href = src;
            elementHref.setAttribute('height', '100%');
            elementHref.setAttribute('width', '100%');

            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.charset = 'utf-8';
            script.src = '//platform.twitter.com/widgets.js';
            script.async = true;
            document.head.appendChild(script);
          }, 500);
        }
      }),

      init: function init() {
        var attrs = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.attributes));

        if (attrs && attrs.classes && attrs.classes[0] && attrs.classes[0].name) {
          this.set('attributes', { class: attrs.classes[0].name });
        } else {
          this.set('attributes', { class: generateClass() });
        }
        this.listenTo(this, 'change:src', this.updateSrc);
        this.listenTo(this, 'change:width ', this.updateWidth);
        this.listenTo(this, 'change:height ', this.updateHeight);
      },
      updateSrc: function updateSrc() {
        this.view.getIframe();
        this.view.render();
        localStorage.setItem('gjs-js', editor.getJs());
      }
    }, {
      isComponent: function isComponent(el) {
        var result = '';
        if (el.tagName == 'div') {
          result = { type: 'social-icons-twitter' };
        }
        return result;
      }
    }),
    view: defaultView.extend({
      initialize: function initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
      },
      getScript: function getScript() {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.charset = 'utf-8';
        script.src = 'https://platform.twitter.com/widgets.js';
        script.async = true;
        return script;
      },
      updateSrcComponentTwitter: function updateSrcComponentTwitter() {
        var _this2 = this;

        var localStorageComponents = JSON.parse(localStorage.getItem('gjs-components'));
        var getAllComponents = function getAllComponents(model) {
          var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

          result.push(model);
          model.components().each(function (mod) {
            return getAllComponents(mod, result);
          });
          return result;
        };
        var all = getAllComponents(editor.DomComponents.getWrapper());
        var twitterModel = all.find(function (item) {
          return item.attributes.attributes.id === _this2.el.id;
        });
        var updateComponent = function updateComponent(arr, index) {
          try {
            if (arr[index].attributes.id === _this2.el.id) {
              arr[index] = twitterModel;
            } else {
              arr[index].components.forEach(function (m, i, a) {
                return updateComponent(a, i);
              });
            }
          } catch (e) {
            console.log(e);
          }
        };
        localStorageComponents.forEach(function (m, index, arr) {
          return updateComponent(arr, index);
        });
        localStorage.setItem('gjs-components', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(localStorageComponents));
        localStorage.setItem('gjs-components2', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(localStorageComponents));
      },
      getIframe: function getIframe() {
        var a = this.el.querySelector('a.twitter-timeline');
        if (a) {
          a.href = this.model.get('src');
          a.setAttribute('height', '100%');
          a.setAttribute('width', '100%');
        }
        if (this.el.querySelector('.content_iframe')) {
          while (this.el.firstChild) {
            this.el.removeChild(this.el.firstChild);
          }

          var widget_twitter = document.createElement('div');
          widget_twitter.className = this.ppfx + 'no-pointer';
          var a = document.createElement('a');
          var linkText = document.createTextNode('Tweets by @TwitterDev');
          a.appendChild(linkText);

          a.href = this.model.get('src');
          a.className = 'twitter-timeline';
          a.id = 'twitt_widget_new';
          a.setAttribute('height', '100%');
          a.setAttribute('width', '100%');
          widget_twitter.appendChild(a);
          this.el.appendChild(widget_twitter);
          this.el.appendChild(this.getScript());
        }
        return this.el;
      },
      render: function render() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        defaultView.prototype.render.apply(this, args);
        this.updateClasses();
        if (this.el.getElementsByTagName('DIV').length === 0) {
          this.getIframe();
        } else if (this.el.querySelector('.content_iframe')) {
          this.getIframe();
        }
        // this.el.appendChild(this.getScript());

        localStorage.setItem('gjs-js', editor.getJs());
        this.updateSrcComponentTwitter();
        return this;
      }
    })
  });
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_grapesjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blocks__ = __webpack_require__(430);




/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_grapesjs___default.a.plugins.add('display-twitter-plugin', function (editor) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // Add components
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */])(editor, opts);

  //  // Add blocks
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__blocks__["a" /* default */])(editor, opts);
}));

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var bm = editor.BlockManager;
  var pfx = 'emp-weather';
  var style = '<style>\n    .' + pfx + ' {} \n    .' + pfx + '-container {\n     width: 100%;\n     height: 100%;\n     pointer-events: none;\n     border-radius: 15px;\n     padding: 1em;\n    }\n  </style>';
  bm.add('Weather', {
    label: 'Weather',
    category: 'Widget',
    content: '\n        <div  data-gjs-type="social-icons-weather"></div>\n        ' + style + '\n      ',
    attributes: {
      class: 'fa fa-sun-o' //icon in the panel
    }
  });
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var domc = editor.DomComponents;
  var defaultType = domc.getType('default');
  var defaultModel = defaultType.model;
  var defaultView = defaultType.view;
  var position, tempMin, tempMax, temp, image, text1, text2, plan, Theme, degree, coloricon, country;
  var widget_weather;
  domc.addType('social-icons-weather', {
    model: defaultModel.extend({
      defaults: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, defaultModel.prototype.defaults, {
        'custom-name': 'weather',
        config: btoa(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config)),
        tagName: 'div',
        selectable: true,
        style: {
          width: '22%',
          height: '27%',
          'font-size': '1.2vw'
        },
        traits: [{
          type: 'text',
          label: config.translate.city,
          name: 'city',
          changeProp: 1
        }, {
          type: 'select',
          label: 'Themes',
          name: 'Themes',
          options: [{ value: 'theme1', name: 'Theme 1' }, { value: 'theme2', name: 'Theme 2' }, { value: 'theme3', name: 'Theme 3' }, { value: 'theme4', name: 'Theme 4' }],
          changeProp: 1
        }, {
          type: 'select',
          label: 'Température',
          name: 'temp',
          options: [{ value: 'C', name: '°C' }, { value: 'F', name: '°F' }],
          changeProp: 1
        }, {
          type: 'color',
          label: 'Couleur Text 1',
          name: 'text1',
          changeProp: 1
        }, {
          type: 'color',
          label: 'Couleur Text 2',
          name: 'text2',
          changeProp: 1
        }, {
          type: 'color',
          label: 'Couleur icon',
          name: 'coloricon',
          changeProp: 1
        }, {
          type: 'color',
          label: "couleurs d'arrière plan",
          name: 'plan',
          changeProp: 1
        }],
        copyable: true,
        saved: false,
        script: function script() {
          var pos = '{[ city ]}';
          var text1 = '{[ text1 ]}';
          var config = '{[ config ]}';
          var conf = JSON.parse(atob(config));
          var id = this.id;
          var c = document.getElementById(id).className.replace('gjs-comp-selected', '');
          var allweather = document.querySelectorAll('.' + c);
          //var allweather = document.querySelectorAll('[data-gjs-type=social-icons-weather]');
          function getDateTime() {
            var now = new Date();
            var hour = now.getHours();
            var minute = now.getMinutes();
            if (hour.toString().length === 1) {
              hour = '0' + hour;
            }
            if (minute.toString().length === 1) {
              minute = '0' + minute;
            }
            var dateTime = hour + ':' + minute;
            return dateTime;
          }
          function getDay() {
            var now = new Date();
            var days = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
            var day = days[now.getDay()];
            return day;
          }
          allweather.forEach(function (weather) {
            var timeEl = weather.querySelector('[data-js=dateHeure-time]');
            var dayEl = weather.querySelector('[data-js=dateHeure-day]');
            if (dayEl) {
              dayEl.innerHTML = '' + getDay() + '';
            }
            if (timeEl) {
              timeEl.innerHTML = '' + getDateTime() + '';
              setInterval(function () {
                timeEl.innerHTML = '' + getDateTime() + '';
              }, 1000);
            }
          });
        }
      }),
      init: function init() {
        this.listenTo(this, 'change:city', this.updateSrc);
        this.listenTo(this, 'change:text1', this.updateStyle);
        this.listenTo(this, 'change:text2', this.updateStyle);
        this.listenTo(this, 'change:plan', this.updateStyle);
        this.listenTo(this, 'change:Themes', this.updateTheme);
        this.listenTo(this, 'change:temp', this.updateStyle);
        this.listenTo(this, 'change:coloricon', this.updateStyle);
        var configMixin = __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin__["a" /* default */].methods.getLangCode('display-weather-plugin');
        window.y = this;

        this.attributes.traits.models.forEach(function (p, index) {
          var name = p.attributes.name;
          p.set('label', configMixin.translate[name]);
        });
      },
      toHTML: function toHTML() {
        return this.view && this.view.el.getAttribute('data-gjs-type') == 'social-icons-weather' ? this.view.el.outerHTML : '';
      },
      updateSrc: function updateSrc() {
        this.view.changePosition(this.get('city'), true);
      },
      updateTheme: function updateTheme() {
        this.view.changeTheme(this.get('Themes'));
      },
      updateStyle: function updateStyle() {
        this.view.changeStyle(this.get('text1'), this.get('text2'), this.get('plan'), this.get('Themes'), this.get('temp'), this.get('coloricon'));
      },
      updateWidth: function updateWidth() {
        this.view.getComponent().width = this.get('width');
      },
      updateHeight: function updateHeight() {
        this.view.getComponent().height = this.get('height');
      },
      isComponent: function isComponent(el) {
        if (el.getAttribute('data-gjs-type') === 'social-icons-weather') {
          return {
            type: 'social-icons-weather'
          };
        }
      }
    }, {
      isComponent: function isComponent(el) {
        var result = '';
        if (el.tagName == 'div') {
          result = { type: 'social-icons-weather' };
        }
        return result;
      }
    }),
    view: defaultView.extend({
      initialize: function initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
      },


      /**
       * Update the map on the canvas
       * @private
       */
      changeTheme: function changeTheme(Themes, self) {
        if (Themes) {
          Theme = Themes;
          localStorage.setItem('Themes', Theme);
        } else {
          Theme = this.model.get('Themes') || localStorage.getItem('Themes') || 'theme1';
        }
        this.model.set('Themes', Theme);
        var classes = this.model.getClasses();
        var cssComposer = editor.CssComposer;
        var style = {};
        if (Theme === 'theme1') {
          var _text = '#FFFFFF';
          var _text2 = '#FFFFFF';
          var _plan = '#157e93';
          var _coloricon = '#FFFFFF';
          this.model.set('text1', _text);
          this.model.set('text2', _text2);
          this.model.set('plan', _plan);
          this.model.set('coloricon', _coloricon);
          localStorage.setItem('gjs-js', editor.getJs());

          style = {
            width: '22%',
            height: '27%',
            'font-size': '1.2vw'
          };

          var comps = this.model.get('components');
          if (comps.length !== 0) {
            this.getComponent(position, temp, tempMin, tempMax, image, country, _text, _text2, _plan, Theme, degree, _coloricon);
          }
        }
        if (Theme === 'theme2') {
          var _text3 = '#fdc104';
          var _text4 = '#FFFFFF';
          var _plan2 = '#224764';
          var _coloricon2 = '#193c57';
          this.model.set('text1', _text3);
          this.model.set('text2', _text4);
          this.model.set('plan', _plan2);
          this.model.set('coloricon', _coloricon2);
          localStorage.setItem('gjs-js', editor.getJs());
          style = {
            width: '15%',
            height: '32%',
            'font-size': '1.2vw'
          };

          var _comps = this.model.get('components');
          if (_comps.length !== 0) {
            this.getComponent(position, temp, tempMin, tempMax, image, country, _text3, _text4, _plan2, Theme, degree, _coloricon2);
          }
        }
        if (Theme === 'theme3') {
          var _text5 = '#fdc104';
          var _text6 = '#FFFFFF';
          var _plan3 = 'linear-gradient(to bottom, #246fa8 0%,#670cd8 100%)';
          var _coloricon3 = '#FFFFFF';
          this.model.set('text1', _text5);
          this.model.set('text2', _text6);
          this.model.set('plan', _plan3);
          this.model.set('coloricon', _coloricon3);
          localStorage.setItem('gjs-js', editor.getJs());
          style = {
            width: '22%',
            height: '27%',
            'font-size': '1.2vw'
          };
          var _comps2 = this.model.get('components');
          if (_comps2.length !== 0) {
            this.getComponent(position, temp, tempMin, tempMax, image, country, _text5, _text6, _plan3, Theme, degree, _coloricon3);
          }
        }
        if (Theme === 'theme4') {
          var _text7 = '#fdc104';
          var _text8 = '#FFFFFF';
          var _plan4 = '#65486a';
          var _coloricon4 = '#FFFFFF';
          this.model.set('text1', _text7);
          this.model.set('text2', _text8);
          this.model.set('plan', _plan4);
          this.model.set('coloricon', _coloricon4);
          localStorage.setItem('gjs-js', editor.getJs());

          style = {
            width: '15%',
            height: '20%',
            'font-size': '1.2vw'
          };
          var _comps3 = this.model.get('components');
          if (_comps3.length !== 0) {
            this.getComponent(position, temp, tempMin, tempMax, image, country, _text7, _text8, _plan4, Theme, degree, _coloricon4);
          }
        }

        if (classes && classes[0]) {
          var oldStyle = cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes ? cssComposer.getClassRule(classes[0]).attributes.style : {};
          var newStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, oldStyle, style);
          cssComposer.setClassRule(classes[0], newStyle);
        }
        this.handleUpdate();
      },
      changeStyle: function changeStyle(colortext1, colortext2, colorplan, Themes, tempdegree, Icon) {
        if (colortext1) {
          text1 = colortext1;
        } else {
          text1 = this.model.get('text1');
        }

        if (colortext2) {
          text2 = colortext2;
        } else {
          text2 = this.model.get('text2');
        }
        if (colorplan) {
          plan = colorplan;
        } else {
          plan = this.model.get('plan');
        }

        if (tempdegree) {
          degree = tempdegree;
        } else {
          degree = this.model.get('temp');
        }
        if (Icon) {
          coloricon = Icon;
        } else {
          coloricon = this.model.get('coloricon');
        }
        localStorage.setItem('gjs-js', editor.getJs());
        this.handleUpdate();
        var comps = this.model.get('components');
        if (comps.length !== 0) {
          this.getComponent(position, temp, tempMin, tempMax, image, country, text1, text2, plan, Theme, degree, coloricon);
        }
      },
      changePosition: function changePosition(pos, self) {
        if (pos) {
          position = pos;
        } else {
          position = this.model.get('city') || localStorage.getItem('city') || 'Paris';
        }

        this.model.set('city', position);
        localStorage.setItem('city', position);
        var el = this;

        var xhttp = new XMLHttpRequest();
        var sunny = 'sunny';
        var partlyCloudy = 'partlyCloudy';
        var cloudy = 'cloudy';
        var weather = {
          temp: { current: undefined, min: undefined, max: undefined },
          clouds: null,
          location: '{location}',
          tempImg: null
        };
        xhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            var data = JSON.parse(this.response);
            if (data) {
              position = data.name;
              localStorage.setItem('city', position);

              if (data.main) {
                temp = data.main.temp;
                tempMin = data.main.temp_min;
                tempMax = data.main.temp_max;
                country = data.sys.country;
                localStorage.setItem('temp', temp);
                localStorage.setItem('tempMin', tempMin);
                localStorage.setItem('tempMax', tempMax);
                localStorage.setItem('country', country);
                if (self) el.render();
              }
              weather.clouds = data.clouds ? data.clouds.all : undefined;
              if (weather.clouds < 20) {
                image = sunny;
                localStorage.setItem('image', image);
              } else if (weather.clouds < 90) {
                image = partlyCloudy;
                localStorage.setItem('image', image);
              } else {
                image = cloudy;
                localStorage.setItem('image', image);
              }
              if (data.main) {
                el.getComponent(position, temp, tempMin, tempMax, image, country
                /* text1,
                text2,
                plan,
                Theme,
                degree,
                coloricon,*/
                );
              }
            }
          }
        };
        xhttp.open('GET', 'https://api.openweathermap.org/data/2.5/weather?q=' + position + '&units=metric&APPID=f9dbd911bc01df1d9ce563b2ba4d3209', true);
        xhttp.send();

        /*
        const comps = this.model.get('components');
        if (comps.length !== 0) {
          this.getComponent(
            position,
            temp,
            tempMin,
            tempMax,
            image,
            country,
           );
        }
        */
        localStorage.setItem('gjs-js', editor.getJs());
        this.handleUpdate();
      },
      handleUpdate: function handleUpdate() {
        var _this = this;

        var tidesModel = editor.getComponents().models.find(function (item) {
          return _this.view && item.attributes.attributes.id === _this.view.el.id;
        });
        var localStorageComponents = JSON.parse(localStorage.getItem('gjs-components')).map(function (item) {
          if (_this.view && item.attributes.id === _this.view.el.id) {
            item = tidesModel;
          }
          return item;
        });
        this.updateScript();
        localStorage.setItem('gjs-js', editor.getJs());
        localStorage.setItem('gjs-html', editor.getHtml());
        localStorage.setItem('gjs-components', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(localStorageComponents));
      },
      getComponent: function getComponent(pos, now, min, max, img, country, text1, text2, plan, Theme, degree, coloricon) {
        this.model.set('config', btoa(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_2__mixins_Mixin__["a" /* default */].methods.getLangCode('display-weather-plugin'))));
        var pos = pos,
            now = now,
            min = min,
            max = max,
            country = country,
            text1 = text1,
            text2 = text2,
            plan = plan,
            Theme = Theme,
            degree = degree,
            coloricon = coloricon;

        if (!pos && localStorage.getItem('city')) pos = localStorage.getItem('city');
        if (!now && localStorage.getItem('temp')) now = localStorage.getItem('temp');
        if (!min && localStorage.getItem('tempMin')) min = localStorage.getItem('tempMin');
        if (!max && localStorage.getItem('tempMax')) max = localStorage.getItem('tempMax');
        if (!max && localStorage.getItem('tempMax')) max = localStorage.getItem('tempMax');
        if (!country && localStorage.getItem('country')) country = localStorage.getItem('country');

        if (!coloricon) coloricon = this.model.get('coloricon');
        if (!degree) degree = this.model.get('temp');
        if (!Theme) Theme = this.model.get('Themes');
        if (!plan) plan = this.model.get('plan');
        if (!text2) text2 = this.model.get('text2');
        if (!text1) text1 = this.model.get('text1');

        var comps = this.model.get('components');
        var textNow = '';
        if (degree === 'C') textNow = parseInt(now).toString();else if (degree === 'F') textNow = parseInt(now * 9 / 5 + 32).toString();else {
          textNow = parseInt(now).toString();
          degree = 'C';
        }

        var base64 = '';
        var frBase64 = '';
        if (!img) img = localStorage.getItem('image');

        if (Theme === "theme2") {
          frBase64 = 'data:image/png;base64,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';
        }

        if (img === 'cloudy') {
          img = 'Cloudy';
          base64 = 'data:image/svg+xml;base64,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';
        } else if (img === 'sunny') base64 = 'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ0LjkgNDQuOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQuOSA0NC45OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgaGVpZ2h0PSI0MHB4IiB3aWR0aD0iNDBweCI+ICAgICAgICAgICAgPGcgaWQ9IlN1biI+ICAgICAgICAgICAgPGNpcmNsZSBpZD0iWE1MSURfNjFfIiBzdHlsZT0iZmlsbDojZmRjMTA0IiBjeD0iMjIuNCIgY3k9IjIyLjYiIHI9IjExIi8+ICAgICAgICAgICAgICA8Zz4gICAgICAgICAgICAgIDxwYXRoIGlkPSJYTUxJRF82MF8iIHN0eWxlPSJmaWxsOiNmZGMxMDQiIGQ9Ik0yMi42LDguMWgtMC4zYy0wLjMsMC0wLjYtMC4zLTAuNi0wLjZ2LTdjMC0wLjMsMC4zLTAuNiwwLjYtMC42bDAuMywwYzAuMywwLDAuNiwwLjMsMC42LDAuNiB2N0MyMy4yLDcuOCwyMi45LDguMSwyMi42LDguMXoiLz4gICAgICAgICAgICAgICAgPHBhdGggaWQ9IlhNTElEXzU5XyIgc3R5bGU9ImZpbGw6I2ZkYzEwNCIgZD0iTTIyLjYsMzYuOGgtMC4zYy0wLjMsMC0wLjYsMC4zLTAuNiwwLjZ2N2MwLDAuMywwLjMsMC42LDAuNiwwLjZoMC4zYzAuMywwLDAuNi0wLjMsMC42LTAuNnYtNyBDMjMuMiwzNywyMi45LDM2LjgsMjIuNiwzNi44eiIvPiAgICAgICAgICAgICAgICA8cGF0aCBpZD0iWE1MSURfNThfIiBzdHlsZT0iZmlsbDojZmRjMTA0IiBkPSJNOC4xLDIyLjN2MC4zYzAsMC4zLTAuMywwLjYtMC42LDAuNmgtN2MtMC4zLDAtMC42LTAuMy0wLjYtMC42bDAtMC4zYzAtMC4zLDAuMy0wLjYsMC42LTAuNmg3IEM3LjgsMjEuNyw4LjEsMjEuOSw4LjEsMjIuM3oiLz4gICAgICAgICAgICAgICAgPHBhdGggaWQ9IlhNTElEXzU3XyIgc3R5bGU9ImZpbGw6I2ZkYzEwNCIgZD0iTTM2LjgsMjIuM3YwLjNjMCwwLjMsMC4zLDAuNiwwLjYsMC42aDdjMC4zLDAsMC42LTAuMywwLjYtMC42di0wLjNjMC0wLjMtMC4zLTAuNi0wLjYtMC42aC03IEMzNywyMS43LDM2LjgsMjEuOSwzNi44LDIyLjN6Ii8+ICAgICAgICAgICAgICAgIDxwYXRoIGlkPSJYTUxJRF81Nl8iIHN0eWxlPSJmaWxsOiNmZGMxMDQiIGQ9Ik0xMS40LDMxLjZsMC4yLDAuM2MwLjIsMC4yLDAuMiwwLjYtMC4xLDAuOGwtNS4zLDQuNWMtMC4yLDAuMi0wLjYsMC4yLTAuOC0wLjFsLTAuMi0wLjMgYy0wLjItMC4yLTAuMi0wLjYsMC4xLTAuOGw1LjMtNC41QzEwLjksMzEuNCwxMS4yLDMxLjQsMTEuNCwzMS42eiIvPiAgICAgICAgICAgICAgICA8cGF0aCBpZD0iWE1MSURfNTVfIiBzdHlsZT0iZmlsbDojZmRjMTA0IiBkPSJNMzMuMiwxM2wwLjIsMC4zYzAuMiwwLjIsMC42LDAuMywwLjgsMC4xbDUuMy00LjVjMC4yLTAuMiwwLjMtMC42LDAuMS0wLjhsLTAuMi0wLjMgYy0wLjItMC4yLTAuNi0wLjMtMC44LTAuMWwtNS4zLDQuNUMzMywxMi40LDMzLDEyLjcsMzMuMiwxM3oiLz4gICAgICAgICAgICAgICAgPHBhdGggaWQ9IlhNTElEXzU0XyIgc3R5bGU9ImZpbGw6I2ZkYzEwNCIgZD0iTTExLjQsMTMuMmwwLjItMC4zYzAuMi0wLjIsMC4yLTAuNi0wLjEtMC44TDYuMyw3LjZDNi4xLDcuNCw1LjcsNy41LDUuNSw3LjdMNS4zLDcuOSBDNS4xLDguMiw1LjEsOC41LDUuNCw4LjdsNS4zLDQuNUMxMC45LDEzLjUsMTEuMiwxMy41LDExLjQsMTMuMnoiLz4gICAgICAgICAgICAgICAgPHBhdGggaWQ9IlhNTElEXzUzXyIgc3R5bGU9ImZpbGw6I2ZkYzEwNCIgZD0iTTMzLjIsMzEuOWwwLjItMC4zYzAuMi0wLjIsMC42LTAuMywwLjgtMC4xbDUuMyw0LjVjMC4yLDAuMiwwLjMsMC42LDAuMSwwLjhsLTAuMiwwLjMgYy0wLjIsMC4yLTAuNiwwLjMtMC44LDAuMWwtNS4zLTQuNUMzMywzMi41LDMzLDMyLjEsMzMuMiwzMS45eiIvPiAgICAgICAgICAgICAgICA8YW5pbWF0ZSAgICAgICAgICAgICAgICAgICAgICAgICBhdHRyaWJ1dGVOYW1lPSJvcGFjaXR5IiAgICAgICAgICAgICAgICAgICAgICAgICBhdHRyaWJ1dGVUeXBlPSJYTUwiICAgICAgICAgICAgICAgICAgICAgICAgIGR1cj0iMC41cyIgICAgICAgICAgICAgICAgICAgICAgICAga2V5VGltZXM9IjA7MC41OzEiICAgICAgICAgICAgICAgICAgICAgICAgIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiAgICAgICAgICAgICAgICAgICAgICAgICB2YWx1ZXM9IjE7MC42OzEiICAgICAgICAgICAgICAgICAgICAgICAgIGNhbGNNb2RlPSJsaW5lYXIiLz4gICAgICAgICAgICAgIDwvZz4gICAgICAgICAgICA8L2c+PC9zdmc+';else if (img === 'partlyCloudy') base64 = 'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDYxLjcgNDIuOCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNjEuNyA0Mi44OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+ICAgICAgICAgICAgPGcgaWQ9IkNsb3VkXzMiPiAgICAgICAgICAgIDxnIGlkPSJXaGl0ZV9jbG91ZF8zIj4gICAgICAgICAgICA8cGF0aCBpZD0iWE1MSURfMjRfIiBzdHlsZT0iZmlsbDojRkZGRkZGIiBkPSJNNDcuMiw0Mi44SDcuOWMtNC4zLDAtNy45LTMuNS03LjktNy45bDAsMEMwLDMwLjUsMy41LDI3LDcuOSwyN2gzOS40YzQuMywwLDcuOSwzLjUsNy45LDcuOSB2MEM1NS4xLDM5LjIsNTEuNiw0Mi44LDQ3LjIsNDIuOHoiLz4gICAgICAgICAgICAgICAgPGNpcmNsZSBpZD0iWE1MSURfMjNfIiBzdHlsZT0iZmlsbDojRkZGRkZGIiBjeD0iMTcuNCIgY3k9IjI1LjUiIHI9IjkuMyIvPiAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSJYTUxJRF8yMl8iIHN0eWxlPSJmaWxsOiNGRkZGRkYiIGN4PSIzNC41IiBjeT0iMjMuOSIgcj0iMTUuNiIvPiAgICAgICAgICAgICAgICA8YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIGF0dHJpYnV0ZVR5cGU9IlhNTCIgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgZHVyPSI2cyIgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAga2V5VGltZXM9IjA7MC41OzEiICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICB0eXBlPSJ0cmFuc2xhdGUiICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHZhbHVlcz0iMDs1OzAiICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIGNhbGNNb2RlPSJsaW5lYXIiPiAgICAgICAgICAgICAgICA8L2FuaW1hdGVUcmFuc2Zvcm0+ICAgICAgICAgICAgPC9nPiAgICAgICAgICAgICAgPGcgaWQ9IlN1bl8zIj4gICAgICAgICAgICA8Y2lyY2xlIGlkPSJYTUxJRF8zMF8iIHN0eWxlPSJmaWxsOiNmZGMxMDQiIGN4PSIzMS40IiBjeT0iMTguNSIgcj0iOSIvPiAgICAgICAgICAgICAgICA8Zz4gICAgICAgICAgICAgIDxwYXRoIGlkPSJYTUxJRF8zMV8iIHN0eWxlPSJmaWxsOiNmZGMxMDQiIGQ9Ik0zMS40LDYuNkwzMS40LDYuNmMtMC40LDAtMC42LTAuMy0wLjYtMC42VjAuNkMzMC44LDAuMywzMSwwLDMxLjMsMGwwLjEsMCBDMzEuNywwLDMyLDAuMywzMiwwLjZ2NS41QzMyLDYuNCwzMS43LDYuNiwzMS40LDYuNnoiLz4gICAgICAgICAgICAgICAgICA8cGF0aCBpZD0iWE1MSURfMzRfIiBzdHlsZT0iZmlsbDojZmRjMTA0IiBkPSJNMzEuNCwzMC4xTDMxLjQsMzAuMWMtMC40LDAtMC42LDAuMy0wLjYsMC42djUuNWMwLDAuMywwLjMsMC42LDAuNiwwLjZoMC4xIGMwLjMsMCwwLjYtMC4zLDAuNi0wLjZ2LTUuNUMzMiwzMC40LDMxLjcsMzAuMSwzMS40LDMwLjF6Ii8+ICAgICAgICAgICAgICAgICAgPHBhdGggaWQ9IlhNTElEXzM1XyIgc3R5bGU9ImZpbGw6I2ZkYzEwNCIgZD0iTTE5LjYsMTguM0wxOS42LDE4LjNjMCwwLjQtMC4zLDAuNi0wLjYsMC42aC01LjVjLTAuMywwLTAuNi0wLjMtMC42LTAuNnYtMC4xIGMwLTAuMywwLjMtMC42LDAuNi0wLjZIMTlDMTkuMywxNy44LDE5LjYsMTgsMTkuNiwxOC4zeiIvPiAgICAgICAgICAgICAgICAgIDxwYXRoIGlkPSJYTUxJRF8zM18iIHN0eWxlPSJmaWxsOiNmZGMxMDQiIGQ9Ik00My4xLDE4LjNMNDMuMSwxOC4zYzAsMC40LDAuMywwLjYsMC42LDAuNmg1LjVjMC4zLDAsMC42LTAuMywwLjYtMC42di0wLjEgYzAtMC4zLTAuMy0wLjYtMC42LTAuNmgtNS41QzQzLjQsMTcuOCw0My4xLDE4LDQzLjEsMTguM3oiLz4gICAgICAgICAgICAgICAgICA8cGF0aCBpZD0iWE1MSURfMzdfIiBzdHlsZT0iZmlsbDojZmRjMTA0IiBkPSJNMjIuNCwyNkwyMi40LDI2YzAuMywwLjMsMC4yLDAuNywwLDAuOWwtNC4yLDMuNmMtMC4yLDAuMi0wLjYsMC4yLTAuOC0wLjFsLTAuMS0wLjEgYy0wLjItMC4yLTAuMi0wLjYsMC4xLTAuOGw0LjItMy42QzIxLjksMjUuOCwyMi4yLDI1LjgsMjIuNCwyNnoiLz4gICAgICAgICAgICAgICAgICA8cGF0aCBpZD0iWE1MSURfMzZfIiBzdHlsZT0iZmlsbDojZmRjMTA0IiBkPSJNNDAuMywxMC43TDQwLjMsMTAuN2MwLjMsMC4zLDAuNiwwLjMsMC44LDAuMWw0LjItMy42YzAuMi0wLjIsMC4zLTAuNiwwLjEtMC44bC0wLjEtMC4xIGMtMC4yLTAuMi0wLjYtMC4zLTAuOC0wLjFsLTQuMiwzLjZDNDAuMSwxMC4xLDQwLDEwLjUsNDAuMywxMC43eiIvPiAgICAgICAgICAgICAgICAgIDxwYXRoIGlkPSJYTUxJRF8zOV8iIHN0eWxlPSJmaWxsOiNmZGMxMDQiIGQ9Ik0yMi40LDEwLjhMMjIuNCwxMC44YzAuMy0wLjMsMC4yLTAuNywwLTAuOWwtNC4yLTMuNmMtMC4yLTAuMi0wLjYtMC4yLTAuOCwwLjFsLTAuMSwwLjEgYy0wLjIsMC4yLTAuMiwwLjYsMC4xLDAuOGw0LjIsMy42QzIxLjksMTEsMjIuMiwxMSwyMi40LDEwLjh6Ii8+ICAgICAgICAgICAgICAgICAgPHBhdGggaWQ9IlhNTElEXzM4XyIgc3R5bGU9ImZpbGw6I2ZkYzEwNCIgZD0iTTQwLjMsMjYuMUw0MC4zLDI2LjFjMC4zLTAuMywwLjYtMC4zLDAuOC0wLjFsNC4yLDMuNmMwLjIsMC4yLDAuMywwLjYsMC4xLDAuOGwtMC4xLDAuMSBjLTAuMiwwLjItMC42LDAuMy0wLjgsMC4xbC00LjItMy42QzQwLjEsMjYuNyw0MCwyNi4zLDQwLjMsMjYuMXoiLz4gICAgICAgICAgICAgICAgICA8YW5pbWF0ZSAgICAgICAgICAgICAgICAgICAgICAgICAgIGF0dHJpYnV0ZU5hbWU9Im9wYWNpdHkiICAgICAgICAgICAgICAgICAgICAgICAgICAgYXR0cmlidXRlVHlwZT0iWE1MIiAgICAgICAgICAgICAgICAgICAgICAgICAgIGR1cj0iMC41cyIgICAgICAgICAgICAgICAgICAgICAgICAgICBrZXlUaW1lcz0iMDswLjU7MSIgICAgICAgICAgICAgICAgICAgICAgICAgICByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgICAgICAgICAgICAgICAgICAgICAgICAgICB2YWx1ZXM9IjE7MC42OzEiICAgICAgICAgICAgICAgICAgICAgICAgICAgY2FsY01vZGU9ImxpbmVhciIvPiAgICAgICAgICAgICAgPC9nPiAgICAgICAgICAgICAgPC9nPiAgICAgICAgICAgICAgPGFuaW1hdGVUcmFuc2Zvcm0gYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgYXR0cmlidXRlVHlwZT0iWE1MIiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgZHVyPSIycyIgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIGtleVRpbWVzPSIwOzEiICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIHR5cGU9InNjYWxlIiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgdmFsdWVzPSIxOzEiICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBjYWxjTW9kZT0ibGluZWFyIj4gICAgICAgICAgICAgIDwvYW5pbWF0ZVRyYW5zZm9ybT4gICAgICAgICAgIDwvZz4gIDxnIGlkPSJHcmF5X2Nsb3VkXzMiPiAgICAgICAgICA8cGF0aCBpZD0iWE1MSURfMjBfIiBzdHlsZT0iZmlsbDojRTBFMEUwIiBkPSJNNTUuNywyNS4xSDM0LjRjLTMuMywwLTYtMi43LTYtNnYwYzAtMy4zLDIuNy02LDYtNmgyMS4zYzMuMywwLDYsMi43LDYsNnYwIEM2MS43LDIyLjQsNTksMjUuMSw1NS43LDI1LjF6Ii8+ICAgIDxjaXJjbGUgaWQ9IlhNTElEXzE5XyIgc3R5bGU9ImZpbGw6I0UwRTBFMCIgY3g9IjQ2LjciIGN5PSIxMy40IiByPSIxMC43Ii8+ICAgIDxhbmltYXRlVHJhbnNmb3JtIGF0dHJpYnV0ZU5hbWU9InRyYW5zZm9ybSIgICAgICAgICAgICAgICAgICAgICAgYXR0cmlidXRlVHlwZT0iWE1MIiAgICAgICAgICAgICAgICAgICAgICBkdXI9IjZzIiAgICAgICAgICAgICAgICAgICAgICBrZXlUaW1lcz0iMDswLjU7MSIgICAgICAgICAgICAgICAgICAgICAgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiICAgICAgICAgICAgICAgICAgICAgIHR5cGU9InRyYW5zbGF0ZSIgICAgICAgICAgICAgICAgICAgICAgdmFsdWVzPSIwOy0zOzAiICAgICAgICAgICAgICAgICAgICAgIGNhbGNNb2RlPSJsaW5lYXIiPiAgICAgICAgICAgICAgPC9hbmltYXRlVHJhbnNmb3JtPiAgICAgICAgICAgPC9nPiA8L3N2Zz4=';

        var content = Theme !== 'theme2' ? '  \n        <div id="weather-grapes" class="emp-weather-container emp-weather-container-' + Theme + '" style=\'background:' + plan + '\'>\n            <div class="' + Theme + '-position" style=\'color:' + text1 + '\'>\n                 <span class="' + Theme + '-pays"><i class="fa fa-map-marker"></i> </span>\n                <strong id="position"> ' + pos + ' </strong> \n                <strong class="' + Theme + '-pays">,' + country + ' </strong> \n            </div>\n            <div class="' + Theme + '-date" style=\'color:' + text2 + '\'>\n                <span style="margin-right: 0.2em;" data-js="dateHeure-day">Lundi </span>\n                <span data-js="dateHeure-time" >  --:-- </span>  \n            </div> \n            <div class="' + Theme + '-meteo" ><img class="' + Theme + '-img-meteo-' + img + '"  src="' + base64 + '" /></div>\n            <div class="' + Theme + '-cart"><span style=\'color:' + coloricon + '\' class="pays-icon-fr icon-' + Theme + '"></span></div>\n            <div class="' + Theme + '-temp" style=\'color:' + text2 + '\'><span id="Temp"> ' + textNow + '\xB0</span><span class=\'' + Theme + '-degree\'>' + degree + '</span></div>\n        </div>\n            ' : '\n            <div id="weather-grapes" class="emp-weather-container emp-weather-container-' + Theme + '" style=\'background:' + plan + '\'>\n                <div class="' + Theme + '-position" style=\'color:' + text1 + '\'>\n                     <span class="' + Theme + '-pays"><i class="fa fa-map-marker"></i> </span>\n                    <strong id="position"> ' + pos + ' </strong> \n                    <strong class="' + Theme + '-pays">,' + country + ' </strong> \n                </div>\n                <div class="' + Theme + '-date" style=\'color:' + text2 + '\'>\n                    <span style="margin-right: 0.2em;" data-js="dateHeure-day">Lundi </span>\n                    <span data-js="dateHeure-time" >  --:-- </span>  \n                </div> \n                <div class="' + Theme + '-meteo" ><img class="' + Theme + '-img-meteo-' + img + '"  src="' + base64 + '" /></div>\n                <div class="' + Theme + '-cart"><span style=\'color:' + coloricon + '\' class="pays-icon-fr icon-' + Theme + '"></span></div>\n                <div class="' + Theme + '-temp" style=\'color:' + text2 + '\'><span id="Temp"> ' + textNow + '\xB0</span><span class=\'' + Theme + '-degree\'>' + degree + '</span></div>\n                <div class="' + Theme + '-fr-carte"><img class="' + Theme + '-img-meteo-fr"  src="' + frBase64 + '" /></div>\n             </div>\n                ';

        if (comps.length == 0) {
          comps.reset();
          comps.add(content);
        } else {
          this.model.set('components', content);
        }
      },
      render: function render() {
        this.model.set('config', btoa(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_2__mixins_Mixin__["a" /* default */].methods.getLangCode('display-weather-plugin'))));

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        defaultView.prototype.render.apply(this, args);
        this.updateClasses();
        var city = this.model.get('city') || localStorage.getItem('city');
        this.model.set('city', city);
        if (this.el.getElementsByTagName('DIV').length === 0) {
          Theme = this.model.get('Themes') || 'theme1';
          this.changeTheme(Theme);
          this.getComponent(position, temp, tempMin, tempMax, image, country, text1, text2, plan, Theme, degree, coloricon);
        }
        window.x = this.model;
        return this;
      }
    })
  });
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_grapesjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blocks__ = __webpack_require__(433);




/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_grapesjs___default.a.plugins.add('display-weather-plugin', function (editor) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // Add components
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */])(editor, opts);

  //  // Add blocks
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__blocks__["a" /* default */])(editor, opts);
}));

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var bm = editor.BlockManager;
  bm.add('web_widget', {
    label: 'Web',
    category: 'Widget',
    content: {
      activeOnRender: 1,
      resizable: {
        step: 0.2,
        minDim: 10,
        maxDim: 100,
        currentUnit: 1,
        autoHeight: true
      },
      void: true,
      type: 'web_widget',
      style: {
        width: '30%',
        height: '30%'
      }
    },
    attributes: {
      class: 'fa fa-globe' //icon in the panel
    }
  });
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var domc = editor.DomComponents;
  var defaultType = domc.getType('default');
  var defaultModel = defaultType.model;
  var defaultView = defaultType.view;

  domc.addType('web_widget', {
    model: defaultModel.extend({
      defaults: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultModel.prototype.defaults, {
        'custom-name': 'web',
        tagName: 'div',
        src: 'https://responsivedesign.is/examples/',
        width: '100%',
        height: '100%',
        traits: [{
          type: 'text',
          label: 'src',
          name: 'src',
          changeProp: 1
        }]
      }),
      init: function init() {
        this.listenTo(this, 'change:src', this.updateSrc);
      },
      toHTML: function toHTML() {
        //todo to html
        return this.view.el.getAttribute('data-gjs-type') == 'web_widget' ? this.view.el.outerHTML : '';
      },
      updateSrc: function updateSrc() {
        this.view.getIframe().src = this.createUri();
      },
      createUri: function createUri() {
        return this.get('src');
      }
    }, {
      isComponent: function isComponent(el) {
        var result = '';
        if (el.tagName == 'div') {
          result = { type: 'web_widget' };
        }
        return result;
      }
    }),
    view: defaultView.extend({
      initialize: function initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
      },
      getIframe: function getIframe() {
        if (!this.iframe) {
          var ifrm = document.createElement('iframe');
          if (this.model.get('src') != 'https://responsivedesign.is/examples/') {
            ifrm.src = this.model.createUri();
          } else {
            ifrm.src = 'https://responsivedesign.is/examples/';
          }
          ifrm.className = this.ppfx + 'no-pointer';
          ifrm.width = this.model.get('width');
          ifrm.height = this.model.get('height');
          ifrm.style.border = 'none;';
          ifrm.style.overflow = 'scroll';
          ifrm.scrolling = 'yes';
          ifrm.frameborder = '0';
          ifrm.allowtransparency = 'true';
          ifrm.allow = 'encrypted-media';

          this.iframe = ifrm;
        }
        return this.iframe;
      },
      render: function render() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        defaultView.prototype.render.apply(this, args);
        this.updateClasses();
        if (this.el.getElementsByTagName('IFRAME').length == 0) {
          this.el.appendChild(this.getIframe());
        }
        return this;
      }
    })
  });
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_grapesjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blocks__ = __webpack_require__(436);




/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_grapesjs___default.a.plugins.add('display-web-plugin', function (editor) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // Add components
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */])(editor, opts);

  //  // Add blocks
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__blocks__["a" /* default */])(editor, opts);
}));

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var bm = editor.BlockManager;
    bm.add('webrtc_widget', {
        label: 'WebRtc',
        category: 'Media',
        content: {
            type: 'webrtc_widget',
            resizable: true,
            style: {
                width: "320px",
                height: "400px"
            }
        },
        attributes: {
            class: 'fa fa-video-camera' //icon in the panel
        }
    });
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

/* harmony default export */ __webpack_exports__["a"] = (function (editor) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var domc = editor.DomComponents;
  var defaultType = domc.getType('default');
  var defaultModel = defaultType.model;
  var defaultView = defaultType.view;
  var camera;
  domc.addType('webrtc_widget', {
    model: defaultModel.extend({
      defaults: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultModel.prototype.defaults, {
        'custom-name': 'webrtc',
        tagName: 'div',
        src: '',
        width: '320',
        height: '400',
        traits: [{
          type: 'text',
          label: 'src',
          name: 'src',
          changeProp: 1
        }, {
          type: 'number',
          label: 'width',
          name: 'width',
          changeProp: 1
        }, {
          type: 'number',
          label: 'height',
          name: 'height',
          changeProp: 1
        }]
      }),
      init: function init() {
        this.listenTo(this, 'change:src', this.updateSrc);
        this.listenTo(this, 'change:width ', this.updateWidth);
        this.listenTo(this, 'change:height ', this.updateHeight);
      },
      toHTML: function toHTML() {
        return this.view && this.view.el.getAttribute('data-gjs-type') === 'webrtc_widget' ? this.view.el.outerHTML : '';
      },
      updateSrc: function updateSrc() {
        this.view.getIframe().src = this.createUri();
      },
      createUri: function createUri() {
        // this.updateWidth();
        // this.updateHeight();
        return this.get('src');
      },
      updateWidth: function updateWidth() {
        this.view.getIframe().width = this.get('width');
        this.view.getIframe().parentNode.style.width = this.get('width');
      },
      updateHeight: function updateHeight() {
        this.view.getIframe().height = this.get('height');
        this.view.getIframe().parentNode.style.height = this.get('height');
      }
    }, {
      isComponent: function isComponent(el) {
        var result = '';
        if (el.tagName == 'div') {
          result = { type: 'webrtc_widget' };
        }
        return result;
      }
    }),
    view: defaultView.extend({
      initialize: function initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
      },
      getScript: function getScript(src) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.charset = 'utf-8';
        script.src = src;
        script.async = true;
        return script;
      },
      getIframe: function getIframe() {
        camera = document.createElement('div');
        camera.innerHTML = '<video   width="100%" height="100%" controls autoplay></video>';

        return camera.firstChild;
      },
      render: function render() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        defaultView.prototype.render.apply(this, args);
        this.updateClasses();
        if (this.el.getElementsByTagName('DIV').length == 0) {
          this.el.appendChild(this.getIframe());
        }
        return this;
      }
    })
  });
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grapesjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_grapesjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blocks__ = __webpack_require__(439);




/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_grapesjs___default.a.plugins.add('display-webrtc-plugin', function (editor) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // Add components
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */])(editor, opts);
  //  // Add blocks
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__blocks__["a" /* default */])(editor, opts);
}));

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_http_http_token__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_router_router__ = __webpack_require__(18);



/* unused harmony default export */ var _unused_webpack_default_export = ({
  existe: function existe(title) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_http_http_token__["a" /* HTTP */])(window.ApiToken).get(__WEBPACK_IMPORTED_MODULE_1__core_router_router__["a" /* default */].generate('api_screenDisplay_get_existant_screen'), {
      params: {
        title: title
      }
    });
  },
  existeDisp: function existeDisp(title) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_http_http_token__["a" /* HTTP */])(window.ApiToken).get(__WEBPACK_IMPORTED_MODULE_1__core_router_router__["a" /* default */].generate('api_screenDisplay_check_existence_disposition'), {
      params: {
        title: title
      }
    });
  }
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var flatElements = function flatElements(src, dest) {
  src.forEach(function (o) {
    if (o.transition) dest.push(o);
    if (o.conf && o.conf.length > 0) {
      flatElements(o.conf, dest);
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (flatElements);

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_http_http_token__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_router_router__ = __webpack_require__(18);






var state = {
  dispositions: [],
  idDispo: [],
  all: [],
  selectedIds: [],
  selectedDispositions: [],
  loading: false,
  currentPage: 1,
  nbPerPage: 8,
  endReached: false,
  currentDisposition: '',
  defaultDisposition: []
};

function pushIdDispo(state, disposition) {
  state.idDispo.push(disposition);
}

function saveDisposition(dispo) {
  var data = {};
  var icon = document.getElementById('icon-add-dispo');
  var icon2 = document.getElementById('icon-add-dispo-load');
  var btnAdd = document.getElementById('success-dispo');
  btnAdd.style.display = 'none';
  // element.classList.add("mystyle");
  /*Todo change api save dispo*/
  data = { screenToSubmit: dispo };

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_http_http_token__["a" /* HTTP */])(window.ApiToken).post(__WEBPACK_IMPORTED_MODULE_4__core_router_router__["a" /* default */].generate('api_screenDisplay_post_add_edit_screen'), {
    data: data,
    client: 'demo'
  }).then(function (response) {
    if (response.data.code === 200) {
      pushIdDispo(state, response.data.id);
      icon.style.display = 'inline-block';
      icon2.style.display = 'none';
      btnAdd.style.display = 'block';
      var toast = self.$toasted.show('Disposition ajoutée avec succès', {
        theme: 'toasted-primary',
        position: 'top-center',
        duration: 4000
      });
      setTimeout(function () {
        var btnAdd = document.getElementById('success-dispo');
        btnAdd.style.display = 'block';
        var btnAddLoad = document.getElementById('success-dispo-loading');
        btnAddLoad.style.display = 'none';
      }, 2000);
    }
  });
}

var mutations = {
  setDispositions: function setDispositions(state, data) {
    state.dispositions = data;
  },
  setSelectedDispositionsIds: function setSelectedDispositionsIds(state, data) {
    state.selectedIds = data;
  },
  setSelectedDispositions: function setSelectedDispositions(state, data) {
    state.selectedDispositions = data;
  },
  setDispositionByIndex: function setDispositionByIndex(state, data) {
    state.dispositions[data.index] = data.disposition;
  },
  pushDispositions: function pushDispositions(state, disposition) {
    state.all = state.all.concat(disposition);
  },
  duplicateDisposition: function duplicateDisposition(state, dispositions) {
    state.selectedDispositions = state.selectedDispositions.concat(dispositions);
  },
  selectDisposition: function selectDisposition(state, dispositionId) {
    if (state.selectedIds.includes(dispositionId)) {
      state.selectedIds = state.selectedIds.filter(function (s) {
        return s !== dispositionId;
      });
    } else {
      state.selectedIds.push(dispositionId);
      var item = state.all.find(function (item) {
        return item.id === dispositionId;
      });
      item.options = { duration: 20000 };
      item.transition = { in: '', out: '' };
      state.selectedDispositions.push(item);
    }
  },
  setLoading: function setLoading(state, loading) {
    state.loading = loading;
  },
  incrementPage: function incrementPage(state) {
    state.currentPage += 1;
  },
  setEndReached: function setEndReached(state, endReached) {
    state.endReached = endReached;
  },
  unshiftDisposition: function unshiftDisposition(state, disposition) {
    state.dispositions.unshift(disposition);
  },
  addDisposition: function addDisposition(state, disposition) {
    //state.dispositions.push(disposition);

    saveDisposition(disposition);
    localStorage.setItem('component', disposition.components);
    localStorage.setItem('style', disposition.styles);
  },
  deleteDispositionsById: function deleteDispositionsById(state, id) {
    state.selectedDispositions = state.selectedDispositions.filter(function (item) {
      return item.id !== id;
    });
  },

  /**
   *
   * @function updateDispositionTitle
   */
  updateDispositionTitle: function updateDispositionTitle(state, title) {
    var index = state.dispositions.findIndex(function (item) {
      return title.oldTitle == item.title;
    });
    state.dispositions[index].title = title.newTitle;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_http_http_token__["a" /* HTTP */])(window.ApiToken).post(__WEBPACK_IMPORTED_MODULE_4__core_router_router__["a" /* default */].generate('api_screenDisplay_edit_title_disposition', {
      id: state.dispositions[index].id
    }), {
      title: title.newTitle
    }).then(function (response) {
      if (response.data.code === 200) {}
    });
  }
};
var actions = {
  paginateDispositions: function paginateDispositions(_ref) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var url, _ref2, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit('setLoading', true);
              url = __WEBPACK_IMPORTED_MODULE_4__core_router_router__["a" /* default */].generate('api_screenDisplay_get_all_disposition', {
                page: state.currentPage,
                nbParPage: state.nbPerPage,
                type: 'Disposition',
                client: localStorage.getItem('client')
              });
              _context.next = 4;
              return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_http_http_token__["a" /* HTTP */])(window.ApiToken).get(url).then(function (response) {
                  resolve(response);
                });
              });

            case 4:
              _ref2 = _context.sent;
              data = _ref2.data;


              commit('pushDispositions', data.data.dispositions);

              commit('incrementPage');
              if (data.data.dispositions.length === 0) {
                commit('setEndReached', true);
              }
              commit('setLoading', false);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  selectDisposition: function selectDisposition(_ref3, dispositionId) {
    var state = _ref3.state,
        commit = _ref3.commit;
    return commit('selectDisposition', dispositionId);
  },
  setDispositions: function setDispositions(_ref4, dispositions) {
    var state = _ref4.state,
        commit = _ref4.commit;
    return commit('setDispositions', dispositions);
  },
  deleteDispositionsById: function deleteDispositionsById(_ref5, dispositions) {
    var state = _ref5.state,
        commit = _ref5.commit;
    return commit('deleteDispositionsById', dispositions);
  },
  setSelectedDispositionsIds: function setSelectedDispositionsIds(_ref6, dispositions) {
    var state = _ref6.state,
        commit = _ref6.commit;
    return commit('setSelectedDispositionsIds', dispositions);
  },
  setSelectedDispositions: function setSelectedDispositions(_ref7, dispositions) {
    var state = _ref7.state,
        commit = _ref7.commit;
    return commit('setSelectedDispositions', dispositions);
  },
  addDisposition: function addDisposition(_ref8, disposition) {
    var state = _ref8.state,
        commit = _ref8.commit;
    return commit('addDisposition', disposition);
  },
  duplicateDisposition: function duplicateDisposition(_ref9, disposition) {
    var state = _ref9.state,
        commit = _ref9.commit;
    return commit('duplicateDisposition', disposition);
  },
  pushDispositions: function pushDispositions(_ref10, disposition) {
    var state = _ref10.state,
        commit = _ref10.commit;
    return commit('pushDispositions', disposition);
  },
  unshiftDisposition: function unshiftDisposition(_ref11, disposition) {
    var state = _ref11.state,
        commit = _ref11.commit;
    return commit('unshiftDisposition', disposition);
  },
  pushIdDispo: function pushIdDispo(_ref12, disposition) {
    var state = _ref12.state,
        commit = _ref12.commit;
    return commit('pushIdDispo', disposition);
  },
  setDispositionByIndex: function setDispositionByIndex(_ref13, data) {
    var state = _ref13.state,
        commit = _ref13.commit;
    return commit('setDispositionByIndex', data);
  },
  updateDispositionTitle: function updateDispositionTitle(_ref14, title) {
    var state = _ref14.state,
        commit = _ref14.commit;
    return commit('updateDispositionTitle', title);
  }
};
var getters = {
  getLoading: function getLoading(state) {
    return state.loading;
  },
  getEndReached: function getEndReached(state) {
    return state.endReached;
  },
  getAll: function getAll(state) {
    return state.all;
  },
  getSelectedIds: function getSelectedIds(state) {
    return state.selectedIds;
  },
  getSelectedDispositions: function getSelectedDispositions(state) {
    return state.selectedDispositions;
  },
  getDispositionPerId: function getDispositionPerId(state) {
    return function (id) {
      var disposition = state.all.filter(function (item) {
        return item.id === id;
      });
      return disposition;
    };
  },
  getDefaultDisposition: function getDefaultDisposition(state) {
    return state.defaultDisposition;
  },
  getCurrentDisposition: function getCurrentDisposition(state) {
    return state.currentDisposition;
  },
  getTemplateTitle: function getTemplateTitle(state) {
    return state.templateTitle;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var lp = './img/';
var plp = '//placehold.it/350x250/';

var state = {
  images: [lp + 'team1.jpg', lp + 'team2.jpg', lp + 'team3.jpg', plp + '78c5d6/fff/image1.jpg', plp + '459ba8/fff/image2.jpg', plp + '79c267/fff/image3.jpg', plp + 'c5d647/fff/image4.jpg', plp + 'f28c33/fff/image5.jpg', plp + 'e868a2/fff/image6.jpg', plp + 'cc4360/fff/image7.jpg', lp + 'work-desk.jpg', lp + 'phone-app.png', lp + 'bg-gr-v.png']
};
var mutations = {
  setImages: function setImages(state, images) {
    state.images = images;
  },
  setImageByIndex: function setImageByIndex(state, data) {
    state.dispositions[data.index] = data.image;
  }
};
var actions = {
  setImages: function setImages(_ref, images) {
    var state = _ref.state,
        commit = _ref.commit;
    return commit('setImages', images);
  },
  setImageByIndex: function setImageByIndex(_ref2, data) {
    var state = _ref2.state,
        commit = _ref2.commit;
    return commit('setImageByIndex', data);
  }
};
var getters = {
  getImages: function getImages(state) {
    return state.images;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_duration_handler__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_transition_handler__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_router_router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_http_http_token__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_http_http_go_token__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_index__ = __webpack_require__(229);









var state = {
  loading: false,
  title: '',
  nbPerPage: 32,
  medias: {
    videos: [],
    images: []
  },
  nbVideos: 0,
  page: {
    images: 1,
    videos: 1
  },
  endReachedMedias: {
    images: false,
    videos: false
  }
};

var mutations = {
  setTitleMedias: function setTitleMedias(state, title) {
    state.title = title;
  },
  setMedias: function setMedias(state, _ref) {
    var type = _ref.type,
        medias = _ref.medias;

    state.medias[type] = medias;
  },
  pushMedias: function pushMedias(state, _ref2) {
    var type = _ref2.type,
        medias = _ref2.medias;

    state.medias[type] = state.medias[type].concat(medias);
  },
  resetPageVideos: function resetPageVideos(state, type) {
    state.page[type] = 1;
  },
  setNbTotalVideos: function setNbTotalVideos(state, nb) {
    state.nbVideos = nb;
  },
  setLoading: function setLoading(state, loading) {
    state.loading = loading;
  },
  incrementPageMedias: function incrementPageMedias(state, type) {
    state.page[type] += 1;
  },
  isEndReachedMedias: function isEndReachedMedias(state, _ref3) {
    var type = _ref3.type,
        endReached = _ref3.endReached;

    state.endReachedMedias[type] = endReached;
  }
};

var actions = {
  reloadVideoList: function reloadVideoList(_ref4) {
    var _this = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var type, params, _ref5, data, datas;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              type = 'videos';
              params = {
                id: '',
                page: state.page[type],
                nbParPage: state.nbPerPage,
                client: localStorage.getItem('client'),
                maxBitrate: true
              };

              if (state.title) {
                params.searchWord = state.title;
              } else {
                params.searchWord = "";
              }

              commit('incrementPageMedias', type);
              _context.next = 6;
              return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__core_http_http_token__["a" /* HTTP */])(window.ApiToken).get(__WEBPACK_IMPORTED_MODULE_5__core_router_router__["a" /* default */].generate('api_media_get_media', params)).then(function (response) {
                  if (response.data.code === 200) {
                    if (response.data) {
                      resolve(response);
                    }
                  }
                });
              });

            case 6:
              _ref5 = _context.sent;
              data = _ref5.data;
              datas = data.medias;
              // commit('pushVideos',datas);

              commit('pushMedias', { type: type, medias: datas });
              commit('setNbTotalVideos', data.nombre_total);
              if (datas.length < state.nbPerPage) {
                commit('isEndReachedMedias', { type: type, endReached: true });
              }
              commit('setLoading', false);

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  reloadImageList: function reloadImageList(_ref6) {
    var _this2 = this;

    var commit = _ref6.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var type, params, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              type = 'images';
              params = {
                offset: (state.page[type] - 1) * state.nbPerPage,
                count: state.nbPerPage - 1
                // client: localStorage.getItem('client'),
              };

              if (state.title) {
                params.q = state.title;
              }
              commit('incrementPageMedias', type);

              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_8__services_index__["a" /* default */].getAllPhotos(params);

            case 6:
              data = _context2.sent;

              // commit('setNbTotalVideos', data.nombre_total);
              //commit('pushImages', data.data);
              commit('pushMedias', { type: type, medias: data.data });
              // commit('setLoading', false);

              if (data.data.length < state.nbPerPage - 1) {
                commit('isEndReachedMedias', { type: type, endReached: true });
              }
              commit('setLoading', false);

            case 10:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },

  setTitleMedias: function setTitleMedias(_ref7, title) {
    var state = _ref7.state,
        commit = _ref7.commit;
    return commit('setTitleMedias', title);
  },
  resetPageVideos: function resetPageVideos(_ref8, type) {
    var state = _ref8.state,
        commit = _ref8.commit;

    commit('resetPageVideos', type);
  },

  setMedias: function setMedias(_ref9, data) {
    var state = _ref9.state,
        commit = _ref9.commit;
    return commit('setMedias', data);
  },
  setEndReachedMedias: function setEndReachedMedias(_ref10, data) {
    var state = _ref10.state,
        commit = _ref10.commit;
    return commit('isEndReachedMedias', data);
  }
};

// getters are functions
var getters = {
  getLoading: function getLoading(state) {
    return state.loading;
  },
  getEndReachedMedias: function getEndReachedMedias(state) {
    return function (type) {
      return state.endReachedMedias[type];
    };
  },
  getAllMedias: function getAllMedias(state) {
    return function (type) {
      return state.medias[type];
    };
  },
  //getAllImages: state => type => state.medias[type],
  getNbVideos: function getNbVideos(state) {
    return state.nbVideos;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transitions__ = __webpack_require__(452);


// import drawSVG from '../bonus-files-for-npm-users/DrawSVGPlugin.js'

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    transitions: __WEBPACK_IMPORTED_MODULE_1__transitions__["a" /* default */],
    findTransition: function findTransition(key) {
      var t = null;
      this.transitions.forEach(function (tt) {
        if (tt.key === key) t = tt;
      });
      return t;
    }
  },
  mutations: {
    defaultElement: function defaultElement(state, ob) {
      var el = ob.element;
      var stagger = ob.stagger;
      if (stagger) el = el.querySelector('g').children;

      var origin = 'center center';
      var defaults = { opacity: 1, x: 0, y: 0, scale: 1, rotation: 0 };

      if (ob.transition) {
        ob.tween.properties.forEach(function (p) {
          var tob = { transformOrigin: origin };
          tob[p.prop] = defaults[p.prop];
          __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TweenMax */].set(el, tob);
        });
      }
    },
    animateElement: function animateElement(state, data) {
      var _this = this;

      var svg = document.querySelector('#' + data.x.file.idImg + ' svg');
      data.all.forEach(function (e) {
        var el = svg.querySelector('#' + e.id);
        e.element = el;
      });
      data.all.forEach(function (ob) {
        __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TweenMax */].killTweensOf(ob.element);
        var origin = 'center center';
        var ease = ob.tween.ease || 'Expo.easeInOut';
        var duration = ob.tween.duration || 1;
        var delay = ob.tween.delay || 0;
        var subdelay = ob.tween.subdelay || 0.1;
        var repeat = ob.tween.repeat || 0;
        var el = ob.element;
        var stagger = ob.stagger;
        if (stagger) el = el.querySelector('g').children;
        _this.commit('defaultElement', ob);
        if (ob.transition) {
          ob.tween.properties.forEach(function (p) {
            if (p.value !== '') {
              var _ease = p.ease || ease;
              var _duration = p.duration || duration;
              var _delay = p.delay || delay;
              var tob = { transformOrigin: origin, ease: _ease, delay: +_delay };
              tob[p.prop] = p.value;
              if (stagger) {
                var _subdelay = p.subdelay || subdelay;
                __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TweenMax */].staggerFrom(el, +_duration, tob, _subdelay);
              } else {
                __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TweenMax */].from(el, +_duration, tob);
              }
            }
          });
        }
      });
    },
    stopAnimated: function stopAnimated(state, list) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TweenMax */].killAll();
      list.forEach(function (ob) {
        _this2.commit('defaultElement', ob);
      });
    }
  },
  getters: {
    transitions: function transitions(state) {
      return state.transitions;
    }
  }
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  players: [{
    id: 1,
    title: 'player 1',
    lien: 'http://ahedia-web-dev.webtv-solution.com/uep_v2/dist/nV2g409KY0SaH5KLTNH0D6dN69Y1FhY6sNepprxRbsM',
    preview: 'data:image/png;base64,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'
  }, {
    id: 2,
    title: 'player 2',
    lien: 'http://nbouaziz-web-dev.webtv-solution.com/version/uep_v2/docs/wjX75sp7U7c9Br5_ALKXJkFS6ra_WPv7F7Bh2sz3L-c?plugin=simple',
    preview: 'data:image/png;base64,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'
  }]
};
var mutations = {
  setPlayers: function setPlayers(state, players) {
    state.players = players;
  },
  setPlayerByIndex: function setPlayerByIndex(state, data) {
    state.players[data.index] = data.player;
  }
};
var actions = {
  setPlayers: function setPlayers(_ref, players) {
    var state = _ref.state,
        commit = _ref.commit;
    return commit('setPlayers', players);
  },
  setPlayerByIndex: function setPlayerByIndex(_ref2, data) {
    var state = _ref2.state,
        commit = _ref2.commit;
    return commit('setPlayerByIndex', data);
  }
};
var getters = {
  getPlayers: function getPlayers(state) {
    return state.players;
  },
  getPlayersById: function getPlayersById(state) {
    return function (id) {
      return state.players.filter(function (element) {
        return element.id === id;
      });
    };
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_router_router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_http_http_token__ = __webpack_require__(25);






var state = {
  all: [],
  selectedIds: [],
  selectedScreens: [],
  loading: false,
  currentPage: 1,
  nbPerPage: 8,
  endReached: false,
  // TO BE DELETED
  templateTitle: '',

  screens: [],
  currentScreen: '',
  defaultscreen: [],
  hasVideoIntro: {
    id: '',
    value: ''
  }
};

var mutations = {
  setListScreens: function setListScreens(state, screens) {
    state.screens = screens;
    // for (var i = 0; i < screens.length; i++) {
    //   if (typeof screens[i].options == 'undefined') {
    //     screens[i].type = "Screen";
    //     screens[i].options = {duration: 5, transition: 'bounce', videointro: {html: '', css: '', duration: 7}};
    //   }
    // }
  },
  setScreens: function setScreens(state, data) {
    state.screens = data;
  },
  setSelectedScreenIds: function setSelectedScreenIds(state, data) {
    state.selectedIds = data;
  },
  setSelectedScreens: function setSelectedScreens(state, data) {
    state.selectedScreens = data;
  },
  pushScreens: function pushScreens(state, screens) {
    state.all = state.all.concat(screens);
  },
  pushEdited: function pushEdited(state, screens) {
    state.selectedScreens = state.selectedScreens.concat(screens);
  },
  duplicateScreens: function duplicateScreens(state, screens) {
    state.selectedScreens = state.selectedScreens.concat(screens);
  },
  selectScreen: function selectScreen(state, screenId) {
    if (state.selectedIds.includes(screenId)) {
      state.selectedIds = state.selectedIds.filter(function (s) {
        return s !== screenId;
      });
    } else {
      state.selectedIds.push(screenId);
      state.all.forEach(function (item) {
        if (item.id === screenId) {
          item.options = { duration: 20000, videointro: { html: '', css: '', duration: 20000 } };
          item.transition = { in: '', out: '' };
          state.selectedScreens.push(item);
        }
      });

      // state.selectedScreens.push( state.all.find(item => item.id === screenId));
    }
  },
  setLoading: function setLoading(state, loading) {
    state.loading = loading;
  },
  incrementPage: function incrementPage(state) {
    state.currentPage += 1;
  },
  setEndReached: function setEndReached(state, endReached) {
    state.endReached = endReached;
  },


  // SET_LIST_SCREEN(state, screens) {
  //     state.screens = screens;
  //     for (var i = 0; i < screens.length; i++) {
  //         if (typeof screens[i].options == 'undefined') {
  //             screens[i].type = "Screen";
  //             screens[i].options = {duration: 5, transition: 'bounce', videointro: {html: '', css: '', duration: 7}};
  //         }
  //     }
  // },
  setComponentScreenByIndex: function setComponentScreenByIndex(state, screen) {
    state.selectedScreens[screen.index].components = screen.components;
    state.selectedScreens[screen.index].html = screen.html;
    state.selectedScreens[screen.index].css = screen.css;
  },
  setTitleScreens: function setTitleScreens(state, screens) {
    state.screens = screens;
    for (var i = 0; i < screens.length; i++) {
      screens[i].title = 'Screen ' + __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__["a" /* default */].methods.makeId();
    }
  },
  setVideoIntro: function setVideoIntro(state, obj) {
    if (!state.selectedScreens[obj.index].options) {
      state.selectedScreens[obj.index].options = {
        duration: 20,
        videointro: { html: '', css: '', duration: 0 }
      };
    }
    state.selectedScreens[obj.index].options.videointro.html = obj.intro;
    state.selectedScreens[obj.index].options.videointro.duration = obj.durationIntro;
    var videoIntro = {
      id: state.selectedScreens[obj.index].id,
      value: true
    };
    state.hasVideoIntro = videoIntro;
  },
  setDurationScreen: function setDurationScreen(state, data) {
    for (var i = 0; i < state.screens.length; i++) {
      if (state.screens[i].title == data.title) {
        state.screens[i].options.duration = data.duration;
      }
    }
  },
  setTransitionScreen: function setTransitionScreen(state, data) {
    state.selectedScreens = state.selectedScreens.map(function (screen, index) {
      if (index === data.index - 1) {
        screen.transition.out = data.name + '-out';
      } else if (index === data.index) {
        screen.transition.in = data.name + '-in';
      }
      return screen;
    });
  },
  deleteScreensById: function deleteScreensById(state, id) {
    state.selectedScreens = state.selectedScreens.filter(function (item) {
      return item.id !== id;
    });
  },
  existanceScreen: function existanceScreen(state, title) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_http_http_token__["a" /* HTTP */])(window.ApiToken).get(__WEBPACK_IMPORTED_MODULE_3__core_router_router__["a" /* default */].generate('api_screenDisplay_get_existant_screen'), {
      title: title
    }).then(function (response) {
      return response.data.existance;
    });
  },
  setCurrentScreen: function setCurrentScreen(state, currentScreen) {
    state.currentScreen = currentScreen;
  },
  saveTitle: function saveTitle(state, title) {
    state.templateTitle = title;
  },


  // pushScreen(state, screen) {
  //
  //
  //     screen.type = "Screen";
  //     screen.title = "Screen " +mixin.methods.makeId();
  //     screen.options = {
  //         duration: 2,
  //         transition: 'bounce',
  //         videointro: {html: '', css: '', duration: 10},
  //     };
  //     if (screen.screenShot === "") {
  //         screen.screenShot = "http://nbouaziz-web-dev.webtv-solution.com/version/FO/demo/display/screen.png";
  //     }
  //
  //     state.screens.push(screen);
  //
  //
  // },
  //
  // pushScreens(state, screens) {
  //     for (var i = 0; i < screens.length; i++) {
  //         var screen= screens[i];
  //         screen.type = "Screen";
  //         screen.title = "Screen " + mixin.methods.makeId();
  //         screen.options = {
  //             duration: 2,
  //             transition: 'bounce',
  //             videointro: {html: '', css: '', duration: 10},
  //         };
  //         if (screen.screenShot === "") {
  //             screen.screenShot = "http://nbouaziz-web-dev.webtv-solution.com/version/FO/demo/display/screen.png";
  //         }
  //
  //
  //         state.screens.push(screen);
  //
  //     }
  //
  // },

  concatScreen: function concatScreen(state, screens) {
    state.screens.concat(screens);
  },
  updateScreenbyId: function updateScreenbyId(state, screenid) {
    state.screen = state.screens.filter(function (item) {
      return item.id === screenid.id;
    });

    /* state.screen[0].components = screenid.component;
        state.screen[0].styles = screenid.style;
        state.screen[0].html = screenid.html;
        state.screen[0].assets = screenid.assets;
        state.screen[0].css = screenid.css;*/
  },
  updateScreenTitle: function updateScreenTitle(state, title) {
    var index = state.screens.findIndex(function (item) {
      return title.id === item.id;
    });
    state.screens[index].title = title.newTitle;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_http_http_token__["a" /* HTTP */])(window.ApiToken).post(__WEBPACK_IMPORTED_MODULE_3__core_router_router__["a" /* default */].generate('api_screenDisplay_edit_title_disposition', { id: title.id }), {
      title: title.newTitle
    }).then(function (response) {});
  }
};

// actions are functions that cause side effects and can involve
// asynchronous operations.
var actions = {
  paginateScreens: function paginateScreens(_ref) {
    /*commit('setLoading', true);
    const url = Routing.generate('api_screenDisplay_get_all_disposition', {
      page: state.currentPage,
      nbParPage: state.nbPerPage,
      type: 'Screen',
      client: localStorage.getItem('client')
    });
    const { data } = await new Promise((resolve, reject) => {
      HTTP(window.ApiToken)
        .get(url)
        .then(function (response) {
          resolve(response)
        });
    });
     commit('pushScreens', data.data.dispositions);
     commit('incrementPage');
    if (data.data.dispositions.length < state.nbPerPage) {
      commit('setEndReached', true);
    }
    commit('setLoading', false);*/

    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  // paginateScreens: ({ state, commit }, screens) => commit('setScreens', screens),
  setScreens: function setScreens(_ref2, screens) {
    var state = _ref2.state,
        commit = _ref2.commit;
    return commit('setScreens', screens);
  },
  setSelectedScreenIds: function setSelectedScreenIds(_ref3, screens) {
    var state = _ref3.state,
        commit = _ref3.commit;
    return commit('setSelectedScreenIds', screens);
  },
  setSelectedScreens: function setSelectedScreens(_ref4, screens) {
    var state = _ref4.state,
        commit = _ref4.commit;
    return commit('setSelectedScreens', screens);
  },
  selectScreen: function selectScreen(_ref5, screenId) {
    var state = _ref5.state,
        commit = _ref5.commit;
    return commit('selectScreen', screenId);
  },
  duplicateScreens: function duplicateScreens(_ref6, screens) {
    var state = _ref6.state,
        commit = _ref6.commit;
    return commit('duplicateScreens', screens);
  },

  setComponentScreenByIndex: function setComponentScreenByIndex(_ref7, screen) {
    var state = _ref7.state,
        commit = _ref7.commit;
    return commit('setComponentScreenByIndex', screen);
  },
  setListScreens: function setListScreens(_ref8, screens) {
    var state = _ref8.state,
        commit = _ref8.commit;
    return commit('setListScreens', screens);
  },
  setTitleScreens: function setTitleScreens(_ref9, screens) {
    var state = _ref9.state,
        commit = _ref9.commit;
    return commit('setTitleScreens', screens);
  },
  setDurationScreen: function setDurationScreen(_ref10, duration) {
    var state = _ref10.state,
        commit = _ref10.commit;
    return commit('setDurationScreen', duration);
  },
  setTransitionScreen: function setTransitionScreen(_ref11, transition) {
    var state = _ref11.state,
        commit = _ref11.commit;
    return commit('setTransitionScreen', transition);
  },
  setVideoIntro: function setVideoIntro(_ref12, obj) {
    var state = _ref12.state,
        commit = _ref12.commit;
    return commit('setVideoIntro', obj);
  },
  deleteScreensById: function deleteScreensById(_ref13, id) {
    var state = _ref13.state,
        commit = _ref13.commit;
    return commit('deleteScreensById', id);
  },
  concatScreen: function concatScreen(_ref14, screens) {
    var state = _ref14.state,
        commit = _ref14.commit;
    return commit('concatScreen', screens);
  },
  pushScreens: function pushScreens(_ref15, screen) {
    var state = _ref15.state,
        commit = _ref15.commit;
    return commit('pushScreens', screen);
  },
  pushEdited: function pushEdited(_ref16, screen) {
    var state = _ref16.state,
        commit = _ref16.commit;
    return commit('pushEdited', screen);
  },

  saveTitle: function saveTitle(_ref17, title) {
    var state = _ref17.state,
        commit = _ref17.commit;
    return commit('saveTitle', title);
  },
  setCurrentScreen: function setCurrentScreen(_ref18, currentScreen) {
    var state = _ref18.state,
        commit = _ref18.commit;
    return commit('setCurrentScreen', currentScreen);
  },
  updateScreenbyId: function updateScreenbyId(_ref19, Screenid) {
    var state = _ref19.state,
        commit = _ref19.commit;
    return commit('updateScreenbyId', Screenid);
  },
  updateScreenTitle: function updateScreenTitle(_ref20, title) {
    var state = _ref20.state,
        commit = _ref20.commit;
    return commit('updateScreenTitle', title);
  }
};

// getters are functions
var getters = {
  getLoading: function getLoading(state) {
    return state.loading;
  },
  getEndReached: function getEndReached(state) {
    return state.endReached;
  },
  getAll: function getAll(state) {
    return state.all;
  },
  getSelectedIds: function getSelectedIds(state) {
    return state.selectedIds;
  },
  getSelectedScreens: function getSelectedScreens(state) {
    return state.selectedScreens;
  },
  getScreenPerId: function getScreenPerId(state) {
    return function (id) {
      var screen = state.selectedScreens.find(function (item) {
        return item.id === id;
      });
      return screen;
    };
  },
  getHasVideoIntro: function getHasVideoIntro(state) {
    return state.hasVideoIntro;
  },
  getDefaultScreen: function getDefaultScreen(state) {
    return state.defaultscreen;
  },
  getCurrentScreen: function getCurrentScreen(state) {
    return state.currentScreen;
  },
  getTemplateTitle: function getTemplateTitle(state) {
    return state.templateTitle;
  }
  // getCurrentscreename:  state => state.screens[state.currentScreen]['title'],
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_number_is_integer__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_duration_handler__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_transition_handler__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__core_router_router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__core_http_http_token__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__core_http_http_go_token__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_index__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__i18n__ = __webpack_require__(35);
















var state = {
  fromRouteAdd: true,
  fromRouteBiblio: false,
  Auteurs: [],
  themes: [],
  selectedSegments: [],
  current: {},
  loading: false,
  duplicatedSegment: null,
  duplicatedSlideInSegment: null,

  moduleSelected: [],

  currentPage: {
    Segment: 1,
    DefaultSegment: 1
  },
  theme: 0,
  author: 0,
  title: '',
  nbPerPage: 32,
  endReached: {
    Segment: false,
    DefaultSegment: false
  },
  generic: {
    start: {},
    end: {}
  },
  delay: 0,
  opacity: 100,
  segments: [],
  indexSlideToAdd: 0,
  indexSegmentToAdd: 0,
  indexSegmentSlideToAdd: 0,
  lengthSegmentToAdd: 0,
  nbrCall: 1,
  typeGeneric: '',
  nbSegments: 0
};

var mutations = {
  pushModuleSelected: function pushModuleSelected(state, segment) {
    var date = new Date(segment.duration);
    var duration = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_number_is_integer___default()(segment.duration) ? segment.duration : Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()) / 1000;
    var s = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({
      uid: Math.floor(new Date().valueOf() * Math.random())
    }, segment, {
      duration: duration,
      originalDuration: duration
    });
    s.screens = s.screens.map(function (s) {
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({
        uid: Math.floor(new Date().valueOf() * Math.random()),
        transition: s.options.transition && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(s.options.transition).length > 0 ? s.options.transition : { in: '', out: '' },
        options: {
          duration: __WEBPACK_IMPORTED_MODULE_9__helpers_duration_handler__["a" /* totalSegmentDuration */](),
          fullscreenVideo: s.options.fullscreenVideo
        }
      }, s);
    });
    var isUpdate = s.isUpdate;
    if (s.isUpdate) {
      delete s.isUpdate;
    }
    state.moduleSelected.push(s);
    if (!!!isUpdate) {
      state.moduleSelected = __WEBPACK_IMPORTED_MODULE_9__helpers_duration_handler__["b" /* updateSegmentDuration */](state.moduleSelected);
    } else {
      state.moduleSelected = __WEBPACK_IMPORTED_MODULE_9__helpers_duration_handler__["c" /* updateSegmentOriginalDuration */](state.moduleSelected);
    }
  },
  restModuleSelected: function restModuleSelected(state) {
    state.moduleSelected = [];
  },
  removeFromModuleSelected: function removeFromModuleSelected(state, id) {
    state.moduleSelected = state.moduleSelected.filter(function (s) {
      return s.id !== id;
    });
  },
  updateSegmentTitleInStore: function updateSegmentTitleInStore(state, data) {
    state.selectedSegments = state.selectedSegments.map(function (Segment) {
      if (Segment.uid === data.uid) {
        Segment.title = data.title;
      }
      return Segment;
    });
  },
  setCurrentSegmentTitle: function setCurrentSegmentTitle(state, title) {
    state.current.title = title;
  },
  setTitle: function setTitle(state, title) {
    state.title = title;
  },
  setThemeid: function setThemeid(state, id) {
    state.theme = id;
  },
  setAuthorid: function setAuthorid(state, id) {
    state.author = id;
  },
  resetPage: function resetPage(state, types) {
    state.currentPage[types] = 1;
  },
  setSegments: function setSegments(state, data) {
    state.segments = data;
  },
  pushSegments: function pushSegments(state, segments) {
    state.segments = state.segments.concat(segments);
  },
  cancelDelete: function cancelDelete(state, data) {
    state.segments.splice(data.index, 0, data.segment);
  },
  nbSegments: function nbSegments(state, nb) {
    state.nbSegments = nb;
  },
  selectSegment: function selectSegment(state, segment) {
    var date = new Date(segment.duration);

    var duration = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_number_is_integer___default()(segment.duration) ? segment.duration : Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()) / 1000;
    var s = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({
      uid: Math.floor(new Date().valueOf() * Math.random())
    }, segment, {
      duration: duration,
      originalDuration: duration
    });
    s.screens = s.screens.map(function (s) {
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({
        uid: Math.floor(new Date().valueOf() * Math.random()),
        transition: s.options.transition && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(s.options.transition).length > 0 ? s.options.transition : { in: '', out: '' },
        options: {
          duration: __WEBPACK_IMPORTED_MODULE_9__helpers_duration_handler__["a" /* totalSegmentDuration */](),
          fullscreenVideo: s.options.fullscreenVideo
        }
      }, s);
    });
    var isUpdate = s.isUpdate;
    if (s.isUpdate) {
      delete s.isUpdate;
    }
    /* if (state.indexSegmentToAdd > -1) {
       state.selectedSegments = [
         ...state.selectedSegments.slice(0, state.indexSegmentToAdd),
         s,
         ...state.selectedSegments.slice(state.indexSegmentToAdd),
       ];
       state.indexSegmentToAdd++;
     } else {*/
    state.selectedSegments.push(s);
    // }

    if (!!!isUpdate) {
      state.selectedSegments = __WEBPACK_IMPORTED_MODULE_9__helpers_duration_handler__["b" /* updateSegmentDuration */](state.selectedSegments);
    } else {
      state.selectedSegments = __WEBPACK_IMPORTED_MODULE_9__helpers_duration_handler__["c" /* updateSegmentOriginalDuration */](state.selectedSegments);
    }
  },
  setLoading: function setLoading(state, loading) {
    state.loading = loading;
  },
  setfromRouteAdd: function setfromRouteAdd(state, add) {
    state.fromRouteAdd = add;
  },
  setfromRouteBiblio: function setfromRouteBiblio(state, is) {
    state.fromRouteBiblio = is;
  },
  pushAuteurs: function pushAuteurs(state, s) {
    state.Auteurs.push(s);
  },
  resetAuteurs: function resetAuteurs(state) {
    state.Auteurs = [];
  },
  pushThemes: function pushThemes(state, s) {
    state.themes.push(s);
  },
  resetThemes: function resetThemes(state) {
    state.themes = [];
  },
  updateDataCurrentSegment: function updateDataCurrentSegment(state, data) {
    state.current.keyWords = data.keyWords;
    state.current.description = data.description;
    state.current.themes = data.Objectthemes;
    state.current.author = data.ObjectAuthor;
  },
  incrementPage: function incrementPage(state, type) {
    state.currentPage[type] += 1;
  },
  setEndReached: function setEndReached(state, _ref) {
    var type = _ref.type,
        endReached = _ref.endReached;

    state.endReached[type] = endReached;
  },
  setSegmentsGeneric: function setSegmentsGeneric(state, slide) {
    var html = '<iframe class="gjs-no-pointer" src="' + slide.src + '?a=1&sc=0" id="player-677" width="100%" height="100%" scrolling="no" allow="encrypted-media" style="border: none; overflow: hidden;"></iframe>';
    var extension = slide.src.split('.').pop();
    if (extension.toLowerCase().indexOf('mp4') > -1) {
      html = '<video data-autoplay class="gjs-no-pointer" data-src="' + slide.src + '" id="player-' + (Math.floor(Math.random() * 10) + Math.floor(Math.random() * 10)) + '" width="100%" height="100%" scrolling="no" allow="encrypted-media" muted autoplay style="border: none; overflow: hidden;"></video>';
    }
    var generic = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({
      html: html,
      type: slide.type,
      components: '',
      css: '',
      js: '',
      options: {
        duration: __WEBPACK_IMPORTED_MODULE_9__helpers_duration_handler__["a" /* totalSegmentDuration */]()
      },
      screenShot: '',
      transition: { in: '', out: '' }
    }, slide);
    var segment = {
      duration: generic.options.duration,
      screens: [generic],
      title: slide.title,
      type: slide.type
    };
    var selected = state.selectedSegments.filter(function (s) {
      return s.type !== slide.type;
    });
    if (segment.screens[0].src !== '') {
      if (generic.type.toLowerCase().includes('start')) {
        selected.unshift(segment);
      } else {
        selected.push(segment);
      }
    }
    selected = __WEBPACK_IMPORTED_MODULE_9__helpers_duration_handler__["b" /* updateSegmentDuration */](selected);
    state.selectedSegments = selected;
    state.selectedSegments = __WEBPACK_IMPORTED_MODULE_10__helpers_transition_handler__["a" /* updateSegmentsTransition */](state.selectedSegments);
  },
  setSegmentsGenericFinEmpty: function setSegmentsGenericFinEmpty(state, slide) {
    var selected = state.selectedSegments.filter(function (s) {
      return s.type == slide.type;
    });
    if (selected[0] && selected[0].screens && selected[0].screens[0].src !== '') {
      state.selectedSegments.pop();
    }
    selected = __WEBPACK_IMPORTED_MODULE_9__helpers_duration_handler__["b" /* updateSegmentDuration */](state.selectedSegments);
    state.selectedSegments = selected;
    state.selectedSegments = __WEBPACK_IMPORTED_MODULE_10__helpers_transition_handler__["a" /* updateSegmentsTransition */](state.selectedSegments);
  },
  setVideoIntro: function setVideoIntro(state, slide) {
    var html = '<iframe class="gjs-no-pointer" src="' + slide.src + '?a=1&sc=0" id="player-677" width="100%" height="100%" scrolling="no" allow="encrypted-media" style="border: none; overflow: hidden;"></iframe>';
    var extension = slide.src.split('.').pop();
    if (extension.toLowerCase().indexOf('mp4') > -1) {
      html = '<video data-autoplay class="gjs-no-pointer" src="' + slide.src + '" id="player-677" width="100%" height="100%" muted autoplay scrolling="no" allow="encrypted-media" style="border: none; overflow: hidden;"></video>';
    }
    var generic = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({
      html: html,
      type: slide.type,
      components: '',
      css: '',
      js: '',
      options: {
        duration: __WEBPACK_IMPORTED_MODULE_9__helpers_duration_handler__["a" /* totalSegmentDuration */]()
      },
      screenShot: '',
      transition: { in: '', out: '' }
    }, slide);
    var index = +slide.index;

    state.selectedSegments = state.selectedSegments.map(function (segment, i) {
      if (i === index) {
        var transition = segment.screens[0].transition.in || '';
        if (transition) {
          generic.transition.in = transition;
          segment.screens[0].transition.in = '';
        }
        segment.screens = segment.screens.filter(function (s) {
          return s.type !== generic.type;
        });
        if (generic.src !== '') {
          segment.screens.unshift(generic);
        }
        segment.duration = segment.screens.reduce(function (sum, e) {
          return sum + +(e.options.duration || 0);
        }, 0);
      }
      return segment;
    });
    state.selectedSegments = __WEBPACK_IMPORTED_MODULE_9__helpers_duration_handler__["b" /* updateSegmentDuration */](state.selectedSegments);
    state.selectedSegments = __WEBPACK_IMPORTED_MODULE_10__helpers_transition_handler__["a" /* updateSegmentsTransition */](state.selectedSegments);
  },

  /* setSegmentDuration(state, data) {
    state.selected = state.selected.map(Segment => {
      if (Segment.id === data.id) {
        Segment.duration = data.duration;
      }
      return Segment;
    });
  },*/
  setCurrentSegmentDuration: function setCurrentSegmentDuration(state, duration) {
    state.current.duration = duration;
  },
  updateSegment: function updateSegment(state, data) {
    state.selectedSegments = state.selectedSegments.map(function (segment, index) {
      if (segment.id === data.id) {
        state.selectedSegments[index].title = data.title || '';
        state.selectedSegments[index].duration = data.duration || '';
        state.selectedSegments[index].screensToSubmit = data.screensToSubmit || [];
      }
      return segment;
    });
  },
  deleteSegmentByIdStore: function deleteSegmentByIdStore(state, item) {
    state.segments = state.segments.filter(function (segment) {
      return segment.id !== item.id;
    });
  },
  removeLastSegmentById: function removeLastSegmentById(state, id) {
    state.selectedSegments = state.selectedSegments.filter(function (s, i) {
      return s.id !== id;
    });
  },
  existanceSlide: function existanceSlide(state, title) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__core_http_http_token__["a" /* HTTP */])(window.ApiToken).get(__WEBPACK_IMPORTED_MODULE_11__core_router_router__["a" /* default */].generate('api_slideDisplay_get_existant_slide'), {
      title: title
    }).then(function (response) {
      return response.data.existance;
    });
  },
  setCurrentSegment: function setCurrentSegment(state, current) {
    state.current = current;
  },
  updateSegmentThumbnail: function updateSegmentThumbnail(state, data) {
    state.selectedSegments = state.selectedSegments.map(function (segment) {
      segment.screens = segment.screens.map(function (screen) {
        if (screen.uid === data.uid) {
          screen.screenShot = data.thumbnail;
        }
        return screen;
      });
      return segment;
    });
  },
  updateSegmentListThumbnail: function updateSegmentListThumbnail(state, data) {
    state.segments = state.segments.map(function (segment) {
      segment.screens = segment.screens.map(function (screen) {
        if (screen.uid === data.uid) {
          screen.screenShot = data.thumbnail;
        }
        return screen;
      });
      return segment;
    });
  },
  updateSegmentTitleGlobally: function updateSegmentTitleGlobally(state, data) {
    state.segments = state.segments.map(function (segment) {
      if (segment.id === data.id) {
        segment.title = data.title;
      }
      return segment;
    });
  },
  setSegmentTransition: function setSegmentTransition(state, data) {
    var transitionIndex = state.selectedSegments.findIndex(function (segment) {
      return segment.screens.some(function (s) {
        return s.uid === data.uid;
      });
    });

    state.selectedSegments = state.selectedSegments.map(function (segment, index) {
      if (index === transitionIndex - 1) {
        segment = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, segment);
        segment.screens = segment.screens.map(function (s, i) {
          if (i === segment.screens.length - 1) {
            s.transition.out = data.name + '-out';
          }
          return s;
        });
      } else if (index === transitionIndex) {
        segment = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, segment);
        segment.screens = segment.screens.map(function (s, i) {
          if (i === 0) {
            s.transition.in = data.name + '-in';
          }
          return s;
        });
      }
      return segment;
    });
  },
  setIndexSegmentToAdd: function setIndexSegmentToAdd(state, index) {
    index += state.selectedSegments.findIndex(function (s) {
      return s.type === 'startGeneric';
    }) + 1;
    state.indexSegmentToAdd = index;
  },
  setLengthSegmentToAdd: function setLengthSegmentToAdd(state, index) {
    state.lengthSegmentToAdd = index;
  },
  setIndexSlideToAdd: function setIndexSlideToAdd(state, index) {
    index += state.selectedSegments.findIndex(function (s) {
      return s.type === 'startGeneric';
    }) + 1;
    state.indexSlideToAdd = index;
  },
  setIndexSegmentSlideToAdd: function setIndexSegmentSlideToAdd(state, index) {
    state.indexSegmentSlideToAdd = index;
  },
  appendSlideToSegment: function appendSlideToSegment(state, slide) {
    var props = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({
      uid: Math.floor(new Date().valueOf() * Math.random()),
      options: {
        duration: __WEBPACK_IMPORTED_MODULE_9__helpers_duration_handler__["a" /* totalSegmentDuration */]()
      },
      transition: {
        in: '',
        out: ''
      },
      js: slide.html.substring(slide.html.indexOf('<script>') + 8, slide.html.indexOf('</script>'))
    }, slide);
    if (slide.type === 'images') {
      props.type = slide.type;
    } else {
      props.type = 'Screen';
    }

    state.selectedSegments = state.selectedSegments.map(function (segment, i) {
      if (i === state.indexSlideToAdd) {
        segment.screens.push(props);
        segment.duration = segment.screens.reduce(function (sum, e) {
          return sum + +(e.options.duration || 0);
        }, 0);
      }
      return segment;
    });
    state.selectedSegments = __WEBPACK_IMPORTED_MODULE_9__helpers_duration_handler__["b" /* updateSegmentDuration */](state.selectedSegments);
    state.selectedSegments = __WEBPACK_IMPORTED_MODULE_10__helpers_transition_handler__["a" /* updateSegmentsTransition */](state.selectedSegments);
  },
  removeLastSlideFromSegmentById: function removeLastSlideFromSegmentById(state, id) {
    state.selectedSegments = state.selectedSegments.map(function (s, i) {
      if (i === state.indexSlideToAdd) {
        var index = s.screens.slice().reverse().findIndex(function (slide) {
          return slide.id === id;
        });
        var count = s.screens.length - 1;
        var finalIndex = index >= 0 ? count - index : index;
        s.screens = s.screens.filter(function (s, i) {
          return i !== finalIndex;
        });
      }
      return s;
    });
  },
  removeSlideFromSegmentByUid: function removeSlideFromSegmentByUid(state, _ref2) {
    var index = _ref2.index,
        uid = _ref2.uid;

    var hasGeneric = state.selectedSegments.filter(function (segment) {
      return segment.type.toLowerCase().includes('generic');
    });
    index = hasGeneric.length > 0 ? index + 1 : index;
    state.selectedSegments = state.selectedSegments.map(function (segment, i) {
      if (i === index) {
        segment.screens = segment.screens.filter(function (s) {
          return s.uid !== uid;
        });
        segment.duration = segment.screens.reduce(function (sum, e) {
          return sum + +(e.options.duration || 0);
        }, 0);
      }
      return segment;
    });

    state.selectedSegments = __WEBPACK_IMPORTED_MODULE_9__helpers_duration_handler__["b" /* updateSegmentDuration */](state.selectedSegments);
    state.selectedSegments = __WEBPACK_IMPORTED_MODULE_10__helpers_transition_handler__["a" /* updateSegmentsTransition */](state.selectedSegments);
  },
  updateSegmenScreentTitleGlobally: function updateSegmenScreentTitleGlobally(state, data) {
    state.segments.map(function (segment) {
      if (segment.screens.length !== 0) {
        var sc = segment.screens.filter(function (screen) {
          return screen.id === data.id;
        });

        if (sc.length !== 0) {
          sc[0].title = data.title;
        }
      }
    });
  },
  removeSegmentByUid: function removeSegmentByUid(state, uid) {
    state.selectedSegments = state.selectedSegments.filter(function (segment) {
      return segment.uid !== uid;
    });
    state.selectedSegments = __WEBPACK_IMPORTED_MODULE_9__helpers_duration_handler__["b" /* updateSegmentDuration */](state.selectedSegments);
  },
  duplicateSegment: function duplicateSegment(state, _ref3) {
    var segment = _ref3.segment,
        index = _ref3.index,
        type = _ref3.type;

    var props = {
      title: segment.title + '(copie)',
      uid: new Date().valueOf(),
      type: 'Segment'
    };

    if (type === 'onescreen') {
      props.screens = segment.screens.map(function (slide, i) {

        var props = {
          title: slide.title + '(copie)',
          uid: new Date().valueOf() + i,
          options: {
            duration: slide.options.duration,
            fullscreenVideo: slide.options.fullscreenVideo
          },
          transition: {
            in: slide.transition.in,
            out: slide.transition.out
          }
        };
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(slide)), props);
      });
    } else {
      props.screens = segment.screens.map(function (slide, i) {
        var props = {
          uid: new Date().valueOf() + i,
          options: {
            duration: slide.options.duration,
            fullscreenVideo: slide.options.fullscreenVideo
          },
          transition: {
            in: slide.transition.in,
            out: slide.transition.out
          }
        };
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(slide)), props);
      });
    }

    state.selectedSegments.splice(index + 1, 0, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(segment)), props));

    state.duplicatedSegment = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(segment)), props);
    state.selectedSegments = __WEBPACK_IMPORTED_MODULE_9__helpers_duration_handler__["b" /* updateSegmentDuration */](state.selectedSegments);
    state.selectedSegments = __WEBPACK_IMPORTED_MODULE_10__helpers_transition_handler__["a" /* updateSegmentsTransition */](state.selectedSegments);
  },
  setScreensTosubmitSegment: function setScreensTosubmitSegment(state, data) {
    state.segments.map(function (screen) {
      if (screen.id === data.id) {
        screen.template = data.template;
        screen.type = data.type;
        screen.options.transition = data.transition;
        screen.screenShot = data.screenShot;
      }
      return screen;
    });
  },
  duplicateBiblioSegment: function duplicateBiblioSegment(state, _ref4) {
    var segment = _ref4.segment,
        index = _ref4.index;

    var nb = 1;
    var indexOf = segment.title.search(/\(copie/i);
    var newTitel = '';
    if (indexOf !== -1) {
      var text = segment.title.substring(segment.title.length, indexOf);
      var originTiel = segment.title.substring(indexOf, 0);

      text = text.match(/\d/g);
      if (text && text !== '') nb += parseInt(text.join(''));

      newTitel = originTiel + '(copie' + nb + ')';
    }
    var props = {
      title: newTitel ? newTitel : segment.title + '(copie)',
      uid: new Date().valueOf(),
      type: 'DefaultSegment'
    };

    props.screens = segment.screens.map(function (slide, i) {
      var props = {
        uid: new Date().valueOf() + i,
        options: {
          duration: slide.options.duration,
          fullscreenVideo: slide.options.fullscreenVideo ? slide.options.fullscreenVideo : false
        }
        /* transition: {
          in: slide.transition.in ? slide.transition.in : '',
          out: slide.transition.out ? slide.transition.out : '',
        },*/
      };
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(slide)), props);
    });
    state.segments.splice(index, 0, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(segment)), props));
  },
  duplicateSlideInsideSegment: function duplicateSlideInsideSegment(state, _ref5) {
    var slide = _ref5.slide,
        segmentIndex = _ref5.segmentIndex,
        slideIndex = _ref5.slideIndex;

    state.selectedSegments = state.selectedSegments.map(function (segment, index) {
      if (segmentIndex === index) {
        var props = {
          title: slide.title + '(copie)',
          uid: new Date().valueOf(),
          options: {
            duration: slide.options.duration,
            fullscreenVideo: slide.options.fullscreenVideo
          },
          transition: {
            in: slide.transition.in,
            out: slide.transition.out
          }
        };
        segment.screens.splice(slideIndex + 1, 0, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(slide)), props));
        state.duplicatedSlideInSegment = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(slide)), props);
        segment.duration = segment.screens.reduce(function (sum, e) {
          return sum + +(e.options.duration || 0);
        }, 0);
      }
      return segment;
    });
    state.selectedSegments = __WEBPACK_IMPORTED_MODULE_9__helpers_duration_handler__["b" /* updateSegmentDuration */](state.selectedSegments);
    state.selectedSegments = __WEBPACK_IMPORTED_MODULE_10__helpers_transition_handler__["a" /* updateSegmentsTransition */](state.selectedSegments);
  },
  updateSlideInsideSegment: function updateSlideInsideSegment(state, data) {
    state.selectedSegments = state.selectedSegments.map(function (segment) {
      segment.screens = segment.screens.map(function (s) {
        if (s.uid === data.uid) {
          s.components = data.components || '';
          s.html = data.html || '';
          s.css = data.css || '';
          s.styles = data.styles || '';
          s.js = data.js || '';
        }
        return s;
      });
      return segment;
    });
  },
  updateSegmentTitle: function updateSegmentTitle(state, data) {
    state.selectedSegments = state.selectedSegments.map(function (segment) {
      if (segment.uid === data.uid) {
        segment.title = data.title;
      }
      segment.screens = segment.screens.map(function (s) {
        if (s.uid === data.uid) {
          s.title = data.title;
        }
        return s;
      });
      return segment;
    });
  },
  updateFirstScreenSegmentTitle: function updateFirstScreenSegmentTitle(state, data) {
    state.selectedSegments = state.selectedSegments.map(function (segment) {
      if (segment.uid === data.uid) {

        segment.title = data.title;
        segment.screens = segment.screens.map(function (s) {
          s.title = data.title;
          return s;
        });
      }

      return segment;
    });
  },
  updateFullScreenVideoWithoutExtend: function updateFullScreenVideoWithoutExtend(state, data) {
    state.selectedSegments = state.selectedSegments.map(function (segment) {
      if (segment.uid === data.uid) {
        segment.withoutExtend = data.without;
      }
      return segment;
    });
  },
  updateSegmentDuration: function updateSegmentDuration(state, _ref6) {
    var uid = _ref6.uid,
        duration = _ref6.duration,
        _ref6$fullscreenVideo = _ref6.fullscreenVideo,
        fullscreenVideo = _ref6$fullscreenVideo === undefined ? false : _ref6$fullscreenVideo;

    state.selectedSegments = state.selectedSegments.map(function (s) {
      var segment = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, s);
      if (segment.uid === uid) {
        segment.duration = +duration;
        var generic = segment.screens.find(function (s) {
          return s.type.toLowerCase().includes('generic');
        });
        var length = segment.screens.length - (generic ? 1 : 0);

        if (generic && generic.options.duration) {
          if (!generic.originalDuration) {
            generic.originalDuration = generic.options.duration;
          }
          generic.options.duration = Math.min(generic.originalDuration, +duration);
          duration -= generic.options.duration;
        }

        segment.screens = segment.screens.filter(function (s) {
          return !s.type.toLowerCase().includes('generic');
        }).map(function (s, i) {
          s.options.duration = Math.floor(+duration / length);
          if (i === length - 1) {
            s.options.duration += +duration % length;
          }
          return s;
        });
        if (generic) {
          segment.screens.unshift(generic);
        }
      } else {
        segment.screens = segment.screens.map(function (s, i) {
          if (s.uid === uid) {
            s.options.duration = +duration;
            s.options.fullscreenVideo = fullscreenVideo;
          }
          return s;
        });
      }

      if (segment.screens.some(function (s) {
        return s.uid === uid;
      })) {
        segment.duration = segment.screens.reduce(function (sum, e) {
          return sum + +(e.options.duration || 0);
        }, 0);
      }
      return segment;
    });
    __WEBPACK_IMPORTED_MODULE_9__helpers_duration_handler__["b" /* updateSegmentDuration */](state.selectedSegments);

    //durationHelper.updateSegmentDuration(state.selectedSegments);
  },
  toggleExtendSegment: function toggleExtendSegment(state, data) {
    state.selectedSegments = state.selectedSegments.map(function (segment) {
      if (segment.uid === data.uid) {
        segment.isExtended = !segment.isExtended;
      }
      return segment;
    });
  },
  setNbrCall: function setNbrCall(state) {
    state.nbrCall = state.nbrCall + 1;
  },
  resetNbCall: function resetNbCall(state) {
    state.nbrCall = 1;
  },
  setTypeGeneric: function setTypeGeneric(state, src) {
    state.typeGeneric = src;
  },
  reorderSegments: function reorderSegments(state, _ref7) {
    var oldIndex = _ref7.oldIndex,
        newIndex = _ref7.newIndex;

    var i = state.selectedSegments.findIndex(function (s) {
      return s.type === 'startGeneric';
    }) + 1;

    oldIndex += i;
    newIndex += i;

    var movedItem = state.selectedSegments.find(function (item, index) {
      return index === oldIndex;
    });
    var remainingItems = state.selectedSegments.filter(function (item, index) {
      return index !== oldIndex;
    });

    state.selectedSegments = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(remainingItems.slice(0, newIndex)), [movedItem], __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(remainingItems.slice(newIndex)));
    state.selectedSegments = __WEBPACK_IMPORTED_MODULE_9__helpers_duration_handler__["b" /* updateSegmentDuration */](state.selectedSegments);
    state.selectedSegments = __WEBPACK_IMPORTED_MODULE_10__helpers_transition_handler__["a" /* updateSegmentsTransition */](state.selectedSegments);
  },
  reorderSlidesInsideSegment: function reorderSlidesInsideSegment(state, _ref8) {
    var event = _ref8.event,
        index = _ref8.index;
    var oldIndex = event.oldIndex,
        newIndex = event.newIndex;


    var segmentIndex = index + state.selectedSegments.findIndex(function (s) {
      return s.type === 'startGeneric';
    }) + 1;
    var i = state.selectedSegments[segmentIndex].screens.findIndex(function (s) {
      return s.type === 'startGeneric';
    }) + 1;

    oldIndex += i;
    newIndex += i;

    state.selectedSegments = state.selectedSegments.map(function (segment, i) {
      if (i === segmentIndex) {
        var movedItem = segment.screens.find(function (item, index) {
          return index === oldIndex;
        });
        var remainingItems = segment.screens.filter(function (item, index) {
          return index !== oldIndex;
        });

        segment.screens = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(remainingItems.slice(0, newIndex)), [movedItem], __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(remainingItems.slice(newIndex)));
      }
      return segment;
    });
  },
  appendCreatedSegment: function appendCreatedSegment(state, data) {
    var date = new Date(data.segment.duration);
    var duration = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_number_is_integer___default()(data.segment.duration) ? data.segment.duration : Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()) / 1000;
    var s = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, data.segment, {
      duration: duration
    });
    s.screens = s.screens.map(function (s) {
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({
        transition: s.options.transition && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(s.options.transition).length > 0 ? s.options.transition : { in: '', out: '' },
        options: {
          duration: __WEBPACK_IMPORTED_MODULE_9__helpers_duration_handler__["a" /* totalSegmentDuration */]()
        }
      }, s);
    });

    state.segments.splice(data.index, 0, s);
  },
  removeBlankSlideToSegment: function removeBlankSlideToSegment(state, uid) {
    state.selectedSegments = state.selectedSegments.map(function (segment, i) {
      if (segment.uid === uid) {
        segment.screens = segment.screens.filter(function (s) {
          return !s.type.toLowerCase().includes('blank');
        });
      }
      return segment;
    });
  },
  appendBlankSlideToSegment: function appendBlankSlideToSegment(state, uid) {
    var props = {
      uid: Math.floor(new Date().valueOf() * Math.random()),
      transition: {
        in: '',
        out: ''
      },
      js: '',
      options: {},
      assets: '',
      components: '',
      css: 'body{background-color:rgb(0, 0, 0);}',
      html: '',
      styles: '',
      title: 'blank',
      type: 'BlankSlide',
      screenShot: 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/2wBDAP//////////////////////////////////////////////////////////////////////////////////////2wBDAf//////////////////////////////////////////////////////////////////////////////////////wAARCAAJABADASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AJgA/9k=',
      id: 0
    };
    state.selectedSegments = state.selectedSegments.map(function (segment, i) {
      if (segment.uid === uid) {
        segment.screens = segment.screens.filter(function (s) {
          return !s.type.toLowerCase().includes('blank');
        });
        // const fullscreenVideo = segment.screens.find(s => s.fullscreenVideo);
        var fullScreenIndex = segment.screens.findIndex(function (s) {
          return s.fullscreenVideo;
        }) + 1;
        if (fullScreenIndex > 0) {
          segment.duration = segment.screens.reduce(function (sum, e) {
            return sum + +(e.options.duration || 0);
          }, 0);

          props.options.duration = 30 - segment.duration % 30;

          if (props.options.duration % 30 > 0) {
            segment.screens = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(segment.screens.slice(0, fullScreenIndex)), [props], __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(segment.screens.slice(fullScreenIndex)));
            segment.duration += props.options.duration;
            segment.originalDuration = segment.duration;
          }
        }
      }
      return segment;
    });
    //state.selectedSegments = durationHelper.updateSegmentDuration(state.selectedSegments);
    //state.selectedSegments = transitionHelper.updateSegmentsTransition(state.selectedSegments);
  },
  cropVideoFromSegment: function cropVideoFromSegment(state, uid) {
    state.selectedSegments = state.selectedSegments.map(function (segment, i) {
      if (segment.uid === uid) {
        segment.screens = segment.screens.filter(function (s) {
          return !s.type.toLowerCase().includes('blank');
        });

        segment.duration = segment.screens.reduce(function (sum, e) {
          return sum + +(e.options.duration || 0);
        }, 0);

        segment.screens = segment.screens.map(function (sc) {
          if (sc.fullscreenVideo) {
            sc.options.duration -= segment.duration % 30;
          }
          return sc;
        });
        segment.duration -= segment.duration % 30;
      }
      return segment;
    });
    state.selectedSegments = __WEBPACK_IMPORTED_MODULE_9__helpers_duration_handler__["b" /* updateSegmentDuration */](state.selectedSegments);
    state.selectedSegments = __WEBPACK_IMPORTED_MODULE_10__helpers_transition_handler__["a" /* updateSegmentsTransition */](state.selectedSegments);
  },
  FixdurationVideoFromSegment: function FixdurationVideoFromSegment(state, data) {
    state.selectedSegments = state.selectedSegments.map(function (segment, i) {
      if (segment.uid === data.uid) {
        segment.screens = segment.screens.filter(function (s) {
          return !s.type.toLowerCase().includes('blank');
        });
        segment.screens = segment.screens.map(function (sc) {
          if (sc.options.fullscreenVideo) {
            sc.withoutExtend = data.without;
          }
          return sc;
        });

        segment.originalDuration = data.duration;
        segment.fullscreenVideo = true;
      }
      return segment;
    });
    //state.selectedSegments = durationHelper.updateSegmentDuration(state.selectedSegments);
    state.selectedSegments = __WEBPACK_IMPORTED_MODULE_10__helpers_transition_handler__["a" /* updateSegmentsTransition */](state.selectedSegments);
  }
};

var actions = {
  appendImageToSegment: function appendImageToSegment(_ref9, media) {
    var _this = this;

    var state = _ref9.state,
        commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var makeId, html, domc, defaultType, defaultModel, components, fullscreenVideo, slide;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              makeId = function makeId() {
                var text = 'i';
                var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                for (var i = 0; i < 5; i++) {
                  text += possible.charAt(Math.floor(Math.random() * possible.length));
                }return text;
              };

              html = '<div data-gjs-type="image_media" id="' + makeId() + ('" width="100%" height="100%"><image class="gjs-no-pointer" src="' + media.selected.src + '" id="image-media-') + makeId() + '" width="100%" height="100%" scrolling="no" allow="encrypted-media" style="border: none; overflow: hidden;"></image></div>';
              domc = grapesjsEMP.editors[0].DomComponents;
              defaultType = domc.getType('default');
              defaultModel = defaultType.model;
              // const defaultView = defaultType.view;

              components = {
                'custom-name': 'image',
                tagName: 'div',
                src: media.selected.src,
                width: '100%',
                height: '100%',
                resizable: false,
                selected: true,
                attributes: {
                  id: +makeId(),
                  'data-class': 'image-media'
                },
                classes: [{
                  active: true,
                  label: makeId(),
                  name: makeId(),
                  private: false,
                  protected: false,
                  type: 1
                }, {
                  active: true,
                  label: 'gjs-comp-selected',
                  name: 'gjs-comp-selected',
                  private: false,
                  protected: false,
                  type: 1
                }],
                type: '',
                draggable: true,
                droppable: false,
                editable: false,
                highlightable: true,
                hoverable: true,
                icon: '',
                layerable: true,
                name: '',
                propagate: '',
                removable: true,
                script: '',
                selectable: true,
                config: {
                  translate: __WEBPACK_IMPORTED_MODULE_15__i18n__["a" /* default */].t('display-image-plugin')
                },
                'data-class': 'image-media',
                badgable: true,
                components: [],
                content: '',
                copyable: true,
                state: '',
                status: ''
              };
              fullscreenVideo = false;
              slide = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({
                html: html,
                type: media.type,
                components: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(components),
                css: '',
                js: '',
                options: { fullscreenVideo: fullscreenVideo },
                screenShot: media.selected.src,
                transition: { in: '', out: '' }
              }, media.selected);

              commit('appendSlideToSegment', slide);

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getTemplateById: function getTemplateById(_ref10, id) {
    var _this2 = this;

    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var url, _ref11, data, screen, totalDuration, templateToEdit;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              url = __WEBPACK_IMPORTED_MODULE_11__core_router_router__["a" /* default */].generate('api_templateDisplay_get_template', {
                id: id,
                client: localStorage.getItem('client')
              });
              _context2.next = 3;
              return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__core_http_http_token__["a" /* HTTP */])(window.ApiToken).get(url).then(function (response) {
                  resolve(response);
                });
              });

            case 3:
              _ref11 = _context2.sent;
              data = _ref11.data;


              data.template.segments.forEach(function (segment) {
                segment.isUpdate = true;
                commit('selectSegment', segment);
              });

              commit('setCurrentSegment', state.selectedSegments.filter(function (s) {
                return !s.type.toLowerCase().includes('generic');
              })[0]);

              screen = state.selectedSegments.filter(function (s) {
                return !s.type.toLowerCase().includes('generic');
              })[0].screens.filter(function (s) {
                return !s.type.toLowerCase().includes('generic');
              })[0];
              totalDuration = 0;

              data.template.segments.forEach(function (s) {
                var date = new Date(s.duration);

                var duration = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_number_is_integer___default()(s.duration) ? s.duration : Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()) / 1000;
                totalDuration += duration;
              });

              templateToEdit = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, data.template, {
                duration: totalDuration
              });

              dispatch('slides/setTemplate', templateToEdit, { root: true });
              dispatch('slides/setCurrentSlide', screen, { root: true });

            case 13:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getAuteurs: function getAuteurs(_ref12) {
    var _this3 = this;

    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var url, _ref13, data, Auteurs;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit('resetAuteurs');

              url = __WEBPACK_IMPORTED_MODULE_11__core_router_router__["a" /* default */].generate('api_media_get_contributors');
              _context3.next = 4;
              return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__core_http_http_token__["a" /* HTTP */])(window.ApiToken).get(url).then(function (response) {
                  resolve(response);
                });
              });

            case 4:
              _ref13 = _context3.sent;
              data = _ref13.data;
              Auteurs = data.contributors;

              Auteurs.map(function (Auteur) {
                commit('pushAuteurs', Auteur);
              });

            case 8:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getSegment: function getSegment(_ref14, id) {
    var _this4 = this;

    var commit = _ref14.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var url, _ref15, data;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              url = __WEBPACK_IMPORTED_MODULE_11__core_router_router__["a" /* default */].generate('api_segmentDisplay_get_one_segments', {
                id: id,
                client: localStorage.getItem('client')
              });
              _context4.next = 3;
              return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__core_http_http_token__["a" /* HTTP */])(window.ApiToken).get(url).then(function (response) {
                  resolve(response);
                });
              });

            case 3:
              _ref15 = _context4.sent;
              data = _ref15.data;


              commit('setCurrentSegment', data);

            case 6:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  setThemes: function setThemes(_ref16) {
    var _this5 = this;

    var commit = _ref16.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var url, _ref17, data, themes;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit('resetThemes');
              url = __WEBPACK_IMPORTED_MODULE_11__core_router_router__["a" /* default */].generate('api_parameters_get_themes_children_per_canal', {
                type: 'segment'
              });
              _context5.next = 4;
              return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__core_http_http_token__["a" /* HTTP */])(window.ApiToken).get(url).then(function (response) {
                  resolve(response);
                });
              });

            case 4:
              _ref17 = _context5.sent;
              data = _ref17.data;
              themes = data.subThemesList;

              if (themes && themes.length > 0) {
                themes.map(function (theme) {
                  commit('pushThemes', theme);
                });
              }

            case 8:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  deleteOneSegmentById: function deleteOneSegmentById(_ref18, item) {
    var _this6 = this;

    var commit = _ref18.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__core_http_http_token__["a" /* HTTP */])(window.ApiToken).delete(__WEBPACK_IMPORTED_MODULE_11__core_router_router__["a" /* default */].generate('api_segmentDisplay_delete_one', { id: item.id })).then(function (response) {});

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  duplicateSegmentInDataBase: function duplicateSegmentInDataBase(_ref19, data) {
    var _this7 = this;

    var state = _ref19.state,
        commit = _ref19.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__core_http_http_token__["a" /* HTTP */])(window.ApiToken).post(__WEBPACK_IMPORTED_MODULE_11__core_router_router__["a" /* default */].generate('api_segmentDisplay_post_duplicate_segment', { id: data.id }), {
                title: data.title,
                author: data.author,
                keyWords: data.keyWords,
                description: data.description,
                themes: data.themes
              }).then(function (response) {});

            case 1:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  paginatesegment: function paginatesegment(_ref20, type) {
    var _this8 = this;

    var commit = _ref20.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var DefParam, nbPage, query, url, _ref21, data;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (state.endReached[type]) {
                _context8.next = 23;
                break;
              }

              DefParam = '{"duration":20,"transition":{in: "", out: ""}';

              self = _this8;
              commit('setLoading', true);
              nbPage = state.nbPerPage;
              query = {
                page: state.currentPage[type],
                nbParPage: nbPage,
                type: type,
                client: localStorage.getItem('client')
              };

              if (state.title) {
                query.title = state.title;
              }
              if (state.theme) {
                query.theme = state.theme;
              }
              if (state.author) {
                query.author = state.author;
              }
              url = __WEBPACK_IMPORTED_MODULE_11__core_router_router__["a" /* default */].generate('api_segmentDisplay_get_list_segments', query);

              commit('incrementPage', type);
              _context8.next = 13;
              return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__core_http_http_token__["a" /* HTTP */])(window.ApiToken).get(url).then(function (response) {
                  resolve(response);
                  if (!state.fromRouteAdd) eventHub.$emit('stopProgress');
                });
              });

            case 13:
              _ref21 = _context8.sent;
              data = _ref21.data;


              // if  duration of segment Null  Default 20s
              data.data.segments.map(function (onesegment) {
                if (onesegment.duration == null) {
                  onesegment.duration = '1970-01-01T00:00:20+0100';
                }
              });

              data.data.segments.flatMap(function (_ref22) {
                var screens = _ref22.screens;

                return screens.map(function (screen) {
                  screen.options = JSON.parse(screen.options);

                  //if screen.options null Default value
                  if (screen.options == null) {
                    screen.options = JSON.parse(DefParam);
                  }
                  if (typeof screen.options === "string") {
                    screen.options = JSON.parse(screen.options);
                  }
                  if (screen.options.duration == null) {
                    screen.options.duration = 20;
                  }
                  if (screen.options.transition == null) {
                    screen.options.transition = { in: '', out: '' };
                  }
                });
              });

              commit('pushSegments', data.data.segments);
              commit('nbSegments', data.data.nombre_total);
              commit('setLoading', false);

              if (data.data.segments.length < state.nbPerPage) {
                commit('setEndReached', { type: type, endReached: true });
              } else {
                commit('setEndReached', { type: type, endReached: false });
              }

              if (data.data.segments.length < 1) eventHub.$emit('notFound', true);else eventHub.$emit('notFound', false);

              commit('setLoading', false);

            case 23:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  updateTitleSegment: function updateTitleSegment(_ref23, data) {
    var _this9 = this;

    var state = _ref23.state,
        commit = _ref23.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__core_http_http_token__["a" /* HTTP */])(window.ApiToken).post(__WEBPACK_IMPORTED_MODULE_11__core_router_router__["a" /* default */].generate('api_segmentDisplay_post_edit_title_segment', { id: data.id }), {
                title: data.title
              }).then(function (response) {
                commit('updateSegmentTitleGlobally', data);
              });

            case 1:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  updateMetadataSegment: function updateMetadataSegment(_ref24, data) {
    var _this10 = this;

    var state = _ref24.state,
        commit = _ref24.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__core_http_http_token__["a" /* HTTP */])(window.ApiToken).post(__WEBPACK_IMPORTED_MODULE_11__core_router_router__["a" /* default */].generate('api_segmentDisplay_post_edit_title_segment', { id: data.id }), {
                title: data.title,
                author: data.author,
                keyWords: data.keyWords,
                description: data.description,
                themes: data.themes
              }).then(function (response) {
                commit('updateDataCurrentSegment', data);

                commit('updateSegmentTitleGlobally', data);
              });

            case 1:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  updateTitleScreenInSegment: function updateTitleScreenInSegment(_ref25, data) {
    var _this11 = this;

    var state = _ref25.state,
        commit = _ref25.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__core_http_http_token__["a" /* HTTP */])(window.ApiToken).post(__WEBPACK_IMPORTED_MODULE_11__core_router_router__["a" /* default */].generate('api_screenDisplay_post_edit_screen', { id: data.id }), {
                title: data.title
              }).then(function (response) {
                commit('updateSegmenScreentTitleGlobally', data);
              });

            case 1:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },

  setScreensTosubmitSegment: function setScreensTosubmitSegment(_ref26, data) {
    var state = _ref26.state,
        commit = _ref26.commit;
    return commit('setScreensTosubmitSegment', data);
  },
  setEndReached: function setEndReached(_ref27, data) {
    var state = _ref27.state,
        commit = _ref27.commit;
    return commit('setEndReached', data);
  },

  deleteSegmentByIdStore: function deleteSegmentByIdStore(_ref28, item) {
    var state = _ref28.state,
        commit = _ref28.commit;
    return commit('deleteSegmentByIdStore', item);
  },
  updateFullScreenVideoWithoutExtend: function updateFullScreenVideoWithoutExtend(_ref29, without) {
    var state = _ref29.state,
        commit = _ref29.commit;
    return commit('updateFullScreenVideoWithoutExtend', without);
  },
  updateSegmentTitleInStore: function updateSegmentTitleInStore(_ref30, Segment) {
    var state = _ref30.state,
        commit = _ref30.commit;
    return commit('updateSegmentTitleInStore', Segment);
  },
  setSegments: function setSegments(_ref31, segments) {
    var state = _ref31.state,
        commit = _ref31.commit;
    return commit('setSegments', segments);
  },
  selectSegment: function selectSegment(_ref32, segment) {
    var state = _ref32.state,
        commit = _ref32.commit;
    return commit('selectSegment', segment);
  },
  setCurrentSegment: function setCurrentSegment(_ref33, segment) {
    var state = _ref33.state,
        commit = _ref33.commit;
    return commit('setCurrentSegment', segment);
  },
  //setSegmentDuration: ({ state, commit }, segment) => commit('setSegmentDuration', segment),
  updateSegment: function updateSegment(_ref34, segment) {
    var state = _ref34.state,
        commit = _ref34.commit;
    return commit('updateSegment', segment);
  },
  updateSegmentThumbnail: function updateSegmentThumbnail(_ref35, segment) {
    var state = _ref35.state,
        commit = _ref35.commit;
    return commit('updateSegmentThumbnail', segment);
  },
  updateSegmentListThumbnail: function updateSegmentListThumbnail(_ref36, segment) {
    var state = _ref36.state,
        commit = _ref36.commit;
    return commit('updateSegmentListThumbnail', segment);
  },
  removeSegmentByUid: function removeSegmentByUid(_ref37, uid) {
    var state = _ref37.state,
        commit = _ref37.commit;
    return commit('removeSegmentByUid', uid);
  },
  removeLastSegmentById: function removeLastSegmentById(_ref38, id) {
    var state = _ref38.state,
        commit = _ref38.commit;
    return commit('removeLastSegmentById', id);
  },
  pushSegments: function pushSegments(_ref39, segment) {
    var state = _ref39.state,
        commit = _ref39.commit;
    return commit('pushSegments', segment);
  },
  cancelDelete: function cancelDelete(_ref40, data) {
    var state = _ref40.state,
        commit = _ref40.commit;
    return commit('cancelDelete', data);
  },
  setTitle: function setTitle(_ref41, title) {
    var state = _ref41.state,
        commit = _ref41.commit;
    return commit('setTitle', title);
  },
  setThemeid: function setThemeid(_ref42, id) {
    var state = _ref42.state,
        commit = _ref42.commit;
    return commit('setThemeid', id);
  },
  setAuthorid: function setAuthorid(_ref43, id) {
    var state = _ref43.state,
        commit = _ref43.commit;
    return commit('setAuthorid', id);
  },
  setCurrentSegmentDuration: function setCurrentSegmentDuration(_ref44, duration) {
    var state = _ref44.state,
        commit = _ref44.commit;
    return commit('setCurrentSegmentDuration', duration);
  },
  resetPage: function resetPage(_ref45, types) {
    var state = _ref45.state,
        commit = _ref45.commit;

    commit('resetPage', types);
  },

  setSegmentsGeneric: function setSegmentsGeneric(_ref46, slide) {
    var state = _ref46.state,
        commit = _ref46.commit;
    return commit('setSegmentsGeneric', slide);
  },
  setSegmentsGenericFinEmpty: function setSegmentsGenericFinEmpty(_ref47, slide) {
    var state = _ref47.state,
        commit = _ref47.commit;
    return commit('setSegmentsGenericFinEmpty', slide);
  },
  setVideoIntro: function setVideoIntro(_ref48, slide) {
    var state = _ref48.state,
        commit = _ref48.commit;
    return commit('setVideoIntro', slide);
  },
  setSegmentTransition: function setSegmentTransition(_ref49, slide) {
    var state = _ref49.state,
        commit = _ref49.commit;
    return commit('setSegmentTransition', slide);
  },
  setIndexSegmentToAdd: function setIndexSegmentToAdd(_ref50, index) {
    var state = _ref50.state,
        commit = _ref50.commit;
    return commit('setIndexSegmentToAdd', index);
  },
  setLengthSegmentToAdd: function setLengthSegmentToAdd(_ref51, index) {
    var state = _ref51.state,
        commit = _ref51.commit;
    return commit('setLengthSegmentToAdd', index);
  },
  setIndexSlideToAdd: function setIndexSlideToAdd(_ref52, index) {
    var state = _ref52.state,
        commit = _ref52.commit;
    return commit('setIndexSlideToAdd', index);
  },
  setIndexSegmentSlideToAdd: function setIndexSegmentSlideToAdd(_ref53, index) {
    var state = _ref53.state,
        commit = _ref53.commit;
    return commit('setIndexSegmentSlideToAdd', index);
  },
  appendSlideToSegment: function appendSlideToSegment(_ref54, slide) {
    var state = _ref54.state,
        commit = _ref54.commit;
    return commit('appendSlideToSegment', slide);
  },
  removeLastSlideFromSegmentById: function removeLastSlideFromSegmentById(_ref55, slide) {
    var state = _ref55.state,
        commit = _ref55.commit;
    return commit('removeLastSlideFromSegmentById', slide);
  },
  removeSlideFromSegmentByUid: function removeSlideFromSegmentByUid(_ref56, data) {
    var state = _ref56.state,
        commit = _ref56.commit;
    return commit('removeSlideFromSegmentByUid', data);
  },
  duplicateSegment: function duplicateSegment(_ref57, data) {
    var state = _ref57.state,
        commit = _ref57.commit;
    return commit('duplicateSegment', data);
  },
  duplicateBiblioSegment: function duplicateBiblioSegment(_ref58, data) {
    var state = _ref58.state,
        commit = _ref58.commit;
    return commit('duplicateBiblioSegment', data);
  },
  duplicateSlideInsideSegment: function duplicateSlideInsideSegment(_ref59, data) {
    var state = _ref59.state,
        commit = _ref59.commit;
    return commit('duplicateSlideInsideSegment', data);
  },
  updateSlideInsideSegment: function updateSlideInsideSegment(_ref60, data) {
    var state = _ref60.state,
        commit = _ref60.commit;
    return commit('updateSlideInsideSegment', data);
  },
  updateSegmentTitle: function updateSegmentTitle(_ref61, data) {
    var state = _ref61.state,
        commit = _ref61.commit;
    return commit('updateSegmentTitle', data);
  },
  updateFirstScreenSegmentTitle: function updateFirstScreenSegmentTitle(_ref62, data) {
    var state = _ref62.state,
        commit = _ref62.commit;
    return commit('updateFirstScreenSegmentTitle', data);
  },
  resetNbCall: function resetNbCall(_ref63) {
    var state = _ref63.state,
        commit = _ref63.commit;
    return commit('resetNbCall');
  },
  updateSegmentDuration: function updateSegmentDuration(_ref64, data) {
    var state = _ref64.state,
        commit = _ref64.commit;
    return commit('updateSegmentDuration', data);
  },
  toggleExtendSegment: function toggleExtendSegment(_ref65, data) {
    var state = _ref65.state,
        commit = _ref65.commit;
    return commit('toggleExtendSegment', data);
  },
  setNbrCall: function setNbrCall(_ref66) {
    var state = _ref66.state,
        commit = _ref66.commit;
    return commit('setNbrCall');
  },
  setTypeGeneric: function setTypeGeneric(_ref67, src) {
    var state = _ref67.state,
        commit = _ref67.commit;
    return commit('setTypeGeneric', src);
  },
  appendCreatedSegment: function appendCreatedSegment(_ref68, segment) {
    var state = _ref68.state,
        commit = _ref68.commit;
    return commit('appendCreatedSegment', segment);
  },
  appendBlankSlideToSegment: function appendBlankSlideToSegment(_ref69, uid) {
    var state = _ref69.state,
        commit = _ref69.commit;
    return commit('appendBlankSlideToSegment', uid);
  },
  removeBlankSlideToSegment: function removeBlankSlideToSegment(_ref70, uid) {
    var state = _ref70.state,
        commit = _ref70.commit;
    return commit('removeBlankSlideToSegment', uid);
  },
  cropVideoFromSegment: function cropVideoFromSegment(_ref71, uid) {
    var state = _ref71.state,
        commit = _ref71.commit;
    return commit('cropVideoFromSegment', uid);
  },
  FixdurationVideoFromSegment: function FixdurationVideoFromSegment(_ref72, data) {
    var state = _ref72.state,
        commit = _ref72.commit;
    return commit('FixdurationVideoFromSegment', data);
  },
  reorderSegments: function reorderSegments(_ref73, event) {
    var state = _ref73.state,
        commit = _ref73.commit;
    return commit('reorderSegments', event);
  },
  reorderSlidesInsideSegment: function reorderSlidesInsideSegment(_ref74, data) {
    var state = _ref74.state,
        commit = _ref74.commit;
    return commit('reorderSlidesInsideSegment', data);
  },
  setCurrentSegmentTitle: function setCurrentSegmentTitle(_ref75, title) {
    var state = _ref75.state,
        commit = _ref75.commit;
    return commit('setCurrentSegmentTitle', title);
  },
  setfromRouteAdd: function setfromRouteAdd(_ref76, add) {
    var state = _ref76.state,
        commit = _ref76.commit;
    return commit('setfromRouteAdd', add);
  },
  setfromRouteBiblio: function setfromRouteBiblio(_ref77, add) {
    var state = _ref77.state,
        commit = _ref77.commit;
    return commit('setfromRouteBiblio', add);
  },
  pushModuleSelected: function pushModuleSelected(_ref78, data) {
    var state = _ref78.state,
        commit = _ref78.commit;
    return commit('pushModuleSelected', data);
  },
  restModuleSelected: function restModuleSelected(_ref79) {
    var state = _ref79.state,
        commit = _ref79.commit;
    return commit('restModuleSelected');
  },
  removeFromModuleSelected: function removeFromModuleSelected(_ref80, id) {
    var state = _ref80.state,
        commit = _ref80.commit;
    return commit('removeFromModuleSelected', id);
  },

  selectMedias: function selectMedias(_ref81, media) {
    var _this12 = this;

    var state = _ref81.state,
        commit = _ref81.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
      var makeId, html, domc, defaultType, defaultModel, components, extension, fullscreenVideo, slide, segment;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              makeId = function makeId() {
                var text = 'i';
                var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                for (var i = 0; i < 5; i++) {
                  text += possible.charAt(Math.floor(Math.random() * possible.length));
                }return text;
              };

              html = '<div data-gjs-type="image_media" id="' + makeId() + ('" width="100%" height="100%"><image class="gjs-no-pointer" src="' + media.selected.src + '" id="image-media-') + makeId() + '" width="100%" height="100%" scrolling="no" allow="encrypted-media" style="border: none; overflow: hidden;"></image></div>';
              domc = grapesjsEMP.editors[0].DomComponents;
              defaultType = domc.getType('default');
              defaultModel = defaultType.model;
              // const defaultView = defaultType.view;

              components = {
                'custom-name': 'image',
                tagName: 'div',
                src: media.selected.src,
                width: '100%',
                height: '100%',
                resizable: false,
                selected: true,
                attributes: {
                  id: +makeId(),
                  'data-class': 'image-media'
                },
                classes: [{
                  active: true,
                  label: makeId(),
                  name: makeId(),
                  private: false,
                  protected: false,
                  type: 1
                }, {
                  active: true,
                  label: 'gjs-comp-selected',
                  name: 'gjs-comp-selected',
                  private: false,
                  protected: false,
                  type: 1
                }],
                type: '',
                draggable: true,
                droppable: false,
                editable: false,
                highlightable: true,
                hoverable: true,
                icon: '',
                layerable: true,
                name: '',
                propagate: '',
                removable: true,
                script: '',
                selectable: true,
                config: {
                  translate: __WEBPACK_IMPORTED_MODULE_15__i18n__["a" /* default */].t('display-image-plugin')
                },
                'data-class': 'image-media',
                badgable: true,
                components: [],
                content: '',
                copyable: true,
                state: '',
                status: ''
              };

              if (media.type === 'videos') {
                html = '<iframe data-gjs-type="video_mp4" class="gjs-no-pointer" src="' + media.selected.src + '?a=1&sc=0" id="player-mp4-' + makeId() + '" width="100%" height="100%" scrolling="no" allow="encrypted-media" style="border: none; overflow: hidden;"></iframe>';
                extension = media.selected.src.split('.').pop();

                if (extension.toLowerCase().indexOf('mp4') > -1) {
                  html = '<video  data-gjs-type="video_mp4" class="gjs-no-pointer" src="' + media.selected.src + '" id="player-mp4-' + makeId() + '" width="100%" height="100%"  scrolling="no" allow="encrypted-media" style="border: none; overflow: hidden;"></video>';
                }
                components.tagName = 'video';
                components.type = 'video_mp4';
                components.config.translate = __WEBPACK_IMPORTED_MODULE_15__i18n__["a" /* default */].t('display-player-mp4-plugin');
                components['custom-name'] = 'video_mp4';
                components.attributes = {
                  autoplay: '1',
                  id: makeId(),
                  muted: true,
                  src: media.selected.src,
                  width: '100%',
                  height: '100%'
                };
                components.autoplay = '1';
                components.muted = true;
                components['data-class'] = 'player-mp4';
                components.duration = media.selected.duration;
              }
              fullscreenVideo = false;

              if (media.type == 'videos') {
                fullscreenVideo = true;
              }
              slide = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({
                html: html,
                type: media.type,
                components: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(components),
                css: '',
                js: '',
                options: { fullscreenVideo: fullscreenVideo },
                screenShot: media.selected.src,
                transition: { in: '', out: '' }
              }, media.selected);
              segment = {
                screens: [slide],
                title: media.selected.title,
                description: media.selected.description,
                author: media.selected.auteur,
                type: 'Segment',
                id: media.selected.id,
                duration: media.selected.duration
              };


              commit('selectSegment', segment);
              commit('pushModuleSelected', segment);

            case 13:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  }
};

// getters are functions
var getters = {
  getduplicatedSegment: function getduplicatedSegment(state) {
    return state.duplicatedSegment;
  },
  getduplicatedSlideInSegment: function getduplicatedSlideInSegment(state) {
    return state.duplicatedSlideInSegment;
  },
  getAuteursList: function getAuteursList(state) {
    return state.Auteurs;
  },
  getModuleSelected: function getModuleSelected(state) {
    return state.moduleSelected;
  },
  getThemesList: function getThemesList(state) {
    return state.themes;
  },

  getFromRouteAdd: function getFromRouteAdd(state) {
    return state.fromRouteAdd;
  },
  getFromRouteBiblio: function getFromRouteBiblio(state) {
    return state.fromRouteBiblio;
  },
  getLoading: function getLoading(state) {
    return state.loading;
  },
  getEndReached: function getEndReached(state) {
    return function (type) {
      return state.endReached[type];
    };
  },
  getSegments: function getSegments(state) {
    return state.segments;
  },
  getSelectedSegments: function getSelectedSegments(state) {
    return state.selectedSegments.filter(function (segment) {
      return !segment.type.toLowerCase().includes('generic');
    });
  },
  getAllSelected: function getAllSelected(state) {
    return state.selectedSegments;
  },
  isSelectedSegment: function isSelectedSegment(state) {
    return function (segment) {
      return state.selectedSegments.some(function (s) {
        return s.id === segment.id;
      });
    };
  },
  getSegmentById: function getSegmentById(state) {
    return function (id) {
      return state.selectedSegments.find(function (item) {
        return item.id === id;
      });
    };
  },
  getLastSegmentById: function getLastSegmentById(state) {
    return function (id) {
      return state.selectedSegments.slice().reverse().find(function (slide) {
        return slide.id === id;
      });
    };
  },
  getCurrent: function getCurrent(state) {
    return state.current;
  },
  getApercu: function getApercu(state) {
    return state.current;
  },

  getByIndex: function getByIndex(state) {
    return function (index) {
      return state.selectedSegments.find(function (s, i) {
        return i === index;
      });
    };
  },
  getAllSegments: function getAllSegments(state) {
    return state.segments.filter(function (s) {
      return s.type === 'Segment';
    });
  },
  getAllDefaultSegments: function getAllDefaultSegments(state) {
    return state.segments.filter(function (s) {
      return s.type === 'DefaultSegment';
    });
  },
  getStartGeneric: function getStartGeneric(state) {
    return state.selectedSegments.find(function (s) {
      return s.type === 'startGeneric';
    });
  },
  getFinishGeneric: function getFinishGeneric(state) {
    return state.selectedSegments.find(function (s) {
      return s.type === 'finishGeneric';
    });
  },
  getAllSelectedSlides: function getAllSelectedSlides(state) {
    var slides = [];
    state.selectedSegments.forEach(function (segment) {
      if (segment.screens && segment.screens.length > 0) {
        segment.screens.forEach(function (screen) {
          slides.push(screen);
        });
      }
    });
    return slides;
  },
  getDeletedSegmentIndex: function getDeletedSegmentIndex(state) {
    return function (segment) {
      return state.segments.findIndex(function (s) {
        return s.id === segment.id;
      });
    };
  },

  getSegmentIndex: function getSegmentIndex(state) {
    return function (segment) {
      return state.selectedSegments.filter(function (segment) {
        return !segment.type.toLowerCase().includes('generic');
      }).findIndex(function (s) {
        return s.uid === segment.uid;
      });
    };
  },
  getAllSegmentsDuration: function getAllSegmentsDuration(state) {
    return state.selectedSegments.reduce(function (sum, e) {
      return sum + +(e.duration || 0);
    }, 0);
  },
  getSlideByUid: function getSlideByUid(state) {
    return function (uid) {
      var slide = {};
      state.selectedSegments.forEach(function (segment) {
        if (segment.uid === uid) {
          slide = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, segment);
        }
        segment.screens.forEach(function (screen) {
          if (screen.uid === uid) {
            slide = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, screen);
          }
        });
      });
      return slide;
    };
  },
  getByUid: function getByUid(state) {
    return function (uid) {
      return state.selectedSegments.find(function (sg) {
        return sg.uid === uid || sg.screens.some(function (sc) {
          return sc.uid === uid;
        });
      });
    };
  },
  hasFullscreenVideo: function hasFullscreenVideo(state) {
    return function (uid) {
      return state.selectedSegments.some(function (sg) {
        return sg.screens.some(function (sc) {
          return sc.fullscreenVideo;
        }) && function (sg) {
          return sg.uid === uid || sg.screens.some(function (sc) {
            return sc.uid === uid;
          });
        };
      });
    };
  },
  getNbrCall: function getNbrCall(state) {
    return state.nbrCall;
  },
  getTypeGeneric: function getTypeGeneric(state) {
    return state.typeGeneric;
  },
  isExtended: function isExtended(state) {
    return function (uid) {
      var segment = state.selectedSegments.find(function (s) {
        return s.uid === uid;
      });
      return segment && segment.isExtended;
    };
  },
  getLastUpdatedSegment: function getLastUpdatedSegment(state) {
    return state.selectedSegments.find(function (s, i) {
      return i === state.indexSlideToAdd;
    });
  },
  getLastUpdatedSegmentById: function getLastUpdatedSegmentById(state) {
    return state.selectedSegments.find(function (s, i) {
      return s.id === state.indexSegmentSlideToAdd;
    });
  },
  getCurrentPage: function getCurrentPage(state) {
    return function (type) {
      return state.currentPage[type];
    };
  },
  getNbSegments: function getNbSegments(state) {
    return state.nbSegments;
  },
  getLengthSegmentToAdd: function getLengthSegmentToAdd(state) {
    return state.lengthSegmentToAdd;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_duration_handler__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_router_router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__core_http_http_token__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18n__ = __webpack_require__(35);












var state = {
  listSelected: [],
  template: {},
  all: [],
  duplicateScreen: null,
  selected: [],
  current: {
    assets: '',
    components: '',
    css: '',
    html: '',
    options: {
      duration: __WEBPACK_IMPORTED_MODULE_7__helpers_duration_handler__["a" /* totalSegmentDuration */]()
    },
    styles: '',
    title: 'Disposition vierge',
    transition: {
      in: '',
      out: ''
    },
    type: 'Segment',
    screenShot: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJAQMAAAAB5D5xAAAABlBMVEXs7vHs7/Hee24nAAAAFUlEQVQI12P4/58BiGrB5D8wCUX/AOfxEWuWlIcVAAAAAElFTkSuQmCC',
    id: 0,
    uid: 100
  },
  loading: false,

  currentPage: {
    Screen: 1,
    Disposition: 1
  },
  nbPerPage: 32,
  endReached: {
    Screen: false,
    Disposition: false
  },
  delay: 0,
  opacity: 100,
  nbSlides: 0
};

var mutations = {
  setSlides: function setSlides(state, data) {
    state.slides = data;
  },
  selectTemplate: function selectTemplate(state, data) {
    state.template = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, state.template, data);
  },
  pushSlides: function pushSlides(state, slides) {
    var slidesTmp = slides.map(function (s) {
      if (!s.screenShot) {
        s.screenShot = 'data:image/png;base64,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';
      }
      return s;
    });

    state.all = state.all.concat(slidesTmp);
  },
  selectSlide: function selectSlide(state, slide) {
    var props = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({
      uid: Math.floor(new Date().valueOf() * Math.random()),
      options: {
        duration: __WEBPACK_IMPORTED_MODULE_7__helpers_duration_handler__["a" /* totalSegmentDuration */]()
      },
      transition: slide.options.transition && slide.options.transition.length > 0 ? slide.options.transition : { in: '', out: '' },
      js: slide.html.substring(slide.html.indexOf('<script>') + 8, slide.html.indexOf('</script>'))
    }, slide);
    if (slide.type === 'images') {
      props.type = 'images';
    } else {
      props.type = 'Screen';
    }
    state.selected.push(props);
    state.selected = __WEBPACK_IMPORTED_MODULE_7__helpers_duration_handler__["d" /* updateSlidesDuration */](state.selected);
  },
  pushListSelected: function pushListSelected(state, data) {
    state.listSelected.push(data);
  },
  resetListSelected: function resetListSelected(state) {
    state.listSelected = [];
  },
  duplicateSlide: function duplicateSlide(state, _ref) {
    var slide = _ref.slide,
        index = _ref.index;

    index += state.selected.findIndex(function (s) {
      return s.type === 'startGeneric';
    }) + 1;

    var props = {
      title: slide.title + '(copie)',
      uid: new Date().valueOf(),
      options: {
        duration: slide.options.duration
      },
      transition: {
        in: slide.transition.in,
        out: slide.transition.out
      }
    };
    state.selected.splice(index + 1, 0, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(slide)), props));
    state.duplicateScreen = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(slide)), props);
    state.selected = __WEBPACK_IMPORTED_MODULE_7__helpers_duration_handler__["d" /* updateSlidesDuration */](state.selected);
  },
  setLoading: function setLoading(state, loading) {
    state.loading = loading;
  },
  incrementPage: function incrementPage(state, type) {
    state.currentPage[type] += 1;
  },
  setEndReached: function setEndReached(state, _ref2) {
    var type = _ref2.type,
        endReached = _ref2.endReached;

    state.endReached[type] = endReached;
  },
  setSlideDuration: function setSlideDuration(state, data) {
    state.selected = state.selected.map(function (slide) {
      if (slide.uid === data.uid) {
        slide.options.duration = data.duration;
      }
      return slide;
    });
  },
  setSlideTransition: function setSlideTransition(state, data) {
    var transitionIndex = state.selected.findIndex(function (slide) {
      return slide.uid === data.uid;
    });

    state.selected = state.selected.map(function (slide, index) {
      if (index === transitionIndex - 1) {
        slide.transition.out = data.name + '-out';
      } else if (index === transitionIndex) {
        slide.transition.in = data.name + '-in';
      }
      return slide;
    });
  },
  setScreensTosubmit: function setScreensTosubmit(state, data) {
    state.selected.map(function (screen) {
      if (screen.uid === data.uid) {
        screen.template = data.template;
        screen.type = data.type;
        if (typeof screen.options == "string") {
          screen.options = JSON.parse(screen.options);
        }
        screen.options.transition = data.transition;
        screen.screenShot = data.screenShot;
      }
      return screen;
    });
  },
  updateSlide: function updateSlide(state, data) {
    state.selected = state.selected.map(function (slide, index) {
      if (slide.uid === data.uid) {
        state.selected[index].components = data.components || '';
        state.selected[index].html = data.html || '';
        state.selected[index].css = data.css || '';
        state.selected[index].styles = data.styles || '';
        state.selected[index].js = data.js || '';
      }
      return slide;
    });
  },
  removeSlideByUid: function removeSlideByUid(state, uid) {
    state.selected = state.selected.filter(function (slide) {
      return slide.uid !== uid;
    });
    state.selected = __WEBPACK_IMPORTED_MODULE_7__helpers_duration_handler__["d" /* updateSlidesDuration */](state.selected);
  },
  removeLastSlideById: function removeLastSlideById(state, id) {
    var index = state.selected.slice().reverse().findIndex(function (slide) {
      return slide.id === id;
    });
    var count = state.selected.length - 1;
    var finalIndex = index >= 0 ? count - index : index;
    state.selected = state.selected.filter(function (slide, i) {
      return slide.id !== id;
    });
    state.selected = __WEBPACK_IMPORTED_MODULE_7__helpers_duration_handler__["d" /* updateSlidesDuration */](state.selected);
  },
  removeFromListSelected: function removeFromListSelected(state, id) {
    state.listSelected = state.listSelected.filter(function (s) {
      return s.id !== id;
    });
  },
  existanceSlide: function existanceSlide(state, title) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__core_http_http_token__["a" /* HTTP */])(window.ApiToken).get(__WEBPACK_IMPORTED_MODULE_8__core_router_router__["a" /* default */].generate('api_slideDisplay_get_existant_slide'), {
      title: title
    }).then(function (response) {
      return response.data.existance;
    });
  },
  setCurrentSlide: function setCurrentSlide(state, current) {
    state.current = current;
  },
  reorderSlides: function reorderSlides(state, event) {
    var oldIndex = event.oldIndex,
        newIndex = event.newIndex;


    var i = state.selected.findIndex(function (s) {
      return s.type === 'startGeneric';
    }) + 1;

    oldIndex += i;
    newIndex += i;

    var movedItem = state.selected.find(function (item, index) {
      return index === oldIndex;
    });
    var remainingItems = state.selected.filter(function (item, index) {
      return index !== oldIndex;
    });

    state.selected = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(remainingItems.slice(0, newIndex)), [movedItem], __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(remainingItems.slice(newIndex)));
  },
  updateSlideTitle: function updateSlideTitle(state, data) {
    state.selected = state.selected.map(function (slide) {
      if (slide.uid === data.uid) {
        slide.title = data.title;
      }
      return slide;
    });
  },
  updateSlideDuration: function updateSlideDuration(state, data) {
    state.selected = state.selected.map(function (slide) {
      if (slide.uid === data.uid) {
        slide.options.duration = data.duration;
      }
      return slide;
    });
  },
  updateSlideThumbnail: function updateSlideThumbnail(state, data) {
    state.selected = state.selected.map(function (slide) {
      if (slide.uid === data.uid) {
        slide.screenShot = data.thumbnail;
      }
      return slide;
    });
  },
  updateSlideTitleGlobally: function updateSlideTitleGlobally(state, data) {
    state.all = state.all.map(function (slide) {
      if (slide.id === data.id) {
        slide.title = data.title;
      }
      return slide;
    });
  },
  setDelayFragment: function setDelayFragment(state, delay) {
    state.delay = delay;
  },
  setDispositions: function setDispositions(state, data) {
    state.all = data;
  },
  setOpacityFragment: function setOpacityFragment(state, opacity) {
    state.opacity = opacity;
  },
  changeTitleInSelected: function changeTitleInSelected(state, title) {
    state.selected[0].title = title;
  },
  setSlidesGeneric: function setSlidesGeneric(state, slide) {
    var html = '<iframe class="gjs-no-pointer" src="' + slide.src + '?a=1&sc=0" id="player-677" width="100%" height="100%" scrolling="no"  allow="encrypted-media" style="border: none; overflow: hidden;"></iframe>';
    var extension = slide.src.split('.').pop();
    if (extension.toLowerCase().indexOf('mp4') > -1) {
      html = '<video data-autoplay class="gjs-no-pointer" src="' + slide.src + '" id="player-677" width="100%" height="100%" scrolling="no" muted autoplay allow="encrypted-media" style="border: none; overflow: hidden;"></video>';
    }
    var generic = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({
      html: html,
      type: slide.type,
      components: '',
      css: '',
      js: '',
      options: {
        duration: __WEBPACK_IMPORTED_MODULE_7__helpers_duration_handler__["a" /* totalSegmentDuration */]()
      },
      screenShot: '',
      transition: { in: '', out: '' }
    }, slide);
    var selected = state.selected.filter(function (slide) {
      return slide.type !== generic.type;
    });
    if (generic.type.toLowerCase().includes('start')) {
      if (generic.src !== '') {
        selected.unshift(generic);
      }
    } else {
      if (generic.src !== '') {
        selected.push(generic);
      }
    }
    state.selected = __WEBPACK_IMPORTED_MODULE_7__helpers_duration_handler__["d" /* updateSlidesDuration */](selected);
  },
  resetSelect: function resetSelect(state) {
    state.selected = [];
  },
  updatePogramTitle: function updatePogramTitle(state, title) {
    state.template.title = title;
  },
  resetPage: function resetPage(state, types) {
    state.currentPage[types] = 1;
  },
  nbSegments: function nbSegments(state, nb) {
    state.nbSegments = nb;
  }
};

var actions = {
  selectImage: function selectImage(_ref3, media) {
    var _this = this;

    var state = _ref3.state,
        commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var makeId, html, domc, defaultType, defaultModel, components, fullscreenVideo, slide;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              makeId = function makeId() {
                var text = 'i';
                var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                for (var i = 0; i < 5; i++) {
                  text += possible.charAt(Math.floor(Math.random() * possible.length));
                }return text;
              };

              html = '<div data-gjs-type="image_media" id="' + makeId() + ('" width="100%" height="100%"><image class="gjs-no-pointer" src="' + media.selected.src + '" id="image-media-') + makeId() + '" width="100%" height="100%" scrolling="no" allow="encrypted-media" style="border: none; overflow: hidden;"></image></div>';
              domc = grapesjsEMP.editors[0].DomComponents;
              defaultType = domc.getType('default');
              defaultModel = defaultType.model;
              // const defaultView = defaultType.view;

              components = {
                'custom-name': 'image',
                tagName: 'div',
                src: media.selected.src,
                width: '100%',
                height: '100%',
                resizable: false,
                selected: true,
                attributes: {
                  id: +makeId(),
                  'data-class': 'image-media'
                },
                classes: [{
                  active: true,
                  label: makeId(),
                  name: makeId(),
                  private: false,
                  protected: false,
                  type: 1
                }, {
                  active: true,
                  label: 'gjs-comp-selected',
                  name: 'gjs-comp-selected',
                  private: false,
                  protected: false,
                  type: 1
                }],
                type: '',
                draggable: true,
                droppable: false,
                editable: false,
                highlightable: true,
                hoverable: true,
                icon: '',
                layerable: true,
                name: '',
                propagate: '',
                removable: true,
                script: '',
                selectable: true,
                config: {
                  translate: __WEBPACK_IMPORTED_MODULE_10__i18n__["a" /* default */].t('display-image-plugin')
                },
                'data-class': 'image-media',
                badgable: true,
                components: [],
                content: '',
                copyable: true,
                state: '',
                status: ''
              };
              fullscreenVideo = false;
              slide = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({
                html: html,
                type: media.type,
                components: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(components),
                css: '',
                js: '',
                options: { fullscreenVideo: fullscreenVideo },
                screenShot: media.selected.src,
                transition: { in: '', out: '' }
              }, media.selected);


              commit('selectSlide', slide);
              commit('pushListSelected', slide);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  paginate: function paginate(_ref4, type) {
    var _this2 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var url, _ref5, data;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (state.endReached[type]) {
                _context2.next = 13;
                break;
              }

              commit('setLoading', true);

              url = __WEBPACK_IMPORTED_MODULE_8__core_router_router__["a" /* default */].generate('api_screenDisplay_get_all_disposition', {
                page: state.currentPage[type],
                nbParPage: state.nbPerPage,
                type: type,
                client: localStorage.getItem('client')
              });
              _context2.next = 5;
              return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__core_http_http_token__["a" /* HTTP */])(window.ApiToken).get(url).then(function (response) {
                  resolve(response);
                });
              });

            case 5:
              _ref5 = _context2.sent;
              data = _ref5.data;


              data.data.dispositions.map(function (screen) {
                if (!screen.options) {
                  screen.options = __WEBPACK_IMPORTED_MODULE_7__helpers_duration_handler__["a" /* totalSegmentDuration */]();
                }
                var newData = JSON.parse(screen.options);
                screen.options = newData;
              });
              commit('incrementPage', type);
              commit('pushSlides', data.data.dispositions);
              commit('nbSegments', data.data.nombre_total);
              if (data.data.dispositions.length < state.nbPerPage) {

                commit('setEndReached', { type: type, endReached: true });
              } else {
                commit('setEndReached', { type: type, endReached: false });
              }
              commit('setLoading', false);

            case 13:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  updateTitle: function updateTitle(_ref6, data) {
    var _this3 = this;

    var state = _ref6.state,
        commit = _ref6.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__core_http_http_token__["a" /* HTTP */])(window.ApiToken).post(__WEBPACK_IMPORTED_MODULE_8__core_router_router__["a" /* default */].generate('api_screenDisplay_post_edit_screen', { id: data.id }), {
                title: data.title
              }).then(function (response) {
                commit('updateSlideTitleGlobally', data);
              });

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  setTemplate: function setTemplate(_ref7, template) {
    var commit = _ref7.commit;

    commit('selectTemplate', template);
  },
  setTemplateCurrent: function setTemplateCurrent(_ref8, template) {
    var commit = _ref8.commit;

    commit('selectTemplate', template);
  },

  setScreensTosubmit: function setScreensTosubmit(_ref9, data) {
    var state = _ref9.state,
        commit = _ref9.commit;
    return commit('setScreensTosubmit', data);
  },
  setSlides: function setSlides(_ref10, slides) {
    var state = _ref10.state,
        commit = _ref10.commit;
    return commit('setSlides', slides);
  },
  selectSlide: function selectSlide(_ref11, slide) {
    var state = _ref11.state,
        commit = _ref11.commit;
    return commit('selectSlide', slide);
  },
  duplicateSlide: function duplicateSlide(_ref12, _ref13) {
    var state = _ref12.state,
        commit = _ref12.commit;
    var slide = _ref13.slide,
        index = _ref13.index;
    return commit('duplicateSlide', { slide: slide, index: index });
  },
  setSlideDuration: function setSlideDuration(_ref14, slide) {
    var state = _ref14.state,
        commit = _ref14.commit;
    return commit('setSlideDuration', slide);
  },
  setDispositions: function setDispositions(_ref15, data) {
    var state = _ref15.state,
        commit = _ref15.commit;
    return commit('setDispositions', data);
  },
  pushListSelected: function pushListSelected(_ref16, data) {
    var state = _ref16.state,
        commit = _ref16.commit;
    return commit('pushListSelected', data);
  },
  resetListSelected: function resetListSelected(_ref17) {
    var state = _ref17.state,
        commit = _ref17.commit;
    return commit('resetListSelected');
  },
  setSlideTransition: function setSlideTransition(_ref18, slide) {
    var state = _ref18.state,
        commit = _ref18.commit;
    return commit('setSlideTransition', slide);
  },
  updateSlide: function updateSlide(_ref19, slide) {
    var state = _ref19.state,
        commit = _ref19.commit;
    return commit('updateSlide', slide);
  },
  updateSlideTitle: function updateSlideTitle(_ref20, slide) {
    var state = _ref20.state,
        commit = _ref20.commit;
    return commit('updateSlideTitle', slide);
  },
  updateSlideDuration: function updateSlideDuration(_ref21, slide) {
    var state = _ref21.state,
        commit = _ref21.commit;
    return commit('updateSlideDuration', slide);
  },
  updateSlideThumbnail: function updateSlideThumbnail(_ref22, slide) {
    var state = _ref22.state,
        commit = _ref22.commit;
    return commit('updateSlideThumbnail', slide);
  },
  removeSlideByUid: function removeSlideByUid(_ref23, uid) {
    var state = _ref23.state,
        commit = _ref23.commit;
    return commit('removeSlideByUid', uid);
  },
  removeLastSlideById: function removeLastSlideById(_ref24, id) {
    var state = _ref24.state,
        commit = _ref24.commit;
    return commit('removeLastSlideById', id);
  },
  removeFromListSelected: function removeFromListSelected(_ref25, id) {
    var state = _ref25.state,
        commit = _ref25.commit;
    return commit('removeFromListSelected', id);
  },
  pushSlides: function pushSlides(_ref26, slide) {
    var state = _ref26.state,
        commit = _ref26.commit;
    return commit('pushSlides', slide);
  },
  setCurrentSlide: function setCurrentSlide(_ref27, slide) {
    var state = _ref27.state,
        commit = _ref27.commit;
    return commit('setCurrentSlide', slide);
  },
  reorderSlides: function reorderSlides(_ref28, event) {
    var state = _ref28.state,
        commit = _ref28.commit;
    return commit('reorderSlides', event);
  },
  setSlidesGeneric: function setSlidesGeneric(_ref29, slide) {
    var state = _ref29.state,
        commit = _ref29.commit;
    return commit('setSlidesGeneric', slide);
  },
  changeTitleInSelected: function changeTitleInSelected(_ref30, title) {
    var state = _ref30.state,
        commit = _ref30.commit;
    return commit('changeTitleInSelected', title);
  },
  setDelayFragment: function setDelayFragment(_ref31, delay) {
    var commit = _ref31.commit;

    commit('setDelayFragment', delay);
  },
  setOpacityFragment: function setOpacityFragment(_ref32, opacity) {
    var commit = _ref32.commit;

    commit('setOpacityFragment', opacity);
  },

  resetSelect: function resetSelect(_ref33) {
    var state = _ref33.state,
        commit = _ref33.commit;
    return commit('resetSelect');
  },
  updatePogramTitle: function updatePogramTitle(_ref34, title) {
    var state = _ref34.state,
        commit = _ref34.commit;
    return commit('updatePogramTitle', title);
  },
  resetPage: function resetPage(_ref35, types) {
    var state = _ref35.state,
        commit = _ref35.commit;

    commit('resetPage', types);
  }
};

// getters are functions
var getters = {
  getLoading: function getLoading(state) {
    return state.loading;
  },
  getduplicateScreen: function getduplicateScreen(state) {
    return state.duplicateScreen;
  },
  getListSelected: function getListSelected(state) {
    return state.listSelected;
  },
  getEndReached: function getEndReached(state) {
    return function (type) {
      return state.endReached[type];
    };
  },
  getAll: function getAll(state) {
    return state.all;
  },
  getAllScreens: function getAllScreens(state) {
    return state.all.filter(function (s) {
      return s.type === 'screen';
    });
  },
  getAllDispositions: function getAllDispositions(state) {
    return state.all.filter(function (s) {
      return s.type === 'Disposition';
    });
  },
  getSelected: function getSelected(state) {
    return state.selected.filter(function (slide) {
      return !slide.type.toLowerCase().includes('generic');
    });
  },
  getAllSelected: function getAllSelected(state) {
    return state.selected;
  },
  isSelected: function isSelected(state) {
    return function (slide) {
      return state.selected.some(function (s) {
        return s.uid === slide.uid;
      });
    };
  },
  getSlideByUid: function getSlideByUid(state) {
    return function (uid) {
      return state.selected.find(function (item) {
        return item.uid === uid;
      });
    };
  },
  getLastSlideById: function getLastSlideById(state) {
    return function (id) {
      return state.selected.slice().reverse().find(function (slide) {
        return slide.id === id;
      });
    };
  },
  getCurrent: function getCurrent(state) {
    return state.current;
  },
  getByIndex: function getByIndex(state) {
    return function (index) {
      return state.selected.find(function (s, i) {
        return i === index;
      });
    };
  },
  getSlideIndex: function getSlideIndex(state) {
    return function (slide) {
      return state.selected.filter(function (slide) {
        return !slide.type.toLowerCase().includes('generic');
      }).findIndex(function (s) {
        return s.uid === slide.uid;
      });
    };
  },
  getTemplateTitle: function getTemplateTitle(state) {
    return state.template.title;
  },
  getDelayFragment: function getDelayFragment(state) {
    return state.delay;
  },
  getOpacityFragment: function getOpacityFragment(state) {
    return state.opacity;
  },
  getTemplate: function getTemplate(state) {
    return state.template;
  },
  getCurrentSlideIndex: function getCurrentSlideIndex(state) {
    return state.selected.findIndex(function (s) {
      return state.current.uid === s.uid;
    });
  },
  getStartGeneric: function getStartGeneric(state) {
    return state.selected.find(function (s) {
      return s.type === 'startGeneric';
    });
  },
  getFinishGeneric: function getFinishGeneric(state) {
    return state.selected.find(function (s) {
      return s.type === 'finishGeneric';
    });
  },
  getAllScreensDuration: function getAllScreensDuration(state) {
    /* todo -2s */
    return state.selected.reduce(function (sum, e) {
      return sum + +(e.options.duration || 0);
    }, 0);
  },
  getNbSlides: function getNbSlides(state) {
    return state.nbSlides;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  presets: [{
    label: 'Fade-In',
    key: 'fadein',
    properties: [{ prop: 'opacity', value: 0 }]
  }, {
    label: 'Slide From Top',
    key: 'fadeinslidedown',
    properties: [{ prop: 'opacity', value: 0 }, { prop: 'y', value: -50 }, { prop: 'rotation', value: 15, ease: 'Elastic.easeInOut' }]
  }, {
    label: 'Slide From Bottom',
    key: 'fadeinslideup',
    properties: [{ prop: 'opacity', value: 0 }, { prop: 'y', value: 50 }, { prop: 'rotation', value: 15, ease: 'Elastic.easeInOut' }]
  }, {
    label: 'Slide From Left',
    key: 'fadeinslideleft',
    properties: [{ prop: 'opacity', value: 0 }, { prop: 'x', value: -50 }]
  }, {
    label: 'Slide From Right',
    key: 'fadeinslideright',
    properties: [{ prop: 'opacity', value: 0 }, { prop: 'x', value: 50 }]
  }, {
    label: 'Zoom-In + Fade-In',
    key: 'zoominfadein',
    properties: [{ prop: 'opacity', value: 0 }, { prop: 'scale', value: 0 }]
  }, {
    label: 'Zoom-Out + Fade-In',
    key: 'zoomoutfadein',
    properties: [{ prop: 'opacity', value: 0 }, { prop: 'scale', value: 2, ease: 'Elastic.easeInOut' }, { prop: 'rotation', value: 30 }]
  }, { label: '[Empty]', key: 'empty', properties: [] }],
  properties: [{ prop: 'x', label: 'X', value: 0, open: false }, { prop: 'y', label: 'Y', value: 0, open: false }, { prop: 'scale', label: 'Scale', value: 1, open: false }, { prop: 'rotation', label: 'Rotation', value: 0, open: false }, { prop: 'autoAlpha', label: 'Opacity', value: 1, open: false }],
  functions: [{ name: 'random', func: function func() {
      return Math.random();
    } }]
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'SweetModal',

	props: {
		title: {
			type: String,
			required: false,
			default: ''
		},

		overlayTheme: {
			type: String,
			required: false,
			default: 'light'
		},

		modalTheme: {
			type: String,
			required: false,
			default: 'light'
		},

		blocking: {
			type: Boolean,
			required: false,
			default: false
		},

		pulseOnBlock: {
			type: Boolean,
			required: false,
			default: true
		},

		icon: {
			type: String,
			required: false,
			default: ''
		},

		hideCloseButton: {
			type: Boolean,
			required: false,
			default: false
		},

		enableMobileFullscreen: {
			type: Boolean,
			required: false,
			default: true
		},

		width: {
			type: [Number, String],
			required: false,
			default: null
		}
	},

	mounted: function mounted() {
		this.tabs = this.$children.filter(function (c) {
			return c.cmpName && c.cmpName == 'tab';
		});

		if (this.has_tabs) {
			this.currentTab = this._changeTab(this.tabs[0]);
		}

		document.addEventListener('keyup', this._onDocumentKeyup);
	},
	beforeDestroy: function beforeDestroy() {
		document.removeEventListener('keyup', this._onDocumentKeyup);
	},
	data: function data() {
		return {
			visible: false,
			is_open: false,
			is_bouncing: false,
			tabs: [],

			backups: {
				body: {
					height: null,
					overflow: null
				}
			}
		};
	},


	computed: {
		has_title: function has_title() {
			return this.title || this.$slots.title;
		},
		has_tabs: function has_tabs() {
			return this.tabs.length > 0;
		},
		has_content: function has_content() {
			return this.$slots.default;
		},
		current_tab: function current_tab() {
			return this.tabs.filter(function (t) {
				return t.active === true;
			})[0];
		},
		overlay_classes: function overlay_classes() {
			return ['sweet-modal-overlay', 'theme-' + this.overlayTheme, 'sweet-modal-clickable', {
				'is-visible': this.visible,
				blocking: this.blocking
			}];
		},
		modal_classes: function modal_classes() {
			return ['sweet-modal', 'theme-' + this.modalTheme, {
				'has-title': this.has_title,
				'has-tabs': this.has_tabs,
				'has-content': this.has_content,
				'has-icon': this.icon,
				'is-mobile-fullscreen': this.enableMobileFullscreen,
				'is-visible': this.visible,
				'is-alert': this.icon && !this.has_tabs || !this.icon && !this.title && !this.$slots.title,
				bounce: this.is_bouncing
			}];
		},
		modal_style: function modal_style() {
			var width = this.width;
			var maxWidth = null;

			if (width !== null) {
				if (Number(width) == width) {
					width = width + 'px';
				}

				maxWidth = 'none';
			}

			return {
				width: width,
				maxWidth: maxWidth
			};
		}
	},

	methods: {
		/**
   * Open the dialog
   * Emits an event 'open'
   *
   * @param tabId string     Optional id or index of initial tab element.
   */
		open: function open() {
			var _this = this;

			var tabId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

			if (tabId && this.has_tabs) {
				// Find tab with wanted id.
				var openingTabs = this.tabs.filter(function (tab) {
					return tab.id === tabId;
				});
				if (openingTabs.length > 0) {
					// Set current tab to first match.
					this.currentTab = this._changeTab(openingTabs[0]);
				} else {
					// Try opening index instead of id as an alternative.
					var openingTab = this.tabs[tabId];
					if (openingTab) {
						this.currentTab = this._changeTab(openingTab);
					}
				}
			}

			this.is_open = true;
			this._lockBody();
			this._animateIcon();

			setTimeout(function () {
				return _this.visible = true;
			}, 30);
			this.$emit('open');
		},


		/**
   * Close the dialog
   * Emits an event 'close'
   */
		close: function close() {
			var _this2 = this;

			this.visible = false;
			this._unlockBody();

			setTimeout(function () {
				return _this2.is_open = false;
			}, 300);
			this.$emit('close');
		},


		/**
   * Bounce the modal.
   */
		bounce: function bounce() {
			var _this3 = this;

			this.is_bouncing = true;

			setTimeout(function () {
				return _this3.is_bouncing = false;
			}, 330);
		},


		/**********************
      INTERNAL METHODS
   **********************/

		_lockBody: function _lockBody() {
			this.backups.body.height = document.body.style.height;
			this.backups.body.overflow = document.body.style.overflow;

			document.body.style.height = '100%';
			document.body.style.overflow = 'hidden';
		},
		_unlockBody: function _unlockBody() {
			document.body.style.height = this.backups.body.height;
			document.body.style.overflow = this.backups.body.overflow;
		},
		_onOverlayClick: function _onOverlayClick(event) {
			if (!event.target.classList || event.target.classList.contains('sweet-modal-clickable')) {
				if (this.blocking) {
					if (this.pulseOnBlock) this.bounce();
				} else {
					this.close();
				}
			}
		},
		_onDocumentKeyup: function _onDocumentKeyup(event) {
			if (event.keyCode == 27) {
				if (this.blocking) {
					if (this.pulseOnBlock) this.bounce();
				} else {
					this.close();
				}
			}
		},
		_changeTab: function _changeTab(tab) {
			this.tabs.map(function (t) {
				return t.active = t == tab;
			});
			this.currentTab = tab;
		},
		_getClassesForTab: function _getClassesForTab(tab) {
			return ['sweet-modal-tab', {
				active: tab.active,
				disabled: tab.disabled
			}];
		},
		_animateIcon: function _animateIcon() {
			var _this4 = this;

			if (!this.icon) return;

			switch (this.icon) {
				case 'success':
					setTimeout(function () {
						_this4._applyClasses(_this4.$refs.icon_success, {
							'': ['animate'],
							'.sweet-modal-tip': ['animateSuccessTip'],
							'.sweet-modal-long': ['animateSuccessLong']
						});
					}, 80);

					break;

				case 'warning':
					this._applyClasses(this.$refs.icon_warning, {
						'': ['pulseWarning'],
						'.sweet-modal-body': ['pulseWarningIns'],
						'.sweet-modal-dot': ['pulseWarningIns']
					});

					break;

				case 'error':
					setTimeout(function () {
						_this4._applyClasses(_this4.$refs.icon_error, {
							'': ['animateErrorIcon'],
							'.sweet-modal-x-mark': ['animateXMark']
						});
					}, 80);

					break;
			}
		},


		/**
   * Apply classes from the classMap to $ref or children of $ref, a native
   * DOMElement.
   *
   * ClassMap:
   * {
   *     'selector': [ 'class1', 'class2', ... ]
   * }
   *
   * Empty Selector selects $ref.
   *
   * @param DOMNode $ref     Element to apply classes to or children of that element
   * @param Object  classMap Class Map which elements get which classes (see doc)
   */
		_applyClasses: function _applyClasses($ref, classMap) {
			for (var cl in classMap) {
				var _$el$classList, _$el$classList2;

				var classes = classMap[cl];
				var $el = void 0;

				if (cl == '') {
					$el = $ref;
				} else {
					$el = $ref.querySelector(cl);
				}

				(_$el$classList = $el.classList).remove.apply(_$el$classList, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(classes));
				(_$el$classList2 = $el.classList).add.apply(_$el$classList2, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(classes));
			}
		}
	}
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		title: {
			type: String,
			required: true
		},

		id: {
			type: String,
			required: true
		},

		icon: {
			type: String,
			required: false,
			default: null
		},

		disabled: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	data: function data() {
		return {
			active: false
		};
	},


	computed: {
		cmpName: function cmpName() {
			return 'tab';
		}
	}
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_core_http_http_common__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_core_router_router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Preview__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Preview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Preview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_Mixin_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_GrapesMixinEditors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Editor__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Editor__);


//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  props: ['typeS'],
  data: function data() {
    return {
      showDisplay: false
    };
  },

  components: {
    Preview: __WEBPACK_IMPORTED_MODULE_5__components_Preview___default.a,
    Editor: __WEBPACK_IMPORTED_MODULE_9__components_Editor___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_Mixin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_GrapesMixinEditors__["a" /* default */]],
  created: function created() {
    var lang = this.$route.query.lang || 'fr';
    this.$root.$i18n.locale = lang;
    localStorage.setItem('gjs-components', '');
    localStorage.setItem('gjs-html', '');
    localStorage.setItem('gjs-styles', '');
    localStorage.setItem('gjs-css', '');

    var self = this;

    __WEBPACK_IMPORTED_MODULE_2__src_core_http_http_common__["a" /* HTTP */].get(__WEBPACK_IMPORTED_MODULE_3__src_core_router_router__["a" /* default */].generate('api_programDisplay_get_params_display', {
      cryptext: this.$route.params.cryptext
    })).then(function (response) {
      if (response.data.code == 200) {
        if (response.data) {
          if (!response.data.display_default_blocks) {
            response.data.display_default_blocks = self.getParamsClients.display_default_blocks;
            if (!response.data.modules.show_list_block_action) {
              self.setHiddenBlock(!!response.data.modules.display_layers);
            }
          } else if (response.data.display_default_blocks && (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(response.data.display_default_blocks).length === 0 || !response.data.modules.show_list_block_action)) {
            self.setHiddenBlock(!!response.data.modules.display_layers);
          }
          var hasDevices = true;
          if (!response.data.display_devices || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(response.data.display_devices).length === 0) {
            hasDevices = false;
            response.data.display_devices = self.getParamsClients.display_devices;
          }
          if (response.data.display_devices && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(response.data.display_devices).length === 1) {
            self.setHiddenButtonDevice();
          }
          if (!response.data.display_custom_style_manager || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(response.data.display_custom_style_manager).length === 0) {
            response.data.display_custom_style_manager = self.getParamsClients.display_custom_style_manager;
          }
          self.pushParamsClient(response.data);

          var modules = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data.modules, {
            can_toggle_slides_action: parseInt(response.data.nb_screen_segment) !== 1,
            nb_screen_segment: response.data.nb_screen_segment,
            display_devices: hasDevices
          });
          if (self.hasPermission('save_video_action') && !self.hasPermission('save_copie_html_action')) {
            self.setSaveVideo(true);
          }
          self.setPermissions(modules);
          if (response.data.auth_token) {
            window.ApiToken = response.data.auth_token;
            //process.env.API_TOCKEN = response.data.auth_token;
            self.showDisplay = true;
          }
          localStorage.setItem('video_intro', response.data.show_video_intro);
          localStorage.setItem('video_generique', response.data.show_generic_display);
          localStorage.setItem('client', response.data.client);
        }
      }
      // self.setDispositions(response.data);
    }, function (error) {});
    document.body.onmouseup = function () {
      window.dragEnabled = false;
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['getParamsClients', 'hasPermission'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['pushParamsClient', 'setPermissions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])({
    setSaveVideo: 'common/setSaveVideo'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('common', ['addToListSvgObject']), {
    eventPostMessage: function eventPostMessage() {
      var self = this;
      var code = 'fr';
      var imageUrl = void 0,
          urlMedia = void 0,
          id = void 0,
          comp = void 0;
      if (window.dataEventPostMessage === undefined) {
        window.dataEventPostMessage = true;

        var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
        var eventer = window[eventMethod];
        var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
        eventer(messageEvent, function (event) {
          var message = event.data;
          if (message !== 'undefined') {
            if (message.postSvg && message.postSvg === true) {
              self.$root.$emit('bv::hide::modal', 'modal-svg-mator');
              self.addToListSvgObject(message);

              //document.getElementsByClassName('gjs-frame')[0].contentDocument.querySelector('#'+message.getImgId).src=message.SVG64;
              if (grapesjsEMP.editors[0].getSelected().attributes.type === 'image_media' || grapesjsEMP.editors[0].getSelected().attributes.type === 'pattern') {
                grapesjsEMP.editors[0].getSelected().set('src', message.SVG64);
                grapesjsEMP.editors[0].getSelected().view.el.firstChild.src = message.SVG64;
              } else {
                grapesjsEMP.editors[0].getSelected().set('src', message.SVG64);
              }
            }
            if (message.info === 'updateLang') {
              code = message.lang;
              __WEBPACK_IMPORTED_MODULE_6__main__["bus"].$emit('setFormLang', code);
              self.$root.$i18n.locale = code;
              self.$i18n.locale = code;
              self.$nextTick(function () {});
            }
            if (message.info && message.info === 'showSocialMedia') {
              if (self.paramsClient.display_default_urls) {
                imageUrl = self.paramsClient.display_default_urls.social_media_url;
              }
              id = 'social-media';
              comp = 'social_media';
              var selectedElement = grapesjsEMP.editors[0].getSelected();
              if (selectedElement !== undefined) {
                /* todo url images */
                try {
                  var style = '';
                  if (message.currentPost.TypeShow === 'fullScreen') {
                    style = {
                      width: '100%',
                      height: '100%',
                      overflow: 'auto',
                      left: '0',
                      top: '0'
                    };
                    window.eventHub.$emit('showToolbarButtons', false);
                  }

                  var objectMedia = {
                    data: message.data,
                    currentPost: message.currentPost
                  };
                  window.y = objectMedia;
                  selectedElement.set({
                    objectMedia: objectMedia,
                    type: message.currentPost.TypeSocial,
                    'custom-name': message.currentPost.TypeSocial
                  });

                  selectedElement.setAttributes({
                    id: selectedElement.attributes.attributes.id,
                    style: style,
                    'data-gjs-type': message.currentPost.TypeSocial
                  });
                } catch (e) {}
              }
              self.closeModal(comp, id);
            }
            if (message.info && message.info === 'showImage') {
              id = 'image-media';
              comp = 'image_media';
              if (self.paramsClient.display_default_urls) {
                imageUrl = self.paramsClient.display_default_urls.image_url;
                urlMedia = self.paramsClient.display_default_urls.url_media;
              }
              var editor = grapesjsEMP.editors[0];
              var selectedElement = editor.getSelected();
              if (selectedElement !== undefined) {
                var wrapperEl = selectedElement.view.el;
                var typeEl = selectedElement.attributes.type;

                /* todo url images */
                try {
                  if (typeEl === 'image_media') {
                    wrapperEl.querySelector('img') && wrapperEl.querySelector('img').setAttribute('src', message.src);
                    var img = new Image();
                    img.onload = function () {
                      var data = {
                        className: selectedElement.view.el.classList[0],
                        img: img
                      };
                      window.eventHub.$emit('updateWidthImage', data);
                    };
                    img.src = message.src;
                    /*    */
                    if (message.src && message.src !== null) {
                      var extension = message.src.split('.').pop();
                      if (extension && extension === 'svg' || selectedElement.attributes.svg === 'svg') {
                        selectedElement.set('svg', 'svg');
                        self.ShowToolBar('object-group');
                      } else self.displayToolBar('object-group');
                    }
                    grapesjsEMP.editors[0].select(null);
                  } else if (typeEl === 'pattern') {
                    id = 'pattern';
                    comp = 'pattern';
                    if (self.paramsClient.display_default_urls) {
                      imageUrl = self.paramsClient.display_default_urls.pattern_url;
                    }
                    wrapperEl.querySelector('img') && wrapperEl.querySelector('img').setAttribute('src', imageUrl);
                    var _img = new Image();
                    _img.onload = function () {
                      var data = {
                        className: selectedElement.view.el.classList[0],
                        img: _img
                      };
                      window.eventHub.$emit('updateWidthImage', data);
                    };
                    _img.src = imageUrl;
                    /*    */
                    if (message.src && message.src !== null) {
                      var _extension = message.src.split('.').pop();
                      if (_extension && _extension === 'svg' || selectedElement.attributes.svg === 'svg') {
                        selectedElement.set('svg', 'svg');
                        self.ShowToolBar('object-group');
                      } else self.displayToolBar('object-group');
                    }
                    grapesjsEMP.editors[0].select(null);
                  } else {
                    wrapperEl && wrapperEl.setAttribute('src', message.src);
                    self.updateWrapperProperties(grapesjsEMP.editors[0], message.src);
                  }
                } catch (e) {}

                selectedElement.set('src', message.src);
              }
              self.closeModal(comp, id);
            }
          }
        }, false);
      }
      self.setCloseImageModal(comp, id);
    },
    setHiddenBlock: function setHiddenBlock() {
      var displayLayers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      setTimeout(function () {
        var elBlocks = document.querySelector('#gjs .gjs-pn-buttons .fa-th-large:not(.gjs-pn-active)');
        if (elBlocks) {
          elBlocks.style.display = 'none';
        }
        var elBrush = document.querySelector('#gjs .gjs-pn-buttons .fa-paint-brush');
        if (elBrush) {
          elBrush.style.display = 'none';
        }

        if (!displayLayers) {
          document.querySelector('.gjs-pn-buttons.panel-buttons') && document.querySelector('.gjs-pn-buttons.panel-buttons').setAttribute('style', 'display: none !important;');
          setTimeout(function () {
            if (document.querySelector('.gjs-pn-panel.gjs-pn-views-container')) document.querySelector('.gjs-pn-panel.gjs-pn-views-container').style.height = 'calc(100% - 40px)';
          }, 1000);
        }
      }, 100);
    },
    setHiddenButtonDevice: function setHiddenButtonDevice() {
      setTimeout(function () {
        if (document.querySelector('.gjs-pn-devices-b')) document.querySelector('.gjs-pn-devices-b').style.display = 'none';
      }, 100);
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.eventPostMessage();
    });
  }
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

//import service from 'vuex-service-api'
/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {}
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_en_US__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_fr_FR__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Modal_SlideCard__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Modal_SlideCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Modal_SlideCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_Mixin_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_carousel__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_GrapesMixinHelpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Modal_SegmentList_vue__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Modal_SegmentList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__Modal_SegmentList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_top_progress__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_top_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_top_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__core_directives_HasPermission_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_duration_handler__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_perfect_scrollbar__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_infinite_loading__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__main__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuedraggable__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mixins_GrapesMixinEditors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__mixins_GrapesMixinTranslate__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__mixins_GrapesMixinPanels__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Panel_PanelCard__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Panel_PanelCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__Panel_PanelCard__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





















var lowercaseKeys = __webpack_require__(347);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddScreen',
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_Mixin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_GrapesMixinHelpers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__mixins_GrapesMixinEditors__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__mixins_GrapesMixinTranslate__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__mixins_GrapesMixinPanels__["a" /* default */]],
  directives: {
    HasPermission: __WEBPACK_IMPORTED_MODULE_15__core_directives_HasPermission_js__["a" /* default */]
  },
  data: function data() {
    return {
      options: [],
      ligneTemplate: [],
      clicksOut: true,
      showCollapse: false,
      navparam: true,
      selectedTab: '',
      infiniteState: null,
      selectedIds: [],
      selecteIdSegment: [],

      titleTemplate: this.$t('template.new_template'),
      total: 0,
      hideCancelButton: true,
      disabledConfirmButton: true,
      duration: 59,
      isActiveModule: false,
      activeModule: 'models',
      all_videos: [],
      all_images: [],
      textToSearch: '',
      tabs: ['models', 'recents', 'images', 'empty'],
      scrollInterval: null,
      list: [],
      lists: [],
      segmentKey: 0,
      showScroll: false,
      isExtendedSlides: false,
      oldImages: false,
      titleSegment: '',
      tabsArray: []
    };
  },

  components: {
    vueTopprogress: __WEBPACK_IMPORTED_MODULE_14_vue_top_progress__["vueTopprogress"],
    SlideCard: __WEBPACK_IMPORTED_MODULE_9__Modal_SlideCard___default.a,
    Carousel: __WEBPACK_IMPORTED_MODULE_11_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_11_vue_carousel__["Slide"],
    SegmentList: __WEBPACK_IMPORTED_MODULE_13__Modal_SegmentList_vue___default.a,
    VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_17_vue_perfect_scrollbar___default.a,
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_18_vue_infinite_loading___default.a,
    draggable: __WEBPACK_IMPORTED_MODULE_20_vuedraggable___default.a,
    PanelCard: __WEBPACK_IMPORTED_MODULE_24__Panel_PanelCard___default.a
  },
  i18n: {
    messages: {
      en: __WEBPACK_IMPORTED_MODULE_7__i18n_en_US__["a" /* default */],
      fr: __WEBPACK_IMPORTED_MODULE_8__i18n_fr_FR__["a" /* default */]
    }
  },
  watch: {
    isLoading: function isLoading(_isLoading) {
      if (this.infiniteState) {
        if (this.isEndReached('Disposition') || this.isEndReached('Screen')) {
          this.infiniteState.complete();
        } else if (!_isLoading) {
          this.infiniteState.loaded();
        }
      }
    },
    isLoadingMedias: function isLoadingMedias(isLoading) {
      this.callLoadMedias(isLoading);
    },
    dispositions: function dispositions(_dispositions) {
      if (_dispositions.length === 0 && this.infiniteState) {
        if (!this.isLoading) {
          this.reloadList();
        }
        this.infiniteState.reset();
      }
    },
    AllScreens: function AllScreens(_AllScreens) {
      if (_AllScreens.length === 0 && this.infiniteState) {
        if (!this.isLoading) {
          this.reloadList();
        }
        this.infiniteState.reset();
      }
    },
    getAllMedias: function getAllMedias(medias) {
      if (medias[this.activeModule].length === 0 && this.infiniteState) {
        if (!this.isLoadingMedias) {
          this.loadMore();
        }
        this.infiniteState.reset();
      }
    },

    all: {
      handler: function handler(all) {
        var _this = this;

        all.forEach(function (el, index) {
          _this.lists[index] = _this.getScreens(el);
        });
      },

      deep: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])({
    screens: 'slides/getAllScreens',
    AllScreens: 'slides/getAllScreens',
    currentSlide: 'slides/getCurrent',
    dispositions: 'slides/getAllDispositions',
    all: 'segments/getSelectedSegments',
    segments: 'segments/getAllSegments',
    SegmentsFiltredByTitle: 'segment/getFilterSegments',
    currentPage: 'segments/getCurrentPage',
    isLoading: 'slides/getLoading',
    isLoadingMedias: 'medias/getLoading',
    isEndReached: 'slides/getEndReached',
    isEndReachedMedias: 'medias/getEndReachedMedias',
    selected: 'slides/getSelected',
    currentSegment: 'segments/getCurrent',
    isSelected: 'slides/isSelected',
    firstSelectedSegment: 'segments/getLastSegmentById',
    showIconSave: 'common/getShowIconSave',
    paramsClient: 'getParamsClients',
    hasPermission: 'hasPermission',
    totalDurationSegments: 'segments/getAllSegmentsDuration',
    template: 'slides/getTemplate',
    nb_videos: 'medias/getNbVideos',
    getAllMedias: 'medias/getAllMedias',
    nb_slides: 'slides/getNbSlides',
    lastUpdatedSegment: 'segments/getLastUpdatedSegmentById',
    ListSelected: 'slides/getListSelected',
    nbrCall: 'segments/getNbrCall',
    firstSelectedSlide: 'slides/getLastSlideById',
    getAssetManager: 'grapes/getAssetManager',
    getPermissions: "getPermissions"
  }), {
    allTabs: function allTabs() {
      for (var i = 0; i < this.tabs.length; i++) {
        if (this.getPermissions['show_' + this.tabs[i] + '_part_action'] || this.tabs[i] === 'empty') {
          this.tabsArray.push(this.tabs[i]);
          if (this.tabsArray.length > 0) {
            this.activeModule = this.tabsArray[0];
          }
        }
      }
      return this.tabsArray;
    },
    hasScrollSlides: function hasScrollSlides() {
      if (this.ListSelected.length > 0) {
        var count = this.ListSelected.length;

        var panelWidth = 0;
        var widthSlides = 0;
        var cardWrapper = document.querySelector('#add-screen-module .timeline-modules .div-draggable-margin .slides-panel .card-wrapper');
        if (cardWrapper) {
          widthSlides = count * cardWrapper.clientWidth;
          if (this.isExtendedSlides) {
            var extendedPanel = document.querySelector('.inner-slides-wrapper.extended');
            widthSlides += extendedPanel.offsetWidth;
          }
        }
        var panel = document.querySelector('#add-screen-module .timeline-modules .div-draggable-margin .slides-panel');
        if (panel) {
          panelWidth = panel.offsetWidth;
        }

        if (widthSlides >= panelWidth) {
          this.showScroll = true;
        } else {
          this.showScroll = false;
        }
        this.$root.$emit('showScroll', this.showScroll);
        return this.showScroll;
      }
    },
    stateTitle: function stateTitle() {
      var state = this.titleTemplate.length >= 1 ? true : false;
      if (state) return null;else return state;
    },
    stateLigne: function stateLigne() {
      var state = this.ligneTemplate.length >= 1 ? true : false;
      if (state) return null;else return state;
    },
    stateDuration: function stateDuration() {
      if (this.durationTemplate === '00:00:00' || this.durationTemplate === '' || this.durationTemplate === '00:00') return false;else return null;
    },

    durationTemplate: {
      get: function get() {
        var value = this.duration;
        var hours = Math.floor(value / 3600);
        value %= 3600;
        var minutes = Math.floor(value / 60);
        var seconds = value % 60;
        var addZero = function addZero(v) {
          return v < 10 ? '0' + v : v;
        };
        var t = [];

        t.push(addZero(hours));
        t.push(addZero(minutes));
        t.push(addZero(seconds));

        return t.join(':');
      },
      set: function set(value) {
        this.duration = value.split(':').reverse().reduce(function (prev, curr, i) {
          return prev + curr * Math.pow(60, i);
        }, 0);
      }
    },
    empty: function empty() {
      var disposition = {
        assets: '',
        components: '',
        css: '',
        html: '',
        options: {
          duration: __WEBPACK_IMPORTED_MODULE_16__helpers_duration_handler__["a" /* totalSegmentDuration */]()
        },
        styles: '',
        title: this.$t('disposition.empty'),
        transition: {
          in: '',
          out: ''
        },
        type: 'Disposition',
        screenShot: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJAQMAAAAB5D5xAAAABlBMVEXs7vHs7/Hee24nAAAAFUlEQVQI12P4/58BiGrB5D8wCUX/AOfxEWuWlIcVAAAAAElFTkSuQmCC',
        id: 0
      };
      return disposition;
    },
    emptyScreen: function emptyScreen() {
      var customTitle = "";
      if (this.selected.length) {
        customTitle = this.$t('screens.screen') + parseInt(this.selected.filter(function (s) {
          return s.options.oldType === 'empty';
        }).length + 1);
      }
      if ((this.$route.name === 'add' || this.$route.name === 'edit') && this.currentSegment.screens.length) {
        customTitle = this.$t('screens.screen') + parseInt(this.currentSegment.screens.filter(function (s) {
          return s.options.oldType === 'empty';
        }).length + 1);
      }

      var disposition = {
        assets: '',
        components: '',
        css: '',
        html: '',
        options: {
          duration: __WEBPACK_IMPORTED_MODULE_16__helpers_duration_handler__["a" /* totalSegmentDuration */](),
          oldType: 'empty'
        },
        styles: '',
        title: customTitle,
        transition: {
          in: '',
          out: ''
        },
        type: 'Disposition',
        screenShot: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJAQMAAAAB5D5xAAAABlBMVEXs7vHs7/Hee24nAAAAFUlEQVQI12P4/58BiGrB5D8wCUX/AOfxEWuWlIcVAAAAAElFTkSuQmCC',
        id: 0
      };
      return disposition;
    },
    getComputedList: function getComputedList() {
      if (this.activeModule === 'models' && this.hasPermission('show_models_part_action')) {
        this.reloadList('models');
        return this.dispositions;
      } else if (this.activeModule === 'recents' && this.hasPermission('show_recents_part_action')) {
        this.reloadList('recents');
        return this.AllScreens;
      } else {
        this.reloadListMedias();
        if (this.hasPermission('show_images_part_action')) {
          if (this.oldImages) {
            var allOldImages = [];
            var i = 0;
            if (this.getAssetManager) {
              this.getAssetManager.map(function (data) {
                i++;
                allOldImages.push({ id: i, title: 'image-' + i, lien: data });
              });
            }
            return allOldImages;
          } else {
            this.all_images = this.getAllMedias(this.activeModule);
            return this.getAllImages();
          }
        }
      }
    },
    getAllImages: function getAllImages() {
      var allImage = [];
      this.getAllMedias(this.activeModule).map(function (data) {
        allImage.push(lowercaseKeys(data));
      });
      return allImage;
    },
    noMoreMedias: function noMoreMedias() {
      if (this.activeModule === 'models') {
        return this.isEndReached('Disposition');
      } else if (this.activeModule === 'recents') {
        return this.isEndReached('Screen');
      } else {
        return this.isEndReachedMedias(this.activeModule);
      }
    },
    noResultMedias: function noResultMedias() {
      if (this.activeModule === 'models') {
        return this.dispositions.length === 0;
      } else if (this.activeModule === 'recents') {
        return this.AllScreens.length === 0;
      } else {
        return this.getAllMedias(this.activeModule).length === 0;
      }
    },
    hasImagesModules: function hasImagesModules() {
      var found = false;
      if (this.paramsClient.display_default_blocks || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.paramsClient.display_default_blocks).length > 0) {
        this.paramsClient.display_default_blocks.map(function (block) {
          for (var i = 0; i < block.blocks.length; i++) {
            if (block.blocks[i] === 'image_media') {
              found = true;
            }
          }
        });
      }
      return found;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('segments', ['getSegments', 'paginatesegment', 'selectSegment', 'setCurrentSegment', 'removeLastSegmentById', 'updateSegment', 'setTitle', 'setSegments', 'setNbrCall', 'updateSlideInsideSegment', 'selectMedias', 'reorderSegments', 'reorderSlidesInsideSegment', 'appendSlideToSegment', 'removeLastSlideFromSegmentById', 'appendImageToSegment']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('common', ['setShowIconSave']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('slides', ['selectImage', 'paginate', 'selectSlide', 'setCurrentSlide', 'removeLastSlideById', 'updateSlide', 'fetch', 'resetPage', 'setTemplate', 'setDispositions', 'pushListSelected', 'resetListSelected', 'removeFromListSelected', 'resetSelect', 'changeTitleInSelected']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(['setRoute']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('medias', ['reloadVideoList', 'reloadImageList', 'resetPageVideos', 'setTitleMedias', 'setMedias']), {
    setActiveScrollButtons: function setActiveScrollButtons() {
      if (this.ListSelected.length > 0) {
        var count = this.ListSelected.length;
        var panelWidth = 0;
        var widthSlides = 0;
        var cardWrapper = document.querySelector('#add-screen-module .timeline-modules .div-draggable-margin .slides-panel .card-wrapper');

        if (cardWrapper) {
          widthSlides = count * cardWrapper.clientWidth;
          if (this.isExtendedSlides) {
            var extendedPanel = document.querySelector('.inner-slides-wrapper.extended');
            widthSlides += extendedPanel.offsetWidth;
          }
        }
        var panel = document.querySelector('#add-screen-module .timeline-modules .div-draggable-margin .slides-panel');
        if (panel) {
          panelWidth = panel.offsetWidth;
        }
        if (widthSlides >= panelWidth) {
          this.showScroll = true;
        } else {
          this.showScroll = false;
        }
        this.$root.$emit('showScroll', this.showScroll);
        return this.showScroll;
      }
    },
    reloadList: function reloadList(module) {
      var self = this;
      var listElm = document.querySelector('#add-screen-module .default-modules.screens');
      if (module === 'models') {
        if (self.nb_slides === self.dispositions.length) {
          return;
        }
      } else {
        if (self.nb_slides === self.AllScreens.length) {
          return;
        }
      }

      if (listElm) {
        listElm.onscroll = function () {
          if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
            self.setHiddenScroll(module);
          }
        };
      }
    },
    reloadListMedias: function reloadListMedias() {
      var self = this;
      var listElm = document.querySelector('#add-screen-module .default-modules.screens');
      if (self.nb_videos === self.getAllMedias(self.activeModule).length) {
        return;
      }
      if (listElm) {
        listElm.onscroll = function () {
          if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
            self.setHiddenScroll();
          }
        };
      }
    },
    setHiddenScroll: function setHiddenScroll(module) {
      var self = this;
      if (module === 'models' && self.hasPermission('show_models_part_action')) {
        if (self.dispositions.length < self.nb_slides || !self.isEndReached(module)) {
          self.paginate('Disposition');
        }
      } else if (module === 'recents' && self.hasPermission('show_recents_part_action')) {
        if (self.AllScreens.length < self.nb_slides || !self.isEndReached(module)) {
          self.paginate('Screen');
        }
      } else {
        if (!self.oldImages && self.hasPermission('show_images_part_action')) {
          if (self.getAllMedias(self.activeModule).length < self.nb_videos || !self.isEndReachedMedias(self.activeModule)) {
            if (self.hasPermission('show_images_part_action')) self.reloadImageList();
          }
        }
      }
    },
    callLoadMedias: function callLoadMedias(isLoading) {
      if (this.infiniteState) {
        if (this.isEndReachedMedias(this.activeModule)) {
          this.infiniteState.complete();
        } else if (!isLoading) {
          this.infiniteState.loaded();
        }
      }
    },
    haveScreen: function haveScreen(item) {
      if (item.screens) {
        return false; //item.screens.length > 1;
      }
    },
    screenShot: function screenShot(item) {
      if (this.activeModule === 'models' || this.activeModule === 'recents') {
        if (item.screenShot) {
          return item.screenShot ? item.screenShot : '';
        }
      } else {
        if (this.activeModule === 'images') {
          if (!this.oldImages) {
            return this.getThumbnailUrl(item, 'fit', 500) ? this.getThumbnailUrl(item, 'fit', 500) : '';
          } else {
            item.lien ? item.lien : '';
          }
        } else {
          return item.logo ? item.logo : '';
        }
      }
    },
    loadMore: function loadMore($state) {
      //TODO  fix infiniteState
      if (!this.infiniteState) {
        this.infiniteState = $state;
      }
      if (this.activeModule === 'models') {
        if (this.isEndReached('Disposition') && this.infiniteState) {
          this.infiniteState.complete();
          return;
        }
      } else if (this.activeModule === 'recents') {
        if (this.isEndReached('Screen') && this.infiniteState) {
          this.infiniteState.complete();
          return;
        }
      } else {
        if (this.isEndReachedMedias(this.activeModule) && this.infiniteState) {
          this.infiniteState.complete();
          return;
        }
      }
      if ($state) {
        if (this.activeModule === 'models' && this.hasPermission('show_models_part_action')) {
          this.paginate('Disposition');
        } else if (this.activeModule === 'recents' && this.hasPermission('show_recents_part_action')) {
          this.paginate('Screen');
        } else {
          if (!this.oldImages && this.hasPermission('show_images_part_action')) {
            this.reloadImageList();
          }
        }
      }
    },
    changeModule: function changeModule(module) {
      this.activeModule = module;
      this.isActiveModule = true;
      document.querySelector('.search-col').style.display = 'block';

      if (document.querySelector('.infinite-loading-container')) {}
      //document.querySelector('.infinite-loading-container').style.display = 'block';

      // this.searchTitle();
      if (module === 'models') {
        if (this.dispositions.length === 0) {
          this.resetPage('Disposition');
          this.paginate('Disposition');
        }
      } else if (module === 'recents') {
        if (this.AllScreens.length === 0) {
          this.resetPage('Screen');
          this.paginate('Screen');
        }
      } else if (module !== 'empty' && module === 'images') {
        //this.loadMore();
        if (this.all_images.length === 0) {
          this.setMedias('images', []);
          this.resetPageVideos('images');
          if (!this.oldImages) {
            this.reloadImageList();
          } else {
            if (document.querySelector('.infinite-loading-container')) {
              document.querySelector('.infinite-loading-container').style.visibility = 'hidden';
            }
            document.querySelector('.search-col').style.display = 'none';
          }
        }
      }

      __WEBPACK_IMPORTED_MODULE_19__main__["bus"].$emit('displaycreenShot', module);
      if (this.textToSearch) {
        this.searchTitle(true);
      }
    },
    optionsLine: function optionsLine() {
      if (this.paramsClient.default_line) {
        this.options = this.paramsClient.default_line;
        this.ligneTemplate = this.options[0].value;
      }
    },
    showSegmentModal: function showSegmentModal() {
      // this.$router.push({ name: 'segment' });
      this.$router.push({ name: 'EditSegment' });
      this.setRoute('segment');
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.innerHTML = "<span style='font-family:RobotoUep!important;'>" + this.$t('template.save_and_exit') + '</span>';
      }
      this.cancel();
      eventHub.$emit('resetModalSegmentList');
      // this.$root.$emit('bv::show::modal', 'segment-list-modal', '#btnShow');
    },

    // loadMore() {
    //   this.isShown = true;
    // },
    showTab: function showTab(tab) {
      this.selectedTab = tab;
    },
    select: function select(item) {
      var limitAdd = this.getNbSreenSegment();
      var nb_screeen = this.permission.nb_screen_segment;
      var selected = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(item));

      /******************  ROUTE segment    ***************/
      if (this.$route.name === 'segment') {
        //remove Last Slide By Id

        if (this.selectedIds.includes(selected.id)) {
          this.selectedIds = this.selectedIds.filter(function (i) {
            return i !== selected.id;
          });
          this.removeLastSlideById(selected.id);
          this.removeFromListSelected(selected.id);
        } else {
          // Type   models &&  recents
          this.selectedIds.push(selected.id);
          this.disabledConfirmButton = false;
          if (this.activeModule === 'models' || this.activeModule === 'recents' || this.activeModule === 'empty') {
            this.selectSlide(selected);
            this.pushListSelected(selected);
          } else {
            var _src = this.getThumbnailUrl(selected, 'fit', 500);
            var duration = __WEBPACK_IMPORTED_MODULE_16__helpers_duration_handler__["a" /* totalSegmentDuration */]();
            var option = {
              duration: __WEBPACK_IMPORTED_MODULE_16__helpers_duration_handler__["a" /* totalSegmentDuration */]()
            };
            var slide = {
              id: selected.id,
              src: _src,
              title: selected.phototitle,
              logo: selected.logo,
              options: option,
              duration: duration
            };
            if (!this.oldImages) {
              slide.src = this.getThumbnailUrl(selected, 'fit', 500);
              slide.title = selected.phototitle;
            } else {
              if (selected.lien.indexOf('/mini') > -1) {
                slide.src = selected.lien.replace('/mini', '');
              } else {
                slide.src = selected.lien;
              }

              slide.title = selected.title;
            }
            this.selectImage({ selected: slide, type: this.activeModule });
          }
        }
      } else {
        /******************  ROUTE add  ( program )    ***************/
        // remove Last Slide From Segment By Id
        if (this.selectedIds.includes(selected.id)) {
          this.selectedIds = this.selectedIds.filter(function (i) {
            return i !== selected.id;
          });
          this.removeLastSlideFromSegmentById(selected.id);
          this.removeFromListSelected(selected.id);
          this.dragSlide(event, -1, 'add-screen-module');
        } else {
          this.selectedIds.push(selected.id);
          this.disabledConfirmButton = false;
          if (this.activeModule === 'models' || this.activeModule === 'recents' || this.activeModule === 'empty') {
            //this.selectSlide(selected);
            this.appendSlideToSegment(selected);
            this.pushListSelected(selected);
          }
          // Type   Image
          else {
              var _duration = __WEBPACK_IMPORTED_MODULE_16__helpers_duration_handler__["a" /* totalSegmentDuration */]();
              var _option = {
                duration: __WEBPACK_IMPORTED_MODULE_16__helpers_duration_handler__["a" /* totalSegmentDuration */]()
              };
              var _slide = {
                id: selected.id,
                src: src,
                title: selected.phototitle,
                logo: selected.logo,
                options: _option,
                duration: _duration
              };
              if (!this.oldImages) {
                _slide.src = this.getThumbnailUrl(selected, 'fit', 500);
                _slide.title = selected.phototitle;
              } else {
                if (selected.lien.indexOf('/mini') > -1) {
                  _slide.src = selected.lien.replace('/mini', '');
                } else {
                  _slide.src = selected.lien;
                }
                _slide.title = selected.title;
              }
              // this.selectSlide(slide);
              this.appendImageToSegment({ selected: _slide, type: this.activeModule });
              this.pushListSelected(_slide);
            }
          this.dragSlide(event, 1, 'add-screen-module');
        }
      }
      // disabledConfirmButton
      if (this.selectedIds.length < 1) {
        this.disabledConfirmButton = true;
      }
    },
    getThumbnailUrl: function getThumbnailUrl(selectedSegment, type, size) {
      var fileHash = selectedSegment.filehash;
      return "undefined" + 'thumbnails/' + type + '/' + size + '/' + fileHash;
    },
    selectAddedSlide: function selectAddedSlide(segment, slide) {
      var _this2 = this;

      if (segment.uid !== this.currentSegment.uid) {
        return;
      }
      var editor = grapesjsEMP.editors[0];
      var wrapper = editor.DomComponents.getWrapper();
      // editor.select(wrapper);
      setTimeout(function () {
        var lastSlide = {
          uid: _this2.currentSlide.uid,
          components: localStorage.getItem('gjs-components'),
          js: localStorage.getItem('gjs-js'),
          html: localStorage.getItem('gjs-html'),
          css: _this2.sanitizeCSS(localStorage.getItem('gjs-css')),
          styles: localStorage.getItem('gjs-styles')
        };
        _this2.updateSlideInsideSegment(lastSlide);
        _this2.generateSlideThmbnail(_this2.currentSlide.uid);
        setTimeout(function () {
          //Set Current Screen
          _this2.setCurrentSlide(slide);
          //Set Current Segment by Screen
          _this2.setCurrentSegment(segment);
          _this2.$root.$emit('updateCanvasContent');
          _this2.setNoAutoplayVideo(editor);
          var videoPlayers = ['player', 'playlist'];
          videoPlayers.forEach(function (player) {
            _this2.setPausedVideo(player);
          });
          if (_this2.paramsClient.display_default_blocks && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(_this2.paramsClient.display_default_blocks).length > 0) {
            var blocks = document.querySelector('#gjs .gjs-pn-buttons .fa-th-large:not(.gjs-pn-active)');
            if (blocks) {
              blocks.click();
            }
          }
        }, 100);
      }, 100);
    },
    confirm: function confirm() {
      var _this3 = this;

      var editor = grapesjsEMP.editors[0];
      var self = this;
      this.selected.map(function (s) {
        return _this3.total += s.options.duration;
      });

      // Segment
      var segment = {
        screensToSubmit: this.selected,
        duration: self.totalDurationScreens,
        uid: Math.floor(new Date().valueOf() * Math.random())
      };
      // this.selectMedias({ selected: slide, type: this.activeModule });
      var newSegment = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, segment, this.currentSegment);
      self.setCurrentSegment(newSegment);
      var psElement = document.getElementById('ps-slide-wrapper');
      try {
        var DraggableElement = document.getElementById('draggable-wrapper');
        psElement.scrollLeft = DraggableElement.offsetWidth;
      } catch (e) {}

      if (this.$route.name === 'segment') {
        // nb_screen_segment = 1 , on doit afficher le titre de segment dans le card et dans le panel
        var nb_screeen_param = this.paramsClient.nb_screen_segment;
        /*if (parseInt(nb_screeen_param) === 1) {
          this.changeTitleInSelected(
            this.titleSegment !== '' ? this.titleSegment : this.$t('panels.newSegment'),
          );
          this.setCurrentSlide(this.selectedIds[0]);
        }*/
        this.FirstSlide();
      } else if (this.selectedIds.length > 0) {
        this.selectAddedSlide(this.lastUpdatedSegment, this.lastUpdatedSegment.screens[this.lastUpdatedSegment.screens.length - 1]);
      }

      this.selectedIds = [];
      eventHub.$emit('setShowAddScreen', false);

      self.setNbrCall();
      //ButtonDisabled for the next call
      this.disabledConfirmButton = true;
      ///new
      this.setNoAutoplayVideo(editor);
      var videoPlayers = ['player', 'playlist'];
      videoPlayers.forEach(function (player) {
        _this3.setPausedVideo(player);
      });

      //reset List in panel
      this.resetListSelected();
      this.updateCanvasDimensions();
      setTimeout(function () {
        if (_this3.paramsClient.display_default_blocks && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(_this3.paramsClient.display_default_blocks).length > 0) {
          var blocks = document.querySelector('#gjs .gjs-pn-buttons .fa-th-large:not(.gjs-pn-active)');
          if (blocks) {
            blocks.click();
          }
        }
      }, 100);
    },
    FirstSlide: function FirstSlide() {
      var lastSlide = {
        uid: this.currentSlide.uid,
        components: localStorage.getItem('gjs-components'),
        js: localStorage.getItem('gjs-js'),
        html: localStorage.getItem('gjs-html'),
        css: this.sanitizeCSS(localStorage.getItem('gjs-css')),
        styles: localStorage.getItem('gjs-styles')
      };
      this.updateSlide(lastSlide);

      this.generateSlideThmbnail(lastSlide.uid);
      var slide = this.firstSelectedSlide(this.selectedIds[0]);
      this.setCurrentSlide(slide);
      this.$root.$emit('updateCanvasContent');
    },
    cancel: function cancel() {
      var _this4 = this;

      this.selectedIds.forEach(function (id) {
        // remove select slide   ( add new segment  )
        _this4.removeLastSlideById(id);
        // remove select slide  ( panelpage : add screens to segment )
        _this4.removeLastSlideFromSegmentById(id);
      });
      this.selectedIds = [];
      this.resetListSelected();
      if (this.$route.params.type === 'NewSegment' && this.nbrCall === 1) {
        this.$router.push({ name: 'AddSegment' });
      }
      eventHub.$emit('setShowAddScreen', false);
    },
    searchTitle: function searchTitle(x) {
      var title = '';
      if (x) {
        title = this.textToSearch;
        this.setTitle(title);
        this.setTitleMedias(title);
        if (this.activeModule === 'models' && this.hasPermission('show_models_part_action')) {
          this.setDispositions([]);
          this.resetPage('Disposition');
          this.paginate('Disposition');
        } else if (this.activeModule === 'recents' && this.hasPermission('show_recents_part_action')) {
          this.setDispositions([]);
          this.resetPage('Screen');
          this.paginate('Screen');
        } else {
          if (this.hasPermission('show_images_part_action')) {
            this.setMedias({ type: this.activeModule, medias: [] });
            this.resetPageVideos(this.activeModule);
            if (!this.oldImages) {
              this.reloadImageList();
            }
          }
        }
      } else {
        this.textToSearch = '';
        this.activeModule = this.tabsArray[0];
        this.setTitle(title);
        this.setTitleMedias(title);
        if (this.hasPermission('show_models_part_action')) {
          this.setDispositions([]);
          this.resetPage('Disposition');
          this.paginate('Disposition');
        }
        if (this.hasPermission('show_recents_part_action')) {
          this.setDispositions([]);
          this.resetPage('Screen');
          this.paginate('Screen');
        }
        if (this.hasPermission('show_images_part_action')) {
          this.setMedias({ type: 'images', medias: [] });
          this.resetPageVideos('images');
          this.reloadVideoList();
          if (!this.oldImages) {
            this.reloadImageList();
          }
        }
      }
    },
    setButtonCancel: function setButtonCancel(cancel) {
      this.hideCancelButton = cancel;
    },
    getScreens: function getScreens(segment) {
      return segment.screens.filter(function (s) {
        return s.type.toLowerCase().indexOf('generic') + s.type.toLowerCase().indexOf('blank') === -2;
      });
    },
    removeSmoothing: function removeSmoothing(event) {
      if (event) {
        this.$refs.ps.$el.style['scroll-behavior'] = 'auto';
      }
    },
    reorder: function reorder(event) {
      this.reorderSegments(event);
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    },
    reorderSlides: function reorderSlides(event, index) {
      this.reorderSlidesInsideSegment({ event: event, index: index });
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    }
  }),
  mounted: function mounted() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var self, blocks;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              //this.reloadVideoList();
              self = _this5;

              if (_this5.paramsClient.display_default_blocks !== null || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(_this5.paramsClient.display_default_blocks).length > 0) {
                blocks = _this5.paramsClient.display_default_blocks.map(function (block) {
                  return block.blocks;
                });

                blocks.forEach(function (item, index) {
                  for (var i = 0; i < item.length; i++) {
                    if (item[i].indexOf('image') > -1) {
                      self.oldImages = true;
                    }
                  }
                });
              }
              if (!self.oldImages && _this5.hasPermission('show_images_part_action')) {
                _this5.reloadImageList();
              }
              _this5.titleSegment = _this5.$t('panels.newSegment');

              _this5.$root.$emit('displaycreenShot', _this5.activeModule);
              _this5.$root.$on('updateScrollInterval', function (obj) {
                _this5.dragSlide(obj.event, obj.position, 'add-screen-module');
              });
              _this5.optionsLine();
              document.querySelector('.timeline-modules #ps-slide-wrapper').addEventListener('mouseover', _this5.removeSmoothing);
              eventHub.$on('setShowAddScreen', function (val) {
                _this5.selecteIdSegment = [];
                _this5.hideCancelButton = !val;
                _this5.disabledConfirmButton = val;
                _this5.activeModule = _this5.tabsArray[0];
                _this5.setActiveScrollButtons();
              });

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this5);
    }))();
  },
  created: function created() {
    var self = this;
    eventHub.$on('stopProgress', function (val) {
      self.$refs.topProgress.done();
    });
    eventHub.$on('saveSelect', this.select);
    eventHub.$on('hideCancelButton', this.setButtonCancel);
  }
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_http_http_token__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_router_router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_Mixin_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_GrapesMixinHelpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_PostCssVw__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_GrapesMixinEditors_js__ = __webpack_require__(48);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_Mixin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_GrapesMixinHelpers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_PostCssVw__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_GrapesMixinEditors_js__["a" /* default */]],

  name: 'Card',
  props: {
    index: '',
    title: '',
    author: '',
    keyWords: '',
    Shot: '',
    item: Object,
    haveScreen: Boolean,
    isSelected: Boolean,
    isCollapse2: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: true
    },
    isHover: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      listSlides: [],
      selectedIds: [],
      selected: '0',
      screenShot: 'data:image/png;base64,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',
      isEditMode: false,
      titleSlide: this.item.title,
      indexDropDown: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    indexDelete: 'segments/getDeletedSegmentIndex',
    paramsClient: 'getParamsClients'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('common', ['setShowIconSave']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('slides', ['setCurrentSlide', 'selectSlide', 'resetSelect', 'updateSlide']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('segments', ['setCurrentSegmentTitle', 'updateMetadataSegment', 'setfromRouteBiblio', 'getSegment', 'setScreensTosubmitSegment', 'duplicateBiblioSegment', 'removeSegmentByUid', 'setfromRouteAdd', 'getAuteurs', 'getSegments', 'paginatesegment', 'selectSegment', 'setCurrentSegment', 'removeLastSegmentById', 'updateSegment', 'setTitle', 'resetPage', 'setSegments', 'setNbrCall', 'updateSlideInsideSegment', 'deleteOneSegmentById', 'deleteSegmentByIdStore', 'pushSegments', 'cancelDelete']), {
    createdPar: function createdPar() {
      return this.item.author.firstName;
    },
    mouseOver: function mouseOver() {
      this.indexDropDown++;
    },
    editSegment: function editSegment(item) {
      this.setCurrentSegment(item);
      this.setfromRouteAdd(false);
      this.$router.push({ name: 'EditSegment', params: { id: item.id } });
      var obj = { EditSegment: true, id: item.id };
      parent.postMessage(obj, '*');
    },
    updateSegmentInGrapes: function updateSegmentInGrapes(item, index) {
      var _this = this;

      var iconSave = document.querySelector('.icon-save');
      this.setfromRouteBiblio(true);
      this.setCurrentSegment(item);
      this.listSlides = this.currentSegment.screens;
      this.resetSelect();
      this.listSlides.forEach(function (selected) {
        _this.selectedIds.push(selected.id);
        //for select
        _this.setCurrentSlide(selected);
        _this.selectSlide(selected);
      });

      this.$router.push({ name: 'segment', params: { type: 'EditSegment', indexSegment: index } });
      this.setShowIconSave(false);
      if (iconSave) {
        iconSave.innerHTML = "<span style='font-family:RobotoUep!important;'>" + this.$t('template.save_and_exit') + '</span>';
        iconSave.classList.remove('icon-selected');
      }

      this.updateCanvasDimensions();
    },
    showSlides: function showSlides(item) {
      this.setCurrentSegment(item);
      eventHub.$emit('showScreen', true);
      this.$root.$emit('bv::show::modal', 'modal-slides', '#a-slides');
    },
    duplicateThis: function duplicateThis(segment, index) {
      var item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, segment);
      var nb = 1;
      var indexOf = item.title.search(/\(copie/i);
      var newTitel = '';
      if (indexOf !== -1) {
        var text = segment.title.substring(segment.title.length, indexOf);
        var originTiel = segment.title.substring(indexOf, 0);

        text = text.match(/\d/g);
        if (text && text !== '') nb += parseInt(text.join(''));

        newTitel = originTiel + '(copie' + nb + ')';
      }
      var self = this;
      setTimeout(function () {
        var duration = 0;
        var screensToSubmit = item.screens.map(function (s) {
          duration += s.options.duration;
          var css = self.fontSizeToVw(s.css);
          css = self.widthHeightToViewport(css);
          var html = self.animationAttributesToClass(s.html);

          var transition = null;
          if (s.options.transition !== 'undefined' && s.options.transition !== '') transition = s.options.transition ? s.options.transition : null;
          self.setScreensTosubmitSegment({
            id: s.id,
            template: self.cmdInlineHtml(self.getSanitizedHtml(html), css),
            type: 'Screen' ? 'Disposition' : s.type,
            transition: transition,
            screenShot: s.screenShot
          });
          /*s.template = self.cmdInlineHtml(self.getSanitizedHtml(html), css);
          s.type = s.type === 'Screen' ? 'Disposition' : s.type;
          s.template = self.cmdInlineHtml(self.getSanitizedHtml(html), css);
          s.options.transition = s.transition;
          s.screenShot = '';*/
          return s;
        });
        var themesIdList = [];
        if (self.item.themes !== null && self.item.themes !== '') {
          self.item.themes.forEach(function (t) {
            themesIdList.push(t.id);
          });
        }
        var authorId = null;
        if (self.item.author) authorId = self.item.author.id;
        var key = '';
        if (self.item.keyWords !== null && self.item.keyWords !== '') if (self.item.keyWords.isArray) {
          key = self.item.keyWords.join();
        }
        var data = {
          screensToSubmit: screensToSubmit,
          title: newTitel ? newTitel : self.item.title + '(copie)',
          duration: duration ? self.SecToTime(duration) : '00:00:30',
          author: authorId,
          keyWords: key ? key : null,
          description: self.item.description ? self.item.description : null,
          themes: themesIdList ? themesIdList : null
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_http_http_token__["a" /* HTTP */])(window.ApiToken).post(__WEBPACK_IMPORTED_MODULE_4__core_router_router__["a" /* default */].generate('api_segmentDisplay_post_add_segment'), {
          id: null,
          data: data,
          client: self.paramsClient.client
        }).then(function (response) {
          if (response.data.code === 200) {
            self.$toasted.show('Segment dupliqué', {
              theme: 'bubble',
              position: 'top-center',
              duration: 3000,
              icon: 'fa-check-circle',
              className: 'save-toast'
            });

            var _segment = {
              screens: screensToSubmit,
              title: self.item.title,
              duration: self.timeToSec(data.duration),
              type: 'DefaultSegment',
              id: response.data.segmentId,
              author: self.item.author ? self.item.author : null,
              keyWords: self.item.keyWords ? self.item.keyWords : null,
              description: self.item.description ? self.item.description : null,
              themes: self.item.themes ? self.item.themes : null
            };
            self.duplicateBiblioSegment({ segment: _segment, index: index });
            self.$router.push({ name: 'ListSegment' });
          }
        }, function (error) {
          console.error(error);
        });
      }, 100);
    },
    handleDelete: function handleDelete(item) {
      var _this2 = this;

      var cancel = false;
      var indexDelete = this.indexDelete(item);

      this.$swal.fire({
        title: this.$t('modal.delete.title'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#f44336',
        cancelButtonColor: '#2196F3',
        confirmButtonText: this.$t('modal.delete.btn_confirm'),
        cancelButtonText: this.$t('modal.delete.btn_cancel'),
        customClass: 'swal-delete'
      }).then(function (result) {
        if (result.value) {
          _this2.$swal.fire({
            title: 'Supprimé!',
            type: 'success',
            showConfirmButton: false,
            timer: 2000
          });
          _this2.deleteSegmentByIdStore(item);
          _this2.deleteOneSegmentById(item);
        }
      });

      /*
      this.$toasted.show(this.$t('biblioSegment.textDelete'), {
        theme: 'bubble',
        position: 'top-center',
        duration: 4000,
        action: [
          {
            text: 'Annuler',
            onClick: (e, toastObject) => {
              setTimeout(() => {
                this.cancelDelete({ segment: item, index: indexDelete });
                cancel = true;
              }, 100);
               toastObject.goAway(0);
            },
          },
          {
            text: 'X',
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
        ],
      });
      setTimeout(() => {
        if (!cancel) this.deleteOneSegmentById(item);
      }, 4500);
      */
    }
  })
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_select__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_Mixin_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_GrapesMixinHelpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_fr_FR__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_en_US__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_select_dist_vue_select_css__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_select_dist_vue_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_select_dist_vue_select_css__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_Mixin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_GrapesMixinHelpers__["a" /* default */]],
  i18n: {
    messages: {
      en: __WEBPACK_IMPORTED_MODULE_9__i18n_en_US__["a" /* default */],
      fr: __WEBPACK_IMPORTED_MODULE_8__i18n_fr_FR__["a" /* default */]
    }
  },
  name: 'EditSegment',
  data: function data() {
    return {
      colorBtn: 'rgb(3,155,229)',

      segmentData: '',
      authorId: '',
      themeId: '',
      title: __WEBPACK_IMPORTED_MODULE_7__i18n__["a" /* default */].t('biblioSegment.placeholder-title'),
      listAuthor: '',
      keyWords: '',
      description: '',
      listSlides: [],
      selectedIds: [],
      keyupEvent: false
    };
  },

  components: {
    'v-select': __WEBPACK_IMPORTED_MODULE_4_vue_select___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    getmaxLength: 'common/getmaxLength',
    selectedSegments: 'segments/getSelectedSegments',
    currentSegment: 'segments/getCurrent',
    paramsClient: 'getParamsClients',
    hasPermission: 'hasPermission',
    getAuteursList: 'segments/getAuteursList',
    routeAdd: 'segments/getFromRouteAdd',
    getThemesList: 'segments/getThemesList',
    currentSlide: 'slides/getCurrent'
  }), {
    getTitleSegment: function getTitleSegment() {
      return this.title;
    },
    stateTitle: function stateTitle() {
      var state = this.title.length >= 1 ? true : false;
      if (state) return null;else return state;
    },
    themeList: function themeList() {
      var list = [];

      if (this.getThemesList) {
        this.getThemesList.forEach(function (t) {
          var o = {};
          o.label = t.name ? t.name : t.title;
          o.code = t.id;
          list.push(o);
        });
      }

      return list;
    },
    auteursList: function auteursList() {
      var list = [];
      if (this.getAuteursList) {
        this.getAuteursList.forEach(function (t) {
          var o = {};
          o.label = t.name;
          o.code = t.id;
          list.push(o);
        });
      }

      return list;
    },
    getColorBtn: function getColorBtn() {
      if (this.$route.query.color) {
        this.colorBtn = this.$route.query.color;
      }

      return { '--primary-color': this.colorBtn };
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var self, urlParams, color, getName, modelAuthor, modelTheme, key, inputText;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = _this;
              urlParams = new URLSearchParams(window.location.color);
              color = urlParams.get('color') ? urlParams.get('color') : 'rgb(3,155,229)';

              _this.colorBtn = color;

              _this.setThemes();
              _this.getAuteurs();

              if (!(_this.$route.name === 'EditSegment')) {
                _context.next = 18;
                break;
              }

              _context.next = 9;
              return _this.getSegment(_this.$route.params.id);

            case 9:

              //if (!this.routeAdd) {
              _this.listAuthor = _this.getAuteursList;
              if (_this.currentSegment.author) {
                getName = '';

                if (_this.currentSegment.author.firstName) {
                  getName = _this.currentSegment.author.firstName + ' ' + _this.currentSegment.author.lastName;
                } else getName = _this.currentSegment.author.name;

                modelAuthor = {};

                modelAuthor.label = getName;
                modelAuthor.code = _this.currentSegment.author.id;
                _this.authorId = modelAuthor;
              }

              if (_this.currentSegment.themes) {
                modelTheme = [];

                _this.currentSegment.themes.forEach(function (t) {
                  var model = {};
                  model.label = t.name ? t.name : t.title;
                  model.code = t.id;
                  modelTheme.push(model);
                });
                _this.themeId = modelTheme;
              }
              _this.title = _this.currentSegment.title;

              if (typeof _this.currentSegment.keyWords === 'string' || _this.currentSegment.keyWords instanceof String) {
                key = _this.currentSegment.keyWords.split(',');

                if (key[0] !== '') _this.keyWords = key;
              } else _this.keyWords = _this.currentSegment.keyWords ? _this.currentSegment.keyWords : null;

              _this.listSlides = _this.currentSegment.screens;
              _this.description = _this.currentSegment.description;
              _context.next = 19;
              break;

            case 18:
              if (_this.$route.name === 'AddSegment') {
                inputText = document.getElementById('input-title');


                if (inputText) {
                  inputText.addEventListener('focus', function (e) {
                    if (self.keyupEvent && self.title !== '' && e.event.target !== '') {
                      return;
                    }
                    self.title = '';
                  });

                  inputText.addEventListener('keyup', function (event) {
                    self.title = event.target.value;
                    self.keyupEvent = true;
                  });
                }
              }

            case 19:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('common', ['setShowIconSave']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('segments', ['setCurrentSegment', 'setCurrentSegmentTitle', 'updateMetadataSegment', 'setThemes', 'getAuteurs', 'setfromRouteBiblio', 'getSegment']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('slides', ['setCurrentSlide', 'selectSlide', 'resetSelect', 'updateSlide']), {
    backToList: function backToList() {
      this.$router.push({ name: 'ListSegment' });
      var obj = { ListSegment: true };
      parent.postMessage(obj, '*');
    },
    updateSegment: function updateSegment() {
      var _this2 = this;

      if (this.title) {
        var themesIdList = [];
        var themesObject = [];
        if (this.themeId) {
          this.themeId.forEach(function (t) {
            themesIdList.push(t.code);
            var object = _this2.getThemesList.filter(function (x) {
              return x.id === t.code;
            });
            if (object) themesObject.push(object[0]);
          });
        }
        var key = '';
        if (this.keyWords !== '' && this.keyWords !== null) {
          key = this.keyWords.join();
        }
        this.setCurrentSegmentTitle(this.title);
        this.updateMetadataSegment(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.currentSegment, {
          title: this.title,
          author: this.authorId.code,
          keyWords: key,
          description: this.description,
          themes: themesIdList,
          Objectthemes: themesObject,
          ObjectAuthor: this.getAuteursList.filter(function (x) {
            return x.id === _this2.authorId.code;
          })[0]
        }));

        this.$router.push({ name: 'ListSegment' });
      }
    },
    NewSegment: function NewSegment() {
      var _this3 = this;

      var iconSave = document.querySelector('.icon-save');
      if (this.title) {
        var themesIdList = [];
        var themesObject = [];
        if (this.themeId) {
          this.themeId.forEach(function (t) {
            themesIdList.push(t.code);
            var object = _this3.getThemesList.filter(function (x) {
              return x.id === t.code;
            });
            if (object) themesObject.push(object[0]);
          });
        }
        this.setfromRouteBiblio(true);
        var segment = {
          title: this.title,
          author: this.getAuteursList.filter(function (x) {
            return x.id === _this3.authorId.code;
          })[0],
          keyWords: this.keyWords,
          description: this.description,
          //uid: Math.floor(new Date().valueOf() * Math.random()),
          themes: themesObject
        };
        this.resetSelect();
        this.setCurrentSegment(segment);
        this.$router.push({ name: 'segment', params: { type: 'NewSegment' } });
        this.setShowIconSave(true);
        if (iconSave) {
          iconSave.innerHTML = "<span style='font-family:RobotoUep!important;'>" + this.$t('template.save_and_exit') + '</span>';
          iconSave.classList.remove('icon-selected');
        }
      }
      this.updateCanvasDimensions();
    }
  })
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_en_US__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_fr_FR__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_Mixin_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_carousel__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_GrapesMixinHelpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Modal_SegmentList_vue__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Modal_SegmentList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Modal_SegmentList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_top_progress__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_top_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_top_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__core_directives_HasPermission_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_duration_handler__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Card_vue__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Card_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__Card_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__NotFoundCard__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__NotFoundCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__NotFoundCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_infinite_loading__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__screenInSegment__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__screenInSegment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__screenInSegment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_select__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_select_dist_vue_select_css__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_select_dist_vue_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_select_dist_vue_select_css__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ListSegment',
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_Mixin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_GrapesMixinHelpers__["a" /* default */]],
  directives: {
    HasPermission: __WEBPACK_IMPORTED_MODULE_12__core_directives_HasPermission_js__["a" /* default */]
  },
  data: function data() {
    return {
      colorBtn: 'rgb(3,155,229)',
      isOpen: false,
      authorModel: '',
      themeModel: '',
      clicksOut: true,
      showCollapse: false,
      navparam: true,
      selectedTab: '',
      infiniteState: null,
      selectedIds: [],
      selecteIdSegment: [],
      showNotFoundCard: false,
      titleTemplate: this.$t('template.new_template'),
      total: 0,
      hideCancelButton: true,
      disabledConfirmButton: true,
      duration: 59,
      currentTheme: '',
      oldTheme: '',

      screenShot: 'data:image/png;base64,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',
      currentShot: 'data:image/png;base64,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',
      showScreen: false
    };
  },

  components: {
    vueTopprogress: __WEBPACK_IMPORTED_MODULE_11_vue_top_progress__["vueTopprogress"],
    Carousel: __WEBPACK_IMPORTED_MODULE_8_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_8_vue_carousel__["Slide"],
    SegmentList: __WEBPACK_IMPORTED_MODULE_10__Modal_SegmentList_vue___default.a,
    'card-segment': __WEBPACK_IMPORTED_MODULE_14__Card_vue___default.a,
    'not-found': __WEBPACK_IMPORTED_MODULE_15__NotFoundCard___default.a,
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_16_vue_infinite_loading___default.a,
    screenInSegment: __WEBPACK_IMPORTED_MODULE_17__screenInSegment___default.a,
    'v-select': __WEBPACK_IMPORTED_MODULE_18_vue_select___default.a
  },
  i18n: {
    messages: {
      en: __WEBPACK_IMPORTED_MODULE_5__i18n_en_US__["a" /* default */],
      fr: __WEBPACK_IMPORTED_MODULE_6__i18n_fr_FR__["a" /* default */]
    }
  },
  watch: {
    isLoading: function isLoading(_isLoading) {
      if (this.infiniteState) {
        if (this.isEndReached('DefaultSegment')) {
          this.infiniteState.complete();
        } else if (!_isLoading) {
          this.infiniteState.loaded();
        }
      }
    },
    DefaultSegments: function DefaultSegments(segments) {
      if (segments.length === 0 && this.infiniteState) {
        if (!this.isLoading) {
          this.loadMoreSegments();
        }
        this.infiniteState.reset();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    //recentsSegment:'segments/getAllSegments',
    screens: 'slides/getAllScreens',
    currentSlide: 'slides/getCurrent',
    dispositions: 'slides/getAllDispositions',
    all: 'segments/getSegments',
    segments: 'segments/getAllSegments',
    DefaultSegments: 'segments/getAllDefaultSegments',
    isLoading: 'segments/getLoading',
    isEndReached: 'segments/getEndReached',
    selected: 'slides/getSelected',
    selectedSegments: 'segments/getSelectedSegments',
    currentSegment: 'segments/getCurrent',
    isSelected: 'slides/isSelected',
    firstSelectedSegment: 'segments/getLastSegmentById',
    showIconSave: 'common/getShowIconSave',
    paramsClient: 'getParamsClients',
    hasPermission: 'hasPermission',
    totalDurationSegments: 'segments/getAllSegmentsDuration',
    getThemesList: 'segments/getThemesList',
    getAuteursList: 'segments/getAuteursList'
  }), {
    getColorBtn: function getColorBtn() {
      if (this.$route.query.color) {
        this.colorBtn = this.$route.query.color;
      }

      return { '--primary-color': this.colorBtn };
    },
    themeList: function themeList() {
      var list = [];
      this.getThemesList.forEach(function (t) {
        var o = {};
        o.label = t.name ? t.name : t.title;
        o.code = t.id;
        list.push(o);
      });
      return list;
    },
    auteursList: function auteursList() {
      var list = [];
      this.getAuteursList.forEach(function (t) {
        var o = {};
        o.label = t.name;
        o.code = t.id;
        list.push(o);
      });
      return list;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('slides', ['paginate', 'selectSlide', 'setCurrentSlide', 'removeLastSlideById', 'updateSlide', 'fetch', 'setTemplate']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('segments', ['setThemeid', 'setAuthorid', 'setThemes', 'setfromRouteAdd', 'getSegments', 'paginatesegment', 'selectSegment', 'setCurrentSegment', 'removeLastSegmentById', 'updateSegment', 'setTitle', 'resetPage', 'setSegments', 'setEndReached', 'setNbrCall', 'updateSlideInsideSegment', 'getAuteurs']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('common', ['setShowIconSave']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['setRoute']), {
    loadMoreSegments: function loadMoreSegments($state) {
      if (!this.infiniteState) {
        this.infiniteState = $state;
      }
      if (this.isEndReached('DefaultSegment')) {
        this.infiniteState.complete();
        return;
      }

      this.paginatesegment('DefaultSegment');
    },
    openMenu: function openMenu() {
      if (!this.isOpen) {
        document.querySelector('.card-theme-segment').style.display = 'none';
      } else document.querySelector('.card-theme-segment').style.display = 'block';

      this.isOpen = !this.isOpen;
    },
    onResize: function onResize() {
      if (window.innerWidth > 1000) {
        document.querySelector('.card-theme-segment').style.display = 'block';
        this.isOpen = true;
      } else {
        document.querySelector('.card-theme-segment').style.display = 'none';
        this.isOpen = true;
      }
    },
    searchOption: function searchOption() {
      this.showCollapse = !this.showCollapse;
      if (this.themeModel) {
        this.currentTheme = ' > ' + this.themeModel.label;
      }
      this.setSegments([]);
      this.setEndReached({ type: 'DefaultSegment', endReached: false });
      var title = document.getElementById('inputSearch').value;
      this.setTitle(title);
      this.setThemeid(this.themeModel.code);
      this.setAuthorid(this.authorModel.code);
      this.resetPage('DefaultSegment');
      this.paginatesegment('DefaultSegment');
      this.themeModel = '';
      this.authorModel = '';
    },
    allSegmentsSearch: function allSegmentsSearch() {
      this.currentTheme = '';
      this.setSegments([]);
      this.setEndReached({ type: 'DefaultSegment', endReached: false });
      this.setAuthorid(null);
      this.setThemeid(null);
      this.setTitle(null);
      this.resetPage('DefaultSegment');
      this.paginatesegment('DefaultSegment');
    },
    setTheme: function setTheme(theme) {
      if (theme === this.oldTheme) {
        return;
      }
      this.currentTheme = ' > ' + theme.name;
      this.setAuthorid(null);
      this.setTitle(null);
      this.setSegments([]);
      this.setEndReached({ type: 'DefaultSegment', endReached: false });
      this.setThemeid(theme.id);
      this.resetPage('DefaultSegment');
      this.paginatesegment('DefaultSegment');
    },
    loadMore: function loadMore() {
      this.isShown = true;
    },
    showTab: function showTab(tab) {
      this.selectedTab = tab;
    },
    select: function select(item) {
      var selected = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(item));
      if (this.selectedIds.includes(selected.id)) {
        this.selectedIds = this.selectedIds.filter(function (i) {
          return i !== selected.id;
        });
        this.removeLastSlideById(selected.id);
      } else {
        this.selectedIds.push(selected.id);
        this.selectSlide(selected);
      }
    },
    searchTitle: function searchTitle() {
      // this.$refs.topProgress.start();
      var title = document.getElementById('inputSearch').value;
      this.setSegments([]);
      this.setTitle(title);
      this.resetPage('DefaultSegment');
      this.paginatesegment('DefaultSegment');
    },
    addnewsegment: function addnewsegment() {
      this.setCurrentSegment(null);
      this.setfromRouteAdd(true);

      // Keep the host page's own state in sync.
      var obj = { AddSegment: true };
      parent.postMessage(obj, '*');

      // This component is shared by both entry points. The main app (index.html)
      // owns the editor, so a normal push completes the flow there and keeps the
      // store mutations above intact. The segment app (index_segment.html) has no
      // 'segment' route and so nothing to hand "Suivant" over to, leaving the user
      // stuck; per _redirects, /display/add-segment/* is served by the main app, so
      // hand over with a real navigation instead of dead-ending.
      var canOpenEditor = this.$router.options.routes.some(function (r) {
        return r.name === 'segment';
      });
      if (canOpenEditor) {
        this.$router.push({ name: 'AddSegment' });
      } else {
        window.location.href = '/display/add-segment/' + this.$route.params.cryptext + window.location.search;
      }
    },

    //--------
    showThis: function showThis(item) {
      this.currentShot = item.screenShot ? item.screenShot : this.screenShot;
    },
    getScreens: function getScreens() {
      if (this.currentSegment && this.currentSegment.screens !== undefined) {
        this.exist = true;
        var screens = this.currentSegment.screens;
        return screens && screens.filter(function (s) {
          return !s.type.toLowerCase().includes('generic');
        });
      }
    },
    closeScreens: function closeScreens() {
      document.querySelector('#list-screens').style.display = 'none';
      this.showScreen = false;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var urlParams, color;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setThemes();
              _this.getAuteurs();
              urlParams = new URLSearchParams(window.location.color);
              color = urlParams.get('color') ? urlParams.get('color') : 'rgb(3,155,229)';

              _this.colorBtn = color;

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  created: function created() {
    var _this2 = this;

    window.addEventListener('resize', this.onResize);

    var self = this;
    eventHub.$on('notFound', function (val) {
      _this2.showNotFoundCard = val;
    });
    eventHub.$on('showScreen', function (val) {
      _this2.showScreen = val;
    });
  }
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotFoundCard'
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_carousel__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Card_vue__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Card_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Card_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'screenInSegment',
  props: {
    current: Object
  },
  data: function data() {
    return {
      screenShot: 'data:image/png;base64,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',
      currentShot: '',
      exist: false
    };
  },

  components: {
    Carousel: __WEBPACK_IMPORTED_MODULE_2_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_2_vue_carousel__["Slide"],
    'card-segment': __WEBPACK_IMPORTED_MODULE_3__Card_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    currentSegment: 'segments/getCurrent'
  })),
  watch: {
    currentSegment: function currentSegment(val) {
      if (val) {
        if (val.screens[0].screenShot === null || val.screens[0].screenShot === '') this.currentShot = this.screenShot;else this.currentShot = val.screens[0].screenShot;
      }
    }
  },
  mounted: function mounted() {
    if (this.currentSegment && this.currentSegment.screens !== undefined && this.currentSegment.screens.length > 1) {
      var firstScreen = this.currentSegment.screens[0].screenShot;
      this.currentShot = firstScreen ? firstScreen : this.screenShot;
    }
  },

  methods: {
    showThis: function showThis(item) {
      this.currentShot = item.screenShot ? item.screenShot : this.screenShot;
    },
    getScreens: function getScreens() {
      if (this.currentSegment && this.currentSegment.screens !== undefined) {
        this.exist = true;
        var screens = this.currentSegment.screens;
        return screens && screens.filter(function (s) {
          return !s.type.toLowerCase().includes('generic');
        });
      }
    },
    closeScreens: function closeScreens() {
      this.$root.$emit('bv::hide::modal', 'modal-slides', '#x-btn');
    }
  }
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_directives_HasPermission_js__ = __webpack_require__(30);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Save',
  directives: {
    HasPermission: __WEBPACK_IMPORTED_MODULE_2__core_directives_HasPermission_js__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('common', ['setShowSave', 'setSaveVideo']), {
    saveAs: function saveAs() {
      this.setShowSave(true);
    },
    saveVideo: function saveVideo() {
      this.setSaveVideo(true);
    }
  })
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__storages_js__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Panel_PanelTitlePages_vue__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Panel_PanelTitlePages_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Panel_PanelTitlePages_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Panel_panelFitScreen_vue__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Panel_panelFitScreen_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Panel_panelFitScreen_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Panel_PanelPages_vue__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Panel_PanelPages_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Panel_PanelPages_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Panel_PanelWrapper_vue__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Panel_PanelWrapper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Panel_PanelWrapper_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modal_SlideList_vue__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modal_SlideList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Modal_SlideList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Modal_SegmentList_vue__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Modal_SegmentList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Modal_SegmentList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ModuleList__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ModuleList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ModuleList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AddScreen__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AddScreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__AddScreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Modal_ListVideo_vue__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Modal_ListVideo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Modal_ListVideo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ListGenericVideo__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ListGenericVideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_ListGenericVideo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Modal_SaveTemplate_vue__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Modal_SaveTemplate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Modal_SaveTemplate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_GrapesWrapper__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_GrapesWrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_GrapesWrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_DropDown_Save_vue__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_DropDown_Save_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_DropDown_Save_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__i18n_index_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Modal_SettingComponent__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Modal_SettingComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__Modal_SettingComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Modal_EditorImageComponent__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Modal_EditorImageComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__Modal_EditorImageComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mixins_Mixin__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Modal_EditorSvgMatorComponent__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Modal_EditorSvgMatorComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__Modal_EditorSvgMatorComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Informations__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Informations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__Informations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__InformationsCanvas__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__InformationsCanvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__InformationsCanvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Modal_AddGeneric__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Modal_AddGeneric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__Modal_AddGeneric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Modal_ExitSave__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Modal_ExitSave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__Modal_ExitSave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Modal_ExtendSegmentDuration__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Modal_ExtendSegmentDuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__Modal_ExtendSegmentDuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__i18n_en_US__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__i18n_fr_FR__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__main__ = __webpack_require__(73);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
































/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'editor',
  mixins: [__WEBPACK_IMPORTED_MODULE_19__mixins_Mixin__["a" /* default */]],
  data: function data() {
    return {
      colorBtn: '',
      FromAddSegment: false,
      showAddScreen: false,
      storage: __WEBPACK_IMPORTED_MODULE_1__storages_js__["a" /* default */],
      showListVideo: false,
      showListDispo: false,
      loaderEditor: true,
      isInitialized: false,
      genericType: ''
    };
  },
  i18n: {
    messages: {
      en: __WEBPACK_IMPORTED_MODULE_26__i18n_en_US__["a" /* default */],
      fr: __WEBPACK_IMPORTED_MODULE_27__i18n_fr_FR__["a" /* default */]
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_vuex__["c" /* mapGetters */])({
    getSelected: 'slides/getSelected',
    currentSlide: 'slides/getCurrent',
    screens: 'screens/getSelectedScreens',
    dispositions: 'dispositions/getSelectedDispositions',
    defaultscreens: 'screens/getDefaultScreen',
    modal: 'grapes/getModal',
    paramsClient: 'getParamsClients',
    showSave: 'common/getShowSave',
    route: 'getRoute',
    RouteFromBiblio: 'segments/getFromRouteBiblio'
  }), {
    all: function all() {
      return this.screens.concat(this.dispositions);
    },
    showModule: function showModule() {
      if (this.$route.name !== 'edit' && !this.RouteFromBiblio) return true;else return false;
    },
    getColorBtn: function getColorBtn() {
      if (this.$route.query.color) {
        this.colorBtn = this.$route.query.color;
      }

      return { '--primary-color': this.colorBtn };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_vuex__["b" /* mapActions */])('segments', ['getTemplateById']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_vuex__["b" /* mapActions */])('slides', ['setCurrentSlide']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_vuex__["b" /* mapActions */])('screens', ['pushScreens', 'setScreens', 'saveTitle', 'pushEdited']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_vuex__["b" /* mapActions */])('dispositions', ['pushDispositions', 'setDispositions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_vuex__["b" /* mapActions */])(['pushVideoGeneriqueFin', 'pushVideoGeneriqueDebut', 'setRoute', 'setTmpId', 'setRouteCryptext']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_vuex__["b" /* mapActions */])('common', ['setShowSave', 'setEditorReady']), {
    setShowAddScreen: function setShowAddScreen(val) {
      this.showAddScreen = val;
    },
    eventShowListVideo: function eventShowListVideo(show) {
      this.showListVideo = show;
    },
    eventShowListDispo: function eventShowListDispo(show) {
      this.showListDispo = show;
    }
  }),
  watch: {
    currentSlide: function currentSlide(val) {
      if (!this.isInitialized) {
        this.isInitialized = true;
        this.$root.$emit('updateCanvasContent');
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    var urlParams = new URLSearchParams(window.location.color);
    var color = urlParams.get('color') ? urlParams.get('color') : 'rgb(3,155,229)';
    this.colorBtn = color;

    var self = this;
    var routeName = this.$route.name;
    var cryptext = this.$route.params.cryptext;
    self.setRouteCryptext(cryptext);

    eventHub.$on('setShowAddScreen', function (val) {
      _this.setShowAddScreen(val);
    });

    if (this.$route.params.type === 'NewSegment') {
      this.showAddScreen = true;
    }

    if (routeName === 'add') {
      self.setRoute('add');
      self.loaderEditor = false;
      this.$nextTick(function () {
        dialogue(self.modal);
      });
      this.isInitialized = true;
    } else if (routeName === 'segment') {
      self.setRoute('segment');
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.innerHTML = "<span style='font-family:RobotoUep!important;'>" + this.$t('template.save_and_exit') + "</span>";
      }

      self.loaderEditor = false;

      if (this.$route.params.type !== 'EditSegment') {
        this.$nextTick(function () {
          dialogue(self.modal);
        });
      }

      this.isInitialized = true;
    }
    if (this.$route.name === 'edit') {
      self.setRoute('edit');
      self.setTmpId(this.$route.params.id);
      self.loaderEditor = true;
      // Block saving until the program is fully loaded. getTemplateById is async;
      // marking ready only after it resolves prevents a fast "Enregistrer" from
      // saving screens before their content/background is loaded (losing them).
      self.setEditorReady(false);
      this.getTemplateById(this.$route.params.id).then(function () {
        self.setEditorReady(true);
        self.loaderEditor = false;
      });
    }
    this.$root.$on('closeModal', function () {
      self.modal.close();
    });
    function dialogue() {
      if (self.$route.name === 'segment') {
        //self.$root.$emit('bv::show::modal', 'segment-list-modal', '#btnShow');
      } else {
          //self.$root.$emit('bv::show::modal', 'slide-list-modal', '#btnShow');
        }
    }
    window.addEventListener('resize', this.updateCanvasDimensions);
    this.showViewContainer();
    self.$nextTick(function () {
      setTimeout(function () {
        _this.updateCanvasDimensions();
      }, 1000);
    });
    __WEBPACK_IMPORTED_MODULE_28__main__["bus"].$on('setFormLang', function (code) {
      __WEBPACK_IMPORTED_MODULE_15__i18n_index_js__["a" /* default */].locale = code;
      _this.$i18n.locale = code;
    });

    document.querySelector('.gjs-cv-canvas').classList.add('customScale');
    var element = document.querySelector('.gjs-cv-canvas');
    var canvasDiv = document.createElement('div');
    canvasDiv.classList.add('canvas-div');
    var parent = document.querySelector('.gjs-cv-canvas').parentNode;
    parent.replaceChild(canvasDiv, element);
    canvasDiv.appendChild(element);
  },

  components: {
    PanelFitScreen: __WEBPACK_IMPORTED_MODULE_3__components_Panel_panelFitScreen_vue___default.a,
    EditorSvgMatorComponent: __WEBPACK_IMPORTED_MODULE_20__Modal_EditorSvgMatorComponent___default.a,
    PanelPages: __WEBPACK_IMPORTED_MODULE_4__components_Panel_PanelPages_vue___default.a,
    AddGeneric: __WEBPACK_IMPORTED_MODULE_23__Modal_AddGeneric___default.a,
    InformationsNew: __WEBPACK_IMPORTED_MODULE_22__InformationsCanvas___default.a,
    Informations: __WEBPACK_IMPORTED_MODULE_21__Informations___default.a,
    PanelWrapper: __WEBPACK_IMPORTED_MODULE_5__components_Panel_PanelWrapper_vue___default.a,
    SaveTemplate: __WEBPACK_IMPORTED_MODULE_12__components_Modal_SaveTemplate_vue___default.a,
    SlideList: __WEBPACK_IMPORTED_MODULE_6__Modal_SlideList_vue___default.a,
    SegmentList: __WEBPACK_IMPORTED_MODULE_7__Modal_SegmentList_vue___default.a,
    PanelTitlePages: __WEBPACK_IMPORTED_MODULE_2__components_Panel_PanelTitlePages_vue___default.a,
    GrapesWrapper: __WEBPACK_IMPORTED_MODULE_13__components_GrapesWrapper___default.a,
    ListVideo: __WEBPACK_IMPORTED_MODULE_10__components_Modal_ListVideo_vue___default.a,
    SettingComponent: __WEBPACK_IMPORTED_MODULE_17__Modal_SettingComponent___default.a,
    EditorImageComponent: __WEBPACK_IMPORTED_MODULE_18__Modal_EditorImageComponent___default.a,
    Save: __WEBPACK_IMPORTED_MODULE_14__components_DropDown_Save_vue___default.a,
    ExtendSegmentDuration: __WEBPACK_IMPORTED_MODULE_25__Modal_ExtendSegmentDuration___default.a,
    ModuleList: __WEBPACK_IMPORTED_MODULE_8__ModuleList___default.a,
    ListGenericVideo: __WEBPACK_IMPORTED_MODULE_11__components_ListGenericVideo___default.a,
    AddScreen: __WEBPACK_IMPORTED_MODULE_9__AddScreen___default.a,
    ExitSave: __WEBPACK_IMPORTED_MODULE_24__Modal_ExitSave___default.a
  },
  created: function created() {
    var _this2 = this;

    eventHub.$on('eventShowListVideo', this.eventShowListVideo);
    eventHub.$on('eventShowListDispo', this.eventShowListDispo);
    eventHub.$on('displayGenericListVideo', function (generic) {
      _this2.genericType = generic;
    });
  }
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__storage_grapes_init__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_index_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__plugins_facebook_index__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__plugins_linkedin_index__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__plugins_player_index__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__plugins_player_mp4_index__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__plugins_twitter_index__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__plugins_weather_index__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__plugins_clock_index__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__plugins_dateHeure_index__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__plugins_filet_index__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__plugins_countDown_index__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__plugins_playlist_index__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__plugins_webrtc_index__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__plugins_web_index__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__plugins_rss_index__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__plugins_live_index__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__plugins_ticker_index__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__plugins_image_index__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__plugins_pattern_index__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__plugins_medias_index__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__core_http_http_token__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__core_router_router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__i18n_en_US__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__i18n_fr_FR__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__mixins_Mixin_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Modal_SettingComponent__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Modal_SettingComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__Modal_SettingComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__Modal_EditorImageComponent__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__Modal_EditorImageComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__Modal_EditorImageComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__mixins_GrapesMixinAnimation_js__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__mixins_GrapesMixinEvent_js__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__mixins_GrapesMixinBlockManger_js__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__mixins_GrapesMixinEditors_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__mixins_GrapesMixinPanels_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__mixins_GrapesMixinTranslate_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__mixins_GrapesMixinCommands_js__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__mixins_PostCssVw__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__mixins_GrapesMixinHelpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Modal_EditorSvgMatorComponent__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Modal_EditorSvgMatorComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__Modal_EditorSvgMatorComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_perfect_scrollbar__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__core_directives_HasPermission_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__main__ = __webpack_require__(73);








//
//
//














































/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GrapesWrapper',
  components: {
    SettingComponent: __WEBPACK_IMPORTED_MODULE_35__Modal_SettingComponent___default.a,
    EditorImageComponent: __WEBPACK_IMPORTED_MODULE_36__Modal_EditorImageComponent___default.a,
    EditorSvgMatorComponent: __WEBPACK_IMPORTED_MODULE_46__Modal_EditorSvgMatorComponent___default.a
  },
  directives: {
    HasPermission: __WEBPACK_IMPORTED_MODULE_48__core_directives_HasPermission_js__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_34__mixins_Mixin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_37__mixins_GrapesMixinAnimation_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_38__mixins_GrapesMixinEvent_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_39__mixins_GrapesMixinBlockManger_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_40__mixins_GrapesMixinEditors_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_41__mixins_GrapesMixinPanels_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_42__mixins_GrapesMixinTranslate_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_43__mixins_GrapesMixinCommands_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_44__mixins_PostCssVw__["a" /* default */], __WEBPACK_IMPORTED_MODULE_45__mixins_GrapesMixinHelpers__["a" /* default */]],
  data: function data() {
    return {
      oldBackgroundColor: null,
      editor: null,
      blockManager: null,
      currentScreen: null,
      idprev: null,
      panels: null,
      commands: null,
      modal: null,
      animate: null,
      showModal: false,
      textRTE: '',
      styleManager: null,
      mouseDown: false,
      pos1: 0,
      pos2: 0,
      pos3: 0,
      pos4: 0,
      videoObject: [],
      isvideoAutoplayed: 0,
      srcVideo: '',
      showToolbarButtons: true,
      confirmSave: false,
      fontsChanged: false,
      textSelected: true,
      blockSelected: true,
      modelToStyle: null,
      rectModal: {}
    };
  },

  i18n: {
    messages: {
      en: __WEBPACK_IMPORTED_MODULE_32__i18n_en_US__["a" /* default */],
      fr: __WEBPACK_IMPORTED_MODULE_33__i18n_fr_FR__["a" /* default */]
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])({
    currentSlide: 'slides/getCurrent',
    selected: 'slides/getAllSelected',
    selectedSegments: 'segments/getAllSelected',
    templateTitle: 'slides/getTemplateTitle',
    dispositions: 'dispositions/getSelectedDispositions',
    screens: 'screens/getSelectedScreens',
    paramsClient: 'getParamsClients',
    getScreenPerId: 'screens/getScreenPerId',
    getDispositionPerId: 'dispositions/getDispositionPerId',
    getDispositionById: 'dispositions/getDispositionById',
    currentscreen: 'screens/getCurrentScreen',
    getTemplate: 'slides/getTemplate',
    deviceType: 'common/getDeviceType',
    parentWidth: 'common/getParentWidth',
    someImage: 'common/getSomeImage',
    showSave: 'common/getShowSave',
    showIconSave: 'common/getShowIconSave',
    changedSave: 'common/getChangedSave',
    editorReady: 'common/getEditorReady',
    getCurrentSlideIndex: 'slides/getCurrentSlideIndex',
    startGeneric: 'segments/getStartGeneric',
    finishGeneric: 'segments/getFinishGeneric',
    hasPermission: 'hasPermission',
    currentSegment: 'segments/getCurrent',
    saveVideo: 'common/getSaveVideo',
    reclamation: 'common/getReclamation',
    permission: 'getPermissions',
    imageWidth: 'common/getImageWidth',
    ListSvgObject: 'common/getListSvgObject',
    VideoGeneriqueDebut: 'getVideoGeneriqueDebut',
    VideoGeneriqueFin: 'getVideoGeneriqueFin',
    template: 'slides/getTemplate',
    totalDurationSegments: 'segments/getAllSegmentsDuration',
    biblioRoute: 'segments/getFromRouteBiblio',
    hasFullscreenVideo: 'segments/hasFullscreenVideo'
  }), {
    all: function all() {
      return this.screens.concat(this.dispositions);
    },
    setChangePreviewAttr: function setChangePreviewAttr() {
      return {
        title: this.$i18n.t('tooltips.preview_screens'),
        'data-tooltip-pos': 'bottom'
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])('slides', ['updateSlide', 'setSlideDuration', 'setTemplate', 'setScreensTosubmit']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])('common', ['setSettingModalPos', 'setImageEdited', 'setShowSave', 'setChangedSave', 'setShowIconSave', 'setCauseReclamation', 'setImageConverted', 'setTitleVideoGeneriqueDebut', 'setTitleVideoGeneriqueFin', 'updateScreenbyId', 'pushDisposition', 'pushIdDispo']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])(['updateScreenbyId', 'pushDisposition', 'pushIdDispo', 'setRoute']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])('grapes', ['setEditor', 'setAssetManager']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])('screens', ['setCurrentScreen', 'setScreens', 'setDurationScreen', 'pushScreens', 'deleteScreensById', 'setComponentScreenByIndex', 'updateScreenTitle', 'setVideoIntro', 'duplicateScreens']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])('dispositions', ['setDispositions', 'addDisposition', 'unshiftDisposition', 'deleteDispositionsById', 'duplicateDisposition']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])('segments', ['setCurrentSegment', 'updateSegmentDuration', 'removeBlankSlideToSegment', 'updateSlideInsideSegment', 'setTypeGeneric', 'paginatesegment', 'resetPage', 'appendCreatedSegment', 'deleteSegmentByIdStore']), {
    showSetting: function showSetting() {
      var self = this;
      this.commands.add('show-setting', function () {
        self.$nextTick(function () {
          self.showModal = !self.showModal;
          var settingLayout = document.getElementById('setting-component');
          var settingCogs = document.querySelector('.gjs-toolbar .fa-cogs');
          settingLayout.classList.toggle('hidden');
          var rect = settingCogs.getBoundingClientRect();
          var left = rect.left,
              top = rect.top;

          left -= 212;
          top += 30;
          this.setSettingModalPos({ left: Math.max(left, 0), top: top });
        });
      });
    },
    updateTarget: function updateTarget(el, rect) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var canvas = grapesjsEMP.editors[0].Canvas;
      var em = canvas.getConfig().em;
      this.modelToStyle = grapesjsEMP.editors[0].StyleManager.getModelToStyle(grapesjsEMP.editors[0].getSelected());
      var body = grapesjsEMP.editors[0].Canvas.getBody().getBoundingClientRect();
      var selected = grapesjsEMP.editors[0].getSelected().view.el.getBoundingClientRect();
      this.rectModal = {
        l: selected.left * 100 / body.width,
        t: selected.top * 100 / body.height,
        h: selected.height * 100 / body.height,
        w: selected.width * 100 / body.width,
        view: grapesjsEMP.editors[0].getSelected().view.el
      };

      if (!this.modelToStyle) {
        return;
      }

      var store = options.store,
          selectedHandler = options.selectedHandler,
          config = options.config;
      var keyHeight = config.keyHeight,
          keyWidth = config.keyWidth,
          autoHeight = config.autoHeight,
          autoWidth = config.autoWidth,
          unitWidth = config.unitWidth,
          unitHeight = config.unitHeight;

      var onlyHeight = ['tc', 'bc'].indexOf(selectedHandler) >= 0;
      var onlyWidth = ['cl', 'cr'].indexOf(selectedHandler) >= 0;
      var style = {};
      var en = !store ? 1 : ''; // this will trigger the final change
      var onlyTop = ['tc'].indexOf(selectedHandler) >= 0;
      var onlyTopLeft = ['tl'].indexOf(selectedHandler) >= 0;
      var onlyLeft = ['cl', 'bl'].indexOf(selectedHandler) >= 0;

      /*todo marouene fix redimensionnement d'image */
      if (!onlyHeight) {
        var bodyw = canvas.getBody().offsetWidth;
        var width = rect.w < bodyw ? rect.w : bodyw;
        style[keyWidth] = autoWidth ? 'auto' : '' + width + unitWidth;
        if (onlyLeft || onlyTopLeft) {
          style['left'] = this.rectModal.l + (this.rectModal.w - width) + ('' + unitWidth);
          this.rectModal.view.style['left'] = style['left'];
        }
        this.rectModal.view.style[keyWidth] = style[keyWidth];
      }

      if (!onlyWidth) {
        style[keyHeight] = autoHeight ? 'auto' : '' + rect.h + unitHeight;
        if (onlyTop || onlyTopLeft) {
          style['top'] = this.rectModal.t + (this.rectModal.h - rect.h) + ('' + unitHeight);
          this.rectModal.view.style['top'] = style['top'];
        }
        this.rectModal.view.style[keyHeight] = style[keyHeight];
      }

      this.rectModal.view.style = this.modelToStyle.addStyle(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, style, { en: en }), { avoidStore: !store });
      var updateEvent = 'update:component:style';
      var eventToListen = updateEvent + ':' + keyHeight + ' ' + updateEvent + ':' + keyWidth;
      em && em.trigger(eventToListen, null, null, { noEmit: 1 });
    },
    showScreenSetting: function showScreenSetting() {
      var self = this;
      this.commands.add('screen-settings', function () {
        self.$nextTick(function () {
          var barsEl = document.querySelector('#gjs .gjs-pn-buttons .fa-bars');
          var brushEl = document.querySelector('#gjs .gjs-pn-buttons .fa-paint-brush');
          var decorationTitleEl = document.querySelector('#gjs-sm-decoration:not(.gjs-sm-open) .gjs-sm-title');
          var durationTitleEl = document.querySelector('#selected-element-properties:not(.gjs-sm-open) .gjs-sm-title');
          barsEl.click();
          var bodyTitleEl = document.querySelector('#gjs .gjs-layer-title');
          bodyTitleEl.click();
          brushEl.click();
          if (durationTitleEl) {
            durationTitleEl.click();
          }
          if (decorationTitleEl) {
            decorationTitleEl.click();
          }
        });
      });
    },
    showSvgMator: function showSvgMator() {
      var self = this;
      this.commands.add('show-svg-mator', function () {
        self.$nextTick(function () {
          var _this = this;

          this.image = grapesjsEMP.editors[0].getSelected().attributes;
          var ObjectSvgMator = null;
          this.ListSvgObject.forEach(function (s) {
            if (s.getImgId === _this.image.attributes.id) {
              ObjectSvgMator = s;
            }
          });
          var obj = {
            updateLang: self.$i18n.locale,
            isVisible: true,
            src: this.image.src,
            iframe: true,
            idImg: this.image.attributes.id
          };
          //self.$root.$emit('showModalSvgMator', obj);
          self.$root.$emit('bv::show::modal', 'modal-svg-mator');
          self.$root.$emit('loadiframe');
          window.frames['svg-iframe'].contentWindow.postMessage(obj, '*');
          //self.$root.$emit('showModalSvgMator');
        });
      });
    },
    rotateElement: function rotateElement() {
      var self = this;
      this.commands.add('rotate-element', function () {
        self.$nextTick(function () {
          var editor = grapesjsEMP.editors[0];
          var wrapper = editor.DomComponents.getWrapper();
          var classimg = 'bg-full-img-0';
          var attributes = editor.getSelected().getAttributes();
          if (attributes['data-rotation'] && attributes['data-rotation'] == 'horizontal') {
            attributes['data-rotation'] = 'vertical';
          } else if (attributes['data-rotation'] && attributes['data-rotation'] == 'vertical') {
            attributes['data-rotation'] = 'horizontal';
          } else if (attributes) {
            attributes['data-rotation'] = 'vertical';
          } else if (attributes) {
            attributes = {};
            attributes['data-rotation'] = 'vertical';
          }

          editor.getSelected().setAttributes(attributes);
          //wrapper.view.el.setAttribute('classimg',editor.getSelected().attributes.classes.models[0].id);
        });
      });
    },
    FullbackgroundImg: function FullbackgroundImg() {
      var self = this;
      this.commands.add('full-background-img', function () {
        self.$nextTick(function () {
          var editor = grapesjsEMP.editors[0];
          var wrapper = editor.DomComponents.getWrapper();
          var src = editor.getSelected().attributes.src ? editor.getSelected().attributes.src : editor.getSelected().attributes.attributes.src;
          wrapper.attributes.src = src;
          wrapper.view.el.setAttribute('src', src);

          // get id and class from old El  img-media
          wrapper.view.el.setAttribute('idimg', editor.getSelected().attributes.attributes.id);
          wrapper.view.el.setAttribute('classimg', editor.getSelected().attributes.classes.models[0].id);

          self.updateWrapperProperties(editor, src);
          editor.getSelected().destroy();
          // hide the toolbar of the default element after the destruction
          setTimeout(function () {
            editor.select(wrapper);
          }, 20);
        });
      });

      this.commands.add('reset-full-background-img', function () {
        self.$nextTick(function () {
          var editor = grapesjsEMP.editors[0];
          var wrapper = editor.DomComponents.getWrapper();
          var src = wrapper.attributes.src ? wrapper.attributes.src : wrapper.attributes.style['background-image'].slice(4, -1).replace(/"/g, '').replace(/'/g, ' ');
          var idimg = self.makeId();
          var classimg = 'bg-full-img-0';
          var imageMediaId = 'image-media-' + self.makeId();
          if (wrapper.view.el.attributes.idimg && wrapper.view.el.attributes.classimg) {
            idimg = wrapper.view.el.attributes.idimg.value;
            classimg = wrapper.view.el.attributes.classimg.value;
          }
          editor.addComponents('<div data-gjs-type="image_media" data-highlightable="1" id="' + idimg + '"  class="' + classimg + '" src ="' + src + '"><img class="gjs-no-pointer" src=' + src + ' id="' + imageMediaId + '" style="width:100%;height:100%;border: none; overflow: hidden;"></div>');
          this.updateWrapperProperties(editor, null, this.oldBackgroundColor);
          wrapper.attributes.src = null;
          wrapper.view.el.setAttribute('src', null);
          this.displayImgBGToolBar();

          //setTimeout(() => {
          //  editor.select(wrapper);},20);
        });
      });
    },
    ShowVideoFullScreen: function ShowVideoFullScreen() {
      var self = this;
      this.commands.add('full-screen-video', function () {
        self.$nextTick(function () {
          var editor = grapesjsEMP.editors[0];
          var model = editor.getSelected();
          var classes = model.getClasses();
          var cssComposer = editor.CssComposer;
          var id = grapesjsEMP.editors[0].getSelected().getAttributes().id;
          if (this.currentSlide.options.fullscreenVideo) {
            self.modeFullScreenOut(classes, cssComposer, id, model);
          } else {
            self.modeFullScreenIN(classes, cssComposer, id, model);
          }
        });
      });
    },
    modeFullScreenOut: function modeFullScreenOut(classes, cssComposer, id, model) {
      if (classes && classes[0]) {
        cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes ? cssComposer.getClassRule(classes[0]).attributes.style : {};
        cssComposer.setClassRule(classes[0], {
          width: '30%',
          height: '30%',
          position: 'fixed'
        });
      }
      if (this.$route.name !== 'segment') {
        //this.removeBlankSlideToSegment(this.currentSegment.uid);
        this.setCurrentSlide(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.currentSlide, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.currentSlide.options, { fullscreenVideo: false })));
        this.updateSegmentDuration({
          duration: model.attributes.duration,
          uid: this.currentSegment.uid,
          fullscreenVideo: false
        });
        this.setCurrentSegment(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, this.currentSegment, { originalDuration: model.attributes.duration }));
      }
      model.set('resizable', true);
    },
    modeFullScreenIN: function modeFullScreenIN(classes, cssComposer, id, model) {
      if (classes && classes[0]) {
        cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes ? cssComposer.getClassRule(classes[0]).attributes.style : {};
        cssComposer.setClassRule(classes[0], {
          width: '100%',
          height: '100%',
          left: '0',
          top: '0',
          position: 'fixed'
        });
      }
      if (id) {
        var oldStyle = cssComposer.getIdRule(id) ? cssComposer.getIdRule(id).attributes.style : {};
        cssComposer.setIdRule(id, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, oldStyle, { left: '0', top: '0' }));
      }
      if (this.$route.name !== 'segment') {
        this.updateSegmentDuration({
          duration: model.attributes.duration,
          uid: this.currentSlide.uid,
          fullscreenVideo: true
        });
      } else {
        this.updateSlideDuration({
          duration: model.attributes.duration,
          uid: this.currentSlide.uid
        });
      }
      model.set('resizable', false);
    },
    showEditor: function showEditor() {
      var self = this;
      this.commands.add('show-editor', function () {
        self.$nextTick(function () {
          var selectedElement = grapesjsEMP.editors[0].getSelected().attributes.type;
          self.changeEditor(selectedElement);
        });
      });
    },
    changeEditor: function changeEditor(element) {
      var self = this;
      document.querySelectorAll('.gjs-sm-sector.no-select.gjs-sm-open .gjs-sm-title').forEach(function (e) {
        e.click();
      });
      var openBlocksBtn = self.editor.Panels.getButton('views', 'open-sm');
      if (element === 'image' || element === 'image_media' || element === 'pattern') {
        this.image = grapesjsEMP.editors[0].getSelected().attributes;
        self.setImageEdited(this.image.src);
        eventHub.$emit('eventShowEditorImage', true);
      } else if (element === 'text' || element === '') {
        openBlocksBtn && openBlocksBtn.set('active', 1);
        var textEditor = document.querySelector('#gjs-sm-text .gjs-sm-title');
        textEditor.click();
      } else if (element === 'player') {
        openBlocksBtn && openBlocksBtn.set('active', 1);
        var playerEditor = document.querySelector('#selected-element-properties .gjs-sm-title');
        playerEditor.click();
        document.querySelector('.gjs-mdl-dialog.gjs-one-bg.gjs-two-color').style.display = 'block';
      } else {
        var decoEditor = document.querySelector('#gjs-sm-decoration .gjs-sm-title');
        decoEditor.click();
      }
    },
    loadErrorBox: function loadErrorBox() {
      // Add info command
      var self = this;
      var mdlClass = 'gjs-mdl-dialog-sm';
      var infoContainer = document.getElementById('info-erreur');
      var mdlDialog = document.querySelector('.gjs-mdl-dialog');
      mdlDialog.className += ' ' + mdlClass;
      infoContainer.style.display = 'block';
      self.modal.setTitle(self.$t('modal.error'));
      self.modal.setContent(infoContainer);
      self.modal.open();
      self.modal.getModel().once('change:open', function () {
        mdlDialog.className = mdlDialog.className.replace(mdlClass, '');
      });
    },
    loadButtonPreviewScreens: function loadButtonPreviewScreens() {
      var self = this;

      this.panels.addButton('options', {
        id: 'preview-screens',
        className: 'fa fa-play',
        command: function command() {
          var lastSlide = {
            uid: self.currentSlide.uid,
            components: localStorage.getItem('gjs-components'),
            js: localStorage.getItem('gjs-js'),
            html: localStorage.getItem('gjs-html'),
            css: self.sanitizeCSS(localStorage.getItem('gjs-css')),
            styles: localStorage.getItem('gjs-styles')
          };
          if (self.$route.name === 'segment') {
            self.updateSlide(lastSlide);
          } else {
            self.updateSlideInsideSegment(lastSlide);
          }
          if (self.$route.name === 'segment') {
            self.$root.$emit('ShowPreview', true);
          } else if (self.paramsClient.show_generic_display === '1') {
            if (!self.startGeneric) {
              self.setTypeGeneric('debut');
              self.$root.$emit('bv::show::modal', 'modal-add-generic', '#btnShow');
              /*} else
               if (!self.finishGeneric) {
              self.setTypeGeneric('fin');
              self.$root.$emit('bv::show::modal', 'modal-add-generic', '#btnShow');
              */
            } else {
              self.$root.$emit('ShowPreview', true);
            }
          } else if (self.paramsClient.show_generic_display === '0') {
            self.$root.$emit('ShowPreview', true);
          }
          // self.getSelectedSlides('preview');
        },
        attributes: this.setChangePreviewAttr
      });
      // this.previewScreens();
    },


    // todo mixin code
    causedata: function causedata() {
      var overlay = document.createElement('div');
      document.body.appendChild(overlay);
      overlay.setAttribute('id', 'CanvOverlay');
      overlay.setAttribute('class', 'overlay');
      var self = this;
      var infoContainer1 = document.getElementById('save-programme');
      var mdlClass = 'gjs-mdl-dialog-sm';
      var editor = grapesjsEMP.editors[0];
      var wrapper = editor.DomComponents.getWrapper();
      var iconSave = document.querySelector('.icon-save');
      editor.select(wrapper);
      setTimeout(function () {
        var btnSave = document.querySelector('#success.button-saveTemp');
        var btnload = document.querySelector('#loadButton');
        btnload.style.display = 'inline-table';
        btnSave.disabled = true;

        var lastSlide = {
          uid: self.currentSlide.uid,
          components: localStorage.getItem('gjs-components'),
          js: localStorage.getItem('gjs-js'),
          html: localStorage.getItem('gjs-html'),
          css: self.sanitizeCSS(localStorage.getItem('gjs-css')),
          styles: localStorage.getItem('gjs-styles')
        };
        self.updateSlideInsideSegment(lastSlide);

        self.generateSlideThmbnail(self.currentSlide.uid);

        var screensToSubmit = self.selectedSegments.map(function (segment) {
          segment = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, segment);
          var t = new Date(Date.UTC(1970, 0, 1));
          t.setSeconds(segment.duration);
          segment.duration = t.toISOString();
          if (!segment.type.toLowerCase().includes('generic')) {
            segment.type = 'Segment';
          }

          segment.screensToSubmit = segment.screens.map(function (s) {
            var css = self.fontSizeToVw(s.css);
            css = self.widthHeightToViewport(css);
            var html = self.animationAttributesToClass(s.html);

            s.template = self.cmdInlineHtml(self.getSanitizedHtml(html), css);
            s.options.transition = s.transition;
            return s;
          });
          delete segment.screens;
          return segment;
        });

        var title = '';
        if (getComputedStyle(document.getElementById('title-template')).display === 'none' && self.changedSave) {
          title = document.getElementById('edit-title-template').value;
        } else {
          title = document.getElementById('title-template').value;
        }
        title = title || self.getTemplate.title;
        if (!self.getTemplate.title || self.changedSave) {
          var data = {
            segmentsToSubmit: screensToSubmit,
            title: title,
            template: self.deviceType
          };
        } else {
          var data = {
            segmentsToSubmit: screensToSubmit,
            title: title,
            template: self.deviceType,
            id: self.getTemplate.id
          };
        }
        if (self.getTemplate.id) {
          data.id = self.getTemplate.id;
        }
        self.setCauseReclamation(data);
      });
    },
    loadCommandeSaveProgramme: function loadCommandeSaveProgramme() {
      var overlay = document.createElement('div');

      document.body.appendChild(overlay);
      overlay.setAttribute('id', 'CanvOverlay');
      overlay.setAttribute('class', 'overlay');
      var self = this;
      var infoContainer1 = document.getElementById('save-programme');
      var mdlClass = 'gjs-mdl-dialog-sm';

      function saveProgramme(e) {
        // Block saving while the program is still loading (e.g. a fast click on
        // "Enregistrer" right after opening the edit interface): saving now would
        // persist screens before their content/background is loaded and lose them.
        if (!self.editorReady) {
          self.$toasted.show(self.$t('template.loading') || 'Chargement en cours...', {
            duration: 2500,
            position: 'top-right',
            className: 'save-toast'
          });
          return;
        }
        var editor = grapesjsEMP.editors[0];
        var wrapper = editor.DomComponents.getWrapper();
        var iconSave = document.querySelector('.icon-save');
        editor.select(wrapper);
        setTimeout(function () {
          var btnSave = document.querySelector('#success.button-saveTemp');
          var btnload = document.querySelector('#loadButton');
          btnload.style.display = 'inline-table';
          btnSave.disabled = true;
          var localStorages = JSON.parse(localStorage.getItem('gjs-components')).map(function (item) {
            window.x = item;
            if (item.type === 'clocks') {
              item.saved = true;
            }
            return item;
          });
          localStorage.setItem('gjs-components', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(localStorages));
          var lastSlide = {
            uid: self.currentSlide.uid,
            components: localStorage.getItem('gjs-components'),
            js: localStorage.getItem('gjs-js'),
            html: localStorage.getItem('gjs-html'),
            css: self.sanitizeCSS(localStorage.getItem('gjs-css')),
            styles: localStorage.getItem('gjs-styles')
          };
          self.updateSlideInsideSegment(lastSlide);

          self.generateSlideThmbnail(self.currentSlide.uid);

          var screensToSubmit = self.selectedSegments.map(function (segment) {
            segment = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, segment);
            var t = new Date(Date.UTC(1970, 0, 1));
            t.setSeconds(segment.duration);
            segment.duration = t.toISOString();
            if (!segment.type.toLowerCase().includes('generic')) {
              segment.type = 'Segment';
            }

            segment.screensToSubmit = segment.screens.map(function (s) {
              var css = self.fontSizeToVw(s.css);
              css = self.widthHeightToViewport(css);
              var html = self.animationAttributesToClass(s.html);

              s.template = self.cmdInlineHtml(self.getSanitizedHtml(html), css);
              s.options.transition = s.transition;
              return s;
            });
            delete segment.screens;
            return segment;
          });

          var title = '';
          if (getComputedStyle(document.getElementById('title-template')).display === 'none' && self.changedSave) {
            title = document.getElementById('edit-title-template').value;
          } else {
            title = document.getElementById('title-template').value;
          }
          title = title || self.getTemplate.title;
          if (!self.getTemplate.title || self.changedSave) {
            var data = {
              segmentsToSubmit: screensToSubmit,
              title: title,
              template: self.deviceType,
              ligne: self.getTemplate.ligne
            };
          } else {
            var data = {
              segmentsToSubmit: screensToSubmit,
              title: title,
              template: self.deviceType,
              ligne: self.getTemplate.ligne,
              id: self.getTemplate.id
            };
            self.$Progress.start();
          }
          if (self.getTemplate.id) {
            data.id = self.getTemplate.id;
          }
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__core_http_http_token__["a" /* HTTP */])(window.ApiToken).post(__WEBPACK_IMPORTED_MODULE_31__core_router_router__["a" /* default */].generate('api_templateDisplay_post_add_edit_template'), {
            data: data,
            client: self.paramsClient.client,
            saveVideo: self.saveVideo
          }).then(function (response) {
            if (response.data.code === 200) {
              self.modal.close();
              var id = response.data.templateId;
              if (!self.getTemplate.title || self.changedSave) {
                self.$toasted.show('Template enregistré', {
                  theme: 'bubble',
                  position: 'top-center',
                  duration: 4000,
                  icon: 'fa-check-circle',
                  className: 'save-toast'
                });
              } else {
                self.$Progress.finish();
                self.$toasted.show('Template enregistré', {
                  theme: 'bubble',
                  position: 'top-center',
                  duration: 4000,
                  icon: 'fa-check-circle',
                  className: 'save-toast'
                });
              }
              self.setTemplate({
                id: id,
                title: title
              });
              self.setShowIconSave(false);

              iconSave.classList.remove('icon-selected');
              if (self.saveVideo) {
                parent.postMessage({ info: 'publishDisplay' }, '*');
              }
            } else {
              self.loadErrorBox();
              self.setShowIconSave(true);
              iconSave.classList.add('icon-selected');
            }
            btnSave.disabled = false;
            btnload.style.display = 'none';
          }, function (error) {
            console.error(error);
            btnSave.disabled = false;
            btnload.style.display = 'none';
          });
        }, 100);
      }
      function saveSegment(e) {
        var editor = grapesjsEMP.editors[0];
        var wrapper = editor.DomComponents.getWrapper();
        var iconSave = document.querySelector('.icon-save');
        editor.select(wrapper);
        setTimeout(function () {
          self.$Progress.start();
          var btnSave = document.querySelector('#success.button-saveTemp');
          var btnload = document.querySelector('#loadButton');
          btnload.style.display = 'inline-table';
          var localStorages = JSON.parse(localStorage.getItem('gjs-components')).map(function (item) {
            if (item.type === 'clocks') {
              item.saved = true;
            }
            return item;
          });
          localStorage.setItem('gjs-components', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(localStorages));
          var lastSlide = {
            uid: self.currentSlide.uid,
            components: localStorage.getItem('gjs-components'),
            js: localStorage.getItem('gjs-js'),
            html: localStorage.getItem('gjs-html'),
            css: self.sanitizeCSS(localStorage.getItem('gjs-css')),
            styles: localStorage.getItem('gjs-styles')
          };
          self.updateSlide(lastSlide);
          self.generateSlideThmbnail(self.currentSlide.uid);
          var duration = 0;
          var screensToSubmit = self.selected.map(function (s) {
            duration += s.options.duration;
            var css = self.fontSizeToVw(s.css);
            css = self.widthHeightToViewport(css);
            var html = self.animationAttributesToClass(s.html);
            self.setScreensTosubmit({
              uid: s.uid,
              template: self.cmdInlineHtml(self.getSanitizedHtml(html), css),
              type: 'Screen' ? 'Disposition' : s.type,
              transition: s.transition,
              screenShot: s.screenShot
            });
            /*
            s.template = self.cmdInlineHtml(self.getSanitizedHtml(html), css);
            s.type = s.type === 'Screen' ? 'Disposition' : s.type;
            s.template = self.cmdInlineHtml(self.getSanitizedHtml(html), css);
            s.options.transition = s.transition;
            s.screenShot = '';
            */
            return s;
          });

          var themesIdList = [];
          self.currentSegment.themes.forEach(function (t) {
            themesIdList.push(t.id);
          });
          var authorId = null;
          if (self.currentSegment.author) authorId = self.currentSegment.author.id;

          var key = '';
          if (self.currentSegment.keyWords && self.currentSegment.keyWords.isArray) {
            key = self.currentSegment.keyWords.join();
          }
          var data = {
            screensToSubmit: self.selected,
            title: self.currentSegment.title,
            duration: duration ? self.SecToTime(duration) : '00:00:30',
            author: authorId,
            keyWords: key ? key : null,
            description: self.currentSegment.description ? self.currentSegment.description : null,
            themes: themesIdList ? themesIdList : null
          };

          self.setRoute('segment');
          iconSave.classList.remove('icon-selected');
          iconSave.innerText = ' ' + self.$t('template.save_and_exit');

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__core_http_http_token__["a" /* HTTP */])(window.ApiToken).post(__WEBPACK_IMPORTED_MODULE_31__core_router_router__["a" /* default */].generate('api_segmentDisplay_post_add_segment'), {
            id: self.currentSegment.id ? self.currentSegment.id : null,
            data: data,
            client: self.paramsClient.client
          }).then(function (response) {
            if (response.data.code === 200) {
              self.$Progress.finish();
              self.$toasted.show('Segment enregistré', {
                theme: 'bubble',
                position: 'top-center',
                duration: 3000,
                icon: 'fa-check-circle',
                className: 'save-toast'
              });

              // if edit mode delet from stor
              if (self.currentSegment.id === response.data.segmentId) {
                self.deleteSegmentByIdStore(self.currentSegment);
              }
              //appendCreatedSegment : to add segment in first index list store
              var segment = {
                screens: response.data.screens,
                title: self.currentSegment.title,
                duration: self.timeToSec(data.duration),
                type: 'DefaultSegment',
                id: response.data.segmentId,
                author: self.currentSegment.author ? self.currentSegment.author : null,
                keyWords: self.currentSegment.keyWords ? self.currentSegment.keyWords : null,
                description: self.currentSegment.description ? self.currentSegment.description : null,
                themes: self.currentSegment.themes ? self.currentSegment.themes : null
              };

              var index = self.$route.params.indexSegment ? self.$route.params.indexSegment : 0;
              var info = {
                segment: segment,
                index: index
              };

              self.appendCreatedSegment(info);

              if (!self.biblioRoute) {
                eventHub.$emit('saveSelect', segment);
                self.$router.push({ name: 'add' });
                self.$root.$emit('bv::show::modal', 'slide-list-modal');
                eventHub.$emit('hideCancelButton', true);
                self.setRoute('add');
              } else {
                self.$router.push({ name: 'ListSegment' });
              }

              iconSave.classList.remove('only-save');
              iconSave.innerText = ' ';
            } else {
              self.loadErrorBox();
              self.setShowIconSave(true);
              iconSave.classList.add('icon-selected');
              iconSave.innerText = ' ' + self.$t('template.save_and_exit');

              self.setRoute('segment');
            }
            btnSave.disabled = false;
            btnload.style.display = 'none';
          }, function (error) {
            console.error(error);
            btnSave.disabled = false;
            btnload.style.display = 'none';
          });
        }, 100);
      }

      infoContainer1.querySelector('#success').addEventListener('click', saveProgramme);
      var self = this;
      this.commands.add('save-template', function () {
        var iconSave = document.querySelector('.icon-save');
        if (self.showIconSave) {
          iconSave.classList.add('icon-selected');
        } else {
          iconSave.classList.remove('icon-selected');
        }
        function showModalSave() {
          document.querySelector('.gjs-mdl-btn-close').addEventListener('click', function () {
            if (self.showIconSave) {
              iconSave.classList.add('icon-selected');
            } else {
              iconSave.classList.remove('icon-selected');
            }
          });

          var mdlDialog = document.querySelector('.gjs-mdl-dialog');
          document.querySelector('.gjs-mdl-container .gjs-mdl-dialog.gjs-one-bg.gjs-two-color').style.display = 'block';
          document.querySelector('.gjs-mdl-container .gjs-mdl-content').style.display = 'block';
          mdlDialog.className += ' ' + mdlClass;
          overlay.style.display = 'block';
          infoContainer1.style.display = 'block';
          self.modal.setTitle(self.$t('template.save_template'));
          if (self.changedSave) {
            if (!self.getTemplate.title) {
              document.getElementById('title-template').value = 'Template ' + self.makeId();
            } else {
              document.getElementById('edit-title-template').value = self.templateTitle + ' - Copie';
              self.modal.setTitle(self.$t('template.save_as_template'));
              document.getElementById('title-template').value = self.templateTitle;
            }
          } else {
            var title = self.getTemplate.title ? self.getTemplate.title.title : 'Template ' + self.makeId();

            document.getElementById('title-template').value = self.templateTitle || title;

            document.getElementById('edit-title-template').value = self.templateTitle || title;
          }

          self.modal.setContent(infoContainer1);
          self.modal.open();
          self.modal.getModel().once('change:open', function () {
            mdlDialog.className = mdlDialog.className.replace(mdlClass, '');
            overlay.style.display = 'none';
            if (self.showIconSave) {
              iconSave.classList.add('icon-selected');
            } else {
              iconSave.classList.remove('icon-selected');
            }
          });
        }
        function save() {
          if (self.paramsClient.show_generic_display === '1' && self.confirmSave && self.$route.name !== 'segment') {
            if (!self.startGeneric) {
              self.setTypeGeneric('debut');
              self.$root.$emit('bv::show::modal', 'modal-add-generic', '#btnShow');
              /*} else if (!self.finishGeneric) {
              self.setTypeGeneric('fin');
              self.$root.$emit('bv::show::modal', 'modal-add-generic', '#btnShow');
              */
            } else {
              if (self.showSave) {
                self.setChangedSave(true);
                showModalSave();
                self.setShowSave(false);
              } else {
                self.setChangedSave(false);
                saveProgramme();
              }
            }
          } else if (self.paramsClient.show_generic_display === '0' && self.confirmSave && self.$route.name !== 'segment') {
            if (self.showSave) {
              self.setChangedSave(true);
              showModalSave();
              self.setShowSave(false);
            } else {
              self.setChangedSave(false);
              saveProgramme();
            }
          }
        }
        // Problème 10 : suppression du message « La durée des écrans est
        // supérieure à celle de la template » — on enregistre directement.
        self.confirmSave = true;
        if (self.$route.name === 'segment') {
          saveSegment();
        }
        save();
      });
    },
    loadButtonSaveOptions: function loadButtonSaveOptions() {
      var self = this;
      this.loadCommandeSaveProgramme();
      this.addSaveOptions(self.editor.Panels);
      if (document.getElementById('saveAsItem')) {
        document.getElementById('saveAsItem').addEventListener('click', function () {
          self.editor.runCommand('save-template');
        });
      }
      if (document.getElementById('saveAsVideo')) {
        document.getElementById('saveAsVideo').addEventListener('click', function () {
          self.editor.runCommand('save-template');
        });
      }
    },
    loadCommandeSaveDisposition: function loadCommandeSaveDisposition() {
      var self = this;
      saveDisposition();

      function saveDisposition(e) {
        var icon = document.getElementById('icon-add-dispo');
        var icon2 = document.getElementById('icon-add-dispo-load');
        icon.style.display = 'none';
        icon2.style.display = 'inline-table';

        var title = 'Disposition ' + self.makeId();
        var id = 'selectedDisposition' + (self.dispositions.length + 1);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__core_http_http_token__["a" /* HTTP */])(window.ApiToken).post(__WEBPACK_IMPORTED_MODULE_31__core_router_router__["a" /* default */].generate('api_templateDisplay_post_screen_shot_html'), {
          html: self.editor.getHtml(),
          client: localStorage.getItem('client')
        }, {
          emulateJSON: true
        }).then(function (response) {
          var localStorages = JSON.parse(localStorage.getItem('gjs-components')).map(function (item) {
            window.x = item;
            if (item.type === 'clocks') {
              item.saved = true;
            }
            return item;
          });
          localStorage.setItem('gjs-components', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(localStorages));
          self.addDisposition({
            js: JSON.parse(localStorage.getItem('gjs-js')),
            components: JSON.parse(localStorage.getItem('gjs-components')),
            options: {
              duration: 30,
              transition: 'bounce',
              videointro: { html: '', css: '', duration: 20 }
            },
            assets: JSON.parse(localStorage.getItem('gjs-assets')),
            css: self.editor.getCss(),
            html: self.editor.getHtml(),
            styles: JSON.parse(localStorage.getItem('gjs-styles')),
            id: id,
            type: 'Disposition',
            title: title,
            screenShot: response.data.path_to_screen
          });
          self.unshiftDisposition({
            components: JSON.parse(localStorage.getItem('gjs-components')),
            js: JSON.parse(localStorage.getItem('gjs-js')),
            options: {
              duration: 30,
              transition: 'bounce',
              videointro: { html: '', css: '', duration: 20 }
            },
            assets: JSON.parse(localStorage.getItem('gjs-assets')),
            css: self.editor.getCss(),
            html: self.editor.getHtml(),
            styles: JSON.parse(localStorage.getItem('gjs-styles')),
            id: id,
            type: 'Disposition',
            title: title,
            screenShot: response.data.path_to_screen
          });
        }, function (error) {
          var toast = self.$toasted.show("n'a pas pu créer La disposition\n verifier Votre Connexion", {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 4000
          });
          icon.style.display = 'inline-block';
          icon2.style.display = 'none';
        });
      }
    },
    loadImages: function loadImages() {
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__core_http_http_token__["a" /* HTTP */])(window.ApiToken).get(__WEBPACK_IMPORTED_MODULE_31__core_router_router__["a" /* default */].generate('api_bloc_get_images_stored', {
        client: localStorage.getItem('client')
      })).then(function (response) {
        var am = self.editor.AssetManager;
        am.getAllVisible().forEach(function (a) {
          if (a && a.id) {
            am.remove(a.id);
          }
        });
        am.getAllVisible().models.forEach(function (a) {
          if (a && a.id) {
            am.remove(a.id);
          }
        });
        am.getAll().forEach(function (a) {
          if (a && a.id) {
            am.remove(a.id);
          }
        });
        am.getAll().models.forEach(function (a) {
          if (a && a.id) {
            am.remove(a.id);
          }
        });
        localStorage.setItem('gjs-assets', '[]');
        self.setAssetManager(response.data.urls);
        am.add(response.data.urls);
      }, function (error) {});
    },
    TabsComponentAdd: function TabsComponentAdd() {
      var panels = document.querySelector('.gjs-pn-panels ');
      var parentbuttons = document.querySelector('.gjs-pn-panels .gjs-pn-panel.gjs-pn-views');
      var buttons = document.querySelector('.gjs-pn-panels .gjs-pn-panel.gjs-pn-views .gjs-pn-buttons');
      var toggleButton = document.createElement('div');
      toggleButton.innerHTML = '<i class="fa fa-angle-left"></i>';
      toggleButton.className = 'arrow-blocks';
      toggleButton.id = 'btn-toggle';
      toggleButton.style.display = 'block';
      buttons.classList.add('panel-buttons');
      parentbuttons.removeChild(buttons);
      panels.insertBefore(buttons, panels.firstChild);
      panels.appendChild(toggleButton);
    },
    eventLoad: function eventLoad() {
      // Do stuff on load
      var self = this;

      this.editor.on('load', function () {
        var $ = grapesjs.$;

        var settings = document.querySelector('.gjs-toolbar');
        // Load and show settings and style manager
        var openTmBtn = self.panels.getButton('views', 'open-tm');
        openTmBtn && openTmBtn.set('active', 1);
        var openSm = self.panels.getButton('views', 'open-sm');
        openSm && openSm.set('active', 1);
        // Add Settings Sector
        var traitsSector = $('<div class="gjs-sm-sector no-select" id="selected-element-properties">' + '<div class="gjs-sm-title">' + '<i id="gjs-sm-caret" class="fa fa-caret-right"></i>' + self.$t('button.settings') + '</div>' + '<div class="gjs-sm-properties" style="display: none;"></div></div>');

        var sectors = self.styleManager.getSectors().models.map(function (sector) {
          return sector.attributes.id;
        });
        var id = void 0;
        sectors.forEach(function (sector, index) {
          var child = $('.gjs-sm-sectors')[0].children[index];
          id = child.id;
          id = 'gjs-sm-' + sector.toLowerCase();
          child.setAttribute('id', id);
        });
        if (!document.getElementById('selected-element-properties')) {
          var traitsProps = traitsSector.find('.gjs-sm-properties');
          traitsProps.append($('.gjs-trt-traits'));
          $('.gjs-sm-sectors').before(traitsSector);
          if (!self.hasPermission('edit_duration_segment_action')) {
            traitsSector.css('height', '0');
            traitsSector.css('overflow', 'hidden');
          }
        }
        traitsSector.find('.gjs-sm-title').on('click', function () {
          if (self.editor.getSelected().get('type') === 'wrapper' && document.querySelector('#selected-element-properties input')) {
            document.querySelector('#selected-element-properties input').value = self.SecToTime(self.currentSlide.options.duration);
          }
          var caret = document.querySelector('#selected-element-properties #gjs-sm-caret');
          var wrapper = document.querySelector('#selected-element-properties');
          var type = self.editor.getSelected().get('type');
          var traitStyle = traitsProps.get(0).style;
          if (type === '') {
            document.querySelector('.gjs-sm-sector').style.display = 'none';
            caret.className = 'fa fa-caret-right';
            wrapper.classList.remove('gjs-sm-open');
          } else {
            var hidden = traitStyle.display === 'none';
            if (hidden) {
              traitStyle.display = 'block';
              caret.className = 'fa fa-caret-down';
              wrapper.classList.add('gjs-sm-open');
            } else {
              traitStyle.display = 'none';
              caret.className = 'fa fa-caret-right';
              wrapper.classList.remove('gjs-sm-open');
            }
          }
        });
        // Open block manager
        var openBlocksBtn = self.editor.Panels.getButton('views', 'open-blocks');
        openBlocksBtn && openBlocksBtn.set('active', 1);
      });
    },
    initializeRotationPosition: function initializeRotationPosition() {
      var self = this;
      var rotateElement = document.getElementById('rotateHandle');
      var selected = grapesjsEMP.editors[0].getSelected().view.el;
      var clientCenter = this.getRectOfElement(selected);
      var left = clientCenter.x;
      var top = clientCenter.y;
      var transform = self.getCurrentRotationFixed(selected);
      rotateElement.classList.add('drag-rotate');
      rotateElement.style.height = clientCenter.height + 30 + 'px';
      rotateElement.style.left = left + 'px';
      rotateElement.style.top = top + 'px';
      rotateElement.style.transform = 'rotate(' + transform + 'deg)';
    },
    mouse: function mouse(evt) {
      if (!grapesjsEMP.editors[0].getSelected()) {
        return;
      }
      var type = grapesjsEMP.editors[0].getSelected().attributes.type;
      if (this.mouseDown /* && type === 'image'*/) {
          this.pos1 = this.pos3 - evt.clientX;
          this.pos2 = this.pos4 - evt.clientY;
          this.pos3 = evt.clientX;
          this.pos4 = evt.clientY;
          var selected = grapesjsEMP.editors[0].getSelected().view.el;
          var clientCenter = this.getRectOfElement(selected);
          var center_x = clientCenter.x;
          var center_y = clientCenter.y;
          var mouse_x = evt.pageX;
          var mouse_y = evt.pageY;
          var radians = Math.atan2(mouse_x - center_x, mouse_y - (center_y + clientCenter.height / 2));
          var degree = (radians * (180 / Math.PI) + 180) * -1;
          var style = {};
          style.transform = 'rotate(' + degree + 'deg)';
          var rotateElement = document.getElementById('rotateHandle');
          rotateElement.style.transform = 'rotate(' + degree + 'deg)';
          selected.style.transform = style.transform;
          var resizer = document.querySelector('.gjs-resizer-c');
          if (resizer) {
            resizer.style.transform = style.transform;
          }
          var cssComposer = this.editor.CssComposer;
          var id = grapesjsEMP.editors[0].getSelected().getAttributes().id;
          if (!id) {
            var newId = self.makeId();
            grapesjsEMP.editor[0].getSelected().setAttributes({ id: newId });
            id = newId;
          }
          var oldStyle = cssComposer.getIdRule(id) ? cssComposer.getIdRule(id).attributes.style : {};
          cssComposer.setIdRule(id, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, oldStyle, style));
        }
    },
    eventComponentSelectedModel: function eventComponentSelectedModel(editor) {
      var self = this;
      editor.on('component:selected', function (e) {
        var body = grapesjsEMP.editors[0].Canvas.getBody().getBoundingClientRect();
        var selected = e.view.el.getBoundingClientRect();
        self.rectModal = {
          l: selected.left * 100 / body.width,
          t: selected.top * 100 / body.height,
          h: selected.height * 100 / body.height,
          w: selected.width * 100 / body.width,
          view: e.view.el
        };
        self.modelToStyle = editor.StyleManager.getModelToStyle(e);
      });
    },
    eventComponentSelected: function eventComponentSelected(editor) {
      var _this2 = this;

      var self = this;
      // function listenersMove() {
      //   editor.runCommand('tlb-move');
      //
      // }
      /**/

      var settings = document.querySelector('.gjs-toolbar');
      editor.on('component:hovered', function (model) {
        _this2.updateResizer(model, '.gjs-highlighter');
      });

      editor.on('component:deselected', function (model, argument) {
        var type = model.get('type');
        if (type === 'text') {
          model.addAttributes({ contenteditable: false });
        }
        if (document.getElementById('rotateHandle')) document.getElementById('rotateHandle').style.display = 'none';
        if (type === 'countdown' || type === 'clocks' || type === 'dateHeure') {
          model.view.updateScript();
          localStorage.setItem('gjs-js', editor.getJs());
        }
      });

      var iframe = document.querySelector('.gjs-frame');
      iframe.contentWindow.addEventListener('mouseup', function () {
        var model = editor.getSelected();
        if (model) {
          var type = model.get('type');
          if (type === 'text') {
            if (window.b) window.b.fire('selectionchange');
          }
        }
      });

      editor.on('component:selected', function (model, argument) {
        var selector = '#gjs-sm-decorations';
        self.pos1 = 0;
        self.pos2 = 0;
        self.pos3 = 0;
        self.pos4 = 0;
        var showSvg = false;
        var isVisible = false;
        var type = model.get('type');
        if (type === 'custom_column') {
          self.updateWrapperProperties(editor);
        }
        var rotateElement = document.getElementById('rotateHandle');
        if (rotateElement && type !== 'wrapper') {
          var _iframe = document.querySelectorAll('.gjs-frame')[0];

          _iframe.contentWindow.addEventListener('mouseup', function (e) {
            _this2.mouseDown = false;
            editor.select(editor.DomComponents.getWrapper());
          });
        }
        var exist = model.getAttributes()['data-class'];
        self.setHiddenStyleManager(model);

        //self.initializeRotationPosition();
        var props = document.getElementById('selected-element-properties');
        if (props) {
          var hidden = type === 'image' || type === 'image_media' || type === 'pattern' || type === 'text' || type === 'filet' || type === 'custom_column2' || type === 'custom_column' || type === 'video_mp4' || model.attributes.name === 'Cell' || model.attributes.name === 'Row';
          props.style.display = hidden ? 'none' : 'block';
        }
        if (type === 'text') {
          settings.style.display = 'none';
          isVisible = true;
        } else if (type === 'image' && model.view) {
          model.view.el.setAttribute('onmousedown', 'return false;');
        }
        /* if (type === 'image') {
            var cc_Style = grapesjsEMP.editors[0].StyleManager.getModelToStyle(grapesjsEMP.editors[0].getSelected()).getStyle()
            if(cc_Style){
              cc_Style.width = '-1%'
              grapesjsEMP.editors[0].StyleManager.getModelToStyle(grapesjsEMP.editors[0].getSelected()).setStyle(cc_Style)
            }
           }*/
        if (model.attributes.attributes.id !== 'wrapper' || model.attributes.name === 'Cell' || model.attributes.name === 'Row') {
          selector = '#gjs-sm-general';
          if (document.getElementById('rotateHandle')) document.getElementById('rotateHandle').style.display = 'block';
        }

        self.addSettingButton(editor);

        if (document.querySelector(selector) && !document.querySelector(selector).classList.contains('gjs-sm-open')) {
          document.querySelector(selector + ' .gjs-sm-title').click();
        }

        document.querySelectorAll('.gjs-sm-sector.no-select.gjs-sm-open .gjs-sm-title').forEach(function (e) {
          e.click();
        });
        var dispoEditor = document.querySelector('#gjs-sm-disposition .gjs-sm-title');
        if (dispoEditor) dispoEditor.click();
        _this2.updateResizer(model, '.gjs-resizer-c');
        self.$root.$emit('add-text-animation', isVisible);
        if (model.collection.models[0].getAttributes()['data-js']) {
          model.set('resizable', false);
        }

        if (type === 'dateHeure') {
          model.set('resizable', false);
        }
        if (type === 'video_mp4') {
          model.set('resizable', false);
        }

        if (model.attributes.type === 'linkedin_widget') {
          setTimeout(function () {
            var wrapper = document.querySelector('[data-related-type="linkedin"]');
            if (wrapper) {
              var textarea = document.createElement('textarea');
              textarea.value = wrapper.querySelector('input').value;
              textarea.setAttribute('id', 'linkedin-iframe');
              textarea.setAttribute('rows', '7');
              wrapper.appendChild(textarea);
              textarea.addEventListener('keyup', function (e) {
                if (/<iframe.*<\/iframe>/g.test(textarea.value)) {
                  wrapper.querySelector('input').value = textarea.value;
                }
              });

              textarea.addEventListener('keydown', function (e) {
                if (e.keyCode === 13) {
                  e.preventDefault();
                  textarea.blur();
                }
              });

              var errorMessage = document.createElement('div');
              errorMessage.classList.add('error-message');
              errorMessage.innerHTML = 'lien embed invalide';
              wrapper.appendChild(errorMessage);

              textarea.addEventListener('blur', function () {
                if (/<iframe.*<\/iframe>/g.test(textarea.value)) {
                  wrapper.classList.remove('has-error');
                } else {
                  wrapper.classList.add('has-error');
                }
              });
            }
          }, 500);
        }
        if (type === 'countdown' || type === 'clocks' || type === 'dateHeure') {
          model.view.updateScript();
          localStorage.setItem('gjs-js', editor.getJs());
        }
        if (model.attributes.type === 'text' || model.attributes.type === 'link') {
          if (self.paramsClient.display_fonts && self.paramsClient.display_fonts.length > 0) {
            var fonts = self.paramsClient.display_fonts;
            var classes = model.getClasses();
            var cssComposer = self.editor.CssComposer;
            var css = cssComposer.getClassRule(classes[0]);
            if (classes && classes[0]) {
              var oldStyle = cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes ? cssComposer.getClassRule(classes[0]).attributes.style : {};

              var styleFamilyFont = oldStyle['font-family'];
              var newStyleFamilyFont = oldStyle['new-font-family'];
              var newFont = styleFamilyFont;
              var fontProperty = self.editor.StyleManager.getProperty('Text', 'font-family');
              window.y = fontProperty;

              if (!exist && fonts && (styleFamilyFont || styleFamilyFont === fonts[0].value)) {
                newFont = styleFamilyFont.replace(/['"]+/g, '');
                if (self.textSelected) {
                  self.textSelected = false;
                  self.blockSelected = true;
                  if (!newStyleFamilyFont || newStyleFamilyFont === fonts[0].value) {
                    self.addCustomFonts();
                  }
                }
              } else {
                var custom = [{
                  value: 'Din Regular',
                  name: 'Din Regular'
                }, {
                  value: 'Din bold',
                  name: 'Din bold'
                }];
                newFont = styleFamilyFont.replace(/['"]+/g, '');
                if (self.blockSelected) {
                  self.blockSelected = false;
                  self.textSelected = true;
                  if (!newStyleFamilyFont || newStyleFamilyFont === custom[0].value) {
                    self.addCustomFonts(custom);
                  }
                }
              }
              var newStyle = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, oldStyle, {
                'font-family': newFont
              });
              cssComposer.setClassRule(classes[0], newStyle);
            }
          }
          self.updatePositionCkeditors(editor);
        }
        var iconSave = document.querySelector('.icon-save');
        if (iconSave && !iconSave.classList.contains('icon-selected')) {
          iconSave.classList.remove('icon-selected');
          _this2.setShowIconSave(false);
        }

        var dimensions = document.getElementById('gjs-sm-dimension');
        if (dimensions) {
          var _hidden = type === 'custom-countdown' || type === 'clocks' || type === 'dateHeure';
          dimensions.style.display = _hidden ? 'none !important' : 'block';
        }
        var gjs = document.getElementById('gjs');
        if (type === 'countdown' || type === 'clocks' || type === 'dateHeure') {
          gjs.classList.add('grapes_edited');
        } else {
          if (gjs.classList.contains('grapes_edited')) gjs.classList.remove('grapes_edited');
        }
        _this2.updateAlignement();
        if (model.getAttributes()['data-class'] !== 'custom-credit') {
          self.addDefaultColors(self.editor, 'text');
        }
        if (model.getAttributes()['data-class'] !== 'custom-title') {
          self.addDefaultColors(self.editor, 'background');
        }

        if (type === 'image_media' || type === 'pattern') {
          var src = model.attributes.attributes.src ? model.attributes.attributes.src : model.view.el.firstChild.src;
          var extension = src.split('.').pop();
          if (extension && extension === 'svg' || model.attributes.svg === 'svg') {
            model.set('svg', 'svg');
            _this2.ShowToolBar('object-group');
            _this2.displayToolBar('paint-brush');
          } else {
            _this2.ShowToolBar('paint-brush');
            _this2.displayToolBar('object-group');
          }
        }

        if (type === 'wrapper') {
          //show btn reset Full Screen  background-image
          if (model.attributes.src && model.attributes.src !== null) {
            _this2.showImgBGToolBars();
          } else _this2.displayImgBGToolBar();
        }
        // when we add new componets with ( editor.addcomponet )
        if (type === 'image_media' || type === 'pattern') {
          model.set('resizable', {
            step: 0.2,
            minDim: 3,
            currentUnit: 1,
            autoHeight: true,
            tl: 1, // Top left
            tc: 1, // Top center
            tr: 1, // Top right
            cl: 1, // Center left
            cr: 1, // Center right
            bl: 1, // Bottom left
            bc: 1, // Bottom center
            br: 1, // Bottom right
            updateTarget: _this2.updateTarget
          });
        }

        window.selected = true;
        setTimeout(function () {
          window.selected = false;
        }, 1000);
      });
      // editor.on('canvas:dragover', (model, argument) => {
      //   var selected = editor.getSelected();
      //
      //   editor.runCommand('emp-move');
      // });
      // editor.on('component:deselected', model => {
      //   model.view.el.removeEventListener('mousedown', listenersMove);
      //
      //   // do your stuff...
      // });
    },
    setHiddenStyleManager: function setHiddenStyleManager(model) {
      var _this3 = this;

      var self = this;
      var type = model.get('type');
      var exist = model.getAttributes()['data-class'];
      var classes = model.getClasses();
      var cssComposer = self.editor.CssComposer;
      var sectors = self.editor.StyleManager.getSectors().models.map(function (sector) {
        return sector.attributes.id;
      });
      var ckEditor = document.querySelector('.gjs-rte-toolbar.gjs-one-bg');
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(sectors), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var sector = _step.value;

          var el = document.getElementById('gjs-sm-' + sector.toLowerCase());
          var property = document.querySelectorAll('#gjs-sm-' + sector.toLowerCase() + ' .gjs-sm-properties .gjs-sm-property');
          var propertyColors = document.querySelector('#gjs-sm-' + sector.toLowerCase() + ' .gjs-sm-properties #gjs-sm-recent-colors-background');
          if (type === 'text' && (exist === 'custom-title' || exist === 'custom-sharing' || exist === 'custom-credit')) {
            if (ckEditor) {
              ckEditor.classList.add('hide-sectors');
            }
            if (el) {
              el.classList.add('hide-sectors');
            }
            if (sector.toLowerCase() === 'disposition') {
              if (el) {
                el.classList.remove('hide-sectors');
              }
            }
            if (exist === 'custom-sharing' || exist === 'custom-title') {
              ckEditor.classList.remove('hide-sectors');
              if (sector.toLowerCase() === 'background' || sector.toLowerCase() === 'text') {
                if (property) {
                  property.forEach(function (prop) {
                    prop.classList.add('hide-properties');
                  });
                }
                if (propertyColors) {
                  propertyColors.classList.add('show-properties');
                }
                if (el) {
                  el.classList.remove('hide-sectors');
                }
                if (exist === 'custom-title') {
                  var colors = [{ name: '', value: '#E42313' }, { name: '', value: 'transparent' }];
                  self.addDefaultColors(self.editor, 'background', colors);
                }
              }
            }
            if (exist === 'custom-credit') {
              ckEditor.classList.remove('hide-sectors');
              var _colors = [{ name: '', value: '#E42313' }, { name: '', value: '#FFFFFF' }, { name: '', value: '#AAAAAA' }, { name: '', value: '#252E63' }, { name: '', value: '#081556' }];
              if (sector.toLowerCase() === 'text') {
                if (property) {
                  property.forEach(function (prop) {
                    prop.classList.add('hide-properties');
                  });
                }
                var custom = [{
                  value: 'Din Regular',
                  name: 'Din Regular'
                }, {
                  value: 'Din bold',
                  name: 'Din bold'
                }];
                var propertyFontFamily = document.querySelector('#gjs-sm-text #gjs-sm-font-family');
                if (propertyFontFamily) {
                  propertyFontFamily.classList.remove('hide-properties');
                }

                var propertyFontSize = document.querySelector('#gjs-sm-text #gjs-sm-font-size');
                if (propertyFontSize) {
                  propertyFontSize.classList.remove('hide-properties');
                }

                self.addDefaultColors(self.editor, 'text', _colors);
                if (!self.fontsChanged) {
                  self.fontsChanged = true;
                  self.addCustomFonts(custom);
                }
                if (propertyColors) {
                  propertyColors.classList.add('show-properties');
                }

                if (el) {
                  el.classList.remove('hide-sectors');
                }
              }
            }
          } else if (type === 'custom_column2' || type === 'custom_column' || type === 'filet') {
            if (el) {
              el.classList.add('hide-sectors');
            }

            if (sector.toLowerCase() === 'background' && type !== 'filet') {
              if (el) {
                el.classList.remove('hide-sectors');
              }
            }
          } else {
            if (type !== 'wrapper') {
              var fonts = self.paramsClient.display_fonts;
              if (classes && classes[0]) {
                var oldStyle = cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes ? cssComposer.getClassRule(classes[0]).attributes.style : {};

                var oldStyleFamilyFont = oldStyle && oldStyle['font-family'] ? oldStyle['font-family'].replace(/['"]+/g, '') : oldStyle;
                if (this.$route.name !== 'edit') {
                  if (!oldStyleFamilyFont || fonts && fonts[0] && oldStyleFamilyFont === fonts[0].value) {
                    self.addCustomFonts();
                  }
                }
              }
            }
            if (propertyColors) {
              propertyColors.classList.remove('show-properties');
            }
            if (property) {
              property.forEach(function (prop) {
                prop.classList.remove('hide-properties');
              });
            }
            if (el) {
              el.classList.remove('hide-sectors');
            }
            if (ckEditor) {
              ckEditor.classList.remove('hide-sectors');
            }
          }
          if (type === 'image_media' || type === 'pattern') {
            (function () {
              var propertytext = document.querySelector('#gjs-sm-text');
              propertytext.classList.add('hide-sectors');
              if (sector.toLowerCase() === 'background') {
                if (property) {
                  property.forEach(function (prop) {
                    prop.classList.add('hide-properties');
                  });
                }
              }
              //----------------
              document.querySelector('#gjs-sm-background .gjs-sm-title').innerHTML = '<i id="gjs-sm-caret" class="fa fa-caret-right"></i> ' + _this3.$i18n.t('styleManager.color');
              var icon = document.querySelector('#gjs-sm-background  #gjs-sm-caret');
              document.querySelector('#gjs-sm-background .gjs-sm-title').addEventListener('click', function () {
                if (icon.classList[1] === 'fa-caret-right') {
                  icon.classList.remove('fa-caret-right');
                  icon.classList.add('fa-caret-down');
                } else {
                  icon.classList.remove('fa-caret-down');
                  icon.classList.add('fa-caret-right');
                }
              });
            })();
          } else if (type === 'clocks') {
            if (sector.toLowerCase() === 'background' || sector.toLowerCase() === 'text') {
              if (el) {
                el.classList.add('hide-sectors');
              }
            }
          } else {
            (function () {
              document.querySelector('#gjs-sm-background .gjs-sm-title').innerHTML = '<i id="gjs-sm-caret" class="fa fa-caret-right"></i> ' + _this3.$i18n.t('styleManager.background');
              var icon = document.querySelector('#gjs-sm-background  #gjs-sm-caret');
              document.querySelector('#gjs-sm-background .gjs-sm-title').addEventListener('click', function () {
                if (icon.classList[1] === 'fa-caret-right') {
                  icon.classList.remove('fa-caret-right');
                  icon.classList.add('fa-caret-down');
                } else {
                  icon.classList.remove('fa-caret-down');
                  icon.classList.add('fa-caret-right');
                }
              });
            })();
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    addAttributesWrapper: function addAttributesWrapper(wrapper) {
      wrapper.set('attributes', { 'data-gjs-emp-wrapper': 'em-display' });
      wrapper.set('attributes', { id: 'wrapper' });
    },
    addTraitsToWrapper: function addTraitsToWrapper() {
      var self = this;
      var wrapper = this.editor.DomComponents.getWrapper();
      this.addTypeNumber(wrapper);
      wrapper.get('traits').add({
        name: 'duration',
        type: 'duration',
        units: ['s'],
        property: 'flex-basis',
        toRequire: 1,
        label: self.$t('labels.duration')
      });
      this.addAttributesWrapper(wrapper);
    },
    addTypeNumber: function addTypeNumber(wrapper) {
      var self = this;
      this.editor.TraitManager.addType('duration', {
        events: {
          keyup: 'onChange' // trigger parent onChange method on keyup
        },
        /**
         * Returns the input element
         * @return {HTMLElement}
         *
         */
        getInputEl: function getInputEl() {
          if (!this.inputEl) {
            var input = document.createElement('input');
            input.value = '00:00:20';
            input.placeholder = 'hh:mm:ss';
            this.inputEl = input;
          }
          return this.inputEl;
        },
        /**
         * Triggered when the value of the model is changed
         */
        onValueChange: function onValueChange() {
          var duration = this.model.get('value');
          if (self.currentSlide != null) {
            var inputEl = document.querySelector('#selected-element-properties input');
            if (duration.length > 3) {
              var isValid = this.validateTime(inputEl.value);
              if (!isValid) {
                inputEl.value = self.SecToTime(self.timeToSec(duration));
                return;
              }
            }
            if (duration.length === 2 || duration.length === 5) {
              inputEl.value = duration + ':';
            } else if (duration.length >= 8) {
              inputEl.value = self.SecToTime(self.timeToSec(duration));
            }

            var data = {
              duration: self.timeToSec(duration),
              uid: self.currentSlide.uid
            };
            if (self.$route.name !== 'segment') {
              self.updateSegmentDuration(data);
            } else {
              self.setSlideDuration(data);
            }
          }
        },
        validateTime: function validateTime(value) {
          var pattern = new RegExp('^((\\d)?\\d:)?[0-5]?[0-9]:[0-5]?[0-9]$');
          return pattern.test(value);
        }
      });
    },
    updateWidthImage: function updateWidthImage(params) {
      var img = params.img,
          className = params.className;

      var iframeEl = document.querySelector('.gjs-cv-canvas .gjs-frame');
      var iframeWidth = parseFloat(window.getComputedStyle(iframeEl).width);
      var iframeHeight = parseFloat(window.getComputedStyle(iframeEl).height);

      var cssComposer = this.editor.CssComposer;

      var oldStyle = cssComposer.getClassRule(className) && cssComposer.getClassRule(className).attributes.style ? cssComposer.getClassRule(className).attributes.style : {};

      var height = parseFloat(oldStyle.height) * iframeHeight / 100;
      var width = parseFloat(oldStyle.width) * iframeWidth / 100;

      var oldRatio = width / height;
      var newRatio = img.width / img.height;

      var style = {
        position: 'fixed',
        width: 'auto',
        height: 'auto'
      };

      if (oldStyle.height && oldStyle.height !== 'auto' && oldStyle.width && oldStyle.width !== 'auto') {
        if (oldRatio > newRatio) {
          style.height = oldStyle.height;
          style.width = parseInt(height * newRatio / iframeWidth * 100) + '%';
        } else {
          style.width = oldStyle.width;
          style.height = parseInt(width / newRatio / iframeHeight * 100) + '%';
        }
      } else {
        if (newRatio > iframeWidth / iframeHeight) {
          style.width = '50%';
        } else {
          style.height = '50%';
        }
      }

      var newStyle = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, oldStyle, style);
      cssComposer.setClassRule(className, newStyle);
    },
    createToggleButton: function createToggleButton(styleManager) {
      var sectors = styleManager.getSectors().models.map(function (sector) {
        return sector.attributes.id;
      });

      var _loop = function _loop(sector) {
        var btnToggle = document.createElement('button');
        btnToggle.innerHTML = '<i class="fa fa-caret-down"></i><span class="params-text">' + __WEBPACK_IMPORTED_MODULE_9__i18n_index_js__["a" /* default */].t('blocks.params') + '</span>';
        btnToggle.value = 'off';
        btnToggle.id = 'button-' + sector.toLowerCase();
        btnToggle.className = 'btn btn-block btn-outline-secondary btn-sm my-3';
        if (sector.toLowerCase() === 'disposition' || sector.toLowerCase() === 'dimension' || sector.toLowerCase() === 'decoration') {
          var el = document.querySelector('#gjs-sm-' + sector.toLowerCase() + ' .gjs-sm-properties #gjs-sm-params-' + sector.toLowerCase());
          if (!el) {
            return {
              v: false
            };
          }
          el.appendChild(btnToggle);
          btnToggle.addEventListener('click', function () {
            document.querySelector('#gjs-sm-' + sector.toLowerCase() + ' .gjs-sm-properties').classList.toggle('hide-advanced-properties');
          });
          document.querySelector('#gjs-sm-' + sector.toLowerCase() + ' .gjs-sm-properties').classList.add('hide-advanced-properties');
        }
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(sectors), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var sector = _step2.value;

          var _ret3 = _loop(sector);

          if ((typeof _ret3 === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(_ret3)) === "object") return _ret3.v;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return true;
    },
    updateStyleInputBackground: function updateStyleInputBackground(styleManager) {
      var backgroundEl = styleManager.filter(function (st) {
        return st.name.toLowerCase() === 'background';
      });
      if (backgroundEl) {
        var elButtonAdd = document.querySelector('#gjs-sm-background .gjs-sm-properties #gjs-sm-background .gjs-fields .gjs-sm-field #gjs-sm-add');
        var div = document.createElement('div');
        div.setAttribute('id', 'gjs-sm-add-btn');
        div.setAttribute('class', 'gjs-sm-add-btn');
        var elParentField = document.querySelector('#gjs-sm-background .gjs-sm-properties #gjs-sm-background .gjs-fields .gjs-sm-field.gjs-sm-stack');
        var backgEls = document.querySelector('#gjs-sm-background .gjs-sm-properties #gjs-sm-background .gjs-fields .gjs-sm-field.gjs-sm-stack div[data-layers-wrapper] .gjs-sm-layers.gjs-field');
        if (!elParentField) {
          return false;
        }
        if (!elButtonAdd) {
          return false;
        }
        if (!backgEls) {
          return false;
        }
        if (elParentField && elButtonAdd) {
          div.innerHTML = '<span class="text-add">' + this.$i18n.t('labels.text-add') + '</span>';
          div.appendChild(elButtonAdd);
          elParentField.appendChild(div);
        }
      }
      return true;
    },
    updateResizer: function updateResizer(model, selector) {
      var id = model.getAttributes().id;
      var child = this.editor.CssComposer.getIdRule(id);
      var resizer = document.querySelector(selector);
      var rect = model.view.el.getBoundingClientRect();
      if (resizer) {
        resizer.style.transform = 'rotate(0)';
      }
      if (child && resizer) {
        var style = child.attributes.style;
        var transform = style.transform;
        if (!transform) {
          return;
        }
        var degree = parseFloat(transform.replace('rotate(', '').replace('deg)', ''));

        resizer.style.transform = style.transform;
        resizer.style.transformOrigin = 'left top';

        var height = parseFloat(window.getComputedStyle(model.view.el).height);
        var width = parseFloat(window.getComputedStyle(model.view.el).width);

        if (degree <= -270) {
          var deviation = Math.sin(degree * Math.PI / 180) * height;
          setTimeout(function () {
            resizer.style.left = parseFloat(resizer.style.left) + deviation + 'px';
          }, 100);
        } else if (degree <= -180) {
          var _deviation = Math.sin((degree - 90) * Math.PI / 180) * height;
          setTimeout(function () {
            resizer.style.left = parseFloat(resizer.style.left) + rect.width + 'px';
            resizer.style.top = parseFloat(resizer.style.top) + _deviation + 'px';
          }, 100);
        } else if (degree <= -90) {
          var _deviation2 = Math.sin((degree - 180) * Math.PI / 180) * height;
          setTimeout(function () {
            resizer.style.left = parseFloat(resizer.style.left) + _deviation2 + 'px';
            resizer.style.transform = 'rotate(' + (degree - 180) + 'deg)';
          }, 100);
        } else {
          var _deviation3 = Math.sin((degree - 180) * Math.PI / 180) * width;
          setTimeout(function () {
            resizer.style.top = parseFloat(resizer.style.top) + _deviation3 + 'px';
          }, 100);
        }
      }
    },
    addCustomFonts: function addCustomFonts(customFonts) {
      var self = this;
      var fontProperty = this.editor.StyleManager.getProperty('Text', 'font-family');
      var fonts = self.paramsClient.display_fonts;
      if (customFonts && customFonts.length > 0) {
        fonts = customFonts;
      }
      fontProperty.attributes.options = [];
      fontProperty.attributes.list = [];
      // let list = this.editor.StyleManager.getProperty('Text', 'font-family').get('list');
      if (fonts && fonts.length > 0) {
        var list = [];
        fontProperty.set('list', list);
        fonts.forEach(function (element) {
          if (list.indexOf(element) === -1) {
            list.push(self.editor.StyleManager.getProperty('Text', 'font-family').addOption({
              value: element.value.replace(/['"]+/g, ''),
              name: element.name
            }));
          }
        });
      }

      // self.editor.StyleManager.render();
    },
    permissionUndoRepeat: function permissionUndoRepeat() {
      if (!this.paramsClient.modules.undo_redo_action) {
        var style = document.createElement('style');
        document.head.appendChild(style);
        var undoRedos = ['undo', 'repeat'];
        for (var i = 0; i < undoRedos.length; i++) {
          style.sheet.insertRule(' span.gjs-pn-btn.fa.fa-' + undoRedos[i] + '{ display:none; }');
        }
      }
    },


    /*Todo Mixin code*/
    permissionEyePreview: function permissionEyePreview() {
      if (!this.paramsClient.modules.eye_preview_action) {
        var style = document.createElement('style');
        document.head.appendChild(style);
        style.sheet.insertRule(' span.gjs-pn-btn.fa.fa-eye{ display:none; }');
      }
    },
    permissionCleanCanvas: function permissionCleanCanvas() {
      if (!this.paramsClient.modules.clean_canvas_action) {
        var style = document.createElement('style');
        document.head.appendChild(style);
        style.sheet.insertRule(' span.gjs-pn-btn.fa.fa-trash{ display:none; }');
      }
    },
    displayToolbarButtons: function displayToolbarButtons(editor) {
      var showToolbar = false;
      var selected = editor.getSelected();
      var type = selected.attributes.type;
      if (this.showToolbarButtons === false && type === 'social_media') {
        showToolbar = true;
      }
      if (showToolbar) {
        this.showHideToolBars('arrows');
      }
      if (showToolbar) {
        this.showHideToolBars('clone');
      }
    },
    permissionToolBar: function permissionToolBar() {
      if (this.permission.display_toolbar) {
        if (!this.permission.display_toolbar.drag) {
          //Mixin Code : displayToolBar
          this.displayToolBar('arrows');
        }

        if (!this.permission.display_toolbar.delete) {
          this.displayToolBar('trash-o');
        }

        if (!this.permission.display_toolbar.duplicate) {
          this.displayToolBar('clone');
        }

        if (!this.permission.display_toolbar.edit) {
          this.displayToolBar('paint-brush');
        }

        if (!this.permission.display_toolbar.parameter) {
          this.displayToolBar('cogs');
        }
      }
    },
    getDevices: function getDevices() {
      setTimeout(function () {
        var devices = document.querySelector('.gjs-pn-devices-b');
        // devices.style.display = 'none';
      }, 100);
    },
    isPluginIframe: function isPluginIframe() {
      var _this4 = this;

      var self = this;
      if (self.paramsClient.display_default_blocks) {
        (function () {
          var existImage = false;
          var existSocial = false;
          var existPattern = false;
          var id = void 0;
          var comp = void 0;
          var blocks = self.paramsClient.display_default_blocks.map(function (block) {
            return block.blocks;
          });
          for (var i = 0; i < blocks.length; i++) {
            blocks[i].forEach(function (item) {
              if (item.indexOf('image_media') > -1) {
                existImage = true;
                return existImage;
              }
              if (item.indexOf('social_media') > -1) {
                existSocial = true;
                return existSocial;
              }
              if (item.indexOf('pattern') > -1) {
                existPattern = true;
                return existPattern;
              }
            });
          }
          if (existImage) {
            id = 'image-media';
            comp = 'image_media';
            _this4.addModalUploadIframePlugin(id);
            _this4.changeModalBackgImage(_this4.editor, comp, id);
          }
          if (existSocial) {
            id = 'social-media';
            comp = 'social_media';
            _this4.addModalUploadIframePlugin(id);
          }
          if (existPattern) {
            id = 'pattern';
            comp = 'pattern';
            _this4.addModalUploadIframePlugin(id);
            _this4.changeModalBackgImage(_this4.editor, comp, id);
          }
        })();
      }
    },
    setHiddenButtonDevice: function setHiddenButtonDevice() {
      setTimeout(function () {
        document.querySelector('.gjs-pn-devices-b').style.display = 'none';
      }, 100);
    }
  }),

  mounted: function mounted() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var self, customStyleManager, editor, index, interval, tools, wrapper, range, buttonFullScreen;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              //this.eventGetMessageFromsvgFrame();

              self = _this5;


              if (_this5.paramsClient.display_devices && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this5.paramsClient.display_devices).length === 1) {
                _this5.setHiddenButtonDevice();
              }

              // permissionUndoRepeat
              self.permissionUndoRepeat();
              self.permissionEyePreview();
              self.permissionCleanCanvas();
              // permissionToolBar
              self.permissionToolBar();
              self.getDevices();
              customStyleManager = JSON.parse(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(self.paramsClient.display_custom_style_manager));


              __WEBPACK_IMPORTED_MODULE_8__storage_grapes_init__["a" /* default */].pluginsOpts['gjs-preset-webpage'].customStyleManager = customStyleManager;
              editor = {};

              if (grapesjs && grapesjs.editors && grapesjs.editors[0]) {
                grapesjs.editors = [];
                editor = grapesjs.init(__WEBPACK_IMPORTED_MODULE_8__storage_grapes_init__["a" /* default */]);
                grapesjs.editors.push(editor);
              } else {
                editor = grapesjs.init(__WEBPACK_IMPORTED_MODULE_8__storage_grapes_init__["a" /* default */]);
              }

              //  this.addCustomStyleManager(editor, this.paramsClient);
              _this5.editor = editor;
              _this5.blockManager = editor.BlockManager;
              _this5.panels = editor.Panels;
              _this5.modal = editor.Modal;
              _this5.commands = editor.Commands;
              _this5.styleManager = editor.StyleManager;
              __WEBPACK_IMPORTED_MODULE_49__main__["bus"].$on('setFormLang', function (code) {
                __WEBPACK_IMPORTED_MODULE_9__i18n_index_js__["a" /* default */].locale = code;

                _this5.$i18n.locale = code;
                _this5.addBeautifyTooltips(_this5.panels);
                _this5.translateBlocksName(_this5.blockManager.getAll().models);
                _this5.updateCategoryBlockManger(_this5.editor, _this5.paramsClient);
                _this5.translateStyleManagerName(_this5.styleManager.getSectors().models);
              });
              index = 0;
              interval = setInterval(function () {
                var done = _this5.createToggleButton(_this5.styleManager);
                index++;
                if (done || index === 20) {
                  clearInterval(interval);
                }
              }, 1000);


              eventHub.$on('updateWidthImage', self.updateWidthImage);
              editor.DomComponents.addType('image', {
                model: {
                  defaults: {
                    resizable: {
                      step: 0.2,
                      minDim: 3,
                      currentUnit: 1,
                      autoHeight: true,
                      tl: 1, // Top left
                      tc: 1, // Top center
                      tr: 1, // Top right
                      cl: 1, // Center left
                      cr: 1, // Center right
                      bl: 1, // Bottom left
                      bc: 1, // Bottom center
                      br: 1 // Bottom right
                    }
                  }
                }
              });
              editor.DomComponents.addType('countdown', {
                model: {
                  defaults: {
                    traits: [{
                      label: 'Début',
                      name: 'startfrom',
                      changeProp: 1,
                      type: 'datetime-local'
                    }, {
                      label: 'Fin du texte',
                      name: 'endText',
                      changeProp: 1
                    }],
                    resizable: {
                      step: 0.2,
                      minDim: 10,
                      maxDim: 100,
                      currentUnit: 1,
                      autoHeight: true,
                      tl: 1, // Top left
                      tc: 0, // Top center
                      tr: 1, // Top right
                      cl: 0, // Center left
                      cr: 0, // Center right
                      bl: 1, // Bottom left
                      bc: 0, // Bottom center
                      br: 1 // Bottom right
                    },
                    copyable: true
                  }
                }
              });

              _this5.setEditor(editor);
              _this5.setDeviceManagerEditor(editor, _this5.paramsClient);
              _this5.setDeviceEditor(editor, _this5.paramsClient);
              if (_this5.paramsClient.display_fonts && _this5.paramsClient.display_fonts.length > 0 && _this5.$route.name !== 'edit') {
                _this5.addCustomFonts();
              }

              _this5.eventComponentUpdateCountDown(editor);
              _this5.eventComponentUpdateStyleBackgroundImage(editor);
              _this5.eventEditText(editor);
              _this5.eventDragEnd(editor);
              tools = grapesjs.editors[0].getModel().get('Canvas').getToolsEl();
              /*var element = document.createElement('div');
                element.id = 'rotateHandle';
                element.className = 'rotate-handle';
                element.style.display = 'none';
                element.style.position = 'absolute';
                 tools.appendChild(element);
                element.addEventListener('mousedown', function(e) {
                  self.mouseDown = true;
                });
                let iframe = document.querySelectorAll('.gjs-frame')[0];
                iframe.contentWindow.addEventListener('mousemove', function(e) {
                  self.mouse(e);
                });*/

              editor.DomComponents.addType('text', {
                model: {
                  defaults: {
                    resizable: {
                      step: 0.1,
                      minDim: 3,
                      currentUnit: 1,
                      autoHeight: true,
                      tl: 0, // Top left
                      tc: 1, // Top center
                      tr: 0, // Top right
                      cl: 1, // Center left
                      cr: 1, // Center right
                      bl: 0, // Bottom left
                      bc: 1, // Bottom center
                      br: 0 // Bottom right
                    }
                  }
                }
              });
              // editor.DomComponents.addType('video', {
              //   model: {
              //     defaults: {
              //       attributes: {
              //         muted: true,
              //       },
              //     },
              //   },
              // });
              //this.eventAutoPlayVideo(editor);
              _this5.$root.$on('isVideoAutoplay', function (object) {
                var videoArray = ['video', 'player', 'video_mp4', 'playlist'];
                var cssComposer = editor.CssComposer;
                var model = object.model;
                var classes = model.getAttributes().class;
                if (videoArray.indexOf(object.video.type) > -1) {
                  var lastSlide = {
                    uid: self.currentSlide.uid,
                    components: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(object.video),
                    js: localStorage.getItem('gjs-js'),
                    html: localStorage.getItem('gjs-html'),
                    css: self.sanitizeCSS(localStorage.getItem('gjs-css')),
                    styles: localStorage.getItem('gjs-styles')
                  };
                  if (classes) {
                    classes = classes.split(' ');
                    if (classes && classes[0]) {
                      var oldStyle = cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes ? cssComposer.getClassRule(classes[0]).attributes.style : {};

                      var obj = { 'background-color': 'black' };
                      var newStyle = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_assign___default()({}, oldStyle, obj);
                      cssComposer.setClassRule(classes[0], newStyle);
                    }
                  }
                  if (_this5.$route.name === 'segment') {
                    _this5.updateSlide(lastSlide);
                  } else {
                    _this5.updateSlideInsideSegment(lastSlide);
                  }
                }
              });
              _this5.eventPausedPlayer(editor);
              _this5.eventComponentAdd(editor);
              _this5.eventComponentStyleUpdate(editor);
              _this5.eventComponentUpdate(editor);
              _this5.eventComponentSelectedModel(editor);
              _this5.eventComponentUpdateWidthSrc(editor);
              _this5.eventRunPreview(editor);
              _this5.eventStopPreview(editor);

              _this5.eventComponentSelected(editor);
              _this5.eventComponentUpdateImage(editor);
              _this5.eventCommandRun(editor);
              _this5.eventDelete(editor);
              _this5.eventFullScreen(editor);
              _this5.eventImageAdded(editor);
              _this5.eventClockAdded(editor);
              _this5.eventDateHeureAdded(editor);

              _this5.eventComponentStyleUpdateImageHeightOrWidht(editor);
              _this5.updateEditableTextHeight(editor);
              _this5.$root.$on('updateCanvasContent', function () {
                localStorage.setItem('id', _this5.currentSlide.id);
                _this5.updateSelectedComponent(editor, _this5.currentSlide);
                editor.addComponents('<style>html{overflow: hidden; user-select: none}#wrapper{height:100%}</style>');
              });
              _this5.$root.$on('saveCurrentDisposition', function (val) {
                _this5.loadCommandeSaveDisposition();
              });

              _this5.$root.$on('clearCanvas', function () {
                self.editor.DomComponents.clear();
              });
              _this5.$root.$on('oldBackgroundColor', function (val) {
                _this5.oldBackgroundColor = val;
              });

              editor.on('load', function () {
                //this.$root.$emit('updateCanvasContent');
                var layerBtn = document.querySelector('.gjs-pn-btn.fa-bars');
                eventHub.$emit('loadGrapes');
                grapesjsEMP.editors[0].on('canvas:dragover', function (model) {
                  if (document.querySelector('.gjs-frame').contentWindow.getSelection().type === 'Range') event.stopPropagation();
                });

                if (_this5.permission.display_layers) {
                  layerBtn.addEventListener('click', function () {
                    grapesjsEMP.editors[0].LayerManager.render();
                    _this5.handleLayersPanel(editor);
                  });
                } else {
                  layerBtn.style.display = 'none';
                }
              });
              _context.next = 59;
              return _this5.updateCategoryBlockManger(_this5.editor, _this5.paramsClient);

            case 59:
              //************wrapper*************//
              _this5.addTraitsToWrapper();
              _this5.translateBlocksName(_this5.blockManager.getAll().models);
              _this5.translateBlocksName(_this5.blockManager.getCategories().models);
              _this5.translateStyleManagerName(_this5.styleManager.getSectors().models);
              _this5.showSvgMator();
              _this5.FullbackgroundImg();
              _this5.rotateElement();
              _this5.ShowVideoFullScreen();
              _this5.loadCanvasClear(_this5.commands);
              _this5.showSetting();
              _this5.showScreenSetting();
              _this5.showEditor();
              _this5.loadButtonPreviewScreens();
              _this5.eventComponentCloneElement(editor);
              _this5.loadButtonSaveOptions();
              _this5.loadScreens(_this5.panels);
              _this5.addBeautifyTooltips(_this5.panels);
              _this5.showBorders(_this5.panels);
              _this5.eventLoad();
              _this5.loadImages();
              _this5.addPanels(_this5.panels);
              _this5.loadShowListPages(_this5.commands);
              _this5.dragElements(_this5.commands);
              self.removeButtons(_this5.panels);
              self.listenerFullScreen();
              //self.clickFullScreen();
              self.clickPreview();
              _this5.createBorderProperty(editor);
              _this5.eventStorageEndStore(editor);
              window.grapesjsEMP = grapesjs;
              _this5.TabsComponentAdd();
              _this5.isPluginIframe();
              wrapper = _this5.editor.DomComponents.getWrapper();
              range = document.querySelector('.gjs-field.gjs-field-range input');

              if (range) {
                range.addEventListener('input', function () {
                  var val = 1 - range.value;
                  wrapper.set('style', { 'background-color': 'rgba(255, 255, 255,' + val + ')' });
                }, false);
              }
              setTimeout(function () {
                _this5.initClone();
                _this5.eventColorPickerListener();
                _this5.addDefaultColors(_this5.editor, 'text');
                _this5.addDefaultColors(_this5.editor, 'background');
                if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this5.paramsClient.display_default_blocks).length > 2) {
                  _this5.setHiddenBlockManager();
                }
                //this.updateStyleInputBackground(customStyleManager);
              }, 1000);
              _this5.eventComponentStyleAlign(_this5.editor);
              eventHub.$on('showToolbarButtons', function (val) {
                _this5.showToolbarButtons = val;
                self.displayToolbarButtons(editor);
              });

              document.addEventListener('callFullScreenMethode', function (e) {
                self.updateSegmentDuration({
                  duration: e.myDuration,
                  uid: self.currentSlide.uid,
                  fullscreenVideo: true
                });
                // e.target matches elem
              }, false);

              buttonFullScreen = document.querySelector('.gjs-pn-btn.fa.fa-arrows-alt');

              buttonFullScreen.addEventListener('click', function () {
                if (buttonFullScreen.classList.contains('gjs-pn-active')) {
                  //is open
                  var data = { info: 'fullScreen', value: true };
                  parent.postMessage(data, '*');
                } else {
                  //is closed
                  var _data = { info: 'fullScreen', value: false };
                  parent.postMessage(_data, '*');
                }
              });

              /*setTimeout(function() {
                  const container = document.querySelector('.gjs-pn-views-container > div:nth-child(2)');
                  const ps = new PerfectScrollbar(container);
                }, 1000);*/
              /*
                setTimeout(() => {
                  var btn = document.createElement('BUTTON'); // Create a <button> element
                  btn.className = 'btn btn-block btn-outline-secondary btn-sm my-3';
                  btn.innerHTML = '<i class="fa fa-caret-down mr-2"></i>paramètres avancés'; // Insert text
                  document.getElementById('gjs-sm-float').appendChild(btn);
                }, 1000);*/

            case 99:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this5);
    }))();
  }
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_directives_HasPermission_js__ = __webpack_require__(30);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Informations',
  directives: {
    HasPermission: __WEBPACK_IMPORTED_MODULE_2__core_directives_HasPermission_js__["a" /* default */]
  },
  data: function data() {
    return {
      placement: 'top',
      showpop: false
    };
  },

  methods: {
    Getduration: function Getduration(value) {
      if (value != null) {
        var hours = Math.floor(value / 3600);
        value %= 3600;
        var minutes = Math.floor(value / 60);
        var seconds = value % 60;
        var addZero = function addZero(v) {
          return v < 10 ? '0' + v : v;
        };
        var t = [];
        t.push(addZero(hours));
        t.push(addZero(minutes));
        t.push(addZero(seconds));
        var time = t[0] + ':' + t[1] + ':' + t[2];
        return time;
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    segment: 'segments/getCurrent',
    template: 'slides/getTemplate',
    totalDurationSegments: 'segments/getAllSegmentsDuration',
    totalDurationScreens: 'slides/getAllScreensDuration',
    canvasSize: 'common/getCanvasSize',
    paramsClient: 'getParamsClients'
  }), {
    isSegmentMode: function isSegmentMode() {
      return this.$route.name === 'segment';
    },
    isEditMode: function isEditMode() {
      return this.$route.name === 'edit';
    }
  })
});

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InformationsNew',
  data: function data() {
    return {
      marginLeft: 0
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    segment: 'segments/getCurrent',
    slide: 'slides/getCurrent',
    paramsClient: 'getParamsClients'

  })),
  mounted: function mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    console.log("valuess ", this.segment);
  },

  methods: {
    handleResize: function handleResize() {
      var _this = this;

      setTimeout(function () {
        var p = document.querySelector('.gjs-frame');
        _this.marginLeft = p.offsetLeft + 20 + 'px';
        // this.marginRight =p.offsetParent.offsetWidth - p.offsetLeft  + 20 + 'px';
        console.log("valeeeuuss", _this.segment);
      }, 1000);
    },
    showPanel: function showPanel() {
      this.$root.$emit('showPanel');
    }
  }
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_http_http_token__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_router_router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_en_US__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_fr_FR__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_Mixin_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_infinite_loading__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_infinite_loading__);



var _mixins$data$i18n$mix;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = (_mixins$data$i18n$mix = {
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_Mixin_js__["a" /* default */]],
  data: function data() {
    return {
      idSelectedTheme: [],
      showSelect: false,
      selected_vid: '',
      all_video: [],
      page: 0,
      total_number: 0,
      defaultScreenshot: '/static/images/play_thumbnail.svg',
      indexvideo: '',
      disabledSelectButton: true,
      videoGeneric: {},
      searchTitle: '',
      screenType: '',
      themId: 0,
      options: [],
      textToSearch: ''
    };
  },

  i18n: {
    messages: {
      en: __WEBPACK_IMPORTED_MODULE_5__i18n_en_US__["a" /* default */],
      fr: __WEBPACK_IMPORTED_MODULE_6__i18n_fr_FR__["a" /* default */]
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mixins$data$i18n$mix, 'mixins', [__WEBPACK_IMPORTED_MODULE_8__mixins_Mixin_js__["a" /* default */]]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mixins$data$i18n$mix, 'mounted', function mounted() {
  this.optionSelect();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mixins$data$i18n$mix, 'props', {
  genericType: {
    type: String
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mixins$data$i18n$mix, 'created', function created() {
  var self = this;
  self.reloadVideoList(1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mixins$data$i18n$mix, 'computed', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
  dispositions: 'dispositions/getAll',
  paramsClient: 'getParamsClients',
  getAllSelected: 'segments/getAllSelected',
  getAllSelectedSlides: 'slides/getAllSelected',
  getGenericThem: 'common/getGenericThem',
  getOptionsThemeSelect: 'common/getOptionsThemeSelect'
}))), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mixins$data$i18n$mix, 'components', {
  InfiniteLoading: __WEBPACK_IMPORTED_MODULE_9_vue_infinite_loading___default.a
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mixins$data$i18n$mix, 'methods', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['pushScreen']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('slides', ['setSlidesGeneric']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('segments', ['setSegmentsGeneric', 'setVideoIntro', 'setSegmentsGenericFinEmpty']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])({
  setSelectedVideo: 'common/setSelectedVideo',
  searchGenericVideo: 'common/searchGenericVideo'
}), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('common', ['setGenericThem']), {
  hasStartGeneric: function hasStartGeneric(segment) {
    return segment.screens.some(function (s) {
      return s.type === 'startGeneric';
    });
  },
  duration: function duration(_duration) {
    return this.getDuration(_duration);
  },
  isSelected: function isSelected(video) {
    var generic = document.getElementById('list_videos').getAttribute('generic');
    var index = document.getElementById('list_videos').getAttribute('data-index');
    if (this.$route.name === 'segment') {
      if (generic === 'debut') {
        var startGeneric = this.getAllSelectedSlides.find(function (s) {
          return s.type === 'startGeneric';
        });
        if (startGeneric) {
          this.disabledSelectButton = false;
          return startGeneric.html.indexOf(video.lien) > -1;
        }
      }
    } else {
      if (generic === 'debut') {
        var _startGeneric = this.getAllSelected.find(function (s) {
          return s.type === 'startGeneric';
        });
        if (_startGeneric) {
          this.disabledSelectButton = false;
          return _startGeneric.screens[0].html.indexOf(video.lien) > -1 || video.lienMp4 && _startGeneric.screens[0].html.indexOf(video.lienMp4.substring(0, video.lienMp4.length - 13)) > -1;
        }
      } else if (generic === 'fin') {
        var finishGeneric = this.getAllSelected.find(function (s) {
          return s.type === 'finishGeneric';
        });
        if (finishGeneric) {
          this.disabledSelectButton = false;
          return finishGeneric.screens[0].html.indexOf(video.lien) > -1 || video.lienMp4 && finishGeneric.screens[0].html.indexOf(video.lienMp4.substring(0, video.lienMp4.length - 13)) > -1;
        }
      } else if (generic === 'intro') {
        var introGeneric = this.getAllSelected[index].screens.find(function (s) {
          return s.type === 'startGeneric';
        });
        if (introGeneric) {
          this.disabledSelectButton = false;
          return introGeneric.html.indexOf(video.lien) > -1 || video.lienMp4 && introGeneric.html.indexOf(video.lienMp4.substring(0, video.lienMp4.length - 13)) > -1;
        }
      }
    }
  },
  SelectVideo: function SelectVideo(video, index) {
    var _this = this;

    var videoObj = {
      lien: video.lien,
      lienMp4: video.lienMp4,
      id: video.id,
      logo: video.logo,
      title: video.title,
      duration: video.duration
    };
    this.videoGeneric = videoObj;
    this.selected_vid = this.videoGeneric.id;
    this.disabledSelectButton = false;

    var videoTag = document.querySelector('.video-tag-' + index);
    videoTag.classList.toggle('is-selected-video');
    if (videoTag.classList.contains('is-selected-video')) {
      this.disabledSelectButton = false;
    } else {
      this.videoGeneric = {};
      this.disabledSelectButton = this.genericType === 'fin' ? false : true;
    }
    if (this.genericType === 'debut') {
      setTimeout(function () {
        _this.addGeneriqueVideo();
      }, 100);
    }
  },
  DeselectVideo: function DeselectVideo() {
    var videoObj = {
      lien: '',
      lienMp4: '',
      id: '',
      logo: '',
      title: '',
      duration: ''
    };
    this.videoGeneric = videoObj;
    this.selected_vid = '';
    this.disabledSelectButton = this.genericType === 'fin' ? false : true;
    this.addGeneriqueVideo();
  },
  closeGenericList: function closeGenericList() {
    eventHub.$emit('eventShowListVideo', false);
  },
  addGeneriqueVideo: function addGeneriqueVideo() {
    var _this2 = this;

    var self = this;
    if (this.genericType === 'fin' && !!!this.videoGeneric.lien) {
      this.setSegmentsGenericFinEmpty({ type: 'finishGeneric' });
      self.selected_vid = 0;
      eventHub.$emit('eventShowListVideo', false);
      return;
    }
    if (this.genericType === 'debut' && !!!this.videoGeneric.lien) {

      return;
    }
    var generic = document.getElementById('list_videos').getAttribute('generic');
    var index = document.getElementById('list_videos').getAttribute('data-index');
    var display_default_blocks = this.paramsClient.display_default_blocks;
    var src = this.videoGeneric.lien;
    if (display_default_blocks && display_default_blocks.length > 0) {
      var blocks = display_default_blocks.map(function (block) {
        return block.blocks;
      });
      blocks.forEach(function (block) {
        for (var i = 0; i < block.length; i++) {
          if (block[i] === 'video_mp4') {
            src = _this2.videoGeneric.lienMp4;
          }
        }
      });
    }
    var slide = {
      src: src,
      title: 'generique ' + generic + ' ' + self.makeId(),
      logo: this.videoGeneric.logo,
      options: {
        duration: this.videoGeneric.duration
      },
      originalDuration: this.videoGeneric.duration
    };
    if (generic === 'intro') {
      slide.type = 'startGeneric';
      slide.index = index;
      self.setVideoIntro(slide);
    } else {
      if (generic === 'debut') {
        slide.type = 'startGeneric';
      } else {
        slide.type = 'finishGeneric';
      }
      if (self.$route.name === 'segment') {
        self.setSlidesGeneric(slide);
      } else {
        self.setSegmentsGeneric(slide);
      }
    }

    self.selected_vid = this.videoGeneric.id;
    self.$toasted.show(__WEBPACK_IMPORTED_MODULE_7__i18n__["a" /* default */].t('module.generic.success_add'), {
      theme: 'bubble',
      position: 'top-center',
      duration: 4000,
      icon: 'fa-check-circle',
      className: 'save-toast'
    });
    eventHub.$emit('eventShowListVideo', false);
  },
  reloadVideoList: function reloadVideoList() {
    var self = this;
    self.page = self.page + 1;
    var params = {};
    if (this.getGenericThem == 0) {
      params = {
        id: '',
        page: self.page,
        nbParPage: 20,
        client: localStorage.getItem('client')
      };
    } else {
      this.themeId = this.getGenericThem;
      params = {
        id: '',
        page: self.page,
        nbParPage: 20,
        idTheme: this.themeId,
        client: localStorage.getItem('client'),
        maxBitrate: true
      };
    }
    if (this.searchTitle) {
      params.searchWord = this.searchTitle;
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_http_http_token__["a" /* HTTP */])(window.ApiToken).get(__WEBPACK_IMPORTED_MODULE_3__core_router_router__["a" /* default */].generate('api_media_get_media', params)).then(function (response) {
      document.getElementById('loader-liste-dispo').style.visibility = 'hidden';
      if (response.data.code === 200) {
        if (response.data) {
          self.total_number = self.total_number + response.data.medias.length;
          self.all_video = self.all_video.concat(response.data.medias);
          var listElm = document.getElementById('list_video');
          listElm.onscroll = function () {
            if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
              if (self.all_video.length < response.data.nombre_total) {
                document.getElementById('loader-liste-dispo').style.visibility = 'visible';
                self.reloadVideoList();
              } else {
                document.getElementById('loader-liste-dispo').style.visibility = 'hidden';
              }
            }
          };
        }
      }
    }, function (response) {
      //self.hideLoader();
    });
  },
  searchVideo: function searchVideo(x) {
    if (x) {
      // title = document.getElementById('inputSearch').value;
      this.searchTitle = this.textToSearch;
      this.page = 0;
      this.all_video = [];
      this.searchGenericVideo(this.searchTitle);
      this.reloadVideoList(this.themeId);
      document.getElementById('loader-liste-dispo').style.visibility = 'visible';
    } else {
      this.textToSearch = '';
      this.searchTitle = '';
      this.page = 0;
      this.all_video = [];
      this.searchGenericVideo(this.searchTitle);
      this.reloadVideoList(this.themeId);
      document.getElementById('loader-liste-dispo').style.visibility = 'hidden';
    }
  },
  btnConfirm: function btnConfirm() {
    var self = this;
    self.close();
  },
  optionSelect: function optionSelect() {
    if (this.getOptionsThemeSelect.length != 0) {
      this.options = this.getOptionsThemeSelect;
      this.idSelectedTheme = this.options[0].id;
      if (this.options.length > 1) this.showSelect = true;
    }
  },
  onChangeThemId: function onChangeThemId() {
    this.setGenericThem(this.idSelectedTheme);
    this.all_video = [];
    this.page = 0;
    this.reloadVideoList();
    document.getElementById('loader-liste-dispo').style.visibility = 'visible';
  }
})), _mixins$data$i18n$mix);

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddGeneric',
  data: function data() {
    return {
      defaultUrl: false,
      defaultUrlGeneric: false,
      defaultUrlConclusion: false,
      isSubmited: false,
      type: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    startGeneric: 'segments/getStartGeneric',
    finishGeneric: 'segments/getFinishGeneric',
    typeGeneric: 'segments/getTypeGeneric',
    paramsClient: 'getParamsClients'
  }), {
    getTitleTranslated: function getTitleTranslated() {
      this.typeGeneric === 'debut' ? this.type = this.$t('modal.add_generic.start') : this.type = this.$t('modal.add_generic.end');
      return this.type;
    }
  }),
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__["a" /* default */]],
  mounted: function mounted() {
    this.defaultUrlgeneric();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('segments', ['setSegmentsGeneric']), {
    defaultUrlgeneric: function defaultUrlgeneric() {
      if (this.paramsClient.display_default_urls) {
        if (this.paramsClient.display_default_urls.conclusion != null) this.defaultUrlConclusion = true;
        if (this.paramsClient.display_default_urls.generic != null) this.defaultUrlGeneric = true;
        this.defaultUrl = this.defaultUrlGeneric;
      }
    },
    emitDefaultVideos: function emitDefaultVideos() {
      if (this.isSubmited) {
        return;
      }

      if (!this.startGeneric && this.defaultUrlGeneric) {
        this.setSegmentsGeneric(this.paramsClient.display_default_urls.generic);

        /** Table: webtv_param : display_default_urls
          "generic":{
          "src":"x",
          "title":"startGeneric",
          "logo":"zzz.jpg",
          "options": {
              "duration": 50
           },
          "originalDuration": 50,
          "type": "startGeneric"
          }
         * */
      } else if (!this.finishGeneric && this.defaultUrlConclusion) {
        this.setSegmentsGeneric(this.paramsClient.display_default_urls.conclusion);
      }

      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
      this.close();
    },
    submit: function submit() {
      this.isSubmited = true;
      this.$root.$emit('bv::hide::modal', 'modal-add-generic', '#btnShow');
      if (!this.startGeneric) {
        this.$root.$emit('show-list-video', 'debut');
      } else if (!this.finishGeneric) {
        this.$root.$emit('show-list-video', 'fin');
      }
    },
    close: function close() {
      this.$root.$emit('bv::hide::modal', 'modal-add-generic');
      this.defaultUrl = this.defaultUrlConclusion;
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
    }
  })
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tui_image_editor_dist_tui_image_editor_css__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tui_image_editor_dist_tui_image_editor_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_tui_image_editor_dist_tui_image_editor_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tui_color_picker_dist_tui_color_picker_css__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tui_color_picker_dist_tui_color_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_tui_color_picker_dist_tui_color_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toast_ui_vue_image_editor__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toast_ui_vue_image_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__toast_ui_vue_image_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ImageEditorContainer__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ImageEditorContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ImageEditorContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//

// Load Style Code






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditorImageComponent',
  components: {
    'tui-image-editor': __WEBPACK_IMPORTED_MODULE_3__toast_ui_vue_image_editor__["ImageEditor"],
    ImageEditorContainer: __WEBPACK_IMPORTED_MODULE_4__ImageEditorContainer___default.a
  },

  data: function data() {
    return {
      changed: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    imageEdited: 'common/getImageEdited'
  })),
  created: function created() {
    eventHub.$on('eventShowEditorImage', this.eventShowEditorImage);
  },

  methods: {
    eventShowEditorImage: function eventShowEditorImage(show) {
      this.changed = show;
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditorSvgMatorComponent',
  components: {},
  data: function data() {
    return {
      footer: true,
      url: '',
      changed: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    paramsClient: 'getParamsClients'
  })),

  methods: {
    closeModal: function closeModal() {
      this.changed = false;
      var obj = { resetSvg: true };
      window.frames['svg-iframe'].contentWindow.postMessage(obj, '*');
    },
    loadiframe: function loadiframe() {
      var obj = { resetSvg: false };
      window.frames['svg-iframe'].contentWindow.postMessage(obj, '*');
      if (this.paramsClient.display_default_urls && this.paramsClient.display_default_urls.svg_mator) {
        this.url = this.paramsClient.display_default_urls.svg_mator;
      } else {}
    }
  },
  created: function created() {
    var _this = this;

    this.$root.$on('loadiframe', function () {
      _this.loadiframe();
    });
  },
  mounted: function mounted() {
    this.loadiframe();
  }
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ExitSave',
  data: function data() {
    return {
      defaultUrl: false,
      defaultUrlGeneric: false,
      defaultUrlConclusion: false,
      isSubmited: false,
      type: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    paramsClient: 'getParamsClients',
    segment: 'segments/getCurrent'

  })),
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__["a" /* default */]],
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('segments', ['setSegmentsGeneric']), {
    close: function close() {
      this.$root.$emit('bv::hide::modal', 'modal-exit-save');
    },
    back: function back() {
      this.$root.$emit('bv::hide::modal', 'modal-exit-save');
      this.$router.push({ name: 'ListSegment' });
    }
  })
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ExtendSegmentDuration',
  data: function data() {
    return {
      duration: 0,
      uid: 0,
      showCrop: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    startGeneric: 'segments/getStartGeneric'
  })),
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('segments', ['cropVideoFromSegment', 'appendBlankSlideToSegment', 'FixdurationVideoFromSegment', 'updateSegmentDuration']), {
    extend: function extend() {
      this.appendBlankSlideToSegment(this.uid);
      this.$refs.extendSegmentDuration.hide();
      document.getElementById('close-modal-image') && document.getElementById('close-modal-image').click();
    },
    crop: function crop() {
      this.cropVideoFromSegment(this.uid);
      this.$refs.extendSegmentDuration.hide();
      document.getElementById('close-modal-image') && document.getElementById('close-modal-image').click();
    }
  }),
  created: function created() {
    var _this = this;

    this.$root.$on('eventExtendSegmentDuration', function (_ref) {
      var duration = _ref.duration,
          uid = _ref.uid;

      _this.uid = uid;
      _this.duration = duration;
      _this.$refs.extendSegmentDuration.show();
    });

    this.$root.$on('eventExtendDuration', function (_ref2) {
      var duration = _ref2.duration,
          uid = _ref2.uid;

      _this.uid = uid;
      _this.duration = duration;
      _this.extend();
    });
  }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tui_image_editor_dist_tui_image_editor_css__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tui_image_editor_dist_tui_image_editor_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_tui_image_editor_dist_tui_image_editor_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tui_color_picker_dist_tui_color_picker_css__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tui_color_picker_dist_tui_color_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_tui_color_picker_dist_tui_color_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toast_ui_vue_image_editor__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toast_ui_vue_image_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__toast_ui_vue_image_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_http_http_file_common__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_router_router__ = __webpack_require__(18);

//
//
//
//
//
//
//
//
//
//
//
//
//

// Load Style Code






var icona = __webpack_require__(771);
var iconb = __webpack_require__(772);
var iconc = __webpack_require__(773);
var icond = __webpack_require__(774);

var blackTheme = {
  // or white
  // main icons
  'menu.normalIcon.path': icond,
  'menu.activeIcon.path': iconb,
  'menu.disabledIcon.path': icona,
  'menu.hoverIcon.path': iconc
};
var locale_ru_Fr = {
  Undo: 'Annuler',
  Redo: 'Refaire',
  Reset: 'Réinitialiser',
  Delete: 'Supprimer',
  'Delete-all': 'Supprimer tout',
  Crop: 'Recadrer',
  Flip: 'Miroir',
  Rotate: 'Pivoter',
  Draw: 'Dessiner',
  Shape: 'Formes',
  Icon: 'Icones',
  Text: 'Texte',
  Mask: 'Masque',
  Filter: 'Filtrer',
  Tint: 'Tenir',
  Multiply: 'Multiplier',
  Blend: 'Mélanger',
  Grayscale: 'Niv. de gris',
  Sepia: 'Sépia',
  Sepia2: 'Sépia 2',
  Invert: 'Inverser',
  Blur: 'Brouiller',
  Sharpen: 'Aiguiser',
  Emboss: 'Gaufrer',
  'Remove White': 'Supp. blanc',
  'Gradient-transparency': 'Niv. de gris',
  Brightness: 'Luminosité',
  Noise: 'Bruit',
  Pixelate: 'Pixellisation',
  'Color Filter': 'Couleur de filtre',
  Threshold: 'Seuil',
  Value: 'Valeur',
  Custom: 'Personnalisé',
  Square: 'Carré',
  Apply: 'Appliquer',
  Cancel: 'Annuler',
  Range: 'Intervalle',
  Free: 'Libre',
  Straight: 'Ligne',
  Color: 'Couleur',
  'Flip X': 'Miroir sur x',
  'Flip Y': 'Miroir sur y',
  Fill: 'Remplir',
  Stroke: 'Contour',
  Arrow: 'Flèche',
  Bold: 'Gras',
  Italic: 'Italique',
  Underline: 'Souligné',
  Left: 'Gauche',
  Center: 'Centre',
  Right: 'Droite',
  'Text size': 'Taille de texte',
  'Arrow-2': 'Flèche 2',
  'Arrow-3': 'Flèche 3',
  'Star-1': 'Etoile 1',
  'Star-2': 'Etoile 2',
  Heart: 'Coeur',
  Bubble: 'Boules',
  Location: 'Localisation',
  'Custom icon': 'Icone personnalisé',
  'No file chosen': 'Aucun fichier choisi',
  'Load Mask Image': 'Charger image de masque'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ImageEditorContainer',
  components: {
    'tui-image-editor': __WEBPACK_IMPORTED_MODULE_4__toast_ui_vue_image_editor__["ImageEditor"]
  },
  data: function data() {
    return {
      useDefaultUI: true,
      options: {
        includeUI: {
          theme: blackTheme,
          locale: locale_ru_Fr,
          initMenu: 'filter',
          loadImage: {
            path: '',
            name: 'Blank'
          },

          menuBarPosition: 'bottom'
        },
        cssMaxWidth: 700,
        cssMaxHeight: 500
      },
      isVisible: false
    };
  },

  watch: {
    imageEdited: function imageEdited() {}
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    imageEdited: 'common/getImageEdited'
  })),
  created: function created() {
    this.options.includeUI.loadImage.path = this.imageEdited;
  },
  mounted: function mounted() {
    var self = this;
    this.customUIEditorImaheTUI();
    var btns = document.querySelectorAll('.tui-image-editor-item.normal');
    var btnSave = document.getElementById('saveBtn');
    var btnCancel = document.getElementById('cancelBtn');
    btns.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.id === 'tie-btn-crop') {
          btnSave.style.display = 'none';
          btnCancel.style.display = 'none';
        } else {
          btnSave.style.display = 'inline-block';
          btnCancel.style.display = 'inline-block';
        }
      });
    });
    var btnsAfterCrop = document.getElementById('tie-crop-button');

    btnsAfterCrop.addEventListener('click', function () {
      btnSave.style.display = 'inline-block';
      btnCancel.style.display = 'inline-block';
    });
    document.querySelector('.spinner-border').style.display = 'none';
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('common', ['setImageEdited']), {
    customUIEditorImaheTUI: function customUIEditorImaheTUI() {
      var saveButton = document.createElement('button');
      saveButton.className = 'tui-image-editor-save-btn';
      saveButton.id = 'saveBtn';
      saveButton.innerHTML = '<span id="spinner-border"class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Enregistrer';
      var cancelButton = document.createElement('button');
      cancelButton.className = 'tui-image-editor-cancel-btn';
      cancelButton.id = 'cancelBtn';
      cancelButton.innerText = 'Annuler';

      document.querySelector('.tui-image-editor-header-logo').style.display = 'none';
      var downloadButton = document.querySelector('.tui-image-editor-header-buttons .tui-image-editor-download-btn');
      downloadButton.replaceWith(cancelButton);

      var LoadButton = document.querySelectorAll('.tui-image-editor-load-btn')[1].parentElement;
      LoadButton.replaceWith(saveButton);

      saveButton.addEventListener('click', this.onSaveImage);
      cancelButton.addEventListener('click', this.onColseEditor);
    },
    hiddenBtn: function hiddenBtn() {
      btnSave.style.display = 'none';
      btnCancel.style.display = 'none';
    },
    onAddText: function onAddText(res) {
      console.group('addText');
      console.groupEnd();
    },
    onObjectMoved: function onObjectMoved(res) {
      console.group('objectMoved');
      console.groupEnd();
    },
    dataURLtoFile: function dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    onSaveImage: function onSaveImage() {
      document.querySelector('.spinner-border').style.display = 'inline-block';
      var self = this;
      var imageEditor = this.$refs.tuiImageEditor;
      var dataurl = imageEditor.invoke('toDataURL', 'image/jpeg');
      var file = this.dataURLtoFile(dataurl, 'image1');
      var formData = new FormData();
      formData.append('empApiFileForm[thumb]', file); //containing all the selected images from local
      formData.append('_format', 'json'); //containing all the selected images from local
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_http_http_file_common__["a" /* HTTP_FILES */])(window.ApiToken).post(__WEBPACK_IMPORTED_MODULE_6__core_router_router__["a" /* default */].generate('api_bloc_post_thumb'), formData).then(function (response) {
        if (response && response.data && response.data.code == 200) {
          document.querySelector('.spinner-border').style.display = 'none';

          var image = response.data.location.url;

          grapesjs.editors[0].AssetManager.add(image);

          try {
            try {
              grapesjs.editors[0].getSelected().attributes.attributes.src = image;
            } catch (e) {
              console.log(e);
            }

            grapesjs.editors[0].getSelected().attributes.src = image;
            grapesjs.editors[0].getSelected().set('src', image);
            self.setImageEdited(image);

            document.querySelector('.gjs-frame').contentWindow.document.querySelector('.gjs-comp-selected').children[0].setAttribute('src', self.imageEdited);
          } catch (e) {
            console.log(e);
          }
          eventHub.$emit('eventShowEditorImage', false);
        }
      }, function (response) {
        //self.hideLoader();
      });
    },
    onColseEditor: function onColseEditor() {
      eventHub.$emit('eventShowEditorImage', false);
      this.setImageEdited('');
    }
  })
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_http_http_token__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_router_router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__storages_js__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_en_US__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_fr_FR__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_Mixin_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_infinite_loading__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_infinite_loading__);



var _mixins$data$i18n$mix;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = (_mixins$data$i18n$mix = {
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_Mixin_js__["a" /* default */]],
  data: function data() {
    return {
      idSelectedTheme: [],
      showSelect: false,
      selected_vid: '',
      all_video: [],
      page: 0,
      total_number: 0,
      defaultScreenshot: '/display/static/images/play_thumbnail.svg',
      indexvideo: '',
      disabledSelectButton: true,
      videoGeneric: {},
      searchTitle: '',
      screenType: '',
      genericType: '',
      themId: 0,
      options: []
    };
  },

  i18n: {
    messages: {
      en: __WEBPACK_IMPORTED_MODULE_6__i18n_en_US__["a" /* default */],
      fr: __WEBPACK_IMPORTED_MODULE_7__i18n_fr_FR__["a" /* default */]
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mixins$data$i18n$mix, 'mixins', [__WEBPACK_IMPORTED_MODULE_8__mixins_Mixin_js__["a" /* default */]]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mixins$data$i18n$mix, 'mounted', function mounted() {
  this.optionSelect();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mixins$data$i18n$mix, 'created', function created() {
  var self = this;
  self.reloadVideoList(1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mixins$data$i18n$mix, 'computed', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
  dispositions: 'dispositions/getAll',
  paramsClient: 'getParamsClients',
  getAllSelected: 'segments/getAllSelected',
  getAllSelectedSlides: 'slides/getAllSelected',
  getGenericThem: 'common/getGenericThem',
  getOptionsThemeSelect: 'common/getOptionsThemeSelect'
}))), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mixins$data$i18n$mix, 'components', {
  InfiniteLoading: __WEBPACK_IMPORTED_MODULE_9_vue_infinite_loading___default.a
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mixins$data$i18n$mix, 'methods', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['pushScreen']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('slides', ['setSlidesGeneric']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('segments', ['setSegmentsGeneric', 'setVideoIntro']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])({
  setSelectedVideo: 'common/setSelectedVideo',
  searchGenericVideo: 'common/searchGenericVideo'
}), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('common', ['setGenericThem']), {
  hasStartGeneric: function hasStartGeneric(segment) {
    return segment.screens.some(function (s) {
      return s.type === 'startGeneric';
    });
  },
  duration: function duration(_duration) {
    return this.getDuration(_duration);
  },
  isSelected: function isSelected(video) {
    var generic = document.getElementById('list_videos').getAttribute('generic');
    var index = document.getElementById('list_videos').getAttribute('data-index');
    if (this.$route.name === 'segment') {
      if (generic === 'debut') {
        var startGeneric = this.getAllSelectedSlides.find(function (s) {
          return s.type === 'startGeneric';
        });
        if (startGeneric) {
          this.disabledSelectButton = false;
          return startGeneric.html.indexOf(video.lien) > -1;
        }
      }
    } else {
      if (generic === 'debut') {
        var _startGeneric = this.getAllSelected.find(function (s) {
          return s.type === 'startGeneric';
        });
        if (_startGeneric) {
          this.disabledSelectButton = false;
          return _startGeneric.screens[0].html.indexOf(video.lien) > -1 || video.lienMp4 && _startGeneric.screens[0].html.indexOf(video.lienMp4.substring(0, video.lienMp4.length - 13)) > -1;
        }
      } else if (generic === 'fin') {
        var finishGeneric = this.getAllSelected.find(function (s) {
          return s.type === 'finishGeneric';
        });
        if (finishGeneric) {
          this.disabledSelectButton = false;
          return finishGeneric.screens[0].html.indexOf(video.lien) > -1 || video.lienMp4 && finishGeneric.screens[0].html.indexOf(video.lienMp4.substring(0, video.lienMp4.length - 13)) > -1;
        }
      } else if (generic === 'intro') {
        var introGeneric = this.getAllSelected[index].screens.find(function (s) {
          return s.type === 'startGeneric';
        });
        if (introGeneric) {
          this.disabledSelectButton = false;
          return introGeneric.html.indexOf(video.lien) > -1 || video.lienMp4 && introGeneric.html.indexOf(video.lienMp4.substring(0, video.lienMp4.length - 13)) > -1;
        }
      }
    }
  },
  SelectVideo: function SelectVideo(video) {
    var videoObj = {
      lien: video.lien,
      lienMp4: video.lienMp4,
      id: video.id,
      logo: video.logo,
      title: video.title,
      duration: video.duration
    };
    this.videoGeneric = videoObj;
    this.selected_vid = this.videoGeneric.id;
    this.disabledSelectButton = false;
  },
  DeselectVideo: function DeselectVideo() {
    var videoObj = {
      lien: '',
      lienMp4: '',
      id: '',
      logo: '',
      title: '',
      duration: ''
    };
    this.videoGeneric = videoObj;
    this.selected_vid = '';
    this.disabledSelectButton = true;
    this.addGeneriqueVideo();
  },
  addGeneriqueVideo: function addGeneriqueVideo() {
    var _this = this;

    var self = this;
    var generic = document.getElementById('list_videos').getAttribute('generic');
    var index = document.getElementById('list_videos').getAttribute('data-index');
    var display_default_blocks = this.paramsClient.display_default_blocks;
    var src = this.videoGeneric.lien;
    if (display_default_blocks && display_default_blocks.length > 0) {
      var blocks = display_default_blocks.map(function (block) {
        return block.blocks;
      });
      blocks.forEach(function (block) {
        for (var i = 0; i < block.length; i++) {
          if (block[i] === 'video_mp4') {
            src = _this.videoGeneric.lienMp4;
          }
        }
      });
    }
    var slide = {
      src: src,
      title: 'generique ' + generic + ' ' + self.makeId(),
      logo: this.videoGeneric.logo,
      options: {
        duration: this.videoGeneric.duration
      },
      originalDuration: this.videoGeneric.duration
    };
    if (generic === 'intro') {
      slide.type = 'startGeneric';
      slide.index = index;
      self.setVideoIntro(slide);
    } else {
      if (generic === 'debut') {
        slide.type = 'startGeneric';
      } else {
        slide.type = 'finishGeneric';
      }
      if (self.$route.name === 'segment') {
        self.setSlidesGeneric(slide);
      } else {
        self.setSegmentsGeneric(slide);
      }
    }

    self.selected_vid = this.videoGeneric.id;
    this.$root.$emit('closeModal');
  },
  reloadVideoList: function reloadVideoList() {
    var self = this;
    self.page = self.page + 1;
    var params = {};
    if (this.getGenericThem == 0) {
      params = {
        id: '',
        page: self.page,
        nbParPage: 20,
        client: localStorage.getItem('client')
      };
    } else {
      this.themeId = this.getGenericThem;
      params = {
        id: '',
        page: self.page,
        nbParPage: 20,
        idTheme: this.themeId,
        client: localStorage.getItem('client'),
        maxBitrate: true
      };
    }

    if (this.searchTitle) {
      params.searchWord = this.searchTitle;
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_http_http_token__["a" /* HTTP */])(window.ApiToken).get(__WEBPACK_IMPORTED_MODULE_3__core_router_router__["a" /* default */].generate('api_media_get_media', params)).then(function (response) {
      document.getElementById('loader-liste-dispo').style.visibility = 'hidden';
      if (response.data.code === 200) {
        if (response.data) {
          self.total_number = self.total_number + response.data.medias.length;
          self.all_video = self.all_video.concat(response.data.medias);
          var listElm = document.getElementById('list_video');
          listElm.onscroll = function () {
            if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
              if (self.all_video.length < response.data.nombre_total) {
                document.getElementById('loader-liste-dispo').style.visibility = 'visible';
                self.reloadVideoList();
              } else {
                document.getElementById('loader-liste-dispo').style.visibility = 'hidden';
              }
            }
          };
        }
      }
    }, function (response) {
      //self.hideLoader();
    });
  },
  searchVideo: function searchVideo() {
    var title = document.getElementById('inputVideoSearch').value;
    this.searchTitle = title;
    this.page = 0;
    this.all_video = [];
    this.searchGenericVideo(title);
    this.reloadVideoList(this.themeId);
    document.getElementById('loader-liste-dispo').style.visibility = 'visible';
  },
  btnConfirm: function btnConfirm() {
    var self = this;
    self.close();
  },
  optionSelect: function optionSelect() {
    if (this.getOptionsThemeSelect.length != 0) {
      this.options = this.getOptionsThemeSelect;
      this.idSelectedTheme = this.options[0].id;
      if (this.options.length > 1) this.showSelect = true;
    }
  },
  onChangeThemId: function onChangeThemId() {
    this.setGenericThem(this.idSelectedTheme);
    this.all_video = [];
    this.page = 0;
    this.reloadVideoList();
    document.getElementById('loader-liste-dispo').style.visibility = 'visible';
  }
})), _mixins$data$i18n$mix);

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      title: ''
    };
  },

  watch: {
    titleTemplate: {
      handler: function handler(val) {
        this.title = val.title;
      },

      deep: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    titleTemplate: 'slides/getTemplate'
  }))
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_en_US__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_fr_FR__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SlideCard__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SlideCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__SlideCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_Mixin_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_carousel__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_GrapesMixinHelpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_duration_handler__ = __webpack_require__(40);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
  name: 'SegmentList',
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_Mixin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_GrapesMixinHelpers__["a" /* default */]],

  data: function data() {
    return {
      ButtonDisabled: true,
      selectedTab: '',
      nbreScreens: 1,
      infiniteState: null,
      selectedIds: [],
      total: 0,
      titleModal: '',
      titleSegment: ''
    };
  },

  components: {
    SlideCard: __WEBPACK_IMPORTED_MODULE_10__SlideCard___default.a,
    Carousel: __WEBPACK_IMPORTED_MODULE_12_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_12_vue_carousel__["Slide"]
  },
  i18n: {
    messages: {
      en: __WEBPACK_IMPORTED_MODULE_8__i18n_en_US__["a" /* default */],
      fr: __WEBPACK_IMPORTED_MODULE_9__i18n_fr_FR__["a" /* default */]
    }
  },
  created: function created() {
    eventHub.$on('resetModalSegmentList', this.reset);
  },
  mounted: function mounted() {
    this.showTab('Disposition');
    this.titleSegment = this.$t('panels.newSegment');
  },

  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])({
    getmaxLength: 'common/getmaxLength',
    AllScreens: 'slides/getAllScreens',
    currentSlide: 'slides/getCurrent',
    dispositions: 'slides/getAllDispositions',
    isLoading: 'slides/getLoading',
    isEndReached: 'slides/getEndReached',
    selected: 'slides/getSelected',
    isSelected: 'slides/isSelected',
    firstSelectedSlide: 'slides/getLastSlideById',
    showIconSave: 'common/getShowIconSave',
    paramsClient: 'getParamsClients',
    totalDurationScreens: 'slides/getAllScreensDuration',
    nbrCall: 'segments/getNbrCall',
    permission: 'getPermissions',
    lastUpdatedSegment: 'segments/getLastUpdatedSegmentById'
  }), {
    confirmButtonDisabled: function confirmButtonDisabled() {
      return this.$route.name === 'segment' ? this.selected.length === 0 : false;
    },
    editMode: function editMode() {
      return this.$route.name === 'edit';
    },
    getModalTitle: function getModalTitle() {
      if (this.$route.name === 'edit') {
        this.titleModal = this.$t('panels.addNewScreen');
      } else if (this.$route.params.type === 'NewSegment' || this.$route.params.type === 'EditSegment') this.titleModal = this.$t('panels.addNewScreen');else {
        this.nbrCall === 1 ? this.titleModal = this.$t('panels.addNewSegment') : this.titleModal = this.$t('panels.addNewScreen');
      }
      return this.titleModal;
    },
    emptyDisposition: function emptyDisposition() {
      var disposition = {
        assets: '',
        components: '',
        css: '',
        html: '',
        options: {
          duration: __WEBPACK_IMPORTED_MODULE_14__helpers_duration_handler__["a" /* totalSegmentDuration */]()
        },
        styles: '',
        title: this.$t('disposition.empty'),
        transition: {
          in: '',
          out: ''
        },
        type: 'Disposition',
        screenShot: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJAQMAAAAB5D5xAAAABlBMVEXs7vHs7/Hee24nAAAAFUlEQVQI12P4/58BiGrB5D8wCUX/AOfxEWuWlIcVAAAAAElFTkSuQmCC',
        id: 0
      };
      return disposition;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('slides', ['paginate', 'selectSlide', 'setCurrentSlide', 'removeLastSlideById', 'updateSlide', 'fetch', 'resetSelect', 'changeTitleInSelected']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('common', ['setShowIconSave']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('segments', ['setfromRouteAdd', 'resetNbCall', 'setCurrentSegment', 'setNbrCall', 'appendSlideToSegment', 'removeLastSlideFromSegmentById', 'updateSlideInsideSegment']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])(['setRoute']), {
    back: function back() {
      var _this = this;

      this.selectedIds.forEach(function (id) {
        _this.removeLastSlideById(id);
        _this.removeLastSlideFromSegmentById(id);
      });
      this.$root.$emit('bv::hide::modal', 'segment-list-modal');
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.innerText = '';
      }

      if (this.$route.params.type === 'NewSegment') {
        this.setfromRouteAdd(true);
        this.$router.push({ name: 'EditSegment' });
      } else {
        this.setRoute('add');
        this.$router.push({ name: 'add' });
        this.$root.$emit('bv::show::modal', 'slide-list-modal');
      }

      this.selectedIds = [];
    },
    loadMore: function loadMore() {
      this.isShown = true;
    },
    showTab: function showTab(tab) {
      this.selectedTab = tab;
    },
    select: function select(item) {
      var limitAdd = this.getNbSreenSegment();
      var nb_screeen = this.permission.nb_screen_segment;
      var selected = JSON.parse(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(item));
      if (this.$route.name === 'segment') {
        if (this.selectedIds.includes(selected.id)) {
          this.selectedIds = this.selectedIds.filter(function (i) {
            return i !== selected.id;
          });
          this.removeLastSlideById(selected.id);
        } else {
          if (limitAdd && this.selected.length < nb_screeen) {
            this.selectedIds.push(selected.id);
            this.selectSlide(selected);
            this.ButtonDisabled = false;
          } else if (!limitAdd) {
            this.selectedIds.push(selected.id);
            this.selectSlide(selected);
            this.ButtonDisabled = false;
          }
        }
      } else {
        if (this.selectedIds.includes(selected.id)) {
          this.selectedIds = this.selectedIds.filter(function (i) {
            return i !== selected.id;
          });
          this.removeLastSlideFromSegmentById(selected.id);
        } else {
          this.selectedIds.push(selected.id);
          this.appendSlideToSegment(selected);
          this.ButtonDisabled = false;
        }
      }
      if (this.selectedIds.length < 1) {
        this.ButtonDisabled = true;
      }
    },
    confirm: function confirm() {
      var _this2 = this;

      var editor = grapesjsEMP.editors[0];
      var self = this;
      this.selected.map(function (s) {
        return _this2.total += s.options.duration;
      });

      // Segment
      var segment = {
        screensToSubmit: this.selected,
        duration: self.totalDurationScreens,
        uid: Math.floor(new Date().valueOf() * Math.random())
      };
      var newSegment = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, segment, this.currentSegment);
      self.setCurrentSegment(newSegment);
      var psElement = document.getElementById('ps-slide-wrapper');
      try {
        var DraggableElement = document.getElementById('draggable-wrapper');
        psElement.scrollLeft = DraggableElement.offsetWidth;
      } catch (e) {}

      if (this.$route.name === 'segment') {
        // nb_screen_segment = 1 , on doit afficher le titre de segment dans le card et dans le panel
        var nb_screeen_param = this.paramsClient.nb_screen_segment;
        if (parseInt(nb_screeen_param) === 1) {
          this.changeTitleInSelected(this.titleSegment !== '' ? this.titleSegment : this.$t('panels.newSegment'));
          this.setCurrentSlide(this.selectedIds[0]);
        }

        this.selectFirstSlide();
      } else if (this.selectedIds.length > 0) {
        console.log(this.lastUpdatedSegment);
        this.selectAddedSlide(this.lastUpdatedSegment, this.lastUpdatedSegment.screens[this.lastUpdatedSegment.screens.length - 1]);
      }

      this.selectedIds = [];
      this.$root.$emit('bv::hide::modal', 'segment-list-modal');
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        if (this.nbrCall === 1) {
          iconSave.classList.add('only-save');
        }
        iconSave.classList.add('icon-selected');
        this.setShowIconSave(true);
      }
      self.setNbrCall();
      //ButtonDisabled for the next call
      this.ButtonDisabled = true;
      ///new
      this.setNoAutoplayVideo(editor);
      var videoPlayers = ['player', 'playlist'];
      videoPlayers.forEach(function (player) {
        _this2.setPausedVideo(player);
      });
    },
    selectFirstSlide: function selectFirstSlide() {
      var lastSlide = {
        uid: this.currentSlide.uid,
        components: localStorage.getItem('gjs-components'),
        js: localStorage.getItem('gjs-js'),
        html: localStorage.getItem('gjs-html'),
        css: this.sanitizeCSS(localStorage.getItem('gjs-css')),
        styles: localStorage.getItem('gjs-styles')
      };
      this.updateSlide(lastSlide);

      this.generateSlideThmbnail(lastSlide.uid);
      var slide = this.firstSelectedSlide(this.selectedIds[0]);
      this.setCurrentSlide(slide);
      this.$root.$emit('updateCanvasContent');
    },
    selectAddedSlide: function selectAddedSlide(segment, slide) {
      var _this3 = this;

      if (segment.uid !== this.currentSegment.uid) {
        return;
      }
      var editor = grapesjsEMP.editors[0];
      var wrapper = editor.DomComponents.getWrapper();
      //editor.select(wrapper);
      setTimeout(function () {
        var lastSlide = {
          uid: _this3.currentSlide.uid,
          components: localStorage.getItem('gjs-components'),
          js: localStorage.getItem('gjs-js'),
          html: localStorage.getItem('gjs-html'),
          css: _this3.sanitizeCSS(localStorage.getItem('gjs-css')),
          styles: localStorage.getItem('gjs-styles')
        };
        _this3.updateSlideInsideSegment(lastSlide);
        _this3.generateSlideThmbnail(_this3.currentSlide.uid);
        setTimeout(function () {
          //Set Current Screen
          _this3.setCurrentSlide(slide);
          //Set Current Segment by Screen
          _this3.setCurrentSegment(segment);

          _this3.$root.$emit('updateCanvasContent');
          _this3.setNoAutoplayVideo(editor);
          var videoPlayers = ['player', 'playlist'];
          videoPlayers.forEach(function (player) {
            _this3.setPausedVideo(player);
          });
          if (_this3.paramsClient.display_default_blocks && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_this3.paramsClient.display_default_blocks).length > 0) {
            var blocks = document.querySelector('#gjs .gjs-pn-buttons .fa-th-large:not(.gjs-pn-active)');
            if (blocks) {
              blocks.click();
            }
          }
        }, 100);
      }, 100);
    },
    cancel: function cancel() {
      var _this4 = this;

      this.selectedIds.forEach(function (id) {
        // remove select slide   ( add new segment  )
        _this4.removeLastSlideById(id);
        // remove select slide  ( panelpage : add screens to segment )
        _this4.removeLastSlideFromSegmentById(id);
      });
      if (this.nbrCall === 1 && !this.editMode) {
        this.$root.$emit('bv::hide::modal', 'segment-list-modal');
        this.setRoute('add');
        var iconSave = document.querySelector('.icon-save');
        if (iconSave) {
          iconSave.innerText = '';
        }
        this.$router.push({ name: 'add' });
        this.$root.$emit('bv::show::modal', 'slide-list-modal');
      } else {
        this.$root.$emit('bv::hide::modal', 'segment-list-modal');
      }

      // réinitialiser  selectedIds
      this.selectedIds = [];
    },
    reset: function reset() {
      this.resetNbCall();
      this.resetSelect();
      this.titleSegment = this.$t('panels.newSegment');
    },
    pageChanged: function pageChanged(selectedTab) {
      var modal = document.getElementById('segment-list-modal');
      if (!modal || modal.style.display === 'none' || this.isLoading) {
        return;
      }
      var length = void 0;
      if (selectedTab === 'Screen') {
        length = this.AllScreens.length;
      } else {
        length = this.dispositions.length;
      }
      if (this.isEndReached(selectedTab) || !this.isShown) {}
      this.paginate(selectedTab);
    }
  })
}, 'mounted', function mounted() {
  var _this5 = this;

  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _this5.paginate('Disposition');
            _this5.paginate('Screen');

            if (_this5.$route.params.type === 'EditSegment') {
              _this5.setNbrCall(2);
            }

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this5);
  }))();
}));

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_dialog_drag__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_dialog_drag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_dialog_drag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweet_modal_vue__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_range_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_range_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_range_slider_dist_vue_range_slider_css__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_range_slider_dist_vue_range_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_range_slider_dist_vue_range_slider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_GrapesMixinAnimation_js__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_directives_HasPermission_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_Mixin_js__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SettingComponent',
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_Mixin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_GrapesMixinAnimation_js__["a" /* default */]],
  directives: {
    HasPermission: __WEBPACK_IMPORTED_MODULE_8__core_directives_HasPermission_js__["a" /* default */]
  },
  data: function data() {
    return {
      isComponentText: false,
      openedAnimation: false,
      openedOpacity: false,
      openedLayers: false,
      sliderValue: 100,
      opacityValue: 1,
      initClass: ['fragment', 'grow', 'fade-in', 'fade-up', 'fade-down', 'fade-left', 'fade-right', 'shrink', 'fade-out', 'delay', 'reveal-text', 'strike'],
      delayValue: '',
      index: 1
    };
  },

  components: {
    DialogDrag: __WEBPACK_IMPORTED_MODULE_3_vue_dialog_drag___default.a,
    SweetModal: __WEBPACK_IMPORTED_MODULE_4_sweet_modal_vue__["a" /* SweetModal */],
    SweetModalTab: __WEBPACK_IMPORTED_MODULE_4_sweet_modal_vue__["b" /* SweetModalTab */],
    RangeSlider: __WEBPACK_IMPORTED_MODULE_5_vue_range_slider___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    settingModalPos: 'common/getSettingModalPos',
    getDelayFragment: 'slides/getDelayFragment',
    getOpacityFragment: 'slides/getOpacityFragment'
  }), {
    currentAnimation: function currentAnimation() {
      if (!window.grapesjsEMP && this.index) {
        return 'none';
      }
      var editor = window.grapesjsEMP.editors[0];
      var model = editor.getSelected();

      var animation = model ? model.getEl().getAttribute('data-animation') : null;
      return this.index && animation ? animation.replace('fragment ', '') : 'none';
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('slides', ['setOpacityFragment']), {
    updateLayers: function updateLayers(zIndex) {
      var self = this;
      var newCurrentZIndex = 0;
      var oldCurrentZIndex = this.getZIndexCurrentSlide();
      switch (zIndex) {
        case 'max':
          newCurrentZIndex = self.getAllComponets().length;
          break;
        case 'min':
          newCurrentZIndex = 0;
          break;
        case -1:
          oldCurrentZIndex--;
          break;
        default:
          oldCurrentZIndex++;
      }
      this.removeStyleClassElement('emp-z-index-');
      this.addStyleClassElement({ 'z-index': newCurrentZIndex }, 'emp-z-index-' + newCurrentZIndex);
    },
    updatePositionLayers: function updatePositionLayers(position) {
      var editor = grapesjsEMP.editors[0];
      var cssComposer = editor.CssComposer;
      var models = editor.DomComponents.getComponents().models;
      var model = editor.getSelected();
      var id = model.getId();
      var c = model.getClasses()[0];
      var oldStyle = cssComposer.getClassRule(c).attributes.style;

      var index = parseInt(oldStyle['z-index']);

      var firstLayer = models.length;

      var newIndex = 0;
      switch (position) {
        case 'back':
          newIndex = Math.max(index - 1, 0);
          break;
        case 'move':
          newIndex = Math.min(index + 1, firstLayer);
          break;
        case 'first':
          newIndex = firstLayer;
          break;
      }

      var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, oldStyle, { 'z-index': newIndex });
      cssComposer.setClassRule(c, newStyle);
    },
    openAnimation: function openAnimation() {
      this.index++;
      this.openedAnimation = !this.openedAnimation;
      this.openedOpacity = false;
      this.openedLayers = false;
    },
    openOpacity: function openOpacity() {
      var dialogSetting = document.getElementById('dialog-setting');
      var dialogOpacity = document.getElementById('dialog-opacity');

      this.openedOpacity = !this.openedOpacity;
      this.openedAnimation = false;
      this.openedLayers = false;
    },
    openLayers: function openLayers() {
      var dialogSetting = document.getElementById('dialog-setting');
      var dialogLayers = document.getElementById('dialog-layers');

      this.openedLayers = !this.openedLayers;
      this.openedAnimation = false;
      this.openedOpacity = false;
    },

    setDelayElement: function setDelayElement(event) {
      this.updateDelayGrapesElement(event.target.value);
      this.delayValue = event.target.value;
    },
    toggleModalDraggable: function toggleModalDraggable(isDraggable) {
      document.getElementById('dialog-setting').setAttribute('draggable', isDraggable);
    },
    setDelayValue: function setDelayValue(delay) {
      this.delayValue = delay;
    },

    updateClassElement: function updateClassElement(classElement) {
      this.index++;
      this.updateClassGrapesElement(classElement, this.initClass);
    },
    changeOpacity: function changeOpacity(event) {
      this.updateStyleClassElement({ opacity: event / 100 }, 'classOpacity');

      this.sliderValue = event;
      document.querySelector('.setting-component').style.position = 'inherit';
    },
    displayOverlay: function displayOverlay() {
      document.querySelector('.setting-component').style.position = 'absolute';
    },
    setOpacityValue: function setOpacityValue(opacity) {
      this.sliderValue = opacity;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    var btnCloseSetting = document.querySelector('#dialog-setting button.close');
    btnCloseSetting.addEventListener('click', function () {
      var modelSetting = document.querySelector('#setting-component');
      modelSetting.classList.toggle('hidden');
      var selected = grapesjsEMP.editors[0].getSelected();
      var animation = grapesjsEMP.editors[0].getSelected().getAttributes();
      if (animation['data-animation']) {
        animation['animation'] = 'end ' + animation['data-animation'];
      } else {
        animation['animation'] = 'end';
      }
      selected.setAttributes(animation);
    });
    this.$root.$on('change-opacity', function (opacity) {
      _this.setOpacityValue(opacity);
    });
    this.$root.$on('change-delay', function (delay) {
      _this.setDelayValue(delay);
    });
  },
  created: function created() {
    var _this2 = this;

    this.$root.$on('add-text-animation', function (isVisible) {
      _this2.isComponentText = isVisible;
    });
  }
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lazyload__ = __webpack_require__(117);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SlideCard',
  props: {
    title: '',
    ModalSegment: {
      type: Boolean,
      default: false
    },
    Shot: '',
    item: Object,
    haveScreen: Boolean,
    isSelected: Boolean,
    isCollapse2: {
      type: Boolean,
      default: false
    },
    isEmpty: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    isHover: {
      type: Boolean
    },
    isActiveModule: String,
    oldImages: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    lazy: __WEBPACK_IMPORTED_MODULE_4_vue_lazyload__["a" /* default */]
  },
  components: {
    lazyComponent: __WEBPACK_IMPORTED_MODULE_4_vue_lazyload__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__["a" /* default */]],
  data: function data() {
    return {
      isEditMode: false,
      titleSlide: this.item.title,
      screenShot: 'data:image/png;base64,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'
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__main__["bus"].$on('displaycreenShot', function (module) {
      _this.screenShot = '/display/static/images/icons/modules/' + module + '-card.svg';
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    getmaxLength: 'common/getmaxLength',
    paramsClient: 'getParamsClients'

  }), {
    getScreenShot: function getScreenShot() {
      this.screenShot = 'data:image/png;base64,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';
      return this.screenShot;
    },
    getShot: function getShot() {
      return this.Shot ? this.Shot : this.getScreenShot;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('slides', ['updateTitle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('segments', ['updateTitleSegment', 'updateTitleScreenInSegment']), {
    toggleEditMode: function toggleEditMode() {
      this.isEditMode = !this.isEditMode;
    },


    // Modal SlideList
    updateTitleScreen: function updateTitleScreen() {
      this.updateTitleScreenInSegment(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.item, { title: this.title }));
      this.toggleEditMode();
    },
    updateSegment: function updateSegment() {
      this.updateTitleSegment(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.item, { title: this.title }));
      this.toggleEditMode();
    },


    // Other Modal
    update: function update() {
      this.updateTitle(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.item, { title: this.titleSlide }));
      this.toggleEditMode();
    }
  })
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_en_US__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_fr_FR__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SlideCard__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SlideCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__SlideCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_Mixin_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_carousel__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_GrapesMixinHelpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SegmentList_vue__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SegmentList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__SegmentList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_top_progress__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_top_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_top_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__core_directives_HasPermission_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_duration_handler__ = __webpack_require__(40);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SlideList',
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_Mixin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_GrapesMixinHelpers__["a" /* default */]],
  directives: {
    HasPermission: __WEBPACK_IMPORTED_MODULE_14__core_directives_HasPermission_js__["a" /* default */]
  },
  data: function data() {
    return {
      options: [],
      ligneTemplate: [],
      clicksOut: true,
      showCollapse: false,
      showCollapse2: false,
      navparam: true,
      selectedTab: '',
      infiniteState: null,
      selectedIds: [],
      selecteIdSegment: [],

      titleTemplate: this.$t('template.new_template'),
      total: 0,
      hideCancelButton: true,
      disabledConfirmButton: true,
      duration: 59
    };
  },

  components: {
    vueTopprogress: __WEBPACK_IMPORTED_MODULE_13_vue_top_progress__["vueTopprogress"],
    SlideCard: __WEBPACK_IMPORTED_MODULE_8__SlideCard___default.a,
    Carousel: __WEBPACK_IMPORTED_MODULE_10_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_10_vue_carousel__["Slide"],
    SegmentList: __WEBPACK_IMPORTED_MODULE_12__SegmentList_vue___default.a
  },
  i18n: {
    messages: {
      en: __WEBPACK_IMPORTED_MODULE_6__i18n_en_US__["a" /* default */],
      fr: __WEBPACK_IMPORTED_MODULE_7__i18n_fr_FR__["a" /* default */]
    }
  },
  watch: {
    // Problème 11 : même défaut que dans ModuleList — sans cette hydratation,
    // confirm() renvoie « Nouveau programme » et écrase le nom du programme.
    'template.title': {
      immediate: true,
      handler: function handler(title) {
        if (title) this.titleTemplate = title;
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    //recentsSegment:'segments/getAllSegments',
    screens: 'slides/getAllScreens',
    currentSlide: 'slides/getCurrent',
    dispositions: 'slides/getAllDispositions',
    all: 'segments/getSegments',
    segments: 'segments/getAllSegments',
    SegmentsFiltredByTitle: 'segment/getFilterSegments',
    DefaultSegments: 'segments/getAllDefaultSegments',
    isLoading: 'slides/getLoading',
    isEndReached: 'slides/getEndReached',
    selected: 'slides/getSelected',
    selectedSegments: 'segments/getSelectedSegments',
    currentSegment: 'segments/getCurrent',
    isSelected: 'slides/isSelected',
    firstSelectedSegment: 'segments/getLastSegmentById',
    showIconSave: 'common/getShowIconSave',
    paramsClient: 'getParamsClients',
    hasPermission: 'hasPermission',
    totalDurationSegments: 'segments/getAllSegmentsDuration',
    template: 'slides/getTemplate'
  }), {
    confirmButtonDisabled: function confirmButtonDisabled() {
      return this.selected.length === 0 && this.selectedSegments.length === 0;
    },
    stateTitle: function stateTitle() {
      var state = this.titleTemplate.length >= 1 ? true : false;
      if (state) return null;else return state;
    },
    stateLigne: function stateLigne() {
      var state = this.ligneTemplate.length >= 1 ? true : false;
      if (state) return null;else return state;
    },
    stateDuration: function stateDuration() {
      if (this.durationTemplate === '00:00:00' || this.durationTemplate === '' || this.durationTemplate === '00:00') return false;else return null;
    },

    durationTemplate: {
      get: function get() {
        var value = this.duration;
        var hours = Math.floor(value / 3600);
        value %= 3600;
        var minutes = Math.floor(value / 60);
        var seconds = value % 60;
        var addZero = function addZero(v) {
          return v < 10 ? '0' + v : v;
        };
        var t = [];

        t.push(addZero(hours));
        t.push(addZero(minutes));
        t.push(addZero(seconds));

        return t.join(':');
      },
      set: function set(value) {
        this.duration = value.split(':').reverse().reduce(function (prev, curr, i) {
          return prev + curr * Math.pow(60, i);
        }, 0);
      }
    },
    emptyDisposition: function emptyDisposition() {
      var disposition = {
        id: 0,
        type: 'Segment',
        title: this.$t('disposition.empty'),
        duration: __WEBPACK_IMPORTED_MODULE_15__helpers_duration_handler__["a" /* totalSegmentDuration */](),
        screens: [{
          id: 0,
          title: this.$t('screens.empty'),
          type: 'screen',
          options: { duration: __WEBPACK_IMPORTED_MODULE_15__helpers_duration_handler__["a" /* totalSegmentDuration */]() },
          assets: '',
          components: '',
          css: '',
          html: '',
          styles: '',
          transition: {
            in: '',
            out: ''
          },
          screenShot: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJAQMAAAAB5D5xAAAABlBMVEXs7vHs7/Hee24nAAAAFUlEQVQI12P4/58BiGrB5D8wCUX/AOfxEWuWlIcVAAAAAElFTkSuQmCC'
        }]
      };
      return disposition;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('slides', ['paginate', 'selectSlide', 'setCurrentSlide', 'removeLastSlideById', 'updateSlide', 'fetch', 'setTemplate']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('segments', ['getSegments', 'paginatesegment', 'selectSegment', 'setCurrentSegment', 'removeLastSegmentById', 'updateSegment', 'setTitle', 'resetPage', 'setSegments', 'setNbrCall', 'updateSlideInsideSegment']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('common', ['setShowIconSave']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['setRoute']), {
    optionsLine: function optionsLine() {
      if (this.paramsClient.default_line) {
        this.options = this.paramsClient.default_line;
        this.ligneTemplate = this.options[0].value;
      }
    },
    showSegmentModal: function showSegmentModal() {
      this.$router.push({ name: 'segment' });
      this.setRoute('segment');
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.innerHTML = "<span style='font-family:RobotoUep!important;'>" + this.$t('template.save_and_exit') + "</span>";
      }
      this.cancel();
      //réinitialiser Modal Listsegment
      eventHub.$emit('resetModalSegmentList');
      this.$root.$emit('bv::show::modal', 'segment-list-modal', '#btnShow');
    },
    loadMore: function loadMore() {
      this.isShown = true;
    },
    showTab: function showTab(tab) {
      this.selectedTab = tab;
    },
    select: function select(item) {
      var selected = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(item));
      if (this.selectedIds.includes(selected.id)) {
        this.selectedIds = this.selectedIds.filter(function (i) {
          return i !== selected.id;
        });
        this.removeLastSlideById(selected.id);
      } else {
        this.selectedIds.push(selected.id);
        this.selectSlide(selected);
      }
    },
    addSegment: function addSegment(item) {
      // this.setCurrentSegment(item);
      var selectedSegment = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(item));

      if (this.selecteIdSegment.includes(selectedSegment.id)) {
        this.selecteIdSegment = this.selecteIdSegment.filter(function (i) {
          return i !== selectedSegment.id;
        });
        this.removeLastSegmentById(selectedSegment.id);
      } else {
        this.disabledConfirmButton = false;
        this.selecteIdSegment.push(selectedSegment.id);
        this.selectSegment(selectedSegment);
      }
      if (this.selecteIdSegment.length < 1) {
        this.disabledConfirmButton = true;
      }
    },
    showSelect: function showSelect(item) {
      this.showCollapse = true;
      this.showCollapse2 = false;
      this.setCurrentSegment(item);
      var px = document.getElementById(item.id).offsetLeft + 150;
      var defaultSegment = document.querySelector('#default-segment .VueCarousel-inner').style.transform;
      //mixin code
      this.triangleStyle('#triangle', defaultSegment, px);
    },
    showSelect2: function showSelect2(item) {
      this.showCollapse2 = true;
      this.showCollapse = false;
      this.setCurrentSegment(item);
      var px = document.getElementById(item.id).offsetLeft + 150;
      var segmentTemplate = document.querySelector('#segment-template .VueCarousel-inner').style.transform;
      //mixin code
      this.triangleStyle('#triangle2', segmentTemplate, px);
    },

    /*confirm() {
      const psElement = document.getElementById('ps-slide-wrapper');
      const DraggableElement = document.getElementById('draggable-wrapper');
      psElement.scrollLeft = DraggableElement.offsetWidth;
      this.selectFirstSlide();
      this.selected.map(s => (this.total += s.options.duration));
       this.setTotalDuration(this.total);
      this.selectedIds = [];
      const template = {
        title: this.titleTemplate !== '' ? this.titleTemplate : this.$t('template.new_template'),
        duration: this.durationTemplate
      };
       this.setTemplate(template);
      this.selecteIdSegment = [];
      this.$root.$emit('bv::hide::modal', 'slide-list-modal');
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
        this.setShowIconSave(true);
        if (this.$route.name === 'segment') {
          iconSave.classList.add('only-save');
        }
      }
    }*/
    confirm: function confirm() {
      var _this = this;

      var editor = grapesjsEMP.editors[0];
      if (this.stateTitle == null && this.stateDuration == null) {
        var psElement = document.getElementById('ps-slide-wrapper');
        var DraggableElement = document.getElementById('draggable-wrapper');
        psElement.scrollLeft = DraggableElement.offsetWidth;
        this.selectFirstSlide();

        var durationT = '';
        if (this.$route.name === 'edit') {
          durationT = this.template.duration;
        } else durationT = this.durationTemplate;

        // Durée totale des écrans
        this.total = 0;
        this.selectedSegments.map(function (s) {
          return _this.total += s.duration;
        });
        this.selectedIds = [];
        var template = {
          title: this.titleTemplate !== '' ? this.titleTemplate : this.$t('template.new_template'),
          ligne: this.ligneTemplate !== [] ? this.ligneTemplate : this.$t('template.new_ligne'),
          duration: durationT
        };

        this.setTemplate(template);
        this.selecteIdSegment = [];
        this.$root.$emit('bv::hide::modal', 'slide-list-modal');
        var iconSave = document.querySelector('.icon-save');
        if (iconSave) {
          iconSave.classList.add('icon-selected');
          iconSave.innerText = '';

          this.setShowIconSave(true);
        }

        if (this.paramsClient.display_default_blocks && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.paramsClient.display_default_blocks).length > 0 && this.paramsClient.modules.show_list_block_action) {
          var blocks = document.querySelector('#gjs .gjs-pn-buttons .fa-th-large:not(.gjs-pn-active)');
          if (blocks) {
            blocks.click();
          }
        }
        this.onNav();
        this.changeStyleOff();
      }
      this.setNbrCall();
      this.setNoAutoplayVideo(editor);

      var videoPlayers = ['player', 'playlist'];
      videoPlayers.forEach(function (player) {
        _this.setPausedVideo(player);
      });
    },
    selectFirstSlide: function selectFirstSlide() {
      var lastSlide = {
        uid: this.currentSlide.uid,
        components: localStorage.getItem('gjs-components'),
        js: localStorage.getItem('gjs-js'),
        html: localStorage.getItem('gjs-html'),
        css: this.sanitizeCSS(localStorage.getItem('gjs-css')),
        styles: localStorage.getItem('gjs-styles')
      };

      this.updateSlideInsideSegment(lastSlide);
      this.generateSlideThmbnail(lastSlide.uid);

      var segment = this.firstSelectedSegment(this.selecteIdSegment[0]);
      this.setCurrentSegment(segment);
      this.setCurrentSlide(segment.screens.filter(function (s) {
        return s.type !== 'startGeneric';
      })[0]);

      this.$root.$emit('updateCanvasContent');
    },
    cancel: function cancel() {
      var _this2 = this;

      this.selecteIdSegment.forEach(function (id) {
        _this2.removeLastSegmentById(id);
      });
      this.selecteIdSegment = [];
      this.$root.$emit('bv::hide::modal', 'slide-list-modal');
    },
    pageChanged: function pageChanged(selectedTab) {
      var modal = document.getElementById('slide-list-modal');
      if (!modal || modal.style.display === 'none' || this.isLoading) {
        return;
      }
      var length = void 0;
      if (selectedTab === 'Screen') {
        length = this.screens.length;
      }
      if (selectedTab === 'dispositions') {
        length = this.dispositions.length;
      }
      if (this.isEndReached(selectedTab) || !this.isShown) {
        return;
      }
      // this.paginate(selectedTab);
    },
    pageSegmentChanged: function pageSegmentChanged(selectedTab) {
      var modal = document.getElementById('slide-list-modal');
      if (!modal || modal.style.display === 'none' || this.isLoading) {
        return;
      }
      var length = void 0;

      if (selectedTab === 'Segment') {
        length = this.segments.length;
      }
      if (selectedTab === 'DefaultSegments') {
        length = this.DefaultSegments.length;
      }
      if (this.isEndReached(selectedTab) || !this.isShown) {
        return;
      }
      this.paginatesegment(selectedTab);
    },
    onNav: function onNav() {
      this.navparam = !this.navparam;
    },
    changeStyleOn: function changeStyleOn() {
      var style = document.createElement('style');
      style.innerHTML = '\n        #plan2 {z-index: 9999;position: absolute;background-color: rgba(255, 255, 255, 0.85);top:0; left:0; width: 100%;height: 100%;}\n        #plan1 {z-index: 1; filter: blur(4px);}\n        #btn-next {visibility:hidden;}\n        #btn-finish {visibility:hidden;}\n       ';
      document.head.appendChild(style);
    },
    changeStyleOff: function changeStyleOff() {
      var style = document.createElement('style');
      style.innerHTML = '\n        #plan1 {z-index: 1;\n        filter: blur(0px);}\n        #btn-next {visibility:visible;}\n        #btn-finish {visibility:visible;}\n       ';
      document.head.appendChild(style);
    },
    closeListScreen: function closeListScreen() {
      if (this.clicksOut) {
        this.showCollapse = false;
        this.showCollapse2 = false;
      }
    },
    searchTitle: function searchTitle() {
      this.$refs.topProgress.start();

      var title = document.getElementById('inputSearch').value;
      this.setSegments([]);
      this.setTitle(title);
      this.resetPage('Segment');
      this.paginatesegment('Segment');
      this.resetPage('DefaultSegment');
      this.paginatesegment('DefaultSegment');
    },
    getScreens: function getScreens(screens) {
      return screens && screens.filter(function (s) {
        return !s.type.toLowerCase().includes('generic');
      });
    },
    setButtonCancel: function setButtonCancel(cancel) {
      this.hideCancelButton = cancel;
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              //this.paginate('Disposition');
              //this.paginate('Screen');
              _this3.paginatesegment('Segment');
              _this3.paginatesegment('DefaultSegment');

              _this3.changeStyleOn();

              eventHub.$on('hideModalTitleSegment', function (val) {
                _this3.navparam = !val;
                _this3.selecteIdSegment = [];
                _this3.hideCancelButton = !val;
                _this3.disabledConfirmButton = val;
                _this3.changeStyleOff();
              });

              _this3.optionsLine();

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  },
  created: function created() {
    var self = this;
    eventHub.$on('stopProgress', function (val) {
      self.$refs.topProgress.done();
    });
    eventHub.$on('saveSelect', this.addSegment);
    eventHub.$on('hideCancelButton', this.setButtonCancel);
  }
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TransitionModal',
  data: function data() {
    return {
      transitionSegment: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    getSegmentByUid: 'segments/getSlideByUid',
    getSlideByUid: 'slides/getSlideByUid'
  }), {
    transition: function transition() {
      var slide = void 0;
      if (this.$route.name === 'segment') {
        slide = this.getSlideByUid(this.slide.uid);
      } else {
        slide = this.getSegmentByUid(this.slide.uid);
      }
      return slide && slide.transition.in ? slide.transition.in.replace('-in', '') : 'no-transition';
    }
  }),
  props: {
    slide: Object
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('slides', ['setSlideTransition']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('segments', ['setSegmentTransition']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('common', ['setShowIconSave']), {
    setTransition: function setTransition(transition) {
      this.transitionSegment = transition;
      var data = {
        uid: this.slide.uid,
        name: transition
      };
      if (this.$route.name === 'segment') {
        this.setSlideTransition(data);
      } else {
        this.setSegmentTransition(data);
      }
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
        this.setShowIconSave(true);
      }
    }
  })
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_en_US__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_fr_FR__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Modal_SlideCard__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Modal_SlideCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Modal_SlideCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_Mixin_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_carousel__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_GrapesMixinHelpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Modal_SegmentList_vue__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Modal_SegmentList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__Modal_SegmentList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_top_progress__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_top_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_top_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__core_directives_HasPermission_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_duration_handler__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_perfect_scrollbar__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_infinite_loading__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__main__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuedraggable__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__mixins_GrapesMixinEditors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mixins_GrapesMixinTranslate__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__mixins_GrapesMixinPanels__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Panel_PanelCard__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Panel_PanelCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__Panel_PanelCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_lazyload__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__core_http_http_token__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__core_router_router__ = __webpack_require__(18);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//























var lowercaseKeys = __webpack_require__(347);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SlideList',
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_Mixin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_GrapesMixinHelpers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__mixins_GrapesMixinEditors__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__mixins_GrapesMixinTranslate__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__mixins_GrapesMixinPanels__["a" /* default */]],
  directives: {
    HasPermission: __WEBPACK_IMPORTED_MODULE_14__core_directives_HasPermission_js__["a" /* default */]
  },
  props: {
    isScreen: false
  },
  data: function data() {
    return {
      options: [],
      ligneTemplate: [],
      clicksOut: true,
      showCollapse: false,
      navparam: true,
      selectedTab: '',
      infiniteState: null,
      selectedIds: [],
      selecteIdSegment: [],

      titleTemplate: this.$t('template.new_template'),
      total: 0,
      hideCancelButton: true,
      disabledConfirmButton: true,
      duration: 59,
      isActiveModule: false,
      activeModule: 'models',
      all_videos: [],
      all_images: [],
      textToSearch: '',
      tabs: ['models', 'recents', 'images', 'videos', 'empty'],
      tabsScreen: ['models-screen', 'recents-screen', 'images', 'empty'],
      scrollInterval: null,
      list: [],
      lists: [],
      segmentKey: 0,
      showScroll: false,
      isExtendedSlides: false,
      oldImages: false,
      tabsArray: []
    };
  },

  components: {
    vueTopprogress: __WEBPACK_IMPORTED_MODULE_13_vue_top_progress__["vueTopprogress"],
    SlideCard: __WEBPACK_IMPORTED_MODULE_8__Modal_SlideCard___default.a,
    Carousel: __WEBPACK_IMPORTED_MODULE_10_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_10_vue_carousel__["Slide"],
    SegmentList: __WEBPACK_IMPORTED_MODULE_12__Modal_SegmentList_vue___default.a,
    VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_16_vue_perfect_scrollbar___default.a,
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_17_vue_infinite_loading___default.a,
    draggable: __WEBPACK_IMPORTED_MODULE_19_vuedraggable___default.a,
    PanelCard: __WEBPACK_IMPORTED_MODULE_23__Panel_PanelCard___default.a,
    lazyComponent: __WEBPACK_IMPORTED_MODULE_24_vue_lazyload__["a" /* default */]
  },
  i18n: {
    messages: {
      en: __WEBPACK_IMPORTED_MODULE_6__i18n_en_US__["a" /* default */],
      fr: __WEBPACK_IMPORTED_MODULE_7__i18n_fr_FR__["a" /* default */]
    }
  },
  watch: {
    // Problème 11 : sur la route d'édition, `titleTemplate` restait à sa valeur
    // par défaut (« Nouveau programme ») car rien ne le renseignait depuis le
    // programme chargé. Le moindre ajout d'écran appelait alors setTemplate()
    // avec ce défaut et écrasait le nom réel, y compris dans le payload de save.
    'template.title': {
      immediate: true,
      handler: function handler(title) {
        if (title) this.titleTemplate = title;
      }
    },
    isLoading: function isLoading(_isLoading) {
      if (this.infiniteState) {
        if (this.isEndReached('DefaultSegment') || this.isEndReached('Segment')) {
          this.infiniteState.complete();
        } else if (!_isLoading) {
          this.infiniteState.loaded();
        }
      }
    },
    isLoadingMedias: function isLoadingMedias(isLoading) {
      this.callLoadMedias(isLoading);
    },
    DefaultSegments: function DefaultSegments(segments) {
      if (segments.length === 0 && this.infiniteState) {
        if (!this.isLoading) {
          this.loadMoreVideos();
        }
        this.infiniteState.reset();
      }
    },
    segments: function segments(_segments) {
      if (_segments.length === 0 && this.infiniteState) {
        if (!this.isLoading) {
          this.loadMoreVideos();
        }
        this.infiniteState.reset();
      }
    },
    getAllMedias: function getAllMedias(medias) {
      if (medias[this.activeModule].length === 0 && this.infiniteState) {
        if (!this.isLoadingMedias) {
          this.loadMoreVideos();
        }
        this.infiniteState.reset();
      }
    },


    all: {
      handler: function handler(all) {
        var _this = this;

        all.forEach(function (el, index) {
          _this.lists[index] = _this.getScreens(el);
        });
      },

      deep: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    //recentsSegment:'segments/getAllSegments',
    screens: 'slides/getAllScreens',
    currentSlide: 'slides/getCurrent',
    dispositions: 'slides/getAllDispositions',
    all: 'segments/getSelectedSegments',
    segments: 'segments/getAllSegments',
    SegmentsFiltredByTitle: 'segment/getFilterSegments',
    DefaultSegments: 'segments/getAllDefaultSegments',
    currentPage: 'segments/getCurrentPage',
    isLoading: 'segments/getLoading',
    isLoadingMedias: 'medias/getLoading',
    isEndReached: 'segments/getEndReached',
    isEndReachedMedias: 'medias/getEndReachedMedias',
    selected: 'slides/getSelected',
    selectedSegments: 'segments/getSelectedSegments',
    currentSegment: 'segments/getCurrent',
    isSelected: 'slides/isSelected',
    firstSelectedSegment: 'segments/getLastSegmentById',
    showIconSave: 'common/getShowIconSave',
    paramsClient: 'getParamsClients',
    hasPermission: 'hasPermission',
    totalDurationSegments: 'segments/getAllSegmentsDuration',
    template: 'slides/getTemplate',
    // all_videos: 'medias/getAllVideos',
    //all_images: 'medias/getAllImages',
    nb_videos: 'medias/getNbVideos',
    getAllMedias: 'medias/getAllMedias',
    nb_segments: 'segments/getNbSegments',
    lengthSegmentToAdd: 'segments/getLengthSegmentToAdd',
    moduleSelected: 'segments/getModuleSelected',

    getAssetManager: 'grapes/getAssetManager',
    getPermissions: 'getPermissions'
  }), {
    allTabs: function allTabs() {
      for (var i = 0; i < this.tabs.length; i++) {
        if (this.getPermissions['show_' + this.tabs[i] + '_part_action'] || this.tabs[i] === 'empty') {
          this.tabsArray.push(this.tabs[i]);
          if (this.tabsArray.length > 0) {
            this.activeModule = this.tabsArray[0];
          }
        }
      }
      return this.tabsArray;
    },
    getTitleSegment: function getTitleSegment() {
      return this.titleTemplate;
    },
    hasScrollSlides: function hasScrollSlides() {
      if (this.moduleSelected.length > 0) {
        var count = this.moduleSelected.length;
        var panelWidth = 0;
        var widthSlides = 0;
        var cardWrapper = document.querySelector('#module-list .timeline-modules .div-draggable-margin .slides-panel .card-wrapper');
        if (cardWrapper) {
          widthSlides = count * cardWrapper.clientWidth;
          if (this.isExtendedSlides) {
            var extendedPanel = document.querySelector('.inner-slides-wrapper.extended');
            widthSlides += extendedPanel.offsetWidth;
          }
        }
        var panel = document.querySelector('#module-list .timeline-modules .div-draggable-margin .slides-panel');
        if (panel) {
          panelWidth = panel.offsetWidth;
        }
        if (widthSlides >= panelWidth) {
          this.showScroll = true;
        } else {
          this.showScroll = false;
        }
        this.$root.$emit('showScroll', this.showScroll);
        return this.showScroll;
      }
    },
    confirmButtonDisabled: function confirmButtonDisabled() {
      return this.selected.length === 0 && this.selectedSegments.length === 0;
    },
    stateTitle: function stateTitle() {
      var state = this.titleTemplate.length >= 1 ? true : false;
      if (state) return null;else return state;
    },
    stateLigne: function stateLigne() {
      var state = this.ligneTemplate.length >= 1 ? true : false;
      if (state) return null;else return state;
    },

    // `durationTemplate` reste calculé : il alimente encore `template.duration`
    // dans le payload de sauvegarde, avec la valeur par défaut (59 s).
    durationTemplate: {
      get: function get() {
        var value = this.duration;
        var hours = Math.floor(value / 3600);
        value %= 3600;
        var minutes = Math.floor(value / 60);
        var seconds = value % 60;
        var addZero = function addZero(v) {
          return v < 10 ? '0' + v : v;
        };
        var t = [];

        t.push(addZero(hours));
        t.push(addZero(minutes));
        t.push(addZero(seconds));

        return t.join(':');
      },
      set: function set(value) {
        this.duration = value.split(':').reverse().reduce(function (prev, curr, i) {
          return prev + curr * Math.pow(60, i);
        }, 0);
      }
    },
    empty: function empty() {
      var disposition = {
        id: 0,
        type: 'Segment',
        title: this.$t('disposition.empty'),
        duration: __WEBPACK_IMPORTED_MODULE_15__helpers_duration_handler__["a" /* totalSegmentDuration */](),
        screens: [{
          id: 0,
          title: this.$t('screens.empty'),
          type: 'screen',
          options: { duration: __WEBPACK_IMPORTED_MODULE_15__helpers_duration_handler__["a" /* totalSegmentDuration */]() },
          assets: '',
          components: '',
          css: '',
          html: '',
          styles: '',
          transition: {
            in: '',
            out: ''
          },
          screenShot: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJAQMAAAAB5D5xAAAABlBMVEXs7vHs7/Hee24nAAAAFUlEQVQI12P4/58BiGrB5D8wCUX/AOfxEWuWlIcVAAAAAElFTkSuQmCC'
        }]
      };
      return disposition;
    },
    emptyDisposition: function emptyDisposition() {
      var customTitle = this.$t('disposition.segment') + parseInt(this.selectedSegments.filter(function (s) {
        return s.screens[0].options.oldType === 'empty';
      }).length + 1);

      var nbScreen = 1;
      if (this.paramsClient.nb_screen_segment === 1) {
        nbScreen = parseInt(this.selectedSegments.filter(function (s) {
          return s.screens[0].options.oldType === 'empty';
        }).length + 1);
      }

      var disposition = {
        id: 0,
        type: 'Segment',
        title: customTitle,
        duration: __WEBPACK_IMPORTED_MODULE_15__helpers_duration_handler__["a" /* totalSegmentDuration */](),
        screens: [{
          id: 0,
          title: this.$t('screens.screen') + nbScreen,
          type: 'screen',
          options: {
            duration: __WEBPACK_IMPORTED_MODULE_15__helpers_duration_handler__["a" /* totalSegmentDuration */](),
            oldType: 'empty'
          },
          assets: '',
          components: '',
          css: '',
          html: '',
          styles: '',
          transition: {
            in: '',
            out: ''
          },
          screenShot: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJAQMAAAAB5D5xAAAABlBMVEXs7vHs7/Hee24nAAAAFUlEQVQI12P4/58BiGrB5D8wCUX/AOfxEWuWlIcVAAAAAElFTkSuQmCC'
        }]
      };
      return disposition;
    },
    getComputedList: function getComputedList() {
      if (this.activeModule === 'models' && this.hasPermission('show_models_part_action')) {
        return this.DefaultSegments;
      } else if (this.activeModule === 'recents' && this.hasPermission('show_recents_part_action')) {
        return this.segments;
      } else {
        this.reloadListMedias();
        if (this.activeModule === 'videos' && this.hasPermission('show_videos_part_action')) {
          this.all_videos = this.getAllMedias(this.activeModule);
          return this.getAllMedias(this.activeModule);
        } else if (this.hasPermission('show_images_part_action')) {
          if (this.oldImages) {
            var allOldImages = [];
            var i = 0;
            if (this.getAssetManager) {
              this.getAssetManager.map(function (data) {
                i++;
                allOldImages.push({ id: i, title: 'image-' + i, lien: data });
              });
            }
            return allOldImages;
          } else {
            this.all_images = this.getAllMedias(this.activeModule);
            return this.getAllImages();
          }
        }
      }
    },
    getAllImages: function getAllImages() {
      var allImage = [];
      this.getAllMedias(this.activeModule).map(function (data) {
        allImage.push(lowercaseKeys(data));
      });
      return allImage;
    },
    noMoreMedias: function noMoreMedias() {
      if (this.activeModule === 'models') {
        return this.isEndReached('DefaultSegment');
      } else if (this.activeModule === 'recents') {
        return this.isEndReached('Segment');
      } else {
        return this.isEndReachedMedias(this.activeModule);
      }
    },
    noResultMedias: function noResultMedias() {
      if (this.activeModule === 'models') {
        return this.DefaultSegments.length === 0;
      } else if (this.activeModule === 'recents') {
        return this.segments.length === 0;
      } else {
        //if (this.activeModule === 'images') {
        return this.getAllMedias(this.activeModule).length === 0;
        // } else {
        //   return  this.getAllMedias(this.activeModule).length === 0;
      }
    },
    hasImagesModules: function hasImagesModules() {
      var found = false;
      if (this.paramsClient.display_default_blocks || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.paramsClient.display_default_blocks).length > 0) {
        this.paramsClient.display_default_blocks.map(function (block) {
          for (var i = 0; i < block.blocks.length; i++) {
            if (block.blocks[i] === 'image_media') {
              found = true;
            }
          }
        });
      }
      return found;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('segments', ['getSegments', 'paginatesegment', 'selectSegment', 'setCurrentSegment', 'removeLastSegmentById', 'updateSegment', 'setTitle', 'resetPage', 'setSegments', 'setNbrCall', 'updateSlideInsideSegment', 'selectMedias', 'reorderSegments', 'reorderSlidesInsideSegment', 'setEndReached', 'restModuleSelected', 'pushModuleSelected', 'removeFromModuleSelected']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('common', ['setShowIconSave']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('slides', ['paginate', 'selectSlide', 'setCurrentSlide', 'removeLastSlideById', 'updateSlide', 'fetch', 'setTemplate']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('grapes', ['setEditor', 'setAssetManager']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['setRoute']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('medias', ['reloadVideoList', 'reloadImageList', 'resetPageVideos', 'setTitleMedias', 'setMedias', 'setEndReachedMedias']), {
    setActiveScrollButtons: function setActiveScrollButtons() {
      if (this.moduleSelected.length > 0) {
        var count = this.all.length;
        var panelWidth = 0;
        var widthSlides = 0;
        var cardWrapper = document.querySelector('#module-list .timeline-modules .div-draggable-margin .slides-panel .card-wrapper');
        if (cardWrapper) {
          widthSlides = count * cardWrapper.clientWidth;
          if (this.isExtendedSlides) {
            var extendedPanel = document.querySelector('.inner-slides-wrapper.extended');
            widthSlides += extendedPanel.offsetWidth;
          }
        }
        var panel = document.querySelector('#module-list .timeline-modules .div-draggable-margin .slides-panel');
        if (panel) {
          panelWidth = panel.offsetWidth;
        }
        if (widthSlides >= panelWidth) {
          this.showScroll = true;
        } else {
          this.showScroll = false;
        }
        this.$root.$emit('showScroll', this.showScroll);
        return this.showScroll;
      }
    },
    reloadListMedias: function reloadListMedias() {
      var self = this;
      var listElm = document.querySelector('.default-modules');
      if (self.nb_videos === self.getAllMedias(self.activeModule).length) {
        return;
      }
      if (listElm) {
        listElm.onscroll = function () {
          if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
            self.setHiddenScroll();
          }
        };
      }
    },
    setHiddenScroll: function setHiddenScroll() {
      var self = this;
      if (self.getAllMedias(self.activeModule).length < self.nb_videos || !self.isEndReachedMedias(self.activeModule)) {
        if (self.activeModule === 'videos' && self.hasPermission('show_videos_part_action')) {
          self.reloadVideoList();
        } else {
          if (!self.oldImages && this.hasPermission('show_images_part_action')) {
            this.reloadImageList();
          }
        }
      }
    },
    callLoadMedias: function callLoadMedias(isLoading) {
      if (this.infiniteState) {
        if (this.isEndReachedMedias(this.activeModule)) {
          this.infiniteState.complete();
        } else if (!isLoading) {
          this.infiniteState.loaded();
        }
      }
    },
    haveScreen: function haveScreen(item) {
      if (item.screens) {
        return false; //item.screens.length > 1;
      }
    },
    screenShot: function screenShot(item) {
      if (this.activeModule === 'models' || this.activeModule === 'recents') {
        if (item.screens) {
          return item.screens[0] ? item.screens[0].screenShot : '';
        }
      } else {
        if (this.activeModule === 'images') {
          if (!this.oldImages) {
            return this.getThumbnailUrl(item, 'fit', 500) ? this.getThumbnailUrl(item, 'fit', 500) : '';
          } else {
            return item.lien ? item.lien : '';
          }
        } else {
          return item.logo ? item.logo : '';
        }
      }
    },
    loadMoreVideos: function loadMoreVideos($state) {
      if (!this.infiniteState) {
        this.infiniteState = $state;
      }
      if (this.activeModule === 'models') {
        if (this.isEndReached('DefaultSegment') && this.infiniteState) {
          this.infiniteState.complete();
          return;
        }
      } else if (this.activeModule === 'recents') {
        if (this.isEndReached('Segment') && this.infiniteState) {
          this.infiniteState.complete();
          return;
        }
      } else {
        if (this.isEndReachedMedias(this.activeModule) && this.infiniteState) {
          this.infiniteState.complete();
          return;
        }
      }
      if ($state) {
        if (this.activeModule === 'models' && this.hasPermission('show_models_part_action')) {
          this.paginatesegment('DefaultSegment');
        } else if (this.activeModule === 'recents' && this.hasPermission('show_recents_part_action')) {
          this.paginatesegment('Segment');
        } else if (this.activeModule === 'videos' && this.hasPermission('show_videos_part_action')) {
          this.reloadVideoList();
        } else {
          if (!this.oldImages && this.hasPermission('show_images_part_action')) {
            this.reloadImageList();
          }
        }
      }
    },
    loadMore: function loadMore() {
      if (this.activeModule === 'models' && this.hasPermission('show_models_part_action')) {
        this.paginatesegment('DefaultSegment');
      } else if (this.activeModule === 'recents' && this.hasPermission('show_recents_part_action')) {
        this.paginatesegment('Segment');
      } else if (this.activeModule === 'videos' && this.hasPermission('show_videos_part_action')) {
        this.reloadVideoList();
      } else {
        if (!this.oldImages && this.hasPermission('show_images_part_action')) {
          this.reloadImageList();
        }
      }
    },
    changeModule: function changeModule(module) {
      this.activeModule = module;
      this.isActiveModule = true;
      document.querySelector('.search-col').style.display = 'block';

      if (document.querySelector('.infinite-loading-container')) {}
      //document.querySelector('.infinite-loading-container').style.display = 'block';

      // this.searchTitle();
      if (module === 'models') {
        if (this.DefaultSegments.length === 0) {
          this.resetPage('DefaultSegment');
          this.paginatesegment('DefaultSegment');
        }
      } else if (module === 'recents') {
        if (this.segments.length === 0) {
          this.resetPage('Segment');
          this.paginatesegment('Segment');
        }
      } else if (module !== 'empty') {
        if (this.getAllMedias(this.activeModule).length == 0) {
          this.loadMoreVideos();
          if (module === 'videos') {
            this.reloadVideoList();
          } else {
            if (!this.oldImages) {
              this.reloadImageList();
            } else {
              if (document.querySelector('.infinite-loading-container')) {
                document.querySelector('.infinite-loading-container').style.visibility = 'hidden';
              }
              document.querySelector('.search-col').style.display = 'none';
            }
          }
        }
      }

      __WEBPACK_IMPORTED_MODULE_18__main__["bus"].$emit('displaycreenShot', module);
      if (this.textToSearch) {
        this.searchTitle(true);
      }
    },
    optionsLine: function optionsLine() {
      if (this.paramsClient.default_line) {
        this.options = this.paramsClient.default_line;
        this.ligneTemplate = this.options[0].value;
      }
    },
    showSegmentModal: function showSegmentModal() {
      // this.$router.push({ name: 'segment' });
      this.$router.push({ name: 'EditSegment' });
      this.setRoute('segment');
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.innerHTML = "<span style='font-family:RobotoUep!important;'>" + this.$t('template.save_and_exit') + '</span>';
      }
      this.cancel();
      eventHub.$emit('resetModalSegmentList');
      // this.$root.$emit('bv::show::modal', 'segment-list-modal', '#btnShow');
    },

    // loadMore() {
    //   this.isShown = true;
    // },
    showTab: function showTab(tab) {
      this.selectedTab = tab;
    },
    select: function select(item) {
      var selected = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(item));
      if (this.selectedIds.includes(selected.id)) {
        this.selectedIds = this.selectedIds.filter(function (i) {
          return i !== selected.id;
        });
        this.removeLastSlideById(selected.id);
      } else {
        this.selectedIds.push(selected.id);
        this.selectSlide(selected);
      }
    },
    addSegment: function addSegment(item, empty) {
      var selectedSegment = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(item));
      var display_default_blocks = this.paramsClient.display_default_blocks;

      if (this.selecteIdSegment.includes(selectedSegment.id)) {
        this.selecteIdSegment = this.selecteIdSegment.filter(function (i) {
          return i !== selectedSegment.id;
        });
        this.removeLastSegmentById(selectedSegment.id);
        this.removeFromModuleSelected(selectedSegment.id);
        this.dragSlide(event, -1, 'module-list');
      } else {
        this.disabledConfirmButton = false;

        this.selecteIdSegment.push(selectedSegment.id);

        if (this.activeModule === 'models' || this.activeModule === 'recents' || empty) {
          this.selectSegment(selectedSegment);
          this.pushModuleSelected(selectedSegment);
        } else {
          var src = selectedSegment.lien;
          if (display_default_blocks && display_default_blocks.length > 0) {
            var blocks = display_default_blocks.map(function (block) {
              return block.blocks;
            });
            blocks.forEach(function (block) {
              for (var i = 0; i < block.length; i++) {
                if (block[i] === 'video_mp4') {
                  src = selectedSegment.lienMp4;
                }
              }
            });
          }

          var slide = {
            id: selectedSegment.id,
            src: src,
            title: selectedSegment.title,
            logo: selectedSegment.logo,
            options: {
              duration: selectedSegment.duration,
              fullscreenVideo: true
            },
            duration: selectedSegment.duration
          };
          if (this.activeModule === 'images') {
            if (!this.oldImages) {
              slide.src = this.getThumbnailUrl(selectedSegment, 'fit', 500);
              slide.title = selectedSegment.phototitle;
            } else {
              if (selectedSegment.lien.indexOf('/mini') > -1) {
                slide.src = selectedSegment.lien.replace('/mini', '');
              } else {
                slide.src = selectedSegment.lien;
              }
              slide.title = selectedSegment.title;
            }

            slide.duration = __WEBPACK_IMPORTED_MODULE_15__helpers_duration_handler__["a" /* totalSegmentDuration */]();
            slide.options = {
              duration: __WEBPACK_IMPORTED_MODULE_15__helpers_duration_handler__["a" /* totalSegmentDuration */]()
            };
          }
          this.selectMedias({ selected: slide, type: this.activeModule });
        }
        this.dragSlide(event, 1, 'module-list');
      }

      if (this.selecteIdSegment.length < 1) {
        this.disabledConfirmButton = true;
      }
    },
    getThumbnailUrl: function getThumbnailUrl(selectedSegment, type, size) {
      var fileHash = selectedSegment.filehash;
      return "undefined" + 'thumbnails/' + type + '/' + size + '/' + fileHash;
    },
    showSelect: function showSelect(event, item, index) {
      this.setCurrentSegment(item);
      var px = document.getElementById(item.id).offsetLeft + 100;
      var topPx = document.getElementById(item.id).offsetHeight + 50;
      document.getElementById('collapse-1').classList.toggle('collapse');
      document.getElementById('collapse-1').classList.toggle('hide-triangle');
      document.getElementById('triangle').style.top = topPx + 'px';
      //  var slidesPreview = document.getElementById('triangle');
      this.showCollapse = true;
      document.getElementById('triangle').style.display = 'block';
    },
    confirm: function confirm() {
      var _this2 = this;

      var editor = grapesjsEMP.editors[0];
      // La durée n'étant plus saisie, seul le titre reste à valider.
      if (this.stateTitle == null) {
        if (this.hideCancelButton && document.querySelector('.canvas-div .gjs-frame')) {
          var height = document.querySelector('.canvas-div').offsetHeight / (document.querySelector('.canvas-div .gjs-frame').offsetHeight + 60) * 100;
          var width = document.querySelector('.canvas-div').offsetWidth / (document.querySelector('.canvas-div .gjs-frame').offsetWidth + 60) * 100;
          eventHub.$emit('updateDefaultValue', {
            percent: Math.min(height, width).toFixed(1) > 99 ? 100 : Math.min(height, width).toFixed(1),
            ty: Math.min(height, width).toFixed(1) > 99 ? 0 : document.querySelector('.canvas-div').offsetHeight - document.querySelector('.canvas-div .gjs-frame').offsetHeight + 50
          });
        }
        var psElement = document.getElementById('ps-slide-wrapper');
        var DraggableElement = document.getElementById('draggable-wrapper');
        psElement.scrollLeft = DraggableElement.offsetWidth;
        this.selectFirstSlide();

        var durationT = '';
        if (this.$route.name === 'edit') {
          durationT = this.template.duration;
        } else durationT = this.durationTemplate;

        // Durée totale des écrans
        this.total = 0;
        this.selectedSegments.map(function (s) {
          return _this2.total += s.duration;
        });
        this.selectedIds = [];
        var template = {
          title: this.titleTemplate !== '' ? this.titleTemplate : this.$t('template.new_template'),
          ligne: this.ligneTemplate !== [] ? this.ligneTemplate : this.$t('template.new_ligne'),
          duration: durationT
        };

        this.setTemplate(template);
        this.selecteIdSegment = [];

        // this.$root.$emit('bv::hide::modal', 'slide-list-modal');
        document.getElementById('module-list').style.display = 'none';
        var iconSave = document.querySelector('.icon-save');
        if (iconSave) {
          iconSave.classList.add('icon-selected');
          iconSave.innerText = '';

          this.setShowIconSave(true);
        }

        if (this.paramsClient.display_default_blocks && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.paramsClient.display_default_blocks).length > 0 && this.paramsClient.modules.show_list_block_action) {
          var blocks = document.querySelector('#gjs .gjs-pn-buttons .fa-th-large:not(.gjs-pn-active)');
          if (blocks) {
            blocks.click();
          }
        }
        this.onNav();
        this.changeStyleOff();
      }
      this.setNbrCall();
      this.setNoAutoplayVideo(editor);

      var videoPlayers = ['player', 'playlist'];
      videoPlayers.forEach(function (player) {
        _this2.setPausedVideo(player);
      });
      this.restModuleSelected();
      this.searchTitle(false);
    },
    selectFirstSlide: function selectFirstSlide() {
      var lastSlide = {
        uid: this.currentSlide.uid,
        components: localStorage.getItem('gjs-components'),
        js: localStorage.getItem('gjs-js'),
        html: localStorage.getItem('gjs-html'),
        css: this.sanitizeCSS(localStorage.getItem('gjs-css')),
        styles: localStorage.getItem('gjs-styles')
      };
      this.updateSlideInsideSegment(lastSlide);
      this.generateSlideThmbnail(lastSlide.uid);
      var segment = this.firstSelectedSegment(this.selecteIdSegment[0]);
      this.setCurrentSegment(segment);
      this.setCurrentSlide(segment.screens.filter(function (s) {
        return s.type !== 'startGeneric';
      })[0]);

      this.$root.$emit('updateCanvasContent');
    },
    cancel: function cancel() {
      var _this3 = this;

      this.selecteIdSegment.forEach(function (id) {
        _this3.removeLastSegmentById(id);
      });
      this.selecteIdSegment = [];
      // this.$root.$emit('bv::hide::modal', 'slide-list-modal');
      document.getElementById('module-list').style.display = 'none';
      if (this.isScreen) eventHub.$emit('eventShowListModuleScreen', false);

      this.restModuleSelected();
    },
    onNav: function onNav() {
      this.navparam = !this.navparam;
    },
    BackToBoProgram: function BackToBoProgram() {
      var obj = { backToBoProgram: true };
      parent.postMessage(obj, '*');
    },
    changeStyleOn: function changeStyleOn() {
      var style = document.createElement('style');
      style.innerHTML = '\n        #plan2,#plan1 {    overflow: auto;z-index: 9999;position: absolute;background-color: rgba(255, 255, 255,1);top:0; left:0; width: 100%;height: 100%;}\n        #plan1 {z-index: 1; filter: blur(4px);}\n        #btn-next {visibility:hidden;}\n        #btn-finish {visibility:hidden;}\n       ';
      document.head.appendChild(style);
    },
    changeStyleOff: function changeStyleOff() {
      var style = document.createElement('style');
      style.innerHTML = '\n        #plan1 {    overflow: auto;z-index: 9999;\n        padding: 1em 2em;\n        filter: blur(0px);}\n        #btn-next {visibility:visible;}\n        #btn-finish {visibility:visible;}\n       ';
      document.head.appendChild(style);
    },
    closeListScreen: function closeListScreen() {
      if (this.clicksOut) {
        this.showCollapse = true;
        if (document.getElementById('triangle')) {
          document.getElementById('triangle').style.display = 'none';
        }
      }
    },
    searchTitle: function searchTitle(x) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var title;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                title = '';

                if (!x) {
                  _context.next = 35;
                  break;
                }

                title = _this4.textToSearch;
                _this4.setTitle(title);
                _this4.setTitleMedias(title);

                if (!(_this4.activeModule === 'models' && _this4.hasPermission('show_models_part_action'))) {
                  _context.next = 13;
                  break;
                }

                _context.next = 8;
                return _this4.setEndReached({ type: 'DefaultSegment', endReached: false });

              case 8:
                _this4.setSegments([]);
                _this4.resetPage('DefaultSegment');
                _this4.paginatesegment('DefaultSegment');
                _context.next = 33;
                break;

              case 13:
                if (!(_this4.activeModule === 'recents' && _this4.hasPermission('show_recents_part_action'))) {
                  _context.next = 21;
                  break;
                }

                _context.next = 16;
                return _this4.setEndReached({ type: 'Segment', endReached: false });

              case 16:
                _this4.setSegments([]);
                _this4.resetPage('Segment');
                _this4.paginatesegment('Segment');
                _context.next = 33;
                break;

              case 21:
                _this4.setMedias({ type: _this4.activeModule, medias: [] });
                _this4.resetPageVideos(_this4.activeModule);

                if (!(_this4.activeModule === 'videos' && _this4.hasPermission('show_videos_part_action'))) {
                  _context.next = 29;
                  break;
                }

                _context.next = 26;
                return _this4.setEndReachedMedias({ type: 'videos', endReached: false });

              case 26:
                _this4.reloadVideoList();
                _context.next = 33;
                break;

              case 29:
                if (!(!_this4.oldImages && _this4.hasPermission('show_images_part_action'))) {
                  _context.next = 33;
                  break;
                }

                _context.next = 32;
                return _this4.setEndReachedMedias({ type: 'images', endReached: false });

              case 32:
                _this4.reloadImageList();

              case 33:
                _context.next = 55;
                break;

              case 35:
                _this4.textToSearch = '';
                _this4.activeModule = _this4.tabsArray[0];
                _this4.setTitle(title);
                _this4.setTitleMedias(title);
                if (_this4.hasPermission('show_models_part_action')) {
                  _this4.setEndReached({ type: 'DefaultSegment', endReached: false });
                  _this4.setSegments([]);
                  _this4.resetPage('DefaultSegment');
                  _this4.paginatesegment('DefaultSegment');
                }
                if (_this4.hasPermission('show_recents_part_action')) {
                  _this4.setEndReached({ type: 'Segment', endReached: false });
                  _this4.setSegments([]);
                  _this4.resetPage('Segment');
                  _this4.paginatesegment('Segment');
                }

                if (!_this4.hasPermission('show_videos_part_action')) {
                  _context.next = 48;
                  break;
                }

                _this4.setMedias({ type: 'videos', medias: [] });
                _this4.resetPageVideos('videos');
                _context.next = 46;
                return _this4.setEndReachedMedias({ type: 'videos', endReached: false });

              case 46:
                _context.next = 48;
                return _this4.reloadVideoList();

              case 48:
                if (!(!_this4.oldImages && _this4.hasPermission('show_images_part_action'))) {
                  _context.next = 55;
                  break;
                }

                _this4.setMedias({ type: 'images', medias: [] });
                _this4.resetPageVideos('images');
                _context.next = 53;
                return _this4.setEndReachedMedias({ type: 'images', endReached: false });

              case 53:
                _context.next = 55;
                return _this4.reloadImageList();

              case 55:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    setButtonCancel: function setButtonCancel(cancel) {
      this.hideCancelButton = cancel;
    },
    getScreens: function getScreens(segment) {
      return segment.screens.filter(function (s) {
        return s.type.toLowerCase().indexOf('generic') + s.type.toLowerCase().indexOf('blank') === -2;
      });
    },
    removeSmoothing: function removeSmoothing(event) {
      if (event) {
        this.$refs.ps.$el.style['scroll-behavior'] = 'auto';
      }
    },
    reorder: function reorder(event) {
      this.reorderSegments(event);
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    },
    reorderSlides: function reorderSlides(event, index) {
      this.reorderSlidesInsideSegment({ event: event, index: index });
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    }
  }),
  mounted: function mounted() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var self, blocks, i, inputText;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this5.changeStyleOn();
              if (_this5.hasPermission('show_videos_part_action')) {
                _this5.reloadVideoList();
              }
              self = _this5;

              if (_this5.paramsClient.display_default_blocks !== null || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_this5.paramsClient.display_default_blocks).length > 0) {
                blocks = _this5.paramsClient.display_default_blocks.map(function (block) {
                  return block.blocks;
                });

                for (i = 0; i < blocks.length; i++) {
                  blocks[i].forEach(function (item) {
                    if (item.indexOf('image') > -1) {
                      self.oldImages = true;
                    }
                  });
                }
              }
              if (!self.oldImages && _this5.hasPermission('show_images_part_action')) {
                _this5.reloadImageList();
              }
              eventHub.$on('hideModalTitleSegment', function (val) {
                _this5.navparam = !val;
                _this5.selecteIdSegment = [];
                _this5.hideCancelButton = !val;
                _this5.disabledConfirmButton = val;
                _this5.activeModule = _this5.tabsArray[0];
                _this5.loadMore();
                _this5.setActiveScrollButtons();
                _this5.changeStyleOff();
              });

              _this5.$root.$emit('displaycreenShot', _this5.activeModule);
              _this5.$root.$on('updateScrollInterval', function (obj) {
                _this5.dragSlide(obj.event, obj.position, 'module-list');
              });
              _this5.optionsLine();
              document.querySelector('.timeline-modules #ps-slide-wrapper').addEventListener('mouseover', _this5.removeSmoothing);
              inputText = document.getElementById('input-titre');


              if (inputText) {
                inputText.addEventListener('focus', function () {
                  // Problème 11 : ce handler vidait le titre à chaque focus (la garde
                  // reposait sur `keyupEvent`, jamais déclaré ici, donc toujours falsy,
                  // et sur `e.event.target` qui n'existe pas sur un FocusEvent).
                  // On ne vide plus que la valeur par défaut, jamais un titre réel.
                  if (self.titleTemplate === self.$t('template.new_template')) {
                    self.titleTemplate = '';
                  }
                });

                inputText.addEventListener('keyup', function (event) {
                  self.titleTemplate = event.target.value;
                });
              }
              eventHub.$on('updateTitleSegment', function (title) {
                _this5.titleTemplate = title;
              });

            case 13:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this5);
    }))();
  },
  created: function created() {
    var self = this;
    eventHub.$on('stopProgress', function (val) {
      self.$refs.topProgress.done();
    });
    this.loadMore();
    this.hideCancelButton = this.isScreen ? false : true;
    eventHub.$on('saveSelect', this.addSegment);
    eventHub.$on('hideCancelButton', this.setButtonCancel);
  }
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_directives_HasPermission_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CustomPanelCardActions__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CustomPanelCardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CustomPanelCardActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_Mixin_js__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PanelCard',
  components: {
    CustomPanelCardActions: __WEBPACK_IMPORTED_MODULE_3__CustomPanelCardActions___default.a
  },
  props: {
    typecard: '',
    segment: Object,
    slide: Object,
    index: Number,
    isSelected: Boolean,
    segmenOneScreen: Boolean,
    removable: Boolean,
    showVideoIntro: Object,
    isModuleList: {
      type: Boolean,
      default: false
    },
    isSegmentCard: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    HasPermission: __WEBPACK_IMPORTED_MODULE_2__core_directives_HasPermission_js__["a" /* default */]
  },
  data: function data() {
    return {
      isToggled: false,
      title: this.slide.title
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_Mixin_js__["a" /* default */]],
  created: function created() {
    eventHub.$on('toggleSegmentx', this.toggleSegment);
  },
  mounted: function mounted() {},

  watch: {
    slide: {
      handler: function handler(val) {
        this.title = val.title;
      },

      deep: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    hasVideoIntro: 'slides/getHasVideoIntro',
    currentSlide: 'slides/getCurrent',
    permission: 'getPermissions',
    selectedSlides: 'slides/getSelected',
    isExtended: 'segments/isExtended',
    paramsClient: 'getParamsClients'
  }), {
    duration: function duration() {
      return this.isSegmentCard ? this.slide.duration : this.slide.options.duration;
    },
    isMultipleLayers: function isMultipleLayers() {
      return this.isSegmentCard && !this.isModuleList && this.slide.screens.filter(function (s) {
        return s.type !== 'startGeneric';
      }).length > 1;
    },
    backgroundImage: function backgroundImage() {
      if (!this.isModuleList) {
        if (this.isSegmentCard) {
          var firstScreen = this.slide.screens.find(function (s) {
            return !s.type.toLowerCase().includes('generic');
          });
          if (firstScreen && firstScreen.screenShot) {
            return 'url(' + firstScreen.screenShot + ')';
          }
        }
        return 'url(' + (this.slide.screenShot || this.defaultScreenshot) + ')';
      }
    },
    backgroundImageMedia: function backgroundImageMedia() {
      if (this.isSegmentCard) {
        var firstScreen = this.slide.screens.find(function (s) {
          return !s.type.toLowerCase().includes('generic');
        });
        if (firstScreen && firstScreen.screenShot) {
          return {
            'background-image': 'url(' + firstScreen.screenShot + ')'
          };
        }
      }
      return { 'background-image': 'url(' + this.slide.screenShot || this.defaultScreenshot + ')' };
    },
    nuberScreen: function nuberScreen() {
      var number = 0;
      if (this.isSegmentCard) if (this.slide.screens) {
        number = this.slide.screens.length;
        return number.toString();
      } else return number.toString();
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('slides', ['updateSlideTitle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('segments', ['setIndexSlideToAdd', 'setCurrentSegment']), {
    checkTarget: function checkTarget(event) {
      if (!(event.target.classList.contains('more-actions-btn') || event.target.parentNode.classList.contains('more-actions-btn-parent'))) {
        this.$refs.cardEl.click();
      }
    },
    toggleSegment: function toggleSegment(isClose) {
      var val = {};
      if (isClose == 'close') {
        val.slide = this.slide;
        val.index = this.index;
        val.close = true;
        this.isToggled = !this.isToggled;
        eventHub.$emit('switchtoggle', val);
        return;
      } else if (!this.isSegmentCard) return;
      val.slide = this.slide;
      val.index = this.index;
      this.isToggled = !this.isToggled;
      eventHub.$emit('switchtoggle', val);

      if (this.isSegmentCard) {
        this.setCurrentSegment(this.slide);
        this.setIndexSlideToAdd(this.index);
      }
    },
    update: function update() {
      this.updateSlideTitle({ title: this.title, uid: this.slide.uid });
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
      this.toggleEditMode();
    },
    showSettingPanel: function showSettingPanel() {
      this.$emit('selected');
      setTimeout(function () {
        var barsEl = document.querySelector('#gjs .gjs-pn-buttons .fa-bars');
        var brushEl = document.querySelector('#gjs .gjs-pn-buttons .fa-paint-brush');
        var decorationTitleEl = document.querySelector('#gjs-sm-decoration:not(.gjs-sm-open) .gjs-sm-title');
        var durationTitleEl = document.querySelector('#gjs .gjs-sm-sector .gjs-sm-title');

        barsEl.click();
        var bodyTitleEl = document.querySelector('#gjs .gjs-layer-title');
        bodyTitleEl.click();

        brushEl.click();
        if (decorationTitleEl) {
          decorationTitleEl.click();
          durationTitleEl.click();
        }
      }, 500);
    }
  })
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Mixin_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_en_US__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_fr_FR__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_directives_HasPermission_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_duration_handler__ = __webpack_require__(40);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CustomPanelCardActions',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_Mixin_js__["a" /* default */]],
  directives: {
    HasPermission: __WEBPACK_IMPORTED_MODULE_6__core_directives_HasPermission_js__["a" /* default */]
  },
  data: function data() {
    return {
      show_transition: false,
      isEditMode: false,
      editMode: '',
      oldTitle: '',
      oldDuration: '',
      durationValue: 0,
      showError: false
    };
  },

  props: {
    index: Number,

    isSegmentCard: {
      type: Boolean,
      default: false
    },
    card: {
      type: Object,
      required: true
    },
    segment: {
      type: Object,
      default: function _default() {
        return { screens: [] };
      }
    }
  },
  mounted: function mounted() {
    this.show_transition = this.permission.show_transition;
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    currentSlide: 'slides/getCurrent',
    slideIndex: 'slides/getSlideIndex',
    allSlides: 'slides/getSelected',
    getmaxLength: 'common/getmaxLength',
    selectedSlides: 'slides/getSelected',

    currentSegment: 'segments/getCurrent',
    segmentIndex: 'segments/getSegmentIndex',
    allSegments: 'segments/getSelectedSegments',
    permissions: 'getPermissions',
    hasFullscreenVideo: 'segments/hasFullscreenVideo',
    getByUid: 'segments/getByUid',

    paramsClient: 'getParamsClients',
    permission: 'getPermissions',
    startGeneric: 'segments/getStartGeneric'
  }), {
    showBtnDuration: function showBtnDuration() {
      if ((this.$route.name === 'add' || this.$route.name === 'edit') && this.paramsClient.default_segment_duration !== null && !this.isSegmentCard) {
        return false;
      } else return true;
    },
    isSegmentMode: function isSegmentMode() {
      return this.$route.name === 'segment';
    },
    isRemovable: function isRemovable() {
      if (this.isSegmentMode) {
        return this.allSlides.length > 1;
      }
      if (this.isSegmentCard) {
        return this.allSegments.length > 1;
      }
      return this.segment.screens.filter(function (s) {
        return s.type !== 'startGeneric';
      }).length > 1;
    },

    title: {
      get: function get() {
        if (this.paramsClient.nb_screen_segment === 1) return this.card.screens[0].title;else return this.card.title;
      },
      set: function set(value) {
        if (!this.isSegmentMode) {
          if (this.paramsClient.nb_screen_segment === 1) this.updateFirstScreenSegmentTitle({ title: value, uid: this.card.uid });else this.updateSegmentTitle({ title: value, uid: this.card.uid });
        } else {
          this.updateSlideTitle({ title: value, uid: this.card.uid });
        }
      }
    },
    duration: {
      get: function get() {
        return this.isSegmentCard ? this.card.duration : this.card.options.duration;
      },
      set: function set(value) {
        this.durationValue = value;
        if (!this.isSegmentMode) {
          this.updateSegmentDuration({ duration: value, uid: this.card.uid });
        } else {
          this.updateSlideDuration({ duration: value, uid: this.card.uid });
        }
      }
    },
    durationInput: {
      get: function get() {
        var value = this.duration;
        var hours = Math.floor(value / 3600);
        value %= 3600;
        var minutes = Math.floor(value / 60);
        var seconds = value % 60;
        var addZero = function addZero(v) {
          return v < 10 ? '0' + v : v;
        };
        var t = [];

        t.push(addZero(hours));
        t.push(addZero(minutes));
        t.push(addZero(seconds));

        return t.join(':');
      },
      set: function set(value) {
        this.showError = false;
        this.duration = value.split(':').reverse().reduce(function (prev, curr, i) {
          return prev + curr * Math.pow(60, i);
        }, 0);
      }
    },
    hasError: function hasError() {
      return this.showError && (!this.hasFullscreenVideo(this.card.uid) || this.isSegmentCard);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('slides', ['updateTitle', 'updateSlideTitle', 'updateSlideDuration', 'removeSlideByUid', 'setCurrentSlide']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('segments', ['updateFirstScreenSegmentTitle', 'updateSegmentTitle', 'updateSegmentDuration', 'removeSegmentByUid', 'setCurrentSegment', 'removeSlideFromSegmentByUid', 'updateTitleScreenInSegment', 'updateTitleSegment', 'setCurrentSegmentTitle']), {
    addTransition: function addTransition(segment) {
      eventHub.$emit('eventaAddTransition', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, segment.screens[0]));
    },
    showEditTitlePanel: function showEditTitlePanel() {
      this.toggleEditMode();
      this.editMode = 'title';
      this.oldTitle = this.title;
    },
    showEditDurationPanel: function showEditDurationPanel() {
      this.toggleEditMode();
      this.editMode = 'duration';
      this.oldDuration = this.duration;
      this.durationValue = this.duration;
      this.showError = false;
    },
    toggleEditMode: function toggleEditMode() {
      var cancel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.isEditMode = !this.isEditMode;
      if (cancel) {
        if (this.editMode === 'title') {
          this.title = this.oldTitle;
        } else {
          this.duration = this.oldDuration;
        }
      }
    },
    closePopover: function closePopover() {
      this.toggleEditMode(true);
      this.$refs.closeBtn.click();
    },
    handleUpdate: function handleUpdate() {
      if (this.editMode === 'title') {
        if (!this.isSegmentMode) {
          if (this.isSegmentCard) {
            this.updateSegment();
          } else {
            this.updateTitleScreen();
          }
        } else {
          this.updateTitleSlide();
        }
      } else {
        if (this.$route.name === 'add' || this.$route.name === 'edit') {
          if (__WEBPACK_IMPORTED_MODULE_7__helpers_duration_handler__["e" /* isMultipleBy30 */]() && Math.abs(this.durationValue - this.oldDuration) % 30 > 0) {
            this.showError = true;
            if (!this.isSegmentCard && this.hasFullscreenVideo(this.card.uid)) {
              this.$root.$emit('eventExtendSegmentDuration', {
                uid: this.getByUid(this.card.uid).uid
              });
            }
            return;
          }
          if (!this.isSegmentMode) {
            this.updateSegmentDuration({
              duration: this.durationValue,
              uid: this.card.uid,
              confirmed: true
            });
            this.showError = false;
          } else {
            this.updateSlideDuration({
              duration: this.durationValue,
              uid: this.card.uid,
              confirmed: true
            });
          }
        } else if (this.$route.name === 'segment') {
          if (!this.isSegmentMode) {
            this.updateSegmentDuration({
              duration: this.durationValue,
              uid: this.card.uid,
              confirmed: true
            });
            this.showError = false;
          } else {
            this.updateSlideDuration({
              duration: this.durationValue,
              uid: this.card.uid,
              confirmed: true
            });
          }
        }

        this.oldDuration = this.durationValue;
        this.closePopover();
      }

      this.toggleEditMode();
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
    },
    updateTitleScreen: function updateTitleScreen() {
      this.updateSegmentTitle(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.card, { title: this.title }));
    },
    updateSegment: function updateSegment() {

      if (this.paramsClient.nb_screen_segment === 1) this.updateFirstScreenSegmentTitle(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.card, { title: this.title }));else this.updateSegmentTitle(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.card, { title: this.title }));
    },
    updateTitleSlide: function updateTitleSlide() {
      if (parseInt(this.permissions.nb_screen_segment) === 1) {
        this.setCurrentSegmentTitle(this.title);
      } else {
        this.updateSlideTitle(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.card, { title: this.title }));
      }
    },
    handleDelete: function handleDelete(event) {
      var _this = this;

      var editor = grapesjsEMP.editors[0];
      this.$swal.fire({
        title: this.$t('modal.delete.title'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#f44336',
        cancelButtonColor: '#2196F3',
        confirmButtonText: this.$t('modal.delete.btn_confirm'),
        cancelButtonText: this.$t('modal.delete.btn_cancel'),
        customClass: 'swal-delete'
      }).then(function (result) {
        if (result.value) {
          _this.$swal.fire({
            title: 'Supprimé!',
            type: 'success',
            showConfirmButton: false,
            timer: 2000
          });
          if (_this.isSegmentMode) {
            _this.deleteSlide();
          } else if (_this.isSegmentCard) {
            _this.deleteSegment();
          } else {
            _this.deleteSlideFromSegment();
          }
          _this.$root.$emit('updateCanvasContent');
          _this.setNoAutoplayVideo(editor);
          var iconSave = document.querySelector('.icon-save');
          if (iconSave) {
            iconSave.classList.add('icon-selected');
          }
          _this.$root.$emit('updateScrollInterval', { event: event, position: -1 });
        }
      });
    },
    deleteSlide: function deleteSlide() {
      var index = this.slideIndex(this.card);

      this.removeSlideByUid(this.card.uid);
      this.setCurrentSlide(this.allSlides[Math.max(index - 1, 0)]);
    },
    deleteSegment: function deleteSegment() {
      var index = this.segmentIndex(this.card);
      this.removeSegmentByUid(this.card.uid);
      this.setCurrentSegment(this.allSegments[Math.max(index - 1, 0)]);
      this.setCurrentSlide(this.allSegments[Math.max(index - 1, 0)].screens.filter(function (s) {
        return s.type !== 'startGeneric';
      })[0]);
    },
    deleteSlideFromSegment: function deleteSlideFromSegment() {
      var index = this.segmentIndex(this.segment);
      this.removeSlideFromSegmentByUid({ index: index, uid: this.card.uid });
      this.setCurrentSlide(this.segment.screens.filter(function (s) {
        return s.type !== 'startGeneric';
      })[0]);
    },
    showSettingPanel: function showSettingPanel() {
      var editor = grapesjsEMP.editors[0];
      var wrapper = editor.DomComponents.getWrapper();
      editor.select(wrapper);

      var brushEl = document.querySelector('#gjs .gjs-pn-buttons .fa-paint-brush:not(.gjs-pn-active )');
      var decorationTitleEl = document.querySelector('#gjs-sm-decoration:not(.gjs-sm-open) .gjs-sm-title');
      var durationTitleEl = document.querySelector('#gjs .gjs-sm-sector .gjs-sm-title');

      if (brushEl) {
        brushEl.click();
      }
      if (decorationTitleEl) {
        decorationTitleEl.click();
        durationTitleEl.click();
      }
    }
  }),
  i18n: {
    messages: {
      en: __WEBPACK_IMPORTED_MODULE_4__i18n_en_US__["a" /* default */],
      fr: __WEBPACK_IMPORTED_MODULE_5__i18n_fr_FR__["a" /* default */]
    }
  }
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_perfect_scrollbar__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_en_US__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_fr_FR__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_Mixin_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_GrapesMixinEditors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_GrapesMixinHelpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_GrapesMixinTranslate__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_GrapesMixinPanels__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CustomPanelCard__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CustomPanelCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__CustomPanelCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__core_directives_HasPermission_js__ = __webpack_require__(30);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_Mixin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_GrapesMixinEditors__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_GrapesMixinHelpers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_GrapesMixinPanels__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_GrapesMixinTranslate__["a" /* default */]],
  directives: {
    HasPermission: __WEBPACK_IMPORTED_MODULE_14__core_directives_HasPermission_js__["a" /* default */]
  },

  data: function data() {
    return {
      typecard: 'segment',
      oneScreen: false,
      showScreen: false,
      show_transition: true,
      segmentKey: 0,
      logoDebut: '',
      logoFin: '',
      list: [],
      lists: [],
      show_video_intro: true,
      show_generic_display: 0,
      oldValue: '',
      opened: true,
      withGeneric: true,
      currentId: null,
      title: '',
      idSelected: 0,
      typeAnimation: '',
      animation: '',
      scrollInterval: null,
      showScroll: false,
      isExtendedSlides: false
    };
  },

  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default.a,
    CustomPanelCard: __WEBPACK_IMPORTED_MODULE_13__CustomPanelCard___default.a,
    VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_5_vue_perfect_scrollbar___default.a
  },
  i18n: {
    messages: {
      en: __WEBPACK_IMPORTED_MODULE_6__i18n_en_US__["a" /* default */],
      fr: __WEBPACK_IMPORTED_MODULE_7__i18n_fr_FR__["a" /* default */]
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    all: 'segments/getSelectedSegments',
    currentSlide: 'slides/getCurrent',
    currentSegment: 'segments/getCurrent',
    modal: 'grapes/getModal',
    paramsClient: 'getParamsClients',
    startGeneric: 'segments/getStartGeneric',
    finishGeneric: 'segments/getFinishGeneric',
    hasPermission: 'hasPermission',
    isExtended: 'segments/isExtended',
    duplicatedSegment: 'segments/getduplicatedSegment',
    duplicatedSlideInSegment: 'segments/getduplicatedSlideInSegment',
    lengthSegmentToAdd: 'segments/getLengthSegmentToAdd'
  }), {
    hasScrollSlides: function hasScrollSlides() {
      if (this.all.length > 0) {
        var count = this.all.length;
        var panelWidth = 0;
        var widthSlides = 0;
        var cardWrapper = document.querySelector('.slide');
        if (cardWrapper) {
          widthSlides = count * cardWrapper.clientWidth * 1.4;
          if (this.isExtendedSlides) {
            var extendedPanel = document.querySelector('.inner-slides-wrapper.extended');
            widthSlides += extendedPanel.offsetWidth;
          }
        }
        var panel = document.querySelector('.slides-panel');
        if (panel) {
          panelWidth = panel.offsetWidth;
        }
        if (widthSlides >= panelWidth) {
          this.showScroll = true;
        } else {
          this.showScroll = false;
        }
        this.$root.$emit('showScroll', this.showScroll);
        return this.showScroll;
      }
    }
  }),
  watch: {
    all: {
      handler: function handler(all) {
        var _this = this;

        all.forEach(function (el, index) {
          _this.lists[index] = _this.getScreens(el);
        });
      },

      deep: true
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('slides', ['setCurrentSlide']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('segments', ['setCurrentSegment', 'setIndexSegmentToAdd', 'setLengthSegmentToAdd', 'setIndexSlideToAdd', 'setIndexSegmentSlideToAdd', 'duplicateSegment', 'duplicateSlideInsideSegment', 'updateSlideInsideSegment', 'toggleExtendSegment', 'reorderSegments', 'reorderSlidesInsideSegment']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('common', ['setGenericThem', 'setOptionsThemeSelect']), {
    setActiveScrollButtons: function setActiveScrollButtons() {
      if (this.all.length > 0) {
        var count = this.all.length;
        var panelWidth = 0;
        var widthSlides = 0;
        var cardWrapper = document.querySelector('.slide');
        if (cardWrapper) {
          widthSlides = count * cardWrapper.clientWidth * 1.4;
          if (this.isExtendedSlides) {
            var extendedPanel = document.querySelector('.inner-slides-wrapper.extended');
            widthSlides += extendedPanel.offsetWidth;
          }
        }
        var panel = document.querySelector('.slides-panel');
        if (panel) {
          panelWidth = panel.offsetWidth;
        }
        if (widthSlides >= panelWidth) {
          this.showScroll = true;
        } else {
          this.showScroll = false;
        }
        this.$root.$emit('showScroll', this.showScroll);
        return this.showScroll;
      }
    },
    isActiveScrollSlide: function isActiveScrollSlide(extended) {
      var _this2 = this;

      this.$nextTick(function () {
        var index = 0;
        var interval = setInterval(function () {
          index++;
          _this2.isExtendedSlides = extended;
          _this2.setActiveScrollButtons();
          if (extended || !extended) {
            clearInterval(interval);
          }
          if (index === 10) {
            clearInterval(interval);
          }
        }, 500);
      });
    },
    getScreens: function getScreens(segment) {
      return segment.screens.filter(function (s) {
        return s.type.toLowerCase().indexOf('generic') + s.type.toLowerCase().indexOf('blank') === -2;
      });
    },
    hasStartGeneric: function hasStartGeneric(segment) {
      return segment.screens.some(function (s) {
        return s.type === 'startGeneric';
      });
    },
    hasTransition: function hasTransition(segment) {
      return segment.screens[0].transition.in && segment.screens[0].transition.in !== 'no-transition-in';
    },
    hasTransitionSlide: function hasTransitionSlide(slide) {
      return slide.transition.in && slide.transition.in.length > 0;
    },
    selectSlide: function selectSlide(segment, slide) {
      var _this3 = this;

      if (slide.uid === this.currentSlide.uid) {
        return;
      }
      var editor = grapesjsEMP.editors[0];
      var wrapper = editor.DomComponents.getWrapper();
      editor.select(wrapper);
      setTimeout(function () {
        var lastSlide = {
          uid: _this3.currentSlide.uid,
          components: localStorage.getItem('gjs-components'),
          js: localStorage.getItem('gjs-js'),
          html: localStorage.getItem('gjs-html'),
          css: _this3.sanitizeCSS(localStorage.getItem('gjs-css')),
          styles: localStorage.getItem('gjs-styles')
        };
        _this3.updateSlideInsideSegment(lastSlide);
        _this3.generateSlideThmbnail(_this3.currentSlide.uid);
        setTimeout(function () {
          //Set Current Screen
          _this3.setCurrentSlide(slide);
          //Set Current Segment by Screen
          _this3.setCurrentSegment(segment);
          _this3.removeToolbarCkeditor();
          _this3.$root.$emit('updateCanvasContent');
          _this3.setNoAutoplayVideo(editor);
          var videoPlayers = ['player', 'playlist'];
          videoPlayers.forEach(function (player) {
            _this3.setPausedVideo(player);
          });
          if (_this3.paramsClient.display_default_blocks && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this3.paramsClient.display_default_blocks).length > 0 && _this3.paramsClient.modules.show_list_block_action) {
            var blocks = document.querySelector('#gjs .gjs-pn-buttons .fa-th-large:not(.gjs-pn-active)');
            if (blocks) {
              blocks.click();
            }
          }
        }, 100);
      }, 100);
    },
    selectSegment: function selectSegment(slide) {
      var _this4 = this;

      if (slide.uid === this.currentSegment.uid) {
        return;
      }
      var editor = grapesjsEMP.editors[0];
      var wrapper = editor.DomComponents.getWrapper();
      editor.select(wrapper);
      setTimeout(function () {
        var lastSlide = {
          uid: _this4.currentSlide.uid,
          components: localStorage.getItem('gjs-components'),
          js: localStorage.getItem('gjs-js'),
          html: localStorage.getItem('gjs-html'),
          css: _this4.sanitizeCSS(localStorage.getItem('gjs-css')),
          styles: localStorage.getItem('gjs-styles')
        };
        _this4.updateSlideInsideSegment(lastSlide);
        _this4.generateSlideThmbnail(_this4.currentSlide.uid);
        setTimeout(function () {
          _this4.setCurrentSlide(slide.screens.filter(function (s) {
            return s.type !== 'startGeneric';
          })[0]);
          _this4.setCurrentSegment(slide);
          _this4.removeToolbarCkeditor();
          _this4.$root.$emit('updateCanvasContent');
          _this4.setNoAutoplayVideo(editor);
          var videoPlayers = ['player', 'playlist'];
          videoPlayers.forEach(function (player) {
            _this4.setPausedVideo(player);
          });
          if (_this4.paramsClient.display_default_blocks && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this4.paramsClient.display_default_blocks).length > 0 && _this4.paramsClient.modules.show_list_block_action) {
            var blocks = document.querySelector('#gjs .gjs-pn-buttons .fa-th-large:not(.gjs-pn-active)');
            if (blocks) {
              blocks.click();
            }
          }
        }, 100);
      }, 100);
    },
    handleDuplicateSegment: function handleDuplicateSegment(segment, index) {
      if (this.startGeneric) {
        index++;
      }

      var clone = this.getSegmentCloneThis(segment);
      segment = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, segment, clone);

      var type = 'manyscreen';
      if (this.paramsClient.nb_screen_segment === 1) {
        type = 'onescreen';
      }

      this.duplicateSegment({ segment: segment, index: index, type: type });
      this.selectSegment(this.duplicatedSegment);

      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
    },
    handleDuplicateSlideInsideSegment: function handleDuplicateSlideInsideSegment(segment, slide, segmentIndex, slideIndex) {
      if (this.startGeneric) {
        segmentIndex++;
      }
      if (this.hasStartGeneric(segment)) {
        slideIndex++;
      }
      if (this.currentSlide.uid === slide.uid) {
        var clone = this.getClone();
        slide = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.currentSlide, clone);
      }
      this.duplicateSlideInsideSegment({ slide: slide, segmentIndex: segmentIndex, slideIndex: slideIndex });

      this.selectSlide(segment, this.duplicatedSlideInSegment);

      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
    },
    toggleSegmentCards: function toggleSegmentCards(slide, index, close) {

      if (this.oneScreen) return;
      this.showScreen = close ? false : !this.showScreen;
      this.toggleExtendSegment(slide);
      //this.isActiveScrollSlide(slide.isExtended);
      this.segmentKey++;
      this.isExtendedSlides = close ? false : !this.isExtendedSlides;
      // this.slide.isExtended = !this.slide.isExtended
    },
    closeSegmentCards: function closeSegmentCards() {
      eventHub.$emit('toggleSegmentx', 'close');
    },
    calculateWidth: function calculateWidth(segment) {
      return {
        width: 'auto' //168+25:0
      };
    },
    addTransition: function addTransition(segment) {
      this.$emit('transitionSelected', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, segment.screens[0]));
    },
    addTransitionSlide: function addTransitionSlide(slide) {
      this.$emit('transitionSelected', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, slide));
    },
    videoGenerique: function videoGenerique(generic, index) {
      if (this.paramsClient.display_themes_elements != null) {
        // initialize idTheme in store for each type generic
        if (generic == 'fin' && this.paramsClient.display_themes_elements.conclusion) {
          this.setGenericThem(this.paramsClient.display_themes_elements.conclusion[0].id);
          this.setOptionsThemeSelect(this.paramsClient.display_themes_elements.conclusion);
        }
        if (generic == 'intro' && this.paramsClient.display_themes_elements.intro) {
          this.setGenericThem(this.paramsClient.display_themes_elements.intro[0].id);
          this.setOptionsThemeSelect(this.paramsClient.display_themes_elements.intro);
        }
        if (generic == 'debut' && this.paramsClient.display_themes_elements.generic) {
          this.setGenericThem(this.paramsClient.display_themes_elements.generic[0].id);
          this.setOptionsThemeSelect(this.paramsClient.display_themes_elements.generic);
        }
      } else this.setGenericThem(0);

      var self = this;
      var mdlDialog = document.querySelector('.gjs-mdl-dialog');
      eventHub.$emit('eventShowListVideo', true);
      eventHub.$emit('displayGenericListVideo', generic);
      var infoContainer = document.getElementById('list_videos');
      infoContainer.setAttribute('generic', generic);
      infoContainer.setAttribute('data-index', this.startGeneric ? index + 1 : index);
      infoContainer.style.display = 'block';
      self.translatePluginsTitle(null, 'add_generic_' + generic);
      /* self.modal.setTitle(self.$t('blocks.add_generic_' + generic));
        self.modal.setContent(infoContainer);
        document.getElementById('CanvOverlay').style.display = 'block';
        self.modal.open();
        self.modal.getModel().once('change:open', function() {
          document.getElementById('CanvOverlay').style.display = 'none';
          eventHub.$emit('eventShowListVideo', false);
        });*/
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
    },
    handleInsertSegment: function handleInsertSegment(index) {
      this.setIndexSegmentToAdd(index + 1);
      this.setLengthSegmentToAdd(this.all.length);
      this.showSlideListModal();
      this.removeToolbarCkeditor();
    },
    handleAppendSlide: function handleAppendSlide(currentSegment) {
      this.setIndexSegmentSlideToAdd(currentSegment.id);
      eventHub.$emit('setShowAddScreen', true);
    },
    showSlideListModal: function showSlideListModal() {
      if (document.getElementById('module-list')) {
        document.getElementById('module-list').style.display = 'block';
      }
      this.$root.$emit('bv::show::modal', 'slide-list-modal');
      eventHub.$emit('hideModalTitleSegment', true);
    },
    reorder: function reorder(event) {
      this.reorderSegments(event);
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    },
    reorderSlides: function reorderSlides(event, index) {
      this.reorderSlidesInsideSegment({ event: event, index: index });
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    }
  }),
  created: function created() {
    var _this5 = this;

    this.show_generic_display = localStorage.getItem('video_generique');
    this.$root.$on('show-list-video', function (val) {
      _this5.videoGenerique(val);
    });
    eventHub.$on('switchtoggle', function (val) {
      _this5.toggleSegmentCards(val.slide, val.index, val.close);
    });
  },
  mounted: function mounted() {
    var _this6 = this;

    if (this.paramsClient.show_video_intro === '0') this.show_video_intro = false;else this.show_video_intro = this.permission.show_intro_video_action;
    this.show_transition = this.permission.show_transition;
    this.isActiveScrollSlide();

    if (this.paramsClient.nb_screen_segment === 1) {
      this.typecard = 'screen';
      this.oneScreen = true;
    }

    this.$root.$on('updateScrollInterval', function (obj) {
      _this6.dragSlide(obj.event, obj.position);
    });
  }
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_sweetalert2__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_perfect_scrollbar__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_screen_service__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_en_US__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_fr_FR__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_Mixin_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_GrapesMixinEditors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_GrapesMixinTranslate__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_GrapesMixinHelpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_GrapesMixinPanels__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CustomPanelCard__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CustomPanelCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__CustomPanelCard__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_Mixin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_GrapesMixinEditors__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_GrapesMixinHelpers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__mixins_GrapesMixinPanels__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_GrapesMixinTranslate__["a" /* default */]],
  props: { isEditSegement: null },
  data: function data() {
    return {
      list: [],
      show_video_intro: true,
      show_transition: true,
      show_generic_display: 0,
      oldValue: '',
      opened: true,
      withGeneric: true,
      currentId: null,
      title: '',
      idSelected: 0,
      typeAnimation: '',
      animation: '',
      scrollInterval: null,
      showScroll: false
    };
  },

  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default.a,
    CustomPanelCard: __WEBPACK_IMPORTED_MODULE_15__CustomPanelCard___default.a,
    VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_6_vue_perfect_scrollbar___default.a
  },
  i18n: {
    messages: {
      en: __WEBPACK_IMPORTED_MODULE_8__i18n_en_US__["a" /* default */],
      fr: __WEBPACK_IMPORTED_MODULE_9__i18n_fr_FR__["a" /* default */]
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    all: 'slides/getSelected',
    currentSlide: 'slides/getCurrent',
    modal: 'grapes/getModal',
    paramsClient: 'getParamsClients',
    startGeneric: 'slides/getStartGeneric',
    finishGeneric: 'slides/getFinishGeneric',
    duplicateScreen: 'slides/getduplicateScreen',
    permission: 'getPermissions'
  }), {
    hasScrollSlides: function hasScrollSlides() {
      if (this.all.length > 0) {
        var panelWidth = 0;
        var widthSlides = 0;
        var count = this.all.length;
        var cardWrapper = document.querySelector('.slide');
        if (cardWrapper) {
          widthSlides = count * cardWrapper.clientWidth * 1.4;
        }
        var panel = document.querySelector('.slides-panel');
        if (panel) {
          panelWidth = panel.offsetWidth;
        }
        if (widthSlides >= panelWidth) {
          this.showScroll = true;
        } else {
          this.showScroll = false;
        }
        return this.showScroll;
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('slides', ['updateSlide', 'setCurrentSlide', 'duplicateSlide']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('common', ['setGenericThem', 'setOptionsThemeSelect']), {
    setActiveScrollButtons: function setActiveScrollButtons() {
      if (this.all.length > 0) {
        var panelWidth = 0;
        var widthSlides = 0;
        var count = this.all.length;
        var cardWrapper = document.querySelector('.slide');
        if (cardWrapper) {
          widthSlides = count * cardWrapper.clientWidth * 1.4;
        }
        var panel = document.querySelector('.slides-panel');
        if (panel) {
          panelWidth = panel.offsetWidth;
        }
        if (widthSlides >= panelWidth) {
          this.showScroll = true;
        } else {
          this.showScroll = false;
        }
        return this.showScroll;
      }
    },
    hasTransition: function hasTransition(slide) {
      return slide.transition.in && slide.transition.in.length > 0;
    },
    selectSlide: function selectSlide(slide) {
      var _this = this;

      if (slide.uid === this.currentSlide.uid) {
        return;
      }
      var editor = grapesjsEMP.editors[0];
      var wrapper = editor.DomComponents.getWrapper();
      //editor.select(wrapper);
      setTimeout(function () {
        var lastSlide = {
          uid: _this.currentSlide.uid,
          components: localStorage.getItem('gjs-components'),
          js: localStorage.getItem('gjs-js'),
          html: localStorage.getItem('gjs-html'),
          css: _this.sanitizeCSS(localStorage.getItem('gjs-css')),
          styles: localStorage.getItem('gjs-styles')
        };
        _this.updateSlide(lastSlide);
        _this.generateSlideThmbnail(_this.currentSlide.uid);
        setTimeout(function () {
          _this.setCurrentSlide(slide);
          _this.removeToolbarCkeditor();
          _this.$root.$emit('updateCanvasContent');
          _this.setNoAutoplayVideo(editor);
          var videoPlayers = ['player', 'playlist'];
          videoPlayers.forEach(function (player) {
            _this.setPausedVideo(player);
          });

          if (_this.paramsClient.display_default_blocks && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this.paramsClient.display_default_blocks).length > 0 && _this.paramsClient.modules.show_list_block_action) {
            var blocks = document.querySelector('#gjs .gjs-pn-buttons .fa-th-large:not(.gjs-pn-active)');
            if (blocks) {
              blocks.click();
            }
          }
        }, 100);
      }, 100);
    },
    handleDuplicateSlide: function handleDuplicateSlide(slide, index) {
      if (this.currentSlide.uid === slide.uid) {
        var clone = this.getClone();
        slide = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.currentSlide, clone);
      }
      this.duplicateSlide({ slide: slide, index: index });

      this.selectSlide(this.duplicateScreen);

      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
    },
    addTransition: function addTransition(slide) {
      this.$emit('transitionSelected', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, slide));
    },
    videoGenerique: function videoGenerique(generic, index) {
      var self = this;
      if (this.paramsClient.display_themes_elements != null) {
        if (generic == 'debut' && this.paramsClient.display_themes_elements.intro) {
          this.setGenericThem(this.paramsClient.display_themes_elements.intro[0].id);
          this.setOptionsThemeSelect(this.paramsClient.display_themes_elements.intro);
        }
      } else this.setGenericThem(0);
      var mdlDialog = document.querySelector('.gjs-mdl-dialog');
      eventHub.$emit('eventShowListVideo', true);
      var infoContainer = document.getElementById('list_videos');
      infoContainer.setAttribute('generic', generic);
      infoContainer.style.display = 'block';
      self.translatePluginsTitle(null, 'add_generic_intro');
      self.modal.setTitle(self.$t('blocks.add_generic_intro'));
      self.modal.setContent(infoContainer);
      document.getElementById('CanvOverlay').style.display = 'block';
      self.modal.open();
      self.modal.getModel().once('change:open', function () {
        document.getElementById('CanvOverlay').style.display = 'none';
        eventHub.$emit('eventShowListVideo', false);
      });
    },
    showSlideListModal: function showSlideListModal() {
      eventHub.$emit('setShowAddScreen', true);

      //this.$root.$emit('bv::show::modal', 'segment-list-modal');
    },
    reorder: function reorder(event) {
      this.reorderSlides(event);
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    var self = this;
    if (this.paramsClient.show_video_intro === '0') this.show_video_intro = false;else this.show_video_intro = this.permission.show_intro_video_action;
    this.show_transition = this.permission.show_transition;
    this.$nextTick(function () {
      var index = 0;
      var interval = setInterval(function () {
        index++;
        _this2.setActiveScrollButtons();
        if (index === 10) {
          clearInterval(interval);
        }
      }, 500);
    });

    if (this.$route.params.type === 'NewSegment') {
      eventHub.$emit('setShowAddScreen', true);
    } else {
      if (this.isEditSegement) {
        localStorage.removeItem('gjs-components');
        localStorage.removeItem('gjs-html');
        self.selectSlide(self.all[0]);

        //this.$root.$emit('updateCanvasContent');
      }
    }
  }
});

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_directives_HasPermission_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelCardActions__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelCardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PanelCardActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_Mixin_js__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PanelCard',
  components: {
    PanelCardActions: __WEBPACK_IMPORTED_MODULE_3__PanelCardActions___default.a
  },
  props: {
    segment: Object,
    slide: Object,
    index: Number,
    isSelected: Boolean,
    removable: Boolean,
    showVideoIntro: Object,
    isModuleList: {
      type: Boolean,
      default: false
    },
    isScreenList: {
      type: Boolean,
      default: false
    },
    isSegmentCard: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    HasPermission: __WEBPACK_IMPORTED_MODULE_2__core_directives_HasPermission_js__["a" /* default */]
  },
  data: function data() {
    return {
      isToggled: false,
      title: this.slide.title
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_Mixin_js__["a" /* default */]],
  created: function created() {},
  mounted: function mounted() {},

  watch: {
    slide: {
      handler: function handler(val) {
        this.title = val.title;
      },

      deep: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    hasVideoIntro: 'slides/getHasVideoIntro',
    currentSlide: 'slides/getCurrent',
    permission: 'getPermissions',
    selectedSlides: 'slides/getSelected',
    isExtended: 'segments/isExtended',
    paramsClient: 'getParamsClients'

  }), {
    duration: function duration() {
      return this.isSegmentCard ? this.slide.duration : this.slide.options.duration;
    },
    isMultipleLayers: function isMultipleLayers() {
      return this.isSegmentCard && !this.isModuleList && this.slide.screens.filter(function (s) {
        return s.type !== 'startGeneric';
      }).length > 1;
    },
    backgroundImage: function backgroundImage() {
      if (!this.isModuleList) {
        if (this.isSegmentCard) {
          var firstScreen = this.slide.screens.find(function (s) {
            return !s.type.toLowerCase().includes('generic');
          });
          if (firstScreen && firstScreen.screenShot) {
            return 'url(' + firstScreen.screenShot + ')';
          }
        }
        return 'url(' + (this.slide.screenShot || this.defaultScreenshot) + ')';
      }
    },
    backgroundImageMedia: function backgroundImageMedia() {
      if (this.isModuleList) {
        if (this.isSegmentCard) {
          var firstScreen = this.slide.screens.find(function (s) {
            return !s.type.toLowerCase().includes('generic');
          });
          if (firstScreen && firstScreen.screenShot) {
            return {
              'background-image': 'url(' + firstScreen.screenShot + ')'
            };
          }
        }
        return {
          'background-image': 'url(' + this.slide.screenShot || this.defaultScreenshot + ')'
        };
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('slides', ['updateSlideTitle']), {
    checkTarget: function checkTarget(event) {
      if (!(event.target.classList.contains('more-actions-btn') || event.target.parentNode.classList.contains('more-actions-btn-parent'))) {
        this.$refs.cardEl.click();
      }
    },
    toggleSegment: function toggleSegment() {
      this.isToggled = !this.isToggled;
      this.$emit('toggled');
    },
    update: function update() {
      this.updateSlideTitle({ title: this.title, uid: this.slide.uid });
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
      this.toggleEditMode();
    },
    showSettingPanel: function showSettingPanel() {
      this.$emit('selected');
      setTimeout(function () {
        var barsEl = document.querySelector('#gjs .gjs-pn-buttons .fa-bars');
        var brushEl = document.querySelector('#gjs .gjs-pn-buttons .fa-paint-brush');
        var decorationTitleEl = document.querySelector('#gjs-sm-decoration:not(.gjs-sm-open) .gjs-sm-title');
        var durationTitleEl = document.querySelector('#gjs .gjs-sm-sector .gjs-sm-title');

        barsEl.click();
        var bodyTitleEl = document.querySelector('#gjs .gjs-layer-title');
        bodyTitleEl.click();

        brushEl.click();
        if (decorationTitleEl) {
          decorationTitleEl.click();
          durationTitleEl.click();
        }
      }, 500);
    }
  })
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_en_US__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_fr_FR__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_directives_HasPermission_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_duration_handler__ = __webpack_require__(40);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PanelCardActions',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__["a" /* default */]],
  directives: {
    HasPermission: __WEBPACK_IMPORTED_MODULE_5__core_directives_HasPermission_js__["a" /* default */]
  },
  data: function data() {
    return {
      isEditMode: false,
      editMode: '',
      oldTitle: '',
      oldDuration: '',
      durationValue: 0,
      showError: false
    };
  },

  props: {
    isSegmentCard: {
      type: Boolean,
      default: false
    },
    card: {
      type: Object,
      required: true
    },
    segment: {
      type: Object,
      default: function _default() {
        return { screens: [] };
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    currentSlide: 'slides/getCurrent',
    slideIndex: 'slides/getSlideIndex',
    allSlides: 'slides/getSelected',
    getmaxLength: 'common/getmaxLength',

    currentSegment: 'segments/getCurrent',
    segmentIndex: 'segments/getSegmentIndex',
    allSegments: 'segments/getSelectedSegments',
    permissions: 'getPermissions',
    hasFullscreenVideo: 'segments/hasFullscreenVideo',
    getByUid: 'segments/getByUid',

    paramsClient: 'getParamsClients',
    permission: 'getPermissions'
  }), {
    showBtnDuration: function showBtnDuration() {
      if ((this.$route.name === 'add' || this.$route.name === 'edit') && this.paramsClient.default_segment_duration !== null && !this.isSegmentCard) {
        return false;
      } else return true;
    },
    isSegmentMode: function isSegmentMode() {
      return this.$route.name === 'segment';
    },
    isRemovable: function isRemovable() {
      if (this.isSegmentMode) {
        return this.allSlides.length > 1;
      }
      if (this.isSegmentCard) {
        return this.allSegments.length > 1;
      }
      return this.segment.screens.filter(function (s) {
        return s.type !== 'startGeneric';
      }).length > 1;
    },

    title: {
      get: function get() {
        return this.card.title;
      },
      set: function set(value) {
        if (!this.isSegmentMode) {
          this.updateSegmentTitle({ title: value, uid: this.card.uid });
        } else {
          this.updateSlideTitle({ title: value, uid: this.card.uid });
        }
      }
    },
    duration: {
      get: function get() {
        return this.isSegmentCard ? this.card.duration : this.card.options.duration;
      },
      set: function set(value) {
        this.durationValue = value;
        if (!this.isSegmentMode) {
          this.updateSegmentDuration({ duration: value, uid: this.card.uid });
        } else {
          this.updateSlideDuration({ duration: value, uid: this.card.uid });
        }
      }
    },
    durationInput: {
      get: function get() {
        var value = this.duration;
        var hours = Math.floor(value / 3600);
        value %= 3600;
        var minutes = Math.floor(value / 60);
        var seconds = value % 60;
        var addZero = function addZero(v) {
          return v < 10 ? '0' + v : v;
        };
        var t = [];

        t.push(addZero(hours));
        t.push(addZero(minutes));
        t.push(addZero(seconds));

        return t.join(':');
      },
      set: function set(value) {
        this.showError = false;
        this.duration = value.split(':').reverse().reduce(function (prev, curr, i) {
          return prev + curr * Math.pow(60, i);
        }, 0);
      }
    },
    hasError: function hasError() {
      return this.showError && (!this.hasFullscreenVideo(this.card.uid) || this.isSegmentCard);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('slides', ['updateTitle', 'updateSlideTitle', 'updateSlideDuration', 'removeSlideByUid', 'setCurrentSlide']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('segments', ['updateSegmentTitle', 'updateSegmentDuration', 'removeSegmentByUid', 'setCurrentSegment', 'removeSlideFromSegmentByUid', 'updateTitleScreenInSegment', 'updateTitleSegment', 'setCurrentSegmentTitle']), {
    showEditTitlePanel: function showEditTitlePanel() {
      this.toggleEditMode();
      this.editMode = 'title';
      this.oldTitle = this.title;
    },
    showEditDurationPanel: function showEditDurationPanel() {
      this.toggleEditMode();
      this.editMode = 'duration';
      this.oldDuration = this.duration;
      this.durationValue = this.duration;
      this.showError = false;
    },
    toggleEditMode: function toggleEditMode() {
      var cancel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.isEditMode = !this.isEditMode;
      if (cancel) {
        if (this.editMode === 'title') {
          this.title = this.oldTitle;
        } else {
          this.duration = this.oldDuration;
        }
      }
    },
    closePopover: function closePopover() {
      this.toggleEditMode(true);
      this.$refs.closeBtn.click();
    },
    handleUpdate: function handleUpdate() {
      if (this.editMode === 'title') {
        if (!this.isSegmentMode) {
          if (this.isSegmentCard) {
            this.updateSegment();
          } else {
            this.updateTitleScreen();
          }
        } else {
          this.updateTitleSlide();
        }
      } else {
        if (this.$route.name === 'add' || this.$route.name === 'edit') {
          if (__WEBPACK_IMPORTED_MODULE_6__helpers_duration_handler__["e" /* isMultipleBy30 */]() && Math.abs(this.durationValue - this.oldDuration) % 30 > 0) {
            this.showError = true;
            if (!this.isSegmentCard && this.hasFullscreenVideo(this.card.uid)) {
              this.$root.$emit('eventExtendSegmentDuration', {
                uid: this.getByUid(this.card.uid).uid
              });
            }
            return;
          }
          if (!this.isSegmentMode) {
            this.updateSegmentDuration({
              duration: this.durationValue,
              uid: this.card.uid,
              confirmed: true
            });
            this.showError = false;
          } else {
            this.updateSlideDuration({
              duration: this.durationValue,
              uid: this.card.uid,
              confirmed: true
            });
          }
        } else if (this.$route.name === 'segment') {
          if (!this.isSegmentMode) {
            this.updateSegmentDuration({
              duration: this.durationValue,
              uid: this.card.uid,
              confirmed: true
            });
            this.showError = false;
          } else {
            this.updateSlideDuration({
              duration: this.durationValue,
              uid: this.card.uid,
              confirmed: true
            });
          }
        }

        this.oldDuration = this.durationValue;
        this.closePopover();
      }

      this.toggleEditMode();
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
    },
    updateTitleScreen: function updateTitleScreen() {
      this.updateSegmentTitle(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.card, { title: this.title }));
    },
    updateSegment: function updateSegment() {
      this.updateSegmentTitle(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.card, { title: this.title }));
    },
    updateTitleSlide: function updateTitleSlide() {
      if (parseInt(this.permissions.nb_screen_segment) === 1) {
        this.setCurrentSegmentTitle(this.title);
      } else {
        this.updateSlideTitle(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.card, { title: this.title }));
      }
    },
    handleDelete: function handleDelete(event) {
      var _this = this;

      var editor = grapesjsEMP.editors[0];
      this.$swal.fire({
        title: this.$t('modal.delete.title'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#f44336',
        cancelButtonColor: '#2196F3',
        confirmButtonText: this.$t('modal.delete.btn_confirm'),
        cancelButtonText: this.$t('modal.delete.btn_cancel'),
        customClass: 'swal-delete'
      }).then(function (result) {
        if (result.value) {
          _this.$swal.fire({
            title: 'Supprimé!',
            type: 'success',
            showConfirmButton: false,
            timer: 2000
          });
          if (_this.isSegmentMode) {
            _this.deleteSlide();
          } else if (_this.isSegmentCard) {
            _this.deleteSegment();
          } else {
            _this.deleteSlideFromSegment();
          }
          _this.$root.$emit('updateCanvasContent');
          _this.setNoAutoplayVideo(editor);
          var iconSave = document.querySelector('.icon-save');
          if (iconSave) {
            iconSave.classList.add('icon-selected');
          }
          _this.$root.$emit('updateScrollInterval', { event: event, position: -1 });
        }
      });
    },
    deleteSlide: function deleteSlide() {
      var index = this.slideIndex(this.card);

      this.removeSlideByUid(this.card.uid);
      this.setCurrentSlide(this.allSlides[Math.max(index - 1, 0)]);
    },
    deleteSegment: function deleteSegment() {
      var index = this.segmentIndex(this.card);
      this.removeSegmentByUid(this.card.uid);
      this.setCurrentSegment(this.allSegments[Math.max(index - 1, 0)]);
      this.setCurrentSlide(this.allSegments[Math.max(index - 1, 0)].screens.filter(function (s) {
        return s.type !== 'startGeneric';
      })[0]);
    },
    deleteSlideFromSegment: function deleteSlideFromSegment() {
      var index = this.segmentIndex(this.segment);
      this.removeSlideFromSegmentByUid({ index: index, uid: this.card.uid });
      this.setCurrentSlide(this.segment.screens.filter(function (s) {
        return s.type !== 'startGeneric';
      })[0]);
    },
    showSettingPanel: function showSettingPanel() {
      var editor = grapesjsEMP.editors[0];
      var wrapper = editor.DomComponents.getWrapper();
      editor.select(wrapper);

      var brushEl = document.querySelector('#gjs .gjs-pn-buttons .fa-paint-brush:not(.gjs-pn-active )');
      var decorationTitleEl = document.querySelector('#gjs-sm-decoration:not(.gjs-sm-open) .gjs-sm-title');
      var durationTitleEl = document.querySelector('#gjs .gjs-sm-sector .gjs-sm-title');

      if (brushEl) {
        brushEl.click();
      }
      if (decorationTitleEl) {
        decorationTitleEl.click();
        durationTitleEl.click();
      }
    }
  }),
  i18n: {
    messages: {
      en: __WEBPACK_IMPORTED_MODULE_3__i18n_en_US__["a" /* default */],
      fr: __WEBPACK_IMPORTED_MODULE_4__i18n_fr_FR__["a" /* default */]
    }
  }
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_perfect_scrollbar__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_en_US__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_fr_FR__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_Mixin_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_GrapesMixinEditors__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_GrapesMixinHelpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_GrapesMixinTranslate__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_GrapesMixinPanels__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PanelCard__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PanelCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__PanelCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__core_directives_HasPermission_js__ = __webpack_require__(30);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_Mixin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_GrapesMixinEditors__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_GrapesMixinHelpers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_GrapesMixinPanels__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_GrapesMixinTranslate__["a" /* default */]],
  directives: {
    HasPermission: __WEBPACK_IMPORTED_MODULE_14__core_directives_HasPermission_js__["a" /* default */]
  },

  data: function data() {
    return {
      show_transition: true,
      segmentKey: 0,
      logoDebut: '',
      logoFin: '',
      list: [],
      lists: [],
      show_video_intro: true,
      show_generic_display: 0,
      oldValue: '',
      opened: true,
      withGeneric: true,
      currentId: null,
      title: '',
      idSelected: 0,
      typeAnimation: '',
      animation: '',
      scrollInterval: null,
      showScroll: false,
      isExtendedSlides: false
    };
  },

  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_4_vuedraggable___default.a,
    PanelCard: __WEBPACK_IMPORTED_MODULE_13__PanelCard___default.a,
    VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_5_vue_perfect_scrollbar___default.a
  },
  i18n: {
    messages: {
      en: __WEBPACK_IMPORTED_MODULE_6__i18n_en_US__["a" /* default */],
      fr: __WEBPACK_IMPORTED_MODULE_7__i18n_fr_FR__["a" /* default */]
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    all: 'segments/getSelectedSegments',
    currentSlide: 'slides/getCurrent',
    currentSegment: 'segments/getCurrent',
    modal: 'grapes/getModal',
    paramsClient: 'getParamsClients',
    startGeneric: 'segments/getStartGeneric',
    finishGeneric: 'segments/getFinishGeneric',
    hasPermission: 'hasPermission'
  }), {
    hasScrollSlides: function hasScrollSlides() {
      if (this.all.length > 0) {
        var count = this.all.length;
        var panelWidth = 0;
        var widthSlides = 0;
        var cardWrapper = document.querySelector('.slide');
        if (cardWrapper) {
          widthSlides = count * cardWrapper.clientWidth * 1.4;
          if (this.isExtendedSlides) {
            var extendedPanel = document.querySelector('.inner-slides-wrapper.extended');
            widthSlides += extendedPanel.offsetWidth;
          }
        }
        var panel = document.querySelector('.slides-panel');
        if (panel) {
          panelWidth = panel.offsetWidth;
        }
        if (widthSlides >= panelWidth) {
          this.showScroll = true;
        } else {
          this.showScroll = false;
        }
        this.$root.$emit('showScroll', this.showScroll);
        return this.showScroll;
      }
    }
  }),
  watch: {
    all: {
      handler: function handler(all) {
        var _this = this;

        all.forEach(function (el, index) {
          _this.lists[index] = _this.getScreens(el);
        });
      },

      deep: true
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('slides', ['setCurrentSlide']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('segments', ['setCurrentSegment', 'setIndexSegmentToAdd', 'setLengthSegmentToAdd', 'setIndexSlideToAdd', 'duplicateSegment', 'duplicateSlideInsideSegment', 'updateSlideInsideSegment', 'toggleExtendSegment', 'reorderSegments', 'reorderSlidesInsideSegment']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('common', ['setGenericThem', 'setOptionsThemeSelect']), {
    setActiveScrollButtons: function setActiveScrollButtons() {
      if (this.all.length > 0) {
        var count = this.all.length;
        var panelWidth = 0;
        var widthSlides = 0;
        var cardWrapper = document.querySelector('.slide');
        if (cardWrapper) {
          widthSlides = count * cardWrapper.clientWidth * 1.4;
          if (this.isExtendedSlides) {
            var extendedPanel = document.querySelector('.inner-slides-wrapper.extended');
            widthSlides += extendedPanel.offsetWidth;
          }
        }
        var panel = document.querySelector('.slides-panel');
        if (panel) {
          panelWidth = panel.offsetWidth;
        }
        if (widthSlides >= panelWidth) {
          this.showScroll = true;
        } else {
          this.showScroll = false;
        }
        this.$root.$emit('showScroll', this.showScroll);
        return this.showScroll;
      }
    },
    isActiveScrollSlide: function isActiveScrollSlide(extended) {
      var _this2 = this;

      this.$nextTick(function () {
        var index = 0;
        var interval = setInterval(function () {
          index++;
          _this2.isExtendedSlides = extended;
          _this2.setActiveScrollButtons();
          if (extended || !extended) {
            clearInterval(interval);
          }
          if (index === 10) {
            clearInterval(interval);
          }
        }, 500);
      });
    },
    getScreens: function getScreens(segment) {
      return segment.screens.filter(function (s) {
        return s.type.toLowerCase().indexOf('generic') + s.type.toLowerCase().indexOf('blank') === -2;
      });
    },
    hasStartGeneric: function hasStartGeneric(segment) {
      return segment.screens.some(function (s) {
        return s.type === 'startGeneric';
      });
    },
    hasTransition: function hasTransition(segment) {
      return segment.screens[0].transition.in && segment.screens[0].transition.in !== 'no-transition-in';
    },
    hasTransitionSlide: function hasTransitionSlide(slide) {
      return slide.transition.in && slide.transition.in.length > 0;
    },
    selectSlide: function selectSlide(segment, slide) {
      var _this3 = this;

      if (slide.uid === this.currentSlide.uid) {
        return;
      }
      var editor = grapesjsEMP.editors[0];
      var wrapper = editor.DomComponents.getWrapper();
      editor.select(wrapper);
      setTimeout(function () {
        var lastSlide = {
          uid: _this3.currentSlide.uid,
          components: localStorage.getItem('gjs-components'),
          js: localStorage.getItem('gjs-js'),
          html: localStorage.getItem('gjs-html'),
          css: _this3.sanitizeCSS(localStorage.getItem('gjs-css')),
          styles: localStorage.getItem('gjs-styles')
        };
        _this3.updateSlideInsideSegment(lastSlide);
        _this3.generateSlideThmbnail(_this3.currentSlide.uid);
        setTimeout(function () {
          //Set Current Screen
          _this3.setCurrentSlide(slide);
          //Set Current Segment by Screen
          _this3.setCurrentSegment(segment);
          _this3.removeToolbarCkeditor();
          _this3.$root.$emit('updateCanvasContent');
          _this3.setNoAutoplayVideo(editor);
          var videoPlayers = ['player', 'playlist'];
          videoPlayers.forEach(function (player) {
            _this3.setPausedVideo(player);
          });
          if (_this3.paramsClient.display_default_blocks && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this3.paramsClient.display_default_blocks).length > 0 && _this3.paramsClient.modules.show_list_block_action) {
            var blocks = document.querySelector('#gjs .gjs-pn-buttons .fa-th-large:not(.gjs-pn-active)');
            if (blocks) {
              blocks.click();
            }
          }
        }, 100);
      }, 100);
    },
    selectSegment: function selectSegment(slide) {
      var _this4 = this;

      if (slide.uid === this.currentSegment.uid) {
        return;
      }

      var editor = grapesjsEMP.editors[0];
      var wrapper = editor.DomComponents.getWrapper();
      editor.select(wrapper);
      setTimeout(function () {
        var lastSlide = {
          uid: _this4.currentSlide.uid,
          components: localStorage.getItem('gjs-components'),
          js: localStorage.getItem('gjs-js'),
          html: localStorage.getItem('gjs-html'),
          css: _this4.sanitizeCSS(localStorage.getItem('gjs-css')),
          styles: localStorage.getItem('gjs-styles')
        };
        _this4.updateSlideInsideSegment(lastSlide);
        _this4.generateSlideThmbnail(_this4.currentSlide.uid);
        setTimeout(function () {
          _this4.setCurrentSlide(slide.screens.filter(function (s) {
            return s.type !== 'startGeneric';
          })[0]);
          _this4.setCurrentSegment(slide);
          _this4.removeToolbarCkeditor();
          _this4.$root.$emit('updateCanvasContent');
          _this4.setNoAutoplayVideo(editor);
          var videoPlayers = ['player', 'playlist'];
          videoPlayers.forEach(function (player) {
            _this4.setPausedVideo(player);
          });
          if (_this4.paramsClient.display_default_blocks && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this4.paramsClient.display_default_blocks).length > 0 && _this4.paramsClient.modules.show_list_block_action) {
            var blocks = document.querySelector('#gjs .gjs-pn-buttons .fa-th-large:not(.gjs-pn-active)');
            if (blocks) {
              blocks.click();
            }
          }
        }, 100);
      }, 100);
    },
    handleDuplicateSegment: function handleDuplicateSegment(segment, index) {
      if (this.startGeneric) {
        index++;
      }

      var clone = this.getSegmentCloneThis(segment);
      segment = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, segment, clone);
      this.duplicateSegment({ segment: segment, index: index });

      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
    },
    handleDuplicateSlideInsideSegment: function handleDuplicateSlideInsideSegment(segment, slide, segmentIndex, slideIndex) {
      if (this.startGeneric) {
        segmentIndex++;
      }
      if (this.hasStartGeneric(segment)) {
        slideIndex++;
      }
      if (this.currentSlide.uid === slide.uid) {
        var clone = this.getClone();
        slide = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.currentSlide, clone);
      }
      this.duplicateSlideInsideSegment({ slide: slide, segmentIndex: segmentIndex, slideIndex: slideIndex });

      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
    },
    toggleSegmentCards: function toggleSegmentCards(slide, index) {
      this.toggleExtendSegment(slide);
      this.isActiveScrollSlide(slide.isExtended);
      this.segmentKey++;
    },
    calculateWidth: function calculateWidth(segment) {
      var count = this.getScreens(segment).length;
      return {
        width: (segment.isExtended ? count * 198 + 25 : 0) + 'px' //168+25:0
      };
    },
    addTransition: function addTransition(segment) {
      this.$emit('transitionSelected', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, segment.screens[0]));
    },
    addTransitionSlide: function addTransitionSlide(slide) {
      this.$emit('transitionSelected', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, slide));
    },
    videoGenerique: function videoGenerique(generic, index) {
      if (this.paramsClient.display_themes_elements != null) {
        // initialize idTheme in store for each type generic
        if (generic == 'fin' && this.paramsClient.display_themes_elements.conclusion) {
          this.setGenericThem(this.paramsClient.display_themes_elements.conclusion[0].id);
          this.setOptionsThemeSelect(this.paramsClient.display_themes_elements.conclusion);
        }
        if (generic == 'intro' && this.paramsClient.display_themes_elements.intro) {
          this.setGenericThem(this.paramsClient.display_themes_elements.intro[0].id);
          this.setOptionsThemeSelect(this.paramsClient.display_themes_elements.intro);
        }
        if (generic == 'debut' && this.paramsClient.display_themes_elements.generic) {
          this.setGenericThem(this.paramsClient.display_themes_elements.generic[0].id);
          this.setOptionsThemeSelect(this.paramsClient.display_themes_elements.generic);
        }
      } else this.setGenericThem(0);

      var self = this;
      var mdlDialog = document.querySelector('.gjs-mdl-dialog');
      eventHub.$emit('eventShowListVideo', true);
      eventHub.$emit('displayGenericListVideo', generic);
      var infoContainer = document.getElementById('list_videos');
      infoContainer.setAttribute('generic', generic);
      infoContainer.setAttribute('data-index', this.startGeneric ? index + 1 : index);
      infoContainer.style.display = 'block';
      self.translatePluginsTitle(null, 'add_generic_' + generic);
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
    },
    handleInsertSegment: function handleInsertSegment(index) {
      this.setIndexSegmentToAdd(index + 1);
      this.setLengthSegmentToAdd(this.all.length);
      this.showSlideListModal();
      this.removeToolbarCkeditor();
    },
    handleAppendSlide: function handleAppendSlide(index) {
      this.setIndexSlideToAdd(index);
      this.$root.$emit('bv::show::modal', 'segment-list-modal');
    },
    showSlideListModal: function showSlideListModal() {
      if (document.getElementById('module-list')) {
        document.getElementById('module-list').style.display = 'block';
      }
      this.$root.$emit('bv::show::modal', 'slide-list-modal');
      eventHub.$emit('hideModalTitleSegment', true);
    },
    reorder: function reorder(event) {
      this.reorderSegments(event);
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    },
    reorderSlides: function reorderSlides(event, index) {
      this.reorderSlidesInsideSegment({ event: event, index: index });
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    }
  }),
  created: function created() {
    var _this5 = this;

    this.show_generic_display = localStorage.getItem('video_generique');
    this.$root.$on('show-list-video', function (val) {
      _this5.videoGenerique(val);
    });
  },
  mounted: function mounted() {
    var _this6 = this;

    if (this.paramsClient.show_video_intro === '0') this.show_video_intro = false;else this.show_video_intro = this.permission.show_intro_video_action;
    this.show_transition = this.permission.show_transition;
    this.isActiveScrollSlide();
    this.$root.$on('updateScrollInterval', function (obj) {
      _this6.dragSlide(obj.event, obj.position);
    });
  }
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n_en_US__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_fr_FR__ = __webpack_require__(12);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isEditMode: false,
      title: '',
      oldTitle: '',
      titleSegment: '',
      oldTitleSegment: ''
    };
  },

  i18n: {
    messages: {
      en: __WEBPACK_IMPORTED_MODULE_2__i18n_en_US__["a" /* default */],
      fr: __WEBPACK_IMPORTED_MODULE_3__i18n_fr_FR__["a" /* default */]
    }
  },
  watch: {
    template: {
      handler: function handler(val) {
        if (val) {
          this.title = val.title;
        }
      },

      deep: true
    },
    segment: {
      handler: function handler(val) {
        if (val) {
          this.titleSegment = val.title;
        }
      },

      deep: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    template: 'slides/getTemplate',
    paramsClient: 'getParamsClients',
    permissions: 'getPermissions',
    segment: 'segments/getCurrent',
    RouteFromBiblio: 'segments/getFromRouteBiblio'
  }), {
    isSegment: function isSegment() {
      if (this.$route.name === 'segment') return true;else return false;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('slides', ['updatePogramTitle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('segments', ['setCurrentSegmentTitle']), {
    toggleEditModeTemplate: function toggleEditModeTemplate() {
      var cancel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (cancel) {
        this.title = this.oldTitle;
      } else {
        this.oldTitle = this.title;
      }
      this.isEditMode = !this.isEditMode;
    },
    toggleEditModeSegment: function toggleEditModeSegment() {
      var cancel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (cancel) {
        this.titleSegment = this.oldTitleSegment;
      } else {
        this.oldTitleSegment = this.titleSegment;
      }
      this.isEditMode = !this.isEditMode;
    },
    updateTemplate: function updateTemplate() {
      this.updatePogramTitle(this.title);
      eventHub.$emit('updateTitleSegment', this.title);
      this.toggleEditModeTemplate();
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
    },
    updateSegment: function updateSegment() {
      this.setCurrentSegmentTitle(this.titleSegment);
      this.toggleEditModeSegment();
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.classList.add('icon-selected');
      }
    },
    backToBiblioSegment: function backToBiblioSegment() {
      this.$root.$emit('bv::show::modal', 'modal-exit-save', '#backToBiblio');
      /*
      if (this.segment.id)
        this.$router.push({ name: 'EditSegment', params: { id: this.segment.id } });
      else this.$router.push({ name: 'AddSegment' });
      */
    }
  })
});

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal_TransitionModal__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal_TransitionModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Modal_TransitionModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CustomSegmentPanelPages_vue__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CustomSegmentPanelPages_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CustomSegmentPanelPages_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CustomPanelPages__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CustomPanelPages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CustomPanelPages__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { CustomPanelPages: __WEBPACK_IMPORTED_MODULE_3__CustomPanelPages___default.a, CustomSegmentPanelPages: __WEBPACK_IMPORTED_MODULE_1__CustomSegmentPanelPages_vue___default.a, TransitionModal: __WEBPACK_IMPORTED_MODULE_0__Modal_TransitionModal___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__["a" /* default */]],
  props: { isEditSegement: null },
  data: function data() {
    return {
      opened: true,
      showModal: false,
      selectedSlideTransition: {}
    };
  },


  methods: {
    showPanel: function showPanel() {
      var _this = this;

      this.opened = !this.opened;
      var imgArrow = document.querySelector('.imgClickAndChange');
      var panelScreen = document.getElementById('panel__left');
      var canvas = document.querySelector('.canvas-div');
      var infos = document.getElementById('list-informations');
      var infos_fieldset = document.querySelector('#list-informations > fieldset');
      var infos_new = document.getElementById('list-informations-new');
      var blocks = document.querySelector('.gjs-pn-panel.gjs-pn-views-container.gjs-one-bg.gjs-two-color');
      if (imgArrow && imgArrow.classList.contains('rotate')) {
        document.querySelector('#list-informations-new').classList.remove('rotate');
        document.querySelector('#list-informations').classList.remove('rotate');
        imgArrow.classList.remove('rotate');
        panelScreen.classList.remove('hidden-panel');
        canvas.classList.remove('full-panel');
        infos.classList.remove('hide-infos');
        if (infos_fieldset) infos_fieldset.classList.remove('hide-infos-fieldset');
        blocks.classList.remove('full-panel-blocks');
        blocks.classList.add('display-panel-blocks');
        infos_new.classList.remove('display-infos-new');
      } else {
        document.querySelector('#list-informations-new').classList.add('rotate');
        document.querySelector('#list-informations').classList.add('rotate');
        imgArrow.classList.add('rotate');
        panelScreen.classList.add('hidden-panel');
        canvas.classList.add('full-panel');
        infos.classList.add('hide-infos');
        if (infos_fieldset) infos_fieldset.classList.add('hide-infos-fieldset');
        blocks.classList.add('full-panel-blocks');
        blocks.classList.remove('display-panel-blocks');
        infos_new.classList.add('display-infos-new');
      }
      setTimeout(function () {
        _this.updateCanvasDimensions();
      }, 150);
    },
    showPanelContainer: function showPanelContainer() {
      var panelElement = document.querySelector('.gjs-pn-panel.gjs-pn-views-container.gjs-one-bg.gjs-two-color');
      var canvasElement = document.querySelector('.gjs-cv-canvas');
      var panelSlidesElement = document.querySelector('div#panel__left.show_panel');
      var panelButtons = document.querySelector('.gjs-pn-panels .panel-buttons');
      var toggleButtons = document.getElementById('btn-toggle');
      panelElement.classList.add('show-blocks-panels');
      panelElement.classList.remove('hide-blocks-panels');
      panelSlidesElement.classList.remove('hide_panel');
      canvasElement.classList.add('show-canvas');
      panelButtons.classList.add('show-panel-buttons');
      toggleButtons.classList.remove('rotate-buttons');
      toggleButtons.classList.add('resize-panel-buttons');
    },
    addTransition: function addTransition(segment) {
      this.selectedSlideTransition = segment;
      this.showModal = true;
    }
  },
  created: function created() {
    var _this2 = this;

    this.$root.$on('show-panels-container', function () {
      _this2.showPanelContainer();
    });
    this.$root.$on('showPanel', function () {
      _this2.showPanel();
    });
    eventHub.$on('eventaAddTransition', function (val) {
      _this2.addTransition(val);
    });
  }
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n_en_US__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n_fr_FR__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'panelFitScreen',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Mixin_js__["a" /* default */]],
  data: function data() {
    return {
      showinfo: false,
      value: '100%',
      defaultScaling: 100
    };
  },

  i18n: {
    messages: {
      en: __WEBPACK_IMPORTED_MODULE_0__i18n_en_US__["a" /* default */],
      fr: __WEBPACK_IMPORTED_MODULE_1__i18n_fr_FR__["a" /* default */]
    }
  },
  mounted: function mounted() {
    var self = this;
    eventHub.$on('updateDefaultValue', self.updateDefaultValue);
    eventHub.$on('scaleDefaultValue', self.scaleDefaultValue);
  },

  methods: {
    updateDefaultValue: function updateDefaultValue(value) {
      var _this = this;

      if (value) {
        setTimeout(function () {
          _this.value = value.percent + "%";
          _this.defaultScaling = value.percent;
          var height = document.querySelector('.canvas-div').offsetHeight / document.querySelector('.canvas-div .gjs-frame').offsetHeight * 100;
          var width = document.querySelector('.canvas-div').offsetWidth / document.querySelector('.canvas-div .gjs-frame').offsetWidth * 100;
          var tx = Math.min(height, width).toFixed(1) > 99 ? 0 : document.querySelector('.canvas-div').offsetWidth - document.querySelector('.canvas-div .gjs-cv-canvas').offsetWidth * value.percent / 100;
          _this.scaleValue('.customScale', value.percent / 100, value.ty / 2, tx > 0 ? -tx / 2 + 20 : 0);
          _this.scale('Minus');
        }, 100);
      }
    },
    scaleDefaultValue: function scaleDefaultValue() {

      this.scaleValue('.customScale', this.defaultScaling, 0, 0, 1);
    },
    scale: function scale(type) {
      var Styletransform = document.querySelector('.customScale');
      var style = getComputedStyle(Styletransform);
      var valuetransform = parseFloat(style.transform.replace(/\(|\)|matrix/g, '').split(',')[0]);
      var ty = parseFloat(style.transform.replace(/\(|\)|matrix/g, '').split(',')[5]);
      var tx = parseFloat(style.transform.replace(/\(|\)|matrix/g, '').split(',')[4]);

      if (type === "Minus" && valuetransform > 0.1) {
        valuetransform = valuetransform - 0.1;
        this.defaultScaling = valuetransform;
        this.scaleValue('.customScale', valuetransform, ty, tx, 1);
      }
      if (type === "Plus" && valuetransform < 1) {
        valuetransform = valuetransform + 0.1;
        this.defaultScaling = valuetransform;
        this.scaleValue('.customScale', valuetransform, ty, tx, -1);
      }

      this.value = (valuetransform * 100).toFixed(0) + '%';
    }
  }
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reveal_js_js_reveal__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reveal_js_js_reveal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reveal_js_js_reveal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_Mixin_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_PostCssVw__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gsap__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_flatElements__ = __webpack_require__(443);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'preview',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_Mixin_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_PostCssVw__["a" /* default */]],
  data: function data() {
    return {
      fileDecorated: false,
      isVisible: false,
      isChanged: false,
      PreviewScreens: [],
      dataStored: [],
      overviewShown: false,
      scriptEl: '',
      videoObject: {},
      slideId: 0,
      typePreview: '',
      getSelectedDevice: '',
      timeout: 0,
      scale: {}
    };
  },

  watch: {
    isVisible: function isVisible(val) {
      var _this = this;

      //Reveal.sync();
      //Reveal.loadSlide();
      if (val) {
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_3_reveal_js_js_reveal___default.a.initialize({
            autoSlide: 20000,
            loop: true,
            width: '100%',
            height: '100%',
            margin: 0,
            minScale: 1,
            maxScale: 1
          });
          __WEBPACK_IMPORTED_MODULE_3_reveal_js_js_reveal___default.a.slide(0);
          __WEBPACK_IMPORTED_MODULE_3_reveal_js_js_reveal___default.a.configure({
            keyboard: {
              70: null // don't do anything when SPACE is pressed (i.e. disable a reveal.js default binding)
            }
          });
          var self = _this;
          self.mountOneSlide();
          __WEBPACK_IMPORTED_MODULE_3_reveal_js_js_reveal___default.a.addEventListener('ready', function (event) {
            var tickers = __WEBPACK_IMPORTED_MODULE_3_reveal_js_js_reveal___default.a.getSlides()[0].querySelectorAll('#newsTicker');

            var index = 0;
            var interval = setInterval(function () {
              index++;
              tickers.forEach(function (t) {
                var playBtn = t.querySelector('.bn-play');
                if (playBtn) {
                  playBtn.click();
                  clearInterval(interval);
                }
                if (index === 100) {
                  clearInterval(interval);
                }
              });
            }, 100);
            self.setRevealUrlsCkeditors(event);
          });
        }, 500);
        this.reloadSlides();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    canvasSize: 'common/getCanvasSize',

    ListSvgObject: 'common/getListSvgObject',
    route: 'getRoute',
    tmpId: 'getTmpId',
    dispositions: 'dispositions/getSelectedDispositions',
    selected: 'slides/getSelected',
    current: 'slides/getCurrent',
    selectedSlides: 'slides/getAllSelected',
    selectedSegments: 'segments/getAllSelectedSlides',
    deviceType: 'common/getDeviceType',
    VideoGeneriqueDebut: 'getVideoGeneriqueDebut',
    VideoGeneriqueFin: 'getVideoGeneriqueFin',
    getCurrent: 'slides/getCurrent',
    getCurrentSlideIndex: 'slides/getCurrentSlideIndex',
    getByIndex: 'slides/getByIndex',
    paramsClient: 'getParamsClients',
    getConfigurationSvg: 'common/getConfigurationSvg'
  }), {
    selected: function selected() {
      return this.$route.name === 'segment' ? this.selectedSlides : this.selectedSegments;
    },
    slides: function slides() {
      var _this2 = this;

      var css = '';
      return this.selected.map(function (slide) {
        css = _this2.postcss(slide.css, _this2.deviceType);
        // To handle slides with duration = 0s
        var duration = slide.options.duration ? slide.options.duration * 1000 : 1;
        //----------------------------------------------
        //convert img to svg
        var newHtml = _this2.convertImgToSVG(_this2.cmdInlineHtml(slide.html, css));
        //convert style ck-editor px to vm

        var html = _this2.convertCKEditorPXToVW(newHtml);

        //this.convertCKEditorPXToem(newHtml);

        //----------------------------------------------
        return {
          transition: slide.transition.in + ' ' + slide.transition.out,
          duration: duration,
          //html: this.cmdInlineHtml(slide.html, css),
          html: html
        };
      });
    },
    devices: function devices() {
      var _this3 = this;

      this.getSelectedDevice = this.paramsClient.display_devices.filter(function (s) {
        return s.name === _this3.deviceType;
      });
      if (this.getSelectedDevice.length === 0) {
        this.getSelectedDevice = this.paramsClient.display_devices;
      }
      return {
        name: this.getSelectedDevice[0].name,
        classes: this.getSelectedDevice[0].className,
        style: {
          width: this.getSelectedDevice[0].fixedSize ? this.getSelectedDevice[0].fixedSize.width + 'px !important' : this.getSelectedDevice[0].width + '!important',
          height: this.getSelectedDevice[0].fixedSize ? this.getSelectedDevice[0].fixedSize.height + 'px !important' : this.getSelectedDevice[0].height + '!important',
          overflow: 'hidden'
        }
      };
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['deleteScreensById']), {
    playAnimationSVG: function playAnimationSVG(id) {
      var all = [];
      var newConf = this.getConfigurationSvg(id);
      var x = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, newConf);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__store_flatElements__["a" /* default */])(x.currentConf.conf, all);
      var data = {
        all: all,
        x: x
      };
      this.$store.commit('animateElement', data);
    },
    newSvg: function newSvg(img, svg) {
      var temp = document.createElement('div');
      temp.classList.add('AnimatSvg');
      temp.id = img.id;
      temp.innerHTML = svg;
      if (img != null) {
        if (img.style.width != null) temp.style.width = img.style.width;
        if (img.style.height != null) temp.style.height = img.style.height;
        if (img.style.top != null) temp.style.top = img.style.top;
        if (img.style.left != null) temp.style.left = img.style.left;
        temp.style.position = 'absolute';
        return temp;
      } else return temp;
    },
    convertImgToSVG: function convertImgToSVG(html) {
      var _this4 = this;

      var stringHtml = html;
      var temporalDivElement = document.createElement('div');
      temporalDivElement.innerHTML = stringHtml;
      if (this.ListSvgObject != null) {
        this.ListSvgObject.forEach(function (o) {
          var oldimg = temporalDivElement.querySelector('#' + o.file.idImg);
          if (oldimg != null) {
            var parentDiv = temporalDivElement.querySelector('.body');
            var newElement = _this4.newSvg(oldimg, o.newTagSvg);
            parentDiv.replaceChild(newElement, oldimg);
          }
        });
      }
      return temporalDivElement.outerHTML;
    },
    convertCKEditorPXToVW: function convertCKEditorPXToVW(htmlCode) {
      var self = this;
      //  Cleaning
      /* htmlCode = htmlCode.replace(/(\n\r|\n|\r)/gm,"\n");
       htmlCode = htmlCode.replace(/(\n \n)/gm,"\n\n");
       htmlCode = htmlCode.replace(/(\n	\n)/gm,"\n\n");
       htmlCode = htmlCode.replace(/(\n\n\n\n\n\n)/gm,"\n\n");
       htmlCode = htmlCode.replace(/(\n\n\n\n\n)/gm,"\n\n");
       htmlCode = htmlCode.replace(/(\n\n\n\n)/gm,"\n\n");
       htmlCode = htmlCode.replace(/(\n\n\n)/gm,"\n\n");*/
      //  exp : &nsmp;
      /* htmlCode = htmlCode.replace(/&[a-z;A-Z;0-9]*;/g, '');
       htmlCode = htmlCode.replace(/&#[a-z;A-Z;0-9]*;/g, '');
       htmlCode = htmlCode.replace(/&\u[a-z;A-Z;0-9]*;/g, '');
       var exp = new RegExp(String.fromCharCode(8203),"g");
       htmlCode = htmlCode.replace(exp,'');*/

      var stringHtml = htmlCode;
      var temporalDivElement = document.createElement('div');
      temporalDivElement.innerHTML = stringHtml;
      var alltext = temporalDivElement.querySelectorAll('.cke_dialog_fontSize');

      alltext.forEach(function (oldtext) {
        if (oldtext != null) {
          var newoldtext = self.fontSizeCKeditorToVw(oldtext.outerHTML);
          var parentDiv = oldtext.parentNode;
          newoldtext = newoldtext.replace(/<br>/g, " <br/>");
          var doc = new DOMParser().parseFromString(newoldtext, 'text/html');
          parentDiv.replaceChild(doc.firstElementChild, oldtext);
        }
      });
      return temporalDivElement.outerHTML;
    },
    fontSizeCKeditorToVw: function fontSizeCKeditorToVw(css) {
      var _this5 = this;

      // width device en px
      var width = this.getSelectedDevice[0].fixedSize ? this.getSelectedDevice[0].fixedSize.width : this.getSelectedDevice[0].width;
      width = parseFloat(width.replace('vw', ''));
      var unitCss = this.canvasSize.width / 100;
      // windowsize
      var windowsize = $(window).width() / 100;
      return css.replace(/font-size:((\d)+\.?(\d)*)vw/g, function (val) {
        var oldValvw = parseFloat(val.replace('font-size:', '').replace('vw', ''));
        var newVal = unitCss * oldValvw;
        var previwWidth = width * windowsize; // en px
        var canvasWidth = _this5.canvasSize.width; // en px
        var size = newVal * previwWidth / canvasWidth / windowsize;
        return 'font-size:' + size + 'vw';
      });
    },
    animationsvgBySlide: function animationsvgBySlide(event) {
      var _this6 = this;

      this.timeout = 0;
      if (event.previousSlide) {}
      if (event.currentSlide) {
        var SvgsInPresentSlide = Array.prototype.slice.call(event.currentSlide.querySelectorAll('.AnimatSvg'));
        if (SvgsInPresentSlide.length > 0) {
          SvgsInPresentSlide.forEach(function (svg) {
            _this6.playAnimationSVG(svg.id);
          });
        }
      }
    },
    mountOneSlide: function mountOneSlide() {
      var _this7 = this;

      var SvgsInPresentSlide = Array.prototype.slice.call(document.querySelectorAll('.slides section')[0].querySelectorAll('.AnimatSvg'));
      if (SvgsInPresentSlide.length > 0) {
        SvgsInPresentSlide.forEach(function (svg) {
          _this7.playAnimationSVG(svg.id);
        });
      }
    },


    /****************************/
    getHtml: function getHtml(html) {
      return this.getSanitizedHtml(html).replace(/autoplay="autoplay"/g, 'data-autoplay="autoplay"').replace(/autoplay="1"/g, 'data-autoplay="autoplay"').replace(/autoplay="true"/g, 'data-autoplay="autoplay"');
    },
    loadScript: function loadScript() {
      var _this8 = this;

      this.scriptEl.text = '';
      var head = document.getElementsByTagName('head').item(0);

      this.selected.forEach(function (item, key) {
        if (item.js && item.js.indexOf('<div') === -1) {
          _this8.scriptEl.text += '\n' + item.js;
        }
      });
      this.scriptEl.onload = function () {
        alert('Script loaded and ready');
      };
      head.appendChild(this.scriptEl);
    },
    showPreview: function showPreview() {
      this.$root.$emit('ShowPreview', false);
      var videoPlayers = ['video', 'player', 'video_mp4', 'playlist'];
      videoPlayers.forEach(function (player) {
        // this.setPausedVideo(player);
      });

      /* Check for full screen mode */
      if ((screen.availHeight || screen.height - 30) <= window.innerHeight) {
        var previewEl = document.getElementById('previewAll');
        var appEl = document.getElementById('app');
        appEl.appendChild(previewEl);
      }
      eventHub.$emit('scaleDefaultValue');
    },
    reloadSlides: function reloadSlides() {
      var self = this;
      self.scriptEl = document.createElement('script');
      this.dataStored = [];

      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_3_reveal_js_js_reveal___default.a.slide(0);
        self.loadScript();
        // self.setAutoPlayVideo(self.slideId, self.typePreview);
        var tickers = __WEBPACK_IMPORTED_MODULE_3_reveal_js_js_reveal___default.a.getSlides()[0].querySelectorAll('#newsTicker');
        // self.setRevealPlayers(Reveal);
        var index = 0;
        var interval = setInterval(function () {
          index++;

          tickers.forEach(function (t) {
            var playBtn = t.querySelector('.bn-play');

            if (playBtn) {
              playBtn.click();
              clearInterval(interval);
            }
            if (index === 100) {
              clearInterval(interval);
            }
          });
        }, 100);
        // this.setNoMutedVideo(grapesjsEMP.editors[0]);
        self.setRevealPlayers(__WEBPACK_IMPORTED_MODULE_3_reveal_js_js_reveal___default.a);
        self.setNoWidthHeightReveal();
      }, 500);

      __WEBPACK_IMPORTED_MODULE_3_reveal_js_js_reveal___default.a.addEventListener('ready', function (event) {
        self.loadScript();
        self.setRevealUrlsCkeditors(event);
        //self.setAutoPlayVideo(self.slideId, self.typePreview);
      });
    },
    setNoWidthHeightReveal: function setNoWidthHeightReveal() {
      var slides = document.querySelector('.reveal .slides');
      slides.style.width = '';
      slides.style.height = '';
    },
    setRevealUrlsCkeditors: function setRevealUrlsCkeditors(event) {
      if (event.previousSlide) {
        var ckEditorsUrls = void 0;
        ckEditorsUrls = event.previousSlide.querySelectorAll("div[data-class='custom-sharing'] > p");
        this.setTargetUrlCkEditor(ckEditorsUrls);
      }
      if (event.currentSlide) {
        var _ckEditorsUrls = void 0;
        _ckEditorsUrls = event.currentSlide.querySelectorAll("div[data-class='custom-sharing'] > p");
        this.setTargetUrlCkEditor(_ckEditorsUrls);
      }
    },
    setTargetUrlCkEditor: function setTargetUrlCkEditor(ckEditorsUrls) {
      if (ckEditorsUrls && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(ckEditorsUrls).length > 0) {
        ckEditorsUrls.forEach(function (e) {
          var ckeditorHref = e.children[0];
          if (ckeditorHref && ckeditorHref.hasAttributes('data-cke-saved-href')) {
            ckeditorHref['target'] = '_blanc';
          }
        });
      }
    },
    setRevealPlayers: function setRevealPlayers(Reveal) {
      if (Reveal.getSlides()) {
        Reveal.getSlides().forEach(function (slide, index) {
          var players = void 0;
          players = slide.querySelectorAll("div iframe, iframe[src*='autoplay='], video, div[data-gjs-type*='video_mp4'] video");
          if (players && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(players).length > 0) {
            players.forEach(function (p) {
              if (index === 0) {
                //this.handleFirstPlayer(p);
              } else {
                  // this.handleOtherPlayers(p);
                }
            });
          }
        });
      }
    },
    handleFirstPlayer: function handleFirstPlayer(p) {
      var src = p.getAttribute('src');
      var id = p.getAttribute('id');
      var autoplayAttr = p.getAttribute('data-autoplay');
      var video = p.localName;
      if (src.indexOf('vimeo') > -1) {
        var iframe = $('#' + id)[0];
        p = $f(iframe);
      }
      var extension = src.split('.').pop();
      if (extension.indexOf('mp4') === -1) {
        if (src.indexOf('a=1') + src.indexOf('autoplay=1') > -1) {
          if (src.indexOf('vimeo') === -1) {
            this.setPlayedPlayers(p, video, this.timeout);
          } else {
            this.setPlayedVimeoVideo(p, video, this.timeout);
          }
        } else {
          if (src.indexOf('vimeo') === -1) {
            this.setPausedPlayers(p, video, this.timeout);
          } else {
            this.setPausedVimeoVideo(p, video, this.timeout);
          }
        }
      } else {
        if (autoplayAttr === 'autoplay' || autoplayAttr !== null || autoplayAttr === 1 || autoplayAttr === true) {
          p.play();
        } else {
          p.pause();
        }
      }
    },
    handleOtherPlayers: function handleOtherPlayers(p) {
      var src = p.getAttribute('src');
      var id = p.getAttribute('id');
      var video = p.localName;
      if (src.indexOf('vimeo') > -1) {
        var iframe = $('#' + id)[0];
        p = $f(iframe);
      }
      var extension = src.split('.').pop();

      if (extension.indexOf('mp4') === -1) {
        this.timeout = 100;
        if (video === 'iframe' && (id.indexOf('player') > -1 || id.indexOf('playlist') > -1 || src.indexOf('vimeo') > -1)) {
          this.timeout = 500;
        }
        if (src.indexOf('vimeo') === -1) {
          this.setPausedPlayers(p, video, this.timeout);
        } else {
          this.setPausedVimeoVideo(p, video, this.timeout);
        }
      } else {
        p.pause();
      }
    },
    slideChanged: function slideChanged(event) {
      var self = this;
      if (event.indexh == 0) {
        self.loadScript();
      }
      self.isChanged = true;
      self.setNoWidthHeightReveal();
      this.handleFragmentsAnimation(event);
      this.handleTickers(event);
      // this.handlePlayers(event);
      this.setRevealUrlsCkeditors(event);
      //this.setAutoPlayVideo(event.indexh, self.typePreview);
      this.animationsvgBySlide(event);
    },
    handleFragmentsAnimation: function handleFragmentsAnimation(event) {
      __WEBPACK_IMPORTED_MODULE_3_reveal_js_js_reveal___default.a.getSlides().forEach(function (s, i) {
        if (i < event.indexh) {
          var fragments = s.querySelectorAll('.fragment.visible');
          fragments.forEach(function (f) {
            f.classList.remove('visible');
          });
        }
      });
    },
    handleTickers: function handleTickers(event) {
      var previousTickers = event.previousSlide.querySelectorAll('#newsTicker');
      var currentTickers = event.currentSlide.querySelectorAll('#newsTicker');

      var previousIndex = 0;
      var currentIndex = 0;
      var previousInterval = setInterval(function () {
        previousIndex++;
        previousTickers.forEach(function (t) {
          var pauseBtn = t.querySelector('.bn-pause');

          if (pauseBtn) {
            pauseBtn.click();
            clearInterval(previousInterval);
          }
          if (previousIndex === 100) {
            clearInterval(previousInterval);
          }
        });
      }, 100);

      var currentInterval = setInterval(function () {
        currentIndex++;
        currentTickers.forEach(function (t) {
          var playBtn = t.querySelector('.bn-play');
          if (playBtn) {
            playBtn.click();
            clearInterval(currentInterval);
          }
          if (currentIndex === 100) {
            clearInterval(previousInterval);
          }
        });
      }, 100);
    },
    handlePlayers: function handlePlayers(event) {
      this.timeout = 0;
      if (event.previousSlide) {
        var previousPlayers = void 0;
        previousPlayers = event.previousSlide.querySelectorAll("div iframe, iframe[src*='autoplay='], video[autoplay='data-autoplay'], div[data-gjs-type*='video_mp4'] video[autoplay='data-autoplay']");
        if (previousPlayers) {
          previousPlayers.forEach(function (p) {
            // this.handlePreviousPlayers(p);
          });
        }
      }
      if (event.currentSlide) {
        var currentPlayers = void 0;
        currentPlayers = event.currentSlide.querySelectorAll("div iframe, iframe[src*='autoplay='], video[autoplay='data-autoplay'], div[data-gjs-type*='video_mp4'] video[autoplay='data-autoplay']");
        if (currentPlayers) {
          currentPlayers.forEach(function (p) {
            //this.handleCurrentPlayers(p);
          });
        }
      }
    },
    handlePreviousPlayers: function handlePreviousPlayers(p) {
      var src = p.getAttribute('src');
      var id = p.getAttribute('id');
      var video = p.localName;
      if (src.indexOf('vimeo') > -1) {
        var iframe = $('#' + id)[0];
        p = $f(iframe);
      }
      var extension = src.split('.').pop();

      if (extension.indexOf('mp4') === -1) {
        if (src.indexOf('vimeo') === -1) {
          this.setPausedPlayers(p, video, this.timeout);
        } else {
          this.setPausedVimeoVideo(p, video, this.timeout);
        }
      } else {
        p.pause();
      }
    },
    handleCurrentPlayers: function handleCurrentPlayers(p) {
      var src = p.getAttribute('src');
      var video = p.localName;
      var id = p.getAttribute('id');
      var autoplayAttr = p.getAttribute('data-autoplay');
      if (src.indexOf('vimeo') > -1) {
        var iframe = $('#' + id)[0];
        p = $f(iframe);
      }

      var extension = src.split('.').pop();

      if (extension.indexOf('mp4') === -1) {
        if (src.indexOf('a=1') + src.indexOf('autoplay=1') > -1) {
          if (src.indexOf('vimeo') === -1) {
            this.setPlayedPlayers(p, video, this.timeout);
          } else {
            this.setPlayedVimeoVideo(p, video, this.timeout);
          }
        } else {
          if (src.indexOf('vimeo') === -1) {
            this.setPausedPlayers(p, video, this.timeout);
          } else {
            this.setPausedVimeoVideo(p, video, this.timeout);
          }
        }
      } else {
        if (autoplayAttr === 'autoplay' || autoplayAttr !== null) {
          p.play();
        } else {
          p.pause();
        }
      }
    },
    setAutoPlayVideo: function setAutoPlayVideo(slide, type) {
      var _this9 = this;

      var self = this;
      var listVideos = self.videoObject.map(function (videos) {
        return videos;
      });
      listVideos.forEach(function (video, index) {
        if (video) {
          var videoArray = ['video']; // 'player', 'playlist'
          if (videoArray.indexOf(video.type) > -1) {
            var srcVideo = video.src;
            var attrAutoplay = void 0;
            var videoId = video.id || video.attributes.id;
            if (video.type === 'video') {
              attrAutoplay = 'autoplay';
            } else {
              attrAutoplay = 'a';
            }
            if (type === 'preview') {
              if (video.autoplay === 1 && video.src.indexOf(attrAutoplay + '=0') > -1 && video.slide === slide) {
                srcVideo = video.src.replace(attrAutoplay + '=0', attrAutoplay + '=1');
              } else {
                srcVideo = video.src.replace(attrAutoplay + '=1', attrAutoplay + '=0');
              }
            } else {
              srcVideo = video.src.replace(attrAutoplay + '=0', attrAutoplay + '=1');
            }
            _this9.setAutoplay(videoId, srcVideo, type);
          }
        }
      });
    },
    setAutoplay: function setAutoplay(videoId, srcVideo, type) {
      if (videoId) {
        setTimeout(function () {
          var iframe = document.querySelector('.gjs-frame').contentWindow;
          var videoEl = void 0;
          if (type === 'preview') {
            videoEl = document.querySelector('#' + videoId);
          } else {
            videoEl = iframe.document.querySelector('#' + videoId + ' > iframe');
          }
          if (videoEl) {
            videoEl.setAttribute('src', srcVideo);
          }
        }, 100);
      }
    }
  }),
  created: function created() {
    var _this10 = this;

    var self = this;
    self.$root.$on('ShowPreview', function (val) {
      self.scale = self.getScalingZoomAll();
      self.scaleValue('.preview-scaling', self.scale.percent / 100, self.scale.ty, self.scale.tx);
      var editor = grapesjsEMP.editors[0];
      var wrapper = editor.DomComponents.getWrapper();
      editor.select(wrapper);
      setTimeout(function () {
        if (!val) {
          self.isChanged = false;
          __WEBPACK_IMPORTED_MODULE_3_reveal_js_js_reveal___default.a.slide(self.selected.length - 1);
        }
        _this10.isVisible = val;
      }, 100);

      /* Check for full screen mode */
      if ((screen.availHeight || screen.height - 30) <= window.innerHeight) {
        var previewEl = document.getElementById('previewAll');
        var editorEl = document.getElementById('editor');
        editorEl.appendChild(previewEl);
      }
    });
    self.$root.$on('AutoPlayVideoPreview', function (obj) {
      self.videoObject = obj.video;
      self.typePreview = obj.type;
      // self.setAutoPlayVideo(self.getCurrentSlideIndex, self.typePreview);
    });
  },
  mounted: function mounted() {
    var self = this;
    __WEBPACK_IMPORTED_MODULE_3_reveal_js_js_reveal___default.a.addEventListener('slidechanged', self.slideChanged);

    __WEBPACK_IMPORTED_MODULE_3_reveal_js_js_reveal___default.a.addEventListener('overviewshown', function (event) {
      self.overviewShown = true;
    });
    __WEBPACK_IMPORTED_MODULE_3_reveal_js_js_reveal___default.a.addEventListener('overviewhidden', function (event) {
      self.overviewShown = false;
    });
  },
  destroyed: function destroyed() {
    var x = document.getElementById('twitter-wjs');
    if (x) {
      x.parentNode.removeChild(x);
    }
  }
});

/***/ }),
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */
/***/ (function(module, exports) {

module.exports = {"name":"cheerio","version":"0.22.0","description":"Tiny, fast, and elegant implementation of core jQuery designed specifically for the server","author":"Matt Mueller <mattmuelle@gmail.com> (mat.io)","license":"MIT","keywords":["htmlparser","jquery","selector","scraper","parser","html"],"repository":{"type":"git","url":"git://github.com/cheeriojs/cheerio.git"},"main":"./index.js","files":["index.js","lib"],"engines":{"node":">= 0.6"},"dependencies":{"css-select":"~1.2.0","dom-serializer":"~0.1.0","entities":"~1.1.1","htmlparser2":"^3.9.1","lodash.assignin":"^4.0.9","lodash.bind":"^4.1.4","lodash.defaults":"^4.0.1","lodash.filter":"^4.4.0","lodash.flatten":"^4.2.0","lodash.foreach":"^4.3.0","lodash.map":"^4.4.0","lodash.merge":"^4.4.0","lodash.pick":"^4.2.1","lodash.reduce":"^4.4.0","lodash.reject":"^4.4.0","lodash.some":"^4.4.0"},"devDependencies":{"benchmark":"^2.1.0","coveralls":"^2.11.9","expect.js":"~0.3.1","istanbul":"^0.4.3","jsdom":"^9.2.1","jquery":"^3.0.0","jshint":"^2.9.2","mocha":"^2.5.3","xyz":"~0.5.0"},"scripts":{"test":"make test"}}

/***/ }),
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */
/***/ (function(module, exports) {

module.exports = {"elementNames":{"altglyph":"altGlyph","altglyphdef":"altGlyphDef","altglyphitem":"altGlyphItem","animatecolor":"animateColor","animatemotion":"animateMotion","animatetransform":"animateTransform","clippath":"clipPath","feblend":"feBlend","fecolormatrix":"feColorMatrix","fecomponenttransfer":"feComponentTransfer","fecomposite":"feComposite","feconvolvematrix":"feConvolveMatrix","fediffuselighting":"feDiffuseLighting","fedisplacementmap":"feDisplacementMap","fedistantlight":"feDistantLight","fedropshadow":"feDropShadow","feflood":"feFlood","fefunca":"feFuncA","fefuncb":"feFuncB","fefuncg":"feFuncG","fefuncr":"feFuncR","fegaussianblur":"feGaussianBlur","feimage":"feImage","femerge":"feMerge","femergenode":"feMergeNode","femorphology":"feMorphology","feoffset":"feOffset","fepointlight":"fePointLight","fespecularlighting":"feSpecularLighting","fespotlight":"feSpotLight","fetile":"feTile","feturbulence":"feTurbulence","foreignobject":"foreignObject","glyphref":"glyphRef","lineargradient":"linearGradient","radialgradient":"radialGradient","textpath":"textPath"},"attributeNames":{"definitionurl":"definitionURL","attributename":"attributeName","attributetype":"attributeType","basefrequency":"baseFrequency","baseprofile":"baseProfile","calcmode":"calcMode","clippathunits":"clipPathUnits","diffuseconstant":"diffuseConstant","edgemode":"edgeMode","filterunits":"filterUnits","glyphref":"glyphRef","gradienttransform":"gradientTransform","gradientunits":"gradientUnits","kernelmatrix":"kernelMatrix","kernelunitlength":"kernelUnitLength","keypoints":"keyPoints","keysplines":"keySplines","keytimes":"keyTimes","lengthadjust":"lengthAdjust","limitingconeangle":"limitingConeAngle","markerheight":"markerHeight","markerunits":"markerUnits","markerwidth":"markerWidth","maskcontentunits":"maskContentUnits","maskunits":"maskUnits","numoctaves":"numOctaves","pathlength":"pathLength","patterncontentunits":"patternContentUnits","patterntransform":"patternTransform","patternunits":"patternUnits","pointsatx":"pointsAtX","pointsaty":"pointsAtY","pointsatz":"pointsAtZ","preservealpha":"preserveAlpha","preserveaspectratio":"preserveAspectRatio","primitiveunits":"primitiveUnits","refx":"refX","refy":"refY","repeatcount":"repeatCount","repeatdur":"repeatDur","requiredextensions":"requiredExtensions","requiredfeatures":"requiredFeatures","specularconstant":"specularConstant","specularexponent":"specularExponent","spreadmethod":"spreadMethod","startoffset":"startOffset","stddeviation":"stdDeviation","stitchtiles":"stitchTiles","surfacescale":"surfaceScale","systemlanguage":"systemLanguage","tablevalues":"tableValues","targetx":"targetX","targety":"targetY","textlength":"textLength","viewbox":"viewBox","viewtarget":"viewTarget","xchannelselector":"xChannelSelector","ychannelselector":"yChannelSelector","zoomandpan":"zoomAndPan"}}

/***/ }),
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */
/***/ (function(module, exports) {

module.exports = {"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","QUOT":"\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */
/***/ (function(module, exports) {

module.exports = {"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}

/***/ }),
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 663 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 664 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 665 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 666 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 667 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 669 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 670 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 671 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 672 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 673 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 674 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 675 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 682 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 685 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 688 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 689 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 690 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 691 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 692 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 693 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 694 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 695 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 696 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 697 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 698 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 699 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 701 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 702 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 703 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 704 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 705 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "display/static/img/icon-a.843c03e.svg";

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "display/static/img/icon-b.d70663d.svg";

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "display/static/img/icon-c.6f440c0.svg";

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "display/static/img/icon-d.4ef3abb.svg";

/***/ }),
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(701)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(848),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(705)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(852),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e8491e26",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(691)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(838),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(702)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(849),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(692)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(839),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(694)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(841),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6abfaa86",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(672)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(820),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-28513504",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(664)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(812),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0273cd3e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(669)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(817),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(704)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(851),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(673)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(821),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(677)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(825),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(695)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(842),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-725ff68c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(688)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(835),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-546d8e50",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(665)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(813),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(666)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(814),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(682)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(829),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(676)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(824),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-33123204",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(686)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(833),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(681)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(828),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(693)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(840),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6845c273",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(668)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(816),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(674)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(822),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2d42cc96",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(703)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(850),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(696)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(843),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73df1de3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(687)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(834),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(699)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(846),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(667)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(815),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 812 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-dispo",
    attrs: {
      "id": "list-video"
    }
  }, [_c('vue-topprogress', {
    ref: "topProgress",
    staticStyle: {
      "position": "relative",
      "right": "0px",
      "height": "7px"
    }
  }), _vm._v(" "), _c('b-row', [_c('div', {
    staticClass: "modal-body-content-module"
  }, [_c('div', {
    attrs: {
      "id": "plan1"
    }
  }, [_c('b-row', [_c('b-card', {
    attrs: {
      "id": "card-add-prog"
    }
  }, [_c('div', {
    staticClass: "icon-add-prog"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "60",
      "height": "60",
      "viewBox": "0 0 30 30"
    }
  }, [_c('path', {
    attrs: {
      "id": "Color",
      "d": "M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z",
      "transform": "translate(3.75 3.75)",
      "fill": "#acadb1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('module.generic.title')))]), _vm._v(" "), _c('h6', {
    staticStyle: {
      "color": "#68686b"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('module.generic.textAdd')) + " " + _vm._s(_vm.$t('blocks.add_generic_' + _vm.genericType)) + "\n              ")])])])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "list_video"
    }
  }, [_c('b-row', [_c('div', {
    staticClass: "search-wrapper-list",
    attrs: {
      "id": "search-list"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-input-group', {
    staticClass: "search-group"
  }, [_c('b-input-group-append', {
    staticClass: " search-icon",
    on: {
      "click": function($event) {
        return _vm.searchVideo(true)
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "1.5em",
      "height": "1.5em",
      "viewBox": "0 0 40 40"
    }
  }, [_c('path', {
    attrs: {
      "id": "Color",
      "d": "M28.879,28.929a1.083,1.083,0,0,1-.76-.305l-6.96-6.712v-.072A13.25,13.25,0,0,1,7.772,23.775,12.758,12.758,0,0,1,3.4,20.785,12.074,12.074,0,0,1,3.763,3.629a13.2,13.2,0,0,1,17.791-.352A12.079,12.079,0,0,1,22.648,20.4h.075l6.96,6.712a1.007,1.007,0,0,1-.043,1.507A1.1,1.1,0,0,1,28.879,28.929ZM12.857,2.143A10.468,10.468,0,0,0,2.143,12.321a9.863,9.863,0,0,0,3.138,7.2A10.935,10.935,0,0,0,12.857,22.5a11.15,11.15,0,0,0,4.1-.775,10.724,10.724,0,0,0,3.476-2.206,10.11,10.11,0,0,0,2.322-3.3,9.7,9.7,0,0,0,.815-3.9,9.862,9.862,0,0,0-3.138-7.2A10.934,10.934,0,0,0,12.857,2.143Z",
      "transform": "translate(5 6)",
      "fill": "#7c7c7c"
    }
  })])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "inputSearch",
    attrs: {
      "placeholder": _vm.$t('placeholder.search'),
      "id": "inputSearch"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchVideo(true)
      }
    },
    model: {
      value: (_vm.textToSearch),
      callback: function($$v) {
        _vm.textToSearch = $$v
      },
      expression: "textToSearch"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close-module-list",
    attrs: {
      "id": "close-module-list"
    },
    on: {
      "click": function($event) {
        return _vm.searchVideo(false)
      }
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])], 1)], 1), _vm._v(" "), _c('b-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSelect),
      expression: "showSelect"
    }]
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    on: {
      "change": function($event) {
        return _vm.onChangeThemId()
      }
    },
    model: {
      value: (_vm.idSelectedTheme),
      callback: function($$v) {
        _vm.idSelectedTheme = $$v
      },
      expression: "idSelectedTheme"
    }
  }, [_c('template', {
    slot: "first"
  }, _vm._l((this.options), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.title,
        "value": option.id
      }
    }, [_vm._v("\n                        " + _vm._s(option.title) + "\n                      ")])
  }), 0)], 2)], 1)], 1)], 1)]), _vm._v(" "), _c('b-row', {
    staticClass: "list-generics"
  }, [_c('div', {
    staticClass: "list-generic-videos"
  }, _vm._l((_vm.all_video), function(video, index) {
    return _c('div', {
      staticClass: "video-wrapper"
    }, [_c('div', {
      class: [
        'video-tag',
        'video-tag-' + index,
        {
          'is-selected-video': _vm.selected_vid === video.id || (!_vm.selected_vid && _vm.isSelected(video)),
        } ],
      on: {
        "click": function($event) {
          return _vm.SelectVideo(video, index)
        }
      }
    }, [_c('div', {
      staticClass: "image-card"
    }, [_c('div', {
      staticClass: "image-card__video"
    }, [(video.logo) ? _c('img', {
      staticClass: "img-liste-dispo",
      attrs: {
        "src": video.logo,
        "id": video.id
      }
    }) : _c('img', {
      staticClass: "img-liste-dispo",
      attrs: {
        "src": _vm.defaultScreenshot,
        "alt": "alt_img",
        "id": video.id
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: " image-card__infos__duration duration-style",
      attrs: {
        "title": video.duration
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.duration(video.duration)) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: " image-card__infos__title",
      attrs: {
        "title": video.title
      }
    }, [_vm._v("\n                    " + _vm._s(video.title) + "\n                  ")])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: " center",
    attrs: {
      "id": "loader-liste-dispo"
    }
  }, [_c('span', [_c('infinite-loading', {
    attrs: {
      "spinner": "bubbles"
    }
  })], 1)])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "position-buttons"
  }, [_c('button', {
    class: ['btn btn-outline-secondary', 'footer-select-button'],
    on: {
      "click": function($event) {
        return _vm.closeGenericList()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.back')) + "\n          ")]), _vm._v(" "), (_vm.genericType === 'fin') ? _c('button', {
    class: ['btn btn-primary', 'footer-select-button'],
    attrs: {
      "disabled": _vm.disabledSelectButton
    },
    on: {
      "click": function($event) {
        return _vm.addGeneriqueVideo()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('button.select')) + "\n          ")]) : _vm._e()])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "slide-list"
    }
  }, [_c('b-modal', {
    attrs: {
      "size": "xl",
      "id": "slide-list-modal",
      "noCloseOnBackdrop": true,
      "noCloseOnEsc": true,
      "hide-header": true
    },
    on: {
      "shown": _vm.loadMore
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function() {
        return [(!_vm.hideCancelButton) ? _c('button', {
          class: ['btn btn-link'],
          on: {
            "click": function($event) {
              return _vm.cancel()
            }
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$t('button.cancel')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.hideCancelButton && !_vm.navparam) ? _c('button', {
          class: ['btn btn-primary'],
          attrs: {
            "id": "btn-next"
          },
          on: {
            "click": function($event) {
              _vm.onNav(), _vm.changeStyleOn()
            }
          }
        }, [_c('i', {
          class: ['fa fa-arrow-left']
        }), _vm._v(" " + _vm._s(_vm.$t('button.back')) + "\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.hideCancelButton) ? _c('button', {
          class: ['btn btn-primary'],
          attrs: {
            "disabled": _vm.disabledConfirmButton
          },
          on: {
            "click": function($event) {
              return _vm.confirm()
            }
          }
        }, [_c('i', {
          class: ['fa fa-check']
        }), _vm._v(" " + _vm._s(_vm.$t('button.confirm')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.hideCancelButton && !_vm.navparam) ? _c('b-button', {
          attrs: {
            "id": "btn-finish",
            "type": "submit",
            "variant": "primary",
            "disabled": _vm.confirmButtonDisabled
          },
          on: {
            "click": _vm.confirm
          }
        }, [_c('i', {
          staticClass: "fa fa-check"
        }), _vm._v(" " + _vm._s(_vm.$t('button.finish')) + "\n      ")]) : _vm._e()]
      },
      proxy: true
    }])
  }, [_c('vue-topprogress', {
    ref: "topProgress",
    staticStyle: {
      "position": "relative",
      "right": "0px",
      "height": "7px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-body-content",
    on: {
      "click": function($event) {
        _vm.closeListScreen(), (_vm.clicksOut = true)
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "plan1"
    }
  }, [_c('b-row', {
    staticClass: "my-2 d-flex justify-content-between"
  }, [_c('b-col', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('show_blank_layout_action'),
      expression: "'show_blank_layout_action'"
    }],
    attrs: {
      "sm": "8"
    }
  }, [_c('slide-card', {
    attrs: {
      "id": "emptyDisposition",
      "isEditable": false,
      "isHover": false,
      "isEmpty": true,
      "item": _vm.emptyDisposition,
      "isSelected": _vm.selecteIdSegment.includes(_vm.emptyDisposition.id)
    },
    on: {
      "selected": function($event) {
        return _vm.addSegment(_vm.emptyDisposition)
      }
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    staticStyle: {
      "border-right": "none",
      "border-color": "#7c7c7c"
    },
    attrs: {
      "placeholder": _vm.$t('placeholder.search'),
      "id": "inputSearch"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchTitle()
      }
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    staticStyle: {
      "border-left": "none",
      "background-color": "#ffffff",
      "color": "#7c7c7c",
      "border-color": "#7c7c7c"
    },
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.searchTitle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticStyle: {
      "padding-left": "100px"
    }
  }, [_c('div', {
    staticClass: "section-disposition section-disposition__title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('labels.models')))])])]), _vm._v(" "), _c('b-col', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('add_segment_action'),
      expression: "'add_segment_action'"
    }],
    attrs: {
      "sm": "1"
    }
  }, [(_vm.hideCancelButton) ? _c('i', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.topleft",
      value: (_vm.$t('labels.add_model')),
      expression: "$t('labels.add_model')",
      modifiers: {
        "hover": true,
        "topleft": true
      }
    }],
    staticClass: "fa fa-plus-circle fa-2x",
    attrs: {
      "id": "fa-plus"
    },
    on: {
      "click": _vm.showSegmentModal
    }
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "slides-carousel",
    attrs: {
      "id": "default-segment"
    }
  }, [_c('carousel', {
    attrs: {
      "navigation-prev-label": "<span><img  src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC41MzEgNDQ0LjUzMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjUzMSA0NDQuNTMxOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTIxMy4xMywyMjIuNDA5TDM1MS44OCw4My42NTNjNy4wNS03LjA0MywxMC41NjctMTUuNjU3LDEwLjU2Ny0yNS44NDFjMC0xMC4xODMtMy41MTgtMTguNzkzLTEwLjU2Ny0yNS44MzUgICBsLTIxLjQwOS0yMS40MTZDMzIzLjQzMiwzLjUyMSwzMTQuODE3LDAsMzA0LjYzNywwcy0xOC43OTEsMy41MjEtMjUuODQxLDEwLjU2MUw5Mi42NDksMTk2LjQyNSAgIGMtNy4wNDQsNy4wNDMtMTAuNTY2LDE1LjY1Ni0xMC41NjYsMjUuODQxczMuNTIxLDE4Ljc5MSwxMC41NjYsMjUuODM3bDE4Ni4xNDYsMTg1Ljg2NGM3LjA1LDcuMDQzLDE1LjY2LDEwLjU2NCwyNS44NDEsMTAuNTY0ICAgczE4Ljc5NS0zLjUyMSwyNS44MzQtMTAuNTY0bDIxLjQwOS0yMS40MTJjNy4wNS03LjAzOSwxMC41NjctMTUuNjA0LDEwLjU2Ny0yNS42OTdjMC0xMC4wODUtMy41MTgtMTguNzQ2LTEwLjU2Ny0yNS45NzggICBMMjEzLjEzLDIyMi40MDl6IiBmaWxsPSIjYTZhNmE2Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=='/></span>",
      "navigation-next-label": "<span><img src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC44MTkgNDQ0LjgxOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjgxOSA0NDQuODE5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTM1Mi4wMjUsMTk2LjcxMkwxNjUuODg0LDEwLjg0OEMxNTkuMDI5LDMuNjE1LDE1MC40NjksMCwxNDAuMTg3LDBjLTEwLjI4MiwwLTE4Ljg0MiwzLjYxOS0yNS42OTcsMTAuODQ4TDkyLjc5MiwzMi4yNjQgICBjLTcuMDQ0LDcuMDQzLTEwLjU2NiwxNS42MDQtMTAuNTY2LDI1LjY5MmMwLDkuODk3LDMuNTIxLDE4LjU2LDEwLjU2NiwyNS45ODFsMTM4Ljc1MywxMzguNDczTDkyLjc4NiwzNjEuMTY4ICAgYy03LjA0Miw3LjA0My0xMC41NjQsMTUuNjA0LTEwLjU2NCwyNS42OTNjMCw5Ljg5NiwzLjUyMSwxOC41NjIsMTAuNTY0LDI1Ljk4bDIxLjcsMjEuNDEzICAgYzcuMDQzLDcuMDQzLDE1LjYxMiwxMC41NjQsMjUuNjk3LDEwLjU2NGMxMC4wODksMCwxOC42NTYtMy41MjEsMjUuNjk3LTEwLjU2NGwxODYuMTQ1LTE4NS44NjQgICBjNy4wNDYtNy40MjMsMTAuNTcxLTE2LjA4NCwxMC41NzEtMjUuOTgxQzM2Mi41OTcsMjEyLjMyMSwzNTkuMDcxLDIwMy43NTUsMzUyLjAyNSwxOTYuNzEyeiIgZmlsbD0iI2EwYTBhMCIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo='/></span>",
      "mouse-drag": false,
      "navigation-enabled": true,
      "pagination-enabled": false,
      "per-page-custom": [
        [320, 1],
        [576, 2],
        [768, 3],
        [992, 4],
        [1200, 4]
      ]
    },
    on: {
      "pageChange": function($event) {
        return _vm.pageSegmentChanged('DefaultSegment')
      }
    }
  }, _vm._l((_vm.DefaultSegments), function(item) {
    return _c('slide', {
      key: item.uid,
      staticClass: "one-disposition"
    }, [_c('slide-card', {
      attrs: {
        "have-screen": item.screens.length > 1,
        "Shot": item.screens[0] ? item.screens[0].screenShot : null,
        "isHover": true,
        "id": item.id,
        "item": item,
        "ModalSegment": true,
        "title": item.title,
        "itemsegment": item,
        "isSelected": _vm.selecteIdSegment.includes(item.id)
      },
      on: {
        "selected": function($event) {
          return _vm.addSegment(item)
        },
        "showSelect": function($event) {
          return _vm.showSelect(item)
        }
      }
    })], 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "triangle"
    },
    on: {
      "click": function($event) {
        _vm.clicksOut = false
      }
    }
  }, [_c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-1"
    },
    model: {
      value: (_vm.showCollapse),
      callback: function($$v) {
        _vm.showCollapse = $$v
      },
      expression: "showCollapse"
    }
  }, [_c('div', {
    staticClass: "p-3",
    staticStyle: {
      "min-height": "170px"
    }
  }, [_c('carousel', {
    attrs: {
      "navigation-prev-label": "<span><img src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC41MzEgNDQ0LjUzMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjUzMSA0NDQuNTMxOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTIxMy4xMywyMjIuNDA5TDM1MS44OCw4My42NTNjNy4wNS03LjA0MywxMC41NjctMTUuNjU3LDEwLjU2Ny0yNS44NDFjMC0xMC4xODMtMy41MTgtMTguNzkzLTEwLjU2Ny0yNS44MzUgICBsLTIxLjQwOS0yMS40MTZDMzIzLjQzMiwzLjUyMSwzMTQuODE3LDAsMzA0LjYzNywwcy0xOC43OTEsMy41MjEtMjUuODQxLDEwLjU2MUw5Mi42NDksMTk2LjQyNSAgIGMtNy4wNDQsNy4wNDMtMTAuNTY2LDE1LjY1Ni0xMC41NjYsMjUuODQxczMuNTIxLDE4Ljc5MSwxMC41NjYsMjUuODM3bDE4Ni4xNDYsMTg1Ljg2NGM3LjA1LDcuMDQzLDE1LjY2LDEwLjU2NCwyNS44NDEsMTAuNTY0ICAgczE4Ljc5NS0zLjUyMSwyNS44MzQtMTAuNTY0bDIxLjQwOS0yMS40MTJjNy4wNS03LjAzOSwxMC41NjctMTUuNjA0LDEwLjU2Ny0yNS42OTdjMC0xMC4wODUtMy41MTgtMTguNzQ2LTEwLjU2Ny0yNS45NzggICBMMjEzLjEzLDIyMi40MDl6IiBmaWxsPSIjYTZhNmE2Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=='/></span>",
      "navigation-next-label": "<span><img src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC44MTkgNDQ0LjgxOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjgxOSA0NDQuODE5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTM1Mi4wMjUsMTk2LjcxMkwxNjUuODg0LDEwLjg0OEMxNTkuMDI5LDMuNjE1LDE1MC40NjksMCwxNDAuMTg3LDBjLTEwLjI4MiwwLTE4Ljg0MiwzLjYxOS0yNS42OTcsMTAuODQ4TDkyLjc5MiwzMi4yNjQgICBjLTcuMDQ0LDcuMDQzLTEwLjU2NiwxNS42MDQtMTAuNTY2LDI1LjY5MmMwLDkuODk3LDMuNTIxLDE4LjU2LDEwLjU2NiwyNS45ODFsMTM4Ljc1MywxMzguNDczTDkyLjc4NiwzNjEuMTY4ICAgYy03LjA0Miw3LjA0My0xMC41NjQsMTUuNjA0LTEwLjU2NCwyNS42OTNjMCw5Ljg5NiwzLjUyMSwxOC41NjIsMTAuNTY0LDI1Ljk4bDIxLjcsMjEuNDEzICAgYzcuMDQzLDcuMDQzLDE1LjYxMiwxMC41NjQsMjUuNjk3LDEwLjU2NGMxMC4wODksMCwxOC42NTYtMy41MjEsMjUuNjk3LTEwLjU2NGwxODYuMTQ1LTE4NS44NjQgICBjNy4wNDYtNy40MjMsMTAuNTcxLTE2LjA4NCwxMC41NzEtMjUuOTgxQzM2Mi41OTcsMjEyLjMyMSwzNTkuMDcxLDIwMy43NTUsMzUyLjAyNSwxOTYuNzEyeiIgZmlsbD0iI2EwYTBhMCIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo='/></span>",
      "mouse-drag": false,
      "navigation-enabled": true,
      "pagination-enabled": false,
      "per-page-custom": [
        [320, 1],
        [576, 2],
        [768, 3],
        [992, 4],
        [1200, 4]
      ]
    },
    on: {
      "pageChange": function($event) {
        return _vm.pageSegmentChanged('DefaultSegment')
      }
    }
  }, _vm._l((_vm.getScreens(_vm.currentSegment.screens)), function(item) {
    return _c('slide', {
      key: item.uid,
      staticClass: "one-screen"
    }, [(!item.type === 'BlankSlide') ? _c('slide-card', {
      style: ({
        cursor: 'default'
      }),
      attrs: {
        "isHover": false,
        "ModalSegment": true,
        "item": item,
        "title": item.title,
        "Shot": item.screenShot
      }
    }) : _vm._e()], 1)
  }), 1)], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.segments.length !== 0),
      expression: "segments.length !== 0"
    }],
    staticClass: "section-screen section-screen__title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('labels.recent')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.segments.length !== 0),
      expression: "segments.length !== 0"
    }],
    staticClass: "slides-carousel",
    attrs: {
      "id": "segment-template"
    }
  }, [_c('carousel', {
    attrs: {
      "navigation-prev-label": "<span><img src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC41MzEgNDQ0LjUzMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjUzMSA0NDQuNTMxOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTIxMy4xMywyMjIuNDA5TDM1MS44OCw4My42NTNjNy4wNS03LjA0MywxMC41NjctMTUuNjU3LDEwLjU2Ny0yNS44NDFjMC0xMC4xODMtMy41MTgtMTguNzkzLTEwLjU2Ny0yNS44MzUgICBsLTIxLjQwOS0yMS40MTZDMzIzLjQzMiwzLjUyMSwzMTQuODE3LDAsMzA0LjYzNywwcy0xOC43OTEsMy41MjEtMjUuODQxLDEwLjU2MUw5Mi42NDksMTk2LjQyNSAgIGMtNy4wNDQsNy4wNDMtMTAuNTY2LDE1LjY1Ni0xMC41NjYsMjUuODQxczMuNTIxLDE4Ljc5MSwxMC41NjYsMjUuODM3bDE4Ni4xNDYsMTg1Ljg2NGM3LjA1LDcuMDQzLDE1LjY2LDEwLjU2NCwyNS44NDEsMTAuNTY0ICAgczE4Ljc5NS0zLjUyMSwyNS44MzQtMTAuNTY0bDIxLjQwOS0yMS40MTJjNy4wNS03LjAzOSwxMC41NjctMTUuNjA0LDEwLjU2Ny0yNS42OTdjMC0xMC4wODUtMy41MTgtMTguNzQ2LTEwLjU2Ny0yNS45NzggICBMMjEzLjEzLDIyMi40MDl6IiBmaWxsPSIjYTZhNmE2Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=='/></span>",
      "navigation-next-label": "<span><img src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC44MTkgNDQ0LjgxOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjgxOSA0NDQuODE5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTM1Mi4wMjUsMTk2LjcxMkwxNjUuODg0LDEwLjg0OEMxNTkuMDI5LDMuNjE1LDE1MC40NjksMCwxNDAuMTg3LDBjLTEwLjI4MiwwLTE4Ljg0MiwzLjYxOS0yNS42OTcsMTAuODQ4TDkyLjc5MiwzMi4yNjQgICBjLTcuMDQ0LDcuMDQzLTEwLjU2NiwxNS42MDQtMTAuNTY2LDI1LjY5MmMwLDkuODk3LDMuNTIxLDE4LjU2LDEwLjU2NiwyNS45ODFsMTM4Ljc1MywxMzguNDczTDkyLjc4NiwzNjEuMTY4ICAgYy03LjA0Miw3LjA0My0xMC41NjQsMTUuNjA0LTEwLjU2NCwyNS42OTNjMCw5Ljg5NiwzLjUyMSwxOC41NjIsMTAuNTY0LDI1Ljk4bDIxLjcsMjEuNDEzICAgYzcuMDQzLDcuMDQzLDE1LjYxMiwxMC41NjQsMjUuNjk3LDEwLjU2NGMxMC4wODksMCwxOC42NTYtMy41MjEsMjUuNjk3LTEwLjU2NGwxODYuMTQ1LTE4NS44NjQgICBjNy4wNDYtNy40MjMsMTAuNTcxLTE2LjA4NCwxMC41NzEtMjUuOTgxQzM2Mi41OTcsMjEyLjMyMSwzNTkuMDcxLDIwMy43NTUsMzUyLjAyNSwxOTYuNzEyeiIgZmlsbD0iI2EwYTBhMCIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo='/></span>",
      "mouse-drag": false,
      "navigation-enabled": true,
      "pagination-enabled": false,
      "per-page-custom": [
        [320, 1],
        [576, 2],
        [768, 3],
        [992, 4],
        [1200, 4]
      ]
    },
    on: {
      "pageChange": function($event) {
        return _vm.pageSegmentChanged('Segment')
      }
    }
  }, _vm._l((_vm.segments), function(item) {
    return _c('slide', {
      key: item.id,
      staticClass: "one-screen"
    }, [_c('slide-card', {
      attrs: {
        "ModalSegment": true,
        "isHover": true,
        "id": item.id,
        "have-screen": item.screens.length > 1,
        "Shot": item.screens[0] ? item.screens[0].screenShot : null,
        "item": item,
        "title": item.title,
        "isCollapse2": true,
        "isSelected": _vm.selecteIdSegment.includes(item.id)
      },
      on: {
        "selected": function($event) {
          return _vm.addSegment(item)
        },
        "showSelect2": function($event) {
          return _vm.showSelect2(item)
        }
      }
    })], 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "triangle2"
    },
    on: {
      "click": function($event) {
        _vm.clicksOut = false
      }
    }
  }, [_c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.showCollapse2),
      callback: function($$v) {
        _vm.showCollapse2 = $$v
      },
      expression: "showCollapse2"
    }
  }, [_c('div', {
    staticClass: "p-3",
    staticStyle: {
      "min-height": "170px"
    }
  }, [_c('carousel', {
    attrs: {
      "navigation-prev-label": "<span><img src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC41MzEgNDQ0LjUzMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjUzMSA0NDQuNTMxOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTIxMy4xMywyMjIuNDA5TDM1MS44OCw4My42NTNjNy4wNS03LjA0MywxMC41NjctMTUuNjU3LDEwLjU2Ny0yNS44NDFjMC0xMC4xODMtMy41MTgtMTguNzkzLTEwLjU2Ny0yNS44MzUgICBsLTIxLjQwOS0yMS40MTZDMzIzLjQzMiwzLjUyMSwzMTQuODE3LDAsMzA0LjYzNywwcy0xOC43OTEsMy41MjEtMjUuODQxLDEwLjU2MUw5Mi42NDksMTk2LjQyNSAgIGMtNy4wNDQsNy4wNDMtMTAuNTY2LDE1LjY1Ni0xMC41NjYsMjUuODQxczMuNTIxLDE4Ljc5MSwxMC41NjYsMjUuODM3bDE4Ni4xNDYsMTg1Ljg2NGM3LjA1LDcuMDQzLDE1LjY2LDEwLjU2NCwyNS44NDEsMTAuNTY0ICAgczE4Ljc5NS0zLjUyMSwyNS44MzQtMTAuNTY0bDIxLjQwOS0yMS40MTJjNy4wNS03LjAzOSwxMC41NjctMTUuNjA0LDEwLjU2Ny0yNS42OTdjMC0xMC4wODUtMy41MTgtMTguNzQ2LTEwLjU2Ny0yNS45NzggICBMMjEzLjEzLDIyMi40MDl6IiBmaWxsPSIjYTZhNmE2Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=='/></span>",
      "navigation-next-label": "<span><img src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC44MTkgNDQ0LjgxOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjgxOSA0NDQuODE5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTM1Mi4wMjUsMTk2LjcxMkwxNjUuODg0LDEwLjg0OEMxNTkuMDI5LDMuNjE1LDE1MC40NjksMCwxNDAuMTg3LDBjLTEwLjI4MiwwLTE4Ljg0MiwzLjYxOS0yNS42OTcsMTAuODQ4TDkyLjc5MiwzMi4yNjQgICBjLTcuMDQ0LDcuMDQzLTEwLjU2NiwxNS42MDQtMTAuNTY2LDI1LjY5MmMwLDkuODk3LDMuNTIxLDE4LjU2LDEwLjU2NiwyNS45ODFsMTM4Ljc1MywxMzguNDczTDkyLjc4NiwzNjEuMTY4ICAgYy03LjA0Miw3LjA0My0xMC41NjQsMTUuNjA0LTEwLjU2NCwyNS42OTNjMCw5Ljg5NiwzLjUyMSwxOC41NjIsMTAuNTY0LDI1Ljk4bDIxLjcsMjEuNDEzICAgYzcuMDQzLDcuMDQzLDE1LjYxMiwxMC41NjQsMjUuNjk3LDEwLjU2NGMxMC4wODksMCwxOC42NTYtMy41MjEsMjUuNjk3LTEwLjU2NGwxODYuMTQ1LTE4NS44NjQgICBjNy4wNDYtNy40MjMsMTAuNTcxLTE2LjA4NCwxMC41NzEtMjUuOTgxQzM2Mi41OTcsMjEyLjMyMSwzNTkuMDcxLDIwMy43NTUsMzUyLjAyNSwxOTYuNzEyeiIgZmlsbD0iI2EwYTBhMCIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo='/></span>",
      "mouse-drag": false,
      "navigation-enabled": true,
      "pagination-enabled": false,
      "per-page-custom": [
        [320, 1],
        [576, 2],
        [768, 3],
        [992, 4],
        [1200, 4]
      ]
    },
    on: {
      "pageChange": function($event) {
        return _vm.pageSegmentChanged('Segment')
      }
    }
  }, _vm._l((_vm.getScreens(_vm.currentSegment.screens)), function(item) {
    return _c('slide', {
      key: item.uid,
      staticClass: "one-screen"
    }, [(!item.type === 'BlankSlide') ? _c('slide-card', {
      style: ({
        cursor: 'default'
      }),
      attrs: {
        "isHover": false,
        "ModalSegment": true,
        "item": item,
        "title": item.title,
        "Shot": item.screenShot
      }
    }) : _vm._e()], 1)
  }), 1)], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.navparam),
      expression: "navparam"
    }],
    attrs: {
      "id": "plan2"
    },
    on: {
      "click": function($event) {
        _vm.clicksOut = false
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "content-plan2"
    }
  }, [_c('b-row', {
    staticClass: "my-2 d-flex justify-content-between"
  }, [_c('b-col', [_c('b-form-group', {
    staticClass: "text-left",
    attrs: {
      "id": "input-group-title",
      "label": _vm.$t('labels.title'),
      "label-for": "input-titre"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "input-titre",
      "state": _vm.stateTitle,
      "required": "",
      "placeholder": _vm.$t('placeholder.title')
    },
    model: {
      value: (_vm.titleTemplate),
      callback: function($$v) {
        _vm.titleTemplate = $$v
      },
      expression: "titleTemplate"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('use_ligne_template_action'),
      expression: "'use_ligne_template_action'"
    }]
  }, [_c('b-form-group', {
    staticClass: "text-left",
    attrs: {
      "id": "input-group-title",
      "label": _vm.$t('labels.ligne'),
      "label-for": "input-titre"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "required": "",
      "state": _vm.stateLigne,
      "id": "input-ligne"
    },
    model: {
      value: (_vm.ligneTemplate),
      callback: function($$v) {
        _vm.ligneTemplate = $$v
      },
      expression: "ligneTemplate"
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.name,
        "value": option.value
      }
    }, [_vm._v("\n                    " + _vm._s(option.name) + "\n                  ")])
  }), 0)], 1)], 1), _vm._v(" "), _c('b-col', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('initialize_duration_template_action'),
      expression: "'initialize_duration_template_action'"
    }],
    attrs: {
      "sm": "4"
    }
  }, [_c('b-form-group', {
    staticClass: "text-left",
    attrs: {
      "id": "input-group-time",
      "label": _vm.$t('labels.duration'),
      "label-for": "input-time"
    }
  }, [_c('b-form-input', {
    staticClass: "input-time",
    attrs: {
      "state": _vm.stateDuration,
      "id": "input-time",
      "type": "text",
      "step": "2",
      "required": ""
    },
    model: {
      value: (_vm.durationTemplate),
      callback: function($$v) {
        _vm.durationTemplate = $$v
      },
      expression: "durationTemplate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "text-right"
  }, [(_vm.navparam) ? _c('button', {
    class: ['btn btn-primary'],
    on: {
      "click": function($event) {
        _vm.onNav(), _vm.changeStyleOff()
      }
    }
  }, [_c('i', {
    class: ['fa fa-arrow-right']
  }), _vm._v(" " + _vm._s(_vm.$t('button.next')) + "\n              ")]) : _vm._e()])], 1)], 1)])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 814 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal-center",
    staticStyle: {
      "position": "absolute"
    },
    attrs: {
      "id": "modal-center",
      "centered": "",
      "title": _vm.$t('titles.title_transition'),
      "ok-only": true,
      "ok-title": _vm.$t('button.validate')
    },
    on: {
      "ok": function($event) {},
      "hidden": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('section', {
    attrs: {
      "id": "contentIn"
    }
  }, [_c('div', {
    staticClass: "mode_transition",
    class: {
      selected: _vm.transition === 'no-transition'
    },
    attrs: {
      "id": "no-transition-in"
    },
    on: {
      "click": function($event) {
        return _vm.setTransition('no-transition')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icons/transitions/none.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "label mt-2"
  }, [_vm._v(_vm._s(_vm.$t('modal.setting.animation.without_transition')))])]), _vm._v(" "), _c('div', {
    staticClass: "mode_transition",
    class: {
      selected: _vm.transition === 'slide'
    },
    attrs: {
      "id": "transition-right-in"
    },
    on: {
      "click": function($event) {
        return _vm.setTransition('slide')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icons/transitions/slide.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "label mt-2"
  }, [_vm._v("Slide")])]), _vm._v(" "), _c('div', {
    staticClass: "mode_transition full",
    class: {
      selected: _vm.transition === 'convex'
    },
    attrs: {
      "id": "transition-left-in"
    },
    on: {
      "click": function($event) {
        return _vm.setTransition('convex')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icons/transitions/convex.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "label mt-2"
  }, [_vm._v(_vm._s(_vm.$t('modal.setting.animation.convex')))])]), _vm._v(" "), _c('div', {
    staticClass: "mode_transition top",
    class: {
      selected: _vm.transition === 'concave'
    },
    attrs: {
      "id": "transition-top-in"
    },
    on: {
      "click": function($event) {
        return _vm.setTransition('concave')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icons/transitions/concave.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "label mt-2"
  }, [_vm._v("Concave")])]), _vm._v(" "), _c('div', {
    staticClass: "mode_transition bottom",
    class: {
      selected: _vm.transition === 'fade'
    },
    attrs: {
      "id": "transition-bottom-in"
    },
    on: {
      "click": function($event) {
        return _vm.setTransition('fade')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icons/transitions/fade.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "label mt-2"
  }, [_vm._v(_vm._s(_vm.$t('modal.setting.animation.fade-in')))])]), _vm._v(" "), _c('div', {
    staticClass: "mode_transition zoom",
    class: {
      selected: _vm.transition === 'zoom'
    },
    attrs: {
      "id": "transition-zoom-in"
    },
    on: {
      "click": function($event) {
        return _vm.setTransition('zoom')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icons/transitions/zoom.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "label mt-2"
  }, [_vm._v(_vm._s(_vm.$t('modal.setting.animation.grow')))])])])])
},staticRenderFns: []}

/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['sweet-modal-tab', {
      active: _vm.active
    }]
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-pages-container"
  }, [(_vm.show_generic_display == 1 && _vm.all.length > 0) ? _c('button', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('show_generic_action'),
      expression: "'show_generic_action'"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.withGeneric),
      expression: "withGeneric"
    }],
    staticClass: "btn btn-sm btn-generic",
    class: {
      filled: _vm.startGeneric
    },
    on: {
      "click": function($event) {
        return _vm.videoGenerique('debut')
      }
    }
  }, [_c('i', {
    staticClass: "icon-movie-clap"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-navigation",
    class: [{
      active: _vm.hasScrollSlides
    }]
  }, [_c('button', {
    staticClass: "  button-navigation--left btn btn-sm",
    attrs: {
      "id": "button-navigation-left",
      "disabled": !_vm.hasScrollSlides
    },
    on: {
      "click": function($event) {
        return _vm.dragSlide($event, -1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "slides-panel row",
    attrs: {
      "id": "div-draggable"
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "ps",
    staticClass: "scroll-area",
    attrs: {
      "id": "ps-slide-wrapper",
      "use-both-wheel-axes": true
    },
    on: {
      "ps-scroll-x": _vm.removeSmoothing,
      "ps-scroll-y": _vm.removeSmoothing
    }
  }, [_c('div', {
    staticClass: "row__inner",
    on: {
      "mousewheel": _vm.scrollHorizontally
    }
  }, [_c('draggable', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "id": "draggable-wrapper",
      "move": _vm.dragSlide
    },
    on: {
      "end": _vm.reorder,
      "start": _vm.getList
    },
    model: {
      value: (_vm.list),
      callback: function($$v) {
        _vm.list = $$v
      },
      expression: "list"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "list-complete"
    }
  }, _vm._l((_vm.all), function(slide, index) {
    return _c('div', {
      key: 'list-complete-' + index,
      staticClass: "card-wrapper",
      class: {
        extended: slide.isExtended
      },
      attrs: {
        "data-uid": slide.uid
      }
    }, [_c('div', {
      staticClass: "transition-icon-wrapper"
    }, [_c('b-button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modal-center",
        modifiers: {
          "modal-center": true
        }
      }, {
        name: "show",
        rawName: "v-show",
        value: (_vm.show_transition && (index > 0 || _vm.startGeneric)),
        expression: "show_transition && (index > 0 || startGeneric)"
      }],
      staticClass: "transition-btn",
      class: {
        active: _vm.hasTransition(slide)
      },
      on: {
        "click": function($event) {
          return _vm.addTransition(slide)
        }
      }
    }, [_c('i', {
      staticClass: "icon-transition"
    })]), _vm._v(" "), _c('b-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.show_video_intro),
        expression: "show_video_intro"
      }],
      staticClass: "transition-btn",
      class: {
        active: _vm.hasStartGeneric(slide)
      },
      on: {
        "click": function($event) {
          return _vm.videoGenerique('intro', index)
        }
      }
    }, [_c('i', {
      staticClass: "icon-film-strip"
    })])], 1), _vm._v(" "), _c('panel-card', {
      attrs: {
        "index": index,
        "slide": slide,
        "isSelected": slide.uid === _vm.currentSegment.uid,
        "removable": _vm.all.length > 1,
        "showVideoIntro": {},
        "is-segment-card": true
      },
      on: {
        "selected": function($event) {
          return _vm.selectSegment(slide)
        },
        "duplicated": function($event) {
          return _vm.handleDuplicateSegment(slide, index)
        },
        "toggled": function($event) {
          return _vm.toggleSegmentCards(slide, index)
        },
        "insertSegment": function($event) {
          return _vm.handleInsertSegment(index)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "inner-slides-wrapper",
      class: {
        extended: slide.isExtended
      },
      style: (_vm.calculateWidth(slide))
    }, [_c('draggable', {
      key: _vm.segmentKey,
      staticClass: "inner-slides-container",
      staticStyle: {
        "display": "flex"
      },
      attrs: {
        "id": "nested-draggable-wrapper"
      },
      on: {
        "end": function($event) {
          return _vm.reorderSlides($event, index)
        }
      },
      model: {
        value: (_vm.lists[index]),
        callback: function($$v) {
          _vm.$set(_vm.lists, index, $$v)
        },
        expression: "lists[index]"
      }
    }, _vm._l((_vm.getScreens(slide)), function(slideScreen, i) {
      return _c('div', {
        key: i,
        staticClass: "slides-transitions-wrapper"
      }, [_c('panel-card', {
        attrs: {
          "index": i,
          "segment": slide,
          "slide": slideScreen,
          "isSelected": slideScreen.uid === _vm.currentSlide.uid
        },
        on: {
          "selected": function($event) {
            return _vm.selectSlide(slide, slideScreen)
          },
          "duplicated": function($event) {
            return _vm.handleDuplicateSlideInsideSegment(slide, slideScreen, index, i)
          }
        }
      })], 1)
    }), 0), _vm._v(" "), _c('b-button', {
      staticClass: "btn btn-sm add-segment-btn",
      attrs: {
        "pill": "",
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleAppendSlide(index)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('button.ecran')) + "\n                ")])], 1)], 1)
  }), 0)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "button-navigation",
    class: [{
      active: _vm.hasScrollSlides
    }]
  }, [_c('button', {
    staticClass: " button-navigation--right btn btn-sm",
    attrs: {
      "id": "button-navigation-right",
      "disabled": !_vm.hasScrollSlides
    },
    on: {
      "click": function($event) {
        return _vm.dragSlide($event, 1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), (_vm.show_generic_display == 1 && _vm.all.length > 0) ? _c('button', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('show_generic_action'),
      expression: "'show_generic_action'"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.withGeneric),
      expression: "withGeneric"
    }],
    staticClass: "btn btn-sm btn-generic",
    class: {
      filled: _vm.finishGeneric
    },
    on: {
      "click": function($event) {
        return _vm.videoGenerique('fin')
      }
    }
  }, [_c('i', {
    staticClass: "icon-finish"
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 817 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "add-generic"
    }
  }, [_c('b-modal', {
    attrs: {
      "id": "modal-add-generic",
      "noCloseOnBackdrop": true,
      "noCloseOnEsc": true,
      "centered": ""
    },
    on: {
      "hide": _vm.close
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function() {
        return [_c('b-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.defaultUrl),
            expression: "defaultUrl"
          }],
          staticClass: "btn btn-primary",
          attrs: {
            "size": "xl"
          },
          on: {
            "click": _vm.emitDefaultVideos
          }
        }, [_vm._v("\n        Défaut\n      ")]), _vm._v(" "), _c('b-button', {
          staticClass: "btn btn-primary",
          attrs: {
            "size": "xl"
          },
          on: {
            "click": _vm.submit
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$t('modal.add_generic.btn_add')) + "\n      ")])]
      },
      proxy: true
    }])
  }, [_c('img', {
    attrs: {
      "src": "data:image/png;base64,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"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mt-4 mb-2 title"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$t('modal.add_generic.title')) + " " + _vm._s(_vm.getTitleTranslated))])]), _vm._v(" "), _c('p', {
    staticClass: "my-2 subtitle"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('modal.add_generic.subtitle')) + "\n    ")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cardSegmentParam",
    class: {
      selected: _vm.isSelected
    },
    attrs: {
      "id": "cardSegmentParam"
    }
  }, [_c('b-card', {
    staticClass: "card-segment"
  }, [_c('div', {
    staticClass: "img-segment",
    on: {
      "mouseover": _vm.mouseOver
    }
  }, [_c('div', {
    staticClass: "image-wrapper-segment"
  }, [_c('img', {
    attrs: {
      "src": _vm.Shot ? _vm.Shot : _vm.screenShot,
      "id": _vm.item.id
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-icon"
  }, [_c('div', {
    staticClass: "image-svg d-flex justify-content-between"
  }, [_c('div', {
    staticClass: "img-svg",
    on: {
      "click": function($event) {
        return _vm.updateSegmentInGrapes(_vm.item, _vm.index)
      }
    }
  }, [_c('i', {
    staticClass: "icon-edit-c white-color-i"
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-svg",
    on: {
      "click": function($event) {
        return _vm.duplicateThis(_vm.item, _vm.index)
      }
    }
  }, [_c('i', {
    staticClass: "icon-duplicate-c white-color-i"
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-svg"
  }, [_c('b-dropdown', {
    attrs: {
      "size": "lg",
      "variant": "link",
      "toggle-class": "text-decoration-none",
      "no-caret": "",
      "id": 'dropdown-' + _vm.indexDropDown
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function() {
        return [_c('i', {
          staticClass: "icon-more-c white-color-i"
        })]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.editSegment(_vm.item)
      }
    }
  }, [_c('svg', {
    staticClass: "svg mr",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24px",
      "height": "24px",
      "viewBox": "0 0 11.361 33.412"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#000000",
      "d": "M37.431,53.379H35.256a.519.519,0,0,0-.1-.074,2.791,2.791,0,0,1-1.671-3.365c.986-4.063,2-8.12,3.007-12.18a12.7,12.7,0,0,0,.3-1.708.4.4,0,0,0-.531-.474,3.214,3.214,0,0,0-.668.231c-.495.207-.976.451-1.474.642A.839.839,0,0,1,33,36.237v-.792a8.973,8.973,0,0,1,1.139-1.307c1.49-1.173,3.007-2.292,4.555-3.412A5.128,5.128,0,0,1,39.75,30.2a2.566,2.566,0,0,1,1.54-.16,2.983,2.983,0,0,1,2.466,3.849q-1.434,5.868-2.88,11.736a15.7,15.7,0,0,0-.334,1.935.378.378,0,0,0,.548.428c.364-.11.708-.287,1.063-.431.428-.187.872-.358,1.3-.521a.628.628,0,0,1,.715.207.668.668,0,0,1,.07.769,2.85,2.85,0,0,1-.411.632,11.1,11.1,0,0,1-1.16,1.119A32,32,0,0,1,37.431,53.379Z",
      "transform": "translate(-33 -19.967)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#000000",
      "d": "M46.49,8.237a4.1,4.1,0,1,1,2.911-1.2A4.113,4.113,0,0,1,46.49,8.237Z",
      "transform": "translate(-39.246 -0.01)"
    }
  })]), _vm._v("\n                  Informations\n                ")]), _vm._v(" "), _c('b-dropdown-item', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.handleDelete(_vm.item)
      }
    }
  }, [_c('svg', {
    staticClass: "action-btn mr",
    attrs: {
      "width": "24px",
      "height": "20px",
      "viewBox": "0 0 16 20",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1.14285714,17.7777778 C1.14285714,19.0055556 2.16571429,20 3.42857143,20 L12.5714286,20 C13.8342857,20 14.8571429,19.0055556 14.8571429,17.7777778 L14.8571429,4.44444444 L1.14285714,4.44444444 L1.14285714,17.7777778 Z M16,1.11111111 L12,1.11111111 L10.8571429,0 L5.14285714,0 L4,1.11111111 L0,1.11111111 L0,3.33333333 L16,3.33333333 L16,1.11111111 Z",
      "id": "Shape",
      "fill": "red",
      "fill-rule": "nonzero"
    }
  })])]), _vm._v("\n                  Supprimer")])], 1)], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-segment d-flex justify-content-between"
  }, [_c('div', {
    staticClass: "resizer-text"
  }, [_c('span', {
    staticClass: "title-segment",
    on: {
      "click": function($event) {
        return _vm.showSlides(_vm.item)
      }
    }
  }, [_vm._v("\n          " + _vm._s(this.item.title) + "\n        ")]), _vm._v(" "), (_vm.item.author) ? _c('div', {
    staticStyle: {
      "margin-top": "0.1em"
    }
  }, [_vm._v("\n          Par "), _c('span', {
    staticStyle: {
      "color": "#2196f3"
    }
  }, [_vm._v(" " + _vm._s(_vm.createdPar()) + " ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "nb-screen"
  }, [_vm._v(_vm._s(_vm.item.screens.length) + " " + _vm._s(_vm.$t('screens.screen')) + "(s)")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.getColorBtn),
    attrs: {
      "id": "editSegment"
    }
  }, [_c('b-container', [_c('b-card', {
    staticClass: "mb-3",
    attrs: {
      "id": "card-edit"
    }
  }, [_c('div', {
    staticClass: "icon-edit-segment"
  }, [_c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.routeAdd),
      expression: "!routeAdd"
    }],
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "50",
      "height": "50",
      "viewBox": "0 0 18 18"
    }
  }, [_c('defs', [_c('clipPath', {
    attrs: {
      "id": "edit-path"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.672-16a.8.8,0,0,1,.8.8.8.8,0,0,1-.707.795l-.093.005H2.4a.8.8,0,0,0-.795.707L1.6-13.6V-2.4a.8.8,0,0,0,.707.795L2.4-1.6H13.6a.8.8,0,0,0,.795-.707L14.4-2.4V-6.672a.8.8,0,0,1,.8-.8.8.8,0,0,1,.795.707L16-6.672V-2.4A2.4,2.4,0,0,1,13.741,0L13.6,0H2.4A2.4,2.4,0,0,1,0-2.259L0-2.4V-13.6A2.4,2.4,0,0,1,2.259-16L2.4-16Zm6.691-1.762a.812.812,0,0,1,1.149,0h0l3.25,3.25a.812.812,0,0,1,0,1.149h0L9.637-5.238A.812.812,0,0,1,9.063-5H5.813A.813.813,0,0,1,5-5.812H5v-3.25a.812.812,0,0,1,.238-.575h0Zm.575,1.724L6.625-8.726v2.1h2.1l7.313-7.312Z",
      "fill": "none",
      "clip-rule": "evenodd"
    }
  })])]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(0 18)",
      "clip-path": "url(#edit-path)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M-5-23H23V5H-5Z",
      "fill": "#acadb1"
    }
  })])]), _vm._v(" "), _c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.routeAdd),
      expression: "routeAdd"
    }],
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "60",
      "height": "60",
      "viewBox": "0 0 30 30"
    }
  }, [_c('path', {
    attrs: {
      "id": "Color",
      "d": "M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z",
      "transform": "translate(3.75 3.75)",
      "fill": "#acadb1"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.routeAdd),
      expression: "!routeAdd"
    }]
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('biblioSegment.editSegment')))]), _vm._v(" "), _c('h6', {
    staticStyle: {
      "color": "#68686b"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('biblioSegment.textEdit')) + "\n        ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.routeAdd),
      expression: "routeAdd"
    }]
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('biblioSegment.addSegment')))]), _vm._v(" "), _c('h6', {
    staticStyle: {
      "color": "#68686b"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('biblioSegment.textAdd')) + "\n        ")])])]), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "input-group-title",
      "label": _vm.$t('biblioSegment.title'),
      "label-for": "input-title"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "input-title",
      "placeholder": _vm.$t('biblioSegment.placeholder-title'),
      "required": "",
      "state": _vm.stateTitle,
      "maxlength": _vm.getmaxLength
    },
    model: {
      value: (_vm.getTitleSegment),
      callback: function($$v) {
        _vm.getTitleSegment = $$v
      },
      expression: "getTitleSegment"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('biblioSegment.theme'),
      "label-for": "input-sm"
    }
  }, [_c('v-select', {
    attrs: {
      "placeholder": _vm.$t('biblioSegment.selectTheme'),
      "options": _vm.themeList,
      "multiple": ""
    },
    model: {
      value: (_vm.themeId),
      callback: function($$v) {
        _vm.themeId = $$v
      },
      expression: "themeId"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    slot: "no-options"
  }, [_vm._v(_vm._s(_vm.$t('biblioSegment.noOption')))]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-result"
    },
    slot: "no-result"
  }, [_vm._v(_vm._s(_vm.$t('biblioSegment.noResult')))])])], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "input-group-desc",
      "label": _vm.$t('biblioSegment.description'),
      "label-for": "textarea-rows"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "textarea-rows",
      "placeholder": _vm.$t('biblioSegment.addDescription'),
      "rows": "4"
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('biblioSegment.author'),
      "label-for": "input-sm"
    }
  }, [_c('v-select', {
    attrs: {
      "placeholder": _vm.$t('biblioSegment.selectAuthor'),
      "options": _vm.auteursList
    },
    model: {
      value: (_vm.authorId),
      callback: function($$v) {
        _vm.authorId = $$v
      },
      expression: "authorId"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    slot: "no-options"
  }, [_vm._v(_vm._s(_vm.$t('biblioSegment.noOption')))]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-result"
    },
    slot: "no-result"
  }, [_vm._v(_vm._s(_vm.$t('biblioSegment.noResult')))])])], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "input-group-keyword",
      "label": _vm.$t('biblioSegment.Keyword'),
      "label-for": "input-keyword"
    }
  }, [_c('v-select', {
    attrs: {
      "no-drop": "",
      "taggable": "",
      "multiple": "",
      "select-on-key-codes": [188, 13],
      "placeholder": _vm.$t('biblioSegment.addkeyword')
    },
    model: {
      value: (_vm.keyWords),
      callback: function($$v) {
        _vm.keyWords = $$v
      },
      expression: "keyWords"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col')], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "text-right"
  }, [_c('b-button', {
    staticClass: "btn-edit",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": function($event) {
        return _vm.backToList()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.cancel')))]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.routeAdd),
      expression: "!routeAdd"
    }],
    staticClass: "btn-edit",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.updateSegment()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('tooltips.save')) + "\n        ")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.routeAdd),
      expression: "routeAdd"
    }],
    staticClass: "btn-edit",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.NewSegment()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('button.next')) + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-informations-new",
    style: ([{
      marginLeft: _vm.marginLeft
    }]),
    attrs: {
      "id": "list-informations-new"
    }
  }, [(this.$route.name === 'segment' && _vm.slide !== null) ? _c('b-row', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "arrow-panel imgClickAndChange",
    on: {
      "click": _vm.showPanel
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), (_vm.slide) ? _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('panels.infos.name_screen')) + "\n    " + _vm._s(_vm.slide.title) + " | " + _vm._s(_vm.$t('panels.infos.duration_screen')) + "\n    " + _vm._s(_vm._f("FormatTime")(_vm.slide.options.duration)) + "\n    \n    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (this.$route.name !== 'segment' && _vm.segment !== null) ? _c('b-row', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "arrow-panel imgClickAndChange",
    on: {
      "click": _vm.showPanel
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), (_vm.paramsClient.nb_screen_segment !== 1) ? _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('panels.infos.name_segment')) + "\n    " + _vm._s(_vm.segment.title) + " | " + _vm._s(_vm.$t('panels.infos.name_screen')) + _vm._s(_vm.slide.title) + " |\n    " + _vm._s(_vm.$t('panels.infos.duration_segment')) + "\n    " + _vm._s(_vm._f("FormatTime")(_vm.segment.duration)) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.paramsClient.nb_screen_segment === 1) ? _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('panels.infos.name_screen')) + _vm._s(_vm.slide.title) + " |\n    " + _vm._s(_vm.$t('panels.infos.duration_screen')) + "\n    " + _vm._s(_vm.FormatTime) + "\n      ")]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "extend-segment-duration"
    }
  }, [_c('b-modal', {
    ref: "extendSegmentDuration",
    attrs: {
      "id": "modal-extend-segment-duration",
      "noCloseOnBackdrop": true,
      "noCloseOnEsc": true,
      "hide-footer": "",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function() {
        return [_c('h5', [_vm._v("Durée du segment invalide!")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "d-block text-center mb-4"
  }, [_c('h3', [_vm._v("Voulez vous étendre ou couper le segment?")])]), _vm._v(" "), _c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-primary",
      "size": "xl"
    },
    on: {
      "click": _vm.extend
    }
  }, [_vm._v("\n      étendre\n    ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "size": "xl"
    },
    on: {
      "click": _vm.crop
    }
  }, [_vm._v("\n      Couper\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.RouteFromBiblio) ? _c('div', {
    staticClass: "backToBiblio",
    staticStyle: {
      "margin-left": "50px"
    },
    attrs: {
      "id": "backToBiblio"
    },
    on: {
      "click": function($event) {
        return _vm.backToBiblioSegment()
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "100px",
      "height": "30px",
      "viewBox": "0 0 100 30",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', [_c('rect', {
    attrs: {
      "stroke": "#FFFFFF",
      "stroke-width": "1",
      "x": "0.5",
      "y": "0.5",
      "width": "99",
      "height": "29",
      "rx": "6"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(16.000000, 7.000000)",
      "fill": "#FFFFFF",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.1714286,7.71428571 L5.29714286,7.71428571 L7.67314286,5.33828571 C7.87577143,5.13565714 7.97142857,4.89394286 7.97142857,4.62857143 C7.97142857,4.12251429 7.55331429,3.6 6.94285714,3.6 C6.66977143,3.6 6.43165714,3.69925714 6.23314286,3.89828571 L2.14045714,7.99097143 C1.97177143,8.15965714 1.8,8.36794286 1.8,8.74285714 C1.8,9.11777143 1.94348571,9.29828571 2.13222857,9.48702857 L6.23314286,13.5874286 C6.43165714,13.7864571 6.66977143,13.8857143 6.94285714,13.8857143 C7.55382857,13.8857143 7.97142857,13.3632 7.97142857,12.8571429 C7.97142857,12.5917714 7.87577143,12.3500571 7.67314286,12.1474286 L5.29714286,9.77142857 L15.1714286,9.77142857 C15.7392,9.77142857 16.2,9.31062857 16.2,8.74285714 C16.2,8.17508571 15.7392,7.71428571 15.1714286,7.71428571 Z",
      "id": "Path"
    }
  })]), _vm._v(" "), _c('text', {
    attrs: {
      "font-family": "RobotoUep!important",
      "font-size": "13",
      "font-weight": "700",
      "letter-spacing": "-0.336",
      "fill": "#FFFFFF"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "39",
      "y": "20"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.back')))])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel__title_page",
    class: {
      'edit-mode': _vm.isEditMode,
      'back-route': _vm.RouteFromBiblio
    },
    staticStyle: {
      "margin-left": "50px"
    },
    attrs: {
      "id": "panel__title_page"
    }
  }, [(!_vm.isSegment && !_vm.isEditMode) ? _c('div', {
    staticClass: "show-panel"
  }, [_c('span', {
    staticClass: "show-panel__span"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-pencil panel__title_edit",
    on: {
      "click": function($event) {
        return _vm.toggleEditModeTemplate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isEditMode && _vm.isSegment) ? _c('div', {
    staticClass: "show-panel"
  }, [_c('span', {
    staticClass: "show-panel__span"
  }, [_vm._v(_vm._s(_vm.titleSegment))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-pencil panel__title_edit",
    on: {
      "click": function($event) {
        return _vm.toggleEditModeSegment()
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSegment),
      expression: "!isSegment"
    }],
    staticClass: "edit-panel"
  }, [_c('div', {
    staticClass: "save-btn fa fa-save",
    on: {
      "click": function($event) {
        return _vm.updateTemplate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close-btn fa fa-times-circle",
    on: {
      "click": function($event) {
        return _vm.toggleEditModeTemplate(true)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control",
    attrs: {
      "title": _vm.$t('panels.title'),
      "placeholder": _vm.$t('panels.title'),
      "type": "text"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSegment),
      expression: "isSegment"
    }],
    staticClass: "edit-panel"
  }, [_c('div', {
    staticClass: "save-btn fa fa-save",
    on: {
      "click": function($event) {
        return _vm.updateSegment()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close-btn fa fa-times-circle",
    on: {
      "click": function($event) {
        return _vm.toggleEditModeSegment(true)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.titleSegment),
      expression: "titleSegment"
    }],
    staticClass: "form-control",
    attrs: {
      "title": _vm.$t('panels.title'),
      "placeholder": _vm.$t('panels.title'),
      "type": "text"
    },
    domProps: {
      "value": (_vm.titleSegment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.titleSegment = $event.target.value
      }
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-card-wrapper",
    class: {
      'segment-card': _vm.isSegmentCard
    },
    on: {
      "click": _vm.toggleSegment
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSegmentCard && _vm.paramsClient.nb_screen_segment !== 1),
      expression: "isSegmentCard && paramsClient.nb_screen_segment !== 1"
    }],
    staticClass: "number-screen"
  }, [_vm._v("\n    " + _vm._s(_vm.nuberScreen) + "\n  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSegmentCard || _vm.paramsClient.nb_screen_segment === 1),
      expression: "!isSegmentCard || paramsClient.nb_screen_segment === 1"
    }],
    staticClass: "time-screen"
  }, [_vm._v("\n    " + _vm._s(_vm._f("FormatTime")(_vm.duration)) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "parent",
    class: [{
      selected: _vm.isSelected
    }, _vm.typecard]
  }, [_c('div', {
    staticClass: "folder small blue",
    class: _vm.typecard
  }, [_c('div', {
    staticClass: "thumb_page tile",
    class: {
      segment: _vm.segment,
      'module-list': _vm.isModuleList,
    }
  }, [_c('div', {
    staticClass: "slide tile__media",
    class: [{
      'module-list': _vm.isModuleList
    }]
  }, [_c('div', {
    ref: "cardEl",
    staticClass: "containerScreen tile__img",
    class: [{
      'module-list': _vm.isModuleList,
      screen: !_vm.isSegmentCard
    }],
    style: ({
      backgroundImage: _vm.backgroundImage
    }),
    on: {
      "click": function($event) {
        return _vm.$emit('selected')
      }
    }
  }, [(!_vm.isModuleList) ? _c('ul', {
    staticClass: "actions-wrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.checkTarget($event)
      }
    }
  }, [_c('v-popover', {
    staticClass: "more-actions-btn-parent",
    attrs: {
      "offset": "16",
      "container": "#editor",
      "popoverClass": "card-tooltip",
      "placement": "top",
      "default-placement": "top"
    }
  }, [_c('li', {
    staticClass: "fa fa-ellipsis-v item-li li-edit more-actions-btn open-menu-style",
    attrs: {
      "title": _vm.$t('panels.editScreen')
    }
  }), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('custom-panel-card-actions', {
    attrs: {
      "index": _vm.index,
      "is-segment-card": _vm.isSegmentCard,
      "card": _vm.slide,
      "segment": _vm.segment
    },
    on: {
      "selected": function($event) {
        return _vm.$emit('selected')
      },
      "duplicated": function($event) {
        return _vm.$emit('duplicated')
      }
    }
  })], 1)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.paramsClient.nb_screen_segment !== 1) ? _c('div', {
    staticClass: "place-title"
  }, [_vm._v("\n              " + _vm._s(_vm.slide.title) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.paramsClient.nb_screen_segment === 1 && _vm.slide.screens) ? _c('div', {
    staticClass: "place-title"
  }, [_vm._v("\n              " + _vm._s(_vm.slide.screens[0].title) + "\n            ")]) : _vm._e()])])])])])])
},staticRenderFns: []}

/***/ }),
/* 824 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-cards-actions-wrapper"
  }, [(!_vm.isEditMode) ? _c('ul', {
    staticClass: "list-unstyled m-0"
  }, [_c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showEditTitlePanel($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" " + _vm._s(_vm.$t('panels.edit_title')) + "\n    ")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSegmentCard && _vm.paramsClient.nb_screen_segment !== 1),
      expression: "isSegmentCard &&  paramsClient.nb_screen_segment !== 1"
    }, {
      name: "close-popover",
      rawName: "v-close-popover.all",
      modifiers: {
        "all": true
      }
    }],
    class: {
      disabled: _vm.selectedSlides.length >= _vm.permission.nb_screen_segment && _vm.getNbSreenSegment,
    },
    staticStyle: {
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('duplicated')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clone"
  }), _vm._v(" " + _vm._s(_vm.$t('panels.duplicateSegment')) + "\n    ")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSegmentCard || _vm.paramsClient.nb_screen_segment === 1),
      expression: "!isSegmentCard || paramsClient.nb_screen_segment === 1"
    }, {
      name: "close-popover",
      rawName: "v-close-popover.all",
      modifiers: {
        "all": true
      }
    }],
    class: {
      disabled: _vm.selectedSlides.length >= _vm.permission.nb_screen_segment && _vm.getNbSreenSegment,
    },
    staticStyle: {
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('duplicated')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clone"
  }), _vm._v(" " + _vm._s(_vm.$t('panels.duplicateScreen')) + "\n    ")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_transition && (_vm.index > 0 || _vm.startGeneric)),
      expression: "show_transition && (index > 0 || startGeneric)"
    }],
    attrs: {
      "id": "li-show-modal"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addTransition(_vm.card)
      }
    }
  }, [_c('i', {
    staticClass: "icon-transition"
  }), _vm._v(" Transition\n    ")]), _vm._v(" "), (_vm.showBtnDuration) ? _c('li', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('edit_duration_segment_action'),
      expression: "'edit_duration_segment_action'"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showEditDurationPanel($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(_vm._s(_vm.$t('panels.duration')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRemovable),
      expression: "isRemovable"
    }, {
      name: "close-popover",
      rawName: "v-close-popover.all",
      modifiers: {
        "all": true
      }
    }],
    staticClass: "text-danger",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleDelete($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" " + _vm._s(_vm.$t('panels.deleteScreen')) + "\n    ")])]) : _c('div', {
    staticClass: "edit-panel",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "actions-wrapper"
  }, [_c('button', {
    staticClass: "btn btn-link btn-sm cancel-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleEditMode(true)
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-left-alt"
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "close-popover",
      rawName: "v-close-popover.all",
      modifiers: {
        "all": true
      }
    }],
    ref: "closeBtn",
    attrs: {
      "hidden": ""
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link btn-sm cancel-btn",
    on: {
      "click": _vm.closePopover
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode === 'title'),
      expression: "editMode === 'title'"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('panels.edit_title')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "title": _vm.$t('panels.title'),
      "placeholder": _vm.$t('panels.title'),
      "type": "text",
      "maxlength": _vm.getmaxLength
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        return _vm.handleUpdate()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode === 'duration'),
      expression: "editMode === 'duration'"
    }],
    staticClass: "form-group",
    class: {
      'has-error': _vm.hasError
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('panels.duration')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.durationInput),
      expression: "durationInput"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "title": _vm.$t('panels.duration'),
      "placeholder": _vm.$t('panels.duration'),
      "type": "text"
    },
    domProps: {
      "value": (_vm.durationInput)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        return _vm.handleUpdate()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.durationInput = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasError) ? _c('small', {
    staticClass: "text-error"
  }, [_vm._v("Valeur invalide!")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-link btn-sm save-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleUpdate()
      }
    }
  }, [_c('span', {
    staticClass: "icon-save"
  })])])])])])
},staticRenderFns: []}

/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-editor-container"
  }, [_c('tui-image-editor', {
    ref: "tuiImageEditor",
    attrs: {
      "include-ui": _vm.useDefaultUI,
      "options": _vm.options
    },
    on: {
      "addText": _vm.onAddText,
      "objectMoved": _vm.onObjectMoved
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      segment: _vm.route === 'segment'
    },
    style: (_vm.getColorBtn),
    attrs: {
      "id": "editor"
    }
  }, [_c('panel-title-pages'), _vm._v(" "), _c('panel-fit-screen'), _vm._v(" "), _c('panel-wrapper', {
    attrs: {
      "is-edit-segement": _vm.$route.params.type
    }
  }), _vm._v(" "), _c('grapes-wrapper'), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "info-panel"
    }
  }, [_c('br'), _vm._v(" "), _c('image', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "img/logo-emp.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.$route.name !== 'segment' && _vm.$route.name !== 'EditSegment') ? _c('save') : _vm._e(), _vm._v(" "), _c('save-template'), _vm._v(" "), _c('setting-component'), _vm._v(" "), _c('module-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModule || _vm.FromAddSegment),
      expression: "showModule || FromAddSegment"
    }]
  }), _vm._v(" "), _c('add-screen', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddScreen),
      expression: "showAddScreen"
    }]
  }), _vm._v(" "), _c('segment-list'), _vm._v(" "), _c('editor-image-component'), _vm._v(" "), _c('editor-svg-mator-component'), _vm._v(" "), _c('div', {
    staticClass: "test",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "list_videos"
    }
  }, [(_vm.showListVideo) ? _c('list-generic-video', {
    attrs: {
      "genericType": _vm.genericType
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "progress",
    attrs: {
      "id": "progress"
    }
  }, [_c('vue-progress-bar')], 1), _vm._v(" "), _c('informations'), _vm._v(" "), _c('informations-new'), _vm._v(" "), _c('add-generic'), _vm._v(" "), _c('exit-save'), _vm._v(" "), _c('extend-segment-duration')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-panel-label"
  }, [_c('b'), _vm._v(" Aujourd’hui, empreinte.com est le leader français indépendant. Sa clientèle,\n      composée de grands comptes est pérenne (100% de réabonnement). Depuis 2015 empreinte a connu\n      une croissance de +60%. En 2017, la société reçoit une aide BPI innovation de 100 K€ et\n      réalise 1 M€ CA avec 575 K€ de fonds propres. En 2018 elle obtient la note H3 de la Banque\n      de France.\n\n      "), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "info-erreur"
    }
  }, [_c('div', {
    staticClass: "info-panel-label"
  }, [_c('b'), _vm._v(" distributes a complete line of video solution:\n\n      "), _c('br'), _c('br')])])
}]}

/***/ }),
/* 827 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden setting-component",
    attrs: {
      "id": "setting-component"
    }
  }, [_c('dialog-drag', {
    staticClass: "dialog-setting",
    attrs: {
      "id": "dialog-setting",
      "title": _vm.$t('modal.setting.title'),
      "options": _vm.settingModalPos
    }
  }, [_c('ul', {
    staticClass: "cards dialog-setting-cards"
  }, [_c('li', {
    staticClass: "cards__item dialog-setting-cards__item"
  }, [_c('div', {
    staticClass: "card dialog-setting-card",
    on: {
      "click": _vm.openLayers
    }
  }, [_c('div', {
    staticClass: "card__image card__image--layers dialog-setting-card__image dialog-setting-card__image--layers"
  }), _vm._v(" "), _c('div', {
    staticClass: "card__content dialog-setting-card__content"
  }, [_c('div', {
    staticClass: "card__title dialog-setting-card__title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('modal.setting.layers')) + "\n              ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.openedLayers),
      expression: "!openedLayers"
    }],
    staticClass: "card__arrow dialog-setting-card__arrow"
  }, [_c('i', {
    staticClass: "gjs-caret-icon fa fa-caret-down"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openedLayers),
      expression: "openedLayers"
    }],
    staticClass: "card__arrow dialog-setting-card__arrow"
  }, [_c('i', {
    staticClass: "gjs-caret-icon fa fa-caret-up"
  })])])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openedLayers),
      expression: "openedLayers"
    }],
    staticClass: "cards dialog-layers-cards",
    attrs: {
      "id": "dialog-layers"
    }
  }, [_c('li', {
    staticClass: "cards__item dialog-layers-cards__item",
    on: {
      "click": function($event) {
        return _vm.updatePositionLayers('first')
      }
    }
  }, [_c('div', {
    staticClass: "card dialog-layers-card"
  }, [_c('div', {
    staticClass: "card__image card__image--fence dialog-layers-card__image dialog-layers-card__image--fence"
  }), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "card__title "
  }, [_vm._v(_vm._s(_vm.$t('labels.Foreground')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "cards__item",
    on: {
      "click": function($event) {
        return _vm.updatePositionLayers('move')
      }
    }
  }, [_c('div', {
    staticClass: "card dialog-layers-card"
  }, [_c('div', {
    staticClass: "card__image card__image--river dialog-layers-card__image dialog-layers-card__image--river"
  }), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.$t('labels.advance_more')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "cards__item",
    on: {
      "click": function($event) {
        return _vm.updatePositionLayers('last')
      }
    }
  }, [_c('div', {
    staticClass: "card dialog-layers-card"
  }, [_c('div', {
    staticClass: "card__image card__image--record dialog-layers-card__image dialog-layers-card__image--record"
  }), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.$t('labels.background')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "cards__item",
    on: {
      "click": function($event) {
        return _vm.updatePositionLayers('back')
      }
    }
  }, [_c('div', {
    staticClass: "card dialog-layers-card"
  }, [_c('div', {
    staticClass: "card__image card__image--flowers dialog-layers-card__image dialog-layers-card__image--flowers"
  }), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.$t('labels.Recede_less')))])])])])])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('animate_components_action'),
      expression: "'animate_components_action'"
    }],
    staticClass: "cards__item dialog-setting-cards__item"
  }, [_c('div', {
    staticClass: "card dialog-setting-card",
    on: {
      "click": _vm.openAnimation
    }
  }, [_c('div', {
    staticClass: "card__image card__image--effects dialog-setting-card__image dialog-setting-card__image--effects"
  }), _vm._v(" "), _c('div', {
    staticClass: "card__content dialog-setting-card__content"
  }, [_c('div', {
    staticClass: "card__title dialog-setting-card__title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('modal.setting.effects')) + "\n              ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.openedAnimation),
      expression: "!openedAnimation"
    }],
    staticClass: "card__arrow dialog-setting-card__arrow"
  }, [_c('i', {
    staticClass: "gjs-caret-icon fa fa-caret-down"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openedAnimation),
      expression: "openedAnimation"
    }],
    staticClass: "card__arrow dialog-setting-card__arrow"
  }, [_c('i', {
    staticClass: "gjs-caret-icon fa fa-caret-up"
  })])])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openedAnimation),
      expression: "openedAnimation"
    }],
    staticClass: "cards dialog-animation-cards",
    attrs: {
      "id": "dialog-animation"
    }
  }, [_c('li', {
    staticClass: "cards__item",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "card dialog-animation-card",
    class: {
      selected: _vm.currentAnimation === 'none'
    },
    staticStyle: {
      "padding": "38px"
    },
    on: {
      "click": function($event) {
        return _vm.updateClassElement('none')
      }
    }
  }, [_c('div', {
    staticClass: "card__image  dialog-animation-card__image "
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('modal.setting.animation.without_animation')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "cards__item"
  }, [_c('div', {
    staticClass: "card dialog-animation-card",
    class: {
      selected: _vm.currentAnimation === 'grow'
    },
    on: {
      "click": function($event) {
        return _vm.updateClassElement('grow')
      }
    }
  }, [_c('div', {
    staticClass: "card__image  dialog-animation-card__image"
  }, [_c('svg', {
    staticClass: "animations",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "130px",
      "height": "100px",
      "viewBox": "0 0 130 100",
      "enable-background": "new 0 0 130 100",
      "xml:space": "preserve"
    }
  }, [_c('linearGradient', {
    attrs: {
      "id": "SVGID_1_",
      "gradientUnits": "userSpaceOnUse",
      "x1": "50",
      "y1": "50",
      "x2": "5.3714",
      "y2": "50"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#E7EAED"
    },
    attrs: {
      "offset": "0.1603"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#2196F3"
    },
    attrs: {
      "offset": "0.5137"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#ACD1EF"
    },
    attrs: {
      "offset": "0.7115"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#C1DAEE"
    },
    attrs: {
      "offset": "0.7853"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#CEDFEE"
    },
    attrs: {
      "offset": "0.8205"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#E7EAED"
    },
    attrs: {
      "offset": "0.8654"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#SVGID_1_)",
      "d": "M114.203,5.367H89.5h-49H15.797c-5.555,0-10.058,4.503-10.058,10.058v69.15\n\tc0,5.555,4.503,10.058,10.058,10.058H40.5h49h24.703c5.555,0,10.058-4.503,10.058-10.058v-69.15\n\tC124.261,9.87,119.758,5.367,114.203,5.367z"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "split-right",
    attrs: {
      "fill": "#01527F"
    }
  }, [_c('path', {
    attrs: {
      "d": "M114.239 49.999c0-.194-.075-.365-.224-.515l-10.438-10.438c-.15-.15-.321-.224-.515-.224s-.365.076-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515L110.229 50l-8.804 8.804c-.15.15-.224.321-.224.515s.075.367.224.515l1.121 1.121c.15.15.321.224.515.224s.365-.075.515-.224l10.438-10.439c.15-.153.225-.323.225-.517z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M106.49 49.999c0-.194-.075-.365-.224-.515L95.828 39.045c-.15-.15-.321-.224-.515-.224s-.365.076-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515L102.48 50l-8.804 8.804c-.15.15-.224.321-.224.515s.075.367.224.515l1.121 1.121c.15.15.321.224.515.224s.365-.075.515-.224l10.438-10.439c.15-.153.225-.323.225-.517z",
      "opacity": ".9"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M97.774 49.999c0-.194-.075-.365-.224-.515L87.112 39.046c-.15-.15-.321-.224-.515-.224s-.365.076-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515L93.764 50l-8.804 8.804c-.15.15-.224.321-.224.515s.075.367.224.515l1.121 1.121c.15.15.321.224.515.224s.365-.075.515-.224l10.438-10.439c.15-.153.225-.323.225-.517z",
      "opacity": ".6"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "split-left",
    attrs: {
      "fill": "#01527F"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20.256 50.001c0 .194.075.365.224.515l10.438 10.438c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515L24.266 50l8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L20.481 49.484c-.15.153-.225.323-.225.517z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M28.005 50.001c0 .194.075.365.224.515l10.438 10.439c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515L32.015 50l8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L28.23 49.484c-.15.153-.225.323-.225.517z",
      "opacity": ".9"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36.721 50.001c0 .194.075.365.224.515l10.438 10.438c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515L40.731 50l8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L36.946 49.484c-.15.153-.225.323-.225.517z",
      "opacity": ".6"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.$t('modal.setting.animation.grow')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "cards__item"
  }, [_c('div', {
    staticClass: "card dialog-animation-card",
    class: {
      selected: _vm.currentAnimation === 'fade-in'
    },
    on: {
      "click": function($event) {
        return _vm.updateClassElement('fade-in')
      }
    }
  }, [_c('div', {
    staticClass: "card__image  dialog-animation-card__image "
  }, [_c('svg', {
    staticClass: "animations",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "x": "0px",
      "y": "0px",
      "width": "130px",
      "height": "100px",
      "viewBox": "0 0 130 100",
      "enable-background": "new 0 0 130 100",
      "xml:space": "preserve"
    }
  }, [_c('linearGradient', {
    attrs: {
      "id": "a",
      "x1": "-843.86",
      "x2": "-735.14",
      "y1": "-1765.76",
      "y2": "-1765.76",
      "gradientTransform": "translate(869.97 1815.33)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": ".15",
      "stop-color": "#ededed"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".28",
      "stop-color": "#eaeced"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".38",
      "stop-color": "#e0e8ed"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".47",
      "stop-color": "#d0e1ee"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".55",
      "stop-color": "#b9d7ef"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".63",
      "stop-color": "#9ccbf0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".65",
      "stop-color": "#95c8f0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".71",
      "stop-color": "#92c7f0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".76",
      "stop-color": "#8ac3f0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".79",
      "stop-color": "#7bbdf1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".82",
      "stop-color": "#65b3f1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".85",
      "stop-color": "#4aa8f2"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".86",
      "stop-color": "#42a4f2"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".98",
      "stop-color": "#2196f3"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#a)",
      "d": "M124.75 84.1c0 5.54-4.5 10.04-10.04 10.04H16.44c-5.54 0-10.04-4.5-10.04-10.04V15.04C6.4 9.5 10.9 5 16.44 5h98.27c5.55 0 10.04 4.5 10.04 10.04V84.1z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "wipe",
    attrs: {
      "fill": "#01527F",
      "d": "M57.915 49.593c0 .194.075.365.224.515l10.438 10.438c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515l-8.803-8.803 8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L58.14 49.076c-.15.153-.225.323-.225.517z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "wipe",
    attrs: {
      "fill": "#01527F",
      "d": "M65.664 49.593c0 .194.075.365.224.515l10.438 10.439c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515l-8.803-8.804 8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L65.889 49.076c-.15.153-.225.323-.225.517z",
      "opacity": ".9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "wipe",
    attrs: {
      "fill": "#01527F",
      "d": "M74.38 49.593c0 .194.075.365.224.515l10.438 10.438c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515l-8.803-8.803 8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L74.605 49.076c-.15.153-.225.323-.225.517z",
      "opacity": ".6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.$t('modal.setting.animation.fade-in')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "cards__item"
  }, [_c('div', {
    staticClass: "card dialog-animation-card",
    class: {
      selected: _vm.currentAnimation === 'fade-up'
    },
    on: {
      "click": function($event) {
        return _vm.updateClassElement('fade-up')
      }
    }
  }, [_c('div', {
    staticClass: "card__image  dialog-animation-card__image  "
  }, [_c('svg', {
    staticClass: "animations",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "x": "0px",
      "y": "0px",
      "width": "130px",
      "height": "100px",
      "viewBox": "0 0 130 100",
      "enable-background": "new 0 0 130 100",
      "xml:space": "preserve"
    }
  }, [_c('linearGradient', {
    attrs: {
      "id": "SVGID_1_",
      "gradientUnits": "userSpaceOnUse",
      "x1": "-5737.2393",
      "y1": "-2156.1602",
      "x2": "-5737.2393",
      "y2": "-2245.2402",
      "gradientTransform": "matrix(1 0 0 1 5802.2344 2236.4221)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#EDEDED"
    },
    attrs: {
      "offset": "0.3976"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#E9EBED"
    },
    attrs: {
      "offset": "0.4897"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#DFE7ED"
    },
    attrs: {
      "offset": "0.5724"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#CCDFEE"
    },
    attrs: {
      "offset": "0.6514"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#B2D4EF"
    },
    attrs: {
      "offset": "0.7282"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#91C6F0"
    },
    attrs: {
      "offset": "0.8034"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#68B4F1"
    },
    attrs: {
      "offset": "0.8774"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#39A0F2"
    },
    attrs: {
      "offset": "0.9491"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#2196F3"
    },
    attrs: {
      "offset": "0.9817"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#SVGID_1_)",
      "d": "M124.132,85.057c0,5.543-4.494,10.037-10.037,10.037H15.895c-5.544,0-10.037-4.494-10.037-10.037\n\tl0-69.006c0-5.543,4.494-10.037,10.037-10.037h98.201c5.543,0,10.037,4.494,10.037,10.037V85.057L124.132,85.057z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "to-the-top",
    attrs: {
      "id": "_x3C_Path3_x3E__1_",
      "fill": "#01527F",
      "d": "M64.999,13.917c-0.174,0-0.328,0.067-0.463,0.201l-9.377,9.377\n\tc-0.135,0.135-0.201,0.288-0.201,0.463c0,0.174,0.068,0.328,0.201,0.463l1.007,1.007c0.135,0.135,0.288,0.201,0.463,0.201\n\tc0.174,0,0.328-0.067,0.463-0.201L65,17.519l7.909,7.909c0.135,0.135,0.288,0.201,0.463,0.201c0.174,0,0.33-0.067,0.463-0.201\n\tl1.007-1.007c0.135-0.135,0.201-0.288,0.201-0.463c0-0.174-0.067-0.328-0.201-0.463l-9.377-9.377\n\tC65.327,13.984,65.173,13.917,64.999,13.917z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "to-the-top",
    attrs: {
      "id": "_x3C_Path2_x3E_",
      "opacity": "0.9",
      "fill": "#01527F",
      "enable-background": "new    ",
      "d": "M64.999,20.878\n\tc-0.174,0-0.328,0.067-0.463,0.201l-9.377,9.377c-0.135,0.135-0.201,0.288-0.201,0.463c0,0.174,0.068,0.328,0.201,0.463l1.007,1.007\n\tc0.135,0.135,0.288,0.201,0.463,0.201c0.174,0,0.328-0.067,0.463-0.201L65,24.48l7.909,7.909c0.135,0.135,0.288,0.201,0.463,0.201\n\tc0.174,0,0.33-0.067,0.463-0.201l1.007-1.007c0.135-0.135,0.201-0.288,0.201-0.463c0-0.174-0.067-0.328-0.201-0.463l-9.377-9.377\n\tC65.327,20.945,65.173,20.878,64.999,20.878z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "to-the-top",
    attrs: {
      "id": "_x3C_Path1_x3E__2_",
      "opacity": "0.6",
      "fill": "#01527F",
      "enable-background": "new    ",
      "d": "M64.999,28.708\n\tc-0.174,0-0.328,0.067-0.463,0.201l-9.377,9.377c-0.135,0.135-0.201,0.288-0.201,0.463c0,0.174,0.068,0.328,0.201,0.463l1.007,1.007\n\tc0.135,0.135,0.288,0.201,0.463,0.201c0.174,0,0.328-0.067,0.463-0.201L65,32.31l7.909,7.909c0.135,0.135,0.288,0.201,0.463,0.201\n\tc0.174,0,0.33-0.067,0.463-0.201l1.007-1.007c0.135-0.135,0.201-0.288,0.201-0.463c0-0.174-0.067-0.328-0.201-0.463l-9.377-9.377\n\tC65.327,28.775,65.173,28.708,64.999,28.708z"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "SVGID_2_",
      "gradientUnits": "userSpaceOnUse",
      "x1": "-2475.406",
      "y1": "-1137.0306",
      "x2": "-2475.406",
      "y2": "-1184.0306",
      "gradientTransform": "matrix(-1 0 0 1 -2410.4109 1232.1246)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#418AC6"
    },
    attrs: {
      "offset": "0.0092"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#3190DD"
    },
    attrs: {
      "offset": "0.3523"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#2594ED"
    },
    attrs: {
      "offset": "0.7102"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#2196F3"
    },
    attrs: {
      "offset": "0.9817"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#SVGID_2_)",
      "d": "M5.968,86.093v-27.41c0-5.55,4.614-10.589,10.154-10.589h36.846v6.199\n\tc0,3.13,2.314,4.801,5.444,4.801h13.36c3.13,0,5.196-1.671,5.196-4.801v-6.199h37.094c5.54,0,9.906,5.039,9.906,10.589v27.411h0.054\n\tc-0.6,5-4.83,9-9.96,9h-97.94c-5.13,0-9.36-4-9.96-9L5.968,86.093L5.968,86.093z"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.$t('modal.setting.animation.fade-up')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "cards__item"
  }, [_c('div', {
    staticClass: "card dialog-animation-card",
    class: {
      selected: _vm.currentAnimation === 'fade-down'
    },
    on: {
      "click": function($event) {
        return _vm.updateClassElement('fade-down')
      }
    }
  }, [_c('div', {
    staticClass: "card__image  dialog-animation-card__image "
  }, [_c('svg', {
    staticClass: "animations",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "130px",
      "height": "100px",
      "viewBox": "0 0 130 100",
      "enable-background": "new 0 0 130 100",
      "xml:space": "preserve"
    }
  }, [_c('linearGradient', {
    attrs: {
      "id": "a",
      "x1": "-1887.4",
      "x2": "-1887.4",
      "y1": "1251.16",
      "y2": "1340.24",
      "gradientTransform": "matrix(-1 0 0 1 -1822.43 -1230.31)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#ededed"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".49",
      "stop-color": "#e9ebed"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".57",
      "stop-color": "#dfe7ed"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".65",
      "stop-color": "#ccdfee"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".73",
      "stop-color": "#b2d4ef"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#91c6f0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".88",
      "stop-color": "#68b4f1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".95",
      "stop-color": "#39a0f2"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".98",
      "stop-color": "#2196f3"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#a)",
      "d": "M5.83 16.05c0-5.54 4.5-10.04 10.04-10.04h98.2c5.54 0 10.03 4.5 10.03 10.04v69c0 5.55-4.49 10.04-10.03 10.04h-98.2c-5.55 0-10.04-4.49-10.04-10.03v-69z"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "b",
      "x1": "64.87",
      "x2": "64.87",
      "y1": "6.32",
      "y2": "53.32",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": ".01",
      "stop-color": "#418ac6"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".35",
      "stop-color": "#3190dd"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".71",
      "stop-color": "#2594ed"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".98",
      "stop-color": "#2196f3"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#b)",
      "d": "M123.8 15.31V42.2c0 5.55-4.29 11.13-9.83 11.13H76.81v-6.74c0-3.13-2-4.26-5.13-4.26H58.32c-3.13 0-5.51 1.13-5.51 4.26v6.74H16.03c-5.54 0-10.22-5.58-10.22-11.13V15.31h.26c.6-5 4.83-9 9.96-9h97.94c5.13 0 9.36 4 9.96 9h-.12z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "down",
    attrs: {
      "fill": "#01527F",
      "d": "M65.002 86.191c.194 0 .365-.075.515-.224l10.438-10.438c.15-.15.224-.321.224-.515s-.076-.365-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224l-8.803 8.803-8.804-8.804c-.15-.15-.321-.224-.515-.224s-.367.075-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515l10.438 10.438c.153.15.324.225.518.225z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "down",
    attrs: {
      "fill": "#01527F",
      "d": "M65.001 78.442c.194 0 .365-.075.515-.224L75.955 67.78c.15-.15.224-.321.224-.515s-.076-.365-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L65 74.432l-8.804-8.804c-.15-.15-.321-.224-.515-.224s-.367.075-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515l10.438 10.438c.153.15.324.225.518.225z",
      "opacity": ".9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "down",
    attrs: {
      "fill": "#01527F",
      "d": "M65.002 69.726c.194 0 .365-.075.515-.224l10.438-10.438c.15-.15.224-.321.224-.515s-.076-.365-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224l-8.803 8.803-8.804-8.804c-.15-.15-.321-.224-.515-.224s-.367.075-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515l10.438 10.438c.153.15.324.225.518.225z",
      "opacity": ".6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.$t('modal.setting.animation.fade-down')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "cards__item"
  }, [_c('div', {
    staticClass: "card dialog-animation-card",
    class: {
      selected: _vm.currentAnimation === 'fade-left'
    },
    on: {
      "click": function($event) {
        return _vm.updateClassElement('fade-left')
      }
    }
  }, [_c('div', {
    staticClass: "card__image  dialog-animation-card__image "
  }, [_c('svg', {
    staticClass: "animations",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "x": "0px",
      "y": "0px",
      "width": "130px",
      "height": "100px",
      "viewBox": "0 0 130 100",
      "enable-background": "new 0 0 130 100",
      "xml:space": "preserve"
    }
  }, [_c('linearGradient', {
    attrs: {
      "id": "SVGID_1_",
      "gradientUnits": "userSpaceOnUse",
      "x1": "1093.7883",
      "y1": "1849.1655",
      "x2": "1212.7463",
      "y2": "1849.1655",
      "gradientTransform": "matrix(-1 0 0 1 1196.7474 -1800.0706)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#EDEDED"
    },
    attrs: {
      "offset": "0.1476"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#EAECED"
    },
    attrs: {
      "offset": "0.2811"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#E0E8ED"
    },
    attrs: {
      "offset": "0.3813"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#D0E1EE"
    },
    attrs: {
      "offset": "0.4706"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#B9D7EF"
    },
    attrs: {
      "offset": "0.5536"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#9CCBF0"
    },
    attrs: {
      "offset": "0.6315"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#95C8F0"
    },
    attrs: {
      "offset": "0.6483"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#92C7F0"
    },
    attrs: {
      "offset": "0.7129"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#8AC3F0"
    },
    attrs: {
      "offset": "0.7553"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#7BBDF1"
    },
    attrs: {
      "offset": "0.7911"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#65B3F1"
    },
    attrs: {
      "offset": "0.8235"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#4AA8F2"
    },
    attrs: {
      "offset": "0.8531"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#42A4F2"
    },
    attrs: {
      "offset": "0.8609"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#2196F3"
    },
    attrs: {
      "offset": "0.9817"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#SVGID_1_)",
      "d": "M3.808,14.392c0-5.576,4.52-10.095,10.095-10.095h98.768c5.576,0,10.095,4.52,10.095,10.095v69.405\n\tc0,5.575-4.52,10.095-10.095,10.095H13.903c-5.576,0-10.095-4.52-10.095-10.095V14.392L3.808,14.392z"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "SVGID_2_",
      "gradientUnits": "userSpaceOnUse",
      "x1": "-1766.7854",
      "y1": "-1182.8807",
      "x2": "-1706.7854",
      "y2": "-1182.8807",
      "gradientTransform": "matrix(1 0 0 -1 1829.9474 -1133.5135)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#418AC6"
    },
    attrs: {
      "offset": "0.0092"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#3190DD"
    },
    attrs: {
      "offset": "0.3523"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#2594ED"
    },
    attrs: {
      "offset": "0.7102"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#2196F3"
    },
    attrs: {
      "offset": "0.9817"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#SVGID_2_)",
      "d": "M123.162,14.431v70.033c0,4.895-3.669,8.831-8.257,9.815c-0.691,0.152-1.636,0.079-2.372,0.079H72.58\n\tc-5.322,0-8.418-3.798-9.418-9.024V61.358h5.185c3.184,0,6.815-1.708,6.815-4.895V42.779c0-3.187-3.631-6.421-6.815-6.421h-5.185\n\tV13.561c1-5.226,4.096-9.203,9.42-9.203h39.95c0.737,0,1.678,0.017,2.37,0.169C119.49,5.51,123.162,9.533,123.162,14.431z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "to-the-left",
    attrs: {
      "fill": "#01527F",
      "d": "M29.911 49.093c0 .194.075.365.224.515l10.438 10.438c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515l-8.803-8.803 8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L30.136 48.576c-.15.153-.225.323-.225.517z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "to-the-left",
    attrs: {
      "fill": "#01527F",
      "d": "M37.66 49.093c0 .194.075.365.224.515l10.438 10.439c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515l-8.803-8.804 8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L37.885 48.576c-.15.153-.225.323-.225.517z",
      "opacity": ".9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "to-the-left",
    attrs: {
      "fill": "#01527F",
      "d": "M46.376 49.093c0 .194.075.365.224.515l10.438 10.438c.15.15.321.224.515.224s.365-.076.515-.224l1.121-1.121c.15-.15.224-.321.224-.515s-.075-.365-.224-.515l-8.803-8.803 8.804-8.804c.15-.15.224-.321.224-.515s-.075-.367-.224-.515l-1.121-1.121c-.15-.15-.321-.224-.515-.224s-.365.075-.515.224L46.601 48.576c-.15.153-.225.323-.225.517z",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "SVGID_3_",
      "gradientUnits": "userSpaceOnUse",
      "x1": "-45.826",
      "y1": "74.554",
      "x2": "-45.826",
      "y2": "74.554",
      "gradientTransform": "matrix(-1 0 0 1 67.93 15.2735)"
    }
  }, [_c('stop', {
    staticStyle: {
      "stop-color": "#418AC6"
    },
    attrs: {
      "offset": "0.0092"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#3190DD"
    },
    attrs: {
      "offset": "0.3523"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#2594ED"
    },
    attrs: {
      "offset": "0.7102"
    }
  }), _vm._v(" "), _c('stop', {
    staticStyle: {
      "stop-color": "#2196F3"
    },
    attrs: {
      "offset": "0.9817"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#SVGID_3_)",
      "d": "M113.756,89.827"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.$t('modal.setting.animation.fade-left')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "cards__item"
  }, [_c('div', {
    staticClass: "card dialog-animation-card",
    class: {
      selected: _vm.currentAnimation === 'fade-right'
    },
    on: {
      "click": function($event) {
        return _vm.updateClassElement('fade-right')
      }
    }
  }, [_c('div', {
    staticClass: "card__image  dialog-animation-card__image "
  }, [_c('svg', {
    staticClass: "animations",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "x": "0px",
      "y": "0px",
      "width": "130px",
      "height": "100px",
      "viewBox": "0 0 130 100",
      "enable-background": "new 0 0 130 100",
      "xml:space": "preserve"
    }
  }, [_c('linearGradient', {
    attrs: {
      "id": "a",
      "x1": "1152.83",
      "x2": "1271.79",
      "y1": "-1765.77",
      "y2": "-1765.77",
      "gradientTransform": "translate(-1128.82 1815.34)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": ".15",
      "stop-color": "#ededed"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".28",
      "stop-color": "#eaeced"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".38",
      "stop-color": "#e0e8ed"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".47",
      "stop-color": "#d0e1ee"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".55",
      "stop-color": "#b9d7ef"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".63",
      "stop-color": "#9ccbf0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".65",
      "stop-color": "#95c8f0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".71",
      "stop-color": "#92c7f0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".76",
      "stop-color": "#8ac3f0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".79",
      "stop-color": "#7bbdf1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".82",
      "stop-color": "#65b3f1"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".85",
      "stop-color": "#4aa8f2"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".86",
      "stop-color": "#42a4f2"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".98",
      "stop-color": "#2196f3"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#a)",
      "d": "M123.16 84.28a10.1 10.1 0 0 1-10.1 10.1H14.3a10.1 10.1 0 0 1-10.1-10.1v-69.4a10.1 10.1 0 0 1 10.1-10.1h98.77a10.1 10.1 0 0 1 10.1 10.1v69.4z"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "b",
      "x1": "-996.83",
      "x2": "-936.83",
      "y1": "1760.48",
      "y2": "1760.48",
      "gradientTransform": "rotate(180 -466.5 904.9)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": ".01",
      "stop-color": "#418ac6"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".35",
      "stop-color": "#3190dd"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".71",
      "stop-color": "#2594ed"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".98",
      "stop-color": "#2196f3"
    }
  })], 1), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#b)",
      "d": "M3.8 84.24V14.21c0-4.9 3.68-8.83 8.27-9.82.69-.15 1.63-.07 2.37-.07h39.95c5.32 0 8.42 3.8 9.42 9.02v23.98h-5.19c-3.18 0-6.81 1.7-6.81 4.89v13.68c0 3.2 3.63 6.42 6.81 6.42h5.19v22.8c-1 5.23-4.1 9.2-9.42 9.2H14.44c-.74 0-1.68-.01-2.37-.16-4.59-.99-8.26-5.01-8.26-9.9z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "to-the-right",
    attrs: {
      "fill": "#01527F",
      "d": "M97.705 49.549c0-.194-.075-.365-.224-.515L87.043 38.596c-.15-.15-.321-.224-.515-.224s-.365.076-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515l8.803 8.803-8.804 8.804c-.15.15-.224.321-.224.515s.075.367.224.515l1.121 1.121c.15.15.321.224.515.224s.365-.075.515-.224L97.48 50.066c.15-.153.225-.323.225-.517z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "to-the-right",
    attrs: {
      "fill": "#01527F",
      "d": "M89.956 49.549c0-.194-.075-.365-.224-.515L79.294 38.595c-.15-.15-.321-.224-.515-.224s-.365.076-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515l8.803 8.804-8.804 8.804c-.15.15-.224.321-.224.515s.075.367.224.515l1.121 1.121c.15.15.321.224.515.224s.365-.075.515-.224l10.438-10.439c.15-.153.225-.323.225-.517z",
      "opacity": ".9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "to-the-right",
    attrs: {
      "fill": "#01527F",
      "d": "M81.24 49.549c0-.194-.075-.365-.224-.515L70.578 38.596c-.15-.15-.321-.224-.515-.224s-.365.076-.515.224l-1.121 1.121c-.15.15-.224.321-.224.515s.075.365.224.515l8.803 8.803-8.804 8.804c-.15.15-.224.321-.224.515s.075.367.224.515l1.121 1.121c.15.15.321.224.515.224s.365-.075.515-.224l10.438-10.439c.15-.153.225-.323.225-.517z",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "c",
      "x1": "13.21",
      "x2": "13.21",
      "y1": "8.85",
      "y2": "8.85",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": ".01",
      "stop-color": "#418ac6"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".35",
      "stop-color": "#3190dd"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".71",
      "stop-color": "#2594ed"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".98",
      "stop-color": "#2196f3"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.$t('modal.setting.animation.fade-right')))])])])])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openedAnimation),
      expression: "openedAnimation"
    }],
    staticClass: "cards dialog-animation-duration-cards",
    attrs: {
      "id": "dialog-animation-duration"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delayValue),
      expression: "delayValue"
    }],
    staticClass: "form-group delay-element",
    attrs: {
      "id": "delay-element",
      "placeholder": _vm.$t('modal.setting.delay')
    },
    domProps: {
      "value": (_vm.delayValue)
    },
    on: {
      "change": function($event) {
        return _vm.setDelayElement($event)
      },
      "focus": function($event) {
        return _vm.toggleModalDraggable('false')
      },
      "blur": function($event) {
        return _vm.toggleModalDraggable('true')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delayValue = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openedAnimation),
      expression: "openedAnimation"
    }],
    staticClass: "cards dialog-text-animation-cards",
    attrs: {
      "id": "dialog-text-animation"
    }
  }, [(_vm.isComponentText) ? _c('li', {
    staticClass: "cards__item dialog-text-animation-cards__item"
  }, [_c('div', {
    staticClass: "card dialog-text-animation-card",
    class: {
      selected: _vm.currentAnimation === 'strike'
    },
    on: {
      "click": function($event) {
        return _vm.updateClassElement('strike')
      }
    }
  }, [_c('div', {
    staticClass: "card__text-animations  dialog-text-animation-card__image dialog-text-animation-card__scale"
  }, [_c('div', {
    staticClass: "text-animation-preview",
    attrs: {
      "id": "animation-strike"
    }
  }, [_c('span', {
    staticClass: "text-animation-preview__sample text-animation-preview__sample--strike"
  }, [_vm._v("Abc")])])]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.$t('modal.setting.animation.strike')))])])])]) : _vm._e(), _vm._v(" "), (_vm.isComponentText) ? _c('li', {
    staticClass: "cards__item dialog-text-animation-cards__item"
  }, [_c('div', {
    staticClass: "card dialog-text-animation-card",
    class: {
      selected: _vm.currentAnimation === 'reveal-text'
    },
    on: {
      "click": function($event) {
        return _vm.updateClassElement('reveal-text')
      }
    }
  }, [_c('div', {
    staticClass: "card__text-animations  dialog-text-animation-card__image dialog-text-animation-card__scale"
  }, [_c('div', {
    staticClass: "text-animation-preview",
    attrs: {
      "id": "animation-reveal-text"
    }
  }, [_c('span', {
    staticClass: "text-animation-preview__sample text-animation-preview__sample--reveal"
  }, [_vm._v("Abc")])])]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.$t('modal.setting.animation.reveal-text')))])])])]) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "cards__item dialog-setting-cards__item"
  }, [_c('div', {
    staticClass: "card dialog-setting-card",
    on: {
      "click": _vm.openOpacity
    }
  }, [_c('div', {
    staticClass: "card__image card__image--opacity dialog-setting-card__image dialog-setting-card__image--opacity"
  }), _vm._v(" "), _c('div', {
    staticClass: "card__content dialog-setting-card__content"
  }, [_c('div', {
    staticClass: "card__title dialog-setting-card__title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('modal.setting.opacity')) + "\n              ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.openedOpacity),
      expression: "!openedOpacity"
    }],
    staticClass: "card__arrow dialog-setting-card__arrow"
  }, [_c('i', {
    staticClass: "gjs-caret-icon fa fa-caret-down"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openedOpacity),
      expression: "openedOpacity"
    }],
    staticClass: "card__arrow dialog-setting-card__arrow"
  }, [_c('i', {
    staticClass: "gjs-caret-icon fa fa-caret-up"
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openedOpacity),
      expression: "openedOpacity"
    }],
    staticClass: "opacity-container",
    attrs: {
      "id": "dialog-opacity",
      "title": _vm.$t('modal.setting.opacity')
    }
  }, [_c('div', {
    staticClass: "opacity-container__range"
  }, [_c('range-slider', {
    staticClass: "slider",
    attrs: {
      "min": "0",
      "max": "100",
      "step": "1"
    },
    on: {
      "input": function($event) {
        return _vm.changeOpacity($event)
      },
      "change": _vm.displayOverlay
    },
    model: {
      value: (_vm.sliderValue),
      callback: function($$v) {
        _vm.sliderValue = $$v
      },
      expression: "sliderValue"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider-value"
  }, [_vm._v(_vm._s(_vm.sliderValue) + "%")])], 1)])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "segment-panel-pages-container"
  }, [_c('div', {
    staticClass: "custom-button-navigation--left",
    on: {
      "click": function($event) {
        return _vm.dragSlide($event, -1)
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "transform": "rotate(180deg)"
    },
    attrs: {
      "viewBox": "0 0 32 32",
      "width": "20px",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "#939ea7"
    }
  }, [_c('path', {
    attrs: {
      "d": "M28.41,13.59l-10-10a2,2,0,0,0-2.82,2.82L24.17,15l-8.58,8.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,28.41,13.59Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.41,13.59l-10-10A2,2,0,0,0,3.59,6.41L12.17,15,3.59,23.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,16.41,13.59Z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "segment-panel row",
    attrs: {
      "id": "div-draggable-new"
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "ps",
    staticClass: "scroll-area",
    attrs: {
      "id": "ps-slide-wrapper-new",
      "use-both-wheel-axes": true
    },
    on: {
      "ps-scroll-x": _vm.removeSmoothing,
      "ps-scroll-y": _vm.removeSmoothing
    }
  }, [_c('div', {
    staticClass: "row__inner",
    on: {
      "mousewheel": _vm.scrollHorizontally
    }
  }, [_c('draggable', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "id": "draggable-wrapper-new",
      "move": _vm.dragSlide
    },
    on: {
      "end": _vm.reorder,
      "start": _vm.getList
    },
    model: {
      value: (_vm.list),
      callback: function($$v) {
        _vm.list = $$v
      },
      expression: "list"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "list-new-segment"
    }
  }, _vm._l((_vm.all), function(slide, index) {
    return _c('div', {
      key: 'list-new-segment' + index,
      staticClass: "card-wrapper",
      attrs: {
        "data-uid": slide.uid,
        "data-id": slide.id
      }
    }, [_c('div', {
      staticClass: "index-screen"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('custom-panel-card', {
      attrs: {
        "typecard": 'screen',
        "index": index,
        "slide": slide,
        "isSelected": slide.uid === _vm.currentSlide.uid,
        "removable": _vm.all.length > 1,
        "showVideoIntro": {}
      },
      on: {
        "selected": function($event) {
          return _vm.selectSlide(slide)
        },
        "generic": function($event) {
          return _vm.videoGenerique('intro', index)
        },
        "duplicated": function($event) {
          return _vm.handleDuplicateSlide(slide, index)
        }
      }
    })], 1)
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "folder-slide-add",
    class: {
      disabled: _vm.all.length >= _vm.permission.nb_screen_segment && _vm.getNbSreenSegment
    },
    on: {
      "click": _vm.showSlideListModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "custom-button-navigation--right",
    on: {
      "click": function($event) {
        return _vm.dragSlide($event, 1)
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 32 32",
      "width": "20px",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "#939ea7"
    }
  }, [_c('path', {
    attrs: {
      "d": "M28.41,13.59l-10-10a2,2,0,0,0-2.82,2.82L24.17,15l-8.58,8.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,28.41,13.59Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.41,13.59l-10-10A2,2,0,0,0,3.59,6.41L12.17,15,3.59,23.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,16.41,13.59Z"
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "module-list"
    }
  }, [_c('vue-topprogress', {
    ref: "topProgress",
    staticStyle: {
      "position": "relative",
      "right": "0px",
      "height": "7px"
    }
  }), _vm._v(" "), _c('b-row', [_c('div', {
    staticClass: "modal-body-content-module"
  }, [_c('div', {
    attrs: {
      "id": "plan1"
    }
  }, [_c('b-row', [_c('div', {
    staticClass: " module-title"
  }, [(_vm.paramsClient.nb_screen_segment !== 1) ? _c('span', {
    staticClass: "module-title--size"
  }, [_vm._v(_vm._s(_vm.$t('module.segment.title')))]) : _vm._e(), _vm._v(" "), (_vm.paramsClient.nb_screen_segment === 1) ? _c('span', {
    staticClass: "module-title--size"
  }, [_vm._v(_vm._s(_vm.$t('module.slide.title')))]) : _vm._e()])]), _vm._v(" "), _c('b-row', {
    staticClass: "header-module-block"
  }, [_c('b-col', {
    staticClass: "tabs-module-col",
    attrs: {
      "sm": "8"
    }
  }, [_c('div', {
    staticClass: " tabs-module"
  }, [_c('b-tabs', {
    attrs: {
      "active-nav-item-class": "font-weight-bold",
      "active-tab-class": "font-weight-bold text-success"
    }
  }, _vm._l((_vm.allTabs), function(tab, index) {
    return _c('b-tab', {
      key: index,
      attrs: {
        "title": _vm.$t('tabs.' + tab),
        "active": tab === _vm.activeModule
      },
      on: {
        "click": function($event) {
          return _vm.changeModule(tab)
        }
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('b-col', {
    staticClass: "search-col",
    attrs: {
      "sm": "4"
    }
  }, [_c('b-input-group', {
    staticClass: "search-group"
  }, [_c('b-input-group-append', {
    staticClass: " search-icon",
    on: {
      "click": function($event) {
        return _vm.searchTitle(true)
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "1.5em",
      "height": "1.5em",
      "viewBox": "0 0 40 40"
    }
  }, [_c('path', {
    attrs: {
      "id": "Color",
      "d": "M28.879,28.929a1.083,1.083,0,0,1-.76-.305l-6.96-6.712v-.072A13.25,13.25,0,0,1,7.772,23.775,12.758,12.758,0,0,1,3.4,20.785,12.074,12.074,0,0,1,3.763,3.629a13.2,13.2,0,0,1,17.791-.352A12.079,12.079,0,0,1,22.648,20.4h.075l6.96,6.712a1.007,1.007,0,0,1-.043,1.507A1.1,1.1,0,0,1,28.879,28.929ZM12.857,2.143A10.468,10.468,0,0,0,2.143,12.321a9.863,9.863,0,0,0,3.138,7.2A10.935,10.935,0,0,0,12.857,22.5a11.15,11.15,0,0,0,4.1-.775,10.724,10.724,0,0,0,3.476-2.206,10.11,10.11,0,0,0,2.322-3.3,9.7,9.7,0,0,0,.815-3.9,9.862,9.862,0,0,0-3.138-7.2A10.934,10.934,0,0,0,12.857,2.143Z",
      "transform": "translate(5 6)",
      "fill": "#7c7c7c"
    }
  })])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "inputSearch",
    attrs: {
      "placeholder": _vm.$t('placeholder.search'),
      "id": "inputSearch"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchTitle(true)
      }
    },
    model: {
      value: (_vm.textToSearch),
      callback: function($$v) {
        _vm.textToSearch = $$v
      },
      expression: "textToSearch"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close-module-list",
    attrs: {
      "id": "close-module-list"
    },
    on: {
      "click": function($event) {
        return _vm.searchTitle(false)
      }
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])], 1)], 1)], 1), _vm._v(" "), (_vm.activeModule === 'empty') ? _c('b-row', {
    staticClass: " d-flex justify-content-between"
  }, [_c('div', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('show_blank_layout_action'),
      expression: "'show_blank_layout_action'"
    }],
    staticClass: "default-modules"
  }, [_c('div', {
    staticClass: "one-disposition"
  }, [_c('slide-card', {
    attrs: {
      "id": "emptyDisposition",
      "isEditable": false,
      "isHover": false,
      "isEmpty": true,
      "item": _vm.empty,
      "isSelected": _vm.selecteIdSegment.includes(_vm.empty.id)
    },
    on: {
      "selected": function($event) {
        return _vm.addSegment(_vm.emptyDisposition, 'empty')
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.activeModule !== 'empty') ? _c('b-row', [_c('div', {
    staticClass: "default-modules"
  }, [_c('div', {
    staticClass: "list-modules"
  }, _vm._l((_vm.getComputedList), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "one-disposition"
    }, [_c('slide-card', {
      class: {
        'fix-height': _vm.activeModule === 'images'
      },
      attrs: {
        "have-screen": _vm.haveScreen(item),
        "Shot": _vm.screenShot(item),
        "isHover": true,
        "id": item.id,
        "item": item,
        "ModalSegment": true,
        "title": item.title,
        "itemsegment": item,
        "isSelected": _vm.selecteIdSegment.includes(item.id),
        "isActiveModule": _vm.activeModule,
        "isOldImages": _vm.activeModule === 'images' && _vm.oldImages
      },
      on: {
        "selected": function($event) {
          return _vm.addSegment(item)
        },
        "showSelect": function($event) {
          return _vm.showSelect($event, item, index)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), _c('infinite-loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.noMoreMedias),
      expression: "!noMoreMedias"
    }],
    staticClass: "infinite-loading-container",
    attrs: {
      "distance": 10,
      "direction": 'bottom',
      "spinner": "bubbles"
    },
    on: {
      "infinite": _vm.loadMoreVideos
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noMoreMedias),
      expression: "noMoreMedias"
    }],
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noResultMedias),
      expression: "noResultMedias"
    }],
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  })])], 1)]) : _vm._e(), _vm._v(" "), _c('b-row', [_c('div', {
    staticClass: " timeline-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('module.timeline.title')))])])]), _vm._v(" "), _c('b-row', [_c('div', {
    staticClass: "timeline-modules"
  }, [_c('div', {
    staticClass: "col-xs-1"
  }, [_c('div', {
    staticClass: "button-navigation button-navigation__left",
    class: [{
      active: _vm.hasScrollSlides
    }]
  }, [_c('button', {
    staticClass: "  button-navigation--left btn btn-sm pl-1 pr-1",
    attrs: {
      "id": "button-navigation-left",
      "disabled": !_vm.hasScrollSlides
    },
    on: {
      "click": function($event) {
        return _vm.dragSlide($event, -1, 'module-list')
      }
    }
  }, [_c('div', {
    staticClass: "icon-navigation-left"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 32 32",
      "width": "20px",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "#939ea7"
    }
  }, [_c('path', {
    attrs: {
      "d": "M28.41,13.59l-10-10a2,2,0,0,0-2.82,2.82L24.17,15l-8.58,8.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,28.41,13.59Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.41,13.59l-10-10A2,2,0,0,0,3.59,6.41L12.17,15,3.59,23.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,16.41,13.59Z"
    }
  })])])])])])]), _vm._v(" "), _c('b-col', {
    staticClass: "div-draggable-margin",
    attrs: {
      "sm": "11"
    }
  }, [_c('div', {
    staticClass: "slides-panel row",
    attrs: {
      "id": "div-draggable"
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "ps",
    staticClass: "scroll-area",
    attrs: {
      "id": "ps-slide-wrapper",
      "use-both-wheel-axes": true
    }
  }, [_c('div', {
    staticClass: "row__inner",
    on: {
      "mousewheel": _vm.scrollHorizontally
    }
  }, [_c('draggable', {
    attrs: {
      "id": "draggable-wrapper",
      "move": _vm.dragSlide
    },
    on: {
      "end": _vm.reorder,
      "start": _vm.getList
    },
    model: {
      value: (_vm.list),
      callback: function($$v) {
        _vm.list = $$v
      },
      expression: "list"
    }
  }, _vm._l((_vm.moduleSelected), function(slide, index) {
    return _c('div', {
      key: 'list-complete-module-list' + slide.id,
      staticClass: "card-wrapper",
      class: {
        extended: slide.isExtended
      },
      attrs: {
        "data-uid": slide.uid
      }
    }, [_c('span', {
      staticClass: "counter-slides"
    }, [_vm._v("\n                          " + _vm._s(index + 1) + "\n                        ")]), _vm._v(" "), _c('panel-card', {
      attrs: {
        "index": index,
        "slide": slide,
        "isSelected": slide.uid === _vm.currentSegment.uid,
        "removable": _vm.all.length > 1,
        "showVideoIntro": {},
        "isSegmentCard": true,
        "isModuleList": true
      },
      on: {
        "remove-segment": function($event) {
          return _vm.addSegment(slide)
        }
      }
    })], 1)
  }), 0)], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1"
  }, [_c('div', {
    staticClass: "button-navigation button-navigation__right",
    class: [{
      active: _vm.hasScrollSlides
    }]
  }, [_c('button', {
    staticClass: " button-navigation--right btn btn-sm pl-1 pr-1",
    attrs: {
      "id": "button-navigation-right",
      "disabled": !_vm.hasScrollSlides
    },
    on: {
      "click": function($event) {
        return _vm.dragSlide($event, 1, 'module-list')
      }
    }
  }, [_c('div', {
    staticClass: "icon-navigation-right"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 32 32",
      "width": "20px",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "#939ea7"
    }
  }, [_c('path', {
    attrs: {
      "d": "M28.41,13.59l-10-10a2,2,0,0,0-2.82,2.82L24.17,15l-8.58,8.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,28.41,13.59Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.41,13.59l-10-10A2,2,0,0,0,3.59,6.41L12.17,15,3.59,23.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,16.41,13.59Z"
    }
  })])])])])])])], 1)]), _vm._v(" "), _c('b-row', {
    staticClass: "position-buttons"
  }, [(!_vm.hideCancelButton) ? _c('button', {
    class: ['btn outline-primary position-buttons__cancel'],
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('i', {
    class: ['fa fa-arrow-left']
  }), _vm._v(" " + _vm._s(_vm.$t('button.back')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.hideCancelButton && !_vm.navparam) ? _c('button', {
    class: ['btn outline-primary position-buttons__next'],
    attrs: {
      "id": "btn-next"
    },
    on: {
      "click": function($event) {
        _vm.onNav(), _vm.changeStyleOn()
      }
    }
  }, [_c('i', {
    class: ['fa fa-arrow-left']
  }), _vm._v(" " + _vm._s(_vm.$t('button.back')) + "\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.hideCancelButton) ? _c('button', {
    class: ['btn btn-primary position-buttons__confirm'],
    attrs: {
      "disabled": _vm.disabledConfirmButton
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_c('i', {
    class: ['fa fa-check']
  }), _vm._v(" " + _vm._s(_vm.$t('button.confirm')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.hideCancelButton && !_vm.navparam) ? _c('b-button', {
    staticClass: "position-buttons__finish",
    attrs: {
      "id": "btn-finish",
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.confirmButtonDisabled
    },
    on: {
      "click": _vm.confirm
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" " + _vm._s(_vm.$t('button.finish')) + "\n          ")]) : _vm._e()], 1), _vm._v("\n        " + _vm._s(_vm.isScreen) + "\n      ")], 1), _vm._v(" "), (!_vm.isScreen) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.navparam),
      expression: "navparam"
    }],
    attrs: {
      "id": "plan2"
    },
    on: {
      "click": function($event) {
        _vm.clicksOut = false
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "content-plan2"
    }
  }, [_c('b-card', {
    attrs: {
      "id": "card-add-prog"
    }
  }, [_c('div', {
    staticClass: "icon-add-prog"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "60",
      "height": "60",
      "viewBox": "0 0 30 30"
    }
  }, [_c('path', {
    attrs: {
      "id": "Color",
      "d": "M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z",
      "transform": "translate(3.75 3.75)",
      "fill": "#acadb1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('addProgram.add')))]), _vm._v(" "), (_vm.options.length > 0) ? _c('h6', {
    staticStyle: {
      "color": "#686866"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('addProgram.textAddLigne')) + "\n              ")]) : _c('h6', {
    staticStyle: {
      "color": "#68686b"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('addProgram.textAdd')) + "\n              ")])])]), _vm._v(" "), _c('b-row', {
    staticClass: "my-2 d-flex justify-content-between"
  }, [_c('b-col', [_c('b-form-group', {
    staticClass: "text-left",
    attrs: {
      "id": "input-group-title",
      "label": _vm.$t('labels.title'),
      "label-for": "input-titre"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "input-titre",
      "state": _vm.stateTitle,
      "required": "",
      "placeholder": _vm.$t('placeholder.title')
    },
    model: {
      value: (_vm.getTitleSegment),
      callback: function($$v) {
        _vm.getTitleSegment = $$v
      },
      expression: "getTitleSegment"
    }
  })], 1)], 1), _vm._v(" "), (_vm.options.length > 0) ? _c('b-col', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('use_ligne_template_action'),
      expression: "'use_ligne_template_action'"
    }]
  }, [_c('b-form-group', {
    staticClass: "text-left",
    attrs: {
      "id": "input-group-title",
      "label": _vm.$t('labels.ligne'),
      "label-for": "input-titre"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "required": "",
      "state": _vm.stateLigne,
      "id": "input-ligne"
    },
    model: {
      value: (_vm.ligneTemplate),
      callback: function($$v) {
        _vm.ligneTemplate = $$v
      },
      expression: "ligneTemplate"
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.name,
        "value": option.value
      }
    }, [_vm._v("\n                    " + _vm._s(option.name) + "\n                  ")])
  }), 0)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "text-right"
  }, [_c('b-button', {
    staticClass: "lg-btn",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": function($event) {
        return _vm.BackToBoProgram()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('button.cancel')) + "\n              ")]), _vm._v(" "), (_vm.navparam) ? _c('b-button', {
    staticClass: "lg-btn",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onNav(), _vm.changeStyleOff()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('button.next')) + "\n              ")]) : _vm._e()], 1)], 1)], 1)]) : _vm._e()])])], 1)
},staticRenderFns: []}

/***/ }),
/* 830 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showDisplay) ? _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.$route.name == 'segment')),
      expression: "!($route.name == 'segment')"
    }]
  }), _vm._v(" "), _c('preview'), _vm._v(" "), (_vm.$route.name.includes('segment') || _vm.$route.name.includes('Segment')) ? _c('editor', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.name == 'segment'),
      expression: "$route.name == 'segment'"
    }]
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "add-screen-module"
    }
  }, [_c('vue-topprogress', {
    ref: "topProgress",
    staticStyle: {
      "position": "relative",
      "right": "0px",
      "height": "7px"
    }
  }), _vm._v(" "), _c('b-row', [_c('div', {
    staticClass: "modal-body-content-module"
  }, [_c('div', {
    attrs: {
      "id": "planx"
    }
  }, [_c('b-row', [_c('div', {
    staticClass: " module-title"
  }, [_c('span', {
    staticClass: "module-title--size"
  }, [_vm._v(_vm._s(_vm.$t('module.slide.title')))])])]), _vm._v(" "), _c('b-row', {
    staticClass: "header-module-block"
  }, [_c('b-col', {
    staticClass: "tabs-module-col",
    attrs: {
      "sm": "8"
    }
  }, [_c('div', {
    staticClass: " tabs-module"
  }, [_c('b-tabs', {
    attrs: {
      "active-nav-item-class": "font-weight-bold",
      "active-tab-class": "font-weight-bold text-success"
    }
  }, _vm._l((_vm.allTabs), function(tab, index) {
    return _c('b-tab', {
      key: index,
      class: [{
        active: tab === _vm.activeModule
      }],
      attrs: {
        "title": _vm.$t('tabs.' + tab)
      },
      on: {
        "click": function($event) {
          return _vm.changeModule(tab)
        }
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('b-col', {
    staticClass: "search-col",
    attrs: {
      "sm": "4"
    }
  }, [_c('b-input-group', {
    staticClass: "search-group"
  }, [_c('b-input-group-append', {
    staticClass: " search-icon",
    on: {
      "click": function($event) {
        return _vm.searchTitle(true)
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "1.5em",
      "height": "1.5em",
      "viewBox": "0 0 40 40"
    }
  }, [_c('path', {
    attrs: {
      "id": "Color",
      "d": "M28.879,28.929a1.083,1.083,0,0,1-.76-.305l-6.96-6.712v-.072A13.25,13.25,0,0,1,7.772,23.775,12.758,12.758,0,0,1,3.4,20.785,12.074,12.074,0,0,1,3.763,3.629a13.2,13.2,0,0,1,17.791-.352A12.079,12.079,0,0,1,22.648,20.4h.075l6.96,6.712a1.007,1.007,0,0,1-.043,1.507A1.1,1.1,0,0,1,28.879,28.929ZM12.857,2.143A10.468,10.468,0,0,0,2.143,12.321a9.863,9.863,0,0,0,3.138,7.2A10.935,10.935,0,0,0,12.857,22.5a11.15,11.15,0,0,0,4.1-.775,10.724,10.724,0,0,0,3.476-2.206,10.11,10.11,0,0,0,2.322-3.3,9.7,9.7,0,0,0,.815-3.9,9.862,9.862,0,0,0-3.138-7.2A10.934,10.934,0,0,0,12.857,2.143Z",
      "transform": "translate(5 6)",
      "fill": "#7c7c7c"
    }
  })])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "inputSearch",
    attrs: {
      "placeholder": _vm.$t('placeholder.search'),
      "id": "inputSearch"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchTitle(true)
      }
    },
    model: {
      value: (_vm.textToSearch),
      callback: function($$v) {
        _vm.textToSearch = $$v
      },
      expression: "textToSearch"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close-add-screen-module",
    attrs: {
      "id": "close-add-screen-module"
    },
    on: {
      "click": function($event) {
        return _vm.searchTitle(false)
      }
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])], 1)], 1)], 1), _vm._v(" "), (_vm.activeModule === 'empty') ? _c('b-row', {
    staticClass: " d-flex justify-content-between"
  }, [_c('div', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('show_blank_layout_action'),
      expression: "'show_blank_layout_action'"
    }],
    staticClass: "default-modules screens"
  }, [_c('div', {
    staticClass: "one-disposition"
  }, [_c('slide-card', {
    attrs: {
      "id": "emptyDisposition",
      "isEditable": false,
      "isHover": false,
      "isEmpty": true,
      "item": _vm.empty,
      "isSelected": _vm.selectedIds.includes(_vm.emptyScreen.id)
    },
    on: {
      "selected": function($event) {
        return _vm.select(_vm.emptyScreen)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.activeModule !== 'empty') ? _c('b-row', [_c('div', {
    staticClass: "default-modules screens"
  }, [_c('div', {
    staticClass: "list-modules"
  }, _vm._l((_vm.getComputedList), function(item, index) {
    return _c('div', {
      key: 'screen-s-' + item.id,
      staticClass: "one-disposition"
    }, [_c('slide-card', {
      class: {
        'fix-height': _vm.activeModule === 'images'
      },
      attrs: {
        "have-screen": _vm.haveScreen(item),
        "Shot": _vm.screenShot(item),
        "isHover": true,
        "id": item.id,
        "item": item,
        "ModalSegment": true,
        "title": item.title,
        "itemsegment": item,
        "isSelected": _vm.selectedIds.includes(item.id),
        "isActiveModule": _vm.activeModule
      },
      on: {
        "selected": function($event) {
          return _vm.select(item)
        },
        "showSelect": function($event) {
          return _vm.showSelect($event, item, index)
        }
      }
    })], 1)
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('b-row', [_c('div', {
    staticClass: " timeline-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('module.timeline.title')))])])]), _vm._v(" "), _c('b-row', [_c('div', {
    staticClass: "timeline-modules"
  }, [_c('div', {
    staticClass: "col-xs-1"
  }, [_c('div', {
    staticClass: "button-navigation button-navigation__left",
    class: [{
      active: _vm.hasScrollSlides
    }]
  }, [_c('button', {
    staticClass: "  button-navigation--left btn btn-sm pl-1 pr-1",
    attrs: {
      "id": "button-navigation-left",
      "disabled": !_vm.hasScrollSlides
    },
    on: {
      "click": function($event) {
        return _vm.dragSlide($event, -1, 'add-screen-module')
      }
    }
  }, [_c('div', {
    staticClass: "icon-navigation-left"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 32 32",
      "width": "20px",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "#939ea7"
    }
  }, [_c('path', {
    attrs: {
      "d": "M28.41,13.59l-10-10a2,2,0,0,0-2.82,2.82L24.17,15l-8.58,8.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,28.41,13.59Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.41,13.59l-10-10A2,2,0,0,0,3.59,6.41L12.17,15,3.59,23.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,16.41,13.59Z"
    }
  })])])])])])]), _vm._v(" "), _c('b-col', {
    staticClass: "div-draggable-margin",
    attrs: {
      "sm": "11"
    }
  }, [_c('div', {
    staticClass: "slides-panel row",
    attrs: {
      "id": "div-draggable"
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "ps",
    staticClass: "scroll-area",
    attrs: {
      "id": "ps-slide-wrapper",
      "use-both-wheel-axes": true
    }
  }, [_c('div', {
    staticClass: "row__inner",
    on: {
      "mousewheel": _vm.scrollHorizontally
    }
  }, [_c('draggable', {
    attrs: {
      "id": "draggable-wrapper",
      "move": _vm.dragSlide
    },
    on: {
      "end": _vm.reorder,
      "start": _vm.getList
    },
    model: {
      value: (_vm.list),
      callback: function($$v) {
        _vm.list = $$v
      },
      expression: "list"
    }
  }, _vm._l((_vm.ListSelected), function(slide, index) {
    return _c('div', {
      key: 'list-screen-' + index,
      staticClass: "card-wrapper",
      class: {
        extended: slide.isExtended
      },
      attrs: {
        "data-uid": slide.uid
      }
    }, [_c('span', {
      staticClass: "counter-slides"
    }, [_vm._v("\n                          " + _vm._s(index + 1) + "\n                        ")]), _vm._v(" "), _c('panel-card', {
      attrs: {
        "index": index,
        "slide": slide,
        "isSelected": slide.uid === _vm.currentSegment.uid,
        "removable": _vm.ListSelected.length > 1,
        "showVideoIntro": {},
        "isSegmentCard": false,
        "isModuleList": true,
        "isScreenList": true
      },
      on: {
        "remove-segment": function($event) {
          return _vm.select(slide)
        }
      }
    })], 1)
  }), 0)], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1"
  }, [_c('div', {
    staticClass: "button-navigation button-navigation__right",
    class: [{
      active: _vm.hasScrollSlides
    }]
  }, [_c('button', {
    staticClass: " button-navigation--right btn btn-sm pl-1 pr-1",
    attrs: {
      "id": "button-navigation-right",
      "disabled": !_vm.hasScrollSlides
    },
    on: {
      "click": function($event) {
        return _vm.dragSlide($event, 1, 'add-screen-module')
      }
    }
  }, [_c('div', {
    staticClass: "icon-navigation-right"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 32 32",
      "width": "20px",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "#939ea7"
    }
  }, [_c('path', {
    attrs: {
      "d": "M28.41,13.59l-10-10a2,2,0,0,0-2.82,2.82L24.17,15l-8.58,8.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,28.41,13.59Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.41,13.59l-10-10A2,2,0,0,0,3.59,6.41L12.17,15,3.59,23.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,16.41,13.59Z"
    }
  })])])])])])])], 1)]), _vm._v(" "), _c('b-row', {
    staticClass: "position-buttons"
  }, [_c('button', {
    class: ['btn outline-primary position-buttons__back'],
    attrs: {
      "id": "btn-back"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('i', {
    class: ['fa fa-arrow-left']
  }), _vm._v(" " + _vm._s(_vm.$t('button.back')) + "\n          ")]), _vm._v(" "), _c('button', {
    class: ['btn btn-primary position-buttons__confirm'],
    attrs: {
      "disabled": _vm.disabledConfirmButton
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_c('i', {
    class: ['fa fa-check']
  }), _vm._v(" " + _vm._s(_vm.$t('button.confirm')) + "\n          ")])])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      imageEditor: _vm.changed
    },
    attrs: {
      "id": "tuiImageEditor"
    }
  }, [(_vm.changed) ? _c('div', {
    staticClass: "imageEditorApp"
  }, [_c('image-editor-container')], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-pages-container"
  }, [(_vm.showScreen) ? _c('div', {
    staticClass: "block-back-to-segment"
  }, [_c('div', {
    staticClass: "backbtn-segment",
    on: {
      "click": _vm.closeSegmentCards
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" Retour\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "current-segment-block"
  }, [_c('div', {
    staticClass: "custom-folder xs small darckblue"
  }, [_c('p', [_vm._v(_vm._s(_vm.currentSegment.title))])])])]) : _vm._e(), _vm._v(" "), (_vm.show_generic_display == 1 && _vm.all.length > 0 && !_vm.showScreen) ? _c('div', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('show_generic_action'),
      expression: "'show_generic_action'"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.withGeneric),
      expression: "withGeneric"
    }],
    staticClass: "custom-btn-generic",
    class: {
      filled: _vm.startGeneric
    },
    on: {
      "click": function($event) {
        return _vm.videoGenerique('debut')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 511.816 511.816"
    },
    attrs: {
      "version": "1.1",
      "width": "25px",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 511.816 511.816",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "fill": "#ffffff"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20.949,298.483v160c0,29.419,23.936,53.333,53.333,53.333h384c29.419,0,53.333-23.915,53.333-53.333v-160H20.949z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "252.757,48.776 172.927,67.72 239.807,166.131 326.271,146.462 \t\t"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "150.741,72.99 64.703,93.384 130.879,190.878 217.471,171.187 \t\t"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M511.274,93.086l-18.155-68.864c-4.181-16.747-21.333-27.285-38.251-23.424l-71.68,17.024l68.011,100.267l52.117-11.861\n\t\t\tc2.837-0.64,5.269-2.411,6.763-4.885S511.999,95.902,511.274,93.086z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "360.981,23.091 275.413,43.4 349.055,141.299 428.863,123.144 \t\t"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "128.447,191.838 94.314,277.15 178.005,277.15 212.138,191.838 \t\t"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "235.114,191.838 200.981,277.15 284.671,277.15 318.805,191.838 \t\t"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M500.949,191.838h-52.501l-34.133,85.333h97.301v-74.667C511.615,196.595,506.858,191.838,500.949,191.838z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "341.781,191.838 307.647,277.15 391.317,277.15 425.471,191.838 \t\t"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M42.517,98.675l-17.387,4.117c-8.469,1.92-15.637,7.061-20.181,14.443c-4.544,7.403-5.888,16.107-3.776,24.533\n\t\t\tl19.776,78.165v57.216h50.389l32.021-80.021l5.205-1.173L42.517,98.675z"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "custom-button-navigation--left",
    on: {
      "click": function($event) {
        return _vm.dragSlide($event, -1)
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "transform": "rotate(180deg)"
    },
    attrs: {
      "viewBox": "0 0 32 32",
      "width": "20px",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "#939ea7"
    }
  }, [_c('path', {
    attrs: {
      "d": "M28.41,13.59l-10-10a2,2,0,0,0-2.82,2.82L24.17,15l-8.58,8.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,28.41,13.59Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.41,13.59l-10-10A2,2,0,0,0,3.59,6.41L12.17,15,3.59,23.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,16.41,13.59Z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "slides-panel row",
    attrs: {
      "id": "div-draggable"
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "ps",
    staticClass: "scroll-area",
    attrs: {
      "id": "ps-slide-wrapper",
      "use-both-wheel-axes": true
    },
    on: {
      "ps-scroll-x": _vm.removeSmoothing
    }
  }, [_c('div', {
    staticClass: "row__inner",
    on: {
      "mousewheel": _vm.scrollHorizontally
    }
  }, [_c('draggable', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "id": "draggable-wrapper",
      "move": _vm.dragSlide
    },
    on: {
      "end": _vm.reorder,
      "start": _vm.getList
    },
    model: {
      value: (_vm.list),
      callback: function($$v) {
        _vm.list = $$v
      },
      expression: "list"
    }
  }, [_vm._l((_vm.all), function(slide, index) {
    return _c('div', {
      key: 'list-complete-c-' + index,
      staticClass: "card-wrapper",
      class: {
        extended: slide.isExtended
      },
      attrs: {
        "data-uid": slide.uid
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isExtendedSlides),
        expression: "!isExtendedSlides"
      }],
      staticClass: "transition-icon-wrapper"
    }, [_c('b-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.show_video_intro),
        expression: "show_video_intro"
      }],
      staticClass: "transition-btn",
      class: {
        active: _vm.hasStartGeneric(slide)
      },
      on: {
        "click": function($event) {
          return _vm.videoGenerique('intro', index)
        }
      }
    }, [_c('i', {
      staticClass: "icon-film-strip"
    })])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isExtendedSlides),
        expression: "!isExtendedSlides"
      }],
      staticClass: "index-segment"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('custom-panel-card', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isExtendedSlides),
        expression: "!isExtendedSlides"
      }],
      attrs: {
        "segmenOneScreen": _vm.oneScreen,
        "typecard": _vm.typecard,
        "index": index,
        "slide": slide,
        "isSelected": slide.uid === _vm.currentSegment.uid,
        "removable": _vm.all.length > 1,
        "showVideoIntro": {},
        "is-segment-card": true
      },
      on: {
        "selected": function($event) {
          return _vm.selectSegment(slide)
        },
        "duplicated": function($event) {
          return _vm.handleDuplicateSegment(slide, index)
        },
        "insertSegment": function($event) {
          return _vm.handleInsertSegment(index)
        }
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExtendedSlides && _vm.currentSegment.uid == slide.uid),
        expression: "isExtendedSlides && currentSegment.uid == slide.uid"
      }],
      staticClass: "inner-slides-wrapper",
      class: {
        extended: slide.isExtended
      },
      style: (_vm.calculateWidth(slide))
    }, [_c('draggable', {
      key: _vm.segmentKey,
      staticClass: "inner-slides-container",
      staticStyle: {
        "display": "flex"
      },
      attrs: {
        "id": "nested-draggable-wrapper"
      },
      on: {
        "end": function($event) {
          return _vm.reorderSlides($event, index)
        }
      },
      model: {
        value: (_vm.lists[index]),
        callback: function($$v) {
          _vm.$set(_vm.lists, index, $$v)
        },
        expression: "lists[index]"
      }
    }, _vm._l((_vm.getScreens(slide)), function(slideScreen, i) {
      return _c('div', {
        key: i,
        staticClass: "slides-transitions-wrapper"
      }, [_c('div', {
        staticClass: "index-screen"
      }, [_vm._v(_vm._s(i + 1))]), _vm._v(" "), _c('custom-panel-card', {
        attrs: {
          "typecard": 'screen',
          "index": i,
          "segment": slide,
          "slide": slideScreen,
          "isSelected": slideScreen.uid === _vm.currentSlide.uid
        },
        on: {
          "selected": function($event) {
            return _vm.selectSlide(slide, slideScreen)
          },
          "duplicated": function($event) {
            return _vm.handleDuplicateSlideInsideSegment(slide, slideScreen, index, i)
          }
        }
      })], 1)
    }), 0)], 1)], 1)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.oneScreen),
      expression: "oneScreen"
    }],
    staticClass: "folder-slide-add",
    on: {
      "click": function($event) {
        return _vm.handleInsertSegment(_vm.lengthSegmentToAdd)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _vm._v(" "), (!_vm.isExtendedSlides && !_vm.oneScreen) ? _c('div', {
    staticClass: "custom-folder small blue floder-add-segment ",
    on: {
      "click": function($event) {
        return _vm.handleInsertSegment(_vm.lengthSegmentToAdd)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]) : _vm._e(), _vm._v(" "), (_vm.isExtendedSlides && !_vm.oneScreen) ? _c('div', {
    staticClass: "folder-slide-add",
    on: {
      "click": function($event) {
        return _vm.handleAppendSlide(_vm.currentSegment)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]) : _vm._e()], 2)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "custom-button-navigation--right",
    on: {
      "click": function($event) {
        return _vm.dragSlide($event, 1)
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 32 32",
      "width": "20px",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "#939ea7"
    }
  }, [_c('path', {
    attrs: {
      "d": "M28.41,13.59l-10-10a2,2,0,0,0-2.82,2.82L24.17,15l-8.58,8.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,28.41,13.59Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.41,13.59l-10-10A2,2,0,0,0,3.59,6.41L12.17,15,3.59,23.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,16.41,13.59Z"
    }
  })])])]), _vm._v(" "), (_vm.show_generic_display == 1 && _vm.all.length > 0 && !_vm.showScreen) ? _c('div', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('show_generic_action'),
      expression: "'show_generic_action'"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.withGeneric),
      expression: "withGeneric"
    }],
    staticClass: "custom-btn-generic",
    class: {
      filled: _vm.finishGeneric
    },
    on: {
      "click": function($event) {
        return _vm.videoGenerique('fin')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "margin-top": "45px"
    },
    attrs: {
      "height": "30px",
      "viewBox": "0 0 58 58",
      "width": "30px",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "#ffffff",
      "fill-rule": "nonzero",
      "transform": "translate(0 -1)"
    }
  }, [_c('path', {
    attrs: {
      "d": "m14.678 58.9507 1.0678-.2984c1.0270794-.287091 1.6269982-1.3523947 1.34-2.3795l-12.2083-43.6888c-.17227193-.6165569-.58242107-1.139423-1.14021438-1.4535673-.5577933-.3141444-1.21753647-.3938324-1.83408562-.2215327l-.1379.0385c-1.28397381.3587434-2.0340279 1.6904218-1.6753 2.9744l12.2086 43.6888c.2870014 1.0271063 1.3522895 1.6270863 2.3794 1.3401z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Shape",
      "d": "m57.67 28.42c-3.8715209-1.930437-7.4530885-4.3944478-10.64-7.32-.2678864-.245221-.3726619-.6216366-.27-.97 1.579074-5.9738125 2.7517572-12.04771023 3.51-18.18.12-1.02-.43-1.32-1.01-.62-11.38 13.61-31.07-2.49-42.79 9.88.14070884.2634479.25140182.5418575.33.83l7.92 28.36c11.74-12.22 31.36 3.78 42.72-9.8.58-.7.69-1.98.23-2.18z"
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "previewDisplay",
    class: {
      overviewShown: _vm.overviewShown,
      'is-visible-preview': _vm.isVisible
    },
    attrs: {
      "id": "previewAll"
    }
  }, [_c('div', {
    staticClass: "gjs-off-prv exit_preview",
    attrs: {
      "id": "exit"
    },
    on: {
      "click": _vm.showPreview
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "40",
      "viewBox": "0 0 401.994 402"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(-296.982 -165)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M134,0A134,134,0,1,1,0,134,134,134,0,0,1,134,0Z",
      "transform": "translate(364 232)",
      "fill": "#fff"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "error",
      "transform": "translate(296.982 165)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M343.193,58.8c-78.4-78.4-205.978-78.41-284.388,0s-78.4,205.978,0,284.388,205.978,78.41,284.388,0S421.595,137.206,343.193,58.8ZM280.3,280.3a15.465,15.465,0,0,1-21.872,0L201,222.871l-60.157,60.157a15.466,15.466,0,0,1-21.872-21.872L179.126,201,121.7,143.572A15.466,15.466,0,1,1,143.572,121.7L201,179.126l54.689-54.689A15.466,15.466,0,0,1,277.56,146.31L222.871,201,280.3,258.425A15.465,15.465,0,0,1,280.3,280.3Z",
      "transform": "translate(0 0)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "exit-container"
  }, [_c('div', {
    staticClass: "exit-alert animated fadeOutUp",
    attrs: {
      "id": "animatedExit"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('labels.press')))]), _vm._v(" "), _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "viewBox": "0 0 401.994 402"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(-296.982 -165)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M134,0A134,134,0,1,1,0,134,134,134,0,0,1,134,0Z",
      "transform": "translate(364 232)",
      "fill": "#fff"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "error",
      "transform": "translate(296.982 165)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M343.193,58.8c-78.4-78.4-205.978-78.41-284.388,0s-78.4,205.978,0,284.388,205.978,78.41,284.388,0S421.595,137.206,343.193,58.8ZM280.3,280.3a15.465,15.465,0,0,1-21.872,0L201,222.871l-60.157,60.157a15.466,15.466,0,0,1-21.872-21.872L179.126,201,121.7,143.572A15.466,15.466,0,1,1,143.572,121.7L201,179.126l54.689-54.689A15.466,15.466,0,0,1,277.56,146.31L222.871,201,280.3,258.425A15.465,15.465,0,0,1,280.3,280.3Z",
      "transform": "translate(0 0)"
    }
  })])])]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.$t('labels.exit_fullScreen')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "reveal"
  }, [_c('div', {
    staticClass: "slidesParent preview-scaling",
    class: _vm.deviceType,
    style: (_vm.devices.style)
  }, [_c('div', {
    staticClass: "slides"
  }, _vm._l((_vm.slides), function(slide) {
    return (_vm.isVisible) ? _c('section', {
      attrs: {
        "data-transition": slide.transition,
        "data-autoslide": slide.duration
      }
    }, [_c('div', {
      staticStyle: {
        "height": "100%"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHtml(slide.html))
      }
    })]) : _vm._e()
  }), 0)])])])
},staticRenderFns: []}

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none",
      "background": "#FFFFFF"
    },
    attrs: {
      "id": "save-programme"
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [(_vm.$route.name === 'edit' || _vm.titleTemplate.title) ? _c('label', {
    staticStyle: {
      "display": "block",
      "font-size": "18px",
      "text-align": "left"
    },
    attrs: {
      "id": "txt-modal-edit"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('labels.edit_template_name')) + "\n      ")]) : _c('label', {
    staticStyle: {
      "display": "block",
      "font-size": "18px",
      "text-align": "left"
    },
    attrs: {
      "id": "txt-modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('labels.add_template_name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.$route.name === 'edit' || _vm.titleTemplate.title)),
      expression: "!($route.name === 'edit' || titleTemplate.title)"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "15px",
      "height": "45px",
      "font-size": "18px",
      "border-radius": "0"
    },
    attrs: {
      "id": "title-template",
      "type": "text",
      "placeholder": _vm.$t('placeholder.template_title'),
      "name": "fname"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.name === 'edit' || _vm.titleTemplate.title),
      expression: "$route.name === 'edit' || titleTemplate.title"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "15px",
      "height": "45px",
      "font-size": "18px",
      "border-radius": "0"
    },
    attrs: {
      "id": "edit-title-template",
      "type": "text",
      "placeholder": _vm.$t('placeholder.template_title'),
      "name": "fname"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "button-saveTemp",
    attrs: {
      "id": "success"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin",
    staticStyle: {
      "margin-right": "10px",
      "display": "none"
    },
    attrs: {
      "id": "loadButton"
    }
  }), _vm._v(_vm._s(_vm.$t('button.confirm')) + "\n      ")])])])])
},staticRenderFns: []}

/***/ }),
/* 836 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-card-wrapper",
    class: {
      'segment-card': _vm.isSegmentCard || _vm.isScreenList
    }
  }, [_c('div', {
    staticClass: "thumb_page tile",
    class: {
      selected: _vm.isSelected,
      segment: _vm.segment,
      'module-list': _vm.isModuleList,
    }
  }, [_c('div', {
    staticClass: "slide tile__media",
    class: [{
      'module-list': _vm.isModuleList
    }],
    style: (_vm.backgroundImageMedia)
  }, [_c('div', {
    ref: "cardEl",
    staticClass: "containerScreen tile__img",
    class: [{
      'module-list': _vm.isModuleList
    }],
    style: ({
      backgroundImage: _vm.backgroundImage
    }),
    on: {
      "click": function($event) {
        return _vm.$emit('selected')
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMultipleLayers),
      expression: "isMultipleLayers"
    }],
    staticClass: "segment-type"
  }, [_c('i', {
    staticClass: "icon-layers"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isModuleList),
      expression: "isModuleList"
    }],
    staticClass: "close-segment",
    on: {
      "click": function($event) {
        return _vm.$emit('remove-segment')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 512 512"
    },
    attrs: {
      "version": "1.1",
      "id": "Capa_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 512 512",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "d": "M437.019,74.981C388.668,26.628,324.378,0,256,0C187.62,0,123.333,26.628,74.981,74.98S0,187.62,0,256\n\t\t\tc0,68.381,26.628,132.668,74.981,181.02C123.332,485.372,187.62,512,255.999,512s132.669-26.628,181.02-74.98\n\t\t\tC485.371,388.667,512,324.38,512,256C512,187.619,485.371,123.332,437.019,74.981z M368.853,347.642\n\t\t\tc5.857,5.857,5.857,15.355,0,21.213c-2.93,2.929-6.768,4.393-10.607,4.393c-3.838,0-7.678-1.465-10.605-4.393L256,277.214\n\t\t\tl-91.641,91.641c-2.93,2.929-6.768,4.393-10.607,4.393c-3.838,0-7.678-1.465-10.605-4.393c-5.858-5.857-5.858-15.355,0-21.213\n\t\t\tl91.64-91.641l-91.64-91.641c-5.858-5.857-5.858-15.355,0-21.213c5.857-5.857,15.354-5.857,21.213,0L256,234.788l91.64-91.641\n\t\t\tc5.857-5.857,15.355-5.857,21.213,0c5.857,5.857,5.857,15.355,0,21.213l-91.641,91.641L368.853,347.642z"
    }
  })])]), _vm._v(" "), (!_vm.isModuleList) ? _c('ul', {
    staticClass: "actions-wrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.checkTarget($event)
      }
    }
  }, [_c('li', {
    staticClass: "fa fa-clone item-li li-duplicate ",
    class: {
      disabled: _vm.selectedSlides.length >= _vm.permission.nb_screen_segment && _vm.getNbSreenSegment,
    },
    attrs: {
      "title": _vm.$t('panels.duplicateScreen')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('duplicated')
      }
    }
  }), _vm._v(" "), _c('v-popover', {
    staticClass: "more-actions-btn-parent p-2",
    attrs: {
      "offset": "16",
      "container": "#editor",
      "popoverClass": "card-tooltip",
      "placement": "top",
      "default-placement": "top"
    }
  }, [_c('li', {
    staticClass: "fa fa-ellipsis-v item-li li-edit more-actions-btn open-menu-style",
    attrs: {
      "title": _vm.$t('panels.editScreen')
    }
  }), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('panel-card-actions', {
    attrs: {
      "is-segment-card": _vm.isSegmentCard,
      "card": _vm.slide,
      "segment": _vm.segment
    }
  })], 1)], 2)], 1) : _vm._e(), _vm._v(" "), (!_vm.isScreenList) ? _c('div', {
    staticClass: "duration-wrapper"
  }, [_vm._v(_vm._s(_vm._f("FormatTime")(_vm.duration)))]) : _vm._e(), _vm._v(" "), (!_vm.isModuleList) ? _c('div', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('can_toggle_slides_action'),
      expression: "'can_toggle_slides_action'"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.isSegmentCard),
      expression: "isSegmentCard"
    }],
    staticClass: "toggle-slides",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleSegment($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-arrow-left",
    class: {
      rotated: _vm.isExtended(_vm.slide.uid)
    }
  })]) : _vm._e()]), _vm._v(" "), (!_vm.isModuleList) ? _c('div', {
    staticClass: "slide_name"
  }, [_c('div', {
    staticClass: "tile__title",
    attrs: {
      "id": _vm.index,
      "title": _vm.$t('panels.edit_title')
    }
  }, [_vm._v("\n            " + _vm._s(_vm.slide.title) + "\n          ")])]) : _vm._e()]), _vm._v(" "), (_vm.isModuleList) ? _c('div', {
    staticClass: "slide_name"
  }, [(_vm.paramsClient.nb_screen_segment !== 1) ? _c('div', {
    staticClass: "tile__title",
    class: [{
      'module-list': _vm.isModuleList
    }],
    attrs: {
      "id": _vm.index,
      "title": _vm.$t('panels.edit_title')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.slide.title) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.paramsClient.nb_screen_segment === 1 && _vm.slide.screens) ? _c('div', {
    staticClass: "tile__title",
    class: [{
      'module-list': _vm.isModuleList
    }],
    attrs: {
      "id": _vm.index,
      "title": _vm.$t('panels.edit_title')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.slide.screens[0].title) + "\n        ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (!_vm.isModuleList) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSegmentCard),
      expression: "isSegmentCard"
    }],
    staticClass: "btn btn-sm add-segment-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('insertSegment')
      }
    }
  }, [_vm._v("\n      + Segment\n    ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 837 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.getColorBtn),
    attrs: {
      "id": "slide-list-segment"
    }
  }, [_c('b-row', {
    staticClass: "mb-4 card-nav"
  }, [_c('b-col', {
    staticClass: "col-11-search",
    attrs: {
      "cols": "11",
      "ms": "11"
    }
  }, [_c('div', {
    staticClass: "search-col"
  }, [_c('b-input-group', {
    staticClass: "search-group"
  }, [_c('b-input-group-append', {
    staticClass: " search-icon",
    on: {
      "click": function($event) {
        return _vm.searchTitle()
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "1.5em",
      "height": "1.5em",
      "viewBox": "0 0 40 40"
    }
  }, [_c('path', {
    attrs: {
      "id": "Color",
      "d": "M28.879,28.929a1.083,1.083,0,0,1-.76-.305l-6.96-6.712v-.072A13.25,13.25,0,0,1,7.772,23.775,12.758,12.758,0,0,1,3.4,20.785,12.074,12.074,0,0,1,3.763,3.629a13.2,13.2,0,0,1,17.791-.352A12.079,12.079,0,0,1,22.648,20.4h.075l6.96,6.712a1.007,1.007,0,0,1-.043,1.507A1.1,1.1,0,0,1,28.879,28.929ZM12.857,2.143A10.468,10.468,0,0,0,2.143,12.321a9.863,9.863,0,0,0,3.138,7.2A10.935,10.935,0,0,0,12.857,22.5a11.15,11.15,0,0,0,4.1-.775,10.724,10.724,0,0,0,3.476-2.206,10.11,10.11,0,0,0,2.322-3.3,9.7,9.7,0,0,0,.815-3.9,9.862,9.862,0,0,0-3.138-7.2A10.934,10.934,0,0,0,12.857,2.143Z",
      "transform": "translate(5 6)",
      "fill": "#7c7c7c"
    }
  })])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "inputSearch",
    attrs: {
      "placeholder": _vm.$t('placeholder.search'),
      "id": "inputSearch"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchTitle()
      }
    }
  }), _vm._v(" "), _c('b-input-group-append', {
    staticClass: "rigth-app",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.showCollapse = !_vm.showCollapse
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "30px",
      "height": "30",
      "viewBox": "0 0 40 40",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M30.6011726,9 L9.39882738,9 C9.08108106,9 8.87887885,9.34451031 9.08108106,9.63160224 L16.8514228,20.4549679 C17.1980552,20.9143149 17.4002574,21.517208 17.4002574,22.120101 L17.4002574,31.5654254 C17.4291434,31.8812265 17.6891177,32.0821909 17.9490919,31.9673541 L22.3686544,30.3022209 C22.5130845,30.2735117 22.5997426,30.1012566 22.5997426,29.9577106 L22.5997426,22.120101 C22.5997426,21.517208 22.8019448,20.9430241 23.1485772,20.4549679 L30.9189189,9.63160224 C31.1211211,9.34451031 30.9189189,9 30.6011726,9 Z",
      "id": "Path",
      "fill": "#353639"
    }
  })])])])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCollapse),
      expression: "showCollapse"
    }],
    staticClass: "card-serch"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('biblioSegment.author'),
      "label-for": "input-sm"
    }
  }, [_c('v-select', {
    attrs: {
      "placeholder": _vm.$t('biblioSegment.selectAuthor'),
      "options": _vm.auteursList
    },
    model: {
      value: (_vm.authorModel),
      callback: function($$v) {
        _vm.authorModel = $$v
      },
      expression: "authorModel"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    slot: "no-options"
  }, [_vm._v(_vm._s(_vm.$t('biblioSegment.noOption')))]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-result"
    },
    slot: "no-result"
  }, [_vm._v(_vm._s(_vm.$t('biblioSegment.noResult')))])])], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('biblioSegment.theme'),
      "label-for": "input-sm"
    }
  }, [_c('v-select', {
    attrs: {
      "placeholder": _vm.$t('biblioSegment.selectOneTheme'),
      "options": _vm.themeList
    },
    model: {
      value: (_vm.themeModel),
      callback: function($$v) {
        _vm.themeModel = $$v
      },
      expression: "themeModel"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    slot: "no-options"
  }, [_vm._v(_vm._s(_vm.$t('biblioSegment.noOption')))]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-result"
    },
    slot: "no-result"
  }, [_vm._v(_vm._s(_vm.$t('biblioSegment.noResult')))])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.searchOption()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.search')))])], 1)], 1)]), _vm._v(" "), _c('b-col', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "cols": "1",
      "ms": "1"
    }
  }, [_c('b-button', {
    staticClass: "btn-lg-w",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addnewsegment()
      }
    }
  }, [_c('svg', {
    staticClass: "svg-m",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "23",
      "height": "23",
      "viewBox": "0 0 30 30"
    }
  }, [_c('path', {
    attrs: {
      "id": "Color",
      "d": "M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z",
      "transform": "translate(3.75 3.75)",
      "fill": "#ffffff"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-btn-add"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('button.add')) + "\n        ")])])], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "row-theme-segment"
  }, [_c('b-col', {
    staticClass: "card-theme-segment no-padding-LR",
    staticStyle: {
      "min-width": "240px"
    },
    attrs: {
      "sm": "2",
      "id": "card-theme-segment"
    }
  }, [_c('b-list-group', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('b-list-group-item', {
    staticClass: "list-group-item-s",
    on: {
      "click": function($event) {
        return _vm.allSegmentsSearch()
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "30px",
      "height": "30px",
      "viewBox": "0 0 30 30",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.7385714,16.5 C13.1657143,16.5 13.5,16.8342857 13.5,17.2614286 L13.5,17.2614286 L13.5,25.4885714 C13.5,25.9157143 13.1657143,26.25 12.7385714,26.25 L12.7385714,26.25 L4.51142857,26.25 C4.10285714,26.25 3.75,25.8971429 3.75,25.4885714 L3.75,25.4885714 L3.75,17.2614286 C3.75,16.8342857 4.08428571,16.5 4.51142857,16.5 L4.51142857,16.5 Z M25.4885714,16.5 C25.8971429,16.5 26.25,16.8528571 26.25,17.2614286 L26.25,17.2614286 L26.25,25.4885714 C26.25,25.9157143 25.9157143,26.25 25.4885714,26.25 L25.4885714,26.25 L17.2614286,26.25 C16.8342857,26.25 16.5,25.9157143 16.5,25.4885714 L16.5,25.4885714 L16.5,17.2614286 C16.5,16.8342857 16.8342857,16.5 17.2614286,16.5 L17.2614286,16.5 Z M11.9771429,18.0228571 L5.27285714,18.0228571 L5.27285714,24.7271429 L11.9771429,24.7271429 L11.9771429,18.0228571 Z M24.7271429,18.0228571 L18.0228571,18.0228571 L18.0228571,24.7271429 L24.7271429,24.7271429 L24.7271429,18.0228571 Z M12.7385714,3.75 C13.1657143,3.75 13.5,4.08428571 13.5,4.51142857 L13.5,4.51142857 L13.5,12.7385714 C13.5,13.1657143 13.1657143,13.5 12.7385714,13.5 L12.7385714,13.5 L4.51142857,13.5 C4.10285714,13.5 3.75,13.1471429 3.75,12.7385714 L3.75,12.7385714 L3.75,4.51142857 C3.75,4.08428571 4.08428571,3.75 4.51142857,3.75 L4.51142857,3.75 Z M25.4885714,3.75 C25.9157143,3.75 26.25,4.08428571 26.25,4.51142857 L26.25,4.51142857 L26.25,12.7385714 C26.25,13.1657143 25.9157143,13.5 25.4885714,13.5 L25.4885714,13.5 L17.2614286,13.5 C16.8342857,13.5 16.5,13.1657143 16.5,12.7385714 L16.5,12.7385714 L16.5,4.51142857 C16.5,4.08428571 16.8342857,3.75 17.2614286,3.75 L17.2614286,3.75 Z M11.9771429,5.27285714 L5.27285714,5.27285714 L5.27285714,11.9771429 L11.9771429,11.9771429 L11.9771429,5.27285714 Z M24.7271429,5.27285714 L18.0228571,5.27285714 L18.0228571,11.9771429 L24.7271429,11.9771429 L24.7271429,5.27285714 Z",
      "id": "Color",
      "fill": "#353639"
    }
  })])]), _vm._v("\n          " + _vm._s(_vm.$t('biblioSegment.allSegments')))]), _vm._v(" "), _vm._l((_vm.getThemesList), function(theme, index) {
    return _c('b-list-group-item', {
      key: index,
      staticClass: "list-group-item-s",
      on: {
        "click": function($event) {
          _vm.setTheme(theme);
          _vm.oldTheme = theme;
        }
      }
    }, [_c('svg', {
      attrs: {
        "width": "30px",
        "height": "30px",
        "viewBox": "0 0 30 30",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_c('g', {
      attrs: {
        "id": "Icon/30/Folder",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('path', {
      attrs: {
        "d": "M23.1432119,3.75 C23.6164029,3.75 24,4.13744589 24,4.61538462 L24.0010217,6.92120039 C25.3074906,7.35836309 26.2485229,8.58384412 26.25,10.0277778 L26.25,22.9722222 C26.2478411,24.7816005 24.7706423,26.2478571 22.9477612,26.25 L7.05223881,26.25 C5.22922997,26.2481626 3.75185109,24.7817273 3.75,22.9722222 L3.75,14.9166667 C3.75174771,13.2082172 5.0688174,11.8055885 6.75024042,11.6527052 L6.75,4.61538462 C6.75,4.13744589 7.13359709,3.75 7.60678808,3.75 L23.1432119,3.75 Z M22.9477612,8.41666667 L17.566791,8.41666667 C16.6703587,8.41666667 15.9436567,9.13798568 15.9436567,10.0277778 C15.9414978,11.8371561 14.464299,13.3034126 12.6414179,13.3055556 L7.05223881,13.3055556 C6.15580647,13.3055556 5.42910448,14.0268746 5.42910448,14.9166667 L5.42910448,22.9722222 C5.42910448,23.8620143 6.15580647,24.5833333 7.05223881,24.5833333 L22.9477612,24.5833333 C23.8441935,24.5833333 24.5708955,23.8620143 24.5708955,22.9722222 L24.5708955,10.0277778 C24.5708955,9.13798568 23.8441935,8.41666667 22.9477612,8.41666667 Z M22.2864238,5.48076923 L8.46357616,5.48076923 L8.463,11.638 L12.6414179,11.6388889 C13.4880485,11.6388889 14.1832837,10.9954901 14.257919,10.1744217 L14.2645522,10.0277778 C14.2664033,8.21827271 15.7437822,6.75183737 17.566791,6.75 L22.286,6.75 L22.2864238,5.48076923 Z",
        "id": "Color",
        "fill": "#353639"
      }
    })])]), _vm._v("\n          " + _vm._s(theme.name) + "\n        ")])
  })], 2)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "custom-mb-row"
  }, [_c('b-row', {
    staticClass: "row-m"
  }, [_c('b-col', {
    staticClass: "menu-theme",
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "cols": "1"
    }
  }, [_c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "pointer",
    attrs: {
      "width": "40px",
      "height": "40px",
      "viewBox": "0 0 40 40",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    },
    on: {
      "click": function($event) {
        return _vm.openMenu()
      }
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M29.3333333,6 C31.8325613,6 33.8729254,7.96462988 33.9942888,10.4337529 L34,10.6666667 L34,29.3333333 C34,31.8325613 32.0353701,33.8729254 29.5662471,33.9942888 L29.3333333,34 L10.6666667,34 C8.16743871,34 6.12707464,32.0353701 6.00571119,29.5662471 L6,29.3333333 L6,10.6666667 C6,8.16743871 7.96462988,6.12707464 10.4337529,6.00571119 L10.6666667,6 L29.3333333,6 Z M29.3333333,8.33333333 L10.6666667,8.33333333 C9.43657791,8.33333333 8.42880736,9.28519076 8.33973336,10.4925273 L8.33333333,10.6666667 L8.33333333,29.3333333 C8.33333333,30.5634221 9.28519076,31.5711926 10.4925273,31.6602666 L10.6666667,31.6666667 L29.3333333,31.6666667 C30.5634221,31.6666667 31.5711926,30.7148092 31.6602666,29.5074727 L31.6666667,29.3333333 L31.6666667,10.6666667 C31.6666667,9.43657791 30.7148092,8.42880736 29.5074727,8.33973336 L29.3333333,8.33333333 Z M27,24.6666667 C27.6443322,24.6666667 28.1666667,25.1890011 28.1666667,25.8333333 C28.1666667,26.4316418 27.7162864,26.9247584 27.136058,26.992151 L27,27 L13,27 C12.3556678,27 11.8333333,26.4776655 11.8333333,25.8333333 C11.8333333,25.2350249 12.2837136,24.7419083 12.863942,24.6745157 L13,24.6666667 L27,24.6666667 Z M27,18.8333333 C27.6443322,18.8333333 28.1666667,19.3556678 28.1666667,20 C28.1666667,20.5983085 27.7162864,21.091425 27.136058,21.1588176 L27,21.1666667 L13,21.1666667 C12.3556678,21.1666667 11.8333333,20.6443322 11.8333333,20 C11.8333333,19.4016915 12.2837136,18.908575 12.863942,18.8411824 L13,18.8333333 L27,18.8333333 Z M27,13 C27.6443322,13 28.1666667,13.5223345 28.1666667,14.1666667 C28.1666667,14.7649751 27.7162864,15.2580917 27.136058,15.3254843 L27,15.3333333 L13,15.3333333 C12.3556678,15.3333333 11.8333333,14.8109989 11.8333333,14.1666667 C11.8333333,13.5683582 12.2837136,13.0752416 12.863942,13.007849 L13,13 L27,13 Z",
      "id": "Shape",
      "fill": "#7c7c7c"
    }
  })])]), _vm._v(" "), _c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isOpen),
      expression: "!isOpen"
    }],
    staticClass: "pointer",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "40",
      "height": "40",
      "viewBox": "0 0 40 40"
    },
    on: {
      "click": function($event) {
        return _vm.openMenu()
      }
    }
  }, [_c('path', {
    attrs: {
      "id": "Path",
      "d": "M.42,2.49A1.486,1.486,0,0,1,.42.42a1.486,1.486,0,0,1,2.07,0L14.911,12.862,27.353.42A1.456,1.456,0,1,1,29.4,2.49L16.981,14.912,29.4,27.354a1.456,1.456,0,1,1-2.049,2.07L14.911,16.982,2.49,29.424a1.486,1.486,0,0,1-2.07,0,1.486,1.486,0,0,1,0-2.07L12.841,14.912Z",
      "transform": "translate(5.003 5)",
      "fill": "#7c7c7c"
    }
  })])]), _vm._v(" "), _c('b-col', {
    staticClass: " padding-l-c padding-l",
    staticStyle: {
      "padding-right": "0px!important"
    }
  }, [_c('b-breadcrumb', [_vm._v("\n            " + _vm._s(_vm.$t('biblioSegment.allSegments')) + "\n            "), _c('span', [_vm._v(_vm._s(_vm.currentTheme))])])], 1)], 1), _vm._v(" "), _c('not-found', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNotFoundCard && _vm.DefaultSegments.length == 0),
      expression: "showNotFoundCard && DefaultSegments.length == 0"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "default-modules"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-right": "0px!important"
    }
  }, _vm._l((_vm.DefaultSegments), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "one-disposition col-xl-3 col-lg-4 col-md-6 col-sm-6 "
    }, [_c('card-segment', {
      key: item.uid,
      attrs: {
        "index": index,
        "have-screen": item.screens.length > 1,
        "Shot": item.screens[0] ? item.screens[0].screenShot : null,
        "isHover": true,
        "id": item.id,
        "item": item,
        "ModalSegment": true,
        "title": item.title,
        "itemsegment": item,
        "isSelected": _vm.selecteIdSegment.includes(item.id)
      },
      on: {
        "selected": function($event) {
          return _vm.addSegment(item)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), _c('infinite-loading', {
    attrs: {
      "spinner": "bubbles",
      "distance": 10,
      "direction": 'bottom'
    },
    on: {
      "infinite": _vm.loadMoreSegments
    }
  }, [(_vm.isEndReached('DefaultSegment')) ? _c('div', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.DefaultSegments.length === 0),
      expression: "DefaultSegments.length === 0"
    }],
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v("\n            " + _vm._s('') + "\n          ")])])], 1)], 1)], 1), _vm._v(" "), (Object.assign({}, _vm.currentSegment) !== {}) ? _c('screen-in-segment') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 838 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "modal-screens"
    }
  }, [_c('b-modal', {
    ref: "modal-slides",
    attrs: {
      "id": "modal-slides",
      "hide-footer": "",
      "hide-header": "",
      "size": "xl"
    }
  }, [_c('div', [_c('div', {
    staticClass: "left-icon-svg"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "40",
      "height": "40",
      "viewBox": "0 0 40 40"
    }
  }, [_c('path', {
    attrs: {
      "d": "M38.334,31.667v-30A1.574,1.574,0,0,1,40,0V33.333A1.574,1.574,0,0,1,38.334,31.667ZM0,0A1.575,1.575,0,0,1,1.667,1.667v30A1.575,1.575,0,0,1,0,33.333ZM33.333,28.333V5A1.574,1.574,0,0,1,35,3.334V30A1.574,1.574,0,0,1,33.333,28.333ZM5,3.334A1.574,1.574,0,0,1,6.666,5V28.333A1.574,1.574,0,0,1,5,30Zm6.666,23.333A1.578,1.578,0,0,1,10,25V8.333a1.578,1.578,0,0,1,1.667-1.667H28.333A1.578,1.578,0,0,1,30,8.333V25a1.578,1.578,0,0,1-1.667,1.667Zm1.667-3.333H26.667V10H13.333Z",
      "transform": "translate(0 3)",
      "fill": "#88898d"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "right-icon-svg"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "40",
      "height": "40",
      "viewBox": "0 0 40 40",
      "id": "x-btn"
    },
    on: {
      "click": function($event) {
        return _vm.closeScreens()
      }
    }
  }, [_c('path', {
    attrs: {
      "d": "M.42,2.49A1.486,1.486,0,0,1,.42.42a1.486,1.486,0,0,1,2.07,0L14.911,12.862,27.353.42A1.456,1.456,0,1,1,29.4,2.49L16.981,14.912,29.4,27.354a1.456,1.456,0,1,1-2.049,2.07L14.911,16.982,2.49,29.424a1.486,1.486,0,0,1-2.07,0,1.486,1.486,0,0,1,0-2.07L12.841,14.912Z",
      "transform": "translate(5.003 5)",
      "fill": "#D9D9DC"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "img-in"
  }, [_c('div', {
    staticClass: "image-wrapper-one"
  }, [_c('img', {
    staticClass: "showScreen",
    attrs: {
      "src": _vm.currentShot
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "slides-carousel"
  }, [_c('carousel', {
    attrs: {
      "per-page-custom": [
        [320, 1],
        [576, 2],
        [768, 3],
        [992, 4],
        [1200, 4]
      ],
      "navigation-prev-label": "<span><img  style='\n        width: 1.5em;\n      ' src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC41MzEgNDQ0LjUzMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjUzMSA0NDQuNTMxOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTIxMy4xMywyMjIuNDA5TDM1MS44OCw4My42NTNjNy4wNS03LjA0MywxMC41NjctMTUuNjU3LDEwLjU2Ny0yNS44NDFjMC0xMC4xODMtMy41MTgtMTguNzkzLTEwLjU2Ny0yNS44MzUgICBsLTIxLjQwOS0yMS40MTZDMzIzLjQzMiwzLjUyMSwzMTQuODE3LDAsMzA0LjYzNywwcy0xOC43OTEsMy41MjEtMjUuODQxLDEwLjU2MUw5Mi42NDksMTk2LjQyNSAgIGMtNy4wNDQsNy4wNDMtMTAuNTY2LDE1LjY1Ni0xMC41NjYsMjUuODQxczMuNTIxLDE4Ljc5MSwxMC41NjYsMjUuODM3bDE4Ni4xNDYsMTg1Ljg2NGM3LjA1LDcuMDQzLDE1LjY2LDEwLjU2NCwyNS44NDEsMTAuNTY0ICAgczE4Ljc5NS0zLjUyMSwyNS44MzQtMTAuNTY0bDIxLjQwOS0yMS40MTJjNy4wNS03LjAzOSwxMC41NjctMTUuNjA0LDEwLjU2Ny0yNS42OTdjMC0xMC4wODUtMy41MTgtMTguNzQ2LTEwLjU2Ny0yNS45NzggICBMMjEzLjEzLDIyMi40MDl6IiBmaWxsPSIjYTZhNmE2Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=='/></span>",
      "navigation-next-label": "<span><img style='\n        width: 1.5em;\n      ' src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC44MTkgNDQ0LjgxOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjgxOSA0NDQuODE5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTM1Mi4wMjUsMTk2LjcxMkwxNjUuODg0LDEwLjg0OEMxNTkuMDI5LDMuNjE1LDE1MC40NjksMCwxNDAuMTg3LDBjLTEwLjI4MiwwLTE4Ljg0MiwzLjYxOS0yNS42OTcsMTAuODQ4TDkyLjc5MiwzMi4yNjQgICBjLTcuMDQ0LDcuMDQzLTEwLjU2NiwxNS42MDQtMTAuNTY2LDI1LjY5MmMwLDkuODk3LDMuNTIxLDE4LjU2LDEwLjU2NiwyNS45ODFsMTM4Ljc1MywxMzguNDczTDkyLjc4NiwzNjEuMTY4ICAgYy03LjA0Miw3LjA0My0xMC41NjQsMTUuNjA0LTEwLjU2NCwyNS42OTNjMCw5Ljg5NiwzLjUyMSwxOC41NjIsMTAuNTY0LDI1Ljk4bDIxLjcsMjEuNDEzICAgYzcuMDQzLDcuMDQzLDE1LjYxMiwxMC41NjQsMjUuNjk3LDEwLjU2NGMxMC4wODksMCwxOC42NTYtMy41MjEsMjUuNjk3LTEwLjU2NGwxODYuMTQ1LTE4NS44NjQgICBjNy4wNDYtNy40MjMsMTAuNTcxLTE2LjA4NCwxMC41NzEtMjUuOTgxQzM2Mi41OTcsMjEyLjMyMSwzNTkuMDcxLDIwMy43NTUsMzUyLjAyNSwxOTYuNzEyeiIgZmlsbD0iI2EwYTBhMCIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo='/></span>",
      "navigation-enabled": true,
      "pagination-enabled": false
    }
  }, _vm._l((_vm.getScreens()), function(item) {
    return _c('slide', {
      key: item.uid,
      staticClass: "slideForImg"
    }, [_c('div', {
      staticClass: "slide-image-wrapper"
    }, [_c('img', {
      attrs: {
        "src": item.screenShot ? item.screenShot : _vm.screenShot
      },
      on: {
        "mouseover": function($event) {
          return _vm.showThis(item)
        }
      }
    })])])
  }), 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 839 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "0",
      "overflow": "hidden",
      "background": "#e2e5ec"
    },
    attrs: {
      "id": "gjs"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 840 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-cards-actions-wrapper"
  }, [(!_vm.isEditMode) ? _c('ul', {
    staticClass: "list-unstyled m-0"
  }, [_c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showEditTitlePanel($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" " + _vm._s(_vm.$t('panels.edit_title')) + "\n    ")]), _vm._v(" "), (_vm.showBtnDuration) ? _c('li', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('edit_duration_segment_action'),
      expression: "'edit_duration_segment_action'"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showEditDurationPanel($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(_vm._s(_vm.$t('panels.duration')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRemovable),
      expression: "isRemovable"
    }, {
      name: "close-popover",
      rawName: "v-close-popover.all",
      modifiers: {
        "all": true
      }
    }],
    staticClass: "text-danger",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleDelete($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" " + _vm._s(_vm.$t('panels.deleteScreen')) + "\n    ")])]) : _c('div', {
    staticClass: "edit-panel",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "actions-wrapper"
  }, [_c('button', {
    staticClass: "btn btn-link btn-sm cancel-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleEditMode(true)
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-left-alt"
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "close-popover",
      rawName: "v-close-popover.all",
      modifiers: {
        "all": true
      }
    }],
    ref: "closeBtn",
    attrs: {
      "hidden": ""
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link btn-sm cancel-btn",
    on: {
      "click": _vm.closePopover
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode === 'title'),
      expression: "editMode === 'title'"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('panels.edit_title')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "title": _vm.$t('panels.title'),
      "placeholder": _vm.$t('panels.title'),
      "type": "text",
      "maxlength": _vm.getmaxLength
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        return _vm.handleUpdate()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode === 'duration'),
      expression: "editMode === 'duration'"
    }],
    staticClass: "form-group",
    class: {
      'has-error': _vm.hasError
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('panels.duration')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.durationInput),
      expression: "durationInput"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "title": _vm.$t('panels.duration'),
      "placeholder": _vm.$t('panels.duration'),
      "type": "text"
    },
    domProps: {
      "value": (_vm.durationInput)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        return _vm.handleUpdate()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.durationInput = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasError) ? _c('small', {
    staticClass: "text-error"
  }, [_vm._v("Valeur invalide!")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-link btn-sm save-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleUpdate()
      }
    }
  }, [_c('span', {
    staticClass: "icon-save"
  })])])])])])
},staticRenderFns: []}

/***/ }),
/* 841 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-informations",
    class: {
      'segment-infos': _vm.isSegmentMode
    },
    attrs: {
      "id": "list-informations"
    }
  }, [(_vm.isSegmentMode && Object.keys(_vm.segment).length !== 0) ? _c('div', {
    staticStyle: {
      "width": "250px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showpop),
      expression: "showpop"
    }],
    staticClass: "info-pop cnqr-popover",
    staticStyle: {
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        _vm.showpop = false
      }
    }
  }, [_c('b-row', {
    staticClass: "content text-m"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('panels.infos.name_segment')) + "\n        " + _vm._s(_vm.segment.title) + "\n      ")]), _vm._v(" "), _c('b-row', {
    staticClass: "content  text-m content__duration"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('panels.infos.duration_total')) + "\n        " + _vm._s(_vm._f("FormatTime")(_vm.totalDurationScreens)) + "\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-info-c",
    on: {
      "click": function($event) {
        _vm.showpop = !_vm.showpop
      }
    }
  }, [_c('span', {
    staticClass: "mr-2 fa fa-info-circle"
  }), _vm._v(_vm._s(_vm.$t('panels.infos.title')) + "\n    ")])]) : _vm._e(), _vm._v(" "), (!_vm.isSegmentMode && Object.keys(_vm.template).length !== 0) ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showpop),
      expression: "showpop"
    }],
    staticClass: "info-pop cnqr-popover arrow top info-pop-3",
    staticStyle: {
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        _vm.showpop = false
      }
    }
  }, [_c('b-row', {
    staticClass: " text-m content"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('panels.infos.name_template')) + "\n        " + _vm._s(_vm.template.title) + "\n      ")]), _vm._v(" "), _c('b-row', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('initialize_duration_template_action'),
      expression: "'initialize_duration_template_action'"
    }],
    staticClass: "content text-m content__duration"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('panels.infos.duration_template')) + "\n        "), (_vm.isEditMode) ? _c('span', [_vm._v(" " + _vm._s(_vm.Getduration(_vm.template.duration)))]) : _c('span', [_vm._v(" " + _vm._s(_vm.template.duration))])]), _vm._v(" "), (_vm.paramsClient.default_segment_duration !== null) ? _c('b-row', {
    staticClass: "content content__duration text-m "
  }, [_vm._v("\n        " + _vm._s(_vm.$t('panels.infos.duration_total')) + "\n        " + _vm._s(_vm._f("FormatTime")((_vm.totalDurationSegments - 2))) + "\n      ")]) : _c('b-row', {
    staticClass: "content content__duration text-m "
  }, [_vm._v("\n        " + _vm._s(_vm.$t('panels.infos.duration_total')) + "\n        " + _vm._s(_vm._f("FormatTime")((_vm.totalDurationSegments))) + "\n      ")]), _vm._v(" "), _c('b-row', {
    staticClass: "content content__duration text-m"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('panels.infos.size_template')) + " " + _vm._s(_vm.canvasSize.width) + " x " + _vm._s(_vm.canvasSize.height) + "\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-info-c",
    on: {
      "click": function($event) {
        _vm.showpop = !_vm.showpop
      }
    }
  }, [_c('span', {
    staticClass: "mr-2 fa fa-info-circle"
  }), _vm._v(_vm._s(_vm.$t('panels.infos.title')) + "\n    ")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 842 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-dispo",
    attrs: {
      "id": "list-video"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body list_video_content",
    attrs: {
      "id": "list_video"
    }
  }, [_c('div', {
    staticClass: "search-wrapper-list",
    attrs: {
      "id": "search-list"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-input-group', [_c('b-form-input', {
    staticClass: "searchInput",
    attrs: {
      "placeholder": _vm.$t('placeholder.search'),
      "id": "inputVideoSearch"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchVideo()
      }
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    staticClass: "searchIcon",
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.searchVideo()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSelect),
      expression: "showSelect"
    }]
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    on: {
      "change": function($event) {
        return _vm.onChangeThemId()
      }
    },
    model: {
      value: (_vm.idSelectedTheme),
      callback: function($$v) {
        _vm.idSelectedTheme = $$v
      },
      expression: "idSelectedTheme"
    }
  }, [_c('template', {
    slot: "first"
  }, _vm._l((this.options), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.title,
        "value": option.id
      }
    }, [_vm._v("\n                  " + _vm._s(option.title) + "\n                ")])
  }), 0)], 2)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, _vm._l((_vm.all_video), function(video, index) {
    return _c('div', {
      staticClass: "video-wrapper"
    }, [_c('div', {
      class: [
        'video-tag',
        {
          'is-selected-video': _vm.selected_vid === video.id || (!_vm.selected_vid && _vm.isSelected(video)),
        } ]
    }, [_c('div', {
      staticClass: "image-card",
      on: {
        "click": function($event) {
          return _vm.SelectVideo(video)
        }
      }
    }, [_c('div', {
      staticClass: "image-card__video"
    }, [(video.logo) ? _c('img', {
      staticClass: "img-liste-dispo",
      attrs: {
        "src": video.logo,
        "id": video.id
      }
    }) : _c('img', {
      staticClass: "img-liste-dispo",
      attrs: {
        "src": _vm.defaultScreenshot,
        "alt": "alt_img",
        "id": video.id
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: " image-card__infos__title",
      attrs: {
        "title": video.title
      }
    }, [_vm._v("\n                " + _vm._s(video.title) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: " image-card__infos__duration duration-style",
      attrs: {
        "title": video.duration
      }
    }, [_vm._v("\n                " + _vm._s(_vm.duration(video.duration)) + "\n              ")]), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selected_vid === video.id || (!_vm.selected_vid && _vm.isSelected(video))),
        expression: "selected_vid === video.id || (!selected_vid && isSelected(video))"
      }],
      staticClass: "tick-img",
      attrs: {
        "src": "/display/static/images/tick.svg"
      }
    })])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: " center",
    attrs: {
      "id": "loader-liste-dispo"
    }
  }, [_c('span', [_c('infinite-loading', {
    attrs: {
      "spinner": "bubbles"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer footer-content"
  }, [_c('button', {
    class: ['btn btn-link', 'footer-select-button'],
    attrs: {
      "disabled": _vm.disabledSelectButton || _vm.isSelected(_vm.videoGeneric)
    },
    on: {
      "click": function($event) {
        return _vm.DeselectVideo()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.deselect')) + "\n      ")]), _vm._v(" "), _c('button', {
    class: ['btn btn-primary', 'footer-select-button'],
    attrs: {
      "disabled": _vm.disabledSelectButton || _vm.isSelected(_vm.videoGeneric)
    },
    on: {
      "click": function($event) {
        return _vm.addGeneriqueVideo()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.select')) + "\n      ")])])])])
},staticRenderFns: []}

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fitpanel",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        _vm.scale('Minus');
        _vm.showinfo = true
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "20",
      "viewBox": "0 0 39.214 39.214"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#ffffff",
      "d": "M52.256,47.635l-8.295-8.295a16.368,16.368,0,1,0-4.621,4.621l8.295,8.295a3.267,3.267,0,0,0,4.621-4.621ZM18.9,30.339A11.437,11.437,0,1,1,30.339,41.776,11.45,11.45,0,0,1,18.9,30.339Z",
      "transform": "translate(-14 -14)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#ffffff",
      "d": "M45.58,33.484a1.658,1.658,0,0,1-1.658,1.658H30.658a1.658,1.658,0,1,1,0-3.316H43.922A1.658,1.658,0,0,1,45.58,33.484Z",
      "transform": "translate(-20.916 -17.11)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "fitpaneltext cursor",
    on: {
      "click": function($event) {
        _vm.showinfo = !_vm.showinfo
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.value) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        _vm.scale('Plus');
        _vm.showinfo = true
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "20",
      "viewBox": "0 0 39.214 39.214"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#ffffff",
      "d": "M52.256,47.635l-8.295-8.295a16.368,16.368,0,1,0-4.621,4.621l8.295,8.295a3.267,3.267,0,0,0,4.621-4.621ZM18.9,30.339A11.437,11.437,0,1,1,30.339,41.776,11.45,11.45,0,0,1,18.9,30.339Z",
      "transform": "translate(-14 -14)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#ffffff",
      "d": "M45.58,37.29a1.658,1.658,0,0,1-1.658,1.658H38.948v4.974a1.658,1.658,0,0,1-3.316,0V38.948H30.658a1.658,1.658,0,1,1,0-3.316h4.974V30.658a1.658,1.658,0,1,1,3.316,0v4.974h4.974A1.658,1.658,0,0,1,45.58,37.29Z",
      "transform": "translate(-20.916 -20.916)"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 844 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "segment-list"
    }
  }, [_c('b-modal', {
    attrs: {
      "id": "segment-list-modal",
      "size": "xl",
      "noCloseOnBackdrop": true,
      "noCloseOnEsc": true
    },
    on: {
      "shown": _vm.loadMore
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function() {
        return [_c('h5', {
          staticClass: "title"
        }, [_vm._v("\n        " + _vm._s(_vm.getModalTitle) + "\n      ")]), _vm._v(" "), _c('div', {
          staticClass: "gjs-mdl-btn-close",
          staticStyle: {
            "top": "0.25em!important"
          },
          attrs: {
            "id": "close-modal-segment-list",
            "data-close-modal": ""
          },
          on: {
            "click": _vm.cancel
          }
        }, [_vm._v("x")])]
      },
      proxy: true
    }, {
      key: "modal-footer",
      fn: function() {
        return [(_vm.nbrCall > 1 || _vm.editMode) ? _c('button', {
          staticClass: "btn btn-link",
          on: {
            "click": _vm.cancel
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$t('button.cancel')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.nbrCall === 1 && !_vm.editMode) ? _c('button', {
          staticClass: "btn btn-primary",
          on: {
            "click": _vm.back
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$t('button.back')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('button', {
          staticClass: "btn btn-primary",
          attrs: {
            "disabled": _vm.ButtonDisabled
          },
          on: {
            "click": _vm.confirm
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$t('button.confirm')) + "\n      ")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', [_c('div', {
    staticClass: "section-segment"
  }, [_c('b-row', {
    staticClass: "mb-2 mx-1 d-flex justify-content-between"
  }, [(
    _vm.nbrCall === 1 &&
    !_vm.editMode &&
    _vm.$route.params.type !== 'NewSegment' &&
    _vm.$route.params.type !== 'EditSegment'
  ) ? _c('b-col', {
    staticClass: "section-segment__title"
  }, [_c('b-form-group', [_c('b-form-input', {
    attrs: {
      "id": "input-titre",
      "placeholder": _vm.$t('panels.newSegment'),
      "autofocus": "",
      "maxlength": _vm.getmaxLength
    },
    model: {
      value: (_vm.titleSegment),
      callback: function($$v) {
        _vm.titleSegment = $$v
      },
      expression: "titleSegment"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('slide-card', {
    class: {
      disabled: _vm.selected.length >= _vm.permission.nb_screen_segment &&
        !_vm.selectedIds.includes(_vm.emptyDisposition.id) &&
        _vm.getNbSreenSegment,
    },
    attrs: {
      "isEditable": false,
      "isHover": false,
      "item": _vm.emptyDisposition,
      "isSelected": _vm.selectedIds.includes(_vm.emptyDisposition.id)
    },
    on: {
      "selected": function($event) {
        return _vm.select(_vm.emptyDisposition)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section-disposition section-disposition__title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('labels.models')))])]), _vm._v(" "), _c('div', {
    staticClass: " slides-carousel"
  }, [_c('carousel', {
    attrs: {
      "navigation-prev-label": "<span><img src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC41MzEgNDQ0LjUzMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjUzMSA0NDQuNTMxOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTIxMy4xMywyMjIuNDA5TDM1MS44OCw4My42NTNjNy4wNS03LjA0MywxMC41NjctMTUuNjU3LDEwLjU2Ny0yNS44NDFjMC0xMC4xODMtMy41MTgtMTguNzkzLTEwLjU2Ny0yNS44MzUgICBsLTIxLjQwOS0yMS40MTZDMzIzLjQzMiwzLjUyMSwzMTQuODE3LDAsMzA0LjYzNywwcy0xOC43OTEsMy41MjEtMjUuODQxLDEwLjU2MUw5Mi42NDksMTk2LjQyNSAgIGMtNy4wNDQsNy4wNDMtMTAuNTY2LDE1LjY1Ni0xMC41NjYsMjUuODQxczMuNTIxLDE4Ljc5MSwxMC41NjYsMjUuODM3bDE4Ni4xNDYsMTg1Ljg2NGM3LjA1LDcuMDQzLDE1LjY2LDEwLjU2NCwyNS44NDEsMTAuNTY0ICAgczE4Ljc5NS0zLjUyMSwyNS44MzQtMTAuNTY0bDIxLjQwOS0yMS40MTJjNy4wNS03LjAzOSwxMC41NjctMTUuNjA0LDEwLjU2Ny0yNS42OTdjMC0xMC4wODUtMy41MTgtMTguNzQ2LTEwLjU2Ny0yNS45NzggICBMMjEzLjEzLDIyMi40MDl6IiBmaWxsPSIjYTZhNmE2Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=='/></span>",
      "navigation-next-label": "<span><img src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC44MTkgNDQ0LjgxOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjgxOSA0NDQuODE5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTM1Mi4wMjUsMTk2LjcxMkwxNjUuODg0LDEwLjg0OEMxNTkuMDI5LDMuNjE1LDE1MC40NjksMCwxNDAuMTg3LDBjLTEwLjI4MiwwLTE4Ljg0MiwzLjYxOS0yNS42OTcsMTAuODQ4TDkyLjc5MiwzMi4yNjQgICBjLTcuMDQ0LDcuMDQzLTEwLjU2NiwxNS42MDQtMTAuNTY2LDI1LjY5MmMwLDkuODk3LDMuNTIxLDE4LjU2LDEwLjU2NiwyNS45ODFsMTM4Ljc1MywxMzguNDczTDkyLjc4NiwzNjEuMTY4ICAgYy03LjA0Miw3LjA0My0xMC41NjQsMTUuNjA0LTEwLjU2NCwyNS42OTNjMCw5Ljg5NiwzLjUyMSwxOC41NjIsMTAuNTY0LDI1Ljk4bDIxLjcsMjEuNDEzICAgYzcuMDQzLDcuMDQzLDE1LjYxMiwxMC41NjQsMjUuNjk3LDEwLjU2NGMxMC4wODksMCwxOC42NTYtMy41MjEsMjUuNjk3LTEwLjU2NGwxODYuMTQ1LTE4NS44NjQgICBjNy4wNDYtNy40MjMsMTAuNTcxLTE2LjA4NCwxMC41NzEtMjUuOTgxQzM2Mi41OTcsMjEyLjMyMSwzNTkuMDcxLDIwMy43NTUsMzUyLjAyNSwxOTYuNzEyeiIgZmlsbD0iI2EwYTBhMCIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo='/></span>",
      "mouse-drag": false,
      "navigation-enabled": true,
      "pagination-enabled": false,
      "per-page-custom": [
        [320, 1],
        [576, 2],
        [768, 2],
        [992, 4],
        [1200, 4]
      ]
    },
    on: {
      "pageChange": function($event) {
        return _vm.pageChanged('Disposition')
      }
    }
  }, _vm._l((_vm.dispositions), function(item) {
    return _c('slide', {
      key: item.uid,
      staticClass: "one-disposition"
    }, [_c('slide-card', {
      class: {
        disabled: _vm.selected.length >= _vm.permission.nb_screen_segment &&
          !_vm.selectedIds.includes(item.id) &&
          _vm.getNbSreenSegment,
      },
      attrs: {
        "Shot": item.screenShot ? item.screenShot : null,
        "isHover": false,
        "item": item,
        "isSelected": _vm.selectedIds.includes(item.id)
      },
      on: {
        "selected": function($event) {
          return _vm.select(item)
        }
      }
    })], 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AllScreens.length > 0),
      expression: "AllScreens.length > 0"
    }],
    staticClass: "section-screen section-screen__title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('labels.recent')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AllScreens.length !== 0),
      expression: "AllScreens.length !== 0"
    }],
    staticClass: " slides-carousel"
  }, [_c('carousel', {
    attrs: {
      "navigation-prev-label": "<span><img src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC41MzEgNDQ0LjUzMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjUzMSA0NDQuNTMxOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTIxMy4xMywyMjIuNDA5TDM1MS44OCw4My42NTNjNy4wNS03LjA0MywxMC41NjctMTUuNjU3LDEwLjU2Ny0yNS44NDFjMC0xMC4xODMtMy41MTgtMTguNzkzLTEwLjU2Ny0yNS44MzUgICBsLTIxLjQwOS0yMS40MTZDMzIzLjQzMiwzLjUyMSwzMTQuODE3LDAsMzA0LjYzNywwcy0xOC43OTEsMy41MjEtMjUuODQxLDEwLjU2MUw5Mi42NDksMTk2LjQyNSAgIGMtNy4wNDQsNy4wNDMtMTAuNTY2LDE1LjY1Ni0xMC41NjYsMjUuODQxczMuNTIxLDE4Ljc5MSwxMC41NjYsMjUuODM3bDE4Ni4xNDYsMTg1Ljg2NGM3LjA1LDcuMDQzLDE1LjY2LDEwLjU2NCwyNS44NDEsMTAuNTY0ICAgczE4Ljc5NS0zLjUyMSwyNS44MzQtMTAuNTY0bDIxLjQwOS0yMS40MTJjNy4wNS03LjAzOSwxMC41NjctMTUuNjA0LDEwLjU2Ny0yNS42OTdjMC0xMC4wODUtMy41MTgtMTguNzQ2LTEwLjU2Ny0yNS45NzggICBMMjEzLjEzLDIyMi40MDl6IiBmaWxsPSIjYTZhNmE2Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=='/></span>",
      "navigation-next-label": "<span><img src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC44MTkgNDQ0LjgxOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjgxOSA0NDQuODE5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTM1Mi4wMjUsMTk2LjcxMkwxNjUuODg0LDEwLjg0OEMxNTkuMDI5LDMuNjE1LDE1MC40NjksMCwxNDAuMTg3LDBjLTEwLjI4MiwwLTE4Ljg0MiwzLjYxOS0yNS42OTcsMTAuODQ4TDkyLjc5MiwzMi4yNjQgICBjLTcuMDQ0LDcuMDQzLTEwLjU2NiwxNS42MDQtMTAuNTY2LDI1LjY5MmMwLDkuODk3LDMuNTIxLDE4LjU2LDEwLjU2NiwyNS45ODFsMTM4Ljc1MywxMzguNDczTDkyLjc4NiwzNjEuMTY4ICAgYy03LjA0Miw3LjA0My0xMC41NjQsMTUuNjA0LTEwLjU2NCwyNS42OTNjMCw5Ljg5NiwzLjUyMSwxOC41NjIsMTAuNTY0LDI1Ljk4bDIxLjcsMjEuNDEzICAgYzcuMDQzLDcuMDQzLDE1LjYxMiwxMC41NjQsMjUuNjk3LDEwLjU2NGMxMC4wODksMCwxOC42NTYtMy41MjEsMjUuNjk3LTEwLjU2NGwxODYuMTQ1LTE4NS44NjQgICBjNy4wNDYtNy40MjMsMTAuNTcxLTE2LjA4NCwxMC41NzEtMjUuOTgxQzM2Mi41OTcsMjEyLjMyMSwzNTkuMDcxLDIwMy43NTUsMzUyLjAyNSwxOTYuNzEyeiIgZmlsbD0iI2EwYTBhMCIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo='/></span>",
      "mouse-drag": false,
      "navigation-enabled": true,
      "pagination-enabled": false,
      "per-page-custom": [
        [320, 1],
        [576, 2],
        [768, 3],
        [992, 4],
        [1200, 4]
      ]
    },
    on: {
      "pageChange": function($event) {
        return _vm.pageChanged('Screen')
      }
    }
  }, _vm._l((_vm.AllScreens), function(item) {
    return _c('slide', {
      key: item.uid,
      staticClass: "one-screen"
    }, [_c('slide-card', {
      class: {
        disabled: _vm.selected.length >= _vm.permission.nb_screen_segment &&
          !_vm.selectedIds.includes(item.id) &&
          _vm.getNbSreenSegment,
      },
      attrs: {
        "item": item,
        "Shot": item.screenShot ? item.screenShot : null,
        "isSelected": _vm.selectedIds.includes(item.id)
      },
      on: {
        "selected": function($event) {
          return _vm.select(item)
        }
      }
    })], 1)
  }), 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 845 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide",
    class: {
      selected: _vm.isSelected,
      'edit-mode': _vm.isEditMode,
    },
    on: {
      "click": function($event) {
        return _vm.$emit('selected')
      }
    }
  }, [_c('div', {
    staticClass: "image-wrapper"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditMode),
      expression: "!isEditMode"
    }],
    staticClass: "tick-img",
    attrs: {
      "src": "/display/static/images/tick.svg"
    }
  }), _vm._v(" "), (_vm.oldImages) ? _c('img', {
    staticClass: "img-fluid",
    staticStyle: {
      "left": "0"
    },
    attrs: {
      "src": _vm.getShot,
      "id": _vm.item.id,
      "loading": "lazy",
      "decoding": "async",
      "index": !_vm.oldImages
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.oldImages) ? _c('img', {
    staticClass: "img-fluid",
    staticStyle: {
      "left": "0"
    },
    attrs: {
      "src": _vm.getShot,
      "id": _vm.item.id,
      "loading": "lazy",
      "decoding": "async",
      "index": _vm.oldImages
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "title-screen"
  }, [(_vm.paramsClient.nb_screen_segment !== 1) ? _c('span', {
    staticClass: "title-screen__span"
  }, [(_vm.isEmpty) ? _c('i', {
    staticClass: "fa fa-file-o"
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.item.title) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.paramsClient.nb_screen_segment === 1 && _vm.item.screens) ? _c('span', {
    staticClass: "title-screen__span"
  }, [(_vm.isEmpty) ? _c('i', {
    staticClass: "fa fa-file-o"
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.item.screens[0].title) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.paramsClient.nb_screen_segment === 1 && !_vm.item.screens) ? _c('span', {
    staticClass: "title-screen__span"
  }, [(_vm.isEmpty) ? _c('i', {
    staticClass: "fa fa-file-o"
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.item.title) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditMode && _vm.isEditable),
      expression: "!isEditMode && isEditable"
    }],
    staticClass: "btn btn-sm edit-title-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleEditMode()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-pencil"
  })]), _vm._v(" "), (_vm.haveScreen) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHover),
      expression: "isHover"
    }],
    staticClass: "fa  icon-layers text-right",
    attrs: {
      "id": "fa-clone"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHover),
      expression: "isHover"
    }],
    staticClass: "text-center",
    staticStyle: {
      "transform": "translateY(50%)"
    }
  }, [(_vm.haveScreen && !_vm.isCollapse2) ? _c('b-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditMode && _vm.isEditable),
      expression: "!isEditMode && isEditable"
    }],
    staticClass: "btn btn-sm edit-title-btn",
    attrs: {
      "id": _vm.item.id,
      "variant": "outline-primary"
    },
    on: {
      "click": [function($event) {
        return _vm.$emit('showSelect', $event)
      }, function($event) {
        $event.stopPropagation();
      }]
    }
  }, [_vm._v(_vm._s(_vm.$t('button.preview')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.haveScreen && _vm.isCollapse2) ? _c('b-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditMode && _vm.isEditable),
      expression: "!isEditMode && isEditable"
    }],
    staticClass: "btn btn-sm edit-title-btn",
    attrs: {
      "id": _vm.item.id,
      "variant": "outline-primary"
    },
    on: {
      "click": [function($event) {
        return _vm.$emit('showSelect2')
      }, function($event) {
        $event.stopPropagation();
      }]
    }
  }, [_vm._v(_vm._s(_vm.$t('button.preview')) + "\n      ")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.item.duration && !_vm.isEmpty && _vm.isActiveModule === 'videos') ? _c('div', {
    staticClass: "duration-screen"
  }, [_c('div', {
    staticClass: " duration-screen__style",
    attrs: {
      "title": _vm.item.duration
    }
  }, [_vm._v("\n      " + _vm._s(_vm.getDuration(_vm.item.duration)) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ModalSegment),
      expression: "ModalSegment"
    }],
    staticClass: "edit-panel",
    attrs: {
      "id": _vm.item.id
    }
  }, [_c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleEditMode()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "title": _vm.$t('labels.title'),
      "placeholder": _vm.$t('placeholder.title'),
      "type": "text",
      "maxlength": _vm.getmaxLength
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.isHover) ? _c('button', {
    staticClass: "btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.updateTitleScreen()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.edit')) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isHover) ? _c('button', {
    staticClass: "btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.updateSegment()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.edit')) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ModalSegment != true),
      expression: "ModalSegment != true"
    }],
    staticClass: "edit-panel",
    attrs: {
      "id": _vm.item.id
    }
  }, [_c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleEditMode()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.titleSlide),
      expression: "titleSlide"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "title": _vm.$t('labels.title'),
      "placeholder": _vm.$t('placeholder.title'),
      "type": "text",
      "maxlength": _vm.getmaxLength
    },
    domProps: {
      "value": (_vm.titleSlide)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.titleSlide = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.update()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('button.edit')) + "\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_open),
      expression: "is_open"
    }],
    class: _vm.overlay_classes,
    on: {
      "click": _vm._onOverlayClick
    }
  }, [_c('div', {
    class: _vm.modal_classes,
    style: (_vm.modal_style)
  }, [_c('div', {
    staticClass: "sweet-box-actions"
  }, [_vm._t("box-action"), _vm._v(" "), (!_vm.hideCloseButton) ? _c('div', {
    staticClass: "sweet-action-close",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z",
      "fill": "#292c34"
    }
  })])]) : _vm._e()], 2), _vm._v(" "), (_vm.has_title || _vm.has_tabs) ? _c('div', {
    staticClass: "sweet-title"
  }, [(_vm.has_tabs && !_vm.has_title) ? [_c('ul', {
    staticClass: "sweet-modal-tabs"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      class: _vm._getClassesForTab(tab)
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm._changeTab(tab)
        }
      }
    }, [_c('div', {
      staticClass: "sweet-modal-valign"
    }, [(tab.icon) ? _c('span', {
      staticClass: "sweet-modal-tab-icon",
      domProps: {
        "innerHTML": _vm._s(tab.icon)
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "sweet-modal-tab-title"
    }, [_vm._v(_vm._s(tab.title))])])])])
  }), 0)] : _vm._e(), _vm._v(" "), (_vm.has_title) ? [(_vm.title) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("title")] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.has_title && _vm.has_tabs) ? _c('ul', {
    staticClass: "sweet-modal-tabs"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      class: _vm._getClassesForTab(tab)
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm._changeTab(tab)
        }
      }
    }, [_c('div', {
      staticClass: "sweet-modal-valign"
    }, [(tab.icon) ? _c('span', {
      staticClass: "sweet-modal-tab-icon",
      domProps: {
        "innerHTML": _vm._s(tab.icon)
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "sweet-modal-tab-title"
    }, [_vm._v(_vm._s(tab.title))])])])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "sweet-content"
  }, [(_vm.icon == 'error') ? _c('div', {
    ref: "icon_error",
    staticClass: "sweet-modal-icon sweet-modal-error"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.icon == 'warning') ? _c('div', {
    ref: "icon_warning",
    staticClass: "sweet-modal-icon sweet-modal-warning"
  }, [_c('span', {
    staticClass: "sweet-modal-body"
  }), _vm._v(" "), _c('span', {
    staticClass: "sweet-modal-dot"
  })]) : _vm._e(), _vm._v(" "), (_vm.icon == 'info') ? _c('div', {
    ref: "icon_info",
    staticClass: "sweet-modal-icon sweet-modal-info"
  }) : _vm._e(), _vm._v(" "), (_vm.icon == 'success') ? _c('div', {
    ref: "icon_success",
    staticClass: "sweet-modal-icon sweet-modal-success"
  }, [_c('span', {
    staticClass: "sweet-modal-line sweet-modal-tip"
  }), _vm._v(" "), _c('span', {
    staticClass: "sweet-modal-line sweet-modal-long"
  }), _vm._v(" "), _c('div', {
    staticClass: "sweet-modal-placeholder"
  }), _vm._v(" "), _c('div', {
    staticClass: "sweet-modal-fix"
  })]) : _vm._e(), _vm._v(" "), (_vm.$slots.default) ? _c('div', {
    staticClass: "sweet-content-content"
  }, [_vm._t("default")], 2) : _vm._e()]), _vm._v(" "), (_vm.$slots.button) ? _c('div', {
    staticClass: "sweet-buttons"
  }, [_vm._t("button")], 2) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "sweet-modal-x-mark"
  }, [_c('span', {
    staticClass: "sweet-modal-line sweet-modal-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "sweet-modal-line sweet-modal-right"
  })])
}]}

/***/ }),
/* 847 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "svgMatorEditorApp"
    }
  }, [_c('b-modal', {
    ref: "modal-svg-mator",
    attrs: {
      "size": "xl",
      "title": "Svg Mator",
      "scrollable": "",
      "id": "modal-svg-mator",
      "hide-footer": ""
    },
    model: {
      value: (_vm.changed),
      callback: function($$v) {
        _vm.changed = $$v
      },
      expression: "changed"
    }
  }, [_c('div', {
    staticClass: "w-100",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('b-button', {
    staticClass: "float-left",
    attrs: {
      "id": "svg-btn-back",
      "size": "sm"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" Retour\n      ")])], 1), _vm._v(" "), _c('iframe', {
    staticClass: "w-100",
    attrs: {
      "id": "svg-iframe",
      "src": _vm.url
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 848 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('section', {
    staticClass: "page_not_found"
  }, [_c('div', {
    staticClass: "page_not_found__content"
  }, [_c('h2', {
    staticClass: "page_not_found__title title"
  }, [_vm._v("404")]), _vm._v(" "), _c('h2', {
    staticClass: "page_not_found__title description"
  }, [_vm._v(_vm._s(_vm.$t('message.pageNotFound')))])])])])
},staticRenderFns: []}

/***/ }),
/* 849 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown-save",
    attrs: {
      "id": "dropdown-save"
    }
  }, [_c('b-dropdown', {
    attrs: {
      "id": "dropdown-right",
      "right": "",
      "text": "",
      "variant": "primary"
    }
  }, [_c('b-dropdown-item', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('save_copie_html_action'),
      expression: "'save_copie_html_action'"
    }],
    attrs: {
      "id": "saveAsItem"
    },
    on: {
      "click": _vm.saveAs
    }
  }, [_vm._v(_vm._s(_vm.$t('template.save_as_copie')))]), _vm._v(" "), _c('b-dropdown-item', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('save_video_action'),
      expression: "'save_video_action'"
    }],
    attrs: {
      "id": "saveAsVideo"
    },
    on: {
      "click": _vm.saveVideo
    }
  }, [_vm._v(_vm._s(_vm.$t('template.save_as_video')))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 850 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-pages",
    staticStyle: {
      "height": "0"
    },
    attrs: {
      "id": "pages"
    }
  }, [_c('div', {
    staticClass: "panel__left show_panel gjs-pn-panel gjs-pn-panel-top gjs-one-bg gjs-two-color",
    attrs: {
      "id": "panel__left"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opened),
      expression: "opened"
    }],
    staticClass: "panel__list-page gjs-pn-panel gjs-pn-panel-basic gjs-one-bg gjs-two-color",
    attrs: {
      "id": "panel__list-page"
    }
  }, [(_vm.$route.name === 'segment') ? _c('custom-segment-panel-pages', {
    attrs: {
      "is-edit-segement": _vm.isEditSegement
    },
    on: {
      "transitionSelected": _vm.addTransition
    }
  }) : _vm._e(), _vm._v(" "), _c('custom-panel-pages', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.name !== 'segment'),
      expression: "$route.name !== 'segment'"
    }],
    on: {
      "transitionSelected": _vm.addTransition
    }
  })], 1)]), _vm._v(" "), (_vm.showModal) ? _c('transition-modal', {
    attrs: {
      "slide": _vm.selectedSlideTransition
    },
    on: {
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 851 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "exit-save"
    }
  }, [_c('b-modal', {
    attrs: {
      "id": "modal-exit-save",
      "noCloseOnBackdrop": true,
      "noCloseOnEsc": true,
      "centered": ""
    },
    on: {
      "hide": _vm.close
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function() {
        return [_c('button', {
          staticClass: "btn btn-primary",
          attrs: {
            "size": "xl"
          },
          on: {
            "click": _vm.back
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$t('button.exit')) + "\n      ")]), _vm._v(" "), _c('button', {
          staticClass: "btn outline-secondary",
          attrs: {
            "size": "xl"
          },
          on: {
            "click": _vm.close
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$t('button.cancel')) + "\n      ")])]
      },
      proxy: true
    }])
  }, [_c('svg', {
    attrs: {
      "width": "128px",
      "height": "128px",
      "viewBox": "0 0 128 128",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(-248.000000, -117.000000)",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(48.000000, 117.000000)"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(200.000000, 0.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M120,0 L24,0 C19.578,0 16,3.582 16,8 L16,30.234 C18.367,28.101 21.063,26.496 24,25.453 L24,8 L120,8 L120,120 L24,120 L24,102.547 C21.062,101.504 18.367,99.899 16,97.766 L16,120 C16,124.418 19.578,128 24,128 L120,128 C124.422,128 128,124.418 128,120 L128,8 C128,3.582 124.422,0 120,0 Z",
      "fill": "#B0BEC5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32,40 C34.047,40 36.094,40.781 37.656,42.344 C40.781,45.469 40.781,50.532 37.656,53.657 L35.313,56 L64,56 C68.422,56 72,59.582 72,64 C72,68.418 68.422,72 64,72 L35.313,72 L37.657,74.344 C40.782,77.469 40.782,82.532 37.657,85.657 C36.094,87.219 34.047,88 32,88 C29.953,88 27.906,87.219 26.344,85.656 L10.344,69.656 C7.219,66.531 7.219,61.468 10.344,58.343 L26.344,42.343 C27.906,40.781 29.953,40 32,40 M32,32 C27.727,32 23.711,33.664 20.687,36.688 L4.687,52.688 C1.664,55.711 0,59.727 0,64 C0,68.273 1.664,72.289 4.688,75.313 L20.688,91.313 C23.711,94.336 27.727,96 32,96 C36.273,96 40.289,94.336 43.313,91.312 C46.43,88.195 47.993,84.097 47.993,79.999 L64,79.999 C72.82,79.999 80,72.823 80,63.999 C80,55.179 72.82,47.999 64,47.999 L47.992,47.999 C47.992,43.901 46.429,39.804 43.312,36.686 C40.289,33.664 36.273,32 32,32 L32,32 Z",
      "fill": "#F44336"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M104,24 L104,104 L96,104 L96,24 L104,24 M112,16 L88,16 L88,112 L112,112 L112,16 L112,16 Z",
      "fill": "#EF9A9A"
    }
  })])])])])]), _vm._v(" "), _c('p', {
    staticClass: "mt-4 mb-2 title"
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.$t('exitSave.exitEditor')) + " ")])]), _vm._v(" "), _c('p', {
    staticClass: "my-2 subtitle"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('exitSave.exitPage')) + "\n    ")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-3",
    attrs: {
      "id": "notfound"
    }
  }, [_c('div', {
    staticClass: "icon-notfound"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "50",
      "height": "50",
      "viewBox": "0 0 50 50"
    }
  }, [_c('g', {
    attrs: {
      "id": "Icon_50_Notfound",
      "data-name": "Icon/50/Notfound",
      "transform": "translate(0)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Shape",
      "d": "M25,50A25,25,0,1,1,50,25,25.029,25.029,0,0,1,25,50ZM8.085,9.557A22.9,22.9,0,0,0,40.442,41.916ZM25,2.084a22.844,22.844,0,0,0-15.443,6L41.916,40.442A22.9,22.9,0,0,0,25,2.084Z",
      "transform": "translate(50 0) rotate(90)",
      "fill": "#acadb1"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('biblioSegment.noSearch')))]), _vm._v(" "), _c('h6', [_vm._v("\n      " + _vm._s(_vm.$t('biblioSegment.trySearch')) + "\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 879 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 880 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 881 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 882 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 883 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 884 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[73]);


// WEBPACK FOOTER //
// display/static/js/app.c6e5d7a54a297f77fd59.js